/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 626);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(538);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(465)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Theme; });
// Styles
var themeStyles = {
  isMobile: false,
  responsive_mobile_width: 768,
  iphone_plus_query: '@media screen and (min-device-width : 414px) and (max-device-width : 736px)',
  mobile_query: '@media screen and (max-width: 768px)',
  desktop_query: '@media screen and (min-width: 769px)',

  font_family_primary: ['Avenir LT W01_45 Book1475508', 'sans-serif'],
  font_size_primary: 20,
  font_weight_primary: 300,

  font_family_secondary: ['filson-soft', 'sans-serif'],
  font_size_secondary: 15,
  font_weight_secondary: 800,

  font_family_heading: ['Gilroy', 'sans-serif'],
  font_weight_heading: 800,
  font_size_heading: 45,

  title_grey: '#676767',

  light_background: '#F5F5F5', // dogshare
  dark_background: '#001227', // dogshare

  border_color: '#F1F1F1',

  even_table_background: '#F3F2F7',

  horizontal_rule_color: '#DDDDDD',

  purple: '#6F43D6',
  teal: '#52B9C3',
  green: '#7FFF24',
  orange: '#FF4E44',
  blue: '#2B00F7',
  baby_blue: '#56C5FF', // dogshare
  red: '#F10B63',
  turquoise: '#39b4d6',

  error: '#E85E5E',

  black: '#000000',
  offblack: '#141D25', // dogshare
  darker_grey: '#505050',
  dark_grey: '#4A4A4A', // dogshare
  grey: '#BFBFBF', // dogshare
  light_grey: '#F4F4F4', // dogshare
  lighter_grey: '#F8F8F8',
  white: '#FFFFFF',

  facebook: '#3B5998',

  container_width: 1170,
  margin: 15,
  navBarHeight: 80,
  tabBarHeight: 40,
  popover_distance_from_bottom: 75,

  post_text_fontSize: 14,
  post_text_lineHeight: 25
};

var apiKeys = {
  facebook_app_id: '727162037485391'
};

var globals = {
  primary: themeStyles.baby_blue,
  secondary: themeStyles.orange,
  tertiary: themeStyles.turquoise
};

var fonts = {
  text_color: themeStyles.darker_grey
};

var navigation = {
  height: 80,
  zIndex: 100,
  link_fontFamily: ['Open Sans', 'sans-serif'],
  link_color: themeStyles.offblack,
  link_hover_color: globals.primary,
  link_styles: {
    fontWeight: 600,
    textDecoration: 'none',
    fontSize: 16
  }
};

var footer = {
  height: 270,
  font_size: 15,
  backgroundColor: themeStyles.dark_background
};

// Export all theme config, plus values dependent on those from above objects
var Theme = Object.assign({}, themeStyles, fonts, globals, { // eslint-disable-line
  footer: footer,
  navigation: navigation,
  apiKeys: apiKeys
});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _generate = __webpack_require__(91);

var _exports2 = __webpack_require__(163);

var _exports3 = _interopRequireDefault(_exports2);

var useImportant = true; // Add !important to all style definitions
exports['default'] = (0, _exports3['default'])(useImportant, _generate.defaultSelectorHandlers);
module.exports = exports['default'];

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(490);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export guid */
/* harmony export (immutable) */ __webpack_exports__["a"] = mapStateToProps;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapDispatchToProps;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return availability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return sex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fixedStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return livingSituations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return regularity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Api__ = __webpack_require__(18);
/* unused harmony reexport request */


/*
 * Generate a globally unique identifier
 */
function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4(); // eslint-disable-line
}

function mapStateToProps(state) {
  return state;
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
}

var availability = [{ value: 'Flexible', label: 'Flexible' }, { value: 'Semi-Flexible', label: 'Semi-Flexible' }, { value: 'Fixed', label: 'Fixed' }];

var sex = [{ value: 'Male', label: 'Male' }, { value: 'Female', label: 'Female' }];

var fixedStatuses = [{ value: 'Neutered', label: 'Neutered (fixed dog)' }, { value: 'Spayed', label: 'Spayed (fixed bitch)' }, { value: 'Entire', label: 'Entire (not fixed)' }];

var livingSituations = [{ value: 'Any', label: 'Any' }, { value: 'Apartment – no yard', label: 'Apartment – no yard' }, { value: 'Apartment – yard', label: 'Apartment – yard' }, { value: 'House – no yard', label: 'House – no yard' }, { value: 'House - yard', label: 'House - yard' },
// { value: 'House – yard and kennel', label: 'House – yard and kennel' },
{ value: 'Lifestyle block', label: 'Lifestyle block' }, { value: 'Farm', label: 'Farm' }, { value: 'Not applicable - no home-hangs', label: 'Not applicable - no home-hangs' }];

var regularity = [
// { value: 'Any', label: 'Any' },
{ value: 'Adhoc / Non-regular', label: 'Adhoc / Non-regular' }, { value: 'Daily', label: 'Daily' }, { value: 'Weekly', label: 'Weekly' }, { value: 'Fortnightly', label: 'Fortnightly' }, { value: 'Monthly', label: 'Monthly' }, { value: 'One off', label: 'One off' }, { value: 'Open for discussion', label: 'Open for discussion' }, { value: 'Not Applicable', label: 'Not Applicable' }];

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(499);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(500);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(501);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(502);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(503);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(504);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(77);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(505);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(506);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(507);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(508);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(509);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateAppState;
// import { request } from '../utils/Api';

function updateAppState(fields) {
  // eslint-disable-line
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch({
        type: 'UPDATE_APP_STATE',
        payload: fields
      });

      resolve();
    });
  };
}

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = updateUser;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateUserRemote;
/* harmony export (immutable) */ __webpack_exports__["a"] = getMember;
/* harmony export (immutable) */ __webpack_exports__["b"] = logout;
/* harmony export (immutable) */ __webpack_exports__["e"] = login;
/* harmony export (immutable) */ __webpack_exports__["f"] = facebookLogin;
/* harmony export (immutable) */ __webpack_exports__["j"] = register;
/* harmony export (immutable) */ __webpack_exports__["i"] = getCurrentMember;
/* harmony export (immutable) */ __webpack_exports__["m"] = fetchCurrentMember;
/* harmony export (immutable) */ __webpack_exports__["d"] = sendNotificationReadReceipt;
/* harmony export (immutable) */ __webpack_exports__["n"] = sendMemberVerificationRequest;
/* harmony export (immutable) */ __webpack_exports__["o"] = sendContactRequest;
/* harmony export (immutable) */ __webpack_exports__["p"] = sendForgotPasswordRequest;
/* harmony export (immutable) */ __webpack_exports__["q"] = sendResetPasswordRequest;
/* harmony export (immutable) */ __webpack_exports__["h"] = resendVerification;
/* harmony export (immutable) */ __webpack_exports__["l"] = sendReviewRequest;
/* harmony export (immutable) */ __webpack_exports__["k"] = reportMember;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Api__ = __webpack_require__(18);


function updateUser(fields) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch({
        type: 'UPDATE_USER',
        payload: fields
      });

      resolve();
    });
  };
}

function updateUserRemote(fields, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('member', 'PATCH', fields, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_USER',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function getMember(id, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('member/' + id, 'GET', null, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_MEMBER_BY_ID',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function logout() {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch({
        type: 'LOGOUT'
      });

      resolve();
    });
  };
}

function login(email, password, stay_logged_in) {
  // eslint-disable-line
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('auth/token', 'POST', {
        email: email,
        password: password,
        stay_logged_in: stay_logged_in
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'LOGIN',
            payload: response.data
          });
          var date = new Date();
          date.setTime(new Date().getTime() + 7 * 24 * 60 * 60 * 1000);
          if (response.data.access_token) {
            var expires = '; expires=' + date.toUTCString();
            document.cookie = 'access_token=' + response.data.access_token + '; expires=Fri, ' + expires + '; path=/';
            document.cookie = 'member_id=' + response.data.id + '; expires=Fri, ' + expires + '; path=/';
          }
          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        if (err.status === 403 && err.data.error === 'verify') {
          reject('verify');
        }
        reject(err);
      });
    });
  };
}

function facebookLogin(accessToken) {
  // eslint-disable-line
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('auth/facebook', 'POST', {
        access_token: accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'LOGIN',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function register(data) {
  // eslint-disable-line
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('member', 'POST', data).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'LOGIN',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function getCurrentMember(id, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('member/' + id, 'GET', null, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_MEMBER_BY_ID',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function fetchCurrentMember(id, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('member/' + id, 'GET', null, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_USER',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function sendNotificationReadReceipt(notificationID, type, accessToken) {
  // eslint-disable-line
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: 'READ_NOTIFICATION_BY_ID',
        payload: notificationID
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('notifications/' + notificationID + '/read?type=' + type, 'GET', null, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

/* eslint-disable */
function sendMemberVerificationRequest(id, verificationToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('verify/user?Member=' + id + '&VerificationToken=' + verificationToken, 'GET', null).then(function (response) {
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(response);
        }
      }, function (err) {
        // TODO this?
        resolve(err);
      });
    });
  };
}

function sendContactRequest(data) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('contact/request', 'POST', data).then(function (response) {
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(response);
        }
      }, function (err) {
        // TODO this?
        resolve(err);
      });
    });
  };
}

/* eslint-disable */
function sendForgotPasswordRequest(data) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('forgot', 'POST', data).then(function (response) {
        resolve(response);
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(response);
        }
      }, function (err) {
        // TODO this?
        resolve(err);
      });
    });
  };
}

function sendResetPasswordRequest(data) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('forgot/reset', 'POST', data).then(function (response) {
        if (response.status === 200) {
          resolve(response);
        } else {
          resolve(response);
        }
      }, function (err) {
        // TODO this?
        resolve(err);
      });
    });
  };
}

function resendVerification(email) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('member/verification', 'POST', {
        email: email
      }).then(function (response) {
        resolve(response);
      }, function (err) {
        reject(err);
      });
    });
  };
}

function sendReviewRequest(data, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('member/' + data.id + '/review', 'POST', data, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(response);
        }
      }, function (err) {
        // TODO this?
        resolve(err);
      });
    });
  };
}

function reportMember(data, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('member/' + data.id + '/report', 'POST', data, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(response);
        }
      }, function (err) {
        // TODO this?
        resolve(err);
      });
    });
  };
}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var styles = void 0;

var ContentContainer = function ContentContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container, props.styles, props.reverse ? styles.reverse : null) },
    props.children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ContentContainer);

ContentContainer.defaultProps = {
  styles: null,
  reverse: false,
  children: []
};

ContentContainer.propTypes = {
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object])),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].node).isRequired, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object]),
  reverse: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool
};

styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    boxSizing: 'border-box',
    width: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].container_width,
    maxWidth: '100vw',
    padding: '0 15px',
    marginRight: 'auto',
    marginLeft: 'auto'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    maxWidth: '100%'
  }),
  reverse: {
    flexDirection: 'row-reverse'
  }
});

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _once = __webpack_require__(461);

var _once2 = _interopRequireDefault(_once);

var _httpplease = __webpack_require__(377);

var _httpplease2 = _interopRequireDefault(_httpplease);

var _oldiexdomain = __webpack_require__(381);

var _oldiexdomain2 = _interopRequireDefault(_oldiexdomain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var http = _httpplease2.default.use(_oldiexdomain2.default);

var Status = {
  PENDING: 'pending',
  LOADING: 'loading',
  LOADED: 'loaded',
  FAILED: 'failed',
  UNSUPPORTED: 'unsupported'
};

var getRequestsByUrl = {};
var loadedIcons = {};

var createGetOrUseCacheForUrl = function createGetOrUseCacheForUrl(url, callback) {
  if (loadedIcons[url]) {
    var params = loadedIcons[url];

    setTimeout(function () {
      return callback(params[0], params[1]);
    }, 0);
  }

  if (!getRequestsByUrl[url]) {
    getRequestsByUrl[url] = [];

    http.get(url, function (err, res) {
      getRequestsByUrl[url].forEach(function (cb) {
        loadedIcons[url] = [err, res];
        cb(err, res);
      });
    });
  }

  getRequestsByUrl[url].push(callback);
};

var supportsInlineSVG = (0, _once2.default)(function () {
  if (!document) {
    return false;
  }

  var div = document.createElement('div');
  div.innerHTML = '<svg />';
  return div.firstChild && div.firstChild.namespaceURI === 'http://www.w3.org/2000/svg';
});

var isSupportedEnvironment = (0, _once2.default)(function () {
  return ((typeof window !== 'undefined' && window !== null ? window.XMLHttpRequest : false) || (typeof window !== 'undefined' && window !== null ? window.XDomainRequest : false)) && supportsInlineSVG();
});

var uniquifyIDs = function () {
  var mkAttributePattern = function mkAttributePattern(attr) {
    return '(?:(?:\\s|\\:)' + attr + ')';
  };

  var idPattern = new RegExp('(?:(' + mkAttributePattern('id') + ')="([^"]+)")|(?:(' + mkAttributePattern('href') + '|' + mkAttributePattern('role') + '|' + mkAttributePattern('arcrole') + ')="\\#([^"]+)")|(?:="url\\(\\#([^\\)]+)\\)")', 'g');

  return function (svgText, svgID) {
    var uniquifyID = function uniquifyID(id) {
      return id + '___' + svgID;
    };

    return svgText.replace(idPattern, function (m, p1, p2, p3, p4, p5) {
      //eslint-disable-line consistent-return
      if (p2) {
        return p1 + '="' + uniquifyID(p2) + '"';
      } else if (p4) {
        return p3 + '="#' + uniquifyID(p4) + '"';
      } else if (p5) {
        return '="url(#' + uniquifyID(p5) + ')"';
      }
    });
  };
}();

var getHash = function getHash(str) {
  var chr = void 0;
  var hash = 0;
  var i = void 0;
  var j = void 0;
  var ref = void 0;

  if (!str) {
    return hash;
  }

  for (i = j = 0, ref = str.length; ref >= 0 ? j < ref : j > ref; i = ref >= 0 ? ++j : --j) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash &= hash;
  }

  return hash;
};

var InlineSVGError = function (_Error) {
  _inherits(InlineSVGError, _Error);

  function InlineSVGError(message) {
    var _ret;

    _classCallCheck(this, InlineSVGError);

    var _this = _possibleConstructorReturn(this, (InlineSVGError.__proto__ || Object.getPrototypeOf(InlineSVGError)).call(this));

    _this.name = 'InlineSVGError';
    _this.isSupportedBrowser = true;
    _this.isConfigurationError = false;
    _this.isUnsupportedBrowserError = false;
    _this.message = message;

    return _ret = _this, _possibleConstructorReturn(_this, _ret);
  }

  return InlineSVGError;
}(Error);

var createError = function createError(message, attrs) {
  var err = new InlineSVGError(message);

  Object.keys(attrs).forEach(function (k) {
    err[k] = attrs[k];
  });

  return err;
};

var unsupportedBrowserError = function unsupportedBrowserError(message) {
  var newMessage = message;

  if (newMessage === null) {
    newMessage = 'Unsupported Browser';
  }

  return createError(newMessage, {
    isSupportedBrowser: false,
    isUnsupportedBrowserError: true
  });
};

var configurationError = function configurationError(message) {
  return createError(message, {
    isConfigurationError: true
  });
};

var InlineSVG = function (_React$PureComponent) {
  _inherits(InlineSVG, _React$PureComponent);

  function InlineSVG(props) {
    _classCallCheck(this, InlineSVG);

    var _this2 = _possibleConstructorReturn(this, (InlineSVG.__proto__ || Object.getPrototypeOf(InlineSVG)).call(this, props));

    _this2.state = {
      status: Status.PENDING
    };

    _this2.handleLoad = _this2.handleLoad.bind(_this2);
    _this2.isActive = false;
    return _this2;
  }

  _createClass(InlineSVG, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.isActive = true;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.status === Status.PENDING) {
        if (this.props.supportTest()) {
          if (this.props.src) {
            this.startLoad();
          } else {
            this.fail(configurationError('Missing source'));
          }
        } else {
          this.fail(unsupportedBrowserError());
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isActive = false;
    }
  }, {
    key: 'fail',
    value: function fail(error) {
      var _this3 = this;

      var status = error.isUnsupportedBrowserError ? Status.UNSUPPORTED : Status.FAILED;

      if (this.isActive) {
        this.setState({ status: status }, function () {
          if (typeof _this3.props.onError === 'function') {
            _this3.props.onError(error);
          }
        });
      }
    }
  }, {
    key: 'handleLoad',
    value: function handleLoad(err, res) {
      var _this4 = this;

      if (err) {
        this.fail(err);
        return;
      }

      if (this.isActive) {
        this.setState({
          loadedText: res.text,
          status: Status.LOADED
        }, function () {
          return typeof _this4.props.onLoad === 'function' ? _this4.props.onLoad() : null;
        });
      }
    }
  }, {
    key: 'startLoad',
    value: function startLoad() {
      if (this.isActive) {
        this.setState({
          status: Status.LOADING
        }, this.load);
      }
    }
  }, {
    key: 'load',
    value: function load() {
      var match = this.props.src.match(/data:image\/svg[^,]*?(;base64)?,(.*)/);
      if (match) {
        return this.handleLoad(null, {
          text: match[1] ? atob(match[2]) : decodeURIComponent(match[2])
        });
      }
      if (this.props.cacheGetRequests) {
        return createGetOrUseCacheForUrl(this.props.src, this.handleLoad);
      }

      return http.get(this.props.src, this.handleLoad);
    }
  }, {
    key: 'getClassName',
    value: function getClassName() {
      var className = 'isvg ' + this.state.status;

      if (this.props.className) {
        className += ' ' + this.props.className;
      }

      return className;
    }
  }, {
    key: 'processSVG',
    value: function processSVG(svgText) {
      if (this.props.uniquifyIDs) {
        return uniquifyIDs(svgText, getHash(this.props.src));
      }

      return svgText;
    }
  }, {
    key: 'renderContents',
    value: function renderContents() {
      switch (this.state.status) {
        case Status.UNSUPPORTED:
        case Status.FAILED:
          return this.props.children;
        default:
          return this.props.preloader;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.wrapper({
        style: this.props.style,
        className: this.getClassName(),
        dangerouslySetInnerHTML: this.state.loadedText ? {
          __html: this.processSVG(this.state.loadedText)
        } : undefined
      }, this.renderContents());
    }
  }]);

  return InlineSVG;
}(_react2.default.PureComponent);

InlineSVG.propTypes = {
  cacheGetRequests: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  onError: _propTypes2.default.func,
  onLoad: _propTypes2.default.func,
  preloader: _propTypes2.default.func,
  src: _propTypes2.default.string.isRequired,
  style: _propTypes2.default.object,
  supportTest: _propTypes2.default.func,
  uniquifyIDs: _propTypes2.default.bool,
  wrapper: _propTypes2.default.func
};
InlineSVG.defaultProps = {
  wrapper: _react2.default.createFactory('span'),
  supportTest: isSupportedEnvironment,
  uniquifyIDs: true,
  cacheGetRequests: false
};
exports.default = InlineSVG;
module.exports = exports['default'];

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cleave_js_react__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cleave_js_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cleave_js_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ErrorContainer__ = __webpack_require__(22);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var DateField = function (_Component) {
  _inherits(DateField, _Component);

  function DateField(props) {
    var _input;

    _classCallCheck(this, DateField);

    var _this = _possibleConstructorReturn(this, (DateField.__proto__ || Object.getPrototypeOf(DateField)).call(this, props));

    _this.assignClasses = _this.assignClasses.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.onKeyDown = _this.props.onKeyDown.bind(_this);

    _this.state = {
      error: _this.props.error,
      remaining: _this.props.limit
    };

    _this.styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
      field: _defineProperty({
        width: '50%',
        marginBottom: 15,
        padding: '0 5px'

      }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
        width: '100%'
      }),
      field_fw: {
        width: '100%'
      },
      remaining: {
        marginTop: 8,
        textAlign: 'right',
        color: '#828282',
        fontSize: 14,
        fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
        fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_primary
      },
      label: {
        display: 'block',
        marginBottom: 9,
        fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
        fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_primary,
        fontSize: 14,
        color: '#828282'
      },
      label_error: {
        color: '#E85E5E'
      },
      input: (_input = {
        width: '100%',
        height: 50,
        padding: '0 16px',
        fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
        fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_primary,
        fontSize: 15,
        color: '#000e1f',
        borderRadius: 3,
        backgroundColor: '#fff',
        border: '1px solid #e4e4e4',
        outline: 'none',
        transition: 'all 300ms'

      }, _defineProperty(_input, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
        fontSize: 16
      }), _defineProperty(_input, '::placeholder', {
        fontSize: 14,
        color: '#bbb'
      }), _defineProperty(_input, ':focus', {
        borderColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].turquoise
      }), _input),
      input_disabled: {
        backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].light_grey,
        color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].grey
      },
      input_error: {
        color: '#E85E5E',
        borderColor: '#E85E5E',
        borderWidth: 2,
        borderRadius: '3px 3px 0 0',

        '::placeholder': {
          color: '#E85E5E'
        },

        ':focus': {
          borderColor: '#E85E5E'
        }
      },
      textarea: {
        display: 'block',
        height: _this.props.height ? _this.props.height : 114,
        padding: 16,
        resize: 'none'
      }
    });
    return _this;
  }

  _createClass(DateField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.focus) {
        this.inputField.focus();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this.props.error !== this.state.error) {
        setTimeout(function () {
          _this2.setState({
            error: _this2.props.error
          });
        }, 200);
      }
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(event) {
      this.props.onKeyDown(event);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      if (this.props.required && event.target.value.length === 0) {
        this.setState({
          error: 'This field is required'
        });
      }

      if (this.props.handler && typeof this.props.handler === 'function') {
        this.props.handler(this.props.name, event.target.value);
      }
    }
  }, {
    key: 'assignClasses',
    value: function assignClasses() {
      this.fieldClasses = [this.styles.field, this.props.fullWidth ? this.styles.field_fw : null];

      this.labelClasses = [this.styles.label, this.state.error ? this.styles.label_error : null];

      this.inputClasses = [this.styles.input, this.state.error ? this.styles.input_error : null, this.props.disabled ? this.styles.input_disabled : null];

      this.textAreaClasses = [this.inputClasses, this.styles.textarea];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      this.assignClasses();

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(this.fieldClasses, this.props.styles) },
        this.props.label ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'label',
          { htmlFor: this.props.id, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(this.labelClasses) },
          this.props.label
        ) : null,
        this.props.textArea ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('textarea', {
          id: this.props.id,
          name: this.props.name,
          ref: function ref(input) {
            _this3.inputField = input;
          },
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(this.textAreaClasses),
          value: this.props.value,
          placeholder: this.props.placeholder,
          maxLength: this.props.limit,
          height: this.props.height,
          onChange: this.handleChange
        }) : null,
        this.props.creditCardNum ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cleave_js_react___default.a, {
          onChange: this.handleChange,
          placeholder: this.props.placeholder,
          options: {
            creditCard: true,
            delimiter: ' - '
          },
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(this.inputClasses)
        }) : null,
        this.props.creditCardExp ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cleave_js_react___default.a, {
          onChange: this.handleChange,
          placeholder: this.props.placeholder,
          options: {
            date: true,
            delimiter: ' / ',
            datePattern: ['m', 'y']
          },
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(this.inputClasses)
        }) : null,
        this.props.creditCardCVC ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cleave_js_react___default.a, {
          onChange: this.handleChange,
          placeholder: this.props.placeholder,
          options: {
            blocks: [3],
            uppercase: true
          },
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(this.inputClasses)
        }) : null,
        !this.props.creditCardNum && !this.props.textArea && !this.props.creditCardExp && !this.props.creditCardCVC ? // eslint-disable-line
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
          ref: function ref(input) {
            _this3.inputField = input;
          },
          id: this.props.id,
          disabled: this.props.disabled,
          readOnly: this.props.readOnly,
          type: this.props.email ? 'email' : this.props.type,
          name: this.props.name,
          value: this.props.value,
          onKeyDown: this.onKeyDown,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(this.inputClasses),
          placeholder: this.props.placeholder,
          onChange: this.handleChange
        }) : null,
        this.state.error ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ErrorContainer__["a" /* default */], { message: this.state.error }) : null,
        this.props.showRemaining && this.props.limit && this.props.value ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(this.styles.remaining) },
          this.props.value.length,
          ' / ',
          this.props.limit
        ) : null
      );
    }
  }]);

  return DateField;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DateField);


DateField.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string,
  placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string,
  error: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string,
  type: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string,
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].number,
  limit: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].number,
  textArea: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].bool,
  disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].bool,
  required: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].bool,
  email: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].bool,
  fullWidth: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].bool,
  showRemaining: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].bool,
  creditCardNum: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].bool,
  creditCardExp: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].bool,
  creditCardCVC: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].bool,
  focus: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].bool,
  styles: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].objectOf(__WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].number, __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].object])),
  handler: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].func
};

DateField.defaultProps = {
  styles: null,
  label: null,
  disabled: false,
  readOnly: false,
  placeholder: null,
  error: null,
  type: 'text',
  focus: false,
  textArea: false,
  email: false,
  limit: null,
  required: false,
  height: null,
  fullWidth: false,
  showRemaining: false,
  creditCardNum: false,
  creditCardExp: false,
  creditCardCVC: false,
  handler: function handler() {},
  onKeyDown: function onKeyDown() {}
};

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoginModal__ = __webpack_require__(101);







var styles = void 0;

var Body = function Body(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.body, props.hasFooter && !__WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].isMobile ? styles.footer : false) },
    props.children,
    props.loginModalCloseHandler ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__LoginModal__["a" /* default */], { open: props.loginModalOpen, closeHandler: props.loginModalCloseHandler }) : false
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Body);

Body.defaultProps = {
  hasFooter: false,
  children: null,
  loginModalOpen: false,
  loginModalCloseHandler: false
};

Body.propTypes = {
  loginModalOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  hasFooter: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  loginModalCloseHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].node)
};

styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  body: {
    position: 'relative',
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_primary,
    backgroundColor: '#f0f0f0',
    minHeight: '100vh',
    overflow: 'hidden'
  },
  footer: {
    paddingBottom: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].footer.height
  }
});

/***/ }),
/* 13 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(484);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports['default'];

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var styles = void 0;

var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button(props) {
    _classCallCheck(this, Button);

    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.handler = _this.props.handler.bind(_this);
    return _this;
  }

  _createClass(Button, [{
    key: 'render',
    value: function render() {
      var buttonStyle = void 0;
      var buttonTitle = void 0;

      switch (this.props.theme) {
        default:
          buttonStyle = styles.button;
          buttonTitle = styles.button_title;
          break;
        case 'white':
          buttonStyle = styles.button_white;
          buttonTitle = styles.button_title_white;
          break;
        case 'black':
          buttonStyle = styles.button_black;
          buttonTitle = styles.button_title_black;
          break;
        case 'facebook':
          buttonStyle = styles.button_facebook;
          buttonTitle = styles.button_title_facebook;
          break;
        case 'disabled':
          buttonStyle = styles.button_disabled;
          buttonTitle = styles.button_title_disabled;
          break;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          tabIndex: -1,
          role: 'button',
          disabled: this.props.disabled,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(buttonStyle, styles.button_generic, this.props.styles),
          onClick: this.handler },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(buttonTitle, styles.button_title_generic) },
          this.props.title
        )
      );
    }
  }]);

  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Button);

Button.defaultProps = {
  styles: null,
  theme: null,
  disabled: false,
  handler: function handler() {}
};

Button.propTypes = {
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object])),
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  handler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func
};

styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  button_generic: {
    display: 'flex',
    width: 260,
    minHeight: 50,
    padding: 10,
    boxSizing: 'none',
    borderRadius: 6,
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
    transition: 'all ease-out 160ms',
    cursor: 'pointer'
  },
  button_title_generic: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_secondary,
    fontSize: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_size_secondary,
    letterSpacing: 2,
    textTransform: 'uppercase',
    fontStyle: 'normal',
    textDecoration: 'none'
  },

  // Theme: default
  button: {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].primary,
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
    ':hover': {
      backgroundColor: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].black,
      color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white
    }
  },
  button_title: {},
  // Theme: white
  button_white: {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].black,
    ':hover': {
      backgroundColor: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].black,
      color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white
    }
  },
  button_title_white: {},
  // Theme: black
  button_black: {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].black,
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
    ':hover': {
      backgroundColor: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].primary,
      color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white
    }
  },
  button_title_black: {},
  // Theme: facebook
  button_facebook: {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].facebook,
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
    ':hover': {
      backgroundColor: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].primary,
      color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white
    }
  },
  button_title_facebook: {},
  // Theme: disabled
  button_disabled: {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].grey,
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
    ':hover': {
      backgroundColor: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].grey,
      color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
      opacity: 0.8
    }
  },
  button_title_disabled: {}
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FooterColumn__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FooterItem__ = __webpack_require__(185);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var styles = void 0;

var INSTAGRAM = __webpack_require__(313);
var FACEBOOK = __webpack_require__(312);
var YOUTUBE = __webpack_require__(315);
var MAIL = __webpack_require__(314);

var Footer = function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__ContentContainer__["a" /* default */],
          { styles: styles.footer_container },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__FooterColumn__["a" /* default */],
            { title: 'About Us' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FooterItem__["a" /* default */], { title: 'Home', url: '/' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FooterItem__["a" /* default */], { title: 'Our Story', url: '/story' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FooterItem__["a" /* default */], { title: 'Dog e-Blog', url: '/blog' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__FooterColumn__["a" /* default */],
            { title: 'Info' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FooterItem__["a" /* default */], { title: 'FAQs - Dog Owner', url: '/faqs-dog-owner' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FooterItem__["a" /* default */], { title: 'FAQs - Dog Borrower', url: '/faqs-dog-borrower' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FooterItem__["a" /* default */], { title: 'Contact Us', url: '/contact' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__FooterColumn__["a" /* default */],
            { title: 'Terms' },
            !this.props.user && !this.props.user.isAuthenticated ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FooterItem__["a" /* default */], { title: 'Pricing', url: '/join/subscription' }) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FooterItem__["a" /* default */], { title: 'Privacy Policy', url: '/privacy' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FooterItem__["a" /* default */], { title: 'Terms of Service', url: '/terms' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__FooterColumn__["a" /* default */],
            { title: 'Connect with us' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.footer_social) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: 'https://www.facebook.com/DogShareCollective', target: '_blank', rel: 'noopener noreferrer' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: FACEBOOK, alt: 'Like us on Facebook', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.social_icon) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: 'https://www.instagram.com/dogsharecollective/', target: '_blank', rel: 'noopener noreferrer' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                  src: INSTAGRAM,
                  alt: 'Follow us on Instagram',
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.social_icon) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  href: 'https://www.youtube.com/channel/UCw70BUCq4MvF7N8LqjjuyqA',
                  target: '_blank',
                  rel: 'noopener noreferrer' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                  src: YOUTUBE,
                  alt: 'Watch us on YouTube',
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.social_icon, styles.youtube_icon) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  href: 'mailto:support@thedogsharecollective.com',
                  target: '_blank',
                  rel: 'noopener noreferrer' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                  src: MAIL,
                  alt: 'Email us',
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.social_icon, styles.mail_icon) })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__ContentContainer__["a" /* default */],
          { styles: styles.footer_container },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.copyright) },
            'Copyright \xA9 The Dog Share Collective \u2122'
          )
        )
      );
    }
  }]);

  return Footer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Footer);


Footer.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
    bottom: 0,
    left: 0,
    paddingTop: 40,
    width: '100vw',
    height: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].footer.height,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].footer.backgroundColor

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    position: 'relative',
    height: 'auto'
  }),
  footer_container: _defineProperty({
    display: 'flex',
    paddingLeft: 70,
    paddingRight: 70

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    flexWrap: 'wrap',
    paddingLeft: 20,
    paddingRight: 20
  }),
  footer_social: _defineProperty({
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 15

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    flexWrap: 'wrap'
  }),
  copyright: {
    color: '#fff',
    paddingBottom: '1rem',
    opacity: 0.6,
    fontSize: '0.9rem'
  },
  social_icon: {
    padding: 8
  },
  youtube_icon: {
    width: 40,
    margin: '2px 0 0 0'
  },
  mail_icon: {
    width: 40,
    margin: '2px 0 0 0'
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CompanyLogo__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__(15);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint import/no-webpack-loader-syntax: off */











var UnauthenticatedHeader = function (_Component) {
  _inherits(UnauthenticatedHeader, _Component);

  function UnauthenticatedHeader(props) {
    _classCallCheck(this, UnauthenticatedHeader);

    var _this = _possibleConstructorReturn(this, (UnauthenticatedHeader.__proto__ || Object.getPrototypeOf(UnauthenticatedHeader)).call(this, props));

    _this.openLoginHandler = _this.props.openLoginHandler.bind(_this);
    return _this;
  }

  _createClass(UnauthenticatedHeader, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container) + ' DashboardHeader' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.header_container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.header) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.logo_container) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CompanyLogo__["a" /* default */], { styles: styles.company_logo })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.buttons) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
                {
                  to: '/',
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.login_link)
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  'How It Works'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
                {
                  to: '/story',
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.login_link)
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  'Our Story'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.login_link),
                  onClick: this.openLoginHandler,
                  role: 'link',
                  tabIndex: 0
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  'Login'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* NavLink */],
                { to: '/join' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Button__["a" /* default */], { title: 'Join the collective' })
              )
            )
          )
        )
      );
    }
  }]);

  return UnauthenticatedHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (UnauthenticatedHeader);


UnauthenticatedHeader.propTypes = {
  openLoginHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: '100',
    display: 'flex',
    width: '100vw',
    height: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].navigation.height,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white
  },
  header_container: {
    position: 'relative',
    display: 'flex',
    margin: '0 auto',
    width: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].container_width,
    alignItems: 'center'
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row'
  },
  logo_container: {
    width: 180
  },
  company_logo: {
    position: 'absolute',
    top: 10,
    left: 0
  },
  buttons: _defineProperty({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    display: 'none'
  }),
  login_link: {
    cursor: 'pointer',
    textTransform: 'uppercase',
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_secondary,
    fontSize: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_size_secondary,
    letterSpacing: 1,
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].offblack,
    transition: 'all 160ms ease-in-out',
    marginRight: 40,
    ':hover': {
      color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary
    }
  },
  nav_item: {
    position: 'relative',
    textTransform: 'uppercase',
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_secondary,
    fontSize: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_size_secondary,
    letterSpacing: 1,
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].dark_grey,
    transition: 'all 160ms ease-in-out',
    marginLeft: 25,
    marginRight: 25,
    ':hover': {
      color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary
    }
  },
  nav_item_disabled: {
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].grey,
    cursor: 'not-allowed',
    ':hover': {
      color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].grey
    }
  },
  nav_item_active: {
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary
  },
  coming_soon: {
    position: 'absolute',
    marginLeft: -10
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HOST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IS_MESSAGING_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ASSET_BASE_URL; });
/* unused harmony export API_HOST */
/* unused harmony export TOP_LEVEL_DOMAIN */
/* unused harmony export AUTH_HEADER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return request; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
  utils/Api

  Contains request configuration and execution methods
 */

/* eslint-disable */

// Detect if we're in react-snap pre-rendering
var isPrerendering = navigator.userAgent === 'ReactSnap';

var HOST = function (host) {
  // If pre-rendering, use production API
  if (isPrerendering || typeof window === 'undefined') {
    return 'https://api.thedogsharecollective.com';
  }

  if (host === 'localhost:3000') {
    // return 'http://dog-api.test';
    return 'https://api.thedogsharecollective.com';
  }
  if (host === 'dogshare.co:3000') {
    return 'https://api.dogshare.io';
  }
  if (host === 'stage.thedogsharecollective.com') {
    return 'https://stage-api.thedogsharecollective.com';
  }
  if (host === 'dogshare.io') {
    return 'https://api.dogshare.io';
  }
  if (host === 'www.dogshare.io') {
    return 'https://api.dogshare.io';
  }
  if (host === 'www.thedogsharecollective.com') {
    return 'https://api.thedogsharecollective.com';
  }
  return 'https://api.thedogsharecollective.com';
}(typeof window !== 'undefined' ? window.location.host : 'prerender');

var IS_MESSAGING_ENABLED = function (host) {
  // If pre-rendering, return true
  if (isPrerendering || typeof window === 'undefined') {
    return true;
  }

  if (host === 'localhost:3000') {
    return true;
  }
  if (host === 'dogshare.co:3000') {
    return true;
  }
  if (host === 'stage.thedogsharecollective.com') {
    return true;
  }
  if (host === 'dogshare.io') {
    return true;
  }
  if (host === 'www.dogshare.io') {
    return true;
  }
  if (host === 'www.thedogsharecollective.com') {
    return true;
  }
  return true;
}(typeof window !== 'undefined' ? window.location.host : 'prerender');

var ASSET_BASE_URL = HOST;
var API_HOST = HOST + '/api/v1';
var CONTENT_AS_FORMDATA = false;
var REQUEST_TIMEOUT = 120000;

var TOP_LEVEL_DOMAIN = API_HOST.replace('/api/v1', '');
var AUTH_HEADER = 'X-Authorization';

/*
  Basic usage:

    request('auth/token', 'POST', {
      email: 'oliver.shaw@littlegiant.co.nz',
      password: 'password'
    });
*/
var request = function request(endpoint) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var allow_body_mutation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

  var API_ADDRESS = API_HOST;

  // Merge default headers with request headers
  var requestHeaders = Object.assign({}, headers || {});

  // Remove any headers with undefined values
  Object.keys(requestHeaders).forEach(function (key) {
    if (requestHeaders[key] === undefined || requestHeaders[key] === null) {
      console.warn('Removing header \'' + key + '\' with undefined/null value');
      delete requestHeaders[key];
    }
  });

  if (method == 'GET' && body !== null && Object.keys(body).length > 0) {
    endpoint = endpoint + '?' + encodeQueryData(body);
    console.log('GET request with query params, final endpoint:', endpoint);
  } else if (allow_body_mutation && method !== 'GET') {
    // Convert body to acceptable type
    if ((typeof body === 'undefined' ? 'undefined' : _typeof(body)) === 'object' && CONTENT_AS_FORMDATA && method !== 'PATCH') {
      // Convert object to FormData
      var formData = new FormData();
      for (var key in body) {
        formData.append(key, body[key]);
      }

      body = formData;
    } else if (CONTENT_AS_FORMDATA && method === 'PATCH') {
      requestHeaders = Object.assign({}, {
        'Content-Type': 'x-www-form-urlencoded'
      }, requestHeaders);

      body = encodeQueryData(body);
    } else if ((typeof body === 'undefined' ? 'undefined' : _typeof(body)) === 'object' && !CONTENT_AS_FORMDATA) {
      // Convert object to a JSON string
      body = JSON.stringify(body);
      // Set Content-Type header for JSON
      if (!requestHeaders['Content-Type']) {
        requestHeaders['Content-Type'] = 'application/json';
      }
    }
  }

  console.log('REQUEST_DISPATCHED', endpoint);
  var fullUrl = API_ADDRESS + '/' + endpoint;
  console.log('Full URL for fetch:', fullUrl);
  console.log('Request headers:', requestHeaders);
  console.log('Request method:', method);
  console.log('Request body:', method !== 'GET' ? body : 'N/A for GET');

  // Execute request - returns a Promise so we can chain subsequent actions to dispatch to the store
  return new Promise(function (resolve, reject) {
    timeoutPromise(REQUEST_TIMEOUT, fetch(fullUrl, {
      method: method,
      credentials: 'same-origin', // This is set on request
      headers: requestHeaders,
      body: method != 'GET' ? body : undefined
    })).then(function (response) {
      console.log('API_RESPONSE', endpoint, response.status);

      return response.json().then(function (responseJSON) {
        return (
          // Transform the response into its JSON representation
          {
            status: response.status,
            data: responseJSON
          }
        );
      }, function (error) {
        if (response.status >= 200 && response.status < 300) {
          // No body, but still a successful request. Return success code
          return {
            status: response.status,
            data: null
          };
        }
      });
    }, function (err) {
      console.error('Fetch failed for URL:', fullUrl);
      console.error('Error details:', err);
      console.error('Error message:', err.message);
      console.error('Error stack:', err.stack);
      reject(err);
    }).then(function (data) {
      if (data && data.status > 200) {
        reject(data);
      } else {
        resolve(data);
      }
    }, function (error) {
      console.log('API_ERROR', endpoint, headers, body);
      reject(error);
    });
  });
};

/*
  Assist creation of GET queries
 */
function encodeQueryData(data) {
  var ret = [];
  for (var d in data) {
    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
  }

  return ret.join('&');
}

/*
  Fetch wrapper to handle timeouts
 */
function timeoutPromise(ms, promise) {
  return new Promise(function (resolve, reject) {
    var timeoutId = setTimeout(function () {
      reject();
    }, ms);
    promise.then(function (res) {
      clearTimeout(timeoutId);
      resolve(res);
    }, function (err) {
      clearTimeout(timeoutId);
      reject(err);
    });
  });
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(467);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CompanyLogo__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserMenu__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MobileNav__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NotificationsMenu__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SettingsMenu__ = __webpack_require__(206);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint import/no-webpack-loader-syntax: off */
















var DashboardHeader = function (_Component) {
  _inherits(DashboardHeader, _Component);

  function DashboardHeader(props) {
    _classCallCheck(this, DashboardHeader);

    var _this = _possibleConstructorReturn(this, (DashboardHeader.__proto__ || Object.getPrototypeOf(DashboardHeader)).call(this, props));

    _this.state = {
      mobNavOpen: false
    };

    _this.logoutHandler = _this.props.logoutHandler.bind(_this);
    _this.toggleMobNav = _this.toggleMobNav.bind(_this);
    return _this;
  }

  _createClass(DashboardHeader, [{
    key: 'toggleMobNav',
    value: function toggleMobNav() {
      this.setState({
        mobNavOpen: !this.state.mobNavOpen
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          ACTIVE_SUBSCRIPTION = _props.user.active_subscription,
          unreadCount = _props.messaging.unreadCount;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container) + ' DashboardHeader' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.header_container) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.header) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.logo_container) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CompanyLogo__["a" /* default */], { link: '/find', styles: styles.company_logo })
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.links) },
              ACTIVE_SUBSCRIPTION ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
                {
                  to: '/find',
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.nav_item),
                  activeClassName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.nav_item_active)
                },
                'Find a dog'
              ) : null,
              ACTIVE_SUBSCRIPTION ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
                {
                  to: '/shares',
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.nav_item),
                  activeClassName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.nav_item_active)
                },
                'My Dog Shares'
              ) : null,
              ACTIVE_SUBSCRIPTION ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
                {
                  to: '/favourites',
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.nav_item),
                  activeClassName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.nav_item_active)
                },
                'My Favourites'
              ) : null,
              ACTIVE_SUBSCRIPTION && __WEBPACK_IMPORTED_MODULE_6__utils_Api__["a" /* IS_MESSAGING_ENABLED */] ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
                {
                  to: '/inbox',
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.nav_item, styles.nav_item_with_badge),
                  activeClassName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.nav_item_active)
                },
                'Messages',
                unreadCount > 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'span',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.unread_badge) },
                  unreadCount > 99 ? '99+' : unreadCount
                )
              ) : null
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.buttons) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__UserMenu__["a" /* default */], { user: this.props.user }),
              ACTIVE_SUBSCRIPTION ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__NotificationsMenu__["a" /* default */], this.props) : null,
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SettingsMenu__["a" /* default */], { logoutHandler: this.logoutHandler }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                {
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.mob_hamburger_wrapper),
                  onClick: this.toggleMobNav,
                  role: 'button',
                  tabIndex: 0
                },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.mob_hamburger) }),
                unreadCount > 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.mob_hamburger_indicator) })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__MobileNav__["a" /* default */], {
          toggle: this.toggleMobNav,
          isOpen: this.state.mobNavOpen,
          unreadCount: unreadCount
        })
      );
    }
  }]);

  return DashboardHeader;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

DashboardHeader.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  logoutHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  messaging: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object
};

DashboardHeader.defaultProps = {
  messaging: { unreadCount: 0 }
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  mob_hamburger_wrapper: _defineProperty({
    position: 'relative',
    display: 'none',
    width: 30,
    height: 21,
    marginLeft: 5,
    cursor: 'pointer'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }),
  mob_hamburger: {
    position: 'relative',
    height: 3,
    width: 30,
    borderRadius: 3,
    backgroundColor: '#000',

    ':before': {
      position: 'absolute',
      top: -9,
      height: 3,
      width: 30,
      borderRadius: 3,
      backgroundColor: '#000',
      content: '""'
    },

    ':after': {
      position: 'absolute',
      top: 9,
      height: 3,
      width: 30,
      borderRadius: 3,
      backgroundColor: '#000',
      content: '""'
    }
  },
  mob_hamburger_indicator: _defineProperty({
    position: 'absolute',
    top: -3,
    right: -3,
    height: 12,
    width: 12,
    borderRadius: 6,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].secondary,
    border: '2px solid ' + __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    display: 'none'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    display: 'block'
  }),
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: '100',
    display: 'flex',
    width: '100vw',
    height: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].navigation.height,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white
  },
  header_container: _defineProperty({
    position: 'relative',
    display: 'flex',
    margin: '0 auto',
    width: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].container_width,
    alignItems: 'center'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    paddingRight: 10
  }),
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row'
  },
  logo_container: _defineProperty({
    width: 180

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    width: 0
  }),
  company_logo: {
    position: 'absolute',
    top: 10,
    left: 0
  },
  links: _defineProperty({
    flex: 2,
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    display: 'none'
  }),
  buttons: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  nav_item: {
    position: 'relative',
    textTransform: 'uppercase',
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_secondary,
    fontSize: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_size_secondary,
    letterSpacing: 1,
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].dark_grey,
    transition: 'all 160ms ease-in-out',
    marginLeft: 20,
    marginRight: 20,
    ':hover': {
      color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].primary
    }
  },
  nav_item_disabled: {
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].grey,
    cursor: 'not-allowed',
    ':hover': {
      color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].grey
    }
  },
  nav_item_active: {
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].primary
  },
  nav_item_with_badge: {
    position: 'relative'
  },
  unread_badge: {
    position: 'absolute',
    top: -10,
    right: -20,
    minWidth: 20,
    height: 20,
    padding: '0 5px',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].secondary,
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    borderRadius: 10,
    fontSize: 12,
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary
  },
  coming_soon: {
    position: 'absolute',
    marginLeft: -10,
    maxWidth: 61,
    maxHeight: 23
  }
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    messaging: state.messaging
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(DashboardHeader));

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var PIN_ASSET = __webpack_require__(316);

var HorizontalRule = function (_Component) {
  _inherits(HorizontalRule, _Component);

  function HorizontalRule() {
    _classCallCheck(this, HorizontalRule);

    return _possibleConstructorReturn(this, (HorizontalRule.__proto__ || Object.getPrototypeOf(HorizontalRule)).apply(this, arguments));
  }

  _createClass(HorizontalRule, [{
    key: 'render',
    value: function render() {
      var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
        container: _defineProperty({
          position: 'relative',
          width: '100%',
          marginTop: this.props.margin,
          marginBottom: this.props.margin
        }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
          marginTop: this.props.margin / 2,
          marginBottom: this.props.margin / 2
        }),
        line: {
          height: 1,
          backgroundColor: this.props.color,
          opacity: 0.45
        },
        pin: _defineProperty({
          position: 'absolute',
          top: 2,
          right: '100%',
          transform: 'translateY(-50%)'
        }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
          display: 'none'
        })
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container) },
        this.props.pin ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, {
          cacheGetRequests: true,
          src: PIN_ASSET,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.pin)
        }) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.line) })
      );
    }
  }]);

  return HorizontalRule;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (HorizontalRule);


HorizontalRule.defaultProps = {
  margin: 40,
  color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].horizontal_rule_color,
  pin: false
};

HorizontalRule.propTypes = {
  margin: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  pin: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool
};

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ErrorContainer = function (_Component) {
  _inherits(ErrorContainer, _Component);

  function ErrorContainer() {
    _classCallCheck(this, ErrorContainer);

    return _possibleConstructorReturn(this, (ErrorContainer.__proto__ || Object.getPrototypeOf(ErrorContainer)).apply(this, arguments));
  }

  _createClass(ErrorContainer, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container) },
        this.props.message
      );
    }
  }]);

  return ErrorContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ErrorContainer);


ErrorContainer.propTypes = {
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: {
    position: 'relative',
    width: '100%',
    padding: '12px 15px',
    fontSize: 15,
    lineHeight: 1.4,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_primary,
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].error,

    ':after': {
      bottom: '100%',
      left: 20,
      border: 'solid transparent',
      content: '""',
      height: 0,
      width: 0,
      position: 'absolute',
      pointerEvents: 'none',
      borderColor: 'rgba(232, 94, 94, 0)',
      borderBottomColor: '#E85E5E',
      borderWidth: 10,
      marginLeft: -10
    }
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchAppData;
/* harmony export (immutable) */ __webpack_exports__["f"] = getBlogPosts;
/* harmony export (immutable) */ __webpack_exports__["c"] = getBlogPost;
/* harmony export (immutable) */ __webpack_exports__["g"] = getFAQs;
/* harmony export (immutable) */ __webpack_exports__["b"] = getResources;
/* harmony export (immutable) */ __webpack_exports__["h"] = getTestimonials;
/* harmony export (immutable) */ __webpack_exports__["e"] = getTerms;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPrivacy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Api__ = __webpack_require__(18);


function fetchAppData(fields) {
  // eslint-disable-line
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('config').then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_APP_DATA',
            payload: response.data
          });

          resolve();
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function getBlogPosts() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('blog').then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_BLOG_POSTS',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function getBlogPost(slug) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('blog/' + slug).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_BLOG_POST_BY_ID',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function getFAQs() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('faq').then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_FAQS',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function getResources() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('resources').then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_RESOURCES',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function getTestimonials() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('testimonials').then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_TESTIMONIALS',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function getTerms() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('terms').then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_TERMS',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function getPrivacy() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('privacy').then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_PRIVACY',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(162);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_tippy__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_tippy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_tippy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_tippy_dist_tippy_css__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_tippy_dist_tippy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_tippy_dist_tippy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ErrorContainer__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_theme__ = __webpack_require__(2);
var _label;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var TOOLTIP_ASSET = __webpack_require__(108);
var CHECK_ASSET = __webpack_require__(307);

var CheckboxField = function (_Component) {
  _inherits(CheckboxField, _Component);

  function CheckboxField(props) {
    _classCallCheck(this, CheckboxField);

    var _this = _possibleConstructorReturn(this, (CheckboxField.__proto__ || Object.getPrototypeOf(CheckboxField)).call(this, props));

    _this.assignClasses = _this.assignClasses.bind(_this);
    _this.changeHandler = _this.handleChange.bind(_this);
    _this.state = {
      error: null
    };
    return _this;
  }

  _createClass(CheckboxField, [{
    key: 'assignClasses',
    value: function assignClasses() {
      this.fieldClasses = [styles.field, this.props.fullWidth ? styles.field_fw : null];

      this.labelClasses = [styles.label, this.state.error ? styles.label_error : null];

      this.inputClasses = [styles.input, this.state.error ? styles.input_error : null];
    }
  }, {
    key: 'handleChange',
    value: function handleChange() {
      this.props.handler(this.props.name, !this.props.value);
    }
  }, {
    key: 'render',
    value: function render() {
      this.assignClasses();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.fieldClasses) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
          id: this.props.id,
          type: 'checkbox',
          onClick: this.changeHandler,
          name: this.props.name,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.inputClasses),
          checked: this.props.value
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          { htmlFor: this.props.id, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.labelClasses) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.label_text) },
            this.props.label
          ),
          this.props.note ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.note) },
            this.props.note
          ) : null,
          this.props.error ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ErrorContainer__["a" /* default */], { message: this.props.error }) : null
        ),
        this.props.tooltip ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_tippy__["Tooltip"],
          {
            position: 'bottom',
            arrow: true,
            html: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.tooltip) },
              this.props.tooltip
            )
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, {
            cacheGetRequests: true,
            src: TOOLTIP_ASSET,
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.tooltip_trigger)
          })
        ) : null
      );
    }
  }]);

  return CheckboxField;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (CheckboxField);


CheckboxField.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  fullWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  tooltip: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  error: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  note: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  handler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired
};

CheckboxField.defaultProps = {
  fullWidth: false,
  tooltip: null,
  error: null,
  note: null,
  value: false
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  note: {
    display: 'block',
    width: '100%',
    paddingLeft: 44,
    fontSize: 14,
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_family_primary,
    color: '#828282'
  },
  tooltip: {
    padding: 5,
    fontSize: 14,
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_family_primary
  },
  tooltip_trigger: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 10px',
    cursor: 'pointer'
  },
  field: _defineProperty({
    display: 'flex',
    alignItems: 'center',
    'user-select': 'none',
    position: 'relative',
    width: '50%',
    padding: '0 5px'
  }, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    'margin-bottom': 15
  }),
  field_fw: {
    width: '100%',
    ':not(:first-child)': {
      marginTop: 20
    }
  },
  label: (_label = {
    userSelect: 'none',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    flexShrink: 0,
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_weight_primary,
    fontSize: 15,
    color: '#000e1f',
    cursor: 'pointer'
  }, _defineProperty(_label, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].mobile_query, {
    position: 'relative',
    paddingLeft: 44,
    minHeight: 30,
    paddingTop: '0.2em',
    flexShrink: 1
  }), _defineProperty(_label, ':before', _defineProperty({
    flexShrink: 0,
    display: 'block',
    width: 30,
    height: 30,
    margin: '0 14px 0 0',
    borderRadius: 3,
    backgroundColor: '#fff',
    border: '1px solid #e4e4e4',
    boxSizing: 'border-box',
    backgroundImage: 'url(' + CHECK_ASSET + ')',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: '0 0',
    content: '""'
  }, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].mobile_query, {
    position: 'absolute',
    top: 0,
    left: 0
  })), _label),
  label_text: {
    minWidth: 50,
    flexGrow: 0,
    lineHeight: '1.5'
  },
  label_error: {
    color: '#E85E5E'
  },
  input: {
    position: 'absolute',
    top: 0,
    left: 5,
    width: 30,
    height: 30,
    opacity: 0,
    cursor: 'pointer',

    ':checked + label:before': {
      backgroundSize: '14px 13px'
    }
  },
  input_error: {
    color: '#E85E5E',
    borderColor: '#E85E5E',

    '::placeholder': {
      color: '#E85E5E'
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);




var SEO = function SEO(_ref) {
  var title = _ref.title,
      description = _ref.description,
      keywords = _ref.keywords,
      image = _ref.image,
      url = _ref.url,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'website' : _ref$type;

  var siteTitle = 'The Dog Share Collective';
  var defaultDescription = "You can't always be around your dog. Good thing is, heaps of people would love to have a dog around, just sometimes. Our mission is to make that introduction, with The Dog Share Collective.";
  var defaultImage = 'https://www.thedogsharecollective.com/images/tdsc-share.png';
  var siteUrl = 'https://www.thedogsharecollective.com';

  var metaTitle = title ? title + ' | ' + siteTitle : siteTitle;
  var metaDescription = description || defaultDescription;
  var metaImage = image || defaultImage;
  var metaUrl = url || siteUrl;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_helmet__["Helmet"],
    null,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'title',
      null,
      metaTitle
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('meta', { name: 'description', content: metaDescription }),
    keywords && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('meta', { name: 'keywords', content: keywords }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('meta', { property: 'og:title', content: metaTitle }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('meta', { property: 'og:description', content: metaDescription }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('meta', { property: 'og:type', content: type }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('meta', { property: 'og:url', content: metaUrl }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('meta', { property: 'og:image', content: metaImage }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('meta', { property: 'og:site_name', content: siteTitle }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('meta', { name: 'twitter:title', content: metaTitle }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('meta', { name: 'twitter:description', content: metaDescription }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('meta', { name: 'twitter:image', content: metaImage }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('link', { rel: 'canonical', href: metaUrl })
  );
};

SEO.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  keywords: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (SEO);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_tippy__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_tippy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_tippy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ErrorContainer__ = __webpack_require__(22);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var TOOLTIP_ASSET = __webpack_require__(108);
var ARROW_ASSET = __webpack_require__(335);

var SimpleSelect = function (_Component) {
  _inherits(SimpleSelect, _Component);

  function SimpleSelect(props) {
    _classCallCheck(this, SimpleSelect);

    var _this = _possibleConstructorReturn(this, (SimpleSelect.__proto__ || Object.getPrototypeOf(SimpleSelect)).call(this, props));

    _this.assignClasses = _this.assignClasses.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.state = {
      error: _this.props.error
    };
    return _this;
  }

  _createClass(SimpleSelect, [{
    key: 'handleChange',
    value: function handleChange(event) {
      this.props.handleChange();

      if (this.props.required && event.target.value.length === 0) {
        this.setState({
          error: 'This field is required'
        });
      }

      if (this.props.handler && typeof this.props.handler === 'function') {
        this.props.handler(this.props.name, event.target.value);
      }
    }
  }, {
    key: 'assignClasses',
    value: function assignClasses() {
      this.fieldClasses = [styles.field, this.props.fullWidth ? styles.field_fw : null, this.props.styles];

      this.labelClasses = [styles.label, this.props.error ? styles.label_error : null];

      this.inputClasses = [styles.input, this.props.error ? styles.input_error : null];
    }
  }, {
    key: 'render',
    value: function render() {
      this.assignClasses();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.fieldClasses) },
        !this.props.hideLabel ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            { htmlFor: this.props.id, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.labelClasses) },
            this.props.label
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.tooltipContainer) },
            this.props.tooltip ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_tippy__["Tooltip"],
              {
                position: 'bottom',
                arrow: true,
                html: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.tooltip) },
                  this.props.tooltip
                )
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, {
                cacheGetRequests: true,
                src: TOOLTIP_ASSET,
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.tooltip_trigger)
              })
            ) : null
          )
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.select_container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'select',
            {
              id: this.props.id,
              name: this.props.name,
              className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.inputClasses),
              required: true,
              disabled: this.props.disabled,
              onChange: this.handleChange,
              value: this.props.value
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'option',
              { value: '', disabled: true, selected: this.props.value ? false : 'selected' },
              this.props.placeholder ? this.props.placeholder : 'Select ' + this.props.label
            ),
            this.props.options.map(function (option) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                {
                  key: option.value,
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.includes_item),
                  value: option.value
                },
                option.label
              );
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, {
            cacheGetRequests: true,
            src: ARROW_ASSET,
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.select_arrow)
          })
        ),
        this.props.error ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ErrorContainer__["a" /* default */], { message: this.props.error }) : null
      );
    }
  }]);

  return SimpleSelect;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SimpleSelect);


SimpleSelect.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  error: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  fullWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  hideLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object).isRequired,
  handleChange: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func,
  handler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func,
  tooltip: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object]))
};

SimpleSelect.defaultProps = {
  placeholder: null,
  error: null,
  value: null,
  textArea: false,
  fullWidth: false,
  disabled: false,
  hideLabel: false,
  required: false,
  styles: null,
  tooltip: null,
  handleChange: function handleChange() {},
  handler: function handler() {}
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  select_container: {
    position: 'relative'
  },
  field: _defineProperty({
    position: 'relative',
    width: '50%',
    marginBottom: 15,
    padding: '0 5px'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  field_fw: {
    width: '100%'
  },
  label: {
    display: 'block',
    marginBottom: 9,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_primary,
    fontSize: 14,
    color: '#828282'
  },
  label_error: {
    color: '#E85E5E'
  },
  tooltipContainer: {
    position: 'absolute',
    top: 0,
    right: 0
  },
  tooltip: {
    padding: 5,
    fontSize: 14,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary
  },
  tooltip_trigger: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    margin: '0 10px',
    cursor: 'pointer'
  },
  input: {
    width: '100%',
    height: 50,
    padding: '0 16px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_primary,
    fontSize: 15,
    color: '#000e1f',
    borderRadius: 3,
    backgroundColor: '#fff',
    border: '1px solid #e4e4e4',
    outline: 'none',
    transition: 'all 300ms',
    appearance: 'none',
    cursor: 'pointer',

    '::placeholder': {
      fontSize: 14,
      color: '#bbb'
    },

    ':invalid': {
      fontSize: 14,
      color: '#bbb'
    },

    ':focus': {
      borderColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].turquoise
    },

    ':disabled': {
      backgroundColor: '#f5f5f5',
      color: '#828282',
      cursor: 'not-allowed'
    }
  },
  input_error: {
    color: '#E85E5E',
    borderColor: '#E85E5E',
    borderWidth: 2,
    borderRadius: '3px 3px 0 0',

    ':invalid': {
      color: '#E85E5E'
    },

    ':focus': {
      borderColor: '#E85E5E'
    }
  },
  select_arrow: {
    position: 'absolute',
    bottom: 0,
    right: 20,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    height: 50,
    width: 9,
    pointerEvents: 'none',
    transition: 'all 300ms'
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(569);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Bounce */
/* unused harmony export Flip */
/* unused harmony export Slide */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToastContainer; });
/* unused harmony export Zoom */
/* unused harmony export collapseToast */
/* unused harmony export cssTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toast; });
/* unused harmony export useToast */
/* unused harmony export useToastContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function isNum(v) {
  return typeof v === 'number' && !isNaN(v);
}
function isBool(v) {
  return typeof v === 'boolean';
}
function isStr(v) {
  return typeof v === 'string';
}
function isFn(v) {
  return typeof v === 'function';
}
function parseClassName(v) {
  return isStr(v) || isFn(v) ? v : null;
}
function objectValues(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
}
function hasToastId(toastId) {
  return toastId === 0 || toastId;
}
function getAutoCloseDelay(toastAutoClose, containerAutoClose) {
  return toastAutoClose === false || isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}
var canUseDom = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function canBeRendered(content) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(content) || isStr(content) || isFn(content) || isNum(content);
}

var POSITION = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  TOP_CENTER: 'top-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_CENTER: 'bottom-center'
};
var TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'default',
  DARK: 'dark'
};

/**
 * Used to collapse toast after exit animation
 */
function collapseToast(node, done, duration
/* COLLAPSE_DURATION */
) {
  if (duration === void 0) {
    duration = 300;
  }

  var height = node.scrollHeight;
  var style = node.style;
  requestAnimationFrame(function () {
    style.minHeight = 'initial';
    style.height = height + 'px';
    style.transition = "all " + duration + "ms";
    requestAnimationFrame(function () {
      style.height = '0';
      style.padding = '0';
      style.margin = '0';
      setTimeout(function () {
        return done();
      }, duration);
    });
  });
}

function cssTransition(_ref) {
  var enter = _ref.enter,
      exit = _ref.exit,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 750 : _ref$duration,
      _ref$appendPosition = _ref.appendPosition,
      appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition,
      _ref$collapse = _ref.collapse,
      collapse = _ref$collapse === void 0 ? true : _ref$collapse,
      _ref$collapseDuration = _ref.collapseDuration,
      collapseDuration = _ref$collapseDuration === void 0 ? 300 : _ref$collapseDuration;
  var enterDuration, exitDuration;

  if (Array.isArray(duration) && duration.length === 2) {
    enterDuration = duration[0];
    exitDuration = duration[1];
  } else {
    enterDuration = exitDuration = duration;
  }

  return function ToastTransition(_ref2) {
    var children = _ref2.children,
        position = _ref2.position,
        preventExitTransition = _ref2.preventExitTransition,
        done = _ref2.done,
        props = _objectWithoutPropertiesLoose(_ref2, ["children", "position", "preventExitTransition", "done"]);

    var enterClassName = appendPosition ? enter + "--" + position : enter;
    var exitClassName = appendPosition ? exit + "--" + position : exit;

    var onEnter = function onEnter() {
      var node = props.nodeRef.current;

      if (node) {
        node.classList.add(enterClassName);
        node.style.animationFillMode = 'forwards';
        node.style.animationDuration = enterDuration + "ms";
      }
    };

    var onEntered = function onEntered() {
      var node = props.nodeRef.current;

      if (node) {
        node.classList.remove(enterClassName);
        node.style.removeProperty('animationFillMode');
        node.style.removeProperty('animationDuration');
      }
    };

    var onExited = function onExited() {
      var node = props.nodeRef.current;

      if (node) {
        node.removeEventListener('animationend', onExited);
        collapse ? collapseToast(node, done, collapseDuration) : done();
      }
    };

    var onExit = function onExit() {
      var node = props.nodeRef.current;

      if (node) {
        node.classList.add(exitClassName);
        node.style.animationFillMode = 'forwards';
        node.style.animationDuration = exitDuration + "ms";
        node.addEventListener('animationend', onExited);
      }
    };

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_1_react_transition_group__["a" /* Transition */], Object.assign({}, props, {
      timeout: preventExitTransition ? collapse ? collapseDuration : 50
      /* DEBOUNCE_DURATION */
      : {
        enter: enterDuration,
        exit: collapse ? exitDuration + collapseDuration : exitDuration + 50
        /* DEBOUNCE_DURATION */

      },
      onEnter: onEnter,
      onEntered: onEntered,
      onExit: preventExitTransition ? onExited : onExit,
      unmountOnExit: true
    }), children);
  };
}

var eventManager = {
  list: /*#__PURE__*/new Map(),
  emitQueue: /*#__PURE__*/new Map(),
  on: function on(event, callback) {
    this.list.has(event) || this.list.set(event, []);
    this.list.get(event).push(callback);
    return this;
  },
  off: function off(event, callback) {
    if (callback) {
      var cb = this.list.get(event).filter(function (cb) {
        return cb !== callback;
      });
      this.list.set(event, cb);
      return this;
    }

    this.list["delete"](event);
    return this;
  },
  cancelEmit: function cancelEmit(event) {
    var timers = this.emitQueue.get(event);

    if (timers) {
      timers.forEach(function (timer) {
        return clearTimeout(timer);
      });
      this.emitQueue["delete"](event);
    }

    return this;
  },

  /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */
  emit: function emit(event) {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    this.list.has(event) && this.list.get(event).forEach(function (callback) {
      var timer = setTimeout(function () {
        // @ts-ignore
        callback.apply(void 0, args);
      }, 0);
      _this.emitQueue.has(event) || _this.emitQueue.set(event, []);

      _this.emitQueue.get(event).push(timer);
    });
  }
};

/**
 * `useKeeper` is a helper around `useRef`.
 *
 * You don't need to access the `.current`property to get the value
 * If refresh is set to true. The ref will be updated every render
 */

function useKeeper(arg, refresh) {
  if (refresh === void 0) {
    refresh = false;
  }

  var ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(arg);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (refresh) ref.current = arg;
  });
  return ref.current;
}

function reducer(state, action) {
  switch (action.type) {
    case 'ADD':
      return [].concat(state, [action.toastId]).filter(function (id) {
        return id !== action.staleId;
      });

    case 'REMOVE':
      return hasToastId(action.toastId) ? state.filter(function (id) {
        return id !== action.toastId;
      }) : [];
  }
}

function useToastContainer(props) {
  var _useReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(function (x) {
    return x + 1;
  }, 0),
      forceUpdate = _useReducer[1];

  var _useReducer2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(reducer, []),
      toast = _useReducer2[0],
      dispatch = _useReducer2[1];

  var containerRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var toastCount = useKeeper(0);
  var queue = useKeeper([]);
  var collection = useKeeper({});
  var instance = useKeeper({
    toastKey: 1,
    displayedToast: 0,
    props: props,
    containerId: null,
    isToastActive: isToastActive,
    getToast: function getToast(id) {
      return collection[id] || null;
    }
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    instance.containerId = props.containerId;
    eventManager.cancelEmit(3
    /* WillUnmount */
    ).on(0
    /* Show */
    , buildToast).on(1
    /* Clear */
    , function (toastId) {
      return containerRef.current && removeToast(toastId);
    }).on(5
    /* ClearWaitingQueue */
    , clearWaitingQueue).emit(2
    /* DidMount */
    , instance);
    return function () {
      return eventManager.emit(3
      /* WillUnmount */
      , instance);
    };
  }, []);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    instance.isToastActive = isToastActive;
    instance.displayedToast = toast.length;
    eventManager.emit(4
    /* Change */
    , toast.length, props.containerId);
  }, [toast]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    instance.props = props;
  });

  function isToastActive(id) {
    return toast.indexOf(id) !== -1;
  }

  function clearWaitingQueue(_ref) {
    var containerId = _ref.containerId;
    var _instance$props = instance.props,
        limit = _instance$props.limit,
        enableMultiContainer = _instance$props.enableMultiContainer;

    if (limit && (!containerId || instance.containerId === containerId && enableMultiContainer)) {
      toastCount -= queue.length;
      queue = [];
    }
  }

  function removeToast(toastId) {
    var queueLen = queue.length;
    toastCount = hasToastId(toastId) ? toastCount - 1 : toastCount - instance.displayedToast;
    if (toastCount < 0) toastCount = 0;

    if (queueLen > 0) {
      var freeSlot = hasToastId(toastId) ? 1 : instance.props.limit;

      if (queueLen === 1 || freeSlot === 1) {
        instance.displayedToast++;
        dequeueToast();
      } else {
        var toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
        instance.displayedToast = toDequeue;

        for (var i = 0; i < toDequeue; i++) {
          dequeueToast();
        }
      }
    }

    dispatch({
      type: 'REMOVE',
      toastId: toastId
    });
  }

  function dequeueToast() {
    var _queue$shift = queue.shift(),
        toastContent = _queue$shift.toastContent,
        toastProps = _queue$shift.toastProps,
        staleId = _queue$shift.staleId; // ensure that exit transition has been completed, hence the timeout


    setTimeout(function () {
      appendToast(toastContent, toastProps, staleId);
    }, 500);
  }
  /**
   * check if a container is attached to the dom
   * check for multi-container, build only if associated
   * check for duplicate toastId if no update
   */


  function isNotValid(_ref2) {
    var containerId = _ref2.containerId,
        toastId = _ref2.toastId,
        updateId = _ref2.updateId;
    return !containerRef.current || instance.props.enableMultiContainer && containerId !== instance.props.containerId || instance.isToastActive(toastId) && updateId == null ? true : false;
  } // this function and all the function called inside needs to rely on ref(`useKeeper`)


  function buildToast(content, _ref3) {
    var delay = _ref3.delay,
        staleId = _ref3.staleId,
        options = _objectWithoutPropertiesLoose(_ref3, ["delay", "staleId"]);

    if (!canBeRendered(content) || isNotValid(options)) return;
    var toastId = options.toastId,
        updateId = options.updateId;
    var props = instance.props,
        isToastActive = instance.isToastActive;

    var closeToast = function closeToast() {
      return removeToast(toastId);
    };

    var isNotAnUpdate = !isToastActive(toastId);
    if (isNotAnUpdate) toastCount++;
    var toastProps = {
      toastId: toastId,
      updateId: updateId,
      key: options.key || instance.toastKey++,
      type: options.type,
      closeToast: closeToast,
      closeButton: options.closeButton,
      rtl: props.rtl,
      position: options.position || props.position,
      transition: options.transition || props.transition,
      className: parseClassName(options.className || props.toastClassName),
      bodyClassName: parseClassName(options.bodyClassName || props.bodyClassName),
      style: options.style || props.toastStyle,
      bodyStyle: options.bodyStyle || props.bodyStyle,
      onClick: options.onClick || props.onClick,
      pauseOnHover: isBool(options.pauseOnHover) ? options.pauseOnHover : props.pauseOnHover,
      pauseOnFocusLoss: isBool(options.pauseOnFocusLoss) ? options.pauseOnFocusLoss : props.pauseOnFocusLoss,
      draggable: isBool(options.draggable) ? options.draggable : props.draggable,
      draggablePercent: isNum(options.draggablePercent) ? options.draggablePercent : props.draggablePercent,
      closeOnClick: isBool(options.closeOnClick) ? options.closeOnClick : props.closeOnClick,
      progressClassName: parseClassName(options.progressClassName || props.progressClassName),
      progressStyle: options.progressStyle || props.progressStyle,
      autoClose: getAutoCloseDelay(options.autoClose, props.autoClose),
      hideProgressBar: isBool(options.hideProgressBar) ? options.hideProgressBar : props.hideProgressBar,
      progress: options.progress,
      role: isStr(options.role) ? options.role : props.role,
      deleteToast: function deleteToast() {
        removeFromCollection(toastId);
      }
    };
    if (isFn(options.onOpen)) toastProps.onOpen = options.onOpen;
    if (isFn(options.onClose)) toastProps.onClose = options.onClose;
    var closeButton = props.closeButton;

    if (options.closeButton === false || canBeRendered(options.closeButton)) {
      closeButton = options.closeButton;
    } else if (options.closeButton === true) {
      closeButton = canBeRendered(props.closeButton) ? props.closeButton : true;
    }

    toastProps.closeButton = closeButton;
    var toastContent = content;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(content) && !isStr(content.type)) {
      toastContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(content, {
        closeToast: closeToast,
        toastProps: toastProps
      });
    } else if (isFn(content)) {
      toastContent = content({
        closeToast: closeToast,
        toastProps: toastProps
      });
    } // not handling limit + delay by design. Waiting for user feedback first


    if (props.limit && props.limit > 0 && toastCount > props.limit && isNotAnUpdate) {
      queue.push({
        toastContent: toastContent,
        toastProps: toastProps,
        staleId: staleId
      });
    } else if (isNum(delay) && delay > 0) {
      setTimeout(function () {
        appendToast(toastContent, toastProps, staleId);
      }, delay);
    } else {
      appendToast(toastContent, toastProps, staleId);
    }
  }

  function appendToast(content, toastProps, staleId) {
    var toastId = toastProps.toastId;
    collection[toastId] = {
      content: content,
      props: toastProps
    };
    dispatch({
      type: 'ADD',
      toastId: toastId,
      staleId: staleId
    });
  }

  function removeFromCollection(toastId) {
    delete collection[toastId];
    forceUpdate();
  }

  function getToastToRender(cb) {
    var toastToRender = {};
    var toastList = props.newestOnTop ? Object.keys(collection).reverse() : Object.keys(collection);

    for (var i = 0; i < toastList.length; i++) {
      var _toast = collection[toastList[i]];
      var position = _toast.props.position;
      toastToRender[position] || (toastToRender[position] = []);
      toastToRender[position].push(_toast);
    }

    return Object.keys(toastToRender).map(function (p) {
      return cb(p, toastToRender[p]);
    });
  }

  return {
    getToastToRender: getToastToRender,
    collection: collection,
    containerRef: containerRef,
    isToastActive: isToastActive
  };
}

function getX(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}

function getY(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}

function useToast(props) {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
      isRunning = _useState[0],
      setIsRunning = _useState[1];

  var _useState2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      preventExitTransition = _useState2[0],
      setPreventExitTransition = _useState2[1];

  var toastRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var drag = useKeeper({
    start: 0,
    x: 0,
    y: 0,
    deltaX: 0,
    removalDistance: 0,
    canCloseOnClick: true,
    canDrag: false,
    boundingRect: null
  });
  var syncProps = useKeeper(props, true);
  var autoClose = props.autoClose,
      pauseOnHover = props.pauseOnHover,
      closeToast = props.closeToast,
      onClick = props.onClick,
      closeOnClick = props.closeOnClick;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (isFn(props.onOpen)) props.onOpen(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(props.children) && props.children.props);
    return function () {
      if (isFn(syncProps.onClose)) syncProps.onClose(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(syncProps.children) && syncProps.children.props);
    };
  }, []);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    props.draggable && bindDragEvents();
    return function () {
      props.draggable && unbindDragEvents();
    };
  }, [props.draggable]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    props.pauseOnFocusLoss && bindFocusEvents();
    return function () {
      props.pauseOnFocusLoss && unbindFocusEvents();
    };
  }, [props.pauseOnFocusLoss]);

  function onDragStart(e) {
    var toast = toastRef.current;
    drag.canCloseOnClick = true;
    drag.canDrag = true;
    drag.boundingRect = toast.getBoundingClientRect();
    toast.style.transition = '';
    drag.start = drag.x = getX(e.nativeEvent);
    drag.removalDistance = toast.offsetWidth * (props.draggablePercent / 100);
  }

  function onDragTransitionEnd() {
    if (drag.boundingRect) {
      var _drag$boundingRect = drag.boundingRect,
          top = _drag$boundingRect.top,
          bottom = _drag$boundingRect.bottom,
          left = _drag$boundingRect.left,
          right = _drag$boundingRect.right;

      if (props.pauseOnHover && drag.x >= left && drag.x <= right && drag.y >= top && drag.y <= bottom) {
        pauseToast();
      } else {
        playToast();
      }
    }
  }

  function playToast() {
    setIsRunning(true);
  }

  function pauseToast() {
    setIsRunning(false);
  }

  function bindFocusEvents() {
    window.addEventListener('focus', playToast);
    window.addEventListener('blur', pauseToast);
  }

  function unbindFocusEvents() {
    window.removeEventListener('focus', playToast);
    window.removeEventListener('blur', pauseToast);
  }

  function bindDragEvents() {
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('mouseup', onDragEnd);
    document.addEventListener('touchmove', onDragMove);
    document.addEventListener('touchend', onDragEnd);
  }

  function unbindDragEvents() {
    document.removeEventListener('mousemove', onDragMove);
    document.removeEventListener('mouseup', onDragEnd);
    document.removeEventListener('touchmove', onDragMove);
    document.removeEventListener('touchend', onDragEnd);
  }

  function onDragMove(e) {
    e.preventDefault();
    var toast = toastRef.current;

    if (drag.canDrag) {
      if (isRunning) pauseToast();
      drag.x = getX(e);
      drag.deltaX = drag.x - drag.start;
      drag.y = getY(e); // prevent false positif during a toast click

      if (drag.start !== drag.x) drag.canCloseOnClick = false;
      toast.style.transform = "translateX(" + drag.deltaX + "px)";
      toast.style.opacity = "" + (1 - Math.abs(drag.deltaX / drag.removalDistance));
    }
  }

  function onDragEnd() {
    var toast = toastRef.current;

    if (drag.canDrag) {
      drag.canDrag = false;

      if (Math.abs(drag.deltaX) > drag.removalDistance) {
        setPreventExitTransition(true);
        props.closeToast();
        return;
      }

      toast.style.transition = 'transform 0.2s, opacity 0.2s';
      toast.style.transform = 'translateX(0)';
      toast.style.opacity = '1';
    }
  }

  var eventHandlers = {
    onMouseDown: onDragStart,
    onTouchStart: onDragStart,
    onMouseUp: onDragTransitionEnd,
    onTouchEnd: onDragTransitionEnd
  };

  if (autoClose && pauseOnHover) {
    eventHandlers.onMouseEnter = pauseToast;
    eventHandlers.onMouseLeave = playToast;
  } // prevent toast from closing when user drags the toast


  if (closeOnClick) {
    eventHandlers.onClick = function (e) {
      onClick && onClick(e);
      drag.canCloseOnClick && closeToast();
    };
  }

  return {
    playToast: playToast,
    pauseToast: pauseToast,
    isRunning: isRunning,
    preventExitTransition: preventExitTransition,
    toastRef: toastRef,
    eventHandlers: eventHandlers
  };
}

function CloseButton(_ref) {
  var closeToast = _ref.closeToast,
      type = _ref.type,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? 'close' : _ref$ariaLabel;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("button", {
    className: "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button " + "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button--" + type,
    type: "button",
    onClick: function onClick(e) {
      e.stopPropagation();
      closeToast(e);
    },
    "aria-label": ariaLabel
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 14 16"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("path", {
    fillRule: "evenodd",
    d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
  })));
}

function ProgressBar(_ref) {
  var _ref2, _animationEvent;

  var delay = _ref.delay,
      isRunning = _ref.isRunning,
      closeToast = _ref.closeToast,
      type = _ref.type,
      hide = _ref.hide,
      className = _ref.className,
      userStyle = _ref.style,
      controlledProgress = _ref.controlledProgress,
      progress = _ref.progress,
      rtl = _ref.rtl,
      isIn = _ref.isIn;

  var style = _extends({}, userStyle, {
    animationDuration: delay + "ms",
    animationPlayState: isRunning ? 'running' : 'paused',
    opacity: hide ? 0 : 1
  });

  if (controlledProgress) style.transform = "scaleX(" + progress + ")";
  var defaultClassArr = ["Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar", controlledProgress ? "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--controlled" : "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--animated", "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--" + type, (_ref2 = {}, _ref2["Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--rtl"] = rtl, _ref2)];
  var classNames = isFn(className) ? className({
    rtl: rtl,
    type: type,
    defaultClassName: __WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */].apply(void 0, defaultClassArr)
  }) : __WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */].apply(void 0, [].concat(defaultClassArr, [className])); // 🧐 controlledProgress is derived from progress
  // so if controlledProgress is set
  // it means that this is also the case for progress

  var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? 'onTransitionEnd' : 'onAnimationEnd'] = controlledProgress && progress < 1 ? null : function () {
    isIn && closeToast();
  }, _animationEvent);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", Object.assign({
    className: classNames,
    style: style
  }, animationEvent));
}
ProgressBar.defaultProps = {
  type: TYPE.DEFAULT,
  hide: false
};

var Toast = function Toast(props) {
  var _ref;

  var _useToast = useToast(props),
      isRunning = _useToast.isRunning,
      preventExitTransition = _useToast.preventExitTransition,
      toastRef = _useToast.toastRef,
      eventHandlers = _useToast.eventHandlers;

  var closeButton = props.closeButton,
      children = props.children,
      autoClose = props.autoClose,
      onClick = props.onClick,
      type = props.type,
      hideProgressBar = props.hideProgressBar,
      closeToast = props.closeToast,
      Transition = props.transition,
      position = props.position,
      className = props.className,
      style = props.style,
      bodyClassName = props.bodyClassName,
      bodyStyle = props.bodyStyle,
      progressClassName = props.progressClassName,
      progressStyle = props.progressStyle,
      updateId = props.updateId,
      role = props.role,
      progress = props.progress,
      rtl = props.rtl,
      toastId = props.toastId,
      deleteToast = props.deleteToast;
  var defaultClassArr = ["Toastify"
  /* CSS_NAMESPACE */
  + "__toast", "Toastify"
  /* CSS_NAMESPACE */
  + "__toast--" + type, (_ref = {}, _ref["Toastify"
  /* CSS_NAMESPACE */
  + "__toast--rtl"] = rtl, _ref)];
  var cssClasses = isFn(className) ? className({
    rtl: rtl,
    position: position,
    type: type,
    defaultClassName: __WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */].apply(void 0, defaultClassArr)
  }) : __WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */].apply(void 0, [].concat(defaultClassArr, [className]));
  var controlledProgress = !!progress;

  function renderCloseButton(closeButton) {
    if (!closeButton) return;
    var props = {
      closeToast: closeToast,
      type: type
    };
    if (isFn(closeButton)) return closeButton(props);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(closeButton)) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(closeButton, props);
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Transition, {
    "in": props["in"],
    appear: true,
    done: deleteToast,
    position: position,
    preventExitTransition: preventExitTransition,
    nodeRef: toastRef
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", Object.assign({
    id: toastId,
    onClick: onClick,
    className: cssClasses || undefined
  }, eventHandlers, {
    style: style,
    ref: toastRef
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", Object.assign({}, props["in"] && {
    role: role
  }, {
    className: isFn(bodyClassName) ? bodyClassName({
      type: type
    }) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])("Toastify"
    /* CSS_NAMESPACE */
    + "__toast-body", bodyClassName),
    style: bodyStyle
  }), children), renderCloseButton(closeButton), (autoClose || controlledProgress) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ProgressBar, Object.assign({}, updateId && !controlledProgress ? {
    key: "pb-" + updateId
  } : {}, {
    rtl: rtl,
    delay: autoClose,
    isRunning: isRunning,
    isIn: props["in"],
    closeToast: closeToast,
    hide: hideProgressBar,
    type: type,
    style: progressStyle,
    className: progressClassName,
    controlledProgress: controlledProgress,
    progress: progress
  }))));
};

var Bounce = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-exit",
  appendPosition: true
});
var Slide = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "__slide-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "__slide-exit",
  duration: [450, 750],
  appendPosition: true
});
var Zoom = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "__zoom-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "__zoom-exit"
});
var Flip = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "__flip-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "__flip-exit"
});

var ToastPositioner = function ToastPositioner(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "className", "style"]);

  // Monkey patch react-transition-group
  // As exit transition is broken with strict mode
  delete rest["in"];
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
    className: className,
    style: style
  }, __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, rest);
  }));
};

var ToastContainer = function ToastContainer(props) {
  var _useToastContainer = useToastContainer(props),
      getToastToRender = _useToastContainer.getToastToRender,
      containerRef = _useToastContainer.containerRef,
      isToastActive = _useToastContainer.isToastActive;

  var className = props.className,
      style = props.style,
      rtl = props.rtl,
      containerId = props.containerId;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
    ref: containerRef,
    className: "Toastify"
    /* CSS_NAMESPACE */
    ,
    id: containerId
  }, getToastToRender(function (position, toastList) {
    var _cx, _cx2;

    var swag = {
      className: isFn(className) ? className({
        position: position,
        rtl: rtl,
        defaultClassName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])("Toastify"
        /* CSS_NAMESPACE */
        + "__toast-container", "Toastify"
        /* CSS_NAMESPACE */
        + "__toast-container--" + position, (_cx = {}, _cx["Toastify"
        /* CSS_NAMESPACE */
        + "__toast-container--rtl"] = rtl, _cx))
      }) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])("Toastify"
      /* CSS_NAMESPACE */
      + "__toast-container", "Toastify"
      /* CSS_NAMESPACE */
      + "__toast-container--" + position, (_cx2 = {}, _cx2["Toastify"
      /* CSS_NAMESPACE */
      + "__toast-container--rtl"] = rtl, _cx2), parseClassName(className)),
      style: toastList.length === 0 ? _extends({}, style, {
        pointerEvents: 'none'
      }) : _extends({}, style)
    };
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ToastPositioner, Object.assign({}, swag, {
      key: "container-" + position
    }), toastList.map(function (_ref) {
      var content = _ref.content,
          toastProps = _ref.props;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Toast, Object.assign({}, toastProps, {
        "in": isToastActive(toastProps.toastId),
        key: "toast-" + toastProps.key,
        closeButton: toastProps.closeButton === true ? CloseButton : toastProps.closeButton
      }), content);
    }));
  }));
};

if (false) {
  // @ts-ignore
  ToastContainer.propTypes = {
    // @ts-ignore
    position: /*#__PURE__*/PropTypes.oneOf( /*#__PURE__*/objectValues(POSITION)),
    // @ts-ignore
    autoClose: /*#__PURE__*/PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    // @ts-ignore
    closeButton: /*#__PURE__*/PropTypes.oneOfType([PropTypes.node, PropTypes.bool, PropTypes.func]),
    hideProgressBar: PropTypes.bool,
    pauseOnHover: PropTypes.bool,
    closeOnClick: PropTypes.bool,
    newestOnTop: PropTypes.bool,
    className: PropTypes.any,
    style: PropTypes.object,
    toastClassName: /*#__PURE__*/PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    bodyClassName: /*#__PURE__*/PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    progressClassName: /*#__PURE__*/PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    progressStyle: PropTypes.object,
    transition: PropTypes.func,
    rtl: PropTypes.bool,
    draggable: PropTypes.bool,
    draggablePercent: PropTypes.number,
    pauseOnFocusLoss: PropTypes.bool,
    enableMultiContainer: PropTypes.bool,
    containerId: /*#__PURE__*/PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    role: PropTypes.string,
    onClick: PropTypes.func
  };
}

ToastContainer.defaultProps = {
  position: POSITION.TOP_RIGHT,
  transition: Bounce,
  rtl: false,
  autoClose: 5000,
  hideProgressBar: false,
  closeButton: CloseButton,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: true,
  newestOnTop: false,
  draggable: true,
  draggablePercent: 80,
  role: 'alert'
};

var containers = /*#__PURE__*/new Map();
var latestInstance;
var containerDomNode;
var containerConfig;
var queue = [];
var lazy = false;
/**
 * Check whether any container is currently mounted in the DOM
 */

function isAnyContainerMounted() {
  return containers.size > 0;
}
/**
 * Get the container by id. Returns the last container declared when no id is given.
 */


function getContainer(containerId) {
  if (!isAnyContainerMounted()) return null;
  return containers.get(!containerId ? latestInstance : containerId);
}
/**
 * Get the toast by id, given it's in the DOM, otherwise returns null
 */


function getToast(toastId, _ref) {
  var containerId = _ref.containerId;
  var container = getContainer(containerId);
  if (!container) return null;
  return container.getToast(toastId);
}
/**
 * Generate a random toastId
 */


function generateToastId() {
  return (Math.random().toString(36) + Date.now().toString(36)).substr(2, 10);
}
/**
 * Generate a toastId or use the one provided
 */


function getToastId(options) {
  if (options && (isStr(options.toastId) || isNum(options.toastId))) {
    return options.toastId;
  }

  return generateToastId();
}
/**
 * If the container is not mounted, the toast is enqueued and
 * the container lazy mounted
 */


function dispatchToast(content, options) {
  if (isAnyContainerMounted()) {
    eventManager.emit(0
    /* Show */
    , content, options);
  } else {
    queue.push({
      content: content,
      options: options
    });

    if (lazy && canUseDom) {
      lazy = false;
      containerDomNode = document.createElement('div');
      document.body.appendChild(containerDomNode);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["render"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ToastContainer, Object.assign({}, containerConfig)), containerDomNode);
    }
  }

  return options.toastId;
}
/**
 * Merge provided options with the defaults settings and generate the toastId
 */


function mergeOptions(type, options) {
  return _extends({}, options, {
    type: options && options.type || type,
    toastId: getToastId(options)
  });
}

var toast = function toast(content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, options));
};

toast.success = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.SUCCESS, options));
};

toast.info = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.INFO, options));
};

toast.error = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.ERROR, options));
};

toast.warning = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.WARNING, options));
};

toast.dark = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DARK, options));
};
/**
 * Maybe I should remove warning in favor of warn, I don't know
 */


toast.warn = toast.warning;
/**
 * Remove toast programmaticaly
 */

toast.dismiss = function (id) {
  return isAnyContainerMounted() && eventManager.emit(1
  /* Clear */
  , id);
};
/**
 * Clear waiting queue when limit is used
 */


toast.clearWaitingQueue = function (params) {
  if (params === void 0) {
    params = {};
  }

  return isAnyContainerMounted() && eventManager.emit(5
  /* ClearWaitingQueue */
  , params);
};
/**
 * return true if one container is displaying the toast
 */


toast.isActive = function (id) {
  var isToastActive = false;
  containers.forEach(function (container) {
    if (container.isToastActive && container.isToastActive(id)) {
      isToastActive = true;
    }
  });
  return isToastActive;
};

toast.update = function (toastId, options) {
  if (options === void 0) {
    options = {};
  }

  // if you call toast and toast.update directly nothing will be displayed
  // this is why I defered the update
  setTimeout(function () {
    var toast = getToast(toastId, options);

    if (toast) {
      var oldOptions = toast.props,
          oldContent = toast.content;

      var nextOptions = _extends({}, oldOptions, options, {
        toastId: options.toastId || toastId,
        updateId: generateToastId()
      });

      if (nextOptions.toastId !== toastId) nextOptions.staleId = toastId;
      var content = typeof nextOptions.render !== 'undefined' ? nextOptions.render : oldContent;
      delete nextOptions.render;
      dispatchToast(content, nextOptions);
    }
  }, 0);
};
/**
 * Used for controlled progress bar.
 */


toast.done = function (id) {
  toast.update(id, {
    progress: 1
  });
};
/**
 * Track changes. The callback get the number of toast displayed
 *
 */


toast.onChange = function (callback) {
  if (isFn(callback)) {
    eventManager.on(4
    /* Change */
    , callback);
  }

  return function () {
    isFn(callback) && eventManager.off(4
    /* Change */
    , callback);
  };
};
/**
 * Configure the ToastContainer when lazy mounted
 */


toast.configure = function (config) {
  if (config === void 0) {
    config = {};
  }

  lazy = true;
  containerConfig = config;
};

toast.POSITION = POSITION;
toast.TYPE = TYPE;
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */

eventManager.on(2
/* DidMount */
, function (containerInstance) {
  latestInstance = containerInstance.containerId || containerInstance;
  containers.set(latestInstance, containerInstance);
  queue.forEach(function (item) {
    eventManager.emit(0
    /* Show */
    , item.content, item.options);
  });
  queue = [];
}).on(3
/* WillUnmount */
, function (containerInstance) {
  containers["delete"](containerInstance.containerId || containerInstance);

  if (containers.size === 0) {
    eventManager.off(0
    /* Show */
    ).off(1
    /* Clear */
    ).off(5
    /* ClearWaitingQueue */
    );
  }

  if (canUseDom && containerDomNode) {
    document.body.removeChild(containerDomNode);
  }
});


//# sourceMappingURL=react-toastify.esm.js.map


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _createAction = __webpack_require__(540);

var _createAction2 = _interopRequireDefault(_createAction);

var _handleAction = __webpack_require__(155);

var _handleAction2 = _interopRequireDefault(_handleAction);

var _handleActions = __webpack_require__(541);

var _handleActions2 = _interopRequireDefault(_handleActions);

exports.createAction = _createAction2['default'];
exports.handleAction = _handleAction2['default'];
exports.handleActions = _handleActions2['default'];

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = getConversations;
/* harmony export (immutable) */ __webpack_exports__["a"] = ensureConversationForMatch;
/* harmony export (immutable) */ __webpack_exports__["d"] = getMessages;
/* harmony export (immutable) */ __webpack_exports__["e"] = sendMessage;
/* harmony export (immutable) */ __webpack_exports__["f"] = deleteMessage;
/* harmony export (immutable) */ __webpack_exports__["g"] = reportMessage;
/* unused harmony export updateMessagingState */
/* harmony export (immutable) */ __webpack_exports__["c"] = getUnreadMessageCount;
/* harmony export (immutable) */ __webpack_exports__["b"] = markConversationAsRead;
/* harmony export (immutable) */ __webpack_exports__["h"] = endConversation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Api__ = __webpack_require__(18);


// Get conversations
function getConversations(accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: 'CONVERSATIONS_LOADING'
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('conversations', 'GET', {}, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'CONVERSATIONS_LOADED',
            payload: response.data
          });
          resolve(response.data);
        } else {
          dispatch({
            type: 'CONVERSATIONS_ERROR',
            payload: response.message
          });
          reject(response);
        }
      }).catch(function (error) {
        dispatch({
          type: 'CONVERSATIONS_ERROR',
          payload: error.message
        });
        reject(error);
      });
    });
  };
}

// Ensure a conversation exists for a given match and return it
function ensureConversationForMatch(matchId, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      if (!matchId || !accessToken) {
        var error = new Error('Match ID and access token are required');
        reject(error);
        return;
      }

      dispatch({
        type: 'ENSURE_CONVERSATION_REQUEST',
        payload: {
          matchId: matchId
        }
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('match/' + matchId + '/conversation', 'GET', null, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200 && response.data && response.data.conversation) {
          var conversation = response.data.conversation;

          dispatch({
            type: 'ENSURE_CONVERSATION_SUCCESS',
            payload: {
              conversation: conversation
            }
          });

          resolve(conversation);
        } else {
          var errorMessage = response.data && response.data.error || 'Unable to create conversation';

          dispatch({
            type: 'ENSURE_CONVERSATION_ERROR',
            payload: {
              matchId: matchId,
              error: errorMessage
            }
          });

          reject(response instanceof Error ? response : new Error(errorMessage || 'Request failed'));
        }
      }).catch(function (error) {
        var message = error && error.data && error.data.error || error.message || 'Request failed';

        dispatch({
          type: 'ENSURE_CONVERSATION_ERROR',
          payload: {
            matchId: matchId,
            error: message
          }
        });

        reject(error);
      });
    });
  };
}

// Get messages for a conversation
function getMessages(conversationId) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
  var accessToken = arguments[3];

  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      if (!conversationId) {
        dispatch({
          type: 'MESSAGES_ERROR',
          payload: {
            conversationId: conversationId,
            error: 'Conversation ID is required'
          }
        });
        reject(new Error('Conversation ID is required'));
        return;
      }

      dispatch({
        type: 'MESSAGES_LOADING',
        payload: { conversationId: conversationId }
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('messages/' + conversationId + '/conversation', 'GET', {
        page: page,
        pageSize: pageSize
      }, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'MESSAGES_LOADED',
            payload: {
              conversationId: conversationId,
              data: response.data
            }
          });
          resolve(response.data);
        } else {
          dispatch({
            type: 'MESSAGES_ERROR',
            payload: {
              conversationId: conversationId,
              error: response.message
            }
          });
          reject(response);
        }
      }).catch(function (error) {
        dispatch({
          type: 'MESSAGES_ERROR',
          payload: {
            conversationId: conversationId,
            error: error.message
          }
        });
        reject(error);
      });
    });
  };
}

// Send a message
function sendMessage(conversationId, content, accessToken, currentUserId) {
  var attachmentIds = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      // Create a temporary ID for the optimistic message
      var tempId = 'temp-' + Date.now() + '-' + Math.random();

      // Create an optimistic message object
      var optimisticMessage = {
        id: tempId,
        content: content,
        sender: {
          id: currentUserId
        },
        created: new Date().toISOString(),
        isRead: true,
        isPending: true, // Flag to indicate this is an optimistic update
        attachments: [] // Empty for optimistic update, will be populated on success
      };

      dispatch({
        type: 'SEND_MESSAGE_PENDING',
        payload: {
          conversationId: conversationId,
          content: content,
          optimisticMessage: optimisticMessage
        }
      });

      var requestBody = {
        content: content
      };

      // Only add attachmentIds if there are any
      if (attachmentIds && attachmentIds.length > 0) {
        requestBody.attachmentIds = attachmentIds;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('messages/' + conversationId, 'POST', requestBody, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'SEND_MESSAGE_SUCCESS',
            payload: {
              conversationId: conversationId,
              message: response.data.data,
              tempId: tempId // Include tempId to replace the optimistic message
            }
          });
          resolve(response.data);
        } else {
          dispatch({
            type: 'SEND_MESSAGE_ERROR',
            payload: {
              conversationId: conversationId,
              error: response.message,
              tempId: tempId // Include tempId to remove the failed message
            }
          });
          reject(response);
        }
      }).catch(function (error) {
        dispatch({
          type: 'SEND_MESSAGE_ERROR',
          payload: {
            conversationId: conversationId,
            error: error.message,
            tempId: tempId // Include tempId to remove the failed message
          }
        });
        reject(error);
      });
    });
  };
}

// Delete a message
function deleteMessage(messageId, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: 'DELETE_MESSAGE_PENDING',
        payload: {
          messageId: messageId
        }
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('messages/' + messageId, 'DELETE', {}, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'DELETE_MESSAGE_SUCCESS',
            payload: {
              messageId: messageId
            }
          });
          resolve(response.data);
        } else {
          dispatch({
            type: 'DELETE_MESSAGE_ERROR',
            payload: {
              messageId: messageId,
              error: response.message
            }
          });
          reject(response);
        }
      }).catch(function (error) {
        dispatch({
          type: 'DELETE_MESSAGE_ERROR',
          payload: {
            messageId: messageId,
            error: error.message
          }
        });
        reject(error);
      });
    });
  };
}

// Report a message
function reportMessage(messageId, reason, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: 'REPORT_MESSAGE_PENDING',
        payload: {
          messageId: messageId,
          reason: reason
        }
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('messages/' + messageId + '/report', 'POST', {
        reason: reason
      }, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'REPORT_MESSAGE_SUCCESS',
            payload: {
              messageId: messageId,
              report: response.data.data
            }
          });
          resolve(response.data);
        } else {
          dispatch({
            type: 'REPORT_MESSAGE_ERROR',
            payload: {
              messageId: messageId,
              error: response.message
            }
          });
          reject(response);
        }
      }).catch(function (error) {
        dispatch({
          type: 'REPORT_MESSAGE_ERROR',
          payload: {
            messageId: messageId,
            error: error.message
          }
        });
        reject(error);
      });
    });
  };
}

// Update messaging state
function updateMessagingState(fields) {
  return {
    type: 'UPDATE_MESSAGING_STATE',
    payload: fields
  };
}

// Get unread message count
function getUnreadMessageCount(accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('conversations/unread-count', 'GET', {}, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'SET_UNREAD_MESSAGE_COUNT',
            payload: response.data.unreadCount
          });
          resolve(response.data.unreadCount);
        } else {
          reject(response);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  };
}

// Optimistically mark a conversation as read in local state
function markConversationAsRead(conversationId) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var state = getState();
      var conversationIdNumber = parseInt(conversationId, 10);

      if (Number.isNaN(conversationIdNumber)) {
        resolve(0);
        return;
      }

      var conversationsState = state.messaging.conversations || {};
      var conversationsData = conversationsState.data || [];

      var matchingConversation = conversationsData.find(function (conversation) {
        return conversation && conversation.id === conversationIdNumber;
      });

      var unreadDelta = matchingConversation && typeof matchingConversation.unreadCount === 'number' ? matchingConversation.unreadCount : 0;

      dispatch({
        type: 'MARK_CONVERSATION_READ',
        payload: {
          conversationId: conversationIdNumber,
          unreadDelta: unreadDelta
        }
      });

      resolve(unreadDelta);
    });
  };
}

// End conversation and unfriend
function endConversation(conversationId, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: 'END_CONVERSATION_PENDING',
        payload: { conversationId: conversationId }
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('conversations/' + conversationId, 'DELETE', {}, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'END_CONVERSATION_SUCCESS',
            payload: { conversationId: conversationId }
          });
          resolve(response.data);
        } else {
          dispatch({
            type: 'END_CONVERSATION_ERROR',
            payload: {
              conversationId: conversationId,
              error: response.message
            }
          });
          reject(response);
        }
      }).catch(function (error) {
        dispatch({
          type: 'END_CONVERSATION_ERROR',
          payload: {
            conversationId: conversationId,
            error: error.message
          }
        });
        reject(error);
      });
    });
  };
}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ActivityBadge__ = __webpack_require__(42);
var _card;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var PAW_ICON = __webpack_require__(310);

var DogCard = function (_Component) {
  _inherits(DogCard, _Component);

  function DogCard(props) {
    _classCallCheck(this, DogCard);

    var _this = _possibleConstructorReturn(this, (DogCard.__proto__ || Object.getPrototypeOf(DogCard)).call(this, props));

    switch (_this.props.status) {
      default:
        _this.status = '';
        break;
      case 'accepted':
        _this.status = "You're Dog Sharing";
        _this.statusClass = styles.card_status_sharing;
        break;
      case 'pending':
        _this.status = 'Request Pending...';
        _this.statusClass = styles.card_status_pending;
        break;
      case 'declined':
        _this.status = 'Share Declined';
        _this.statusClass = styles.card_status_declined;
        break;
      case 'ended':
        _this.status = 'Sharing ended';
        _this.statusClass = styles.card_status_declined;
        break;
      case 'favourite':
        _this.status = "Let's dog share";
        _this.statusClass = styles.card_status_sharing;
        break;
    }
    return _this;
  }

  _createClass(DogCard, [{
    key: 'getDogImage',
    value: function getDogImage() {
      if (this.props.image && this.props.image.length > 6) {
        return this.props.image;
      }

      return '/images/default_dog.jpg';
    }
  }, {
    key: 'getProfileLink',
    value: function getProfileLink() {
      if (this.props.member) {
        return '/profile/' + this.props.id;
      }

      if (this.props.id) {
        return '/pooch/' + this.props.id;
      }

      return '/join';
    }
  }, {
    key: 'renderPawIcon',
    value: function renderPawIcon() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, {
        cacheGetRequests: true,
        src: PAW_ICON,
        className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.paw_icon, styles.paw_icon_blue)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var hoverText = this.props.member || this.props.id ? 'View Profile' : 'Sign up to view profile';

      var dynamicStyles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
        card_image: {
          ':after': {
            content: '"' + hoverText + '"'
          }
        }
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* Link */],
        {
          to: this.getProfileLink(),
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.card, this.props.signup ? styles.card_signup : null, this.props.status ? styles.card_has_status : false)
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.card_image, dynamicStyles.card_image) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.card_photo), src: this.getDogImage(), alt: this.props.name })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.card_details) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.card_meta) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.card_name) },
              this.props.name
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.card_breed) },
              this.props.breed
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.card_suburb) },
              this.props.suburb ? this.props.suburb.title : ' '
            ),
            this.props.proximityText && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.card_proximity) },
              this.props.proximityText
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].isMobile ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* Link */],
            { to: this.getProfileLink(), className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.card_view) },
            'View'
          ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.card_summary) },
            this.props.summary
          ),
          __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].isMobile ? null : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.card_badges) },
            this.props.interests.slice(0, 4).map(function (interest) {
              return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ActivityBadge__["a" /* default */], { key: interest.title, activity: interest.title });
            })
          ),
          this.status ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.card_status, this.statusClass) },
            this.props.status === 'accepted' ? this.renderPawIcon() : false,
            this.status
          ) : null
        )
      );
    }
  }]);

  return DogCard;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DogCard);


DogCard.defaultProps = {
  id: null,
  status: null,
  signup: false,
  interests: [],
  member: false,
  image: null,
  summary: null,
  breed: 'Unknown',
  suburb: null,
  proximityText: null
};

DogCard.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number,
  image: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  breed: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  summary: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  signup: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  interests: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].array,
  member: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  suburb: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  proximityText: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  card_status: {
    padding: '12px 15px',
    margin: '25px -18px -18px',
    fontSize: 15,
    textTransform: 'uppercase',
    letterSpacing: 1.3,
    textAlign: 'center',
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_secondary,
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].error,
    position: 'absolute',
    bottom: 0,
    width: '100%',

    ':after': {
      bottom: '100%',
      right: 40,
      border: 'solid transparent',
      content: '""',
      height: 0,
      width: 0,
      position: 'absolute',
      pointerEvents: 'none',
      borderColor: 'rgba(232, 94, 94, 0)',
      borderBottomColor: '#E85E5E',
      borderWidth: 10,
      marginLeft: -10
    }
  },
  card_status_sharing: {
    backgroundColor: '#f4f4f4',
    color: '#39b4d6',

    ':after': {
      borderBottomColor: '#f4f4f4'
    }
  },
  card_status_pending: {
    backgroundColor: '#021a36',
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,

    ':after': {
      borderBottomColor: '#021a36'
    }
  },
  card: (_card = {
    position: 'relative',
    display: 'block',
    width: 262,
    minWidth: 262,
    padding: 18,
    margin: '0 15px 23px',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.05)',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].lighter_grey

  }, _defineProperty(_card, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    paddingBottom: 38
  }), _defineProperty(_card, '@media screen and (min-width: 625px) and (max-width: 768px)', {
    width: 262
  }), _defineProperty(_card, ':hover > div:first-child:after', {
    opacity: 1
  }), _card),
  card_has_status: {
    marginBottom: 50
  },
  card_details: _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    display: 'flex',
    alignItems: 'center'
  }),
  card_meta: _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    flexGrow: 1
  }),
  card_view: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_secondary,
    fontSize: 15,
    lineHeight: 1.73,
    letterSpacing: 2,
    textAlign: 'center',
    textTransform: 'uppercase',
    color: '#39b4d6'
  },
  card_image: {
    position: 'relative',
    display: 'block',
    margin: '-18px -18px 10px',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].black,

    ':before': {
      display: 'block',
      width: '100%',
      paddingTop: 'calc((260 / 276) * 100%)',
      content: '""'
    },

    ':after': {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      padding: 65,
      fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_secondary,
      fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_secondary,
      fontSize: 15,
      lineHeight: 1.73,
      letterSpacing: 2,
      textAlign: 'center',
      textTransform: 'uppercase',
      color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
      backgroundColor: 'rgba(86, 197, 255, 0.9)',
      boxSizing: 'border-box',
      opacity: 0,
      transition: 'opacity 300ms'
    }
  },
  card_photo: {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'block',
    height: '100%',
    width: '100%',
    objectFit: 'cover'
  },
  card_name: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_heading,
    fontSize: 20,
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].black,
    lineHeight: 1.5
  },
  card_breed: _defineProperty({
    marginBottom: 7,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_primary,
    fontSize: 15,
    color: '#000e1f'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    marginTop: 6,
    marginBottom: 0
  }),
  card_suburb: _defineProperty({
    marginBottom: 7,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 'bold',
    fontSize: 15,
    color: '#000e1f'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    marginTop: 6,
    marginBottom: 0
  }),
  card_proximity: _defineProperty({
    marginTop: 4,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_secondary,
    fontSize: 15,
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].primary

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    marginTop: 6,
    fontSize: 15
  }),
  card_summary: {
    marginBottom: 12.7,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_primary,
    fontSize: 14,
    color: '#828282'
  },
  card_badges: {
    display: 'flex'
  },
  paw_icon: {
    position: 'relative',
    top: 2,
    marginRight: 10,
    fill: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white
  },
  paw_icon_blue: {
    fill: '#39b4d6'
  }
});

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentRequestButtonElement = exports.PostalCodeElement = exports.CardCVCElement = exports.CardExpiryElement = exports.CardNumberElement = exports.CardElement = exports.Elements = exports.injectStripe = exports.StripeProvider = undefined;

var _Provider = __webpack_require__(85);

var _Provider2 = _interopRequireDefault(_Provider);

var _inject = __webpack_require__(532);

var _inject2 = _interopRequireDefault(_inject);

var _Elements = __webpack_require__(61);

var _Elements2 = _interopRequireDefault(_Elements);

var _Element = __webpack_require__(530);

var _Element2 = _interopRequireDefault(_Element);

var _PaymentRequestButtonElement = __webpack_require__(531);

var _PaymentRequestButtonElement2 = _interopRequireDefault(_PaymentRequestButtonElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardElement = (0, _Element2.default)('card', { sourceType: 'card' });

var CardNumberElement = (0, _Element2.default)('cardNumber', { sourceType: 'card' });
var CardExpiryElement = (0, _Element2.default)('cardExpiry');
var CardCVCElement = (0, _Element2.default)('cardCvc');
var PostalCodeElement = (0, _Element2.default)('postalCode');

exports.StripeProvider = _Provider2.default;
exports.injectStripe = _inject2.default;
exports.Elements = _Elements2.default;
exports.CardElement = CardElement;
exports.CardNumberElement = CardNumberElement;
exports.CardExpiryElement = CardExpiryElement;
exports.CardCVCElement = CardCVCElement;
exports.PostalCodeElement = PostalCodeElement;
exports.PaymentRequestButtonElement = _PaymentRequestButtonElement2.default;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(462), __webpack_require__(19));
	else if(typeof define === 'function' && define.amd)
		define("reactTippy", ["react", "popper.js", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["reactTippy"] = factory(require("react"), require("popper.js"), require("react-dom"));
	else
		root["reactTippy"] = factory(root["React"], root["Popper"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_38__, __WEBPACK_EXTERNAL_MODULE_39__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 15);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Browser = exports.Browser = {};

if (typeof window !== 'undefined') {
  Browser.SUPPORTED = 'requestAnimationFrame' in window;
  Browser.SUPPORTS_TOUCH = 'ontouchstart' in window;
  Browser.touch = false;
  Browser.dynamicInputDetection = true;
  // Chrome device/touch emulation can make this dynamic
  Browser.iOS = function () {
    return (/iPhone|iPad|iPod/.test(navigator.userAgent) && !window.MSStream
    );
  };
}

/**
* The global storage array which holds all data reference objects
* from every instance
* This allows us to hide tooltips from all instances, finding the ref when
* clicking on the body, and for followCursor
*/
var Store = exports.Store = [];

/**
* Selector constants used for grabbing elements
*/
var Selectors = exports.Selectors = {
  POPPER: '.tippy-popper',
  TOOLTIP: '.tippy-tooltip',
  CONTENT: '.tippy-tooltip-content',
  CIRCLE: '[x-circle]',
  ARROW: '[x-arrow]',
  TOOLTIPPED_EL: '[data-tooltipped]',
  CONTROLLER: '[data-tippy-controller]'
};

/**
* The default settings applied to each instance
*/
var Defaults = exports.Defaults = {
  html: false,
  position: 'top',
  animation: 'shift',
  animateFill: true,
  arrow: false,
  arrowSize: 'regular',
  delay: 0,
  trigger: 'mouseenter focus',
  duration: 350,
  interactive: false,
  interactiveBorder: 2,
  theme: 'dark',
  size: 'regular',
  distance: 10,
  offset: 0,
  hideOnClick: true,
  multiple: false,
  followCursor: false,
  inertia: false,
  flipDuration: 350,
  sticky: false,
  stickyDuration: 200,
  appendTo: function appendTo() {
    return document.body;
  },
  zIndex: 9999,
  touchHold: false,
  performance: false,
  dynamicTitle: false,
  useContext: false,
  reactInstance: undefined,
  popperOptions: {},
  open: undefined,
  onRequestClose: function onRequestClose() {}
};

/**
* The keys of the defaults object for reducing down into a new object
* Used in `getIndividualSettings()`
*/
var DefaultsKeys = exports.DefaultsKeys = Browser.SUPPORTED && Object.keys(Defaults);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefix;
/**
* Returns the supported prefixed property - only `webkit` is needed, `moz`, `ms` and `o` are obsolete
* @param {String} property
* @return {String} - browser supported prefixed property
*/
function prefix(property) {
  var prefixes = [false, 'webkit'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var _prefix = prefixes[i];
    var prefixedProp = _prefix ? '' + _prefix + upperProp : property;
    if (typeof window.document.body.style[prefixedProp] !== 'undefined') {
      return prefixedProp;
    }
  }

  return null;
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = find;
/**
* Ponyfill for Array.prototype.find
* @param {Array} arr
* @param {Function} checkFn
* @return item in the array
*/
function find(arr, checkFn) {
  if (Array.prototype.find) {
    return arr.find(checkFn);
  }

  // use `filter` as fallback
  return arr.filter(checkFn)[0];
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCorePlacement;
/**
* Returns the non-shifted placement (e.g., 'bottom-start' => 'bottom')
* @param {String} placement
* @return {String}
*/
function getCorePlacement(placement) {
  return placement.replace(/-.+/, '');
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = closest;

var _matches = __webpack_require__(8);

/**
* Ponyfill to get the closest parent element
* @param {Element} element - child of parent to be returned
* @param {String} parentSelector - selector to match the parent if found
* @return {Element}
*/
function closest(element, parentSelector) {
  var _closest = Element.prototype.closest || function (selector) {
    var el = this;
    while (el) {
      if (_matches.matches.call(el, selector)) {
        return el;
      }
      el = el.parentElement;
    }
  };

  return _closest.call(element, parentSelector);
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defer;
/**
* Waits until next repaint to execute a fn
* @param {Function} fn
*/
function defer(fn) {
  window.requestAnimationFrame(function () {
    setTimeout(fn, 0);
  });
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getInnerElements;

var _globals = __webpack_require__(0);

/**
* Returns inner elements of the popper element
* @param {Element} popper
* @return {Object}
*/
function getInnerElements(popper) {
  return {
    tooltip: popper.querySelector(_globals.Selectors.TOOLTIP),
    circle: popper.querySelector(_globals.Selectors.CIRCLE),
    content: popper.querySelector(_globals.Selectors.CONTENT)
  };
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isVisible;
/**
* Determines if a popper is currently visible
* @param {Element} popper
* @return {Boolean}
*/
function isVisible(popper) {
  return popper.style.visibility === 'visible';
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function defaultMatchSelector(s) {
  var matches = (this.document || this.ownerDocument).querySelectorAll(s),
      i = matches.length;
  while (--i >= 0 && matches.item(i) !== this) {}
  return i > -1;
}

var matches = exports.matches = typeof window === 'undefined' ? defaultMatchSelector : Element.prototype.matches || Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || defaultMatchSelector;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(13);

var _react2 = _interopRequireDefault(_react);

var _tippy = __webpack_require__(30);

var _tippy2 = _interopRequireDefault(_tippy);

var _globals = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var stopPortalEvent = function stopPortalEvent(e) {
  return e.stopPropagation();
};

var defaultProps = {
  html: null,
  position: 'top',
  animation: 'shift',
  animateFill: true,
  arrow: false,
  delay: 0,
  hideDelay: 0,
  trigger: 'mouseenter focus',
  duration: 375,
  hideDuration: 375,
  interactive: false,
  interactiveBorder: 2,
  theme: 'dark',
  offset: 0,
  hideOnClick: true,
  multiple: false,
  followCursor: false,
  inertia: false,
  popperOptions: {},
  onShow: function onShow() {},
  onShown: function onShown() {},
  onHide: function onHide() {},
  onHidden: function onHidden() {},
  disabled: false,
  arrowSize: 'regular',
  size: 'regular',
  className: '',
  style: {},
  distance: 10,
  onRequestClose: function onRequestClose() {},
  sticky: false,
  stickyDuration: 200,
  tag: 'div',
  touchHold: false,
  unmountHTMLWhenHide: false,
  zIndex: 9999
};

var propKeys = Object.keys(defaultProps);

var detectPropsChanged = function detectPropsChanged(props, prevProps) {
  var result = [];
  propKeys.forEach(function (key) {
    if (props[key] !== prevProps[key]) {
      result.push(key);
    }
  });
  return result;
};

var Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip(props) {
    _classCallCheck(this, Tooltip);

    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.initTippy = _this._initTippy.bind(_this);
    _this.destroyTippy = _this._destroyTippy.bind(_this);
    _this.updateTippy = _this._updateTippy.bind(_this);
    _this.updateReactDom = _this._updateReactDom.bind(_this);
    _this.showTooltip = _this._showTooltip.bind(_this);
    _this.hideTooltip = _this._hideTooltip.bind(_this);
    _this.updateSettings = _this._updateSettings.bind(_this);

    _this.state = {
      reactDOMValue: null
    };
    return _this;
  }

  _createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      this.initTippy();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      this.destroyTippy();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      // enable and disabled
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.props.disabled === false && prevProps.disabled === true) {
        this.updateSettings('disabled', false);
        this.destroyTippy();
        this.initTippy();
        return;
      }

      if (this.props.disabled === true && prevProps.disabled === false) {
        this.updateSettings('disabled', true);
        this.destroyTippy();
        return;
      }

      // open
      if (this.props.open === true && !prevProps.open) {
        this.updateSettings('open', true);
        setTimeout(function () {
          _this2.showTooltip();
        }, 0);
      }
      if (this.props.open === false && prevProps.open === true) {
        this.updateSettings('open', false);
        this.hideTooltip();
      }

      if (this.props.html !== prevProps.html) {
        this.updateReactDom();
      }

      // Update content
      if (this.props.title !== prevProps.title) {
        this.updateTippy();
      }

      // update otherProps
      var propChanges = detectPropsChanged(this.props, prevProps);
      propChanges.forEach(function (key) {
        _this2.updateSettings(key, _this2.props[key]);
      });
    }
  }, {
    key: '_showTooltip',
    value: function _showTooltip() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        this.tippy.show(popper, this.props.duration);
      }
    }
  }, {
    key: '_hideTooltip',
    value: function _hideTooltip() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        this.tippy.hide(popper, this.props.hideDuration);
      }
    }
  }, {
    key: '_updateSettings',
    value: function _updateSettings(name, value) {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        this.tippy.updateSettings(popper, name, value);
      }
    }
  }, {
    key: '_updateReactDom',
    value: function _updateReactDom() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        this.updateSettings('reactDOM', this.props.html);
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        var isVisible = popper.style.visibility === 'visible' || this.props.open;
        if (isVisible) {
          this.tippy.updateForReact(popper, this.props.html);
        }
      }
    }
  }, {
    key: '_updateTippy',
    value: function _updateTippy() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        this.tippy.update(popper);
      }
    }
  }, {
    key: '_initTippy',
    value: function _initTippy() {
      var _this3 = this;

      if (typeof window === 'undefined' || typeof document === 'undefined' || !_globals.Browser.SUPPORTED) {
        return;
      }
      if (!this.props.disabled) {
        if (this.props.title) {
          this.tooltipDOM.setAttribute('title', this.props.title);
        }

        this.tippy = (0, _tippy2.default)(this.tooltipDOM, {
          disabled: this.props.disabled,
          position: this.props.position,
          animation: this.props.animation,
          animateFill: this.props.animateFill,
          arrow: this.props.arrow,
          arrowSize: this.props.arrowSize,
          delay: this.props.delay,
          hideDelay: this.props.hideDelay,
          trigger: this.props.trigger,
          duration: this.props.duration,
          hideDuration: this.props.hideDuration,
          interactive: this.props.interactive,
          interactiveBorder: this.props.interactiveBorder,
          theme: this.props.theme,
          offset: this.props.offset,
          hideOnClick: this.props.hideOnClick,
          multiple: this.props.multiple,
          size: this.props.size,
          followCursor: this.props.followCursor,
          inertia: this.props.inertia,
          popperOptions: this.props.popperOptions,
          onShow: this.props.onShow,
          onShown: this.props.onShown,
          onHide: this.props.onHide,
          onHidden: this.props.onHidden,
          distance: this.props.distance,
          reactDOM: this.props.html,
          setReactDOMValue: function setReactDOMValue(newReactDOM) {
            return _this3.setState({ reactDOMValue: newReactDOM });
          },
          unmountHTMLWhenHide: this.props.unmountHTMLWhenHide,
          open: this.props.open,
          sticky: this.props.sticky,
          stickyDuration: this.props.stickyDuration,
          tag: this.props.tag,
          touchHold: this.props.touchHold,
          onRequestClose: this.props.onRequestClose,
          useContext: this.props.useContext,
          reactInstance: this.props.useContext ? this : undefined,
          performance: true,
          html: this.props.rawTemplate ? this.props.rawTemplate : undefined,
          zIndex: this.props.zIndex
        });
        if (this.props.open) {
          this.showTooltip();
        }
      } else {
        this.tippy = null;
      }
    }
  }, {
    key: '_destroyTippy',
    value: function _destroyTippy() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        this.updateSettings('open', false);
        this.tippy.hide(popper, 0);
        this.tippy.destroy(popper);
        this.tippy = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var Tag = this.props.tag;


      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          Tag,
          {
            ref: function ref(tooltip) {
              _this4.tooltipDOM = tooltip;
            },
            title: this.props.title,
            className: this.props.className,
            tabIndex: this.props.tabIndex,
            style: _extends({
              display: 'inline'
            }, this.props.style)
          },
          this.props.children
        ),
        this.state.reactDOMValue && _react2.default.createElement(
          'div',
          {
            onClick: stopPortalEvent,
            onContextMenu: stopPortalEvent,
            onDoubleClick: stopPortalEvent,
            onDrag: stopPortalEvent,
            onDragEnd: stopPortalEvent,
            onDragEnter: stopPortalEvent,
            onDragExit: stopPortalEvent,
            onDragLeave: stopPortalEvent,
            onDragOver: stopPortalEvent,
            onDragStart: stopPortalEvent,
            onDrop: stopPortalEvent,
            onMouseDown: stopPortalEvent,
            onMouseEnter: stopPortalEvent,
            onMouseLeave: stopPortalEvent,
            onMouseMove: stopPortalEvent,
            onMouseOver: stopPortalEvent,
            onMouseOut: stopPortalEvent,
            onMouseUp: stopPortalEvent,

            onKeyDown: stopPortalEvent,
            onKeyPress: stopPortalEvent,
            onKeyUp: stopPortalEvent,

            onFocus: stopPortalEvent,
            onBlur: stopPortalEvent,

            onChange: stopPortalEvent,
            onInput: stopPortalEvent,
            onInvalid: stopPortalEvent,
            onSubmit: stopPortalEvent
          },
          this.state.reactDOMValue
        )
      );
    }
  }]);

  return Tooltip;
}(_react.Component);

Tooltip.defaultProps = defaultProps;

exports.default = Tooltip;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = followCursorHandler;

var _globals = __webpack_require__(0);

var _getCorePlacement = __webpack_require__(3);

var _getCorePlacement2 = _interopRequireDefault(_getCorePlacement);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

var _closest = __webpack_require__(4);

var _closest2 = _interopRequireDefault(_closest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Mousemove event listener callback method for follow cursor setting
* @param {MouseEvent} e
*/
function followCursorHandler(e) {
  var _this = this;

  var refData = (0, _find2.default)(_globals.Store, function (refData) {
    return refData.el === _this;
  });
  if (!refData) return;

  var popper = refData.popper,
      offset = refData.settings.offset;


  var position = (0, _getCorePlacement2.default)(popper.getAttribute('x-placement'));
  var halfPopperWidth = Math.round(popper.offsetWidth / 2);
  var halfPopperHeight = Math.round(popper.offsetHeight / 2);
  var viewportPadding = 5;
  var pageWidth = document.documentElement.offsetWidth || document.body.offsetWidth;

  var pageX = e.pageX,
      pageY = e.pageY;


  var x = void 0,
      y = void 0;

  switch (position) {
    case 'top':
      x = pageX - halfPopperWidth + offset;
      y = pageY - 2.25 * halfPopperHeight;
      break;
    case 'left':
      x = pageX - 2 * halfPopperWidth - 10;
      y = pageY - halfPopperHeight + offset;
      break;
    case 'right':
      x = pageX + halfPopperHeight;
      y = pageY - halfPopperHeight + offset;
      break;
    case 'bottom':
      x = pageX - halfPopperWidth + offset;
      y = pageY + halfPopperHeight / 1.5;
      break;
  }

  var isRightOverflowing = pageX + viewportPadding + halfPopperWidth + offset > pageWidth;
  var isLeftOverflowing = pageX - viewportPadding - halfPopperWidth + offset < 0;

  // Prevent left/right overflow
  if (position === 'top' || position === 'bottom') {
    if (isRightOverflowing) {
      x = pageWidth - viewportPadding - 2 * halfPopperWidth;
    }

    if (isLeftOverflowing) {
      x = viewportPadding;
    }
  }

  popper.style[(0, _prefix2.default)('transform')] = 'translate3d(' + x + 'px, ' + y + 'px, 0)';
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getOffsetDistanceInPx;

var _globals = __webpack_require__(0);

/**
* Returns the distance taking into account the default distance due to
* the transform: translate setting in CSS
* @param {Number} distance
* @return {String}
*/
function getOffsetDistanceInPx(distance) {
  return -(distance - _globals.Defaults.distance) + 'px';
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeTitle;
/**
* Removes the title from the tooltipped element, setting `data-original-title`
* appropriately
* @param {Element} el
*/
function removeTitle(el) {
  var title = el.getAttribute('title');

  // Only set `data-original-title` attr if there is a title
  if (title) {
    el.setAttribute('data-original-title', title);
  }

  el.removeAttribute('title');
}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_13__;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(13);

var _react2 = _interopRequireDefault(_react);

var _component = __webpack_require__(9);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var withTooltip = function withTooltip(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref) {
    var props = _objectWithoutProperties(_ref, []);

    return _react2.default.createElement(
      _component2.default,
      options,
      _react2.default.createElement(Component, props)
    );
  };
};

exports.default = withTooltip;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTooltip = exports.Tooltip = undefined;

var _component = __webpack_require__(9);

var _component2 = _interopRequireDefault(_component);

var _hoc = __webpack_require__(14);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Tooltip = _component2.default;
exports.withTooltip = _hoc2.default;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bindEventListeners;

var _globals = __webpack_require__(0);

var _hideAllPoppers = __webpack_require__(25);

var _hideAllPoppers2 = _interopRequireDefault(_hideAllPoppers);

var _closest = __webpack_require__(4);

var _closest2 = _interopRequireDefault(_closest);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _matches = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Adds the needed event listeners
*/
function bindEventListeners() {
  var touchHandler = function touchHandler() {
    _globals.Browser.touch = true;

    if (_globals.Browser.iOS()) {
      document.body.classList.add('tippy-touch');
    }

    if (_globals.Browser.dynamicInputDetection && window.performance) {
      document.addEventListener('mousemove', mousemoveHandler);
    }
  };

  var mousemoveHandler = function () {
    var time = void 0;

    return function () {
      var now = performance.now();

      // Chrome 60+ is 1 mousemove per rAF, use 20ms time difference
      if (now - time < 20) {
        _globals.Browser.touch = false;
        document.removeEventListener('mousemove', mousemoveHandler);
        if (!_globals.Browser.iOS()) {
          document.body.classList.remove('tippy-touch');
        }
      }

      time = now;
    };
  }();

  var clickHandler = function clickHandler(event) {
    // Simulated events dispatched on the document
    if (!(event.target instanceof Element)) {
      return (0, _hideAllPoppers2.default)();
    }

    var el = (0, _closest2.default)(event.target, _globals.Selectors.TOOLTIPPED_EL);
    var popper = (0, _closest2.default)(event.target, _globals.Selectors.POPPER);

    if (popper) {
      var ref = (0, _find2.default)(_globals.Store, function (ref) {
        return ref.popper === popper;
      });
      if (!ref) return;

      var interactive = ref.settings.interactive;

      if (interactive) return;
    }

    if (el) {
      var _ref = (0, _find2.default)(_globals.Store, function (ref) {
        return ref.el === el;
      });
      if (!_ref) return;

      var _ref$settings = _ref.settings,
          hideOnClick = _ref$settings.hideOnClick,
          multiple = _ref$settings.multiple,
          trigger = _ref$settings.trigger;

      // Hide all poppers except the one belonging to the element that was clicked IF
      // `multiple` is false AND they are a touch user, OR
      // `multiple` is false AND it's triggered by a click

      if (!multiple && _globals.Browser.touch || !multiple && trigger.indexOf('click') !== -1) {
        return (0, _hideAllPoppers2.default)(_ref);
      }

      // If hideOnClick is not strictly true or triggered by a click don't hide poppers
      if (hideOnClick !== true || trigger.indexOf('click') !== -1) return;
    }

    // Don't trigger a hide for tippy controllers, and don't needlessly run loop
    if ((0, _closest2.default)(event.target, _globals.Selectors.CONTROLLER) || !document.querySelector(_globals.Selectors.POPPER)) return;

    (0, _hideAllPoppers2.default)();
  };

  var blurHandler = function blurHandler(event) {
    var _document = document,
        el = _document.activeElement;

    if (el && el.blur && _matches.matches.call(el, _globals.Selectors.TOOLTIPPED_EL)) {
      el.blur();
    }
  };

  // Hook events
  document.addEventListener('click', clickHandler);
  document.addEventListener('touchstart', touchHandler);
  window.addEventListener('blur', blurHandler);

  if (!_globals.Browser.SUPPORTS_TOUCH && (navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0)) {
    document.addEventListener('pointerdown', touchHandler);
  }
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPopperElement;

var _getCorePlacement = __webpack_require__(3);

var _getCorePlacement2 = _interopRequireDefault(_getCorePlacement);

var _getOffsetDistanceInPx = __webpack_require__(11);

var _getOffsetDistanceInPx2 = _interopRequireDefault(_getOffsetDistanceInPx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Creates a popper element then returns it
* @param {Number} id - the popper id
* @param {String} title - the tooltip's `title` attribute
* @param {Object} settings - individual settings
* @return {Element} - the popper element
*/
function createPopperElement(id, title, settings) {
  var position = settings.position,
      distance = settings.distance,
      arrow = settings.arrow,
      animateFill = settings.animateFill,
      inertia = settings.inertia,
      animation = settings.animation,
      arrowSize = settings.arrowSize,
      size = settings.size,
      theme = settings.theme,
      html = settings.html,
      zIndex = settings.zIndex,
      interactive = settings.interactive;


  var popper = document.createElement('div');
  popper.setAttribute('class', 'tippy-popper');
  popper.setAttribute('role', 'tooltip');
  popper.setAttribute('aria-hidden', 'true');
  popper.setAttribute('id', 'tippy-tooltip-' + id);
  popper.style.zIndex = zIndex;

  var tooltip = document.createElement('div');
  tooltip.setAttribute('class', 'tippy-tooltip tippy-tooltip--' + size + ' leave');
  tooltip.setAttribute('data-animation', animation);

  theme.split(' ').forEach(function (t) {
    tooltip.classList.add(t + '-theme');
  });

  if (arrow) {
    // Add an arrow
    var _arrow = document.createElement('div');
    _arrow.setAttribute('class', 'arrow-' + arrowSize);
    _arrow.setAttribute('x-arrow', '');
    tooltip.appendChild(_arrow);
  }

  if (animateFill) {
    // Create animateFill circle element for animation
    tooltip.setAttribute('data-animatefill', '');
    var circle = document.createElement('div');
    circle.setAttribute('class', 'leave');
    circle.setAttribute('x-circle', '');
    tooltip.appendChild(circle);
  }

  if (inertia) {
    // Change transition timing function cubic bezier
    tooltip.setAttribute('data-inertia', '');
  }

  if (interactive) {
    tooltip.setAttribute('data-interactive', '');
  }

  // Tooltip content (text or HTML)
  var content = document.createElement('div');
  content.setAttribute('class', 'tippy-tooltip-content');

  if (html) {
    var templateId = void 0;

    if (html instanceof Element) {
      content.appendChild(html);
      templateId = '#' + html.id || 'tippy-html-template';
    } else {
      content.innerHTML = document.getElementById(html.replace('#', '')).innerHTML;
      templateId = html;
    }

    popper.classList.add('html-template');
    interactive && popper.setAttribute('tabindex', '-1');
    tooltip.setAttribute('data-template-id', templateId);
  } else {
    content.innerHTML = title;
  }

  // Init distance. Further updates are made in the popper instance's `onUpdate()` method
  tooltip.style[(0, _getCorePlacement2.default)(position)] = (0, _getOffsetDistanceInPx2.default)(distance);

  tooltip.appendChild(content);
  popper.appendChild(tooltip);

  return popper;
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createPopperInstance;

var _popper = __webpack_require__(38);

var _popper2 = _interopRequireDefault(_popper);

var _defer = __webpack_require__(5);

var _defer2 = _interopRequireDefault(_defer);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

var _getCorePlacement = __webpack_require__(3);

var _getCorePlacement2 = _interopRequireDefault(_getCorePlacement);

var _getInnerElements2 = __webpack_require__(6);

var _getInnerElements3 = _interopRequireDefault(_getInnerElements2);

var _getOffsetDistanceInPx = __webpack_require__(11);

var _getOffsetDistanceInPx2 = _interopRequireDefault(_getOffsetDistanceInPx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Creates a new popper instance
* @param {Object} data
* @return {Object} - the popper instance
*/
function createPopperInstance(data) {
  var el = data.el,
      popper = data.popper,
      _data$settings = data.settings,
      position = _data$settings.position,
      popperOptions = _data$settings.popperOptions,
      offset = _data$settings.offset,
      distance = _data$settings.distance,
      flipDuration = _data$settings.flipDuration;

  var _getInnerElements = (0, _getInnerElements3.default)(popper),
      tooltip = _getInnerElements.tooltip;

  var config = _extends({
    placement: position
  }, popperOptions || {}, {
    modifiers: _extends({}, popperOptions ? popperOptions.modifiers : {}, {
      flip: _extends({
        padding: distance + 5 /* 5px from viewport boundary */
      }, popperOptions && popperOptions.modifiers ? popperOptions.modifiers.flip : {}),
      offset: _extends({
        offset: offset
      }, popperOptions && popperOptions.modifiers ? popperOptions.modifiers.offset : {})
    }),
    onUpdate: function onUpdate() {
      var styles = tooltip.style;
      styles.top = '';
      styles.bottom = '';
      styles.left = '';
      styles.right = '';
      styles[(0, _getCorePlacement2.default)(popper.getAttribute('x-placement'))] = (0, _getOffsetDistanceInPx2.default)(distance);
    }
  });

  // Update the popper's position whenever its content changes
  // Not supported in IE10 unless polyfilled
  if (window.MutationObserver) {
    var styles = popper.style;

    var observer = new MutationObserver(function () {
      styles[(0, _prefix2.default)('transitionDuration')] = '0ms';
      data.popperInstance.update();
      (0, _defer2.default)(function () {
        styles[(0, _prefix2.default)('transitionDuration')] = flipDuration + 'ms';
      });
    });

    observer.observe(popper, {
      childList: true,
      subtree: true,
      characterData: true
    });

    data._mutationObserver = observer;
  }

  return new _popper2.default(el, popper, config);
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTooltips;

var _getIndividualSettings = __webpack_require__(24);

var _getIndividualSettings2 = _interopRequireDefault(_getIndividualSettings);

var _createPopperElement = __webpack_require__(17);

var _createPopperElement2 = _interopRequireDefault(_createPopperElement);

var _createTrigger = __webpack_require__(20);

var _createTrigger2 = _interopRequireDefault(_createTrigger);

var _getEventListenerHandlers = __webpack_require__(23);

var _getEventListenerHandlers2 = _interopRequireDefault(_getEventListenerHandlers);

var _evaluateSettings = __webpack_require__(21);

var _evaluateSettings2 = _interopRequireDefault(_evaluateSettings);

var _removeTitle = __webpack_require__(12);

var _removeTitle2 = _interopRequireDefault(_removeTitle);

var _globals = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var idCounter = 1;

/**
* Creates tooltips for all el elements that match the instance's selector
* @param {Element[]} els
* @return {Object[]} Array of ref data objects
*/
function createTooltips(els) {
  var _this = this;

  return els.reduce(function (a, el) {
    var id = idCounter;

    var settings = (0, _evaluateSettings2.default)(_this.settings.performance ? _this.settings : (0, _getIndividualSettings2.default)(el, _this.settings));

    var html = settings.html,
        reactDOM = settings.reactDOM,
        trigger = settings.trigger,
        touchHold = settings.touchHold;


    var title = el.getAttribute('title');
    if (!title && !html && !reactDOM) return a;

    el.setAttribute('data-tooltipped', '');
    el.setAttribute('aria-describedby', 'tippy-tooltip-' + id);
    (0, _removeTitle2.default)(el);

    var popper = (0, _createPopperElement2.default)(id, title, settings);
    var handlers = _getEventListenerHandlers2.default.call(_this, el, popper, settings);

    var listeners = [];

    trigger.trim().split(' ').forEach(function (event) {
      return listeners = listeners.concat((0, _createTrigger2.default)(event, el, handlers, touchHold));
    });

    a.push({
      id: id,
      el: el,
      popper: popper,
      settings: settings,
      listeners: listeners,
      tippyInstance: _this
    });

    idCounter++;

    return a;
  }, []);
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTrigger;

var _globals = __webpack_require__(0);

/**
* Creates a trigger
* @param {Object} event - the custom event specified in the `trigger` setting
* @param {Element} el - tooltipped element
* @param {Object} handlers - the handlers for each listener
* @param {Boolean} touchHold
* @return {Array} - array of listener objects
*/
function createTrigger(event, el, handlers, touchHold) {
  var listeners = [];

  if (event === 'manual') return listeners;

  // Enter
  el.addEventListener(event, handlers.handleTrigger);
  listeners.push({
    event: event,
    handler: handlers.handleTrigger
  });

  // Leave
  if (event === 'mouseenter') {
    if (_globals.Browser.SUPPORTS_TOUCH && touchHold) {
      el.addEventListener('touchstart', handlers.handleTrigger);
      listeners.push({
        event: 'touchstart',
        handler: handlers.handleTrigger
      });
      el.addEventListener('touchend', handlers.handleMouseleave);
      listeners.push({
        event: 'touchend',
        handler: handlers.handleMouseleave
      });
    }

    el.addEventListener('mouseleave', handlers.handleMouseleave);
    listeners.push({
      event: 'mouseleave',
      handler: handlers.handleMouseleave
    });
  }

  if (event === 'focus') {
    el.addEventListener('blur', handlers.handleBlur);
    listeners.push({
      event: 'blur',
      handler: handlers.handleBlur
    });
  }

  return listeners;
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = evaluateSettings;
/**
* Evaluates/modifies the settings object for appropriate behavior
* @param {Object} settings
* @return {Object} modified/evaluated settings
*/
function evaluateSettings(settings) {
  // animateFill is disabled if an arrow is true
  if (settings.arrow) {
    settings.animateFill = false;
  }

  // reassign appendTo into the result of evaluating appendTo
  // if it's set as a function instead of Element
  if (settings.appendTo && typeof settings.appendTo === 'function') {
    settings.appendTo = settings.appendTo();
  }

  return settings;
}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getArrayOfElements;
/**
* Returns an array of elements based on the selector input
* @param {String|Element|Element[]} selector
* @return {Element[]}
*/
function getArrayOfElements(selector) {
  if (selector instanceof Element) {
    return [selector];
  }

  if (Array.isArray(selector)) {
    return selector;
  }

  return [].slice.call(document.querySelectorAll(selector));
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getEventListenerHandlers;

var _globals = __webpack_require__(0);

var _isVisible = __webpack_require__(7);

var _isVisible2 = _interopRequireDefault(_isVisible);

var _closest = __webpack_require__(4);

var _closest2 = _interopRequireDefault(_closest);

var _cursorIsOutsideInteractiveBorder = __webpack_require__(32);

var _cursorIsOutsideInteractiveBorder2 = _interopRequireDefault(_cursorIsOutsideInteractiveBorder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Returns relevant listener callbacks for each ref
* @param {Element} el
* @param {Element} popper
* @param {Object} settings
* @return {Object} - relevant listener handlers
*/
function getEventListenerHandlers(el, popper, settings) {
  var _this = this;

  var position = settings.position,
      delay = settings.delay,
      duration = settings.duration,
      interactive = settings.interactive,
      interactiveBorder = settings.interactiveBorder,
      distance = settings.distance,
      hideOnClick = settings.hideOnClick,
      trigger = settings.trigger,
      touchHold = settings.touchHold,
      touchWait = settings.touchWait;


  var showDelay = void 0,
      hideDelay = void 0;

  var clearTimeouts = function clearTimeouts() {
    clearTimeout(showDelay);
    clearTimeout(hideDelay);
  };

  var _show = function _show() {
    clearTimeouts();

    // Not hidden. For clicking when it also has a `focus` event listener
    if ((0, _isVisible2.default)(popper)) return;

    var _delay = Array.isArray(delay) ? delay[0] : delay;

    if (delay) {
      showDelay = setTimeout(function () {
        return _this.show(popper);
      }, _delay);
    } else {
      _this.show(popper);
    }
  };

  var show = function show(event) {
    return _this.callbacks.wait ? _this.callbacks.wait.call(popper, _show, event) : _show();
  };

  var hide = function hide() {
    clearTimeouts();

    var _delay = Array.isArray(delay) ? delay[1] : delay;

    if (delay) {
      hideDelay = setTimeout(function () {
        return _this.hide(popper);
      }, _delay);
    } else {
      _this.hide(popper);
    }
  };

  var handleTrigger = function handleTrigger(event) {
    var mouseenterTouch = event.type === 'mouseenter' && _globals.Browser.SUPPORTS_TOUCH && _globals.Browser.touch;

    if (mouseenterTouch && touchHold) return;

    // Toggle show/hide when clicking click-triggered tooltips
    var isClick = event.type === 'click';
    var isNotPersistent = hideOnClick !== 'persistent';

    isClick && (0, _isVisible2.default)(popper) && isNotPersistent ? hide() : show(event);

    if (mouseenterTouch && _globals.Browser.iOS() && el.click) {
      el.click();
    }
  };

  var handleMouseleave = function handleMouseleave(event) {

    // Don't fire 'mouseleave', use the 'touchend'
    if (event.type === 'mouseleave' && _globals.Browser.SUPPORTS_TOUCH && _globals.Browser.touch && touchHold) {
      return;
    }

    if (interactive) {
      // Temporarily handle mousemove to check if the mouse left somewhere
      // other than its popper
      var handleMousemove = function handleMousemove(event) {

        var triggerHide = function triggerHide() {
          document.body.removeEventListener('mouseleave', hide);
          document.removeEventListener('mousemove', handleMousemove);
          hide();
        };

        var closestTooltippedEl = (0, _closest2.default)(event.target, _globals.Selectors.TOOLTIPPED_EL);

        var isOverPopper = (0, _closest2.default)(event.target, _globals.Selectors.POPPER) === popper;
        var isOverEl = closestTooltippedEl === el;
        var isClickTriggered = trigger.indexOf('click') !== -1;
        var isOverOtherTooltippedEl = closestTooltippedEl && closestTooltippedEl !== el;

        if (isOverOtherTooltippedEl) {
          return triggerHide();
        }

        if (isOverPopper || isOverEl || isClickTriggered) return;

        if ((0, _cursorIsOutsideInteractiveBorder2.default)(event, popper, settings)) {
          triggerHide();
        }
      };

      document.body.addEventListener('mouseleave', hide);
      document.addEventListener('mousemove', handleMousemove);

      return;
    }

    // If it's not interactive, just hide it
    hide();
  };

  var handleBlur = function handleBlur(event) {
    // Ignore blur on touch devices, if there is no `relatedTarget`, hide
    // If the related target is a popper, ignore
    if (!event.relatedTarget || _globals.Browser.touch) return;
    if ((0, _closest2.default)(event.relatedTarget, _globals.Selectors.POPPER)) return;

    hide();
  };

  return {
    handleTrigger: handleTrigger,
    handleMouseleave: handleMouseleave,
    handleBlur: handleBlur
  };
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getIndividualSettings;

var _globals = __webpack_require__(0);

/**
* Returns an object of settings to override global settings
* @param {Element} el - the tooltipped element
* @param {Object} instanceSettings
* @return {Object} - individual settings
*/
function getIndividualSettings(el, instanceSettings) {
  var settings = _globals.DefaultsKeys.reduce(function (acc, key) {
    var val = el.getAttribute('data-' + key.toLowerCase()) || instanceSettings[key];

    // Convert strings to booleans
    if (val === 'false') val = false;
    if (val === 'true') val = true;

    // Convert number strings to true numbers
    if (isFinite(val) && !isNaN(parseFloat(val))) {
      val = parseFloat(val);
    }

    // Convert array strings to actual arrays
    if (typeof val === 'string' && val.trim().charAt(0) === '[') {
      val = JSON.parse(val);
    }

    acc[key] = val;

    return acc;
  }, {});

  return Object.assign({}, instanceSettings, settings);
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hideAllPoppers;

var _globals = __webpack_require__(0);

/**
* Hides all poppers
* @param {Object} exclude - refData to exclude if needed
*/
function hideAllPoppers(exclude) {
  _globals.Store.forEach(function (refData) {
    var popper = refData.popper,
        tippyInstance = refData.tippyInstance,
        _refData$settings = refData.settings,
        appendTo = _refData$settings.appendTo,
        hideOnClick = _refData$settings.hideOnClick,
        trigger = _refData$settings.trigger;

    // Don't hide already hidden ones

    if (!appendTo.contains(popper)) return;

    // hideOnClick can have the truthy value of 'persistent', so strict check is needed
    var isHideOnClick = hideOnClick === true || trigger.indexOf('focus') !== -1;
    var isNotCurrentRef = !exclude || popper !== exclude.popper;

    if (isHideOnClick && isNotCurrentRef) {
      refData.settings.onRequestClose();
      tippyInstance.hide(popper);
    }
  });
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _bindEventListeners = __webpack_require__(16);

var _bindEventListeners2 = _interopRequireDefault(_bindEventListeners);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* To run a single time, once DOM is presumed to be ready
* @return {Boolean} whether the function has run or not
*/
function init() {
  if (init.done) return false;
  init.done = true;

  (0, _bindEventListeners2.default)();

  return true;
}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeSticky;

var _defer = __webpack_require__(5);

var _defer2 = _interopRequireDefault(_defer);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

var _isVisible = __webpack_require__(7);

var _isVisible2 = _interopRequireDefault(_isVisible);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Updates a popper's position on each animation frame to make it stick to a moving element
* @param {Object} refData
*/
function makeSticky(refData) {
  var popper = refData.popper,
      popperInstance = refData.popperInstance,
      stickyDuration = refData.settings.stickyDuration;


  var applyTransitionDuration = function applyTransitionDuration() {
    return popper.style[(0, _prefix2.default)('transitionDuration')] = stickyDuration + 'ms';
  };

  var removeTransitionDuration = function removeTransitionDuration() {
    return popper.style[(0, _prefix2.default)('transitionDuration')] = '';
  };

  var updatePosition = function updatePosition() {
    popperInstance && popperInstance.scheduleUpdate();

    applyTransitionDuration();

    (0, _isVisible2.default)(popper) ? window.requestAnimationFrame(updatePosition) : removeTransitionDuration();
  };

  // Wait until Popper's position has been updated initially
  (0, _defer2.default)(updatePosition);
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mountPopper;

var _globals = __webpack_require__(0);

var _followCursorHandler = __webpack_require__(10);

var _followCursorHandler2 = _interopRequireDefault(_followCursorHandler);

var _createPopperInstance = __webpack_require__(18);

var _createPopperInstance2 = _interopRequireDefault(_createPopperInstance);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Appends the popper and creates a popper instance if one does not exist
* Also updates its position if need be and enables event listeners
* @param {Object} data -  the element/popper reference data
*/
function mountPopper(data) {
  var el = data.el,
      popper = data.popper,
      _data$settings = data.settings,
      appendTo = _data$settings.appendTo,
      followCursor = _data$settings.followCursor;

  // Already on the DOM

  if (appendTo.contains(popper)) return;

  appendTo.appendChild(popper);

  if (!data.popperInstance) {
    data.popperInstance = (0, _createPopperInstance2.default)(data);
  } else {
    data.popperInstance.update();
    if (!followCursor || _globals.Browser.touch) {
      data.popperInstance.enableEventListeners();
    }
  }

  // Since touch is determined dynamically, followCursor is set on mount
  if (followCursor && !_globals.Browser.touch) {
    el.addEventListener('mousemove', _followCursorHandler2.default);
    data.popperInstance.disableEventListeners();
  }
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = onTransitionEnd;

var _globals = __webpack_require__(0);

var _getInnerElements2 = __webpack_require__(6);

var _getInnerElements3 = _interopRequireDefault(_getInnerElements2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Prepares the callback functions for `show` and `hide` methods
* @param {Object} data
* @param {Number} duration
* @param {Function} callback - callback function to fire once transitions complete
*/
function onTransitionEnd(data, duration, callback) {
  // Make callback synchronous if duration is 0
  if (!duration) {
    return callback();
  }

  var _getInnerElements = (0, _getInnerElements3.default)(data.popper),
      tooltip = _getInnerElements.tooltip;

  var transitionendFired = false;

  var listenerCallback = function listenerCallback(e) {
    if (e.target === tooltip && !transitionendFired) {
      transitionendFired = true;
      callback();
    }
  };

  // Fire callback upon transition completion
  tooltip.addEventListener('webkitTransitionEnd', listenerCallback);
  tooltip.addEventListener('transitionend', listenerCallback);

  // Fallback: transitionend listener sometimes may not fire
  clearTimeout(data._transitionendTimeout);
  data._transitionendTimeout = setTimeout(function () {
    if (!transitionendFired) {
      callback();
    }
  }, duration);
}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

/* Utility functions */


/* Core library functions */


var _globals = __webpack_require__(0);

var _reactDom = __webpack_require__(39);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _init = __webpack_require__(26);

var _init2 = _interopRequireDefault(_init);

var _defer = __webpack_require__(5);

var _defer2 = _interopRequireDefault(_defer);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _findIndex = __webpack_require__(34);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _removeTitle = __webpack_require__(12);

var _removeTitle2 = _interopRequireDefault(_removeTitle);

var _elementIsInViewport = __webpack_require__(33);

var _elementIsInViewport2 = _interopRequireDefault(_elementIsInViewport);

var _triggerReflow = __webpack_require__(37);

var _triggerReflow2 = _interopRequireDefault(_triggerReflow);

var _modifyClassList = __webpack_require__(35);

var _modifyClassList2 = _interopRequireDefault(_modifyClassList);

var _getInnerElements4 = __webpack_require__(6);

var _getInnerElements5 = _interopRequireDefault(_getInnerElements4);

var _applyTransitionDuration = __webpack_require__(31);

var _applyTransitionDuration2 = _interopRequireDefault(_applyTransitionDuration);

var _isVisible = __webpack_require__(7);

var _isVisible2 = _interopRequireDefault(_isVisible);

var _noop = __webpack_require__(36);

var _noop2 = _interopRequireDefault(_noop);

var _followCursorHandler = __webpack_require__(10);

var _followCursorHandler2 = _interopRequireDefault(_followCursorHandler);

var _getArrayOfElements = __webpack_require__(22);

var _getArrayOfElements2 = _interopRequireDefault(_getArrayOfElements);

var _onTransitionEnd = __webpack_require__(29);

var _onTransitionEnd2 = _interopRequireDefault(_onTransitionEnd);

var _mountPopper = __webpack_require__(28);

var _mountPopper2 = _interopRequireDefault(_mountPopper);

var _makeSticky = __webpack_require__(27);

var _makeSticky2 = _interopRequireDefault(_makeSticky);

var _createTooltips = __webpack_require__(19);

var _createTooltips2 = _interopRequireDefault(_createTooltips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
* @param {String|Element|Element[]} selector
* @param {Object} settings (optional) - the object of settings to be applied to the instance
*/
var Tippy = function () {
  function Tippy(selector) {
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Tippy);

    // Use default browser tooltip on unsupported browsers
    if (!_globals.Browser.SUPPORTED) return;

    (0, _init2.default)();

    this.state = {
      destroyed: false
    };

    this.selector = selector;

    this.settings = _extends({}, _globals.Defaults, settings);

    if (settings.show || settings.shown || settings.hide || settings.hidden) {
      console.warn('Callbacks without the `on` prefix are deprecated (with the exception of `wait`).' + ' Use onShow, onShown, onHide, and onHidden instead.');
    }

    this.callbacks = {
      wait: settings.wait,
      show: settings.onShow || settings.show || _noop2.default,
      shown: settings.onShown || settings.shown || _noop2.default,
      hide: settings.onHide || settings.hide || _noop2.default,
      hidden: settings.onHidden || settings.hidden || _noop2.default
    };

    this.store = _createTooltips2.default.call(this, (0, _getArrayOfElements2.default)(selector));
    _globals.Store.push.apply(_globals.Store, this.store);
  }

  /**
  * Returns the reference element's popper element
  * @param {Element} el
  * @return {Element}
  */


  _createClass(Tippy, [{
    key: 'getPopperElement',
    value: function getPopperElement(el) {
      try {
        return (0, _find2.default)(this.store, function (data) {
          return data.el === el;
        }).popper;
      } catch (e) {
        console.error('[getPopperElement]: Element passed as the argument does not exist in the instance');
      }
    }

    /**
    * Returns a popper's reference element
    * @param {Element} popper
    * @return {Element}
    */

  }, {
    key: 'getReferenceElement',
    value: function getReferenceElement(popper) {
      try {
        return (0, _find2.default)(this.store, function (data) {
          return data.popper === popper;
        }).el;
      } catch (e) {
        console.error('[getReferenceElement]: Popper passed as the argument does not exist in the instance');
      }
    }

    /**
    * Returns the reference data object from either the reference element or popper element
    * @param {Element} x (reference element or popper)
    * @return {Object}
    */

  }, {
    key: 'getReferenceData',
    value: function getReferenceData(x) {
      return (0, _find2.default)(this.store, function (data) {
        return data.el === x || data.popper === x;
      });
    }

    /**
    * Update settings
    * @param {DOMElement} - popper
    * @param {string} - name
    * @param {string} - value
    */

  }, {
    key: 'updateSettings',
    value: function updateSettings(popper, name, value) {
      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });
      if (!data) return;

      var newSettings = _extends({}, data.settings, _defineProperty({}, name, value));
      data.settings = newSettings;
    }
  }, {
    key: 'updateForReact',


    /**
    * Update for React
    * @param {DOMElement} - popper
    * @param {ReactElement} - content
    */
    value: function updateForReact(popper, updatedContent) {
      var tooltipContent = popper.querySelector(_globals.Selectors.CONTENT);
      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });
      if (!data) return;

      var _data$settings = data.settings,
          useContext = _data$settings.useContext,
          setReactDOMValue = _data$settings.setReactDOMValue;


      if (useContext) {
        setReactDOMValue(_reactDom2.default.createPortal(updatedContent, tooltipContent));
      } else {
        _reactDom2.default.render(updatedContent, tooltipContent);
      }
    }
    /**
    * Shows a popper
    * @param {Element} popper
    * @param {Number} customDuration (optional)
    */

  }, {
    key: 'show',
    value: function show(popper, customDuration) {
      var _this = this;

      if (this.state.destroyed) return;

      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });
      if (!data) return;

      var _getInnerElements = (0, _getInnerElements5.default)(popper),
          tooltip = _getInnerElements.tooltip,
          circle = _getInnerElements.circle,
          content = _getInnerElements.content;

      if (!document.body.contains(data.el)) {
        this.destroy(popper);
        return;
      }

      this.callbacks.show.call(popper);

      // Custom react
      if (data.settings && data.settings.open === false) {
        return;
      }

      if (data.settings.reactDOM) {
        this.updateForReact(popper, data.settings.reactDOM);
      }
      // end: Custom react

      var el = data.el,
          _data$settings2 = data.settings,
          appendTo = _data$settings2.appendTo,
          sticky = _data$settings2.sticky,
          interactive = _data$settings2.interactive,
          followCursor = _data$settings2.followCursor,
          flipDuration = _data$settings2.flipDuration,
          duration = _data$settings2.duration,
          dynamicTitle = _data$settings2.dynamicTitle;


      if (dynamicTitle) {
        var title = el.getAttribute('title');
        if (title) {
          content.innerHTML = title;
          (0, _removeTitle2.default)(el);
        }
      }

      var _duration = customDuration !== undefined ? customDuration : Array.isArray(duration) ? duration[0] : duration;

      // Prevent a transition when popper changes position
      (0, _applyTransitionDuration2.default)([popper, tooltip, circle], 0);

      (0, _mountPopper2.default)(data);

      popper.style.visibility = 'visible';
      popper.setAttribute('aria-hidden', 'false');

      // Wait for popper's position to update
      (0, _defer2.default)(function () {
        // Sometimes the arrow will not be in the correct position, force another update
        if (!followCursor || _globals.Browser.touch) {
          data.popperInstance.update();
          (0, _applyTransitionDuration2.default)([popper], flipDuration);
        }

        // Re-apply transition durations
        (0, _applyTransitionDuration2.default)([tooltip, circle], _duration);

        // Make content fade out a bit faster than the tooltip if `animateFill`
        if (circle) content.style.opacity = 1;

        // Interactive tooltips receive a class of 'active'
        interactive && el.classList.add('active');

        // Update popper's position on every animation frame
        sticky && (0, _makeSticky2.default)(data);

        // Repaint/reflow is required for CSS transition when appending
        (0, _triggerReflow2.default)(tooltip, circle);

        (0, _modifyClassList2.default)([tooltip, circle], function (list) {
          list.contains('tippy-notransition') && list.remove('tippy-notransition');
          list.remove('leave');
          list.add('enter');
        });

        // Wait for transitions to complete
        (0, _onTransitionEnd2.default)(data, _duration, function () {
          if (!(0, _isVisible2.default)(popper) || data._onShownFired) return;

          // Focus interactive tooltips only
          interactive && popper.focus();
          // Remove transitions from tooltip
          tooltip.classList.add('tippy-notransition');
          // Prevents shown() from firing more than once from early transition cancellations
          data._onShownFired = true;

          _this.callbacks.shown.call(popper);
        });
      });
    }

    /**
    * Hides a popper
    * @param {Element} popper
    * @param {Number} customDuration (optional)
    */

  }, {
    key: 'hide',
    value: function hide(popper, customDuration) {
      var _this2 = this;

      if (this.state.destroyed) return;

      this.callbacks.hide.call(popper);

      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });
      if (!data) return;

      var _getInnerElements2 = (0, _getInnerElements5.default)(popper),
          tooltip = _getInnerElements2.tooltip,
          circle = _getInnerElements2.circle,
          content = _getInnerElements2.content;

      // custom react
      // Prevent hide if open


      if (data.settings.disabled === false && data && data.settings.open) {
        return;
      }

      var isUnmount = data && data.settings && data.settings.unmountHTMLWhenHide && data.settings.reactDOM;
      // end: custom react

      var el = data.el,
          _data$settings3 = data.settings,
          appendTo = _data$settings3.appendTo,
          sticky = _data$settings3.sticky,
          interactive = _data$settings3.interactive,
          followCursor = _data$settings3.followCursor,
          html = _data$settings3.html,
          trigger = _data$settings3.trigger,
          duration = _data$settings3.duration;


      var _duration = customDuration !== undefined ? customDuration : Array.isArray(duration) ? duration[1] : duration;

      data._onShownFired = false;
      interactive && el.classList.remove('active');

      popper.style.visibility = 'hidden';
      popper.setAttribute('aria-hidden', 'true');

      (0, _applyTransitionDuration2.default)([tooltip, circle, circle ? content : null], _duration);

      if (circle) content.style.opacity = 0;

      (0, _modifyClassList2.default)([tooltip, circle], function (list) {
        list.contains('tippy-tooltip') && list.remove('tippy-notransition');
        list.remove('enter');
        list.add('leave');
      });

      // Re-focus click-triggered html elements
      // and the tooltipped element IS in the viewport (otherwise it causes unsightly scrolling
      // if the tooltip is closed and the element isn't in the viewport anymore)
      if (html && trigger.indexOf('click') !== -1 && (0, _elementIsInViewport2.default)(el)) {
        el.focus();
      }

      // Wait for transitions to complete
      (0, _onTransitionEnd2.default)(data, _duration, function () {
        // `isVisible` is not completely reliable to determine if we shouldn't
        // run the hidden callback, we need to check the computed opacity style.
        // This prevents glitchy behavior of the transition when quickly showing
        // and hiding a tooltip.
        if ((0, _isVisible2.default)(popper) || !appendTo.contains(popper) || getComputedStyle(tooltip).opacity === '1') return;

        el.removeEventListener('mousemove', _followCursorHandler2.default);
        data.popperInstance.disableEventListeners();
        appendTo.removeChild(popper);

        _this2.callbacks.hidden.call(popper);

        // custom react
        if (isUnmount) {
          _reactDom2.default.unmountComponentAtNode(content);
        }
      });
    }

    /**
    * Updates a popper with new content
    * @param {Element} popper
    */

  }, {
    key: 'update',
    value: function update(popper) {
      if (this.state.destroyed) return;

      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });
      if (!data) return;

      var _getInnerElements3 = (0, _getInnerElements5.default)(popper),
          content = _getInnerElements3.content;

      var el = data.el,
          html = data.settings.html;


      if (html instanceof Element) {
        console.warn('Aborted: update() should not be used if `html` is a DOM element');
        return;
      }

      content.innerHTML = html ? document.getElementById(html.replace('#', '')).innerHTML : el.getAttribute('title') || el.getAttribute('data-original-title');

      if (!html) (0, _removeTitle2.default)(el);
    }

    /**
    * Destroys a popper
    * @param {Element} popper
    * @param {Boolean} _isLast - private param used by destroyAll to optimize
    */

  }, {
    key: 'destroy',
    value: function destroy(popper, _isLast) {
      var _this3 = this;

      if (this.state.destroyed) return;

      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });
      if (!data) return;

      var el = data.el,
          popperInstance = data.popperInstance,
          listeners = data.listeners,
          _mutationObserver = data._mutationObserver;

      // Ensure the popper is hidden

      if ((0, _isVisible2.default)(popper)) {
        this.hide(popper, 0);
      }

      // Remove Tippy-only event listeners from tooltipped element
      listeners.forEach(function (listener) {
        return el.removeEventListener(listener.event, listener.handler);
      });

      // Restore original title
      el.setAttribute('title', el.getAttribute('data-original-title'));

      el.removeAttribute('data-original-title');
      el.removeAttribute('data-tooltipped');
      el.removeAttribute('aria-describedby');

      popperInstance && popperInstance.destroy();
      _mutationObserver && _mutationObserver.disconnect();

      // Remove from store
      _globals.Store.splice((0, _findIndex2.default)(_globals.Store, function (data) {
        return data.popper === popper;
      }), 1);

      // Ensure filter is called only once
      if (_isLast === undefined || _isLast) {
        this.store = _globals.Store.filter(function (data) {
          return data.tippyInstance === _this3;
        });
      }
    }

    /**
    * Destroys all tooltips created by the instance
    */

  }, {
    key: 'destroyAll',
    value: function destroyAll() {
      var _this4 = this;

      if (this.state.destroyed) return;

      var storeLength = this.store.length;

      this.store.forEach(function (_ref, index) {
        var popper = _ref.popper;

        _this4.destroy(popper, index === storeLength - 1);
      });

      this.store = null;
      this.state.destroyed = true;
    }
  }]);

  return Tippy;
}();

function tippy(selector, settings) {
  return new Tippy(selector, settings);
}

tippy.Browser = _globals.Browser;
tippy.Defaults = _globals.Defaults;
tippy.disableDynamicInputDetection = function () {
  return _globals.Browser.dynamicInputDetection = false;
};
tippy.enableDynamicInputDetection = function () {
  return _globals.Browser.dynamicInputDetection = true;
};

exports.default = tippy;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyTransitionDuration;

var _globals = __webpack_require__(0);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

var _matches = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Applies the transition duration to each element
* @param {Element[]} els - Array of elements
* @param {Number} duration
*/
function applyTransitionDuration(els, duration) {
  els.forEach(function (el) {
    if (!el) return;

    var isContent = _matches.matches.call(el, _globals.Selectors.CONTENT);

    var _duration = isContent ? Math.round(duration / 1.3) : duration;

    el.style[(0, _prefix2.default)('transitionDuration')] = _duration + 'ms';
  });
}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursorIsOutsideInteractiveBorder;

var _getCorePlacement = __webpack_require__(3);

var _getCorePlacement2 = _interopRequireDefault(_getCorePlacement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Determines if the mouse's cursor is outside the interactive border
* @param {MouseEvent} event
* @param {Element} popper
* @param {Object} settings
* @return {Boolean}
*/
function cursorIsOutsideInteractiveBorder(event, popper, settings) {
  if (!popper.getAttribute('x-placement')) return true;

  var x = event.clientX,
      y = event.clientY;
  var interactiveBorder = settings.interactiveBorder,
      distance = settings.distance;


  var rect = popper.getBoundingClientRect();
  var corePosition = (0, _getCorePlacement2.default)(popper.getAttribute('x-placement'));
  var borderWithDistance = interactiveBorder + distance;

  var exceeds = {
    top: rect.top - y > interactiveBorder,
    bottom: y - rect.bottom > interactiveBorder,
    left: rect.left - x > interactiveBorder,
    right: x - rect.right > interactiveBorder
  };

  switch (corePosition) {
    case 'top':
      exceeds.top = rect.top - y > borderWithDistance;
      break;
    case 'bottom':
      exceeds.bottom = y - rect.bottom > borderWithDistance;
      break;
    case 'left':
      exceeds.left = rect.left - x > borderWithDistance;
      break;
    case 'right':
      exceeds.right = x - rect.right > borderWithDistance;
      break;
  }

  return exceeds.top || exceeds.bottom || exceeds.left || exceeds.right;
}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = elementIsInViewport;
/**
* Determines if an element is visible in the viewport
* @param {Element} el
* @return {Boolean}
*/
function elementIsInViewport(el) {
  var rect = el.getBoundingClientRect();

  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findIndex;

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Ponyfill for Array.prototype.findIndex
* @param {Array} arr
* @param {Function} checkFn
* @return index of the item in the array
*/
function findIndex(arr, checkFn) {
  if (Array.prototype.findIndex) {
    return arr.findIndex(checkFn);
  }

  // fallback
  return arr.indexOf((0, _find2.default)(arr, checkFn));
}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = modifyClassList;
/**
* Modifies elements' class lists
* @param {Element[]} els - Array of elements
* @param {Function} callback
*/
function modifyClassList(els, callback) {
  els.forEach(function (el) {
    if (!el) return;
    callback(el.classList);
  });
}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = noop;
function noop() {}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = triggerReflow;

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Triggers a document repaint or reflow for CSS transition
* @param {Element} tooltip
* @param {Element} circle
*/
function triggerReflow(tooltip, circle) {
  // Safari needs the specific 'transform' property to be accessed
  circle ? window.getComputedStyle(circle)[(0, _prefix2.default)('transform')] : window.getComputedStyle(tooltip).opacity;
}

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_38__;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_39__;

/***/ })
/******/ ]);
});
//# sourceMappingURL=react-tippy.js.map

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getDog;
/* harmony export (immutable) */ __webpack_exports__["a"] = createDog;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateDogRemote;
/* harmony export (immutable) */ __webpack_exports__["g"] = requestMatch;
/* harmony export (immutable) */ __webpack_exports__["e"] = toggleFavourite;
/* harmony export (immutable) */ __webpack_exports__["h"] = acceptMatch;
/* harmony export (immutable) */ __webpack_exports__["i"] = declineMatch;
/* harmony export (immutable) */ __webpack_exports__["j"] = notNowMatch;
/* harmony export (immutable) */ __webpack_exports__["f"] = endMatch;
/* harmony export (immutable) */ __webpack_exports__["c"] = cancelMatch;
/* unused harmony export logout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Api__ = __webpack_require__(18);


function getDog(id, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('dog/' + id, 'GET', null, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_DOG',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function createDog(data, accessToken) {
  // eslint-disable-line
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('dog', 'POST', data, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          // Create dog endpoint returns entire user object
          dispatch({
            type: 'UPDATE_USER',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function updateDogRemote(id, fields, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('dog/' + id, 'PATCH', fields, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_USER',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function requestMatch(id, message, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('dog/' + id + '/share', 'POST', message ? { message: message } : null, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_USER',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function toggleFavourite(id, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('dog/' + id + '/favourite', 'POST', null, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_USER',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function acceptMatch(id, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('match/' + id + '/accept', 'GET', null, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_MATCH',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function declineMatch(id, message, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('match/' + id + '/decline', 'POST', { message: message }, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_MATCH',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function notNowMatch(id, message, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('match/' + id + '/not-now', 'POST', { message: message }, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_MATCH',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function endMatch(id, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('match/' + id + '/end', 'GET', null, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_MATCH',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function cancelMatch(id, accessToken) {
  var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      var payload = typeof message === 'string' && message.trim().length ? {
        message: message.trim()
      } : {};

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('match/' + id + '/cancel', 'POST', payload, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_MATCH',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function logout() {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch({
        type: 'LOGOUT'
      });

      resolve();
    });
  };
}

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var styles = void 0;
var walkingIcon = __webpack_require__(302);
var runningIcon = __webpack_require__(297);
var swimmingIcon = __webpack_require__(299);

var beachIcon = __webpack_require__(292);
var parksIcon = __webpack_require__(296);
var cafesIcon = __webpack_require__(293);
var homeHangsIcon = __webpack_require__(295);
var adventuresIcon = __webpack_require__(290);
var trainingIcon = __webpack_require__(301);
var agilityIcon = __webpack_require__(291);
var serviceWorkIcon = __webpack_require__(298);
var therapyWorkIcon = __webpack_require__(300);
var dogTimeIcon = __webpack_require__(294);

var ActivityBadge = function (_Component) {
  _inherits(ActivityBadge, _Component);

  function ActivityBadge(props) {
    _classCallCheck(this, ActivityBadge);

    var _this = _possibleConstructorReturn(this, (ActivityBadge.__proto__ || Object.getPrototypeOf(ActivityBadge)).call(this, props));

    _this.icons = {
      running: runningIcon,
      walking: walkingIcon,
      beach: beachIcon,
      swimming: swimmingIcon,
      parks: parksIcon,
      cafes: cafesIcon,
      'home hangs': homeHangsIcon,
      adventures: adventuresIcon,
      training: trainingIcon,
      agility: agilityIcon,
      'service work': serviceWorkIcon,
      'therapy work': therapyWorkIcon,
      'dog time': dogTimeIcon,
      'dog friends': dogTimeIcon
    };
    return _this;
  }

  _createClass(ActivityBadge, [{
    key: 'render',
    value: function render() {
      var iconSource = this.icons[this.props.activity.toLowerCase()];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.badge, this.props.label ? styles.badge_lg : null, this.props.styles) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: iconSource, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.badge_icon), alt: '' + this.props.activity }),
        this.props.label ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.label) },
          this.props.activity
        ) : null
      );
    }
  }]);

  return ActivityBadge;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ActivityBadge);


ActivityBadge.defaultProps = {
  label: false,
  styles: null
};

ActivityBadge.propTypes = {
  styles: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].objectOf(__WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].number, __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].object])),
  activity: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].bool
};

styles = __WEBPACK_IMPORTED_MODULE_1_aphrodite__["StyleSheet"].create({
  badge: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 42,
    width: 42,

    ':not(:last-child)': {
      marginRight: 10
    },

    ':after': {
      position: 'absolute',
      top: -1,
      left: -1,
      height: 44,
      width: 44,
      boxShadow: '0 0 0 2px #fff inset',
      borderRadius: '50%',
      content: '""'
    }
  },
  badge_lg: {
    height: 58,
    width: 58,

    ':after': {
      height: 60,
      width: 60
    }
  },
  label: {
    marginTop: 10.4,
    textAlign: 'center',
    textTransform: 'capitalize'
  },
  badge_icon: {
    flexShrink: 0,
    display: 'block',
    height: '100%',
    width: '100%',
    borderRadius: '50%',
    backgroundColor: '#000e1f'
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ActivityBadge__ = __webpack_require__(42);
var _activity_card_select;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var styles = void 0;
var CHECK_ASSET = __webpack_require__(303);

var ActivityCard = function (_Component) {
  _inherits(ActivityCard, _Component);

  function ActivityCard(props) {
    _classCallCheck(this, ActivityCard);

    var _this = _possibleConstructorReturn(this, (ActivityCard.__proto__ || Object.getPrototypeOf(ActivityCard)).call(this, props));

    _this.toggleSelected = _this.toggleSelected.bind(_this);
    return _this;
  }

  _createClass(ActivityCard, [{
    key: 'toggleSelected',
    value: function toggleSelected() {
      if (this.props.profileHandler) {
        this.props.onSelect(this.props.name, this.props.id, !this.props.value);
      } else {
        this.props.onSelect(!this.props.value, this.props.id);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          role: 'button',
          tabIndex: 0,
          className: this.props.value ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.activity_card, styles.activity_card_selected, this.props.styles) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.activity_card, this.props.styles),
          onClick: this.toggleSelected
        },
        this.props.activity ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ActivityBadge__["a" /* default */], { activity: this.props.activity }) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.activity_label) },
          this.props.label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, {
          cacheGetRequests: true,
          src: CHECK_ASSET,
          className: this.props.value ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.check, styles.check_visible) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.check)
        })
      );
    }
  }]);

  return ActivityCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ActivityCard);


ActivityCard.defaultProps = {
  styles: null,
  onSelect: function onSelect() {},
  value: false,
  id: 0,
  profileHandler: false,
  name: null
};

ActivityCard.propTypes = {
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object])),
  profileHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func,
  activity: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string
};

styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  activity_card: _defineProperty({
    display: 'flex',
    alignItems: 'center',
    width: 250,
    height: 82,
    padding: 20,
    color: '#828282',
    backgroundColor: '#f4f4f4',
    border: 'solid 1px #e0e0e0',
    borderRadius: 5,
    margin: '6px 10px',
    cursor: 'pointer',
    transition: 'box-shadow 300ms, background-color 300ms, border-color 300ms, color 300ms',
    outline: 'none',
    'user-select': 'none',
    ':hover': {
      color: '#000e1f',
      backgroundColor: '#fff',
      boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)'
    }
  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    height: 62,
    margin: '6px 0',
    flexShrink: 0
  }),
  activity_card_selected: (_activity_card_select = {
    color: '#000e1f',
    backgroundColor: '#fff',
    borderColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary + ' inset'

  }, _defineProperty(_activity_card_select, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    height: 62
  }), _defineProperty(_activity_card_select, ':hover', {
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary + ' inset'
  }), _activity_card_select),
  activity_label: {
    flexGrow: 1,
    marginLeft: 10,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14
  },
  check: {
    display: 'block',
    marginRight: 5,
    opacity: 0,
    transition: 'opacity 300ms'
  },
  check_visible: {
    opacity: 1
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
var _activity_card;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var CHECK_ASSET = __webpack_require__(306);

var CheckButton = function (_Component) {
  _inherits(CheckButton, _Component);

  function CheckButton(props) {
    _classCallCheck(this, CheckButton);

    var _this = _possibleConstructorReturn(this, (CheckButton.__proto__ || Object.getPrototypeOf(CheckButton)).call(this, props));

    _this.toggleSelected = _this.toggleSelected.bind(_this);
    return _this;
  }

  _createClass(CheckButton, [{
    key: 'toggleSelected',
    value: function toggleSelected() {
      this.props.onSelect(this.props.name, this.props.id, !this.props.selected);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          role: 'button',
          tabIndex: 0,
          className: this.props.selected ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.activity_card, styles.activity_card_selected) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.activity_card),
          onClick: this.toggleSelected
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.activity_label) },
          this.props.label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, {
          cacheGetRequests: true,
          src: CHECK_ASSET,
          className: this.props.selected ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.check, styles.check_visible) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.check)
        })
      );
    }
  }]);

  return CheckButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (CheckButton);


CheckButton.defaultProps = {
  onSelect: function onSelect() {}
};

CheckButton.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOf([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number]).isRequired,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  activity_card: (_activity_card = {
    display: 'flex',
    alignItems: 'center',
    width: 244,
    height: 50,
    padding: 15,
    color: '#828282',
    backgroundColor: '#f4f4f4',
    border: 'solid 1px #e0e0e0',
    borderRadius: 5,
    margin: '6px 4.5px',
    cursor: 'pointer',
    transition: 'all 300ms',
    outline: 'none',
    'user-select': 'none'
  }, _defineProperty(_activity_card, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    margin: '6px 0',
    height: 62,
    flexShrink: 0
  }), _defineProperty(_activity_card, ':hover', {
    color: '#000e1f',
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)'
  }), _activity_card),
  activity_card_selected: {
    color: '#000e1f',
    backgroundColor: '#fff',
    borderColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary + ' inset',

    ':hover': {
      boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary + ' inset'
    }
  },
  activity_label: {
    flexGrow: 1,
    marginLeft: 10,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14
  },
  check: {
    display: 'block',
    marginRight: 5,
    opacity: 0,
    transition: 'opacity 300ms'
  },
  check_visible: {
    opacity: 1
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);





var styles = void 0;

var Paragraph = function Paragraph(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container, props.styles) },
    props.children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Paragraph);

Paragraph.defaultProps = {
  styles: null
};

Paragraph.propTypes = {
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object])),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].node).isRequired, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string]).isRequired
};

styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_size_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_primary,
    lineHeight: 1.4,
    marginBottom: 10
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__select_css__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__select_css__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var styles = void 0;
var ARROW_ASSET = __webpack_require__(328);

var Select = function (_Component) {
  _inherits(Select, _Component);

  function Select(props) {
    _classCallCheck(this, Select);

    var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

    _this.updateValue = _this.updateValue.bind(_this);
    _this.open = _this.open.bind(_this);
    _this.close = _this.close.bind(_this);
    _this.valueRenderer = _this.valueRenderer.bind(_this);

    _this.initialLabel = _this.props.options[0] ? _this.props.options[0].label : null;

    _this.state = {
      selectOpen: false,
      selectValue: null,
      totalSelected: 0,
      singleValue: null
    };
    return _this;
  }

  _createClass(Select, [{
    key: 'updateValue',
    value: function updateValue(newValue) {
      this.props.handler(this.props.name, newValue);
      this.setState({
        selectValue: newValue,
        singleValue: newValue && (typeof newValue === 'undefined' ? 'undefined' : _typeof(newValue)) === 'object' && newValue[0] ? newValue[0].label : null,
        totalSelected: newValue && newValue.length
      });
    }
  }, {
    key: 'open',
    value: function open() {
      if (this.props.disabled) {
        return;
      }
      this.setState({
        selectOpen: !this.state.selectOpen
      });
    }
  }, {
    key: 'close',
    value: function close() {
      this.setState({
        selectOpen: !this.state.selectOpen
      });
    }
  }, {
    key: 'valueRenderer',
    value: function valueRenderer(res) {
      this.fish = null;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'Select-value' },
        res.value.label
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var ICON_ASSET = void 0;
      var multiLabel = void 0;

      if (this.props.type !== 'simple') {
        ICON_ASSET = __webpack_require__(625)("./" + this.props.type + '.svg'); // eslint-disable-line
      }

      if (this.state.totalSelected > 1) {
        multiLabel = this.props.multiLabel + ' (' + this.state.totalSelected + ')';
      } else if (this.state.totalSelected === 1) {
        multiLabel = this.state.singleValue;
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.select_container) },
        this.props.label ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'label',
          { htmlFor: this.props.name, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.label) },
          this.props.label
        ) : null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.select_parent) },
          this.props.disabled && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.disabled_overlay) }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
            name: this.props.name,
            value: this.props.value ? this.props.value : null,
            placeholder: this.props.placeholder,
            options: this.props.options,
            clearable: true,
            backspaceRemoves: false,
            onChange: this.updateValue,
            onOpen: this.open,
            onClose: this.close,
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.select, this.props.style),
            multi: this.props.multiLabel !== null,
            valueComponent: this.valueRenderer,
            noOptionsMessage: this.props.noOptionsMessage,
            closeOnSelect: !this.props.multiLabel,
            disabled: this.props.disabled
          }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, {
            cacheGetRequests: true,
            src: ICON_ASSET,
            className: this.state.selectOpen || this.props.value && this.props.value.length ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.select_icon, styles.select_icon_open) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.select_icon)
          }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, {
            cacheGetRequests: true,
            src: ARROW_ASSET,
            className: this.state.selectOpen === true ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.select_arrow, styles.select_arrow_open) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.select_arrow)
          }),
          this.props.multiLabel ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.multi_label) },
            multiLabel ? multiLabel // eslint-disable-line
            : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'span',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.placeholder) },
              'All ',
              this.props.multiLabel
            )
          ) : null
        )
      );
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Select);


Select.defaultProps = {
  multiLabel: null,
  label: null,
  handler: function handler() {},
  value: null,
  style: false,
  noOptionsMessage: 'No results found',
  disabled: false
};

Select.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object).isRequired,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  multiLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  handler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOf([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number]),
  noOptionsMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool
};

styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  multi_label: _defineProperty({
    position: 'absolute',
    top: 1,
    left: 51,
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    height: 48,
    width: 130,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 15,
    color: '#000e1f',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    pointerEvents: 'none',
    transition: 'all 300ms'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    display: 'none'
  }),
  label: {
    display: 'block',
    marginBottom: 9,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_primary,
    fontSize: 14,
    color: '#828282'
  },
  select: {
    position: 'relative'
  },
  select_parent: {
    position: 'relative'
  },
  select_container: _defineProperty({
    position: 'relative'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    ':not(.a) > div': {
      width: '100%'
    },

    ':not(.a) > div.is-open .Select-input > input': {
      width: '100%'
    },

    ':not(.a) > div.is-open': {
      zIndex: 9
    }
  }),
  select_icon: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 2,
    display: 'block',
    height: 50,
    width: 50,
    pointerEvents: 'none',
    fill: '#D0D0D0',
    transition: 'fill 300ms'
  },
  select_icon_open: {
    fill: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].primary
  },
  select_arrow: {
    position: 'absolute',
    top: 0,
    right: 20,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    height: 50,
    width: 9,
    pointerEvents: 'none',
    transition: 'all 300ms'
  },
  select_arrow_open: {
    transform: 'rotateX(180deg)'
  },
  placeholder: {
    color: '#828282',
    transition: 'color 300ms'
  },
  disabled_overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'transparent',
    zIndex: 10,
    cursor: 'not-allowed'
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var UserImage = function (_Component) {
  _inherits(UserImage, _Component);

  function UserImage() {
    _classCallCheck(this, UserImage);

    return _possibleConstructorReturn(this, (UserImage.__proto__ || Object.getPrototypeOf(UserImage)).apply(this, arguments));
  }

  _createClass(UserImage, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.container, this.props.styles) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.image), src: this.props.image, alt: 'Profile' })
      );
    }
  }]);

  return UserImage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (UserImage);


UserImage.defaultProps = {
  styles: null
};

UserImage.propTypes = {
  styles: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object])),
  image: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_1_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    position: 'relative',
    zIndex: 1,
    width: 60,
    height: 60,
    borderRadius: 30,
    borderWidth: 2,
    borderColor: '#fff',
    borderStyle: 'solid',
    backgroundColor: '#fff',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset',
    overflow: 'hidden'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    height: 50,
    width: 50
  }),
  image: {
    zIndex: -1,
    cursor: 'pointer',
    display: 'block',
    height: '100%',
    width: '100%'
  }
});

/***/ }),
/* 48 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isArguments;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(454);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(437);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(119);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(1),__webpack_require__(0),__webpack_require__(19)):"function"==typeof define&&define.amd?define(["prop-types","react","react-dom"],t):e.AvatarEditor=t(e.PropTypes,e.React,e.ReactDOM)}(this,function(e,t,o){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function n(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}e=e&&e.hasOwnProperty("default")?e.default:e,t=t&&t.hasOwnProperty("default")?t.default:t,o=o&&o.hasOwnProperty("default")?o.default:o;var r=function(e){var t="undefined"==typeof DOMParser?null:new DOMParser;return t?t.parseFromString(e,"text/html"):null},s=function(e,t){for(var o=0;o<e.length;o++){var a=e[o];if("text/html"===a.type){a.getAsString(function(e){var o=r(e).querySelector("img");o&&o.src&&t(o.src)});break}}},h=function(){function e(e,t){var o=[],a=!0,n=!1,i=void 0;try{for(var r,s=e[Symbol.iterator]();!(a=(r=s.next()).done)&&(o.push(r.value),!t||o.length!==t);a=!0);}catch(e){n=!0,i=e}finally{try{!a&&s.return&&s.return()}finally{if(n)throw i}}return o}return function(t,o){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,o);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var a in o)Object.prototype.hasOwnProperty.call(o,a)&&(e[a]=o[a])}return e},c=function(){function e(e,t){for(var o=0;o<t.length;o++){var a=t[o];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,o,a){return o&&e(t.prototype,o),a&&e(t,a),t}}(),d=!("undefined"==typeof window||"undefined"==typeof navigator||!("ontouchstart"in window||navigator.msMaxTouchPoints>0)),p="undefined"!=typeof File,l={touch:{react:{down:"onTouchStart",mouseDown:"onMouseDown",drag:"onTouchMove",drop:"onTouchEnd",move:"onTouchMove",mouseMove:"onMouseMove",up:"onTouchEnd",mouseUp:"onMouseUp"},native:{down:"touchstart",mouseDown:"mousedown",drag:"touchmove",drop:"touchend",move:"touchmove",mouseMove:"mousemove",up:"touchend",mouseUp:"mouseup"}},desktop:{react:{down:"onMouseDown",drag:"onDragOver",drop:"onDrop",move:"onMouseMove",up:"onMouseUp"},native:{down:"mousedown",drag:"dragStart",drop:"drop",move:"mousemove",up:"mouseup"}}},g=d?l.touch:l.desktop,m="undefined"!=typeof window&&window.devicePixelRatio?window.devicePixelRatio:1,v=function(e,t,o,a,n,i){if(0===i)e.rect(t,o,a,n);else{var r=a-i,s=n-i;e.translate(t,o),e.arc(i,i,i,Math.PI,1.5*Math.PI),e.lineTo(r,0),e.arc(r,i,i,1.5*Math.PI,2*Math.PI),e.lineTo(a,s),e.arc(r,s,i,2*Math.PI,.5*Math.PI),e.lineTo(i,n),e.arc(i,s,i,.5*Math.PI,Math.PI),e.translate(-t,-o)}},f=function(e){function r(){var e,t,o,i;a(this,r);for(var h=arguments.length,c=Array(h),d=0;d<h;d++)c[d]=arguments[d];return t=o=n(this,(e=r.__proto__||Object.getPrototypeOf(r)).call.apply(e,[this].concat(c))),o.state={drag:!1,my:null,mx:null,image:{x:.5,y:.5}},o.handleMouseDown=function(e){(e=e||window.event).preventDefault(),o.setState({drag:!0,mx:null,my:null})},o.handleMouseUp=function(){o.state.drag&&(o.setState({drag:!1}),o.props.onMouseUp())},o.handleMouseMove=function(e){if(e=e||window.event,!1!==o.state.drag){var t=e.targetTouches?e.targetTouches[0].pageX:e.clientX,a=e.targetTouches?e.targetTouches[0].pageY:e.clientY,n={mx:t,my:a},i=o.props.rotate;if(i%=360,i=i<0?i+360:i,o.state.mx&&o.state.my){var r=o.state.mx-t,s=o.state.my-a,h=o.state.image.width*o.props.scale,c=o.state.image.height*o.props.scale,d=o.getCroppingRect(),p=d.x,l=d.y;p*=h,l*=c;var g=function(e){return e*(Math.PI/180)},m=Math.cos(g(i)),v=Math.sin(g(i)),f=l+-r*v+s*m,y={x:(p+r*m+s*v)/h+1/o.props.scale*o.getXScale()/2,y:f/c+1/o.props.scale*o.getYScale()/2};o.props.onPositionChange(y),n.image=u({},o.state.image,y)}o.setState(n),o.props.onMouseMove(e)}},o.handleDragOver=function(e){(e=e||window.event).preventDefault()},o.handleDrop=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.event;if(e.stopPropagation(),e.preventDefault(),e.dataTransfer){var t=e.dataTransfer,a=t.files,n=t.items;a&&a.length?(o.props.onDropFile(e),o.loadImageFile(a[0])):n&&n.length&&s(n,function(e){return o.loadImage(e)})}},o.setCanvas=function(e){o.canvas=e},i=t,n(o,i)}return i(r,t.Component),c(r,[{key:"isVertical",value:function(){return this.props.rotate%180!=0}},{key:"getBorders",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.props.border;return Array.isArray(e)?e:[e,e]}},{key:"getDimensions",value:function(){var e=this.props,t=e.width,o=e.height,a=e.rotate,n=e.border,i={},r=this.getBorders(n),s=h(r,2),u=s[0],c=s[1],d=t,p=o;return this.isVertical()?(i.width=p,i.height=d):(i.width=d,i.height=p),i.width+=2*u,i.height+=2*c,{canvas:i,rotate:a,width:t,height:o,border:n}}},{key:"getImage",value:function(){var e=this.getCroppingRect(),t=this.state.image;e.x*=t.resource.width,e.y*=t.resource.height,e.width*=t.resource.width,e.height*=t.resource.height;var o=document.createElement("canvas");this.isVertical()?(o.width=e.height,o.height=e.width):(o.width=e.width,o.height=e.height);var a=o.getContext("2d");return a.translate(o.width/2,o.height/2),a.rotate(this.props.rotate*Math.PI/180),a.translate(-o.width/2,-o.height/2),this.isVertical()&&a.translate((o.width-o.height)/2,(o.height-o.width)/2),a.drawImage(t.resource,-e.x,-e.y),o}},{key:"getImageScaledToCanvas",value:function(){var e=this.getDimensions(),t=e.width,o=e.height,a=document.createElement("canvas");return this.isVertical()?(a.width=o,a.height=t):(a.width=t,a.height=o),this.paintImage(a.getContext("2d"),this.state.image,0,1),a}},{key:"getXScale",value:function(){var e=this.props.width/this.props.height,t=this.state.image.width/this.state.image.height;return Math.min(1,e/t)}},{key:"getYScale",value:function(){var e=this.props.height/this.props.width,t=this.state.image.height/this.state.image.width;return Math.min(1,e/t)}},{key:"getCroppingRect",value:function(){var e=this.props.position||{x:this.state.image.x,y:this.state.image.y},t=1/this.props.scale*this.getXScale(),o=1/this.props.scale*this.getYScale(),a={x:e.x-t/2,y:e.y-o/2,width:t,height:o},n=0,i=1-a.width,r=0,s=1-a.height;return(t>1||o>1)&&(n=-a.width,i=1,r=-a.height,s=1),u({},a,{x:Math.max(n,Math.min(a.x,i)),y:Math.max(r,Math.min(a.y,s))})}},{key:"isDataURL",value:function(e){if(null===e)return!1;var t=/^\s*data:([a-z]+\/[a-z]+(;[a-z-]+=[a-z-]+)?)?(;base64)?,[a-z0-9!$&',()*+;=\-._~:@/?%\s]*\s*$/i;return!!e.match(t)}},{key:"loadImage",value:function(e){p&&e instanceof File?this.loadImageFile(e):"string"==typeof e&&this.loadImageURL(e)}},{key:"loadImageURL",value:function(e){var t=new Image;t.onload=this.handleImageReady.bind(this,t),t.onerror=this.props.onLoadFailure,!this.isDataURL(e)&&this.props.crossOrigin&&(t.crossOrigin=this.props.crossOrigin),t.src=e}},{key:"loadImageFile",value:function(e){var t=this,o=new FileReader;o.onload=function(e){return t.loadImageURL(e.target.result)},o.readAsDataURL(e)}},{key:"componentDidMount",value:function(){var e=o.findDOMNode(this.canvas).getContext("2d");if(this.props.image&&this.loadImage(this.props.image),this.paint(e),document){var t=g.native;document.addEventListener(t.move,this.handleMouseMove,!1),document.addEventListener(t.up,this.handleMouseUp,!1),d&&(document.addEventListener(t.mouseMove,this.handleMouseMove,!1),document.addEventListener(t.mouseUp,this.handleMouseUp,!1))}}},{key:"componentWillUnmount",value:function(){if(document){var e=g.native;document.removeEventListener(e.move,this.handleMouseMove,!1),document.removeEventListener(e.up,this.handleMouseUp,!1),d&&(document.removeEventListener(e.mouseMove,this.handleMouseMove,!1),document.removeEventListener(e.mouseUp,this.handleMouseUp,!1))}}},{key:"componentDidUpdate",value:function(e,t){var a=o.findDOMNode(this.canvas),n=a.getContext("2d");n.clearRect(0,0,a.width,a.height),this.paint(n),this.paintImage(n,this.state.image,this.props.border),e.image===this.props.image&&e.width===this.props.width&&e.height===this.props.height&&e.position===this.props.position&&e.scale===this.props.scale&&e.rotate===this.props.rotate&&t.my===this.state.my&&t.mx===this.state.mx&&t.image.x===this.state.image.x&&t.image.y===this.state.image.y||this.props.onImageChange()}},{key:"handleImageReady",value:function(e){var t=this.getInitialSize(e.width,e.height);t.resource=e,t.x=.5,t.y=.5,this.setState({drag:!1,image:t},this.props.onImageReady),this.props.onLoadSuccess(t)}},{key:"getInitialSize",value:function(e,t){var o=void 0,a=void 0,n=this.getDimensions();return n.height/n.width>t/e?a=e*((o=this.getDimensions().height)/t):o=t*((a=this.getDimensions().width)/e),{height:o,width:a}}},{key:"componentWillReceiveProps",value:function(e){(e.image&&this.props.image!==e.image||this.props.width!==e.width||this.props.height!==e.height)&&this.loadImage(e.image)}},{key:"paintImage",value:function(e,t,o){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:m;if(t.resource){var n=this.calculatePosition(t,o);e.save(),e.translate(e.canvas.width/2,e.canvas.height/2),e.rotate(this.props.rotate*Math.PI/180),e.translate(-e.canvas.width/2,-e.canvas.height/2),this.isVertical()&&e.translate((e.canvas.width-e.canvas.height)/2,(e.canvas.height-e.canvas.width)/2),e.scale(a,a),e.globalCompositeOperation="destination-over",e.drawImage(t.resource,n.x,n.y,n.width,n.height),e.restore()}}},{key:"calculatePosition",value:function(e,t){e=e||this.state.image;var o=this.getBorders(t),a=h(o,2),n=a[0],i=a[1],r=this.getCroppingRect(),s=e.width*this.props.scale,u=e.height*this.props.scale,c=-r.x*s,d=-r.y*u;return this.isVertical()?(c+=i,d+=n):(c+=n,d+=i),{x:c,y:d,height:u,width:s}}},{key:"paint",value:function(e){e.save(),e.scale(m,m),e.translate(0,0),e.fillStyle="rgba("+this.props.color.slice(0,4).join(",")+")";var t=this.props.borderRadius,o=this.getDimensions(),a=this.getBorders(o.border),n=h(a,2),i=n[0],r=n[1],s=o.canvas.height,u=o.canvas.width;t=Math.max(t,0),t=Math.min(t,u/2-i,s/2-r),e.beginPath(),v(e,i,r,u-2*i,s-2*r,t),e.rect(u,0,-u,s),e.fill("evenodd"),e.restore()}},{key:"render",value:function(){var e=this.getDimensions(),o={width:e.canvas.width,height:e.canvas.height,cursor:this.state.drag?"grabbing":"grab"},a={width:e.canvas.width*m,height:e.canvas.height*m,style:u({},o,this.props.style)};return a[g.react.down]=this.handleMouseDown,a[g.react.drag]=this.handleDragOver,this.props.disableDrop||(a[g.react.drop]=this.handleDrop),d&&(a[g.react.mouseDown]=this.handleMouseDown),t.createElement("canvas",u({ref:this.setCanvas},a))}}]),r}();return f.propTypes={scale:e.number,rotate:e.number,image:e.oneOfType([e.string].concat(function(e){if(Array.isArray(e)){for(var t=0,o=Array(e.length);t<e.length;t++)o[t]=e[t];return o}return Array.from(e)}(p?[e.instanceOf(File)]:[]))),border:e.oneOfType([e.number,e.arrayOf(e.number)]),borderRadius:e.number,width:e.number,height:e.number,position:e.shape({x:e.number,y:e.number}),color:e.arrayOf(e.number),style:e.object,crossOrigin:e.oneOf(["","anonymous","use-credentials"]),onDropFile:e.func,onLoadFailure:e.func,onLoadSuccess:e.func,onImageReady:e.func,onImageChange:e.func,onMouseUp:e.func,onMouseMove:e.func,onPositionChange:e.func,disableDrop:e.bool},f.defaultProps={disableDrop:!1,scale:1,rotate:0,border:25,borderRadius:0,width:200,height:200,color:[0,0,0,.5],style:{},onDropFile:function(){},onLoadFailure:function(){},onLoadSuccess:function(){},onImageReady:function(){},onImageChange:function(){},onMouseUp:function(){},onMouseMove:function(){},onPositionChange:function(){}},f});
//# sourceMappingURL=index.js.map


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles__ = __webpack_require__(469);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint prefer-template: 0 */






var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone(props, context) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));

    _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === 'function') {
        return children(_extends({}, _this.state, {
          isDragActive: isDragActive,
          isDragAccept: isDragAccept,
          isDragReject: isDragReject
        }));
      }
      return children;
    };

    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);

    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);

    _this.isFileDialogActive = false;

    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      this.dragTargets = [];

      if (preventDropOnDocument) {
        document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* onDocumentDragOver */], false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }
      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
      window.addEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      if (preventDropOnDocument) {
        document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* onDocumentDragOver */]);
        document.removeEventListener('drop', this.onDocumentDrop);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
      }
      window.removeEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'composeHandlers',
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }

      return handler;
    }
  }, {
    key: 'onDocumentDrop',
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(evt) {
      if (this.props.onDragStart) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(evt) {
      var _this2 = this;

      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }

      Promise.resolve(this.props.getDataTransferItems(evt)).then(function (draggedFiles) {
        _this2.setState({
          isDragActive: true, // Do not rely on files for the drag state. It doesn't work in Safari.
          draggedFiles: draggedFiles
        });
      });
      if (this.props.onDragEnter) {
        this.props.onDragEnter.call(this, evt);
      }
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.stopPropagation();
      try {
        // The file dialog on Chrome allows users to drag files from the dialog onto
        // the dropzone, causing the browser the crash when the file dialog is closed.
        // A drop effect of 'none' prevents the file from being dropped
        evt.dataTransfer.dropEffect = this.isFileDialogActive ? 'none' : 'copy'; // eslint-disable-line no-param-reassign
      } catch (err) {
        // continue regardless of error
      }

      if (this.props.onDragOver) {
        this.props.onDragOver.call(this, evt);
      }
      return false;
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(evt) {
      var _this3 = this;

      evt.preventDefault();

      // Only deactivate once the dropzone and all children have been left.
      this.dragTargets = this.dragTargets.filter(function (el) {
        return el !== evt.target && _this3.node.contains(el);
      });
      if (this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (this.props.onDragLeave) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(evt) {
      var _this4 = this;

      var _props = this.props,
          onDrop = _props.onDrop,
          onDropAccepted = _props.onDropAccepted,
          onDropRejected = _props.onDropRejected,
          multiple = _props.multiple,
          disablePreview = _props.disablePreview,
          accept = _props.accept,
          getDataTransferItems = _props.getDataTransferItems;

      // Stop default browser behavior

      evt.preventDefault();

      // Reset the counter along with the drag on a drop.
      this.dragTargets = [];
      this.isFileDialogActive = false;

      // Clear files value
      this.draggedFiles = null;

      // Reset drag state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      Promise.resolve(getDataTransferItems(evt)).then(function (fileList) {
        var acceptedFiles = [];
        var rejectedFiles = [];

        fileList.forEach(function (file) {
          if (!disablePreview) {
            try {
              file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
            } catch (err) {
              if (false) {
                console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
              }
            }
          }

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* fileAccepted */])(file, accept) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* fileMatchSize */])(file, _this4.props.maxSize, _this4.props.minSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });

        if (!multiple) {
          // if not in multi mode add any extra accepted files to rejected.
          // This will allow end users to easily ignore a multi file drop in "single" mode.
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
        }

        if (onDrop) {
          onDrop.call(_this4, acceptedFiles, rejectedFiles, evt);
        }

        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected.call(_this4, rejectedFiles, evt);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted.call(_this4, acceptedFiles, evt);
        }
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          disableClick = _props2.disableClick;

      if (!disableClick) {
        evt.stopPropagation();

        if (onClick) {
          onClick.call(this, evt);
        }

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* isIeOrEdge */])()) {
          setTimeout(this.open.bind(this), 0);
        } else {
          this.open();
        }
      }
    }
  }, {
    key: 'onInputElementClick',
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick();
      }
    }
  }, {
    key: 'onFileDialogCancel',
    value: function onFileDialogCancel() {
      var _this5 = this;

      // timeout will not recognize context of this method
      var onFileDialogCancel = this.props.onFileDialogCancel;
      // execute the timeout only if the FileDialog is opened in the browser

      if (this.isFileDialogActive) {
        setTimeout(function () {
          if (_this5.fileInputEl != null) {
            // Returns an object as FileList
            var files = _this5.fileInputEl.files;


            if (!files.length) {
              _this5.isFileDialogActive = false;
            }
          }

          if (typeof onFileDialogCancel === 'function') {
            onFileDialogCancel();
          }
        }, 300);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.node = ref;
    }
  }, {
    key: 'setRefs',
    value: function setRefs(ref) {
      this.fileInputEl = ref;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */

  }, {
    key: 'open',
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          accept = _props3.accept,
          acceptClassName = _props3.acceptClassName,
          activeClassName = _props3.activeClassName,
          children = _props3.children,
          disabled = _props3.disabled,
          disabledClassName = _props3.disabledClassName,
          inputProps = _props3.inputProps,
          multiple = _props3.multiple,
          name = _props3.name,
          rejectClassName = _props3.rejectClassName,
          rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);

      var acceptStyle = rest.acceptStyle,
          activeStyle = rest.activeStyle,
          _rest$className = rest.className,
          className = _rest$className === undefined ? '' : _rest$className,
          disabledStyle = rest.disabledStyle,
          rejectStyle = rest.rejectStyle,
          style = rest.style,
          props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);

      var _state = this.state,
          isDragActive = _state.isDragActive,
          draggedFiles = _state.draggedFiles;

      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* allFilesAccepted */])(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

      if (isDragActive && activeClassName) {
        className += ' ' + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += ' ' + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += ' ' + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += ' ' + disabledClassName;
      }

      if (noStyles) {
        style = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].default;
        activeStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        acceptStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        rejectStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].rejected;
        disabledStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].disabled;
      }

      var appliedStyle = _extends({ position: 'relative' }, style);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, appliedStyle, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, appliedStyle, disabledStyle);
      }

      var inputAttributes = {
        accept: accept,
        disabled: disabled,
        type: 'file',
        style: _extends({
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          opacity: 0.00001,
          pointerEvents: 'none'
        }, inputProps.style),
        multiple: __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* supportMultiple */] && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: 'off'
      };

      if (name && name.length) {
        inputAttributes.name = name;
      }

      // Destructure custom props away from props used for the div element

      var acceptedFiles = props.acceptedFiles,
          preventDropOnDocument = props.preventDropOnDocument,
          disablePreview = props.disablePreview,
          disableClick = props.disableClick,
          onDropAccepted = props.onDropAccepted,
          onDropRejected = props.onDropRejected,
          onFileDialogCancel = props.onFileDialogCancel,
          maxSize = props.maxSize,
          minSize = props.minSize,
          getDataTransferItems = props.getDataTransferItems,
          divProps = _objectWithoutProperties(props, ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize', 'getDataTransferItems']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: className,
          style: appliedStyle
        }, divProps /* expand user provided props first so event handlers are never overridden */, {
          onClick: this.composeHandlers(this.onClick),
          onDragStart: this.composeHandlers(this.onDragStart),
          onDragEnter: this.composeHandlers(this.onDragEnter),
          onDragOver: this.composeHandlers(this.onDragOver),
          onDragLeave: this.composeHandlers(this.onDragLeave),
          onDrop: this.composeHandlers(this.onDrop),
          ref: this.setRef,
          'aria-disabled': disabled
        }),
        this.renderChildren(children, isDragActive, isDragAccept, isDragReject),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
      );
    }
  }]);

  return Dropzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Dropzone);

Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),

  /**
   * Contents of the dropzone
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),

  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable the dropzone entirely
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable preview generation
   */
  disablePreview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Allow dropping multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * `name` attribute for the input tag
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Minimum file size (in bytes)
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * className
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drag is active
   */
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be accepted
   */
  acceptClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be rejected
   */
  rejectClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when dropzone is disabled
   */
  disabledClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS styles to apply
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * getDataTransferItems handler
   * @param {Event} event
   * @returns {Array} array of File objects
   */
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDrop callback
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropAccepted callback
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropRejected callback
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragStart callback
   */
  onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragEnter callback
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragOver callback
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragLeave callback
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disablePreview: false,
  disableClick: false,
  inputProps: {},
  multiple: true,
  maxSize: Infinity,
  minSize: 0,
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_2__utils__["g" /* getDataTransferItems */]
};

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(59);

var _utils2 = _interopRequireDefault(_utils);

var _animateScroll = __webpack_require__(147);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollEvents = __webpack_require__(82);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

exports.default = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    var horizontal = props.horizontal;
    var scrollOffset = _utils2.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](to, target);
      }

      if (containerElement === document) {
        if (props.horizontal) {
          window.scrollTo(scrollOffset, 0);
        } else {
          window.scrollTo(0, scrollOffset);
        }
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2.default.registered['end']) {
        _scrollEvents2.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var updateHash = function updateHash(hash, historyUpdate) {
  var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
  var hashToUpdate = hashVal ? "#" + hashVal : "";
  var curLoc = window && window.location;
  var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
  historyUpdate ? history.pushState(null, "", urlToPush) : history.replaceState(null, "", urlToPush);
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var scrollOffset = function scrollOffset(c, t, horizontal) {
  if (horizontal) {
    return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
  } else {
    return c === document ? t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) : getComputedStyle(c).position !== "static" ? t.offsetTop : t.offsetTop - c.offsetTop;
  }
};
exports.default = {
  updateHash: updateHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(19));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


exports.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


exports.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

exports.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

exports.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

exports.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


exports.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

exports.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

exports.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


exports.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


exports.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


exports.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react.default.Children.count(spec.children);

  var listWidth = Math.ceil(getWidth(_reactDom.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom.default.findDOMNode(spec.trackRef)));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = _reactDom.default.findDOMNode(spec.listRef) && getHeight(_reactDom.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }, spec);
  lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

exports.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = {
      animating: false
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    animationLeft = getTrackLeft(_objectSpread({}, spec, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread({}, spec, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread({}, spec, {
      currentSlide: animationSlide
    })));

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread({}, spec, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread({}, spec, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread({}, spec, {
          left: finalLeft
        })),
        swipeLeft: null
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

exports.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;

    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (targetSlide === options.currentSlide) {
      return null;
    }

    if (infinite) {
      var direction = siblingDirection(_objectSpread({}, spec, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);

    if (targetSlide === options.currentSlide) {
      return null;
    }
  }

  return targetSlide;
};

exports.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

exports.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

exports.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread({}, spec, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }

  return state;
};

exports.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = currentSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread({}, spec, {
      left: currentLeft
    }));
  }

  return state;
};

exports.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

exports.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

exports.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;

    var slickList = _reactDom.default.findDOMNode(spec.listRef);

    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

exports.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

exports.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

exports.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

exports.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;

    var trackElem = _reactDom.default.findDOMNode(trackRef);

    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

exports.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

exports.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

exports.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

exports.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

exports.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

exports.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

exports.slidesOnLeft = slidesOnLeft;

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

exports.canUseDOM = canUseDOM;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elementContextTypes = exports.injectContextTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Provider = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var injectContextTypes = exports.injectContextTypes = {
  getRegisteredElements: _propTypes2.default.func.isRequired
};

var elementContextTypes = exports.elementContextTypes = {
  addElementsLoadListener: _propTypes2.default.func.isRequired,
  registerElement: _propTypes2.default.func.isRequired,
  unregisterElement: _propTypes2.default.func.isRequired
};

var Elements = function (_React$Component) {
  _inherits(Elements, _React$Component);

  function Elements(props, context) {
    _classCallCheck(this, Elements);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleRegisterElement = function (type, element) {
      _this.setState(function (prevState) {
        return {
          registeredElements: [].concat(_toConsumableArray(prevState.registeredElements), [{ type: type, element: element }])
        };
      });
    };

    _this.handleUnregisterElement = function (el) {
      _this.setState(function (prevState) {
        return {
          registeredElements: prevState.registeredElements.filter(function (_ref) {
            var element = _ref.element;
            return element !== el;
          })
        };
      });
    };

    _this.state = {
      registeredElements: []
    };
    return _this;
  }

  Elements.prototype.getChildContext = function getChildContext() {
    var _this2 = this;

    return {
      addElementsLoadListener: function addElementsLoadListener(fn) {
        // Return the existing elements instance if we already have one.
        if (_this2._elements) {
          fn(_this2._elements);
          return;
        }

        var _props = _this2.props,
            children = _props.children,
            options = _objectWithoutProperties(_props, ['children']);

        if (_this2.context.tag === 'sync') {
          _this2._elements = _this2.context.stripe.elements(options);
          fn(_this2._elements);
        } else {
          _this2.context.addStripeLoadListener(function (stripe) {
            if (_this2._elements) {
              fn(_this2._elements);
            } else {
              _this2._elements = stripe.elements(options);
              fn(_this2._elements);
            }
          });
        }
      },
      registerElement: this.handleRegisterElement,
      unregisterElement: this.handleUnregisterElement,
      getRegisteredElements: function getRegisteredElements() {
        return _this2.state.registeredElements;
      }
    };
  };

  Elements.prototype.render = function render() {
    return _react2.default.Children.only(this.props.children);
  };

  return Elements;
}(_react2.default.Component);

Elements.childContextTypes = _extends({}, injectContextTypes, elementContextTypes);
Elements.contextTypes = _Provider.providerContextTypes;
Elements.defaultProps = {
  children: null
};
exports.default = Elements;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  keyPrefix: 'reduxPersist:',
  REHYDRATE: 'persist/REHYDRATE',
  REHYDRATE_COMPLETE: 'persist/COMPLETE'
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _stringHash = __webpack_require__(562);

var _stringHash2 = _interopRequireDefault(_stringHash);

/* ::
type Pair = [ string, any ];
type Pairs = Pair[];
type PairsMapper = (pair: Pair) => Pair;
type ObjectMap = { [id:string]: any };
*/

var mapObj = function mapObj(obj, /* : ObjectMap */
fn /* : PairsMapper */
) /* : ObjectMap */{
    var keys = Object.keys(obj);
    var mappedObj = {};
    for (var i = 0; i < keys.length; i += 1) {
        var _fn = fn([keys[i], obj[keys[i]]]);

        var _fn2 = _slicedToArray(_fn, 2);

        var newKey = _fn2[0];
        var newValue = _fn2[1];

        mappedObj[newKey] = newValue;
    }
    return mappedObj;
};

exports.mapObj = mapObj;
var UPPERCASE_RE = /([A-Z])/g;
var UPPERCASE_RE_TO_KEBAB = function UPPERCASE_RE_TO_KEBAB(match /* : string */) {
    return (/* : string */'-' + match.toLowerCase()
    );
};

var kebabifyStyleName = function kebabifyStyleName(string /* : string */) /* : string */{
    var result = string.replace(UPPERCASE_RE, UPPERCASE_RE_TO_KEBAB);
    if (result[0] === 'm' && result[1] === 's' && result[2] === '-') {
        return '-' + result;
    }
    return result;
};

exports.kebabifyStyleName = kebabifyStyleName;
/**
 * CSS properties which accept numbers but are not in units of "px".
 * Taken from React's CSSProperty.js
 */
var isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridColumn: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,

    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};

/**
 * Taken from React's CSSProperty.js
 *
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
    return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 * Taken from React's CSSProperty.js
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
// Taken from React's CSSProperty.js
Object.keys(isUnitlessNumber).forEach(function (prop) {
    prefixes.forEach(function (prefix) {
        isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
    });
});

var stringifyValue = function stringifyValue(key, /* : string */
prop /* : any */
) /* : string */{
    if (typeof prop === "number") {
        if (isUnitlessNumber[key]) {
            return "" + prop;
        } else {
            return prop + "px";
        }
    } else {
        return '' + prop;
    }
};

exports.stringifyValue = stringifyValue;
var stringifyAndImportantifyValue = function stringifyAndImportantifyValue(key, /* : string */
prop /* : any */
) {
    return (/* : string */importantify(stringifyValue(key, prop))
    );
};

exports.stringifyAndImportantifyValue = stringifyAndImportantifyValue;
// Turn a string into a hash string of base-36 values (using letters and numbers)
var hashString = function hashString(string /* : string */) {
    return (/* string */(0, _stringHash2['default'])(string).toString(36)
    );
};

exports.hashString = hashString;
// Hash a javascript object using JSON.stringify. This is very fast, about 3
// microseconds on my computer for a sample object:
// http://jsperf.com/test-hashfnv32a-hash/5
//
// Note that this uses JSON.stringify to stringify the objects so in order for
// this to produce consistent hashes browsers need to have a consistent
// ordering of objects. Ben Alpert says that Facebook depends on this, so we
// can probably depend on this too.
var hashObject = function hashObject(object /* : ObjectMap */) {
    return (/* : string */hashString(JSON.stringify(object))
    );
};

exports.hashObject = hashObject;
// Given a single style value string like the "b" from "a: b;", adds !important
// to generate "b !important".
var importantify = function importantify(string /* : string */) {
    return (/* : string */
        // Bracket string character access is very fast, and in the default case we
        // normally don't expect there to be "!important" at the end of the string
        // so we can use this simple check to take an optimized path. If there
        // happens to be a "!" in this position, we follow up with a more thorough
        // check.
        string[string.length - 10] === '!' && string.slice(-11) === ' !important' ? string : string + ' !important'
    );
};

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var styles = void 0;
var LOGO_ASSET = __webpack_require__(308);

var CompanyLogo = function CompanyLogo(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.relative_container, props.styles) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
      { to: props.link },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: LOGO_ASSET, alt: 'The Dog Share Collective', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.logo) })
    )
  );
};

CompanyLogo.defaultProps = {
  styles: null,
  link: '/'
};

CompanyLogo.propTypes = {
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object])),
  link: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = (CompanyLogo);

styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  relative_container: {
    position: 'relative'
  },
  logo: _defineProperty({
    height: 140,
    width: 140

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    position: 'relative',
    top: 0,
    left: 20,
    height: 80,
    width: 80,
    marginBottom: 20
  })
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);





var styles = void 0;

var Heading = function Heading(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.paragraph, props.styles) },
    props.children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Heading);

Heading.defaultProps = {
  styles: null
};

Heading.propTypes = {
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object])),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired
};

styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  paragraph: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_size_heading,
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_heading,
    marginBottom: 10
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROUTES; });
var ROUTES = { // eslint-disable-line import/prefer-default-export
  SETTINGS: {
    MEMBERSHIP: '/settings/membership'
  }
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.7082e21a.svg";

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = extend

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (source.hasOwnProperty(key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 69 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(72);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(70),
    getRawTag = __webpack_require__(427),
    objectToString = __webpack_require__(450);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(426);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 73 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(71),
    isObjectLike = __webpack_require__(73);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warn;
function warn(s) {
  console.warn('[react-ga]', s);
}

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(56);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(57);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Helpers = exports.ScrollElement = exports.ScrollLink = exports.animateScroll = exports.scrollSpy = exports.Events = exports.scroller = exports.Element = exports.Button = exports.Link = undefined;

var _Link = __webpack_require__(515);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(513);

var _Button2 = _interopRequireDefault(_Button);

var _Element = __webpack_require__(514);

var _Element2 = _interopRequireDefault(_Element);

var _scroller = __webpack_require__(58);

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = __webpack_require__(82);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = __webpack_require__(84);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = __webpack_require__(147);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = __webpack_require__(83);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = __webpack_require__(148);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = __webpack_require__(516);

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Link = _Link2.default;
exports.Button = _Button2.default;
exports.Element = _Element2.default;
exports.scroller = _scroller2.default;
exports.Events = _scrollEvents2.default;
exports.scrollSpy = _scrollSpy2.default;
exports.animateScroll = _animateScroll2.default;
exports.ScrollLink = _scrollLink2.default;
exports.ScrollElement = _scrollElement2.default;
exports.Helpers = _Helpers2.default;
exports.default = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports.default = Events;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollSpy = __webpack_require__(84);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _scroller = __webpack_require__(58);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollHash = __webpack_require__(149);

var _scrollHash2 = _interopRequireDefault(_scrollHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes = {
  to: _propTypes2.default.string.isRequired,
  containerId: _propTypes2.default.string,
  container: _propTypes2.default.object,
  activeClass: _propTypes2.default.string,
  spy: _propTypes2.default.bool,
  horizontal: _propTypes2.default.bool,
  smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  offset: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  isDynamic: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  absolute: _propTypes2.default.bool,
  onSetActive: _propTypes2.default.func,
  onSetInactive: _propTypes2.default.func,
  ignoreCancelEvents: _propTypes2.default.bool,
  hashSpy: _propTypes2.default.bool,
  saveHashHistory: _propTypes2.default.bool
};

exports.default = function (Component, customScroller) {

  var scroller = customScroller || _scroller2.default;

  var Link = function (_React$PureComponent) {
    _inherits(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck(this, Link);

      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      return _this;
    }

    _createClass(Link, [{
      key: 'getScrollSpyContainer',
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
            _scrollSpy2.default.mount(scrollSpyContainer);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
      }
    }, {
      key: 'render',
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var props = _extends({}, this.props);

        for (var prop in protoTypes) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.onClick = this.handleClick;

        return _react2.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends({}, _this2.state, props));
    };

    this.handleClick = function (event) {

      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (x, y) {
      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var horizontal = _this2.props.horizontal;

      var to = _this2.props.to;
      var element = null;
      var isInside = void 0;
      var isOutside = void 0;

      if (horizontal) {
        var elemLeftBound = 0;
        var elemRightBound = 0;
        var containerLeft = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerLeft = containerCords.left;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemLeftBound = cords.left - containerLeft + x;
          elemRightBound = elemLeftBound + cords.width;
        }

        var offsetX = x - _this2.props.offset;
        isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
        isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
      } else {
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var _containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = _containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var _cords = element.getBoundingClientRect();
          elemTopBound = _cords.top - containerTop + y;
          elemBottomBound = elemTopBound + _cords.height;
        }

        var offsetY = y - _this2.props.offset;
        isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      }

      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          var _props$saveHashHistor = _this2.props.saveHashHistory,
              saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;

          _scrollHash2.default.changeHash("", saveHashHistory);
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        var _props$saveHashHistor2 = _this2.props.saveHashHistory,
            _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to, _saveHashHistory);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  ;

  Link.propTypes = protoTypes;

  Link.defaultProps = { offset: 0 };

  return Link;
};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(519);

var _lodash2 = _interopRequireDefault(_lodash);

var _passiveEventListeners = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps
var eventThrottler = function eventThrottler(eventHandler) {
  return (0, _lodash2.default)(eventHandler, 66);
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy.scrollHandler(scrollSpyContainer);
      });
      scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
    }
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionX: function currentPositionX(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageYOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    } else {
      return scrollSpyContainer.scrollLeft;
    }
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);

    handler(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
  },
  updateStates: function updateStates() {
    scrollSpy.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy.spySetState && scrollSpy.spySetState.length) {
      scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy.scrollHandler);
  },


  update: function update() {
    return scrollSpy.scrollSpyContainers.forEach(function (c) {
      return scrollSpy.scrollHandler(c);
    });
  }
};

exports.default = scrollSpy;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.providerContextTypes = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO(jez) 'sync' and 'async' are bad tag names.
// TODO(jez) What if redux also uses this.context.tag?
var providerContextTypes = exports.providerContextTypes = {
  tag: _propTypes2.default.string.isRequired,
  stripe: _propTypes2.default.object,
  addStripeLoadListener: _propTypes2.default.func
};

var getOrCreateStripe = function getOrCreateStripe(apiKey, options) {
  /**
   * Note that this is not meant to be a generic memoization solution.
   * This is specifically a solution for `StripeProvider`s being initialized
   * and destroyed regularly (with the same set of props) when users only
   * use `StripeProvider` for the subtree that contains their checkout form.
   */
  window.Stripe.__cachedInstances = window.Stripe.__cachedInstances || {};
  var cacheKey = 'key=' + apiKey + ' options=' + JSON.stringify(options);

  var stripe = window.Stripe.__cachedInstances[cacheKey] || window.Stripe(apiKey, options);
  window.Stripe.__cachedInstances[cacheKey] = stripe;

  return stripe;
};

var ensureStripeShape = function ensureStripeShape(stripe) {
  if (stripe && stripe.elements && stripe.createSource && stripe.createToken) {
    return stripe;
  } else {
    throw new Error("Please pass a valid Stripe object to StripeProvider. You can obtain a Stripe object by calling 'Stripe(...)' with your publishable key.");
  }
};

var Provider = function (_React$Component) {
  _inherits(Provider, _React$Component);

  // on the other hand: childContextTypes is *required* to use context.
  function Provider(props) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    if (_this.props.apiKey && _this.props.stripe) {
      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider, not both.");
    } else if (_this.props.apiKey) {
      if (!window.Stripe) {
        throw new Error("Please load Stripe.js (https://js.stripe.com/v3/) on this page to use react-stripe-elements. If Stripe.js isn't available yet (it's loading asynchronously, or you're using server-side rendering), see https://github.com/stripe/react-stripe-elements#advanced-integrations");
      } else {
        var _this$props = _this.props,
            _apiKey = _this$props.apiKey,
            _children = _this$props.children,
            _stripe = _this$props.stripe,
            options = _objectWithoutProperties(_this$props, ['apiKey', 'children', 'stripe']);

        _this._meta = {
          tag: 'sync',
          stripe: getOrCreateStripe(_apiKey, options)
        };
      }
    } else if (_this.props.stripe) {
      // If we already have a stripe instance (in the constructor), we can behave synchronously.
      _this._meta = {
        tag: 'sync',
        stripe: ensureStripeShape(_this.props.stripe)
      };
    } else if (_this.props.stripe === null) {
      _this._meta = {
        tag: 'async',
        stripe: null
      };
    } else {
      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider. If you're using 'stripe' but don't have a Stripe instance yet, pass 'null' explicitly.");
    }

    _this._didWarn = false;
    _this._didWakeUpListeners = false;
    _this._listeners = [];
    return _this;
  }
  // Even though we're using flow, also use PropTypes so we can take advantage of developer warnings.


  Provider.prototype.getChildContext = function getChildContext() {
    var _this2 = this;

    // getChildContext is run after the constructor, so we WILL have access to
    // the initial state.
    //
    // However, context doesn't update in respnse to state changes like you
    // might expect: context is pulled by the child, not pushed by the parent.
    if (this._meta.tag === 'sync') {
      return {
        tag: 'sync',
        stripe: this._meta.stripe
      };
    } else {
      return {
        tag: 'async',
        addStripeLoadListener: function addStripeLoadListener(fn) {
          if (_this2._meta.stripe) {
            fn(_this2._meta.stripe);
          } else {
            _this2._listeners.push(fn);
          }
        }
      };
    }
  };

  Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var apiKeyChanged = this.props.apiKey && nextProps.apiKey && this.props.apiKey !== nextProps.apiKey;

    var stripeInstanceChanged = this.props.stripe && nextProps.stripe && this.props.stripe !== nextProps.stripe;
    if (!this._didWarn && (apiKeyChanged || stripeInstanceChanged) && window.console && window.console.error) {
      this._didWarn = true;
      // eslint-disable-next-line no-console
      console.error('StripeProvider does not support changing the apiKey parameter.');
      return;
    }

    if (!this._didWakeUpListeners && nextProps.stripe) {
      // Wake up the listeners if we've finally been given a StripeShape
      this._didWakeUpListeners = true;
      var _stripe2 = ensureStripeShape(nextProps.stripe);
      this._meta.stripe = _stripe2;
      this._listeners.forEach(function (fn) {
        fn(_stripe2);
      });
    }
  };

  Provider.prototype.render = function render() {
    return _react2.default.Children.only(this.props.children);
  };

  return Provider;
}(_react2.default.Component);

Provider.propTypes = {
  apiKey: _propTypes2.default.string,
  // PropTypes.object is the only way we can accept a Stripe instance
  // eslint-disable-next-line react/forbid-prop-types
  stripe: _propTypes2.default.object,
  children: _propTypes2.default.node
};
Provider.childContextTypes = providerContextTypes;
Provider.defaultProps = {
  apiKey: undefined,
  stripe: undefined,
  children: null
};
exports.default = Provider;

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UNMOUNTED */
/* unused harmony export EXITED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENTERING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ENTERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EXITING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_PropTypes__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__ = __webpack_require__(87);








var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */].Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(children), childProps))
    );
  };

  return Transition;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Transition.contextType = __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */];
Transition.propTypes =  false ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : PropTypes.instanceOf(Element)
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ __webpack_exports__["a"] = (Transition);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null));

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate, global, process) {

exports.__esModule = true;
var genericSetImmediate = typeof setImmediate === 'undefined' ? global.setImmediate : setImmediate;
var nextTick = process && process.nextTick ? process.nextTick : genericSetImmediate;

var noStorage = process && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'production' ? function () {
  /* noop */return null;
} : function () {
  console.error('redux-persist asyncLocalStorage requires a global localStorage object. Either use a different storage backend or if this is a universal redux application you probably should conditionally persist like so: https://gist.github.com/rt2zz/ac9eb396793f95ff3c3b');
  return null;
};

function hasLocalStorage() {
  try {
    return typeof window === 'object' && typeof window.localStorage !== 'undefined';
  } catch (e) {
    return false;
  }
}

function hasSessionStorage() {
  try {
    return typeof window === 'object' && typeof window.sessionStorage !== 'undefined';
  } catch (e) {
    return false;
  }
}

function getStorage(type) {
  if (type === 'local') {
    return hasLocalStorage() ? window.localStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
  if (type === 'session') {
    return hasSessionStorage() ? window.sessionStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
}

exports['default'] = function (type) {
  var storage = getStorage(type);
  return {
    getItem: function getItem(key, cb) {
      try {
        var s = storage.getItem(key);
        nextTick(function () {
          cb(null, s);
        });
      } catch (e) {
        cb(e);
      }
    },
    setItem: function setItem(key, string, cb) {
      try {
        storage.setItem(key, string);
        nextTick(function () {
          cb(null);
        });
      } catch (e) {
        cb(e);
      }
    },
    removeItem: function removeItem(key, cb) {
      try {
        storage.removeItem(key);
        nextTick(function () {
          cb(null);
        });
      } catch (e) {
        cb(e);
      }
    },
    getAllKeys: function getAllKeys(cb) {
      try {
        var keys = [];
        for (var i = 0; i < storage.length; i++) {
          keys.push(storage.key(i));
        }
        nextTick(function () {
          cb(null, keys);
        });
      } catch (e) {
        cb(e);
      }
    }
  };
};

module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(159).setImmediate, __webpack_require__(13), __webpack_require__(122)))

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(158);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* unused harmony reexport compose */







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _inlineStylePrefixerStaticCreatePrefixer = __webpack_require__(383);

var _inlineStylePrefixerStaticCreatePrefixer2 = _interopRequireDefault(_inlineStylePrefixerStaticCreatePrefixer);

var _libStaticPrefixData = __webpack_require__(165);

var _libStaticPrefixData2 = _interopRequireDefault(_libStaticPrefixData);

var _orderedElements = __webpack_require__(92);

var _orderedElements2 = _interopRequireDefault(_orderedElements);

var _util = __webpack_require__(63);

var prefixAll = (0, _inlineStylePrefixerStaticCreatePrefixer2['default'])(_libStaticPrefixData2['default']);

/* ::
import type { SheetDefinition } from './index.js';
type StringHandlers = { [id:string]: Function };
type SelectorCallback = (selector: string) => any;
export type SelectorHandler = (
    selector: string,
    baseSelector: string,
    callback: SelectorCallback
) => string | null;
*/

/**
 * `selectorHandlers` are functions which handle special selectors which act
 * differently than normal style definitions. These functions look at the
 * current selector and can generate CSS for the styles in their subtree by
 * calling the callback with a new selector.
 *
 * For example, when generating styles with a base selector of '.foo' and the
 * following styles object:
 *
 *   {
 *     ':nth-child(2n)': {
 *       ':hover': {
 *         color: 'red'
 *       }
 *     }
 *   }
 *
 * when we reach the ':hover' style, we would call our selector handlers like
 *
 *   handler(':hover', '.foo:nth-child(2n)', callback)
 *
 * Since our `pseudoSelectors` handles ':hover' styles, that handler would call
 * the callback like
 *
 *   callback('.foo:nth-child(2n):hover')
 *
 * to generate its subtree `{ color: 'red' }` styles with a
 * '.foo:nth-child(2n):hover' selector. The callback would return CSS like
 *
 *   '.foo:nth-child(2n):hover{color:red !important;}'
 *
 * and the handler would then return that resulting CSS.
 *
 * `defaultSelectorHandlers` is the list of default handlers used in a call to
 * `generateCSS`.
 *
 * @name SelectorHandler
 * @function
 * @param {string} selector: The currently inspected selector. ':hover' in the
 *     example above.
 * @param {string} baseSelector: The selector of the parent styles.
 *     '.foo:nth-child(2n)' in the example above.
 * @param {function} generateSubtreeStyles: A function which can be called to
 *     generate CSS for the subtree of styles corresponding to the selector.
 *     Accepts a new baseSelector to use for generating those styles.
 * @returns {?string} The generated CSS for this selector, or null if we don't
 *     handle this selector.
 */
var defaultSelectorHandlers = [
// Handle pseudo-selectors, like :hover and :nth-child(3n)
function pseudoSelectors(selector, /* : string */
baseSelector, /* : string */
generateSubtreeStyles /* : Function */
) /* */{
    if (selector[0] !== ":") {
        return null;
    }
    return generateSubtreeStyles(baseSelector + selector);
},

// Handle media queries (or font-faces)
function mediaQueries(selector, /* : string */
baseSelector, /* : string */
generateSubtreeStyles /* : Function */
) /* */{
    if (selector[0] !== "@") {
        return null;
    }
    // Generate the styles normally, and then wrap them in the media query.
    var generated = generateSubtreeStyles(baseSelector);
    return selector + '{' + generated + '}';
}];

exports.defaultSelectorHandlers = defaultSelectorHandlers;
/**
 * Generate CSS for a selector and some styles.
 *
 * This function handles the media queries and pseudo selectors that can be used
 * in aphrodite styles.
 *
 * @param {string} selector: A base CSS selector for the styles to be generated
 *     with.
 * @param {Object} styleTypes: A list of properties of the return type of
 *     StyleSheet.create, e.g. [styles.red, styles.blue].
 * @param {Array.<SelectorHandler>} selectorHandlers: A list of selector
 *     handlers to use for handling special selectors. See
 *     `defaultSelectorHandlers`.
 * @param stringHandlers: See `generateCSSRuleset`
 * @param useImportant: See `generateCSSRuleset`
 *
 * To actually generate the CSS special-construct-less styles are passed to
 * `generateCSSRuleset`.
 *
 * For instance, a call to
 *
 *     generateCSS(".foo", [{
 *       color: "red",
 *       "@media screen": {
 *         height: 20,
 *         ":hover": {
 *           backgroundColor: "black"
 *         }
 *       },
 *       ":active": {
 *         fontWeight: "bold"
 *       }
 *     }], defaultSelectorHandlers);
 *
 * with the default `selectorHandlers` will make 5 calls to
 * `generateCSSRuleset`:
 *
 *     generateCSSRuleset(".foo", { color: "red" }, ...)
 *     generateCSSRuleset(".foo:active", { fontWeight: "bold" }, ...)
 *     // These 2 will be wrapped in @media screen {}
 *     generateCSSRuleset(".foo", { height: 20 }, ...)
 *     generateCSSRuleset(".foo:hover", { backgroundColor: "black" }, ...)
 */
var generateCSS = function generateCSS(selector, /* : string */
styleTypes, /* : SheetDefinition[] */
selectorHandlers, /* : SelectorHandler[] */
stringHandlers, /* : StringHandlers */
useImportant /* : boolean */
) /* : string */{
    var merged = new _orderedElements2['default']();

    for (var i = 0; i < styleTypes.length; i++) {
        merged.addStyleType(styleTypes[i]);
    }

    var plainDeclarations = new _orderedElements2['default']();
    var generatedStyles = "";

    // TODO(emily): benchmark this to see if a plain for loop would be faster.
    merged.forEach(function (val, key) {
        // For each key, see if one of the selector handlers will handle these
        // styles.
        var foundHandler = selectorHandlers.some(function (handler) {
            var result = handler(key, selector, function (newSelector) {
                return generateCSS(newSelector, [val], selectorHandlers, stringHandlers, useImportant);
            });
            if (result != null) {
                // If the handler returned something, add it to the generated
                // CSS and stop looking for another handler.
                generatedStyles += result;
                return true;
            }
        });
        // If none of the handlers handled it, add it to the list of plain
        // style declarations.
        if (!foundHandler) {
            plainDeclarations.set(key, val, true);
        }
    });

    return generateCSSRuleset(selector, plainDeclarations, stringHandlers, useImportant, selectorHandlers) + generatedStyles;
};

exports.generateCSS = generateCSS;
/**
 * Helper method of generateCSSRuleset to facilitate custom handling of certain
 * CSS properties. Used for e.g. font families.
 *
 * See generateCSSRuleset for usage and documentation of paramater types.
 */
var runStringHandlers = function runStringHandlers(declarations, /* : OrderedElements */
stringHandlers, /* : StringHandlers */
selectorHandlers /* : SelectorHandler[] */
) /* : void */{
    if (!stringHandlers) {
        return;
    }

    var stringHandlerKeys = Object.keys(stringHandlers);
    for (var i = 0; i < stringHandlerKeys.length; i++) {
        var key = stringHandlerKeys[i];
        if (declarations.has(key)) {
            // A declaration exists for this particular string handler, so we
            // need to let the string handler interpret the declaration first
            // before proceeding.
            //
            // TODO(emily): Pass in a callback which generates CSS, similar to
            // how our selector handlers work, instead of passing in
            // `selectorHandlers` and have them make calls to `generateCSS`
            // themselves. Right now, this is impractical because our string
            // handlers are very specialized and do complex things.
            declarations.set(key, stringHandlers[key](declarations.get(key), selectorHandlers),

            // Preserve order here, since we are really replacing an
            // unprocessed style with a processed style, not overriding an
            // earlier style
            false);
        }
    }
};

var transformRule = function transformRule(key, /* : string */
value, /* : string */
transformValue /* : function */
) {
    return (/* : string */(0, _util.kebabifyStyleName)(key) + ':' + transformValue(key, value) + ';'
    );
};

/**
 * Generate a CSS ruleset with the selector and containing the declarations.
 *
 * This function assumes that the given declarations don't contain any special
 * children (such as media queries, pseudo-selectors, or descendant styles).
 *
 * Note that this method does not deal with nesting used for e.g.
 * psuedo-selectors or media queries. That responsibility is left to  the
 * `generateCSS` function.
 *
 * @param {string} selector: the selector associated with the ruleset
 * @param {Object} declarations: a map from camelCased CSS property name to CSS
 *     property value.
 * @param {Object.<string, function>} stringHandlers: a map from camelCased CSS
 *     property name to a function which will map the given value to the value
 *     that is output.
 * @param {bool} useImportant: A boolean saying whether to append "!important"
 *     to each of the CSS declarations.
 * @returns {string} A string of raw CSS.
 *
 * Examples:
 *
 *    generateCSSRuleset(".blah", { color: "red" })
 *    -> ".blah{color: red !important;}"
 *    generateCSSRuleset(".blah", { color: "red" }, {}, false)
 *    -> ".blah{color: red}"
 *    generateCSSRuleset(".blah", { color: "red" }, {color: c => c.toUpperCase})
 *    -> ".blah{color: RED}"
 *    generateCSSRuleset(".blah:hover", { color: "red" })
 *    -> ".blah:hover{color: red}"
 */
var generateCSSRuleset = function generateCSSRuleset(selector, /* : string */
declarations, /* : OrderedElements */
stringHandlers, /* : StringHandlers */
useImportant, /* : boolean */
selectorHandlers /* : SelectorHandler[] */
) /* : string */{
    // Mutates declarations
    runStringHandlers(declarations, stringHandlers, selectorHandlers);

    var originalElements = _extends({}, declarations.elements);

    // NOTE(emily): This mutates handledDeclarations.elements.
    var prefixedElements = prefixAll(declarations.elements);

    var elementNames = Object.keys(prefixedElements);
    if (elementNames.length !== declarations.keyOrder.length) {
        // There are some prefixed values, so we need to figure out how to sort
        // them.
        //
        // Loop through prefixedElements, looking for anything that is not in
        // sortOrder, which means it was added by prefixAll. This means that we
        // need to figure out where it should appear in the sortOrder.
        for (var i = 0; i < elementNames.length; i++) {
            if (!originalElements.hasOwnProperty(elementNames[i])) {
                // This element is not in the sortOrder, which means it is a prefixed
                // value that was added by prefixAll. Let's try to figure out where it
                // goes.
                var originalStyle = undefined;
                if (elementNames[i][0] === 'W') {
                    // This is a Webkit-prefixed style, like "WebkitTransition". Let's
                    // find its original style's sort order.
                    originalStyle = elementNames[i][6].toLowerCase() + elementNames[i].slice(7);
                } else if (elementNames[i][1] === 'o') {
                    // This is a Moz-prefixed style, like "MozTransition". We check
                    // the second character to avoid colliding with Ms-prefixed
                    // styles. Let's find its original style's sort order.
                    originalStyle = elementNames[i][3].toLowerCase() + elementNames[i].slice(4);
                } else {
                    // if (elementNames[i][1] === 's') {
                    // This is a Ms-prefixed style, like "MsTransition".
                    originalStyle = elementNames[i][2].toLowerCase() + elementNames[i].slice(3);
                }

                if (originalStyle && originalElements.hasOwnProperty(originalStyle)) {
                    var originalIndex = declarations.keyOrder.indexOf(originalStyle);
                    declarations.keyOrder.splice(originalIndex, 0, elementNames[i]);
                } else {
                    // We don't know what the original style was, so sort it to
                    // top. This can happen for styles that are added that don't
                    // have the same base name as the original style.
                    declarations.keyOrder.unshift(elementNames[i]);
                }
            }
        }
    }

    var transformValue = useImportant === false ? _util.stringifyValue : _util.stringifyAndImportantifyValue;

    var rules = [];
    for (var i = 0; i < declarations.keyOrder.length; i++) {
        var key = declarations.keyOrder[i];
        var value = prefixedElements[key];
        if (Array.isArray(value)) {
            // inline-style-prefixer returns an array when there should be
            // multiple rules for the same key. Here we flatten to multiple
            // pairs with the same key.
            for (var j = 0; j < value.length; j++) {
                rules.push(transformRule(key, value[j], transformValue));
            }
        } else {
            rules.push(transformRule(key, value, transformValue));
        }
    }

    if (rules.length) {
        return selector + '{' + rules.join("") + '}';
    } else {
        return "";
    }
};
exports.generateCSSRuleset = generateCSSRuleset;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var MAP_EXISTS = typeof Map !== 'undefined';

var OrderedElements = (function () {
    /* ::
    elements: {[string]: any};
    keyOrder: string[];
    */

    function OrderedElements() {
        _classCallCheck(this, OrderedElements);

        this.elements = {};
        this.keyOrder = [];
    }

    _createClass(OrderedElements, [{
        key: 'forEach',
        value: function forEach(callback /* : (string, any) => void */) {
            for (var i = 0; i < this.keyOrder.length; i++) {
                // (value, key) to match Map's API
                callback(this.elements[this.keyOrder[i]], this.keyOrder[i]);
            }
        }
    }, {
        key: 'set',
        value: function set(key, /* : string */value, /* : any */shouldReorder /* : ?boolean */) {
            var _this = this;

            if (!this.elements.hasOwnProperty(key)) {
                this.keyOrder.push(key);
            } else if (shouldReorder) {
                var index = this.keyOrder.indexOf(key);
                this.keyOrder.splice(index, 1);
                this.keyOrder.push(key);
            }

            if (value == null) {
                this.elements[key] = value;
                return;
            }

            if (MAP_EXISTS && value instanceof Map || value instanceof OrderedElements) {
                var _ret = (function () {
                    // We have found a nested Map, so we need to recurse so that all
                    // of the nested objects and Maps are merged properly.
                    var nested = _this.elements.hasOwnProperty(key) ? _this.elements[key] : new OrderedElements();
                    value.forEach(function (value, key) {
                        nested.set(key, value, shouldReorder);
                    });
                    _this.elements[key] = nested;
                    return {
                        v: undefined
                    };
                })();

                if (typeof _ret === 'object') return _ret.v;
            }

            if (!Array.isArray(value) && typeof value === 'object') {
                // We have found a nested object, so we need to recurse so that all
                // of the nested objects and Maps are merged properly.
                var nested = this.elements.hasOwnProperty(key) ? this.elements[key] : new OrderedElements();
                var keys = Object.keys(value);
                for (var i = 0; i < keys.length; i += 1) {
                    nested.set(keys[i], value[keys[i]], shouldReorder);
                }
                this.elements[key] = nested;
                return;
            }

            this.elements[key] = value;
        }
    }, {
        key: 'get',
        value: function get(key /* : string */) /* : any */{
            return this.elements[key];
        }
    }, {
        key: 'has',
        value: function has(key /* : string */) /* : boolean */{
            return this.elements.hasOwnProperty(key);
        }
    }, {
        key: 'addStyleType',
        value: function addStyleType(styleType /* : any */) /* : void */{
            var _this2 = this;

            if (MAP_EXISTS && styleType instanceof Map || styleType instanceof OrderedElements) {
                styleType.forEach(function (value, key) {
                    _this2.set(key, value, true);
                });
            } else {
                var keys = Object.keys(styleType);
                for (var i = 0; i < keys.length; i++) {
                    this.set(keys[i], styleType[keys[i]], true);
                }
            }
        }
    }]);

    return OrderedElements;
})();

exports['default'] = OrderedElements;
module.exports = exports['default'];

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMember;
/* unused harmony export updateProfile */
/* unused harmony export addProfileArrayKey */
/* unused harmony export removeProfileArrayKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Api__ = __webpack_require__(18);


function getMember(id, accessToken) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])('member/' + id, 'GET', null, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_MEMBER_BY_ID',
            payload: response.data
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function updateProfile(fields) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch({
        type: 'UPDATE_PROFILE',
        payload: fields
      });

      resolve();
    });
  };
}

function addProfileArrayKey(name, id) {
  var action = void 0;

  switch (name) {
    default:
      action = 'ADD_PROFILE_NEED';
      break;
    case 'needs':
      action = 'ADD_PROFILE_NEED';
      break;
    case 'interests':
      action = 'ADD_PROFILE_INTEREST';
      break;
  }

  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch({
        type: action,
        payload: id
      });

      resolve();
    });
  };
}

function removeProfileArrayKey(name, id) {
  var action = void 0;

  switch (name) {
    default:
      action = 'REMOVE_PROFILE_NEED';
      break;
    case 'needs':
      action = 'REMOVE_PROFILE_NEED';
      break;
    case 'interests':
      action = 'REMOVE_PROFILE_INTEREST';
      break;
  }

  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch({
        type: action,
        payload: id
      });

      resolve();
    });
  };
}

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = search;
/* unused harmony export updateSearch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Api__ = __webpack_require__(18);


function search() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var interests = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var district = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var suburb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var breed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var needs = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var page = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var endpoint = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'home/search';
  var sort = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  var accessToken = arguments[9];
  var nearestMe = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : false;
  var maxDegrees = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : 5;

  // eslint-disable-line
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Api__["b" /* request */])(endpoint, 'POST', {
        query: query,
        interests: interests,
        needs: needs,
        district: district,
        suburb: suburb,
        breed: breed,
        page: page,
        sort: sort,
        nearestMe: nearestMe,
        maxDegrees: maxDegrees
      }, {
        Authorization: 'Bearer ' + accessToken
      }).then(function (response) {
        if (response.status === 200) {
          dispatch({
            type: 'SEARCH_RESULTS',
            payload: response.data
          });
          dispatch({
            type: 'SAVE_SEARCH',
            payload: {
              query: query,
              interests: interests,
              needs: needs,
              district: district,
              suburb: suburb,
              breeds: breed,
              page: page,
              sort: sort,
              nearestMe: nearestMe,
              maxDegrees: maxDegrees
            }
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, function (err) {
        reject(err);
      });
    });
  };
}

function updateSearch(fields) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch({
        type: 'UPDATE_SEARCH',
        payload: fields
      });

      resolve();
    });
  };
}

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_stripe_elements__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable */





var CheckoutForm = function (_Component) {
  _inherits(CheckoutForm, _Component);

  function CheckoutForm() {
    _classCallCheck(this, CheckoutForm);

    return _possibleConstructorReturn(this, (CheckoutForm.__proto__ || Object.getPrototypeOf(CheckoutForm)).apply(this, arguments));
  }

  _createClass(CheckoutForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onRef(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onRef(undefined);
    }
  }, {
    key: 'verifyCard',
    value: function verifyCard() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.props.stripe.createToken({
          first_name: _this2.props.first_name,
          last_name: _this2.props.last_name
        }).then(function (response) {
          console.log('Received Stripe token:', response);
          _this2.props.handler(response).then(function () {
            resolve(response);
          });
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        { style: { width: '100%' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_stripe_elements__["CardElement"], {
          onChange: this.props.cardChangedHandler.bind(this),
          style: {
            base: {
              fontSize: '18px',
              backgroundColor: __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].white
            }
          } })
      );
    }
  }]);

  return CheckoutForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_stripe_elements__["injectStripe"])(CheckoutForm));

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cleave_js_react__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cleave_js_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_cleave_js_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ErrorContainer__ = __webpack_require__(22);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var DateField = function (_Component) {
  _inherits(DateField, _Component);

  function DateField(props) {
    var _input;

    _classCallCheck(this, DateField);

    var _this = _possibleConstructorReturn(this, (DateField.__proto__ || Object.getPrototypeOf(DateField)).call(this, props));

    _this.assignClasses = _this.assignClasses.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.onKeyDown = _this.props.onKeyDown.bind(_this);

    _this.state = {
      error: _this.props.error,
      remaining: _this.props.limit
    };

    _this.styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
      field: _defineProperty({
        width: '50%',
        marginBottom: 15,
        padding: '0 5px'

      }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
        width: '100%'
      }),
      field_fw: {
        width: '100%'
      },
      remaining: {
        marginTop: 8,
        textAlign: 'right',
        color: '#828282',
        fontSize: 14,
        fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
        fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_primary
      },
      label: {
        display: 'block',
        marginBottom: 9,
        fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
        fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_primary,
        fontSize: 14,
        color: '#828282'
      },
      label_error: {
        color: '#E85E5E'
      },
      input: (_input = {
        width: '100%',
        height: 50,
        padding: '0 16px',
        fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
        fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_primary,
        fontSize: 15,
        color: '#000e1f',
        borderRadius: 3,
        backgroundColor: '#fff',
        border: '1px solid #e4e4e4',
        outline: 'none',
        transition: 'all 300ms'

      }, _defineProperty(_input, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
        fontSize: 16
      }), _defineProperty(_input, '::placeholder', {
        fontSize: 14,
        color: '#bbb'
      }), _defineProperty(_input, ':focus', {
        borderColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].turquoise
      }), _input),
      input_disabled: {
        backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].light_grey,
        color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].grey
      },
      input_error: {
        color: '#E85E5E',
        borderColor: '#E85E5E',
        borderWidth: 2,
        borderRadius: '3px 3px 0 0',

        '::placeholder': {
          color: '#E85E5E'
        },

        ':focus': {
          borderColor: '#E85E5E'
        }
      },
      textarea: {
        display: 'block',
        height: _this.props.height ? _this.props.height : 114,
        padding: 16,
        resize: 'none'
      }
    });
    return _this;
  }

  _createClass(DateField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.focus) {
        this.inputField.focus();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this.props.error !== this.state.error) {
        setTimeout(function () {
          _this2.setState({
            error: _this2.props.error
          });
        }, 200);
      }
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(event) {
      this.props.onKeyDown(event);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      if (this.props.required && event.target.value.length === 0) {
        this.setState({
          error: 'This field is required'
        });
      }

      if (this.props.handler && typeof this.props.handler === 'function') {
        this.props.handler(this.props.name, event.target.value);
      }
    }
  }, {
    key: 'assignClasses',
    value: function assignClasses() {
      this.fieldClasses = [this.styles.field, this.props.fullWidth ? this.styles.field_fw : null];

      this.labelClasses = [this.styles.label, this.state.error ? this.styles.label_error : null];

      this.inputClasses = [this.styles.input, this.state.error ? this.styles.input_error : null, this.props.disabled ? this.styles.input_disabled : null];

      this.textAreaClasses = [this.inputClasses, this.styles.textarea];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      this.assignClasses();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.fieldClasses, this.props.styles) },
        this.props.label ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          { htmlFor: this.props.id, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.labelClasses) },
          this.props.label
        ) : null,
        this.props.textArea ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', {
          id: this.props.id,
          name: this.props.name,
          ref: function ref(input) {
            _this3.inputField = input;
          },
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.textAreaClasses),
          defaultValue: this.props.value,
          value: this.props.value,
          placeholder: this.props.placeholder,
          maxLength: this.props.limit,
          height: this.props.height,
          onChange: this.handleChange
        }) : null,
        this.props.creditCardNum ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_cleave_js_react___default.a, {
          onChange: this.handleChange,
          placeholder: this.props.placeholder,
          options: {
            creditCard: true,
            delimiter: ' - '
          },
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.inputClasses)
        }) : null,
        this.props.creditCardExp ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_cleave_js_react___default.a, {
          onChange: this.handleChange,
          placeholder: this.props.placeholder,
          options: {
            date: true,
            delimiter: ' / ',
            datePattern: ['m', 'y']
          },
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.inputClasses)
        }) : null,
        this.props.creditCardCVC ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_cleave_js_react___default.a, {
          onChange: this.handleChange,
          placeholder: this.props.placeholder,
          options: {
            blocks: [3],
            uppercase: true
          },
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.inputClasses)
        }) : null,
        !this.props.creditCardNum && !this.props.textArea && !this.props.creditCardExp && !this.props.creditCardCVC ? // eslint-disable-line
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
          ref: function ref(input) {
            _this3.inputField = input;
          },
          id: this.props.id,
          disabled: this.props.disabled,
          readOnly: this.props.readOnly,
          type: this.props.email ? 'email' : this.props.type,
          name: this.props.name,
          defaultValue: this.props.value,
          value: this.props.value,
          onKeyDown: this.onKeyDown,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.inputClasses),
          placeholder: this.props.placeholder,
          onChange: this.handleChange
        }) : null,
        this.state.error ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ErrorContainer__["a" /* default */], { message: this.state.error }) : null,
        this.props.showRemaining && this.props.limit && this.props.value ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.styles.remaining) },
          this.props.value.length,
          ' / ',
          this.props.limit
        ) : null
      );
    }
  }]);

  return DateField;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DateField);


DateField.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  error: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number,
  limit: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number,
  textArea: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  email: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  fullWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  showRemaining: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  creditCardNum: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  creditCardExp: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  creditCardCVC: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  focus: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object])),
  handler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func
};

DateField.defaultProps = {
  styles: null,
  label: null,
  disabled: false,
  readOnly: false,
  placeholder: null,
  error: null,
  type: 'text',
  focus: false,
  textArea: false,
  email: false,
  limit: null,
  required: false,
  height: null,
  fullWidth: false,
  showRemaining: false,
  creditCardNum: false,
  creditCardExp: false,
  creditCardCVC: false,
  handler: function handler() {},
  onKeyDown: function onKeyDown() {}
};

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var styles = void 0;

var EditProfileSummary = function (_Component) {
  _inherits(EditProfileSummary, _Component);

  function EditProfileSummary() {
    _classCallCheck(this, EditProfileSummary);

    return _possibleConstructorReturn(this, (EditProfileSummary.__proto__ || Object.getPrototypeOf(EditProfileSummary)).apply(this, arguments));
  }

  _createClass(EditProfileSummary, [{
    key: 'render',
    value: function render() {
      var profileLink = '/' + (this.props.dog ? 'pooch' : 'profile') + '/' + this.props.id;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.content_container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.image_container) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.image_wrapper) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
                { to: profileLink },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.image), src: this.props.image_url, alt: 'Profile' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.information_container) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.title) },
              this.props.name
            ),
            this.props.breed ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.subtitle) },
              this.props.breed
            ) : false
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.actions) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
              {
                to: profileLink,
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.action_link, styles.left_action) },
              'View'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
              {
                to: profileLink + '/edit',
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.action_link, styles.right_action) },
              'Edit'
            )
          )
        )
      );
    }
  }]);

  return EditProfileSummary;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (EditProfileSummary);


EditProfileSummary.defaultProps = {
  image_url: null,
  name: null,
  breed: null,
  dog: true
};

EditProfileSummary.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number.isRequired,
  image_url: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  breed: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  dog: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool
};

styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    position: 'relative',
    display: 'flex',
    width: '750',
    height: 100,
    margin: '20px auto',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    height: 'auto',
    padding: '15px 0'
  }),
  content_container: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    paddingLeft: 20,
    paddingRight: 20
  },
  image_container: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    flexShrink: 0
  },
  image_wrapper: {
    zIndex: 1,
    width: 60,
    height: 60,
    borderRadius: 30,
    borderWidth: 2,
    borderColor: '#fff',
    borderStyle: 'solid',
    backgroundColor: '#fff',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset',
    overflow: 'hidden'
  },
  image: {
    zIndex: -1,
    cursor: 'pointer',
    display: 'block',
    height: '100%',
    width: '100%'
  },
  information_container: _defineProperty({
    flex: 6,
    display: 'flex',
    flexDirection: 'column'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    paddingLeft: 20
  }),
  title: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 20,
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].black,
    fontWeight: 'bold'
  },
  subtitle: {
    marginTop: 10,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 15,
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].black
  },
  actions: _defineProperty({
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    flex: 'initial',
    width: '100%',
    justifyContent: 'center',
    marginTop: 15
  }),
  action_link: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_secondary,
    fontSize: 15,
    fontWeight: 'bold',
    height: 40,
    width: 50,
    textTransform: 'uppercase'
  },
  left_action: {
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].black,
    justifyContent: 'flex-start',
    borderRight: '1px solid ' + __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].horizontal_rule_color,
    boxSizing: 'content-box',
    paddingRight: 5
  },
  right_action: {
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary,
    justifyContent: 'flex-end'
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
var _select, _panel, _clear_container;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var styles = void 0;
var ARROW_ASSET = __webpack_require__(317);
var CLOSE_ASSET = __webpack_require__(318);

var JumboSelect = function (_Component) {
  _inherits(JumboSelect, _Component);

  function JumboSelect(props) {
    _classCallCheck(this, JumboSelect);

    var _this = _possibleConstructorReturn(this, (JumboSelect.__proto__ || Object.getPrototypeOf(JumboSelect)).call(this, props));

    _this.toggleOpen = _this.toggleOpen.bind(_this);
    _this.clear = _this.props.clear.bind(_this);
    _this.assignClasses = _this.assignClasses.bind(_this);
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(JumboSelect, [{
    key: 'toggleOpen',
    value: function toggleOpen() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: 'assignClasses',
    value: function assignClasses() {
      this.selectClasses = [styles.select, this.state.isOpen ? styles.select_open : null];

      this.panelClasses = [styles.panel, this.state.isOpen ? styles.panel_open : null, this.props.modifier === 'breeds' ? styles.panel_breeds : null, this.props.modifier === 'needs' ? styles.panel_needs : null, this.props.modifier === 'interests' ? styles.panel_interests : null];

      this.iconClasses = [styles.select_icon, this.state.isOpen || this.props.selected > 0 ? styles.select_icon_open : null];

      this.arrowClasses = [styles.select_arrow, this.state.isOpen ? styles.select_arrow_open : null];

      this.labelClasses = [!this.props.selected && !this.state.isOpen ? styles.select_placeholder : null];
    }
  }, {
    key: 'render',
    value: function render() {
      this.assignClasses();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.select_container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              role: 'button',
              tabIndex: 0,
              className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.selectClasses),
              onClick: this.toggleOpen
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.labelClasses) },
              this.props.defaultAll && !this.props.selected ? 'All ' : null,
              ' ',
              this.props.label,
              ' ',
              this.props.selected ? ' (' + this.props.selected + ')' : null
            ),
            this.props.selected !== 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              {
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.clear_container),
                title: 'Clear value',
                'aria-label': 'Clear value',
                onClick: this.clear,
                role: 'button',
                tabIndex: '0' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.button) },
                '\xD7'
              )
            ) : ''
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: this.props.icon, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.iconClasses) }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: ARROW_ASSET, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.arrowClasses) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.panelClasses) },
          __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].isMobile ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
            role: 'button',
            tabIndex: 0,
            className: this.state.isOpen ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.select_close) : null,
            onClick: this.toggleOpen
          }) : null,
          __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].isMobile ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.heading) },
            this.props.label
          ) : null,
          this.props.children
        ),
        !__WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].isMobile ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          role: 'button',
          tabIndex: 0,
          className: this.state.isOpen ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.select_close) : null,
          onClick: this.toggleOpen
        }) : null
      );
    }
  }]);

  return JumboSelect;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (JumboSelect);


JumboSelect.defaultProps = {
  defaultAll: false,
  modifier: null,
  selected: 0
};

JumboSelect.propTypes = {
  defaultAll: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  modifier: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].node).isRequired,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number,
  clear: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func //eslint-disable-line
};

styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  select_container: _defineProperty({
    position: 'relative',
    zIndex: 2

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  heading: {
    marginTop: 30,
    marginBottom: 30,
    lineHeight: 2.09,
    textAlign: 'center',
    fontSize: 28,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_heading
  },
  select: (_select = {
    display: 'flex',
    alignItems: 'center',
    height: 50,
    width: 180,
    padding: '0 50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 15,
    color: '#000e1f',
    border: '1px solid #e4e4e4',
    borderRadius: 3,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    appearance: 'none',
    cursor: 'pointer',
    outline: 'none',
    transition: 'all 300ms'

  }, _defineProperty(_select, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }), _defineProperty(_select, ':hover', {
    boxShadow: '0 1px 0 rgba(0, 0, 0, 0.06)'
  }), _select),
  select_open: {
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    backgroundColor: '#031a37'
  },
  select_close: _defineProperty({
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 4,
    height: '100vh',
    width: '100vw',
    content: '""'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    position: 'absolute',
    top: 15,
    right: 15,
    left: 'auto',
    zIndex: 6,
    height: 20,
    width: 20,
    backgroundImage: 'url(\'' + CLOSE_ASSET + '\')',
    backgroundSize: 'cover'
  }),
  select_placeholder: {
    color: '#828282'
  },
  select_icon: {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'block',
    height: 50,
    width: 50,
    pointerEvents: 'none',
    fill: '#D0D0D0',
    transition: 'fill 300ms'
  },
  select_icon_open: {
    fill: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary
  },
  select_arrow: {
    position: 'absolute',
    top: 0,
    right: 20,
    display: 'flex',
    alignItems: 'center',
    height: 50,
    width: 9,
    pointerEvents: 'none',
    transition: 'all 300ms'
  },
  select_arrow_open: {
    transform: 'rotateX(180deg)'
  },
  panel: (_panel = {
    position: 'absolute',
    top: 80,
    left: '50%',
    zIndex: 5,
    transform: 'translateX(-50%)',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    width: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].container_width,
    padding: '39px 0 34px',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.19)',
    border: 'solid 1px #e2e2e2',
    opacity: 0,
    pointerEvents: 'none',
    transition: 'all 300ms'

  }, _defineProperty(_panel, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    position: 'absolute',
    top: -121,
    left: -15,
    height: '100vh',
    width: '100vw',
    padding: '0 5px',
    paddingBottom: 30,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    flexDirection: 'column',
    flexWrap: 'initial',
    transform: 'none',
    overflow: 'scroll',
    justifyContent: 'flex-start'
  }), _defineProperty(_panel, ':before', _defineProperty({
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    height: 0,
    width: 0,
    marginLeft: -17,
    border: 'solid transparent',
    borderWidth: 17,
    borderColor: 'transparent',
    borderBottomColor: '#e2e2e2',
    pointerEvents: 'none',
    content: '""'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    display: 'none'
  })), _defineProperty(_panel, ':after', _defineProperty({
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    height: 0,
    width: 0,
    marginLeft: -16,
    border: 'solid transparent',
    borderWidth: 16,
    borderColor: 'transparent',
    borderBottomColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    pointerEvents: 'none',
    content: '""'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    display: 'none'
  })), _panel),
  panel_breeds: {
    ':before': {
      transform: 'translateX(-90px)'
    },
    ':after': {
      transform: 'translateX(-90px)'
    }
  },
  panel_interests: {
    ':before': {
      transform: 'translateX(145px)'
    },
    ':after': {
      transform: 'translateX(145px)'
    }
  },
  panel_needs: {
    ':before': {
      transform: 'translateX(220px)'
    },
    ':after': {
      transform: 'translateX(220px)'
    }
  },
  panel_open: {
    top: 70,
    opacity: 1,
    pointerEvents: 'initial'
  },
  clear_container: (_clear_container = {
    animation: 'Select-animation-fadeIn 200ms',
    color: '#999',
    cursor: 'pointer',
    display: 'table-cell',
    position: 'absolute',
    textAlign: 'center',
    verticalAlign: 'middle',
    width: '17px',
    right: 36,
    transition: 'color 300ms',
    marginLeft: '77px',
    fontSize: 18

  }, _defineProperty(_clear_container, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    marginLeft: '157px'
  }), _defineProperty(_clear_container, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].iphone_plus_query, {
    marginLeft: '196px'
  }), _clear_container),
  clear_button: {
    display: 'inline-block',
    fontSize: '18px',
    lineHeight: '1'
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ANIMATION = __webpack_require__(601);

var Loader = function (_Component) {
  _inherits(Loader, _Component);

  function Loader() {
    _classCallCheck(this, Loader);

    return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
  }

  _createClass(Loader, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.overlay) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
            src: ANIMATION,
            alt: 'Loading',
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.image),
            width: 150,
            height: 150 }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.label) },
            this.props.text ? this.props.text : 'Fetching...'
          )
        )
      );
    }
  }]);

  return Loader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Loader);


Loader.defaultProps = {
  text: 'Fetching...'
};

Loader.propTypes = {
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string
};

var bounceKeyframes = {
  from: {
    transform: 'scale(2)',
    animationTimingFunction: 'ease-in'
  },

  to: {
    transform: 'scale(0.8)',
    animationTimingFunction: 'cubic-bezier(0, 0, 0, 1)'
  }
};

var bounceShadowKeyframes = {
  from: {
    transform: 'scale(2.5, 2.6) translateY(-50%)',
    animationTimingFunction: 'ease-in'
  },
  to: {
    transform: 'scale(0.5) translateY(0)',
    animationTimingFunction: 'cubic-bezier(0, 0, 0, 1)'
  }
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 500,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100vw'
  },
  container: {
    padding: '50px 60px 50px',
    width: 300,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
    borderRadius: 5,
    boxShadow: '0 3px 4px 0 rgba(0, 0, 0, 0.25)',
    border: 'solid 1px #e4e4e4'
  },
  image: {},
  label: {
    display: 'block',
    marginTop: 50,
    textAlign: 'center',
    fontSize: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_heading
  },
  ball: {
    position: 'relative',
    width: 32,
    height: 32,
    borderRadius: '50%',
    zIndex: 0,
    outline: 'none',

    ':after': {
      content: '""',
      position: 'absolute',
      display: 'block',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      borderRadius: '50%',
      boxShadow: 'inset 0 -8px 0 0 rgba(0,0,0, 0.2)',
      background: '#56C5FF',
      zIndex: 1,
      animationName: bounceKeyframes,
      animationDuration: '600ms',
      animationIterationCount: 'infinite',
      animationDirection: 'alternate'
    },

    ':before': {
      content: '""',
      position: 'absolute',
      display: 'block',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      background: 'rgba(0,0,0, 0.05)',
      animationName: bounceShadowKeyframes,
      animationDuration: '600ms',
      animationIterationCount: 'infinite',
      animationDirection: 'alternate',
      zIndex: -10
    }
  }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_facebook_login__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_facebook_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_facebook_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Button__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CheckboxField__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TextField__ = __webpack_require__(11);
var _forgotten_password, _login_button_contain, _stay_logged_in_conta;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var CLOSE_ICON = __webpack_require__(319);

var DEFAULT_TILE = 'Log in';

var styles = void 0;

var LoginModal = function (_Component) {
  _inherits(LoginModal, _Component);

  function LoginModal(props) {
    _classCallCheck(this, LoginModal);

    var _this = _possibleConstructorReturn(this, (LoginModal.__proto__ || Object.getPrototypeOf(LoginModal)).call(this, props));

    _this.handleClose = props.closeHandler.bind(_this);
    _this.setValue = _this.updateField.bind(_this);
    _this.handleSignUp = _this.redirectToSignUp.bind(_this);
    _this.handleEnter = _this.loginFormKeyDown.bind(_this);
    _this.facebookCallback = _this.facebookResponse.bind(_this);

    _this.state = {
      email: '',
      password: '',
      stay_logged_in: false
    };
    return _this;
  }

  _createClass(LoginModal, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // fixes cursor float bug - modal full width on mobile
      if (this.props.open === true) {
        document.body.classList.add('scroll-locked');
      } else {
        document.body.classList.remove('scroll-locked');
      }
    }
  }, {
    key: 'loginFormKeyDown',
    value: function loginFormKeyDown(event) {
      if (this.state.email && this.state.password && event.keyCode === 13) {
        this.attemptLogin(this.props.history);
      }
    }
  }, {
    key: 'attemptLogin',
    value: function attemptLogin(history) {
      var _this2 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
        loading: true,
        loading_text: 'Fetching...'
      })).then(function () {
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__actions_user__["e" /* login */])(_this2.state.email, _this2.state.password, _this2.state.stay_logged_in)).then(function (response) {
          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
            loading: false,
            login_modal_open: false
          }));

          if (response.verified === false) {
            history.push('/join/verify');
          } else if (response.completed_membership === true) {
            var searchParams = new URLSearchParams(history.location.search);
            var backURL = searchParams.get('backURL');
            if (backURL) {
              history.push('/' + backURL);
            } else {
              history.push('/find');
            }
          } else {
            history.push('/join/profile');
          }
        }, function (err) {
          if (err === 'verify') {
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
              loading: false,
              login_modal_open: false
            }));
            history.push('/join/verify');
          } else {
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
              loading: false
            }));

            _this2.setState({
              error: 'Your email or password is incorrect.'
            });
          }
        });
      });
    }
  }, {
    key: 'redirectToSignUp',
    value: function redirectToSignUp() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
        loading: false,
        login_modal_open: false
      }));
    }
  }, {
    key: 'updateField',
    value: function updateField(key, value) {
      this.setState(_defineProperty({}, key, value));
    }
  }, {
    key: 'facebookResponse',
    value: function facebookResponse(response) {
      var _this3 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
        loading: true,
        loading_text: 'Fetching...'
      })).then(function () {
        _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__actions_user__["f" /* facebookLogin */])(response.accessToken)).then(function () {
          _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
            loading: false,
            login_modal_open: false
          }));

          _this3.props.history.push('/find');
        }, function (err) {
          _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));

          _this3.setState({
            error: 'Your email or password is incorrect.'
          });

          console.log(err); // eslint-disable-line no-console
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var APP_ID = this.props.facebookAppId;


      var LoginButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["g" /* withRouter */])(function (_ref) {
        var history = _ref.history;
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Button__["a" /* default */], {
          title: 'Log in',
          theme: 'black',
          handler: function handler() {
            _this4.attemptLogin(history);
          },
          styles: styles.full_width_button
        });
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_modal___default.a,
        {
          isOpen: this.props.open,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container),
          onRequestClose: this.handleClose,
          style: {
            overlay: {
              backgroundColor: 'rgba(0,0,0,0.67)',
              zIndex: 101,
              display: 'flex'
            }
          },
          contentLabel: this.props.title && this.props.title.length > 0 ? this.props.title : DEFAULT_TILE
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modal_wrapper) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.header) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'h2',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.title) },
              'Log in'
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              {
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.close_icon),
                onClick: this.handleClose,
                role: 'button',
                tabIndex: 0
              },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { src: CLOSE_ICON, alt: 'Close modal' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.body) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_facebook_login___default.a, {
              appId: APP_ID,
              containerStyle: {
                width: '100%'
              },
              autoLoad: false,
              isMobile: false,
              fields: 'first_name,last_name,email,picture',
              callback: this.facebookCallback,
              cssClass: 'facebook-login-button',
              textButton: false,
              icon: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Button__["a" /* default */], {
                title: 'Log in with Facebook',
                theme: 'facebook',
                styles: styles.full_width_button
              })
            }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.seperator_container) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.seperator_text) },
                'Or'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__TextField__["a" /* default */], {
              id: 'email',
              name: 'email',
              email: true,
              placeholder: 'Email',
              fullWidth: true,
              onKeyDown: this.handleEnter,
              error: this.state.error,
              value: this.state.email,
              handler: this.setValue
            }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__TextField__["a" /* default */], {
              id: 'password',
              name: 'password',
              type: 'password',
              placeholder: 'Password',
              fullWidth: true,
              onKeyDown: this.handleEnter,
              value: this.state.password,
              handler: this.setValue
            }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.actions_container) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_router_dom__["e" /* Link */],
                {
                  to: '/forgot',
                  onClick: this.handleSignUp,
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.forgotten_password)
                },
                'Forgotten password?'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.login_button_container) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(LoginButton, null)
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.stay_logged_in_container) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CheckboxField__["a" /* default */], {
                  id: 'stay_logged_in',
                  name: 'stay_logged_in',
                  label: 'Automatically log me in on this device',
                  value: this.state.stay_logged_in,
                  handler: this.setValue
                })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.footer) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.sign_up_container) },
            'Not a member?',
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_router_dom__["e" /* Link */],
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.sign_up_link), to: '/join', onClick: this.handleSignUp },
              'Sign up here'
            )
          )
        )
      );
    }
  }]);

  return LoginModal;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

LoginModal.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  facebookAppId: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string
};

LoginModal.defaultProps = {
  open: false,
  closeHandler: function closeHandler() {},
  title: DEFAULT_TILE
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    facebookAppId: state.appdata && state.appdata.apiKeys && state.appdata.apiKeys.facebook_app_id || ''
  };
};

styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 590,
    maxWidth: '100vw',
    minHeight: 640,
    maxHeight: '100vh',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].white,
    borderRadius: 5,
    overflow: 'hidden',
    outline: 'none',
    margin: 'auto auto'
  }, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].mobile_query, {
    top: 0,
    left: 0,
    borderRadius: 0,
    width: '100%',
    height: '100%'
  }),
  modal_wrapper: _defineProperty({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: 600 - 100,
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 100px'
  }, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0px 20px 180px'
  }),
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px 0px'
  },
  title: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 30,
    fontWeight: '900'
  },
  close_icon: {
    position: 'absolute',
    right: 15,
    top: 15,
    outline: 'none',
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6
    }
  },
  full_width_button: {
    width: '100%',
    minHeight: 50
  },
  full_width: {
    width: '100%'
  },
  body: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  },
  seperator_container: {
    display: 'flex',
    height: 25,
    margin: '25px auto',
    alignItems: 'center',
    justifyContent: 'center',
    ':after': {
      content: "' '",
      position: 'absolute',
      width: '100%',
      height: 1,
      backgroundColor: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].horizontal_rule_color
    }
  },
  seperator_text: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_family_primary,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].white,
    zIndex: 10,
    padding: 15
  },
  actions_container: _defineProperty({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '100%'
  }, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].mobile_query, {
    flexWrap: 'wrap'
  }),
  footer: _defineProperty({
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    bottom: 0,
    height: 100,
    width: '100%',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].light_grey
  }, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].mobile_query, {
    height: 'auto',
    padding: '20px 0'
  }),
  sign_up_container: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 16
  },
  sign_up_link: {
    display: 'inline',
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_family_secondary,
    letterSpacing: 1,
    marginLeft: 5,
    textTransform: 'uppercase',
    fontWeight: 'bold'
  },
  forgotten_password: (_forgotten_password = {
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14
  }, _defineProperty(_forgotten_password, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].desktop_query, {
    flex: 1
  }), _defineProperty(_forgotten_password, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    order: 2,
    textAlign: 'center',
    marginTop: '1rem',
    marginBottom: '1rem'
  }), _forgotten_password),
  login_button_container: (_login_button_contain = {}, _defineProperty(_login_button_contain, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].desktop_query, {
    flex: 1
  }), _defineProperty(_login_button_contain, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }), _login_button_contain),
  stay_logged_in_container: (_stay_logged_in_conta = {}, _defineProperty(_stay_logged_in_conta, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].desktop_query, {
    width: '100%',
    marginTop: '.8rem'
  }), _defineProperty(_stay_logged_in_conta, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    order: 3
  }), _stay_logged_in_conta)
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(LoginModal));

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Reviews = function (_Component) {
  _inherits(Reviews, _Component);

  function Reviews() {
    _classCallCheck(this, Reviews);

    return _possibleConstructorReturn(this, (Reviews.__proto__ || Object.getPrototypeOf(Reviews)).apply(this, arguments));
  }

  _createClass(Reviews, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.notification) },
        this.props.children
      );
    }
  }]);

  return Reviews;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Reviews);


Reviews.defaultProps = {};

Reviews.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].node).isRequired, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object]).isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  notification: _defineProperty({
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 50,
    width: '100vw',
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
    fontSize: 14,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_primary,
    backgroundColor: '#16345a'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    height: 'auto',
    padding: 15,
    flexWrap: 'wrap',
    lineHeight: 1.7,
    zIndex: 99
  })
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ViewProfileCard = function (_Component) {
  _inherits(ViewProfileCard, _Component);

  function ViewProfileCard() {
    _classCallCheck(this, ViewProfileCard);

    return _possibleConstructorReturn(this, (ViewProfileCard.__proto__ || Object.getPrototypeOf(ViewProfileCard)).apply(this, arguments));
  }

  _createClass(ViewProfileCard, [{
    key: 'getDogImage',
    value: function getDogImage() {
      var dog = this.props;

      if (dog.image_url && dog.image_url.length > 10) {
        return dog.image_url;
      }

      if (dog.profile_photo && dog.profile_photo.length > 10) {
        return dog.profile_photo;
      }

      return '/images/default_dog.jpg';
    }
  }, {
    key: 'render',
    value: function render() {
      var profileLink = '/pooch/' + this.props.id;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.content_container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.image_container) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.image_wrapper) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
                { to: profileLink },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.image), src: this.getDogImage(), alt: 'Profile' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.information_container) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.title) },
              this.props.name
            ),
            this.props.breed ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.subtitle) },
              this.props.breed
            ) : false
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.actions) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.action_link, styles.left_action), to: profileLink },
              'View'
            )
          )
        )
      );
    }
  }]);

  return ViewProfileCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ViewProfileCard);


ViewProfileCard.defaultProps = {
  name: null,
  breed: null
};

ViewProfileCard.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  breed: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    position: 'relative',
    display: 'flex',
    width: 360,
    height: 100,
    margin: '20px auto',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    borderRadius: 3,
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  content_container: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    paddingLeft: 20,
    paddingRight: 20
  },
  image_container: {
    display: 'flex',
    alignItems: 'center',
    flex: 1
  },
  image_wrapper: _defineProperty({
    zIndex: 1,
    width: 60,
    height: 60,
    borderRadius: 30,
    borderWidth: 2,
    borderColor: '#fff',
    borderStyle: 'solid',
    backgroundColor: '#fff',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset',
    overflow: 'hidden'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    marginRight: 15
  }),
  image: {
    zIndex: -1,
    cursor: 'pointer',
    display: 'block',
    height: '100%',
    width: '100%'
  },
  information_container: {
    flex: 2,
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 20,
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].black,
    fontWeight: 'bold'
  },
  subtitle: {
    marginTop: 10,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 15,
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].black
  },
  actions: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  action_link: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_secondary,
    fontSize: 15,
    fontWeight: 'bold',
    height: 40,
    width: 50,
    textTransform: 'uppercase'
  },
  left_action: {
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary,
    justifyContent: 'flex-end',
    boxSizing: 'content-box'
  }
});

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(274);


/***/ }),
/* 105 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tooltip.1b52d399.svg";

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function Request(optsOrUrl) {
  var opts = typeof optsOrUrl === 'string' ? {url: optsOrUrl} : optsOrUrl || {};
  this.method = opts.method ? opts.method.toUpperCase() : 'GET';
  this.url = opts.url;
  this.headers = opts.headers || {};
  this.body = opts.body;
  this.timeout = opts.timeout || 0;
  this.errorOn404 = opts.errorOn404 != null ? opts.errorOn404 : true;
  this.onload = opts.onload;
  this.onerror = opts.onerror;
}

Request.prototype.abort = function() {
  if (this.aborted) return;
  this.aborted = true;
  this.xhr.abort();
  return this;
};

Request.prototype.header = function(name, value) {
  var k;
  for (k in this.headers) {
    if (this.headers.hasOwnProperty(k)) {
      if (name.toLowerCase() === k.toLowerCase()) {
        if (arguments.length === 1) {
          return this.headers[k];
        }

        delete this.headers[k];
        break;
      }
    }
  }
  if (value != null) {
    this.headers[name] = value;
    return value;
  }
};


module.exports = Request;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Request = __webpack_require__(109);
var extractResponseProps = __webpack_require__(111);

function Response(props) {
  this.request = props.request;
  this.xhr = props.xhr;
  this.headers = props.headers || {};
  this.status = props.status || 0;
  this.text = props.text;
  this.body = props.body;
  this.contentType = props.contentType;
  this.isHttpError = props.status >= 400;
}

Response.prototype.header = Request.prototype.header;

Response.fromRequest = function(req) {
  return new Response(extractResponseProps(req));
};


module.exports = Response;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var extend = __webpack_require__(68);

module.exports = function(req) {
  var xhr = req.xhr;
  var props = {request: req, xhr: xhr};

  // Try to create the response from the request. If the request was aborted,
  // accesssing properties of the XHR may throw an error, so we wrap in a
  // try/catch.
  try {
    var lines, i, m, headers = {};
    if (xhr.getAllResponseHeaders) {
      lines = xhr.getAllResponseHeaders().split('\n');
      for (i = 0; i < lines.length; i++) {
        if ((m = lines[i].match(/\s*([^\s]+):\s+([^\s]+)/))) {
          headers[m[1]] = m[2];
        }
      }
    }

    props = extend(props, {
      status: xhr.status,
      contentType: xhr.contentType || (xhr.getResponseHeader && xhr.getResponseHeader('Content-Type')),
      headers: headers,
      text: xhr.responseText,
      body: xhr.response || xhr.responseText
    });
  } catch (err) {}

  return props;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// A "once" utility.
module.exports = function(fn) {
  var result, called = false;
  return function() {
    if (!called) {
      called = true;
      result = fn.apply(this, arguments);
    }
    return result;
  };
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(408);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(409);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 116 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `baseForIn` and `baseForOwn` which iterates
 * over `object` properties returned by `keysFunc` invoking `iteratee` for
 * each property. Iteratee functions may exit iteration early by explicitly
 * returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * Creates a base function for methods like `_.forIn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = baseFor;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var arrayEach = __webpack_require__(410),
    baseEach = __webpack_require__(411),
    bindCallback = __webpack_require__(412),
    isArray = __webpack_require__(69);

/**
 * Creates a function for `_.forEach` or `_.forEachRight`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over an array.
 * @param {Function} eachFunc The function to iterate over a collection.
 * @returns {Function} Returns the new each function.
 */
function createForEach(arrayFunc, eachFunc) {
  return function(collection, iteratee, thisArg) {
    return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
      ? arrayFunc(collection, iteratee)
      : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
  };
}

/**
 * Iterates over elements of `collection` invoking `iteratee` for each element.
 * The `iteratee` is bound to `thisArg` and invoked with three arguments:
 * (value, index|key, collection). Iteratee functions may exit iteration early
 * by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length" property
 * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
 * may be used for object iteration.
 *
 * @static
 * @memberOf _
 * @alias each
 * @category Collection
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [thisArg] The `this` binding of `iteratee`.
 * @returns {Array|Object|string} Returns `collection`.
 * @example
 *
 * _([1, 2]).forEach(function(n) {
 *   console.log(n);
 * }).value();
 * // => logs each value from left to right and returns the array
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
 *   console.log(n, key);
 * });
 * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
 */
var forEach = createForEach(arrayEach, baseEach);

module.exports = forEach;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArguments = __webpack_require__(48),
    isArray = __webpack_require__(69);

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keysIn;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(422),
    getValue = __webpack_require__(428);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(622)(module)))

/***/ }),
/* 122 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(93);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.FacebookLogin=t(require("react")):e.FacebookLogin=t(e.react)}(this,function(e){return function(e){function t(n){if(o[n])return o[n].exports;var r=o[n]={exports:{},id:n,loaded:!1};return e[n].call(r.exports,r,r.exports,t),r.loaded=!0,r.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t,o){e.exports=o(2)},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var n in o)Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n])}return e},c=function(){function e(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,o,n){return o&&e(t.prototype,o),n&&e(t,n),t}}(),u=o(11),l=n(u),f=o(9),d=n(f),p=o(4),h=n(p),b=o(3),y=n(b),g=function(){var e=!1;try{e=!!(window.navigator&&window.navigator.standalone||navigator.userAgent.match("CriOS")||navigator.userAgent.match(/mobile/i))}catch(t){}return e},m=function(e){return["button","input","select","textarea","optgroup","option","fieldset"].indexOf((e+"").toLowerCase())>=0},k=function(e){function t(){var e,o,n,a;r(this,t);for(var c=arguments.length,u=Array(c),l=0;l<c;l++)u[l]=arguments[l];return o=n=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(u))),n.state={isSdkLoaded:!1,isProcessing:!1},n.responseApi=function(e){window.FB.api("/me",{locale:n.props.language,fields:n.props.fields},function(t){s(t,e),n.props.callback(t)})},n.checkLoginState=function(e){n.setStateIfMounted({isProcessing:!1}),e.authResponse?n.responseApi(e.authResponse):n.props.onFailure?n.props.onFailure({status:e.status}):n.props.callback({status:e.status})},n.checkLoginAfterRefresh=function(e){"connected"===e.status?n.checkLoginState(e):window.FB.login(function(e){return n.checkLoginState(e)},!0)},n.click=function(e){if(n.state.isSdkLoaded&&!n.state.isProcessing&&!n.props.isDisabled){n.setState({isProcessing:!0});var t=n.props,o=t.scope,r=t.appId,i=t.onClick,a=t.reAuthenticate,s=t.returnScopes,c=t.redirectUri,u=t.disableMobileRedirect;if("function"!=typeof i||(i(e),!e.defaultPrevented)){var l={client_id:r,redirect_uri:c,state:"facebookdirect",return_scopes:s,scope:o};a&&(l.auth_type="reauthenticate"),n.props.isMobile&&!u?window.location.href="//www.facebook.com/dialog/oauth"+(0,y["default"])(l):window.FB.login(n.checkLoginState,{scope:o,return_scopes:s,auth_type:l.auth_type})}}},a=o,i(n,a)}return a(t,e),c(t,[{key:"componentDidMount",value:function(){if(this._isMounted=!0,document.getElementById("facebook-jssdk"))return void this.sdkLoaded();this.setFbAsyncInit(),this.loadSdkAsynchronously();var e=document.getElementById("fb-root");e||(e=document.createElement("div"),e.id="fb-root",document.body.appendChild(e))}},{key:"componentWillReceiveProps",value:function(e){this.state.isSdkLoaded&&e.autoLoad&&!this.props.autoLoad&&window.FB.getLoginStatus(this.checkLoginAfterRefresh)}},{key:"componentWillUnmount",value:function(){this._isMounted=!1}},{key:"setStateIfMounted",value:function(e){this._isMounted&&this.setState(e)}},{key:"setFbAsyncInit",value:function(){var e=this,t=this.props,o=t.appId,n=t.xfbml,r=t.cookie,i=t.version,a=t.autoLoad;window.fbAsyncInit=function(){window.FB.init({version:"v"+i,appId:o,xfbml:n,cookie:r}),e.setStateIfMounted({isSdkLoaded:!0}),(a||window.location.search.includes("facebookdirect"))&&window.FB.getLoginStatus(e.checkLoginAfterRefresh)}}},{key:"sdkLoaded",value:function(){this.setState({isSdkLoaded:!0})}},{key:"loadSdkAsynchronously",value:function(){var e=this.props.language;!function(t,o,n){var r=t.getElementsByTagName(o)[0],i=r,a=r;t.getElementById(n)||(a=t.createElement(o),a.id=n,a.src="https://connect.facebook.net/"+e+"/sdk.js",i.parentNode.insertBefore(a,i))}(document,"script","facebook-jssdk")}},{key:"style",value:function(){var e=this.constructor.defaultProps.cssClass;return this.props.cssClass===e&&l["default"].createElement("style",{dangerouslySetInnerHTML:{__html:h["default"]}})}},{key:"containerStyle",value:function(){var e={transition:"opacity 0.5s"};return(this.state.isProcessing||!this.state.isSdkLoaded||this.props.isDisabled)&&(e.opacity=.6),s(e,this.props.containerStyle)}},{key:"renderOwnButton",value:function(){var e=this.props,t=e.cssClass,o=e.size,n=e.icon,r=e.textButton,i=e.typeButton,a=e.buttonStyle,c="string"==typeof n,u={};return this.props.isDisabled&&m(this.props.tag)&&(u.disabled=!0),l["default"].createElement("span",{style:this.containerStyle()},c&&l["default"].createElement("link",{rel:"stylesheet",href:"//maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css"}),l["default"].createElement(this.props.tag,s({type:i,className:t+" "+o,style:a,onClick:this.click},u),n&&c&&l["default"].createElement("i",{className:"fa "+n}),n&&!c&&n,r),this.style())}},{key:"render",value:function(){var e=this.props.children;return e?l["default"].createElement("span",{onClick:this.click},e):this.renderOwnButton()}}]),t}(l["default"].Component);k.propTypes={isDisabled:d["default"].bool,callback:d["default"].func.isRequired,appId:d["default"].string.isRequired,xfbml:d["default"].bool,cookie:d["default"].bool,reAuthenticate:d["default"].bool,scope:d["default"].string,returnScopes:d["default"].bool,redirectUri:d["default"].string,textButton:d["default"].string,typeButton:d["default"].string,autoLoad:d["default"].bool,disableMobileRedirect:d["default"].bool,isMobile:d["default"].bool,size:d["default"].string,fields:d["default"].string,cssClass:d["default"].string,version:d["default"].string,icon:d["default"].any,language:d["default"].string,onClick:d["default"].func,containerStyle:d["default"].object,buttonStyle:d["default"].object,children:d["default"].node,tag:d["default"].oneOfType([d["default"].node,d["default"].func]),onFailure:d["default"].func},k.defaultProps={textButton:"Login with Facebook",typeButton:"button",redirectUri:"undefined"!=typeof window?window.location.href:"/",scope:"public_profile,email",returnScopes:!1,xfbml:!1,cookie:!1,reAuthenticate:!1,size:"metro",fields:"name",cssClass:"kep-login-facebook",version:"2.3",language:"en_US",disableMobileRedirect:!1,isMobile:g(),tag:"button",onFailure:null},t["default"]=k},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=void 0;var r=o(1),i=n(r);t["default"]=i["default"]},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){return"?"+Object.keys(e).map(function(t){return t+"="+encodeURIComponent(e[t])}).join("&")}},function(e,t,o){t=e.exports=o(5)(),t.push([e.id,".kep-login-facebook{font-family:Helvetica,sans-serif;font-weight:700;-webkit-font-smoothing:antialiased;color:#fff;cursor:pointer;display:inline-block;font-size:calc(.27548vw + 12.71074px);text-decoration:none;text-transform:uppercase;transition:background-color .3s,border-color .3s;background-color:#4c69ba;border:calc(.06887vw + .67769px) solid #4c69ba;padding:calc(.34435vw + 13.38843px) calc(.34435vw + 18.38843px)}.kep-login-facebook.small{padding:calc(.34435vw + 3.38843px) calc(.34435vw + 8.38843px)}.kep-login-facebook.medium{padding:calc(.34435vw + 8.38843px) calc(.34435vw + 13.38843px)}.kep-login-facebook.metro{border-radius:0}.kep-login-facebook .fa{margin-right:calc(.34435vw + 3.38843px)}",""]),t.locals={"kep-login-facebook":"kep-login-facebook",small:"small",medium:"medium",metro:"metro",fa:"fa"}},function(e,t){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],t=0;t<this.length;t++){var o=this[t];o[2]?e.push("@media "+o[2]+"{"+o[1]+"}"):e.push(o[1])}return e.join("")},e.i=function(t,o){"string"==typeof t&&(t=[[null,t,""]]);for(var n={},r=0;r<this.length;r++){var i=this[r][0];"number"==typeof i&&(n[i]=!0)}for(r=0;r<t.length;r++){var a=t[r];"number"==typeof a[0]&&n[a[0]]||(o&&!a[2]?a[2]=o:o&&(a[2]="("+a[2]+") and ("+o+")"),e.push(a))}},e}},function(e,t){"use strict";function o(e){return function(){return e}}var n=function(){};n.thatReturns=o,n.thatReturnsFalse=o(!1),n.thatReturnsTrue=o(!0),n.thatReturnsNull=o(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n},function(e,t,o){"use strict";function n(e,t,o,n,i,a,s,c){if(r(t),!e){var u;if(void 0===t)u=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[o,n,i,a,s,c],f=0;u=new Error(t.replace(/%s/g,function(){return l[f++]})),u.name="Invariant Violation"}throw u.framesToPop=1,u}}var r=function(e){};e.exports=n},function(e,t,o){"use strict";var n=o(6),r=o(7),i=o(10);e.exports=function(){function e(e,t,o,n,a,s){s!==i&&r(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var o={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return o.checkPropTypes=n,o.PropTypes=o,o}},function(e,t,o){e.exports=o(8)()},function(e,t){"use strict";var o="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=o},function(t,o){t.exports=e}])});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trim;
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(521);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _reactFastCompare = __webpack_require__(470);

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _HelmetUtils = __webpack_require__(481);

var _HelmetConstants = __webpack_require__(127);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _reactFastCompare2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 127 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(483);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.tryForceFallback = tryForceFallback;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;
var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error('react-modal: No elements were found for selector ' + selector + '.');
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === 'string') {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = 'length' in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function tryForceFallback() {
  if (document && document.body) {
    // force fallback to document.body
    setElement(document.body);
    return true;
  }
  return false;
}

function validateElement(appElement) {
  if (!appElement && !globalElement && !tryForceFallback()) {
    throw new Error(['react-modal: Cannot fallback to `document.body`, because it\'s not ready or available.', 'If you are doing server-side rendering, use this function to defined an element.', '`Modal.setAppElement(el)` to make this accessible']);
  }
}

function hide(appElement) {
  validateElement(appElement);
  (appElement || globalElement).setAttribute('aria-hidden', 'true');
}

function show(appElement) {
  validateElement(appElement);
  (appElement || globalElement).removeAttribute('aria-hidden');
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = document.body;
}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = get;
exports.add = add;
exports.remove = remove;
exports.totalCount = totalCount;
var classListMap = {};

function get() {
  return classListMap;
}

function add(bodyClass) {
  // Set variable and default if none
  if (!classListMap[bodyClass]) {
    classListMap[bodyClass] = 0;
  }
  classListMap[bodyClass] += 1;
  return bodyClass;
}

function remove(bodyClass) {
  if (classListMap[bodyClass]) {
    classListMap[bodyClass] -= 1;
  }
  return bodyClass;
}

function totalCount() {
  return Object.keys(classListMap).reduce(function (acc, curr) {
    return acc + classListMap[curr];
  }, 0);
}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _exenv = __webpack_require__(284);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

exports.default = SafeHTMLElement;
module.exports = exports['default'];

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidden(el) {
  return el.offsetWidth <= 0 && el.offsetHeight <= 0 || el.style.display === 'none';
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidden(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute('tabindex');
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(tabbable);
}
module.exports = exports['default'];

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(135);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(136);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(76);


function verifyPlainObject(value, displayName, methodName) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(32);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(78);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(56);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(79);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(prevProps.to);
    var nextTo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(this.props.to);

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(56);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(57);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(78);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(512)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(59);

var _utils2 = _interopRequireDefault(_utils);

var _smooth = __webpack_require__(518);

var _smooth2 = _interopRequireDefault(_smooth);

var _cancelEvents = __webpack_require__(517);

var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

var _scrollEvents = __webpack_require__(82);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPosition: 0,
    startPosition: 0,
    targetPosition: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    delta: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionX = function currentPositionX(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollLeft;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
  }
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerWidth = function scrollContainerWidth(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollWidth - containerElement.offsetWidth;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  };

  data.delta = Math.round(data.targetPosition - data.startPosition);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    if (options.horizontal) {
      data.containerElement.scrollLeft = data.currentPosition;
    } else {
      data.containerElement.scrollTop = data.currentPosition;
    }
  } else {
    if (options.horizontal) {
      window.scrollTo(data.currentPosition, 0);
    } else {
      window.scrollTo(0, data.currentPosition);
    }
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2.default.registered['end']) {
    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPosition);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  _cancelEvents2.default.subscribe(function () {
    options.data.cancel = true;
  });

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;

  if (options.data.startPosition === options.data.targetPosition) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPosition);
    }
    return;
  }

  options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);

  options.data.duration = functionWrapper(options.duration)(options.data.delta);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2.default.registered['begin']) {
    _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toPosition, options) {
  animateTopScroll(toPosition, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(options.horizontal ? scrollContainerWidth(options) : scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toPosition, options) {
  options = proceedOptions(options);
  setContainer(options);
  var currentPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  animateTopScroll(toPosition + currentPosition, options);
};

exports.default = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _scroller = __webpack_require__(58);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Component) {
  var Element = function (_React$Component) {
    _inherits(Element, _React$Component);

    function Element(props) {
      _classCallCheck(this, Element);

      var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.registerElems(this.props.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2.default.Component);

  ;

  Element.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string
  };

  return Element;
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(81);

var _utils = __webpack_require__(59);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to, saveHashHistory) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.updateHash(to, saveHashHistory);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

exports.default = scrollHash;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slider = _interopRequireDefault(__webpack_require__(527));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _slider.default;
exports.default = _default;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var shallowEqual = function shallowEqual(a, b) {
  var keysA = Object.keys(a);
  var keysB = Object.keys(b);

  return keysA.length === keysB.length && keysA.every(function (key) {
    return b.hasOwnProperty(key) && b[key] === a[key];
  });
};

exports.default = shallowEqual;

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__ = __webpack_require__(537);









var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["a" /* getInitialChildMapping */])(nextProps, handleExited) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["b" /* getNextChildMapping */])(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["c" /* getChildMapping */])(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__["a" /* default */].Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__["a" /* default */].Provider, {
      value: contextValue
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, props, children));
  };

  return TransitionGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (TransitionGroup);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  disabled: false
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export timeoutsShape */
/* unused harmony export classNamesShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var timeoutsShape =  false ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape =  false ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = handleAction;

var _fluxStandardAction = __webpack_require__(373);

function isFunction(val) {
  return typeof val === 'function';
}

function handleAction(type, reducers) {
  return function (state, action) {
    // If action type does not match, return previous state
    if (action.type !== type) return state;

    var handlerKey = _fluxStandardAction.isError(action) ? 'throw' : 'next';

    // If function is passed instead of map, use as reducer
    if (isFunction(reducers)) {
      reducers.next = reducers['throw'] = reducers;
    }

    // Otherwise, assume an action map was passed
    var reducer = reducers[handlerKey];

    return isFunction(reducer) ? reducer(state, action) : state;
  };
}

module.exports = exports['default'];

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(567);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(559);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(464).enable();
  window.Promise = __webpack_require__(463);
}

// fetch() polyfill for making API calls.
__webpack_require__(623);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(53);


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_built_index_css__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_built_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_built_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Application__ = __webpack_require__(168);





__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Application__["a" /* default */], null) // eslint-disable-line
, document.getElementById('root'));

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _util = __webpack_require__(63);

var _inject = __webpack_require__(164);

/* ::
import type { SelectorHandler } from './generate.js';
export type SheetDefinition = { [id:string]: any };
export type SheetDefinitions = SheetDefinition | SheetDefinition[];
type RenderFunction = () => string;
type Extension = {
    selectorHandler: SelectorHandler
};
export type MaybeSheetDefinition = SheetDefinition | false | null | void
*/

var StyleSheet = {
    create: function create(sheetDefinition /* : SheetDefinition */) {
        return (0, _util.mapObj)(sheetDefinition, function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2);

            var key = _ref2[0];
            var val = _ref2[1];

            var stringVal = JSON.stringify(val);
            return [key, {
                _len: stringVal.length,
                _name:  true ? (0, _util.hashString)(stringVal) : key + '_' + (0, _util.hashString)(stringVal),
                _definition: val
            }];
        });
    },

    rehydrate: function rehydrate() {
        var renderedClassNames /* : string[] */ = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

        (0, _inject.addRenderedClassNames)(renderedClassNames);
    }
};

/**
 * Utilities for using Aphrodite server-side.
 */
var StyleSheetServer = {
    renderStatic: function renderStatic(renderFunc /* : RenderFunction */) {
        (0, _inject.reset)();
        (0, _inject.startBuffering)();
        var html = renderFunc();
        var cssContent = (0, _inject.flushToString)();

        return {
            html: html,
            css: {
                content: cssContent,
                renderedClassNames: (0, _inject.getRenderedClassNames)()
            }
        };
    }
};

/**
 * Utilities for using Aphrodite in tests.
 *
 * Not meant to be used in production.
 */
var StyleSheetTestUtils = {
    /**
     * Prevent styles from being injected into the DOM.
     *
     * This is useful in situations where you'd like to test rendering UI
     * components which use Aphrodite without any of the side-effects of
     * Aphrodite happening. Particularly useful for testing the output of
     * components when you have no DOM, e.g. testing in Node without a fake DOM.
     *
     * Should be paired with a subsequent call to
     * clearBufferAndResumeStyleInjection.
     */
    suppressStyleInjection: function suppressStyleInjection() {
        (0, _inject.reset)();
        (0, _inject.startBuffering)();
    },

    /**
     * Opposite method of preventStyleInject.
     */
    clearBufferAndResumeStyleInjection: function clearBufferAndResumeStyleInjection() {
        (0, _inject.reset)();
    }
};

/**
 * Generate the Aphrodite API exports, with given `selectorHandlers` and
 * `useImportant` state.
 */
var makeExports = function makeExports(useImportant, /* : boolean */
selectorHandlers /* : SelectorHandler[] */
) {
    return {
        StyleSheet: _extends({}, StyleSheet, {

            /**
             * Returns a version of the exports of Aphrodite (i.e. an object
             * with `css` and `StyleSheet` properties) which have some
             * extensions included.
             *
             * @param {Array.<Object>} extensions: An array of extensions to
             *     add to this instance of Aphrodite. Each object should have a
             *     single property on it, defining which kind of extension to
             *     add.
             * @param {SelectorHandler} [extensions[].selectorHandler]: A
             *     selector handler extension. See `defaultSelectorHandlers` in
             *     generate.js.
             *
             * @returns {Object} An object containing the exports of the new
             *     instance of Aphrodite.
             */
            extend: function extend(extensions /* : Extension[] */) {
                var extensionSelectorHandlers = extensions
                // Pull out extensions with a selectorHandler property
                .map(function (extension) {
                    return extension.selectorHandler;
                })
                // Remove nulls (i.e. extensions without a selectorHandler
                // property).
                .filter(function (handler) {
                    return handler;
                });

                return makeExports(useImportant, selectorHandlers.concat(extensionSelectorHandlers));
            }
        }),

        StyleSheetServer: StyleSheetServer,
        StyleSheetTestUtils: StyleSheetTestUtils,

        css: function css() /* : MaybeSheetDefinition[] */{
            for (var _len = arguments.length, styleDefinitions = Array(_len), _key = 0; _key < _len; _key++) {
                styleDefinitions[_key] = arguments[_key];
            }

            return (0, _inject.injectAndGetClassName)(useImportant, styleDefinitions, selectorHandlers);
        }
    };
};

module.exports = makeExports;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _asap = __webpack_require__(166);

var _asap2 = _interopRequireDefault(_asap);

var _orderedElements = __webpack_require__(92);

var _orderedElements2 = _interopRequireDefault(_orderedElements);

var _generate = __webpack_require__(91);

var _util = __webpack_require__(63);

/* ::
import type { SheetDefinition, SheetDefinitions } from './index.js';
import type { MaybeSheetDefinition } from './exports.js';
import type { SelectorHandler } from './generate.js';
type ProcessedStyleDefinitions = {
  classNameBits: Array<string>,
  definitionBits: Array<Object>,
};
*/

// The current <style> tag we are inserting into, or null if we haven't
// inserted anything yet. We could find this each time using
// `document.querySelector("style[data-aphrodite"])`, but holding onto it is
// faster.
var styleTag = null;

// Inject a string of styles into a <style> tag in the head of the document. This
// will automatically create a style tag and then continue to use it for
// multiple injections. It will also use a style tag with the `data-aphrodite`
// tag on it if that exists in the DOM. This could be used for e.g. reusing the
// same style tag that server-side rendering inserts.
var injectStyleTag = function injectStyleTag(cssContents /* : string */) {
    if (styleTag == null) {
        // Try to find a style tag with the `data-aphrodite` attribute first.
        styleTag = document.querySelector("style[data-aphrodite]");

        // If that doesn't work, generate a new style tag.
        if (styleTag == null) {
            // Taken from
            // http://stackoverflow.com/questions/524696/how-to-create-a-style-tag-with-javascript
            var head = document.head || document.getElementsByTagName('head')[0];
            styleTag = document.createElement('style');

            styleTag.type = 'text/css';
            styleTag.setAttribute("data-aphrodite", "");
            head.appendChild(styleTag);
        }
    }

    if (styleTag.styleSheet) {
        // $FlowFixMe: legacy Internet Explorer compatibility
        styleTag.styleSheet.cssText += cssContents;
    } else {
        styleTag.appendChild(document.createTextNode(cssContents));
    }
};

// Custom handlers for stringifying CSS values that have side effects
// (such as fontFamily, which can cause @font-face rules to be injected)
var stringHandlers = {
    // With fontFamily we look for objects that are passed in and interpret
    // them as @font-face rules that we need to inject. The value of fontFamily
    // can either be a string (as normal), an object (a single font face), or
    // an array of objects and strings.
    fontFamily: function fontFamily(val) {
        if (Array.isArray(val)) {
            return val.map(fontFamily).join(",");
        } else if (typeof val === "object") {
            injectStyleOnce(val.src, "@font-face", [val], false);
            return '"' + val.fontFamily + '"';
        } else {
            return val;
        }
    },

    // With animationName we look for an object that contains keyframes and
    // inject them as an `@keyframes` block, returning a uniquely generated
    // name. The keyframes object should look like
    //  animationName: {
    //    from: {
    //      left: 0,
    //      top: 0,
    //    },
    //    '50%': {
    //      left: 15,
    //      top: 5,
    //    },
    //    to: {
    //      left: 20,
    //      top: 20,
    //    }
    //  }
    // TODO(emily): `stringHandlers` doesn't let us rename the key, so I have
    // to use `animationName` here. Improve that so we can call this
    // `animation` instead of `animationName`.
    animationName: function animationName(val, selectorHandlers) {
        if (Array.isArray(val)) {
            return val.map(function (v) {
                return animationName(v, selectorHandlers);
            }).join(",");
        } else if (typeof val === "object") {
            // Generate a unique name based on the hash of the object. We can't
            // just use the hash because the name can't start with a number.
            // TODO(emily): this probably makes debugging hard, allow a custom
            // name?
            var _name = 'keyframe_' + (0, _util.hashObject)(val);

            // Since keyframes need 3 layers of nesting, we use `generateCSS` to
            // build the inner layers and wrap it in `@keyframes` ourselves.
            var finalVal = '@keyframes ' + _name + '{';

            // TODO see if we can find a way where checking for OrderedElements
            // here is not necessary. Alternatively, perhaps we should have a
            // utility method that can iterate over either a plain object, an
            // instance of OrderedElements, or a Map, and then use that here and
            // elsewhere.
            if (val instanceof _orderedElements2['default']) {
                val.forEach(function (valVal, valKey) {
                    finalVal += (0, _generate.generateCSS)(valKey, [valVal], selectorHandlers, stringHandlers, false);
                });
            } else {
                Object.keys(val).forEach(function (key) {
                    finalVal += (0, _generate.generateCSS)(key, [val[key]], selectorHandlers, stringHandlers, false);
                });
            }
            finalVal += '}';

            injectGeneratedCSSOnce(_name, finalVal);

            return _name;
        } else {
            return val;
        }
    }
};

// This is a map from Aphrodite's generated class names to `true` (acting as a
// set of class names)
var alreadyInjected = {};

// This is the buffer of styles which have not yet been flushed.
var injectionBuffer = "";

// A flag to tell if we are already buffering styles. This could happen either
// because we scheduled a flush call already, so newly added styles will
// already be flushed, or because we are statically buffering on the server.
var isBuffering = false;

var injectGeneratedCSSOnce = function injectGeneratedCSSOnce(key, generatedCSS) {
    if (alreadyInjected[key]) {
        return;
    }

    if (!isBuffering) {
        // We should never be automatically buffering on the server (or any
        // place without a document), so guard against that.
        if (typeof document === "undefined") {
            throw new Error("Cannot automatically buffer without a document");
        }

        // If we're not already buffering, schedule a call to flush the
        // current styles.
        isBuffering = true;
        (0, _asap2['default'])(flushToStyleTag);
    }

    injectionBuffer += generatedCSS;
    alreadyInjected[key] = true;
};

var injectStyleOnce = function injectStyleOnce(key, /* : string */
selector, /* : string */
definitions, /* : SheetDefinition[] */
useImportant /* : boolean */
) {
    var selectorHandlers /* : SelectorHandler[] */ = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];

    if (alreadyInjected[key]) {
        return;
    }

    var generated = (0, _generate.generateCSS)(selector, definitions, selectorHandlers, stringHandlers, useImportant);

    injectGeneratedCSSOnce(key, generated);
};

exports.injectStyleOnce = injectStyleOnce;
var reset = function reset() {
    injectionBuffer = "";
    alreadyInjected = {};
    isBuffering = false;
    styleTag = null;
};

exports.reset = reset;
var startBuffering = function startBuffering() {
    if (isBuffering) {
        throw new Error("Cannot buffer while already buffering");
    }
    isBuffering = true;
};

exports.startBuffering = startBuffering;
var flushToString = function flushToString() {
    isBuffering = false;
    var ret = injectionBuffer;
    injectionBuffer = "";
    return ret;
};

exports.flushToString = flushToString;
var flushToStyleTag = function flushToStyleTag() {
    var cssContent = flushToString();
    if (cssContent.length > 0) {
        injectStyleTag(cssContent);
    }
};

exports.flushToStyleTag = flushToStyleTag;
var getRenderedClassNames = function getRenderedClassNames() {
    return Object.keys(alreadyInjected);
};

exports.getRenderedClassNames = getRenderedClassNames;
var addRenderedClassNames = function addRenderedClassNames(classNames /* : string[] */) {
    classNames.forEach(function (className) {
        alreadyInjected[className] = true;
    });
};

exports.addRenderedClassNames = addRenderedClassNames;
var processStyleDefinitions = function processStyleDefinitions(styleDefinitions, /* : any[] */
result /* : ProcessedStyleDefinitions */
) /* : void */{
    for (var i = 0; i < styleDefinitions.length; i += 1) {
        // Filter out falsy values from the input, to allow for
        // `css(a, test && c)`
        if (styleDefinitions[i]) {
            if (Array.isArray(styleDefinitions[i])) {
                // We've encountered an array, so let's recurse
                processStyleDefinitions(styleDefinitions[i], result);
            } else {
                result.classNameBits.push(styleDefinitions[i]._name);
                result.definitionBits.push(styleDefinitions[i]._definition);
            }
        }
    }
};

// Sum up the lengths of the stringified style definitions (which was saved as _len property)
// and use modulus to return a single byte hash value.
// We append this extra byte to the 32bit hash to decrease the chance of hash collisions.
var getStyleDefinitionsLengthHash = function getStyleDefinitionsLengthHash(styleDefinitions /* : any[] */) {
    return (/* : string */(styleDefinitions.reduce(function (length, styleDefinition) {
            return length + (styleDefinition ? styleDefinition._len : 0);
        }, 0) % 36).toString(36)
    );
};

/**
 * Inject styles associated with the passed style definition objects, and return
 * an associated CSS class name.
 *
 * @param {boolean} useImportant If true, will append !important to generated
 *     CSS output. e.g. {color: red} -> "color: red !important".
 * @param {(Object|Object[])[]} styleDefinitions style definition objects, or
 *     arbitrarily nested arrays of them, as returned as properties of the
 *     return value of StyleSheet.create().
 */
var injectAndGetClassName = function injectAndGetClassName(useImportant, /* : boolean */
styleDefinitions, /* : MaybeSheetDefinition[] */
selectorHandlers /* : SelectorHandler[] */
) /* : string */{
    var processedStyleDefinitions /* : ProcessedStyleDefinitions */ = {
        classNameBits: [],
        definitionBits: []
    };
    // Mutates processedStyleDefinitions
    processStyleDefinitions(styleDefinitions, processedStyleDefinitions);

    // Break if there aren't any valid styles.
    if (processedStyleDefinitions.classNameBits.length === 0) {
        return "";
    }

    var className = undefined;
    if (true) {
        className = processedStyleDefinitions.classNameBits.length === 1 ? '_' + processedStyleDefinitions.classNameBits[0] : '_' + (0, _util.hashString)(processedStyleDefinitions.classNameBits.join()) + getStyleDefinitionsLengthHash(styleDefinitions);
    } else {
        className = processedStyleDefinitions.classNameBits.join("-o_O-");
    }

    injectStyleOnce(className, '.' + className, processedStyleDefinitions.definitionBits, useImportant, selectorHandlers);

    return className;
};
exports.injectAndGetClassName = injectAndGetClassName;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var calc = __webpack_require__(384)
var crossFade = __webpack_require__(385)
var cursor = __webpack_require__(386)
var filter = __webpack_require__(387)
var flex = __webpack_require__(388)
var flexboxIE = __webpack_require__(389)
var flexboxOld = __webpack_require__(390)
var gradient = __webpack_require__(391)
var imageSet = __webpack_require__(392)
var position = __webpack_require__(393)
var sizing = __webpack_require__(394)
var transition = __webpack_require__(395)

module.exports =  {
  plugins: [calc,crossFade,cursor,filter,flex,flexboxIE,flexboxOld,gradient,imageSet,position,sizing,transition],
  prefixMap: {"transform":["Webkit","ms"],"transformOrigin":["Webkit","ms"],"transformOriginX":["Webkit","ms"],"transformOriginY":["Webkit","ms"],"backfaceVisibility":["Webkit"],"perspective":["Webkit"],"perspectiveOrigin":["Webkit"],"transformStyle":["Webkit"],"transformOriginZ":["Webkit"],"animation":["Webkit"],"animationDelay":["Webkit"],"animationDirection":["Webkit"],"animationFillMode":["Webkit"],"animationDuration":["Webkit"],"animationIterationCount":["Webkit"],"animationName":["Webkit"],"animationPlayState":["Webkit"],"animationTimingFunction":["Webkit"],"appearance":["Webkit","Moz"],"userSelect":["Webkit","Moz","ms"],"fontKerning":["Webkit"],"textEmphasisPosition":["Webkit"],"textEmphasis":["Webkit"],"textEmphasisStyle":["Webkit"],"textEmphasisColor":["Webkit"],"boxDecorationBreak":["Webkit"],"clipPath":["Webkit"],"maskImage":["Webkit"],"maskMode":["Webkit"],"maskRepeat":["Webkit"],"maskPosition":["Webkit"],"maskClip":["Webkit"],"maskOrigin":["Webkit"],"maskSize":["Webkit"],"maskComposite":["Webkit"],"mask":["Webkit"],"maskBorderSource":["Webkit"],"maskBorderMode":["Webkit"],"maskBorderSlice":["Webkit"],"maskBorderWidth":["Webkit"],"maskBorderOutset":["Webkit"],"maskBorderRepeat":["Webkit"],"maskBorder":["Webkit"],"maskType":["Webkit"],"textDecorationStyle":["Webkit","Moz"],"textDecorationSkip":["Webkit","Moz"],"textDecorationLine":["Webkit","Moz"],"textDecorationColor":["Webkit","Moz"],"filter":["Webkit"],"fontFeatureSettings":["Webkit","Moz"],"breakAfter":["Webkit","Moz","ms"],"breakBefore":["Webkit","Moz","ms"],"breakInside":["Webkit","Moz","ms"],"columnCount":["Webkit","Moz"],"columnFill":["Webkit","Moz"],"columnGap":["Webkit","Moz"],"columnRule":["Webkit","Moz"],"columnRuleColor":["Webkit","Moz"],"columnRuleStyle":["Webkit","Moz"],"columnRuleWidth":["Webkit","Moz"],"columns":["Webkit","Moz"],"columnSpan":["Webkit","Moz"],"columnWidth":["Webkit","Moz"],"flex":["Webkit","ms"],"flexBasis":["Webkit"],"flexDirection":["Webkit","ms"],"flexGrow":["Webkit"],"flexFlow":["Webkit","ms"],"flexShrink":["Webkit"],"flexWrap":["Webkit","ms"],"alignContent":["Webkit"],"alignItems":["Webkit"],"alignSelf":["Webkit"],"justifyContent":["Webkit"],"order":["Webkit"],"transitionDelay":["Webkit"],"transitionDuration":["Webkit"],"transitionProperty":["Webkit"],"transitionTimingFunction":["Webkit"],"backdropFilter":["Webkit"],"scrollSnapType":["Webkit","ms"],"scrollSnapPointsX":["Webkit","ms"],"scrollSnapPointsY":["Webkit","ms"],"scrollSnapDestination":["Webkit","ms"],"scrollSnapCoordinate":["Webkit","ms"],"shapeImageThreshold":["Webkit"],"shapeImageMargin":["Webkit"],"shapeImageOutside":["Webkit"],"hyphens":["Webkit","Moz","ms"],"flowInto":["Webkit","ms"],"flowFrom":["Webkit","ms"],"regionFragment":["Webkit","ms"],"boxSizing":["Moz"],"textAlignLast":["Moz"],"tabSize":["Moz"],"wrapFlow":["ms"],"wrapThrough":["ms"],"wrapMargin":["ms"],"touchAction":["ms"],"gridTemplateColumns":["ms"],"gridTemplateRows":["ms"],"gridTemplateAreas":["ms"],"gridTemplate":["ms"],"gridAutoColumns":["ms"],"gridAutoRows":["ms"],"gridAutoFlow":["ms"],"grid":["ms"],"gridRowStart":["ms"],"gridColumnStart":["ms"],"gridRowEnd":["ms"],"gridRow":["ms"],"gridColumn":["ms"],"gridColumnEnd":["ms"],"gridColumnGap":["ms"],"gridRowGap":["ms"],"gridArea":["ms"],"gridGap":["ms"],"textSizeAdjust":["Webkit","ms"],"borderImage":["Webkit"],"borderImageOutset":["Webkit"],"borderImageRepeat":["Webkit"],"borderImageSlice":["Webkit"],"borderImageSource":["Webkit"],"borderImageWidth":["Webkit"]}
}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// rawAsap provides everything we need except exception management.
var rawAsap = __webpack_require__(93);
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};


/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return t[e].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var r={};return n.m=t,n.c=r,n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=13)}([function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n){var r=t.exports={version:"2.5.0"};"number"==typeof __e&&(__e=r)},function(t,n,r){t.exports=!r(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(32)("wks"),o=r(9),i=r(0).Symbol,u="function"==typeof i;(t.exports=function(t){return e[t]||(e[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=e},function(t,n,r){var e=r(0),o=r(2),i=r(8),u=r(22),c=r(10),f=function(t,n,r){var a,s,p,l,v=t&f.F,y=t&f.G,h=t&f.S,d=t&f.P,x=t&f.B,g=y?e:h?e[n]||(e[n]={}):(e[n]||{}).prototype,m=y?o:o[n]||(o[n]={}),b=m.prototype||(m.prototype={});y&&(r=n);for(a in r)s=!v&&g&&void 0!==g[a],p=(s?g:r)[a],l=x&&s?c(p,e):d&&"function"==typeof p?c(Function.call,p):p,g&&u(g,a,p,t&f.U),m[a]!=p&&i(m,a,l),d&&b[a]!=p&&(b[a]=p)};e.core=o,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f},function(t,n,r){var e=r(16),o=r(21);t.exports=r(3)?function(t,n,r){return e.f(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(24);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){var e=r(28),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";n.__esModule=!0,n.default=function(t,n){if(t&&n){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):n.endsWith("/*")?i===n.replace(/\/.*$/,""):o===n})}return!0},r(14),r(34)},function(t,n,r){r(15),t.exports=r(2).Array.some},function(t,n,r){"use strict";var e=r(7),o=r(25)(3);e(e.P+e.F*!r(33)([].some,!0),"Array",{some:function(t){return o(this,t,arguments[1])}})},function(t,n,r){var e=r(17),o=r(18),i=r(20),u=Object.defineProperty;n.f=r(3)?Object.defineProperty:function(t,n,r){if(e(t),n=i(n,!0),e(r),o)try{return u(t,n,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(t[n]=r.value),t}},function(t,n,r){var e=r(1);t.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t}},function(t,n,r){t.exports=!r(3)&&!r(4)(function(){return 7!=Object.defineProperty(r(19)("div"),"a",{get:function(){return 7}}).a})},function(t,n,r){var e=r(1),o=r(0).document,i=e(o)&&e(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,n,r){var e=r(1);t.exports=function(t,n){if(!e(t))return t;var r,o;if(n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;if("function"==typeof(r=t.valueOf)&&!e(o=r.call(t)))return o;if(!n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(0),o=r(8),i=r(23),u=r(9)("src"),c=Function.toString,f=(""+c).split("toString");r(2).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,c){var a="function"==typeof r;a&&(i(r,"name")||o(r,"name",n)),t[n]!==r&&(a&&(i(r,u)||o(r,u,t[n]?""+t[n]:f.join(String(n)))),t===e?t[n]=r:c?t[n]?t[n]=r:o(t,n,r):(delete t[n],o(t,n,r)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[u]||c.call(this)})},function(t,n){var r={}.hasOwnProperty;t.exports=function(t,n){return r.call(t,n)}},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n,r){var e=r(10),o=r(26),i=r(27),u=r(12),c=r(29);t.exports=function(t,n){var r=1==t,f=2==t,a=3==t,s=4==t,p=6==t,l=5==t||p,v=n||c;return function(n,c,y){for(var h,d,x=i(n),g=o(x),m=e(c,y,3),b=u(g.length),_=0,w=r?v(n,b):f?v(n,0):void 0;b>_;_++)if((l||_ in g)&&(h=g[_],d=m(h,_,x),t))if(r)w[_]=d;else if(d)switch(t){case 3:return!0;case 5:return h;case 6:return _;case 2:w.push(h)}else if(s)return!1;return p?-1:a||s?s:w}}},function(t,n,r){var e=r(5);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==e(t)?t.split(""):Object(t)}},function(t,n,r){var e=r(11);t.exports=function(t){return Object(e(t))}},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(30);t.exports=function(t,n){return new(e(t))(n)}},function(t,n,r){var e=r(1),o=r(31),i=r(6)("species");t.exports=function(t){var n;return o(t)&&(n=t.constructor,"function"!=typeof n||n!==Array&&!o(n.prototype)||(n=void 0),e(n)&&null===(n=n[i])&&(n=void 0)),void 0===n?Array:n}},function(t,n,r){var e=r(5);t.exports=Array.isArray||function(t){return"Array"==e(t)}},function(t,n,r){var e=r(0),o=e["__core-js_shared__"]||(e["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,n,r){"use strict";var e=r(4);t.exports=function(t,n){return!!t&&e(function(){n?t.call(null,function(){},1):t.call(null)})}},function(t,n,r){r(35),t.exports=r(2).String.endsWith},function(t,n,r){"use strict";var e=r(7),o=r(12),i=r(36),u="".endsWith;e(e.P+e.F*r(38)("endsWith"),"String",{endsWith:function(t){var n=i(this,t,"endsWith"),r=arguments.length>1?arguments[1]:void 0,e=o(n.length),c=void 0===r?e:Math.min(o(r),e),f=String(t);return u?u.call(n,f,c):n.slice(c-f.length,c)===f}})},function(t,n,r){var e=r(37),o=r(11);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){var e=r(1),o=r(5),i=r(6)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n,r){var e=r(6)("match");t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(r){try{return n[e]=!1,!"/./"[t](n)}catch(t){}}return!0}}]);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_ga__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify_dist_ReactToastify_css__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify_dist_ReactToastify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toastify_dist_ReactToastify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_persist__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_persist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_redux_persist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_thunk__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_applicationData__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_StripeAPIProvider__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__reducers__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_promise__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__store_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_ApplicationHelper__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Blog__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_BlogPost__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Contact__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_DogProfile__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_EditPooch__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_EditProfile__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_ErrorView__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_FAQs__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_Favourites__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_Find__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_Forgot__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_Home__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_JoinComplete__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_JoinContainer__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_JoinDetails__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_JoinPayment__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_JoinPooch__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_JoinProfile__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_JoinSubscription__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_JoinVerify__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_LoadingView__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_Matches__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_MemberProfile__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_MessengerConversation__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_MessengerInbox__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_Privacy__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_Profiles__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_ServerErrorView__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_SettingsAccount__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_SettingsContainer__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_SettingsDetails__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_SettingsHelp__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_SettingsMembership__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_SettingsResources__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__views_ShareHistory__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_Story__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_Terms__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_UnauthenticatedContainer__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__views_Verify__ = __webpack_require__(272);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable */



























































// Initialize Google Analytics only if not pre-rendering
if (navigator.userAgent !== 'ReactSnap') {
  __WEBPACK_IMPORTED_MODULE_1_react_ga__["a" /* default */].initialize('UA-48870839-48');
}

var appStore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_8_redux_thunk___default.a, __WEBPACK_IMPORTED_MODULE_14__store_promise___default.a)(__WEBPACK_IMPORTED_MODULE_6_redux__["b" /* createStore */]);
var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_persist__["autoRehydrate"])()(appStore)(__WEBPACK_IMPORTED_MODULE_13__reducers__["a" /* default */]);

var Application = function (_Component) {
  _inherits(Application, _Component);

  function Application() {
    _classCallCheck(this, Application);

    var _this = _possibleConstructorReturn(this, (Application.__proto__ || Object.getPrototypeOf(Application)).call(this));

    _this.mobBreak = _this.mobBreak.bind(_this);
    _this.state = {
      rehydrated: false,
      isMobile: false
    };
    return _this;
  }

  _createClass(Application, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_persist__["persistStore"])(store, { blacklist: ['routing', 'appstate', 'search'], storage: __WEBPACK_IMPORTED_MODULE_7_redux_persist__["storages"].localForage }, function () {
        _this2.setState({
          rehydrated: true
        });

        // Skip authentication check during react-snap pre-rendering
        if (navigator.userAgent === 'ReactSnap') {
          return;
        }

        // Check existing user (via redux-persist) and validate authentication
        var user = store.getState().user;
        if (user && user.id && user.isAuthenticated) {
          store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__actions_user__["a" /* getMember */])(user.id, user.access_token)).then(function (response) {
            if (!response) {
              store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__actions_user__["b" /* logout */])());
            } else {
              store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__actions_user__["c" /* updateUser */])(response));
            }
          }, function (err) {
            console.log(err);
            store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__actions_user__["b" /* logout */])());
          });
        }
      });
      this.mobBreak();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Skip API calls during react-snap pre-rendering
      if (navigator.userAgent === 'ReactSnap') {
        return;
      }

      // Fetch app config
      store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__actions_applicationData__["a" /* fetchAppData */])());
    }
  }, {
    key: 'mobBreak',
    value: function mobBreak() {
      if (window.innerWidth > __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].responsive_mobile_width && this.state.isMobile) {
        __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].isMobile = false;
        this.setState({
          isMobile: false
        });
      } else if (window.innerWidth <= __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].responsive_mobile_width && !this.state.isMobile) {
        __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].isMobile = true;
        this.setState({
          isMobile: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.rehydrated) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__views_LoadingView__["a" /* default */], null) // eslint-disable-line
        ;
      }

      window.removeEventListener('resize', this.mobBreak);
      window.addEventListener('resize', this.mobBreak);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],
        { store: store },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__components_StripeAPIProvider__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* BrowserRouter */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_15__views_ApplicationHelper__["a" /* default */],
              { ga: __WEBPACK_IMPORTED_MODULE_1_react_ga__["a" /* default */] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toastify__["a" /* ToastContainer */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Switch */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { path: '/', exact: true, render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__views_Home__["a" /* default */], props);
                  } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { path: '/story', exact: true, component: __WEBPACK_IMPORTED_MODULE_52__views_Story__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { path: '/forgot', exact: true, component: __WEBPACK_IMPORTED_MODULE_27__views_Forgot__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { path: '/contact', exact: true, component: __WEBPACK_IMPORTED_MODULE_18__views_Contact__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { path: '/verify', exact: true, render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_55__views_Verify__["a" /* default */], props);
                  } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Redirect */], { from: '/faqs', to: '/faqs-dog-owner' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/faqs-dog-borrower',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__views_FAQs__["a" /* default */], Object.assign({}, props, { type: 'borrower' }));
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/faqs-dog-owner',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__views_FAQs__["a" /* default */], Object.assign({}, props, { type: 'owner' }));
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { path: '/blog', exact: true, component: __WEBPACK_IMPORTED_MODULE_16__views_Blog__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { path: '/terms', exact: true, render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_53__views_Terms__["a" /* default */], props);
                  } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { path: '/privacy', exact: true, render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__views_Privacy__["a" /* default */], props);
                  } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { path: '/blog/:slug', exact: true, render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__views_BlogPost__["a" /* default */], props);
                  } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/find',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__views_Find__["a" /* default */], props)
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/profiles',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__views_Profiles__["a" /* default */], props)
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/shares',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__views_Matches__["a" /* default */], props)
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/favourites',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__views_Favourites__["a" /* default */], props)
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/inbox',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__views_MessengerInbox__["a" /* default */], props)
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/inbox/:conversationId',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      { hideFooter: true },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__views_MessengerConversation__["a" /* default */], props)
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/history',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_51__views_ShareHistory__["a" /* default */], props)
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/profile/:id',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__views_MemberProfile__["a" /* default */], props)
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/profile/:id/edit',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__views_EditProfile__["a" /* default */], props)
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/pooch/:id',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__views_DogProfile__["a" /* default */], props)
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/pooch/:id/edit',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__views_EditPooch__["a" /* default */], props)
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/settings/account',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_46__views_SettingsContainer__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45__views_SettingsAccount__["a" /* default */], props)
                      )
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/settings/help',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_46__views_SettingsContainer__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48__views_SettingsHelp__["a" /* default */], props)
                      )
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/settings/resources',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_46__views_SettingsContainer__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_50__views_SettingsResources__["a" /* default */], props)
                      )
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/settings/membership',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_46__views_SettingsContainer__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_49__views_SettingsMembership__["a" /* default */], props)
                      )
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/settings/profiles',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_46__views_SettingsContainer__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_47__views_SettingsDetails__["a" /* default */], props)
                      )
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/join/subscription',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_54__views_UnauthenticatedContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_30__views_JoinContainer__["a" /* default */],
                        { step: 1 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__views_JoinSubscription__["a" /* default */], props)
                      )
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/join/details',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_54__views_UnauthenticatedContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_30__views_JoinContainer__["a" /* default */],
                        { step: 2 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__views_JoinDetails__["a" /* default */], props)
                      )
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/join/payment',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_54__views_UnauthenticatedContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_30__views_JoinContainer__["a" /* default */],
                        { step: 3 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__views_JoinPayment__["a" /* default */], Object.assign({}, props, { ga: __WEBPACK_IMPORTED_MODULE_1_react_ga__["a" /* default */] }))
                      )
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/join/verify',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_54__views_UnauthenticatedContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__views_JoinVerify__["a" /* default */], Object.assign({}, props, { ga: __WEBPACK_IMPORTED_MODULE_1_react_ga__["a" /* default */] }))
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/join/profile',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__views_JoinProfile__["a" /* default */], props)
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/join/pooch',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__views_JoinPooch__["a" /* default */], props)
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
                  path: '/join/complete',
                  exact: true,
                  render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_19__views_DashboardContainer__["a" /* default */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__views_JoinComplete__["a" /* default */], props)
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Redirect */], { from: '/join', to: '/join/subscription' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Redirect */], { from: '/settings', to: '/settings/profiles' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { path: '/500', component: __WEBPACK_IMPORTED_MODULE_44__views_ServerErrorView__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { component: __WEBPACK_IMPORTED_MODULE_23__views_ErrorView__["a" /* default */] })
              )
            )
          )
        )
      );
    }
  }]);

  return Application;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Application);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_theme__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var styles = void 0;
var BACKGROUND_ASSET = __webpack_require__(571);

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.container) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h1',
      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.title) },
      'Our Story'
    )
  );
});

styles = __WEBPACK_IMPORTED_MODULE_1_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 515,
    marginTop: 80,
    backgroundImage: 'url(\'' + BACKGROUND_ASSET + '\')',
    backgroundSize: 'cover',
    backgroundPosition: 'center'

  }, __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].mobile_query, {
    height: 'auto',
    padding: '80px 20px',
    backgroundPosition: 'left center',
    boxShadow: '0 0 0 1000px rgba(0,0,0,.3) inset'
  }),
  title: _defineProperty({
    fontFamily: __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 100,
    fontWeight: __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].font_weight_heading,
    color: __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].white

  }, __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 45
  })
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var CLOSE_ICON = __webpack_require__(289);

var AcceptanceConditionsModal = function (_Component) {
  _inherits(AcceptanceConditionsModal, _Component);

  function AcceptanceConditionsModal(props) {
    _classCallCheck(this, AcceptanceConditionsModal);

    var _this = _possibleConstructorReturn(this, (AcceptanceConditionsModal.__proto__ || Object.getPrototypeOf(AcceptanceConditionsModal)).call(this, props));

    _this.toggle = _this.props.toggle.bind(_this);
    return _this;
  }

  _createClass(AcceptanceConditionsModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var Continue = function Continue() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.continue),
            onClick: function onClick() {
              _this2.props.onClickPass();
            }
          },
          'Continue'
        );
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_modal___default.a,
        {
          isOpen: this.props.open,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container),
          style: {
            overlay: {
              backgroundColor: 'rgba(0,0,0,0.67)',
              zIndex: 10,
              display: 'flex'
            }
          },
          contentLabel: 'Report'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.modal_wrapper) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.header) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.title) },
              'Conditions Acceptance'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.close_icon),
                onClick: this.props.toggle,
                role: 'button',
                tabIndex: 0
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: CLOSE_ICON, alt: 'Close modal' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.body) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'By clicking continue, you have read the terms and conditions'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.actions) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Continue, null)
          )
        )
      );
    }
  }]);

  return AcceptanceConditionsModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AcceptanceConditionsModal);


AcceptanceConditionsModal.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  onClickPass: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired
};

AcceptanceConditionsModal.defaultProps = {
  open: false
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 590,
    maxWidth: '95vw',
    maxHeight: '50vh',
    transform: 'translateY(40px)',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    borderRadius: 5,
    overflow: 'auto',
    outline: 'none',
    margin: 'auto auto'
  },
  modal_wrapper: _defineProperty({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    // height: 600 - 100,
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 80px 40px'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0 30px 50px'
  }),
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px 0px 35px'
  },
  title: {
    marginBottom: 0,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 30,
    fontWeight: '900'
  },
  close_icon: {
    position: 'absolute',
    right: 5,
    top: 5,
    outline: 'none',
    cursor: 'pointer',
    padding: 10,
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6
    }
  },
  body: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    textAlign: 'center',

    ':not(.a) > p': {
      marginBottom: 20,
      fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
      fontSize: 16,
      color: '#828282'
    }
  },
  actions: _defineProperty({
    display: 'flex',
    justifyContent: 'center',
    marginTop: 22

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    marginTop: 0
  }),
  continue: {
    width: 340,
    height: 50,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_secondary,
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary,
    cursor: 'pointer',
    outline: 'none'
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JumboSelect__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ActivityCard__ = __webpack_require__(43);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ICON_ASSET = __webpack_require__(304);

var ActivitySelect = function (_Component) {
  _inherits(ActivitySelect, _Component);

  function ActivitySelect(props) {
    _classCallCheck(this, ActivitySelect);

    var _this = _possibleConstructorReturn(this, (ActivitySelect.__proto__ || Object.getPrototypeOf(ActivitySelect)).call(this, props));

    _this.handleSelect = _this.props.handler.bind(_this);
    return _this;
  }

  _createClass(ActivitySelect, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__JumboSelect__["a" /* default */],
        {
          label: 'Interests',
          icon: ICON_ASSET,
          selected: this.props.value ? this.props.value.length : 0,
          modifier: 'interests',
          clear: this.props.clear
        },
        this.props.interests.map(function (interest) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ActivityCard__["a" /* default */], {
            key: interest.id,
            id: interest.id,
            value: _this2.props.value && _this2.props.value.length > 0 && _this2.props.value.find(function (interestID) {
              return interestID === interest.id;
            }),
            activity: interest.title,
            label: interest.title,
            onSelect: _this2.handleSelect });
        })
      );
    }
  }]);

  return ActivitySelect;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ActivitySelect);


ActivitySelect.defaultProps = {
  value: [],
  handler: function handler() {},
  clear: function clear() {}
};

ActivitySelect.propTypes = {
  handler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func, //eslint-disable-line
  clear: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func, //eslint-disable-line
  interests: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].array.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].array
};

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_theme__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var styles = void 0;
var APP_DOWNLOAD_ICON = __webpack_require__(573);
var IOS_ICON = __webpack_require__(574);
var ANDROID_ICON = __webpack_require__(572);

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.container) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.information) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
        src: APP_DOWNLOAD_ICON,
        alt: 'Add to your homescreen',
        className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.appDownloadIcon)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.copy) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.heading) },
          'Is there a Dog Share app?'
        ),
        'You can add the website bookmark to your phone\'s home screen, and it operates just like an app! Click the icon of your mobile OS for instructions.'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.information) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        {
          rel: 'noopener noreferrer',
          href: 'https://www.macrumors.com/how-to/add-a-web-link-to-home-screen-iphone-ipad/#:~:text=Launch%20Safari%20on%20your%20%E2%80%8CiPhone%E2%80%8C,tap%20Add%20to%20Home%20Screen.',
          target: '_blank'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: IOS_ICON, alt: 'Supported on iOS', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.osIcon) })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        {
          rel: 'noopener noreferrer',
          href: 'https://support.google.com/android/answer/9450271?hl=en#zippy=%2Cadd-an-app',
          target: '_blank'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: ANDROID_ICON, alt: 'Supported on Android', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.osIcon) })
      )
    )
  );
});

styles = __WEBPACK_IMPORTED_MODULE_1_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    padding: '5px 0',
    textAlign: 'center',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].white,
    border: '1px solid ' + __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].horizontal_rule_color

  }, __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].mobile_query, {
    padding: '25px 0 35px'
  }),
  heading: {
    marginBottom: 5,
    fontFamily: __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].font_family_secondary,
    fontSize: 15,
    letterSpacing: 2,
    textTransform: 'uppercase',
    fontWeight: __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].font_weight_heading,
    lineHeight: 1.73,
    color: '#000e1f'
  },
  appDownloadIcon: {
    maxWidth: 100,
    maxHeight: 100
  },
  information: _defineProperty({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    margin: '0 auto 8px'

  }, __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto',
    flexWrap: 'wrap',
    justifyContent: 'center'
  }),
  copy: _defineProperty({
    position: 'relative',
    textAlign: 'left',
    lineHeight: 1.73,
    padding: '0 5px'

  }, __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].mobile_query, {
    textAlign: 'center'
  }),
  osIcon: {
    maxWidth: 40,
    maxHeight: 40,
    margin: '0 10px',
    opacity: 1,
    transition: 'all 300ms',

    ':hover': {
      opacity: 0.6
    }
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentContainer__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var styles = void 0;
var SEVENSHARP_LOGO = __webpack_require__(576);
var TVNZ_LOGO = __webpack_require__(578);
var ONENEWS_LOGO = __webpack_require__(575);
var STUFF_LOGO = __webpack_require__(577);

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.container) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__ContentContainer__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.heading) },
        'As Seen On'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.brands) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.brand) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: ONENEWS_LOGO, alt: 'One News Now', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.onenews) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.brand) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: TVNZ_LOGO, alt: 'TVNZ', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.tvnz) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.brand) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: SEVENSHARP_LOGO, alt: 'Seven Sharp', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.sevensharp) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.brand) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: STUFF_LOGO, alt: 'Stuff', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.stuff) })
        )
      )
    )
  );
});

styles = __WEBPACK_IMPORTED_MODULE_1_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    padding: '35px 0',
    textAlign: 'center',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].white

  }, __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].mobile_query, {
    padding: '45px 0 35px'
  }),
  heading: {
    marginBottom: 35,
    fontFamily: __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].font_family_secondary,
    fontSize: 15,
    letterSpacing: 2,
    textTransform: 'uppercase',
    fontWeight: __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].font_weight_heading,
    lineHeight: 1.73,
    color: '#000e1f'
  },
  brands: _defineProperty({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 920,
    margin: '0 auto 46px'

  }, __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto',
    flexWrap: 'wrap',
    justifyContent: 'center'
  }),
  brand: _defineProperty({
    margin: '0 60px'

  }, __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].mobile_query, {
    margin: 0,
    padding: '15px 30px'
  }),
  onenews: {
    maxWidth: 181,
    maxHeight: 37
  },
  tvnz: {
    maxWidth: 86,
    maxHeight: 107
  },
  sevensharp: {
    maxWidth: 89,
    maxHeight: 75
  },
  stuff: {
    maxWidth: 88,
    maxHeight: 72
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var BlogCard = function (_Component) {
  _inherits(BlogCard, _Component);

  function BlogCard() {
    _classCallCheck(this, BlogCard);

    return _possibleConstructorReturn(this, (BlogCard.__proto__ || Object.getPrototypeOf(BlogCard)).apply(this, arguments));
  }

  _createClass(BlogCard, [{
    key: 'getDogImage',
    value: function getDogImage() {
      if (this.props.image && this.props.image.length > 6) {
        return this.props.image;
      }

      return '/images/default_dog.jpg';
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
        { to: '/blog/' + this.props.slug, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.card), id: this.props.slug },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.card_image) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.card_photo), src: this.props.image, alt: this.props.title })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.card_details) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.card_meta) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.card_title) },
              this.props.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.card_date) },
              this.props.date
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.card_summary) },
              this.props.summary
            )
          )
        )
      );
    }
  }]);

  return BlogCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (BlogCard);


BlogCard.defaultProps = {
  status: null,
  signup: false,
  interests: []
};

BlogCard.propTypes = {
  slug: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  image: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  summary: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  card: {
    position: 'relative',
    display: 'block',
    width: 262,
    minWidth: 262,
    padding: 18,
    margin: '0 15px 23px',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.05)',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].lighter_grey,
    transition: 'all 300ms',

    ':hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 6px 11px 0 rgba(0, 0, 0, 0.05)'
    }
  },
  card_image: {
    position: 'relative',
    display: 'block',
    margin: '-18px -18px 10px',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].black,

    ':before': {
      display: 'block',
      width: '100%',
      paddingTop: 'calc((200 / 280) * 100%)',
      content: '""'
    }
  },
  card_photo: {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'block',
    height: '100%',
    width: '100%',
    objectFit: 'cover'
  },
  card_title: {
    marginBottom: 10,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_heading,
    fontSize: 20,
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].black,
    lineHeight: 1.4
  },
  card_date: _defineProperty({
    marginBottom: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_primary,
    fontSize: 14,
    color: '#828282'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    marginBottom: 0
  }),
  card_summary: {
    marginBottom: 12.7,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_primary,
    fontSize: 14,
    lineHeight: 1.4,
    color: '#021a36'
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TextField__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var CLOSE_ICON = __webpack_require__(67);

var CancelRequestModal = function (_Component) {
  _inherits(CancelRequestModal, _Component);

  function CancelRequestModal(props) {
    _classCallCheck(this, CancelRequestModal);

    var _this = _possibleConstructorReturn(this, (CancelRequestModal.__proto__ || Object.getPrototypeOf(CancelRequestModal)).call(this, props));

    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.updateTextField = _this.updateTextField.bind(_this);

    _this.state = {
      message: '',
      charCount: 0
    };
    return _this;
  }

  _createClass(CancelRequestModal, [{
    key: 'handleClose',
    value: function handleClose() {
      this.setState({
        message: '',
        charCount: 0
      });
      this.props.onClose();
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(event) {
      if (event && event.preventDefault) {
        event.preventDefault();
      }

      var trimmedMessage = this.state.message.trim();

      this.props.onSubmit(trimmedMessage);
      this.handleClose();
    }
  }, {
    key: 'updateTextField',
    value: function updateTextField(key, value) {
      var charCount = value.length;

      if (charCount <= 500) {
        this.setState({
          message: value,
          charCount: charCount
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpen = _props.isOpen,
          dogName = _props.dogName,
          recipientName = _props.recipientName;


      var modalStyle = {
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          zIndex: 9999
        },
        content: {
          border: 0,
          padding: 0,
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
          borderRadius: 5,
          width: 580,
          maxWidth: '95%'
        }
      };

      var recipientDisplayName = recipientName || 'the other member';
      var messagePlaceholder = recipientName ? 'Hi ' + recipientName + ', I need to cancel because...' : 'I need to cancel because...';

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_modal___default.a,
        {
          isOpen: isOpen,
          onRequestClose: this.handleClose,
          contentLabel: 'Cancel match request',
          style: modalStyle
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modal) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'button',
            { onClick: this.handleClose, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.close) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { src: CLOSE_ICON, alt: 'Close' })
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h2',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.title) },
            'Cancel your request'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'p',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.description) },
            'Let ',
            recipientDisplayName,
            ' know why you\u2019re cancelling your request to share ',
            dogName,
            '. They will see this message in their cancellation email.'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'form',
            { onSubmit: this.handleSubmit },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.input_container) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TextField__["a" /* default */], {
                textArea: true,
                name: 'message',
                value: this.state.message,
                handler: this.updateTextField,
                placeholder: messagePlaceholder,
                styles: styles.textAreaField
              }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.char_count) },
                this.state.charCount,
                '/500 characters'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.buttons) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* default */], {
                title: 'Go back',
                handler: this.handleClose,
                theme: 'grey',
                styles: styles.cancel_button
              }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* default */], {
                title: 'Confirm cancellation',
                handler: this.handleSubmit,
                theme: 'blue',
                styles: styles.submit_button
              })
            )
          )
        )
      );
    }
  }]);

  return CancelRequestModal;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

CancelRequestModal.propTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool.isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  dogName: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  recipientName: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string
};

CancelRequestModal.defaultProps = {
  dogName: 'this dog',
  recipientName: null
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  modal: {
    padding: 40,
    position: 'relative'
  },
  close: {
    position: 'absolute',
    top: 20,
    right: 20,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    outline: 'none'
  },
  title: {
    fontSize: 24,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_secondary,
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary_color,
    marginBottom: 20,
    paddingRight: 30
  },
  description: {
    fontSize: 16,
    lineHeight: 1.5,
    color: '#000e1f',
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary
  },
  input_container: {
    marginBottom: 30
  },
  textAreaField: {
    display: 'flex',
    flexDirection: 'column',
    height: 150,
    width: '100%',
    marginBottom: 10,

    ':not(.a) > *': {
      flexGrow: 1
    }
  },
  char_count: {
    textAlign: 'right',
    fontSize: 14,
    color: '#999',
    marginTop: 5,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 15
  },
  cancel_button: {
    minWidth: 140
  },
  submit_button: {
    minWidth: 200
  }
});

/* harmony default export */ __webpack_exports__["a"] = (CancelRequestModal);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_stripe_elements__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Button__ = __webpack_require__(15);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable */














var CLOSE_ICON = __webpack_require__(305);

var styles = void 0;

var CancelSubscriptionModal = function (_Component) {
  _inherits(CancelSubscriptionModal, _Component);

  function CancelSubscriptionModal(props) {
    _classCallCheck(this, CancelSubscriptionModal);

    var _this = _possibleConstructorReturn(this, (CancelSubscriptionModal.__proto__ || Object.getPrototypeOf(CancelSubscriptionModal)).call(this, props));

    _this.handleClose = _this.handleClose.bind(_this);

    _this.state = {
      error: null
    };
    return _this;
  }

  _createClass(CancelSubscriptionModal, [{
    key: 'handleClose',
    value: function handleClose() {
      this.props.closeHandler();
    }
  }, {
    key: 'submit',
    value: function submit() {
      var _this2 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      }));

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_user__["g" /* updateUserRemote */])({
        renew_membership: false,
        card_token: null,
        last4: null
      }, this.props.user.access_token)).then(function (response) {
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
          loading: false
        }));

        _this2.props.closeHandler();
      }, function (err) {
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
          loading: false
        }));

        _this2.props.closeHandler();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_modal___default.a,
        {
          isOpen: this.props.open,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.container),
          onRequestClose: this.handleClose,
          style: {
            overlay: {
              backgroundColor: 'rgba(0,0,0,0.67)',
              zIndex: 101,
              display: 'flex'
            }
          },
          contentLabel: 'Cancel subscription'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.modal_wrapper) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.header) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.title) },
              'Cancel your resubscription'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.close_icon),
                onClick: this.handleClose,
                role: 'button',
                tabIndex: 0
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: CLOSE_ICON, alt: 'Close modal' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.body) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.text) },
              'We know dog needs change across life, so we have made it easy for you to come and go. By cancelling your planned resubscription today, your current subscription term will auto-expire on its one year anniversary. To re-join after this date simply log in using your email address and password and add a payment method. Or if there is anything else we can help you with before or after you depart, ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Link */],
                { to: '/contact' },
                'get in touch'
              ),
              '. We\'re here for good!'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.button_container) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Button__["a" /* default */], {
                title: 'Cancel my resubscription',
                styles: styles.button,
                handler: this.submit.bind(this) })
            )
          )
        )
      );
    }
  }]);

  return CancelSubscriptionModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (CancelSubscriptionModal);


CancelSubscriptionModal.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired
};

CancelSubscriptionModal.defaultProps = {
  open: false,
  closeHandler: function closeHandler() {}
};

styles = __WEBPACK_IMPORTED_MODULE_4_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 590,
    maxWidth: '100vw',
    height: 450,
    maxHeight: '100vh',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].white,
    borderRadius: 5,
    overflow: 'hidden',
    outline: 'none',
    margin: 'auto auto'

  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    width: '95%',
    height: 'auto'
  }),
  modal_wrapper: _defineProperty({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: 500,
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 60px'

  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    height: 'auto',
    padding: '0 30px'
  }),
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px 0px'
  },
  title: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 30,
    fontWeight: '900'
  },
  close_icon: {
    position: 'absolute',
    right: 15,
    top: 15,
    outline: 'none',
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6
    }
  },
  full_width_button: {
    width: '100%'
  },
  button: {
    width: '100%'
  },
  body: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  },
  seperator_container: {
    display: 'flex',
    height: 25,
    margin: '25px auto',
    alignItems: 'center',
    justifyContent: 'center',
    ':after': {
      content: "' '",
      position: 'absolute',
      width: '100%',
      height: 1,
      backgroundColor: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].horizontal_rule_color
    }
  },
  text: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_primary,
    textAlign: 'center',
    marginBottom: 10,
    lineHeight: '21px'
  },
  seperator_text: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_primary,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].white,
    zIndex: 10,
    padding: 15
  },
  actions_container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
  footer: _defineProperty({
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    bottom: 0,
    height: 100,
    width: '100%',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].light_grey

  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    position: 'relative',
    height: 'auto',
    marginTop: 30,
    padding: '30px',
    textAlign: 'center'
  }),
  sign_up_container: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 16,
    textAlign: 'center'
  },
  sign_up_link: {
    display: 'inline',
    fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_secondary,
    letterSpacing: 1,
    marginLeft: 5,
    textTransform: 'uppercase',
    fontWeight: 'bold'
  },
  forgotten_password: {
    flex: 1,
    fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14,
    textAlign: 'center'
  },
  login_button_container: {
    flex: 1
  },
  clippy: {
    marginLeft: 20
  },
  copy_button: {
    backgroundColor: 'transparent',
    padding: '10px 20px',
    boxSizing: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
    transition: 'all ease-out 160ms',
    cursor: 'pointer',
    border: 'none'
  },
  copy_button_container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].primary,
    fontSize: 13,
    fontWeight: 'bold'
  },
  button_container: _defineProperty({
    marginTop: 40,
    marginBottom: 20

  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    justifyContent: 'center'
  })
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContentContainer__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var styles = void 0;

var BRAND1 = __webpack_require__(579);
var BRAND2 = __webpack_require__(590);
var BRAND3 = __webpack_require__(595);
var BRAND4 = __webpack_require__(596);
var BRAND6 = __webpack_require__(597);
var BRAND7 = __webpack_require__(598);
var BRAND8 = __webpack_require__(599);
var BRAND9 = __webpack_require__(600);
var BRAND10 = __webpack_require__(580);
var BRAND11 = __webpack_require__(581);
var BRAND12 = __webpack_require__(582);
var BRAND13 = __webpack_require__(583);
var BRAND14 = __webpack_require__(584);
var BRAND15 = __webpack_require__(585);
var BRAND16 = __webpack_require__(586);
var BRAND17 = __webpack_require__(587);

var BRAND18 = __webpack_require__(588);
var BRAND19 = __webpack_require__(589);
var BRAND20 = __webpack_require__(591);
var BRAND21 = __webpack_require__(592);
var BRAND22 = __webpack_require__(593);
var BRAND23 = __webpack_require__(594);

var DONATION_PRICE = 1.00;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.container) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__ContentContainer__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.heading) },
        'We support local charities'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.paragraph) },
        '$',
        DONATION_PRICE.toFixed(2),
        ' of your membership fee goes towards a dog charity of your choosing'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logos) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND1, alt: 'The Underdogs Foundation', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND2, alt: 'Hurrah', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND3, alt: 'SPCA', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND4, alt: 'SAFE', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND6, alt: 'Auckland Puppy Rescue', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND7, alt: 'Assistance Dogs New Zealand Trust', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND8, alt: 'Ruakaka Dog Rescue', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND9, alt: 'Mobility Dogs', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND10, alt: 'HUHA', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
            src: BRAND11,
            alt: 'Chained Dog Rehabilitation and Rehoming NZ',
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND12, alt: 'Rottweiler Rescue & Rehoming', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND13, alt: 'Aspiring Avalanche Dogs', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND14, alt: 'Blind Foundation Guide Dogs', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND15, alt: 'NZ Chihuahua Rescue', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND16, alt: 'Dog Rescue Dunedin', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND17, alt: 'Nightrave Greyhounds', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND18, alt: 'Christchurch Bull Breed Rescue', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND19, alt: 'Dogwatch Sanctuary Trust', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND20, alt: 'Hearing Dogs', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND21, alt: 'New Lives Animal Rescue', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND22, alt: 'Saving Hope', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.charity) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: BRAND23, alt: 'We Love Dogs', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.logo) })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Link */],
        { to: '/story', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.btn) },
        'Find out more'
      )
    )
  );
});

styles = __WEBPACK_IMPORTED_MODULE_1_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    padding: '108px 0',
    textAlign: 'center',
    backgroundColor: '#fff'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    height: 'auto',
    padding: '40px 0 50px'
  }),
  heading: {
    marginBottom: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 30,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_heading,
    lineHeight: 1.17,
    color: '#262626'
  },
  paragraph: {
    marginBottom: 45,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 20,
    fontWeight: 500,
    color: '#000e1f'
  },
  logos: _defineProperty({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    width: 920,
    margin: '0 auto 46px'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginBottom: 20
  }),
  charity: _defineProperty({
    width: '20%',
    marginBottom: 15
  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    padding: 15,
    width: '50%'
  }),
  btn: {
    display: 'block',
    height: 50,
    width: 229,
    margin: '0 auto',
    padding: '0 40px',
    textTransform: 'uppercase',
    fontSize: 15,
    fontWeight: 900,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_secondary,
    lineHeight: '50px',
    letterSpacing: 2,
    textAlign: 'center',
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
    borderRadius: 5,
    border: 0,
    backgroundColor: '#000e1f',
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 300ms',

    ':hover': {
      backgroundColor: '#333e4c'
    }
  },
  logo: {
    maxWidth: 115,
    maxHeight: 102
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_slick__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel_slick_slick_theme_css__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_slick_carousel_slick_slick_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_slick_carousel_slick_slick_css__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_applicationData__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var styles = void 0;

var OurCommunity = function (_React$PureComponent) {
  _inherits(OurCommunity, _React$PureComponent);

  function OurCommunity(props) {
    _classCallCheck(this, OurCommunity);

    var _this = _possibleConstructorReturn(this, (OurCommunity.__proto__ || Object.getPrototypeOf(OurCommunity)).call(this, props));

    _this.state = {
      activeTestimonial: 1,
      readMoreOpen: false
    };
    _this.handleReadMoreToggle = _this.handleReadMoreToggle.bind(_this);
    _this.setSlide = _this.setSlide.bind(_this);
    return _this;
  }

  _createClass(OurCommunity, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Skip API calls during react-snap pre-rendering
      if (navigator.userAgent === 'ReactSnap') {
        this.setState({
          loaded: true,
          testimonials: []
        });
        return;
      }

      this.fetchTestimonials();
    }
  }, {
    key: 'setSlide',
    value: function setSlide(slide, id) {
      var _this2 = this;

      this.setState({
        activeTestimonial: id
      }, function () {
        _this2.slider.slickGoTo(slide);
      });
    }
  }, {
    key: 'handleReadMoreToggle',
    value: function handleReadMoreToggle(e) {
      e.preventDefault();
      this.setState({
        readMoreOpen: !this.state.readMoreOpen
      });
    }
  }, {
    key: 'fetchTestimonials',
    value: function fetchTestimonials() {
      var _this3 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationData__["h" /* getTestimonials */])()).then(function (response) {
          _this3.setState({
            testimonials: response,
            loaded: true
          }, function () {
            setTimeout(function () {
              _this3.slider.innerSlider.onWindowResized();
            }, 0);
          });

          _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        }, function (err) {
          console.log(err); // eslint-disable-line no-console
          _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
          _this3.props.history.push('/404');
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var buttonText = this.state.readMoreOpen ? 'Read Less' : 'Find Out More';

      var sliderSettings = {
        dots: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 15000,
        afterChange: function afterChange(index) {
          _this4.setSlide(index, _this4.state.testimonials[index].id);
        }
      };

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section) },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.column) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'h2',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.heading) },
              'Our Collective Impact'
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.paragraph) },
              'The Dog Share Collective provides practical, economical and sustainable canine companionship solutions for NZ dogs.'
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.paragraph) },
              'By providing innovative solutions to pressing social problems for dogs, and the people who love them, The Dog Share Collective builds a membership, creates a profit, and makes a difference by giving back to the wider dog community.'
            ),
            this.state.readMoreOpen ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.paragraph) },
              'As a social enterprise, The Dog Share Collective difference = $1 of every membership fee being given to a NZ dog charity of our ',
              "member's",
              ' choosing through our charitable trust called The UnderDogs Foundation (CC54581). Called our',
              ' ',
              'Impact Partners',
              ', these proven dog charities provide invaluable service to our communities.',
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
              'By giving them a leg up, we provide maximum support to the widest NZ dog community possible and, together, we become part of something truly great.'
            ) : null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'button',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.more), onClick: this.handleReadMoreToggle },
              buttonText
            )
          ),
          this.state.testimonials ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.column, styles.column_testimonials) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.slides) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_slick___default.a,
                Object.assign({}, sliderSettings, {
                  ref: function ref(slider) {
                    _this4.slider = slider;
                  }
                }),
                this.state.testimonials.map(function (testimonial) {
                  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    {
                      key: testimonial.id,
                      className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.slide, testimonial.id === _this4.state.activeTestimonial ? styles.slide_active : null)
                    },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', {
                      className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.photo),
                      src: testimonial.image,
                      alt: testimonial.name
                    }),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.testimonial) },
                      testimonial.copy
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.author) },
                      testimonial.name,
                      ', ',
                      testimonial.location
                    )
                  );
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.indicators) },
              this.state.testimonials.map(function (testimonial, index) {
                return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', {
                  onClick: function onClick() {
                    return _this4.setSlide(index, testimonial.id);
                  },
                  role: 'button',
                  tabIndex: 0,
                  key: testimonial.id,
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.indicator, testimonial.id === _this4.state.activeTestimonial ? styles.indicator_active : null)
                });
              })
            )
          ) : null
        )
      );
    }
  }]);

  return OurCommunity;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.PureComponent);

/* harmony default export */ __webpack_exports__["a"] = (OurCommunity);


OurCommunity.defaultProps = {
  history: function history() {}
};

OurCommunity.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  section: _defineProperty({
    padding: '108px 0',
    backgroundColor: '#fff'

  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    height: 'auto',
    padding: '40px 0 50px',
    textAlign: 'center'
  }),
  container: _defineProperty({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '100%',
    maxWidth: '100vw',
    width: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].container_width,
    margin: '0 auto',
    padding: '0 15px'

  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    display: 'block',
    width: '100%'
  }),
  heading: _defineProperty({
    width: 410,
    marginBottom: 40,
    fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 40,
    fontWeight: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_weight_heading,
    color: '#020440'

  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto',
    fontSize: 30
  }),
  paragraph: _defineProperty({
    width: 410,
    marginBottom: '1em',
    fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 15,
    fontWeight: 500,
    lineHeight: '1.6',
    color: '#828282'

  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto',
    padding: '0 15px'
  }),
  more: _defineProperty({
    display: 'inline-block',
    marginTop: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_secondary,
    color: '#39b4d6',
    textTransform: 'uppercase',
    lineHeight: 1.4,
    letterSpacing: 2,
    fontSize: 15,
    border: 'none',
    borderBottom: '2px solid #39b4d6',
    backgroundColor: 'transparent',
    outline: 'none',
    cursor: 'pointer'
  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    marginTop: 0,
    marginBottom: 30
  }),
  column_testimonials: _defineProperty({
    marginLeft: 80,
    // marginTop: 50,
    textAlign: 'center'

  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto',
    marginLeft: 0,
    marginTop: 30
  }),
  slides: _defineProperty({
    width: 571

  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  slide: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  photo: {
    height: 120,
    width: 120,
    marginBottom: 21,
    borderRadius: '50%'
  },
  testimonial: {
    marginBottom: 40,
    fontSize: 20,
    fontWeight: 500,
    fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_primary,
    color: '#000e1f'
  },
  author: {
    fontSize: 14,
    fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_primary,
    color: '#828282'
  },
  indicators: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 40
  },
  indicator: {
    height: 14,
    width: 14,
    margin: '0 11px',
    borderRadius: '50%',
    backgroundColor: '#fff',
    border: 'solid 1px #d0d0d0',
    cursor: 'pointer',
    outline: 'none'
  },
  indicator_active: {
    borderColor: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].primary,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].primary
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var CLOSE_ICON = __webpack_require__(309);

var ConditionsModal = function (_Component) {
  _inherits(ConditionsModal, _Component);

  function ConditionsModal(props) {
    _classCallCheck(this, ConditionsModal);

    var _this = _possibleConstructorReturn(this, (ConditionsModal.__proto__ || Object.getPrototypeOf(ConditionsModal)).call(this, props));

    _this.toggle = _this.props.toggle.bind(_this);
    return _this;
  }

  _createClass(ConditionsModal, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_modal___default.a,
        {
          isOpen: this.props.open,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container),
          style: {
            overlay: {
              backgroundColor: 'rgba(0,0,0,0.67)',
              zIndex: 10,
              display: 'flex'
            }
          },
          contentLabel: 'Report'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.modal_wrapper) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.header) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.title) },
              'Conditions'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.close_icon),
                onClick: this.props.toggle,
                role: 'button',
                tabIndex: 0
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: CLOSE_ICON, alt: 'Close modal' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.body) },
            this.props.children
          )
        )
      );
    }
  }]);

  return ConditionsModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ConditionsModal);


ConditionsModal.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].node).isRequired, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object]).isRequired
};

ConditionsModal.defaultProps = {
  open: false
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 590,
    maxWidth: '95vw',
    maxHeight: '50vh',
    transform: 'translateY(40px)',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    borderRadius: 5,
    overflow: 'auto',
    outline: 'none',
    margin: 'auto auto'
  },
  modal_wrapper: _defineProperty({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    // height: 600 - 100,
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 80px 40px'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0 30px 50px'
  }),
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px 0px 35px'
  },
  title: {
    marginBottom: 0,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 30,
    fontWeight: '900'
  },
  close_icon: {
    position: 'absolute',
    right: 5,
    top: 5,
    outline: 'none',
    cursor: 'pointer',
    padding: 10,
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6
    }
  },
  body: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    textAlign: 'center',

    ':not(.a) > p': {
      marginBottom: 20,
      fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
      fontSize: 14,
      color: '#828282'
    }
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// import ActivityBadge from '../ActivityBadge';

var FAQ = function (_Component) {
  _inherits(FAQ, _Component);

  function FAQ(props) {
    _classCallCheck(this, FAQ);

    var _this = _possibleConstructorReturn(this, (FAQ.__proto__ || Object.getPrototypeOf(FAQ)).call(this, props));

    _this.state = {
      visible: false
    };
    return _this;
  }

  _createClass(FAQ, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container, this.props.visible ? null : styles.container_hidden) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.question) },
          this.props.question
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.answer) },
          this.props.children
        )
      );
    }
  }]);

  return FAQ;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FAQ);


FAQ.defaultProps = {
  visible: false
};

FAQ.propTypes = {
  question: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].node).isRequired, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object]).isRequired,
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container_hidden: {
    display: 'none'
  },
  question: {
    marginBottom: 31,
    fontSize: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_heading,
    color: '#262626',
    lineHeight: '1.2'
  },
  answer: {
    ':not(.a) > p': {
      fontSize: 15,
      fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_primary,
      fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_primary,
      color: '#000e1f',
      lineHeight: 1.8,

      ':not(:last-child)': {
        marginBottom: 15
      }
    }
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_load_script__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_load_script___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_load_script__);


var initialized = false;
var queue = [];

function fb(callback) {
  // Skip Facebook SDK loading during pre-rendering
  if (navigator.userAgent === 'ReactSnap') {
    return;
  }

  if (initialized) {
    callback(window.FB);
  } else {
    queue.push(callback);
    if (!window.fbAsyncInit) {
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: 407792786407248,
          autoLogAppEvents: true,
          status: true,
          cookie: true,
          xfbml: false,
          version: 'v3.2'
        });
        initialized = true;
        queue.forEach(function (cb) {
          return cb(window.FB);
        });
        queue = null;
      };
      var script = window.localStorage.getItem('fb:debug') === 'true' ? 'xfbml.customerchat/debug.js' : 'xfbml.customerchat.js';
      __WEBPACK_IMPORTED_MODULE_0_load_script___default()('https://connect.facebook.net/en_US/sdk/' + script, { async: true });
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (fb);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScriptLoader__ = __webpack_require__(181);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var FacebookChat = function (_React$PureComponent) {
  _inherits(FacebookChat, _React$PureComponent);

  function FacebookChat() {
    _classCallCheck(this, FacebookChat);

    return _possibleConstructorReturn(this, (FacebookChat.__proto__ || Object.getPrototypeOf(FacebookChat)).apply(this, arguments));
  }

  _createClass(FacebookChat, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.timeout = setTimeout(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ScriptLoader__["a" /* default */])(function (FB) {
          return _this2.timeout && FB.XFBML.parse();
        });
      }, 2000);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
      delete this.timeout;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        className: 'fb-customerchat',
        attribution: 'setup_tool',
        page_id: '1554157068222377'
      });
    }
  }]);

  return FacebookChat;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

/* harmony default export */ __webpack_exports__["a"] = (FacebookChat);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ActivitySelect__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NeedsSelect__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Select__ = __webpack_require__(46);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var styles = void 0;
var CLOSE_ASSET = __webpack_require__(311);

var FindADog = function (_Component) {
  _inherits(FindADog, _Component);

  function FindADog(props) {
    _classCallCheck(this, FindADog);

    var _this = _possibleConstructorReturn(this, (FindADog.__proto__ || Object.getPrototypeOf(FindADog)).call(this, props));

    _this.state = {
      redirect: false
    };
    _this.handleSearch = props.handleSearch.bind(_this, _this.props.interests, _this.props.needs, _this.props.district, _this.props.breeds);

    _this.handleDistrict = _this.props.handleDistrict.bind(_this);
    _this.handleSuburb = _this.props.handleSuburb.bind(_this);
    _this.handleInterests = _this.props.handleInterests.bind(_this);
    _this.clearInterests = _this.props.clearInterests.bind(_this);
    _this.handleNeeds = _this.props.handleNeeds.bind(_this);
    _this.clearNeeds = _this.props.clearNeeds.bind(_this);
    _this.handleBreeds = _this.props.handleBreeds.bind(_this);
    return _this;
  }

  _createClass(FindADog, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (this.state.redirect) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Redirect */], { push: true, to: '/find' });
      }

      var selectedDistrict = this.props.appdata.localitydistrict.find(function (district) {
        return _this2.props.district && district.id === parseInt(_this2.props.district, 10);
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        {
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container, this.props.mobFilterVisible ? styles.container_show : null)
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          {
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.select_container, this.props.nearestMe && styles.select_container_disabled)
          },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Select__["a" /* default */], {
            name: 'district',
            placeholder: this.props.nearestMe ? 'Using your location' : 'All Regions',
            options: this.props.appdata.localitydistrict.map(function (district) {
              return {
                value: district.id,
                label: district.title
              };
            }),
            value: this.props.district,
            handler: this.handleDistrict,
            type: 'location',
            style: styles.select,
            disabled: this.props.nearestMe
          })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          {
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.select_container, this.props.nearestMe && styles.select_container_disabled)
          },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Select__["a" /* default */], {
            name: 'suburb',
            placeholder: this.props.nearestMe ? 'Using your location' : 'All Suburbs',
            disabled: !this.props.district || this.props.nearestMe,
            options: selectedDistrict ? this.props.appdata.suburb.filter(function (suburb) {
              return selectedDistrict.id === suburb.district.id;
            }).map(function (suburb) {
              return {
                value: suburb.id,
                label: suburb.title
              };
            }) : [],
            value: this.props.suburb,
            handler: this.handleSuburb,
            type: 'location',
            style: styles.select
          })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.select_container) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Select__["a" /* default */], {
            name: 'breed',
            placeholder: 'All Breeds',
            options: this.props.appdata.breed.filter(function (breed) {
              return breed.enabled;
            }).map(function (breed) {
              return {
                value: breed.id,
                label: breed.title
              };
            }),
            value: this.props.breeds,
            handler: this.handleBreeds,
            type: 'breed',
            style: styles.select
          })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.select_container) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ActivitySelect__["a" /* default */], {
            value: this.props.interests,
            handler: this.handleInterests,
            clear: this.clearInterests,
            interests: this.props.appdata.interest
          })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.select_container) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__NeedsSelect__["a" /* default */], {
            value: this.props.needs,
            handler: this.handleNeeds,
            clear: this.clearNeeds,
            needs: this.props.appdata.need
          })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'button',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.submit), onClick: this.handleSearch },
          'Find a Dog'
        )
      );
    }
  }]);

  return FindADog;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FindADog);


FindADog.defaultProps = {
  district: null,
  suburb: null,
  breeds: null,
  interests: null,
  needs: null,
  nearestMe: false,
  handleDistrict: function handleDistrict() {},
  handleSuburb: function handleSuburb() {},
  handleBreeds: function handleBreeds() {},
  handleInterests: function handleInterests() {},
  clearInterests: function clearInterests() {},
  handleNeeds: function handleNeeds() {},
  clearNeeds: function clearNeeds() {},
  toggleMobFilter: function toggleMobFilter() {},
  mobFilterVisible: false
};

FindADog.propTypes = {
  appdata: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  handleSearch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  district: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOf([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number]),
  suburb: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOf([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number]),
  breeds: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOf([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number]),
  interests: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOf([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number]),
  needs: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOf([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number]),
  nearestMe: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  handleDistrict: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func,
  handleSuburb: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func,
  handleBreeds: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func,
  handleInterests: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func,
  clearInterests: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func,
  handleNeeds: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func,
  clearNeeds: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func,
  mobFilterVisible: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool
};

styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  heading: {
    marginTop: 30,
    marginBottom: 30,
    lineHeight: 2.09,
    textAlign: 'center',
    fontSize: 28,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_heading
  },
  close: {
    position: 'absolute',
    top: 15,
    right: 15,
    left: 'auto',
    zIndex: 6,
    height: 20,
    width: 20,
    backgroundImage: 'url(\'' + CLOSE_ASSET + '\')',
    backgroundSize: 'cover'
  },
  select: _defineProperty({
    position: 'absolute',
    width: '180'
  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  container: _defineProperty({
    position: 'relative',
    zIndex: 5,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginBottom: 27

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    position: 'relative',
    top: 0,
    left: 0,
    zIndex: 5,
    width: '100%',
    padding: '10px',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    opacity: 1
  }),
  container_show: _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    opacity: 1,
    pointerEvents: 'initial'
  }),
  select_container: _defineProperty({
    position: 'relative',
    margin: '0 5px 10px',
    width: 180,
    height: 50

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    margin: '0 5px 10px',
    width: '100%'
  }),
  select_container_disabled: {
    opacity: 0.6,
    cursor: 'not-allowed'
  },
  submit: _defineProperty({
    width: 173,
    height: 50,
    margin: '0 5px 10px',
    textTransform: 'uppercase',
    fontSize: 15,
    fontWeight: 900,
    lineHeight: 1.73,
    letterSpacing: 2,
    textAlign: 'center',
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    borderRadius: 5,
    border: 0,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary,
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 300ms',

    ':hover': {
      backgroundColor: '#61c3df'
    },

    '@media screen and (max-width: 750px)': {
      width: 167
    }

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto'
  })
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var styles = void 0;

var FooterColumn = function FooterColumn(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.header) },
      props.title
    ),
    props.children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (FooterColumn);

FooterColumn.defaultProps = {
  children: null
};

FooterColumn.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].node).isRequired, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object])
};

styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    display: 'flex',
    flexDirection: 'column',
    width: '25%'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    width: '50%',
    padding: '0 20px',
    flexShrink: 0,
    marginBottom: 30
  }),
  header: {
    display: 'flex',
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_heading,
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
    fontSize: 15,
    letterSpacing: 1,
    marginBottom: 25
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);






var styles = void 0;

var FooterItem = function FooterItem(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
    { to: props.url },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container, props.styles) },
      props.title
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (FooterItem);

FooterItem.propTypes = {
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].array),
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired
};

FooterItem.defaultProps = {
  styles: []
};

styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: {
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].footer.font_size,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_primary,
    marginBottom: 16,
    transition: 'all 150ms ease-in-out',
    ':hover': {
      opacity: 0.6
    }
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var GlobalMessage = function (_Component) {
  _inherits(GlobalMessage, _Component);

  function GlobalMessage() {
    _classCallCheck(this, GlobalMessage);

    return _possibleConstructorReturn(this, (GlobalMessage.__proto__ || Object.getPrototypeOf(GlobalMessage)).apply(this, arguments));
  }

  _createClass(GlobalMessage, [{
    key: 'createMarkup',
    value: function createMarkup() {
      return {
        __html: this.props.message
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.container) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.global_message_box) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.global_message_title_container, styles.larger) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.global_message_title) },
              this.props.title
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.global_message_container) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
              className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.global_message)
              // eslint-disable-next-line
              , dangerouslySetInnerHTML: this.createMarkup() })
          )
        )
      );
    }
  }]);

  return GlobalMessage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

GlobalMessage.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string
};

GlobalMessage.defaultProps = {
  title: '',
  message: ''
};

var styles = __WEBPACK_IMPORTED_MODULE_3_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    position: 'relative',
    margin: 10

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto'
  }),
  form_group: _defineProperty({
    display: 'flex',
    flexDirection: 'row'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column'
  }),
  global_message_box: _defineProperty({
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    position: 'relative',
    display: 'flex',
    padding: 20,
    flex: 1,
    height: 'auto',
    margin: '20px auto',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
    flexDirection: 'column'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column',
    height: 'auto'
  }),
  global_message_title_container: _defineProperty({
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 15

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    marginBottom: 15,
    flexDirection: 'column'
  }),
  larger: {
    flex: 2,
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  global_message_title: _defineProperty({
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 20,
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].black,
    fontWeight: 'bold',
    marginRight: 10

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    marginBottom: 5
  }),
  global_message_container: _defineProperty({
    flex: 1,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    marginBottom: 15,
    flexDirection: 'column'
  }),
  global_message: _defineProperty({
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 16,
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].black,
    marginRight: 10

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    marginBottom: 5
  })
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* mapDispatchToProps */])(GlobalMessage));

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var styles = void 0;

var HeroHeading = function HeroHeading(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container) },
    props.children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (HeroHeading);

HeroHeading.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].node).isRequired, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string]).isRequired
};

styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 100,
    textAlign: 'center',
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
    width: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].container_width / 2,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_heading,
    marginBottom: 10

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    padding: '0 25px',
    fontSize: 45
  })
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_search__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DogCard__ = __webpack_require__(37);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var styles = void 0;

var HomepageFeaturedDogs = function (_Component) {
  _inherits(HomepageFeaturedDogs, _Component);

  function HomepageFeaturedDogs(props) {
    _classCallCheck(this, HomepageFeaturedDogs);

    var _this = _possibleConstructorReturn(this, (HomepageFeaturedDogs.__proto__ || Object.getPrototypeOf(HomepageFeaturedDogs)).call(this, props));

    _this.handleSearch = _this.performSearch.bind(_this);
    _this.handleInterests = _this.toggleInterest.bind(_this);
    _this.handleNeeds = _this.toggleNeed.bind(_this);
    _this.handleCity = _this.setCity.bind(_this);
    _this.handleDistrict = _this.setDistrict.bind(_this);
    _this.handleBreeds = _this.setBreeds.bind(_this);
    _this.toggleMobFilter = _this.toggleMobFilter.bind(_this);

    _this.state = {
      results: [],
      interests: [],
      needs: [],
      city: null,
      district: null,
      breeds: null,
      filterVisibleMob: false
    };
    return _this;
  }

  _createClass(HomepageFeaturedDogs, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Skip API calls during react-snap pre-rendering
      if (navigator.userAgent === 'ReactSnap') {
        return;
      }

      this.doSearch(false);
    }
  }, {
    key: 'setCity',
    value: function setCity(name, city) {
      this.setState({
        city: city ? city.value : null
      });
    }
  }, {
    key: 'setDistrict',
    value: function setDistrict(name, district) {
      this.setState({
        district: district ? district.value : null
      });
    }
  }, {
    key: 'setBreeds',
    value: function setBreeds(name, breeds) {
      this.setState({
        breeds: breeds.value
      });
    }
  }, {
    key: 'toggleMobFilter',
    value: function toggleMobFilter() {
      this.setState({
        filterVisibleMob: !this.state.filterVisibleMob
      });
    }
  }, {
    key: 'toggleInterest',
    value: function toggleInterest(selected, interestID) {
      if (selected) {
        this.setState({
          interests: [].concat(this.state.interests, [interestID])
        });
      } else {
        this.setState({
          interests: this.state.interests.filter(function (interest) {
            return interest !== interestID;
          })
        });
      }
    }
  }, {
    key: 'toggleNeed',
    value: function toggleNeed(selected, needID) {
      if (selected) {
        this.setState({
          needs: [].concat(this.state.needs, [needID])
        });
      } else {
        this.setState({
          needs: this.state.needs.filter(function (interest) {
            return interest !== needID;
          })
        });
      }
    }
  }, {
    key: 'doSearch',
    value: function doSearch() {
      var showLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.performSearch(this.state.interests, this.state.city, this.state.district, this.state.breeds, this.state.needs, showLoading);
    }
  }, {
    key: 'performSearch',
    value: function performSearch(interests, city, district, breeds, needs) {
      var _this2 = this;

      var showLoading = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

      var cityQuery = city;
      var districtQuery = district;
      var breedsQuery = typeof breeds === 'number' ? [breeds] : null;
      var interestsQuery = interests && interests.length ? interests : null;
      var needsQuery = needs && needs.length ? needs : null;

      this.setState({
        filterVisibleMob: false
      });

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions_applicationState__["a" /* updateAppState */])({
        loading: showLoading,
        loading_text: 'Searching'
      })).then(function () {
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_search__["a" /* search */])(interestsQuery, cityQuery, districtQuery, breedsQuery, needsQuery, 1, 'home/search')).then(function (results) {
          _this2.setState({
            results: results,
            count: results.count,
            page: results.page
          });

          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions_applicationState__["a" /* updateAppState */])({
            loading: false,
            loading_text: false
          }));
        }, function (err) {
          console.log(err); // eslint-disable-line

          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions_applicationState__["a" /* updateAppState */])({
            loading: false,
            loading_text: false
          }));
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container) },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__ContentContainer__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cards) },
            this.state.results.length ? this.state.results.map(function (dog) {
              return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__DogCard__["a" /* default */], {
                key: dog.dog_id,
                id: null,
                signup: true,
                image: dog.image_url,
                name: dog.name,
                breed: dog.breed,
                summary: dog.bio,
                interests: dog.interests,
                needs: dog.needs,
                suburb: dog.suburb
              });
            }) : false
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
            { to: '/join', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.more) },
            __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].isMobile ? 'Join to view more' : 'Join us to view more pooches'
          )
        )
      );
    }
  }]);

  return HomepageFeaturedDogs;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (HomepageFeaturedDogs);


HomepageFeaturedDogs.propTypes = {
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired
  // appdata: PropTypes.object.isRequired,
};

styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  container: {
    padding: '0 0 40px',
    backgroundColor: '#fff'
  },
  cards: _defineProperty({
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    margin: '0 -15px'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0 20px'
  }),
  more: _defineProperty({
    display: 'block',
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_secondary,
    fontSize: 15,
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: 2,

    '@media screen and (min-width: 601px)': {
      marginTop: 9,
      color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary
    }

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    height: 50,
    margin: '0 20px',
    lineHeight: '50px',
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    border: 0,
    borderRadius: 5,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary,
    cursor: 'pointer',
    outline: 'none'
  }),
  mob_find: {
    display: 'block',
    width: '100vw',
    height: 50,
    margin: '0 -15px 30px',
    textTransform: 'uppercase',
    fontSize: 15,
    fontWeight: 900,
    lineHeight: 1.73,
    letterSpacing: 2,
    textAlign: 'center',
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary,
    border: 0,
    borderTop: '1px solid #cecece',
    borderBottom: '1px solid #cecece',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 300ms'
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_scroll__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CompanyLogo__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HeroHeading__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Paragraph__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ScrollDownTrigger__ = __webpack_require__(205);
var _login_link;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var styles = void 0;
var ScrollLink = __WEBPACK_IMPORTED_MODULE_4_react_scroll__["Link"];

var Home = function (_Component) {
  _inherits(Home, _Component);

  function Home(props) {
    _classCallCheck(this, Home);

    var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));

    _this.openLoginHandler = _this.loginModalOpenHandler.bind(_this);
    _this.scrollHandler = props.scrollHandler.bind(_this);

    _this.unauthenticatedLinks = [!__WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].isMobile ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ScrollLink,
      {
        to: 'homepage-inspiration-1',
        spy: true,
        smooth: true,
        duration: 1200,
        className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.login_link),
        key: 'unauthenticated-link-1'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'How It Works'
      )
    ) : null, !__WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].isMobile ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
      {
        to: '/story',
        className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.login_link),
        key: 'unauthenticated-link-2'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'Our Story'
      )
    ) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.login_link),
        onClick: _this.openLoginHandler,
        role: 'link',
        tabIndex: 0,
        key: 'unauthenticated-link-3'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'Login'
      )
    )];
    return _this;
  }

  _createClass(Home, [{
    key: 'loginModalOpenHandler',
    value: function loginModalOpenHandler() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
        login_modal_open: true
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container) },
        !__WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].isMobile ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'video',
          {
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.video),
            autoPlay: true,
            loop: true,
            muted: true,
            style: { opacity: 0 },
            onCanPlay: function onCanPlay(e) {
              e.target.style.opacity = 1;
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source', { src: '/media/background.mp4', type: 'video/mp4' })
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.header_container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.header) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CompanyLogo__["a" /* default */], { styles: styles.company_logo }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.buttons) },
              !this.props.user.isAuthenticated ? this.unauthenticatedLinks : false,
              !__WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].isMobile ? this.props.user.isAuthenticated ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
                { to: '/find' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */], { title: 'Go to Dashboard' })
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
                { to: '/join' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */], { title: 'Join the collective' })
              ) : this.props.user.isAuthenticated ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
                { to: '/find', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.join_link) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  'Dashboard'
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
                { to: '/join', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.join_link) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  'Join'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.hero_text_container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__HeroHeading__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h1',
              null,
              'Be a dog\u2019s best friend'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__Paragraph__["a" /* default */],
            { styles: styles.paragraph },
            'You can',
            '\'',
            't always be around your dog. Good thing is, heaps of people would love to have a dog around, just sometimes. Our mission is to make that introduction, with The Dog Share Collective.'
          ),
          __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].isMobile ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
            { to: '/join', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.join_container) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */], { styles: styles.btn, title: 'Join the collective' })
          ) : null
        ),
        !__WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].isMobile ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ScrollDownTrigger__["a" /* default */], { handler: this.scrollHandler }) : null
      );
    }
  }]);

  return Home;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Home);


Home.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  scrollHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired
};

styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    width: '100vw',
    height: '100vh',
    // backgroundImage: 'url(/images/background.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: '#aaaaaa',
    overflow: 'hidden'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    // height: 'calc(100vh - 40px)',
    // maxHeight: 627,
    height: 'auto',
    backgroundPosition: 'top center',
    backgroundImage: 'url(/images/hero_mob.jpg)',
    backgroundColor: '#001227'
  }),
  video: _defineProperty({
    position: 'absolute',
    top: 0,
    left: 0,
    minWidth: '100%',
    minWeight: '100%',
    maxWidth: '100%',
    width: 'auto',
    height: '100%',
    zIndex: -100,
    transition: 'opacity 1s',
    objectFit: 'cover'
  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    display: 'none',
    height: 0,
    width: 0,
    pointerEvents: 'none'
  }),
  join_container: {
    width: '100%'
  },
  btn: {
    width: 'calc(100% - 40px)',
    margin: '40px 20px 0'
  },
  header_container: _defineProperty({
    position: 'relative',
    display: 'block',
    margin: '0 auto',
    // paddingTop: 20,
    height: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].navigation.height,
    width: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].container_width,
    maxWidth: '100vw'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    height: 110
  }),
  header: {
    position: 'absolute',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    height: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].navigation.height
  },
  company_logo: {
    position: 'absolute',
    top: 10,
    left: 0
  },
  buttons: _defineProperty({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    alignItems: 'flex-start',
    marginTop: 15,
    marginRight: 15
  }),
  login_link: (_login_link = {
    cursor: 'pointer',
    textTransform: 'uppercase',
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_secondary,
    fontSize: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_size_secondary,
    letterSpacing: 1,
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    transition: 'all 160ms ease-in-out',
    marginRight: 40,
    ':hover': {
      color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].primary,
      textShadow: 'none'
    }
  }, _defineProperty(_login_link, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    marginRight: 0,
    lineHeight: '30px'
  }), _defineProperty(_login_link, 'textShadow', '0px 0px 2px #000'), _login_link),
  join_link: {
    cursor: 'pointer',
    textTransform: 'uppercase',
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_secondary,
    fontSize: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_size_secondary,
    lineHeight: '30px',
    letterSpacing: 1,
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].primary,
    transition: 'all 160ms ease-in-out',
    marginLeft: 20,
    paddingLeft: 20,
    ':hover': {
      color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].primary
    },
    ':not(:first-child)': {
      borderLeft: '1px solid #fff'
    }
  },
  hero_text_container: _defineProperty({
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    paddingBottom: 51,
    justifyContent: 'flex-end'
  }),
  paragraph: _defineProperty({
    marginTop: 20,
    lineHeight: '30px',
    width: 630,
    textAlign: 'center',
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto',
    padding: '0 30px'
  })
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContentContainer__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var styles = void 0;

var HomepageInspiration = function HomepageInspiration(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.inspirational, styles['inspirational_' + props.position]) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__ContentContainer__["a" /* default */],
      {
        styles: styles.inspirational_content,
        reverse: Boolean(props.position % 2 && !__WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].isMobile)
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.inspirational_half) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.description) },
          props.description
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.title) },
          props.title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.text) },
          props.text
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (HomepageInspiration);

HomepageInspiration.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  position: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number.isRequired
};

styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  inspirational: _defineProperty({
    display: 'flex',
    position: 'relative',
    width: '100vw',
    height: 700,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundPosition: 'center',
    backgroundSize: 'cover'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    height: 'auto',
    paddingTop: 130,
    paddingBottom: 40,
    backgroundPosition: 'top center'
  }),
  inspirational_1: _defineProperty({
    backgroundImage: 'url("/images/inspirational_1.png")'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    backgroundImage: 'url("/images/inspirational_mob_1.png")'
  }),
  inspirational_2: _defineProperty({
    backgroundImage: 'url("/images/inspirational_2.png")'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    backgroundImage: 'url("/images/inspirational_mob_2.png")'
  }),
  inspirational_3: _defineProperty({
    backgroundImage: 'url("/images/inspirational_3.png")'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    backgroundImage: 'url("/images/inspirational_mob_3.png")'
  }),
  inspirational_content: {
    display: 'flex',
    alignItems: 'center'
  },
  inspirational_half: _defineProperty({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),

  description: _defineProperty({
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_secondary,
    fontSize: 16,
    letterSpacing: 4,
    textTransform: 'uppercase',
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
    marginBottom: 20

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 15,
    letterSpacing: 2
  }),
  title: _defineProperty({
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_heading,
    fontSize: 100,
    width: 500,
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].primary,
    marginBottom: 40

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 45,
    width: 230,
    marginBottom: 20
  }),
  text: _defineProperty({
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_primary,
    fontSize: 18,
    lineHeight: '24px',
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
    width: 310

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    fontSize: 15,
    fontWeight: 500,
    lineHeight: 1.4
  })
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TextField__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var CLOSE_ICON = __webpack_require__(67);

var MatchRequestModal = function (_Component) {
  _inherits(MatchRequestModal, _Component);

  function MatchRequestModal(props) {
    _classCallCheck(this, MatchRequestModal);

    var _this = _possibleConstructorReturn(this, (MatchRequestModal.__proto__ || Object.getPrototypeOf(MatchRequestModal)).call(this, props));

    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.setValue = _this.updateTextField.bind(_this);
    _this.state = {
      message: '',
      charCount: 0
    };
    return _this;
  }

  _createClass(MatchRequestModal, [{
    key: 'handleClose',
    value: function handleClose() {
      this.setState({
        message: '',
        charCount: 0
      });
      this.props.onClose();
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit() {
      this.props.onSubmit(this.state.message);
      this.handleClose();
    }
  }, {
    key: 'updateTextField',
    value: function updateTextField(key, value) {
      if (key === 'message') {
        var charCount = value.length;
        if (charCount <= 500) {
          this.setState({
            message: value,
            charCount: charCount
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var greetingPlaceholder = this.props.ownerName ? 'Hi ' + this.props.ownerName : "Hi 'null'";

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_modal___default.a,
        {
          isOpen: this.props.isOpen,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container),
          style: {
            overlay: {
              backgroundColor: 'rgba(0,0,0,0.67)',
              zIndex: 10,
              display: 'flex'
            }
          },
          contentLabel: 'Match Request'
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modal_wrapper) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.header) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'h2',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.title) },
              'Request to share ',
              this.props.dogName
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              {
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.close_icon),
                onClick: this.handleClose,
                role: 'button',
                tabIndex: 0
              },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { src: CLOSE_ICON, alt: 'Close modal' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.body) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.description) },
              'Add a message to introduce yourself (optional)'
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.comments) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TextField__["a" /* default */], {
                textArea: true,
                name: 'message',
                styles: styles.textArea,
                handler: this.setValue,
                value: this.state.message,
                placeholder: greetingPlaceholder
              }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.charCounter) },
                this.state.charCount,
                ' / 500'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.actions) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Button__["a" /* default */], {
                title: 'Cancel',
                theme: 'white',
                handler: this.handleClose,
                styles: styles.cancel_button
              }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Button__["a" /* default */], {
                title: 'Send',
                theme: 'blue',
                handler: this.handleSubmit,
                styles: styles.submit_button
              })
            )
          )
        )
      );
    }
  }]);

  return MatchRequestModal;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

MatchRequestModal.propTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool.isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  dogName: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  ownerName: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string
};

MatchRequestModal.defaultProps = {
  dogName: 'this dog',
  ownerName: 'the owner'
};

var openModalKeyFrames = {
  from: {
    transform: 'scale(0.8)',
    animationTimingFunction: 'ease-in'
  },

  to: {
    transform: 'scale(1)',
    animationTimingFunction: 'ease-in'
  }
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 590,
    maxWidth: '100vw',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    borderRadius: 5,
    overflow: 'hidden',
    outline: 'none',
    margin: 'auto auto',
    animationName: openModalKeyFrames,
    animationDuration: '100ms',
    animationDirection: 'alternate'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    height: '100%',
    borderRadius: 0
  }),
  modal_wrapper: _defineProperty({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 60px 40px'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0px 20px 20px'
  }),
  header: _defineProperty({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px 0px 35px'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    padding: '40px 0px 25px'
  }),
  title: _defineProperty({
    marginBottom: 0,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 26,
    fontWeight: '900',
    textAlign: 'center'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 22,
    paddingRight: 30,
    paddingLeft: 30
  }),
  close_icon: {
    position: 'absolute',
    right: 15,
    top: 15,
    outline: 'none',
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6
    }
  },
  body: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  },
  description: {
    marginBottom: 25,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 16,
    lineHeight: 1.5,
    color: '#4A4A4A',
    textAlign: 'center'
  },
  comments: {
    position: 'relative',
    width: '100%',
    marginBottom: 30
  },
  textArea: {
    display: 'flex',
    flexDirection: 'column',
    height: 150,
    width: '100%',
    marginBottom: 10,

    ':not(.a) > *': {
      flexGrow: 1
    }
  },
  charCounter: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14,
    color: '#828282',
    textAlign: 'right'
  },
  actions: _defineProperty({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: 15

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column',
    gap: 10
  }),
  cancel_button: _defineProperty({
    width: 150

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  submit_button: _defineProperty({
    width: 150

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  })
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(null, null)(MatchRequestModal));

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TextField__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var CLOSE_ICON = __webpack_require__(320);

var MatchResponseModal = function (_Component) {
  _inherits(MatchResponseModal, _Component);

  function MatchResponseModal(props) {
    _classCallCheck(this, MatchResponseModal);

    var _this = _possibleConstructorReturn(this, (MatchResponseModal.__proto__ || Object.getPrototypeOf(MatchResponseModal)).call(this, props));

    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.setValue = _this.updateTextField.bind(_this);
    _this.state = {
      message: '',
      charCount: 0
    };
    return _this;
  }

  _createClass(MatchResponseModal, [{
    key: 'getModalTitle',
    value: function getModalTitle() {
      return this.props.actionType === 'decline' ? 'Decline Match Request' : 'Not Now Response';
    }
  }, {
    key: 'getModalDescription',
    value: function getModalDescription() {
      if (this.props.actionType === 'decline') {
        return 'Please let ' + this.props.borrowerName + ' know why you\'re declining their request for ' + this.props.dogName + '. This helps them understand and potentially improve future requests.';
      }
      return 'Let ' + this.props.borrowerName + ' know why now isn\'t a good time for sharing ' + this.props.dogName + '. They may be able to try again in the future.';
    }
  }, {
    key: 'getPlaceholder',
    value: function getPlaceholder() {
      if (this.props.actionType === 'decline') {
        return "Thank you for your interest in my dog. Unfortunately, I don't think this would be a good match because...";
      }
      return "Thank you for your interest. Unfortunately, now isn't a good time because...";
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      this.setState({
        message: '',
        charCount: 0
      });
      this.props.onClose();
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      if (!this.state.message.trim()) {
        alert('Please provide a message explaining your decision.');
        return;
      }
      this.props.onSubmit(this.state.message);
      this.handleClose();
    }
  }, {
    key: 'updateTextField',
    value: function updateTextField(key, value) {
      var charCount = value.length;

      if (charCount <= 500) {
        this.setState({
          message: value,
          charCount: charCount
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var modalStyle = {
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          zIndex: 9999
        },
        content: {
          border: 0,
          padding: 0,
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
          borderRadius: 5,
          width: 580,
          maxWidth: '95%'
        }
      };

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_modal___default.a,
        {
          isOpen: this.props.isOpen,
          onRequestClose: this.handleClose,
          contentLabel: this.getModalTitle(),
          style: modalStyle
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modal) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'button',
            { onClick: this.handleClose, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.close) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { src: CLOSE_ICON, alt: 'Close' })
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h2',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.title) },
            this.getModalTitle()
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'p',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.description) },
            this.getModalDescription()
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'form',
            { onSubmit: this.handleSubmit },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.input_container) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TextField__["a" /* default */], {
                textArea: true,
                name: 'message',
                value: this.state.message,
                handler: this.setValue,
                placeholder: this.getPlaceholder(),
                styles: styles.textAreaField
              }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.char_count) },
                this.state.charCount,
                '/500 characters'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.buttons) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Button__["a" /* default */], {
                title: 'Cancel',
                handler: this.handleClose,
                theme: 'grey',
                styles: styles.cancel_button
              }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Button__["a" /* default */], {
                title: 'Send',
                handler: function handler() {
                  return _this2.handleSubmit(new Event('submit'));
                },
                theme: 'blue',
                styles: styles.submit_button
              })
            )
          )
        )
      );
    }
  }]);

  return MatchResponseModal;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

MatchResponseModal.propTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool.isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  actionType: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOf(['decline', 'notNow']).isRequired,
  borrowerName: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  dogName: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  modal: {
    padding: 40,
    position: 'relative'
  },
  close: {
    position: 'absolute',
    top: 20,
    right: 20,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    outline: 'none'
  },
  title: {
    fontSize: 24,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_secondary,
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].primary_color,
    marginBottom: 20,
    paddingRight: 30
  },
  description: {
    fontSize: 16,
    lineHeight: 1.5,
    color: '#000e1f',
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary
  },
  input_container: {
    marginBottom: 30
  },
  textAreaField: {
    display: 'flex',
    flexDirection: 'column',
    height: 150,
    width: '100%',
    marginBottom: 10,

    ':not(.a) > *': {
      flexGrow: 1
    }
  },
  char_count: {
    textAlign: 'right',
    fontSize: 14,
    color: '#999',
    marginTop: 5,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    gap: 15
  },
  cancel_button: {
    minWidth: 100
  },
  submit_button: {
    minWidth: 150
  }
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(MatchResponseModal));

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Api__ = __webpack_require__(18);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var BG = __webpack_require__(602);
var CLOSE = __webpack_require__(321);

var MobileNav = function (_Component) {
  _inherits(MobileNav, _Component);

  function MobileNav(props) {
    _classCallCheck(this, MobileNav);

    var _this = _possibleConstructorReturn(this, (MobileNav.__proto__ || Object.getPrototypeOf(MobileNav)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(MobileNav, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container, this.props.isOpen ? styles.container_open : null) },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.close), onClick: this.props.toggle, role: 'button', tabIndex: 0 }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'ul',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.menu) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'li',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.item) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* NavLink */],
              { to: '/', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.item), onClick: this.props.toggle },
              'Home'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'li',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.item) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* NavLink */],
              { to: '/find', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.item), onClick: this.props.toggle },
              'Find a Dog'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'li',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.item) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* NavLink */],
              { to: '/shares', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.item), onClick: this.props.toggle },
              'My Dog Shares'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'li',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.item) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* NavLink */],
              { to: '/favourites', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.item), onClick: this.props.toggle },
              'My Favourites'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5__utils_Api__["a" /* IS_MESSAGING_ENABLED */] && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'li',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.item) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* NavLink */],
              {
                to: '/inbox',
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.item, styles.item_with_badge),
                onClick: this.props.toggle
              },
              'Messages',
              this.props.unreadCount > 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'span',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.unread_badge) },
                this.props.unreadCount > 99 ? '99+' : this.props.unreadCount
              )
            )
          )
        )
      );
    }
  }]);

  return MobileNav;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MobileNav);


MobileNav.defaultProps = {
  dog: false,
  unreadCount: 0
};

MobileNav.propTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  unreadCount: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 90,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '100vh',
    width: '100vw',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    backgroundImage: 'url(' + BG + ')',
    backgroundSize: 'cover',
    backgroundPosition: '-500px 0',
    opacity: 0,
    pointerEvents: 'none',
    transition: 'opacity 300ms',

    ':before': {
      position: 'absolute',
      height: '100vh',
      width: '100vw',
      top: 0,
      left: 0,
      zIndex: 1,
      backdropFilter: 'blur(20px)',
      content: '""'
    }
  },
  container_open: {
    opacity: 1,
    pointerEvents: 'initial'
  },
  close: {
    position: 'absolute',
    top: 15,
    right: 15,
    left: 'auto',
    zIndex: 6,
    height: 30,
    width: 30,
    backgroundImage: 'url(\'' + CLOSE + '\')',
    backgroundSize: 'cover'
  },
  menu: {
    position: 'relative',
    zIndex: 2,
    margin: 0,
    padding: 0,
    listStyle: 'none'
  },
  item: {
    display: 'block',
    marginBottom: 40,
    fontSize: 24,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: 500,
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    textShadow: '0 2px 2px rgba(0,0,0,.75)',
    textAlign: 'center',
    textTransform: 'uppercase'
  },
  item_with_badge: {
    position: 'relative'
  },
  unread_badge: {
    position: 'absolute',
    top: -10,
    right: -30,
    minWidth: 24,
    height: 24,
    padding: '0 6px',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].secondary,
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    borderRadius: 12,
    fontSize: 14,
    fontWeight: 'bold',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
    textShadow: 'none'
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JumboSelect__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ActivityCard__ = __webpack_require__(43);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ICON_ASSET = __webpack_require__(322);

var NeedsSelect = function (_Component) {
  _inherits(NeedsSelect, _Component);

  function NeedsSelect(props) {
    _classCallCheck(this, NeedsSelect);

    var _this = _possibleConstructorReturn(this, (NeedsSelect.__proto__ || Object.getPrototypeOf(NeedsSelect)).call(this, props));

    _this.handleSelect = _this.props.handler.bind(_this);
    return _this;
  }

  _createClass(NeedsSelect, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__JumboSelect__["a" /* default */],
        {
          label: 'Needs',
          icon: ICON_ASSET,
          selected: this.props.value ? this.props.value.length : 0,
          modifier: 'needs',
          clear: this.props.clear
        },
        this.props.needs.map(function (need) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ActivityCard__["a" /* default */], {
            key: need.id,
            id: need.id,
            value: _this2.props.value && _this2.props.value.length > 0 && _this2.props.value.find(function (needID) {
              return needID === need.id;
            }),
            label: need.title,
            onSelect: _this2.handleSelect });
        })
      );
    }
  }]);

  return NeedsSelect;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (NeedsSelect);


NeedsSelect.defaultProps = {
  value: [],
  handler: function handler() {},
  clear: function clear() {}
};

NeedsSelect.propTypes = {
  handler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func, //eslint-disable-line
  clear: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func, //eslint-disable-line
  needs: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].array.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].array
};

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_react_loader_dismiss_svg__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_react_loader_dismiss_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_react_loader_dismiss_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserImage__ = __webpack_require__(47);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







 // eslint-disable-line


var UserMenu = function (_Component) {
  _inherits(UserMenu, _Component);

  function UserMenu(props) {
    _classCallCheck(this, UserMenu);

    var _this = _possibleConstructorReturn(this, (UserMenu.__proto__ || Object.getPrototypeOf(UserMenu)).call(this, props));

    _this.readHandler = _this.notificationRead.bind(_this);
    return _this;
  }

  _createClass(UserMenu, [{
    key: 'notificationRead',
    value: function notificationRead() {
      this.props.handler(this.props.id, this.props.type);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.notification) },
        this.props.image ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UserImage__["a" /* default */], { styles: styles.notification_image, image: this.props.image }) : false,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.notification_content) },
          this.props.children,
          this.props.profileLink ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* NavLink */],
            {
              onClick: this.readHandler,
              to: this.props.profileLink,
              className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.notification_view)
            },
            'View profile'
          ) : null
        ),
        this.props.closable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_react_loader_dismiss_svg___default.a, {
          onClick: this.readHandler,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.notification_dismiss) }) : false
      );
    }
  }]);

  return UserMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (UserMenu);


UserMenu.defaultProps = {
  profileLink: null,
  closable: true,
  handler: function handler() {}
};

UserMenu.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].number.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].string.isRequired,
  handler: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].string.isRequired,
  image: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].string.isRequired,
  profileLink: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].string,
  closable: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].bool
};

var styles = __WEBPACK_IMPORTED_MODULE_1_aphrodite__["StyleSheet"].create({
  notification: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: 12,
    cursor: 'default',

    ':not(:last-child)': {
      borderBottom: '1px solid #16345a'
    }
  },

  notification_dismiss: {
    display: 'block',
    flexShrink: 0,
    height: 12,
    width: 12,
    marginTop: 12,
    marginRight: 4,
    cursor: 'pointer',

    ':not(.a) > path': { // Ugly descendant selector trick...
      transition: 'fill 300ms'
    },

    ':hover > path': {
      fill: '#E85E5E'
    }
  },

  notification_image: {
    flexShrink: 0,
    height: 55,
    width: 55,
    marginLeft: 0,
    marginRight: 15
  },

  notification_content: {
    paddingTop: 10,
    paddingRight: 12,
    paddingBottom: 6,
    fontSize: 15,
    cursor: 'default',
    width: '100%'
  },

  notification_view: {
    display: 'block',
    marginTop: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 900,
    color: '#39b4d6',
    fontSize: 14
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_react_loader_notifications_svg__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_react_loader_notifications_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__svg_react_loader_notifications_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Notification__ = __webpack_require__(195);
var _container;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint import/no-webpack-loader-syntax: off */









 // eslint-disable-line


var NotificationsMenu = function (_Component) {
  _inherits(NotificationsMenu, _Component);

  function NotificationsMenu(props) {
    _classCallCheck(this, NotificationsMenu);

    var _this = _possibleConstructorReturn(this, (NotificationsMenu.__proto__ || Object.getPrototypeOf(NotificationsMenu)).call(this, props));

    _this.state = {
      menuOpen: false
    };
    _this.readHandler = _this.notificationRead.bind(_this);
    _this.toggleMenu = _this.toggleMenu.bind(_this);
    return _this;
  }

  _createClass(NotificationsMenu, [{
    key: 'notificationRead',
    value: function notificationRead(id, type) {
      this.toggleMenu();
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions_user__["d" /* sendNotificationReadReceipt */])(id, type, this.props.user.access_token));
    }
  }, {
    key: 'toggleMenu',
    value: function toggleMenu(e, preventDefault) {
      if (preventDefault) e.preventDefault();
      this.setState({
        menuOpen: !this.state.menuOpen
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var unreadNotifications = this.props.user.unread_notifications;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        {
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container, this.state.menuOpen ? styles.container_top : null) + ' SVGContainer NotificationsSVG',
          onMouseEnter: !__WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].isMobile && !this.state.menuOpen ? this.toggleMenu : null,
          onMouseLeave: !__WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].isMobile && this.state.menuOpen ? this.toggleMenu : null
        },
        __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].isMobile && this.state.menuOpen ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.close), onClick: this.toggleMenu, role: 'button', tabIndex: 0 }) : null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
          {
            to: '/inbox',
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.link),
            onClick: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].isMobile ? function (e) {
              return _this2.toggleMenu(e, true);
            } : null
          },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__svg_react_loader_notifications_svg___default.a, { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.icon) }),
          unreadNotifications && unreadNotifications.length ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.unread_notifications) }) : false
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'ul',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.menu, this.state.menuOpen ? styles.menu_open : null) },
          unreadNotifications && unreadNotifications.length > 0 ? unreadNotifications.map(function (notification) {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__components_Notification__["a" /* default */],
              {
                id: notification.id,
                type: notification.type,
                handler: _this2.readHandler,
                image: notification.image_url,
                profileLink: '/' + notification.type + '/' + notification.profile_id
              },
              notification.message
            );
          }) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.center) },
            'You don',
            "'",
            't have any notifications right now.'
          )
        )
      );
    }
  }]);

  return NotificationsMenu;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (NotificationsMenu);


NotificationsMenu.propTypes = {
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  close: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    content: '""'
  },
  container_top: {
    zIndex: 9
  },
  container: (_container = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].navigation.height,
    marginLeft: 10,
    marginRight: 10

  }, _defineProperty(_container, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    position: 'static',
    marginLeft: 10,
    marginRight: 5
  }), _defineProperty(_container, ':hover > svg', _defineProperty({
    fill: '#39b4d6'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    fill: '#000'
  })), _container),

  icon: {
    transition: 'all 300ms'
  },

  menu: _defineProperty({
    position: 'absolute',
    top: '100%',
    right: -10,
    width: 385,
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    backgroundColor: '#021a36',
    transformOrigin: 'top center',
    transition: 'all 500ms cubic-bezier(0.175, 0.885, 0.320, 1.275)',
    pointerEvents: 'none',
    opacity: 0,
    transform: 'rotateX(-100deg)'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    right: 0,
    width: '100vw'
  }),
  menu_open: {
    transform: 'rotate(0deg)',
    opacity: 1,
    pointerEvents: 'initial'
  },
  center: {
    padding: 30,
    display: 'block',
    textAlign: 'center'
  },
  link: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  unread_notifications: {
    position: 'absolute',
    width: 14,
    height: 14,
    borderRadius: 7,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].secondary,
    right: -2,
    top: 0
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var OrderSummary = function (_Component) {
  _inherits(OrderSummary, _Component);

  function OrderSummary(props) {
    _classCallCheck(this, OrderSummary);

    var _this = _possibleConstructorReturn(this, (OrderSummary.__proto__ || Object.getPrototypeOf(OrderSummary)).call(this, props));

    _this.state = {
      hasError: false
    };
    return _this;
  }

  _createClass(OrderSummary, [{
    key: 'render',
    value: function render() {
      var price = this.props.promoPrice !== null ? this.props.promoPrice : this.props.price;
      var gst = price / 1.15 * 0.15;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.heading) },
          'Order Summary'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.membership) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.membership_details) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.membership_title) },
              this.props.membership,
              ' Membership'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.membership_type) },
              this.props.type,
              this.props.donationPrice ? ' (inc. $' + this.props.donationPrice.toFixed(2) + ' donation)' : ''
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.membership_price) },
            '$',
            price.toFixed(2)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.totals) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.total) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.total_label) },
              'Total'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.total_price) },
              '$',
              price.toFixed(2)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { textAlign: 'right', paddingBottom: 15 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { fontSize: 14, color: 'grey' } },
              '(inc. GST $',
              gst.toFixed(2),
              ')'
            )
          ),
          this.props.checkout,
          this.props.hasError ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.error) },
            'Please fix any form errors ',
            __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].isMobile ? 'above ' : null,
            'to continue'
          ) : null
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.billingNoteWrapper) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.billingNote) },
            'Your account will NOT auto-resubscribe. To activate your re-subscription go to your My Membership page.'
          )
        ),
        this.props.promoText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.promo) },
          this.props.promoTitle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.promo_title) },
            this.props.promoTitle
          ) : null,
          this.props.promoText
        ) : null
      );
    }
  }]);

  return OrderSummary;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (OrderSummary);


OrderSummary.defaultProps = {
  promoPrice: null,
  promoText: null,
  promoTitle: null,
  donationPrice: 0.00
};

OrderSummary.propTypes = {
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  membership: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number.isRequired,
  donationPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number,
  promoPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].number,
  promoTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  promoText: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].node).isRequired, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object]),
  checkout: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].node.isRequired,
  hasError: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  error: {
    marginTop: 15,
    textAlign: 'center',
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].error,
    fontSize: 14,
    lineHeight: 1.4
  },
  promo: {
    padding: '15px',
    textAlign: 'center',
    color: '#fff',
    fontSize: 14,
    lineHeight: 1.4,
    backgroundColor: '#021a36',

    ':not(.a) strong': {
      fontWeight: 'bold'
    }
  },
  disclaimer: {
    padding: 15,
    textAlign: 'center',
    fontSize: 14,
    lineHeight: 1.4
  },
  billingNoteWrapper: {
    padding: '0 20px 30px 20px',
    textAlign: 'center'
  },
  billingNote: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: 500,
    fontSize: 13,
    lineHeight: 1.4
  },
  promo_title: {
    display: 'block',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    marginBottom: 5,
    fontSize: 13,
    letterSpacing: 0.65
  },
  totals: {
    padding: '35px 30px 30px'
  },
  total: _defineProperty({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 22

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column',
    alignItems: 'flex-start'
  }),
  total_price: _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    marginTop: 10
  }),
  total_price_lg: _defineProperty({
    fontSize: 20,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_heading,
    color: '#262626'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    marginTop: 10
  }),
  membership: _defineProperty({
    display: 'flex',
    justifyContent: 'space-between',
    padding: '35px 30px 30px',
    borderBottom: '1px solid #d8d8d8'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column'
  }),
  membership_title: {
    marginBottom: 6,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 20,
    fontWeight: 500,
    color: '#000e1f'
  },
  membership_type: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14,
    color: '#828282'
  },
  membership_price: _defineProperty({
    textAlign: 'right',
    fontSize: 20,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_heading,
    color: '#262626'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    textAlign: 'left',
    marginTop: 10
  }),
  container: _defineProperty({
    width: 360,
    minHeight: 100,
    marginBottom: 40,
    boxShadow: '0 3px 4px 0 rgba(171, 171, 171, 0.5)',
    border: 'solid 1px #e4e4e4',
    borderRadius: 5,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
    overflow: 'hidden'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  heading: {
    height: 50,
    lineHeight: '50px',
    textAlign: 'center',
    backgroundColor: '#021a36',
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 500,
    fontSize: 20
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Heading__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Paragraph__ = __webpack_require__(45);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var styles = void 0;

var PromoSearch = function (_Component) {
  _inherits(PromoSearch, _Component);

  function PromoSearch() {
    _classCallCheck(this, PromoSearch);

    return _possibleConstructorReturn(this, (PromoSearch.__proto__ || Object.getPrototypeOf(PromoSearch)).apply(this, arguments));
  }

  _createClass(PromoSearch, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.container) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__Heading__["a" /* default */],
          { styles: styles.heading },
          'Find your new best friend'
        ),
        __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].isMobile ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__Paragraph__["a" /* default */],
          null,
          'Join us to view their full profiles, and see more dogs!'
        ) : null
      );
    }
  }]);

  return PromoSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PromoSearch);


styles = __WEBPACK_IMPORTED_MODULE_1_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    paddingTop: 40,
    paddingBottom: 40,
    fontFamily: __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].font_size_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].font_weight_primary,
    textAlign: 'center',
    backgroundColor: '#fff'

  }, __WEBPACK_IMPORTED_MODULE_2__config_theme__["a" /* Theme */].mobile_query, {
    padding: '40px 20px'
  }),
  heading: {
    fontSize: 30,

    ':not(:last-child)': {
      marginBottom: 16
    }
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_stripe_elements__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ErrorContainer__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Button__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CheckoutForm__ = __webpack_require__(96);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable */














var CLOSE_ICON = __webpack_require__(323);

var styles = void 0;

var RenewResubscriptionModal = function (_Component) {
  _inherits(RenewResubscriptionModal, _Component);

  function RenewResubscriptionModal(props) {
    _classCallCheck(this, RenewResubscriptionModal);

    var _this = _possibleConstructorReturn(this, (RenewResubscriptionModal.__proto__ || Object.getPrototypeOf(RenewResubscriptionModal)).call(this, props));

    _this.handleCardToken = _this.handleCardToken.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleErrorReset = _this.handleErrorReset.bind(_this);
    _this.handleErrorTriggered = _this.handleErrorTriggered.bind(_this);
    _this.handleReuseCard = _this.handleReuseCard.bind(_this);
    _this.handleSubmitCard = _this.handleSubmitCard.bind(_this);
    _this.submitPaymentDetails = _this.submitPaymentDetails.bind(_this);

    var _props$user = props.user,
        user = _props$user === undefined ? {} : _props$user;
    var _user$stripeCard = user.stripeCard,
        stripeCard = _user$stripeCard === undefined ? null : _user$stripeCard,
        _user$stripeToken = user.stripeToken,
        stripeToken = _user$stripeToken === undefined ? null : _user$stripeToken,
        _user$last = user.last4,
        last4 = _user$last === undefined ? null : _user$last;


    _this.state = {
      errors: {
        card: false
      },

      // For existing card re-use
      stripeCard: stripeCard,
      stripeToken: stripeToken,
      last4: last4
    };
    return _this;
  }

  _createClass(RenewResubscriptionModal, [{
    key: 'handleClose',
    value: function handleClose() {
      this.props.closeHandler();
    }
  }, {
    key: 'handleErrorReset',
    value: function handleErrorReset() {
      this.setState({
        errors: {
          card: false
        }
      });
    }

    /**
     * Handle "use existing card" being checked
     */

  }, {
    key: 'handleReuseCard',
    value: function handleReuseCard() {
      var _this2 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      }));

      // Update payment details
      this.submitPaymentDetails({
        card_token: this.state.stripeCard,
        last4: this.state.last4,
        renew_membership: true
      }).finally(function () {
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
          loading: false
        }));
      });
    }

    /**
     * Handle "new card" being checked
     *
     * @param {Event} event
     */

  }, {
    key: 'handleSubmitCard',
    value: function handleSubmitCard() {
      var _this3 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      }));

      // Handle reuse or created card response
      this.CheckoutForm.verifyCard().then(function (response) {
        return _this3.submitPaymentDetails({
          stripe_token: response.token.id,
          card_token: response.token.card.id,
          last4: response.token.card.last4,
          renew_membership: true
        });
      }).catch(this.handleErrorTriggered).finally(function () {
        _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
          loading: false
        }));
      });
    }
  }, {
    key: 'submitPaymentDetails',
    value: function submitPaymentDetails(details) {
      var _this4 = this;

      return this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_user__["g" /* updateUserRemote */])(details, this.props.user.access_token)).then(function () {
        _this4.props.closeHandler();
      }).catch(this.handleErrorTriggered);
    }

    /**
     * Set errors in the state
     */

  }, {
    key: 'handleErrorTriggered',
    value: function handleErrorTriggered() {
      this.setState({
        errors: Object.assign({}, this.state.errors, {
          card: 'A problem occurred with this card, and you were not charged. Please try another card.'
        }),
        hasError: true
      });
    }
  }, {
    key: 'handleCardToken',
    value: function handleCardToken(response) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        if (response.error) {
          _this5.handleErrorTriggered();
          _this5.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));

          reject(response);
        } else if (response.token) {
          _this5.setState({
            stripeToken: response.token.id,
            stripeCard: response.token.card.id,
            last4: response.token.card.last4
          });

          resolve(response);
        }
      });
    }
  }, {
    key: 'existingPaymentAvailable',
    value: function existingPaymentAvailable() {
      // Note: There is a case where a customer lacks a stripe CustomerID. A StripeToken is necessary in order
      // to create a new customer.
      // Thus, if a customerID is not set, we can't re-use an existing payment and must create a new one
      // If card / last4 digits are saved, use these
      return this.props.current_card && this.state.stripeCard && this.state.last4 && this.props.user && this.props.user.has_customer_id;
    }
  }, {
    key: 'renderExistingPayment',
    value: function renderExistingPayment() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.payment_area) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Button__["a" /* default */], {
          title: 'Use current payment method',
          styles: styles.full_width_button,
          handler: this.handleReuseCard }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.current_card_details) },
          'Current payment method: ',
          this.props.current_card
        )
      );
    }
  }, {
    key: 'renderPaymentArea',
    value: function renderPaymentArea() {
      // Show both "use existing card" and "enter new card" forms
      if (this.existingPaymentAvailable()) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.body) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.text) },
            'Tails are wagging! Thank you for being us for the time you have and choosing to stay on! To activate your resubscription, simply confirm your current preferred payment method or enter a new one.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          this.renderExistingPayment(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.seperator_container) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.seperator_text) },
              'Or'
            )
          ),
          this.renderNewPayment()
        );
      }

      // Show only "enter new card" form
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.body) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.text) },
          'Tails are wagging! Thank you for being us for the time you have and choosing to stay on! To activate your resubscription, simply enter a new payment method.'
        ),
        this.renderNewPayment()
      );
    }

    /**
     * Render "enter new card" form
     *
     * @returns {any}
     */

  }, {
    key: 'renderNewPayment',
    value: function renderNewPayment() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.payment_area) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_stripe_elements__["Elements"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CheckoutForm__["a" /* default */], {
            onRef: function onRef(ref) {
              return _this6.CheckoutForm = ref;
            },
            handler: this.handleCardToken,
            first_name: this.props.first_name,
            last_name: this.props.last_name,
            cardChangedHandler: this.handleErrorReset })
        ),
        this.state.errors.card ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ErrorContainer__["a" /* default */], { message: this.state.errors.card }) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.button_container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Button__["a" /* default */], {
            title: 'Verify and store card',
            styles: styles.button,
            handler: this.handleSubmitCard })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_modal___default.a,
        {
          isOpen: this.props.open,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.container),
          onRequestClose: this.handleClose,
          style: {
            overlay: {
              backgroundColor: 'rgba(0,0,0,0.67)',
              zIndex: 101,
              display: 'flex'
            }
          },
          contentLabel: 'Change payment method'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.modal_wrapper) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.header) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.title) },
              'Activate my resubscription'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.close_icon),
                onClick: this.handleClose,
                role: 'button',
                tabIndex: 0
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: CLOSE_ICON, alt: 'Close modal' })
            )
          ),
          this.renderPaymentArea()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.footer) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.sign_up_container) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { fontSize: 14, padding: 20 } },
              'Your account will NOT auto-resubscribe! ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              'And if you choose to reactivate your resubscription before your current subscription is up for renewal, your card will not be charged until the renewal date of your current subscription.'
            )
          )
        )
      );
    }
  }]);

  return RenewResubscriptionModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (RenewResubscriptionModal);


RenewResubscriptionModal.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func,
  first_name: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  last_name: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  current_card: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string
};

RenewResubscriptionModal.defaultProps = {
  open: false,
  closeHandler: function closeHandler() {},
  current_card: null
};

styles = __WEBPACK_IMPORTED_MODULE_3_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 590,
    maxWidth: '100vw',
    height: 700,
    maxHeight: '100vh',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    borderRadius: 5,
    overflow: 'hidden',
    outline: 'none',
    margin: 'auto auto'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    width: '95%',
    height: 'auto'
  }),
  modal_wrapper: _defineProperty({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: 600,
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 80px'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    height: 'auto',
    padding: '0 30px'
  }),
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px 0px'
  },
  title: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 30,
    fontWeight: '900'
  },
  close_icon: {
    position: 'absolute',
    right: 15,
    top: 15,
    outline: 'none',
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6
    }
  },
  current_card_details: {
    textAlign: 'center',
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 13,
    marginTop: 5
  },
  full_width_button: {
    width: '100%'
  },
  payment_area: {
    width: '100%'
  },
  body: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  },
  seperator_container: {
    display: 'flex',
    height: 25,
    margin: '25px auto',
    alignItems: 'center',
    justifyContent: 'center',
    ':after': {
      content: "' '",
      position: 'absolute',
      width: '100%',
      height: 1,
      backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].horizontal_rule_color
    }
  },
  text: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    textAlign: 'center',
    marginBottom: 20,
    lineHeight: '21px'
  },
  seperator_text: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    zIndex: 10,
    padding: 15
  },
  actions_container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
  footer: _defineProperty({
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    bottom: 0,
    height: 100,
    width: '100%',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].light_grey

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    position: 'relative',
    height: 'auto',
    marginTop: 30,
    padding: '30px',
    textAlign: 'center'
  }),
  sign_up_container: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 16,
    textAlign: 'center'
  },
  sign_up_link: {
    display: 'inline',
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_secondary,
    letterSpacing: 1,
    marginLeft: 5,
    textTransform: 'uppercase',
    fontWeight: 'bold'
  },
  forgotten_password: {
    flex: 1,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14,
    textAlign: 'center'
  },
  login_button_container: {
    flex: 1
  },
  clippy: {
    marginLeft: 20
  },
  copy_button: {
    backgroundColor: 'transparent',
    padding: '10px 20px',
    boxSizing: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
    transition: 'all ease-out 160ms',
    cursor: 'pointer',
    border: 'none'
  },
  copy_button_container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].primary,
    fontSize: 13,
    fontWeight: 'bold'
  },
  button_container: _defineProperty({
    marginTop: 40

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    justifyContent: 'center'
  })
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TextField__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Button__ = __webpack_require__(15);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var CLOSE_ICON = __webpack_require__(324);

var ReportModal = function (_Component) {
  _inherits(ReportModal, _Component);

  function ReportModal(props) {
    _classCallCheck(this, ReportModal);

    var _this = _possibleConstructorReturn(this, (ReportModal.__proto__ || Object.getPrototypeOf(ReportModal)).call(this, props));

    _this.openHandler = _this.props.openHandler.bind(_this);
    _this.reportMemberProfile = _this.reportMember.bind(_this);
    _this.setValue = _this.updateTextField.bind(_this);
    _this.state = {
      report_submitted: false,
      errors: {
        report_message: false
      }
    };
    return _this;
  }

  _createClass(ReportModal, [{
    key: 'reportMember',
    value: function reportMember() {
      var _this2 = this;

      // Initiate loading sequence
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        // Continue loading during request
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
          loading: true
        }));
        // Dispatching member report request
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_user__["k" /* reportMember */])({
          reporter_id: _this2.props.user.id,
          reporter_name: _this2.props.user.first_name + ' ' + _this2.props.user.last_name,
          reported_id: _this2.props.match.params.id,
          email: _this2.props.user.email,
          message: _this2.state.report_message
        }, _this2.props.user.access_token)).then(function () {
          // discontinue dog sharing
          // Manage state with response
          _this2.setState({
            report_submitted: true
          });
          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_user__["i" /* getCurrentMember */])(_this2.props.user.id, _this2.props.user.access_token)).then(function (response) {
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_user__["c" /* updateUser */])(response));

            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
              loading: false
            }));
          });
        }, function () {
          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        });
      });
    }
  }, {
    key: 'updateTextField',
    value: function updateTextField(key, value) {
      var _this3 = this;

      var updatedState = _defineProperty({}, key, value);

      this.setState(updatedState);

      setTimeout(function () {
        _this3.validateForm();
        if (_this3.state.errors[key]) {
          _this3.validateForm();
        }
      }, 10);
    }
  }, {
    key: 'validateForm',
    value: function validateForm() {
      var errors = {};

      if (!this.state.report_message.length) {
        errors.report_message = 'You need to provide a reason on why you are reporting this member';
      } else {
        errors.report_message = false;
      }

      var formErrors = false;

      for (var key in errors) {
        //eslint-disable-line
        if (errors[key] !== null) {
          formErrors = true;
        }
      }

      if (formErrors) {
        this.setState({
          errors: errors
        });

        return false;
      }

      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_modal___default.a,
        {
          isOpen: this.props.open,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.container),
          style: {
            overlay: {
              backgroundColor: 'rgba(0,0,0,0.67)',
              zIndex: 10,
              display: 'flex'
            }
          },
          contentLabel: 'Report'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.modal_wrapper) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.header) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.title) },
              this.state.report_submitted === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                ' Report submitted'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                ' Report this member'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.close_icon),
                onClick: this.props.openHandler,
                role: 'button',
                tabIndex: 0
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: CLOSE_ICON, alt: 'Close modal' })
            )
          ),
          this.state.report_submitted === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.body) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.successParagraph) },
              'Thank you for your feedback. We will review this report and take any action necessary to ensure the safety of our community.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Button__["a" /* default */], {
              title: 'Continue',
              theme: 'blue',
              handler: this.openHandler,
              styles: styles.full_width_button })
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.body) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.comments) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TextField__["a" /* default */], {
                textArea: true,
                name: 'report_message',
                styles: styles.textArea,
                handler: this.setValue,
                placeholder: 'Tell us why you\u2019d like to report this user\u2026',
                error: this.state.errors.report_message
              })
            ),
            this.state.errors.report_message ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Button__["a" /* default */], {
              title: 'Submit Report',
              theme: 'disabled',
              disabled: true //eslint-disable-line
              , styles: styles.full_width_button }) : false,
            !this.state.errors.report_message ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Button__["a" /* default */], {
              title: 'Submit Report',
              theme: 'blue',
              handler: this.reportMemberProfile,
              styles: styles.full_width_button }) : false
          )
        )
      );
    }
  }]);

  return ReportModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ReportModal.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  openHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  match: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired
};

ReportModal.defaultProps = {
  open: false
};

var openModalKeyFrames = {
  from: {
    transform: 'scale(0.8)',
    animationTimingFunction: 'ease-in'
  },

  to: {
    transform: 'scale(1)',
    animationTimingFunction: 'ease-in'
  }
};

var styles = __WEBPACK_IMPORTED_MODULE_3_aphrodite__["StyleSheet"].create({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 590,
    maxWidth: '100vw',
    height: 513,
    maxHeight: '100vh',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    borderRadius: 5,
    overflow: 'hidden',
    outline: 'none',
    margin: 'auto auto',
    animationName: openModalKeyFrames,
    animationDuration: '100ms',
    animationDirection: 'alternate'
  },
  modal_wrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: 600 - 100,
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 80px'
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px 0px 35px'
  },
  title: {
    marginBottom: 0,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 30,
    fontWeight: '900'
  },
  close_icon: {
    position: 'absolute',
    right: 15,
    top: 15,
    outline: 'none',
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6
    }
  },
  body: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    textAlign: 'center'
  },
  stars: {
    display: 'flex',
    marginBottom: 40
  },
  star: {
    display: 'block',
    height: 30,
    width: 30,
    margin: '0 8px',
    stroke: '#DFDFDF',
    fill: '#F4F4F4',
    transition: 'all 300ms',
    cursor: 'pointer',
    outline: 'none'
  },
  star_active: {
    stroke: '#39b4d6',
    fill: '#39b4d6'
  },
  successParagraph: {
    marginBottom: 60,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 16,
    lineHeight: 1.5,
    color: '#828282'
  },
  textArea: {
    display: 'flex',
    flexDirection: 'column',
    height: 200,
    width: 340,
    marginBottom: 25,

    ':not(.a) > *': {
      flexGrow: 1
    }
  },
  paragraph: {
    marginBottom: 20,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14,
    color: '#828282'
  },
  actions_container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
  sign_up_container: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 16
  },
  sign_up_link: {
    display: 'inline',
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_secondary,
    letterSpacing: 1,
    marginLeft: 5,
    textTransform: 'uppercase',
    fontWeight: 'bold'
  },
  forgotten_password: {
    flex: 1,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14
  },
  login_button_container: {
    flex: 1
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_8__utils__["b" /* mapDispatchToProps */])(ReportModal));

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button__ = __webpack_require__(15);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ResourceCard = function (_Component) {
  _inherits(ResourceCard, _Component);

  function ResourceCard() {
    _classCallCheck(this, ResourceCard);

    return _possibleConstructorReturn(this, (ResourceCard.__proto__ || Object.getPrototypeOf(ResourceCard)).apply(this, arguments));
  }

  _createClass(ResourceCard, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        {
          rel: 'noopener noreferrer',
          href: this.props.link,
          target: '_blank',
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.card) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.card_title) },
          this.props.title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.card_date) },
          this.props.date
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.card_summary) },
          this.props.summary
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Button__["a" /* default */], { title: 'Download file', styles: styles.button })
      );
    }
  }]);

  return ResourceCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ResourceCard);


ResourceCard.defaultProps = {
  status: null,
  signup: false,
  interests: []
};

ResourceCard.propTypes = {
  link: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  summary: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  button: {
    width: '100%'
  },
  card: {
    position: 'relative',
    display: 'inline-block',
    width: 250,
    minWidth: 250,
    padding: 18,
    margin: '0 15px 23px',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.05)',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].lighter_grey,
    transition: 'all 300ms',

    ':hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 6px 11px 0 rgba(0, 0, 0, 0.05)'
    }
  },
  card_title: {
    marginBottom: 10,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_heading,
    fontSize: 20,
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].black,
    lineHeight: 1.4
  },
  card_date: _defineProperty({
    marginBottom: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_primary,
    fontSize: 14,
    color: '#828282'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    marginBottom: 0
  }),
  card_summary: {
    marginBottom: 12.7,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_primary,
    fontSize: 14,
    lineHeight: 1.4,
    color: '#021a36'
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserImage__ = __webpack_require__(47);
var _review, _notFishP, _review_content;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import { Link } from 'react-router-dom';




var Reviews = function (_Component) {
  _inherits(Reviews, _Component);

  function Reviews() {
    _classCallCheck(this, Reviews);

    return _possibleConstructorReturn(this, (Reviews.__proto__ || Object.getPrototypeOf(Reviews)).apply(this, arguments));
  }

  _createClass(Reviews, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        this.props.isPublic ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.review) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.review_author) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: this.props.profileLink },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__UserImage__["a" /* default */], {
                image: this.props.photo,
                styles: styles.review_photo
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.review_details) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.review_name) },
                this.props.name
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.review_date) },
                this.props.date
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.review_content) },
            this.props.children
          )
        ) : false
      );
    }
  }]);

  return Reviews;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Reviews);


Reviews.defaultProps = {};

Reviews.propTypes = {
  photo: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  profileLink: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  isPublic: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  review: (_review = {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '25px 20px',
    color: '#000e1f',
    fontSize: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_primary,
    backgroundColor: '#f5f5f5',
    border: '1px solid #ddd'

  }, _defineProperty(_review, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column'
  }), _defineProperty(_review, ':not(:last-child)', {
    borderBottom: 0
  }), _review),
  review_author: {
    display: 'flex',
    alignItems: 'center'
  },
  review_photo: {
    height: 50,
    width: 50,
    marginRight: 15,
    flexShrink: 0
  },
  review_details: {
    flexShrink: 0
  },
  review_name: {
    marginBottom: 8,
    fontSize: 15
  },
  review_date: {
    fontSize: 14,
    color: '#828282'
  },
  review_content: (_review_content = {
    position: 'relative',
    paddingTop: 3,
    paddingBottom: 7,
    fontSize: 15,
    paddingLeft: 80,
    lineHeight: 1.53,
    letterSpacing: 0.3

  }, _defineProperty(_review_content, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    paddingLeft: 0,
    paddingTop: 15
  }), _defineProperty(_review_content, ':not(.fish) > p', (_notFishP = {
    fontSize: 15

  }, _defineProperty(_notFishP, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 14
  }), _defineProperty(_notFishP, ':not(:last-child)', {
    marginBottom: 15
  }), _notFishP)), _review_content)
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TextField__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(15);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var CLOSE_ICON = __webpack_require__(325);
var STAR_ICON = __webpack_require__(326);

var ReviewModal = function (_Component) {
  _inherits(ReviewModal, _Component);

  function ReviewModal(props) {
    _classCallCheck(this, ReviewModal);

    var _this = _possibleConstructorReturn(this, (ReviewModal.__proto__ || Object.getPrototypeOf(ReviewModal)).call(this, props));

    _this.openHandler = _this.props.openHandler;
    _this.submitReview = _this.props.submitReviewHandler;
    _this.setValue = _this.props.updateTextField;
    _this.setRating = _this.props.setRatingHandler;
    return _this;
  }

  _createClass(ReviewModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_modal___default.a,
        {
          isOpen: this.props.open,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container),
          style: {
            overlay: {
              backgroundColor: 'rgba(0,0,0,0.67)',
              zIndex: 10,
              display: 'flex'
            }
          },
          contentLabel: 'Review'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.modal_wrapper) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.header) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.title) },
              this.props.reviewSubmitted === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                ' Review submitted'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                ' Review this member'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.close_icon),
                onClick: this.props.openHandler,
                role: 'button',
                tabIndex: 0
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: CLOSE_ICON, alt: 'Close modal' })
            )
          ),
          this.props.reviewSubmitted === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.body) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.successParagraph) },
              'Thank you for your feedback. Your review has been published.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */], {
              title: 'Continue',
              theme: 'blue',
              handler: this.openHandler,
              styles: styles.full_width_button })
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.body) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.paragraph) },
              'Add your rating (only Dog Share Collective will see this rating):'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.stars) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  role: 'button',
                  tabIndex: -4,
                  onClick: function onClick() {
                    _this2.setRating(1);
                  },
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.star, this.props.updatedStars > 0 ? styles.star_active : null)
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.ratingBelowStandardText) },
                  'Below standard'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, {
                  cacheGetRequests: true,
                  src: STAR_ICON
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  role: 'button',
                  tabIndex: -3,
                  onClick: function onClick() {
                    _this2.setRating(2);
                  },
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.star, this.props.updatedStars > 1 ? styles.star_active : null)
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, {
                  cacheGetRequests: true,
                  src: STAR_ICON
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  role: 'button',
                  tabIndex: -2,
                  onClick: function onClick() {
                    _this2.setRating(3);
                  },
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.star, this.props.updatedStars > 2 ? styles.star_active : null)
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, {
                  cacheGetRequests: true,
                  src: STAR_ICON
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  role: 'button',
                  tabIndex: -1,
                  onClick: function onClick() {
                    _this2.setRating(4);
                  },
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.star, this.props.updatedStars > 3 ? styles.star_active : null)
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, {
                  cacheGetRequests: true,
                  src: STAR_ICON
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  role: 'button',
                  tabIndex: 0,
                  onClick: function onClick() {
                    _this2.setRating(5);
                  },
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.star, this.props.updatedStars > 4 ? styles.star_active : null)
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.ratingAboveStandardText) },
                  'Above standard'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, {
                  cacheGetRequests: true,
                  src: STAR_ICON
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.comments) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TextField__["a" /* default */], {
                textArea: true,
                name: 'public_review',
                styles: styles.textArea,
                handler: this.setValue,
                placeholder: 'Public comments (optional)',
                error: this.props.formError
              })
            ),
            this.props.formError ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */], {
              title: 'Submit Review',
              theme: 'disabled',
              disabled: true //eslint-disable-line
              , styles: styles.full_width_button }) : false,
            !this.props.formError ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */], {
              title: 'Submit Review',
              theme: 'blue',
              handler: this.submitReview,
              styles: styles.full_width_button }) : false
          )
        )
      );
    }
  }]);

  return ReviewModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ReviewModal);


ReviewModal.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  reviewSubmitted: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool.isRequired,
  openHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  submitReviewHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  updateTextField: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  setRatingHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  updatedStars: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  formError: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired
};

ReviewModal.defaultProps = {
  open: false
};

var openModalKeyFrames = {
  from: {
    transform: 'scale(0.8)',
    animationTimingFunction: 'ease-in'
  },

  to: {
    transform: 'scale(1)',
    animationTimingFunction: 'ease-in'
  }
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 590,
    maxWidth: '100vw',
    height: 513,
    maxHeight: '100vh',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    borderRadius: 5,
    overflow: 'hidden',
    outline: 'none',
    margin: 'auto auto',
    animationName: openModalKeyFrames,
    animationDuration: '100ms',
    animationDirection: 'alternate'
  },
  modal_wrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: 600 - 100,
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 80px'
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px 0px 35px'
  },
  title: {
    marginBottom: 0,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 30,
    fontWeight: '900'
  },
  close_icon: {
    position: 'absolute',
    right: 15,
    top: 15,
    outline: 'none',
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6
    }
  },
  body: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    textAlign: 'center'
  },
  stars: {
    display: 'flex',
    marginBottom: 40
  },
  star: {
    display: 'block',
    height: 30,
    width: 30,
    margin: '0 8px',
    stroke: '#DFDFDF',
    fill: '#F4F4F4',
    transition: 'all 300ms',
    cursor: 'pointer',
    outline: 'none'
  },
  star_active: {
    stroke: '#39b4d6',
    fill: '#39b4d6'
  },
  textArea: {
    display: 'flex',
    flexDirection: 'column',
    height: 130,
    width: 337,
    marginBottom: 25,

    ':not(.a) > *': {
      flexGrow: 1
    }
  },
  paragraph: {
    marginBottom: 20,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14,
    color: '#828282'
  },
  ratingBelowStandardText: {
    position: 'absolute',
    marginLeft: -90,
    paddingTop: 10,
    marginBottom: 20,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 11,
    color: '#828282'
  },
  ratingAboveStandardText: {
    position: 'absolute',
    marginLeft: 45,
    paddingTop: 10,
    marginBottom: 20,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 11,
    color: '#828282'
  },
  successParagraph: {
    marginBottom: 60,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 16,
    lineHeight: 1.5,
    color: '#828282'
  },
  actions_container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
  sign_up_container: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 16
  },
  sign_up_link: {
    display: 'inline',
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_secondary,
    letterSpacing: 1,
    marginLeft: 5,
    textTransform: 'uppercase',
    fontWeight: 'bold'
  },
  forgotten_password: {
    flex: 1,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14
  },
  login_button_container: {
    flex: 1
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_profile__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_Api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Review__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ReviewModal__ = __webpack_require__(203);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Reviews = function (_Component) {
  _inherits(Reviews, _Component);

  function Reviews(props) {
    _classCallCheck(this, Reviews);

    var _this = _possibleConstructorReturn(this, (Reviews.__proto__ || Object.getPrototypeOf(Reviews)).call(this, props));

    _this.state = {
      stars: 3,
      review_submitted: false,
      errors: {
        public_review: false
      }
    };
    _this.submitReview = _this.submitReviewHandler.bind(_this);
    _this.setRatingHandler = _this.setRating.bind(_this);
    _this.updateTextFieldHandler = _this.updateTextField.bind(_this);

    _this.openHandler = props.openHandler.bind(_this);
    _this.pushReview = props.pushReviewHandler.bind(_this);
    _this.canReview = props.canReview;
    _this.reviews = props.reviews;
    return _this;
  }

  _createClass(Reviews, [{
    key: 'getUserImage',
    value: function getUserImage(review) {
      if (review.reviewer_image_url && review.reviewer_image_url.length > 10) {
        return __WEBPACK_IMPORTED_MODULE_7__utils_Api__["c" /* ASSET_BASE_URL */] + '/' + review.reviewer_image_url;
      }

      return '/images/default_profile.jpg';
    }
  }, {
    key: 'getMemberFirstName',
    value: function getMemberFirstName(reviewer) {
      var fullName = reviewer.split(' ');
      return fullName[0];
    }
  }, {
    key: 'getUserProfileLink',
    value: function getUserProfileLink(review) {
      return '/profile/' + review.reviewer_id;
    }
  }, {
    key: 'setRating',
    value: function setRating(rating) {
      this.setState({
        stars: rating
      });
    }
  }, {
    key: 'updateTextField',
    value: function updateTextField(key, value) {
      var _this2 = this;

      var updatedState = _defineProperty({}, key, value);

      this.setState(updatedState);

      setTimeout(function () {
        _this2.validateForm();
        if (_this2.state.errors[key]) {
          _this2.validateForm();
        }
      }, 10);
    }
  }, {
    key: 'pushNewReview',
    value: function pushNewReview() {
      var _this3 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_profile__["a" /* getMember */])(_this3.props.match.params.id, _this3.props.user.access_token)).then(function (response) {
          var reviews = response.reviews;
          // pushes new review prop into profile state
          reviews.map(function (review) {
            return _this3.props.pushReviewHandler(review);
          });
        });
      }, function (err) {
        console.log(err); // eslint-disable-line no-console
        _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions_applicationState__["a" /* updateAppState */])({
          loading: false
        }));
      });
    }
  }, {
    key: 'submitReviewHandler',
    value: function submitReviewHandler() {
      var _this4 = this;

      // Initiate loading sequence
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        // Continue loading during request
        _this4.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions_applicationState__["a" /* updateAppState */])({
          loading: true
        }));
        // Dispatching review request
        _this4.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions_user__["l" /* sendReviewRequest */])({
          id: _this4.props.match.params.id,
          type: _this4.props.user.subscription,
          review: _this4.state.public_review,
          rating: _this4.state.stars
        }, _this4.props.user.access_token)).then(function () {
          // Manage state with response
          _this4.pushNewReview();
          _this4.setState({
            review_submitted: true
          });
          _this4.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        }, function (err) {
          console.log(err); // eslint-disable-line no-console
          _this4.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        });
      });
    }
  }, {
    key: 'validateForm',
    value: function validateForm() {
      var errors = {};

      if (this.state.public_review.length > 200) {
        errors.public_review = 'You have exceeded the (200) character limit';
      } else {
        errors.public_review = false;
      }

      var formErrors = false;

      for (var key in errors) {
        //eslint-disable-line
        if (errors[key] !== null) {
          formErrors = true;
        }
      }

      if (formErrors) {
        this.setState({
          errors: errors
        });

        return false;
      }

      return true;
    }
  }, {
    key: 'countPublicReviews',
    value: function countPublicReviews(reviews) {
      var total = 0;
      reviews.map(function (review) {
        // eslint-disable-line
        if (review.isPublicReview) {
          total++; // eslint-disable-line
        }
      });

      if (total === 1) {
        return total + ' Public Review';
      }

      return total + ' Public Reviews';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.review_note) },
          'Feedback enables transparency, creates trust and keeps our community safe.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.heading) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.count) },
            this.countPublicReviews(this.props.reviews)
          ),
          this.props.canReview === true && !this.state.review_submitted ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              onClick: this.openHandler,
              className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.add),
              role: 'button',
              tabIndex: 0
            },
            'Write a review'
          ) : false,
          this.props.open
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.reviews) },
          this.props.reviews.length ? this.props.reviews.map(function (review) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__Review__["a" /* default */],
              {
                photo: _this5.getUserImage(review),
                profileLink: _this5.getUserProfileLink(review),
                name: _this5.getMemberFirstName(review.reviewer),
                date: review.created,
                isPublic: review.isPublicReview
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                review.reviewer_comment
              )
            );
          }) : false
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ReviewModal__["a" /* default */], {
          openHandler: this.props.openHandler,
          submitReviewHandler: this.submitReview,
          setRatingHandler: this.setRatingHandler,
          updateTextField: this.updateTextFieldHandler,
          reviewSubmitted: this.state.review_submitted,
          updatedStars: this.state.stars,
          formError: this.state.errors.public_review,
          open: this.props.open
        })
      );
    }
  }]);

  return Reviews;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Reviews);


Reviews.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool.isRequired,
  openHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  pushReviewHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  reviews: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].array.isRequired,
  canReview: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  match: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: {},
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 20,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_primary
  },
  count: {
    fontSize: 15
  },
  add: {
    fontSize: 18,
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].turquoise,
    cursor: 'pointer',
    outline: 'none'
  },
  review_note: {
    padding: '10px 0 30px',
    fontSize: 16,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_primary
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var PAW_ASSET = __webpack_require__(327);

var ScrollDownTrigger = function (_Component) {
  _inherits(ScrollDownTrigger, _Component);

  function ScrollDownTrigger(props) {
    _classCallCheck(this, ScrollDownTrigger);

    var _this = _possibleConstructorReturn(this, (ScrollDownTrigger.__proto__ || Object.getPrototypeOf(ScrollDownTrigger)).call(this, props));

    _this.scrollHandler = props.handler.bind(_this);

    _this.styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
      container: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justiyContent: 'flex-end',
        fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_secondary,
        fontSize: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_size_secondary,
        fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_secondary,
        outline: 'none'
      },
      text: {
        display: 'flex',
        flex: 1,
        textTransform: 'uppercase',
        letterSpacing: 2,
        textAlign: 'center',
        color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
        fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_secondary,
        fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_secondary,
        fontSize: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_size_secondary + 2,
        marginBottom: 20
      },
      image_container: {
        position: 'relative',
        display: 'flex',
        overflow: 'hidden',
        transition: 'all 180ms ease-in-out',
        ':hover': {
          paddingTop: 10,
          paddingRight: 30,
          paddingBottom: 0,
          paddingLeft: 30
        },
        cursor: 'pointer',
        flex: 3,
        alignItems: 'flex-end'
      },
      image: {
        marginBottom: -20,
        display: 'block',
        height: 90,
        transition: 'all 180ms ease-in-out',
        ':hover': {
          scale: 2,
          marginBottom: 0,
          transform: 'scale(1.3,1.1)'
        }
      }
    });
    return _this;
  }

  _createClass(ScrollDownTrigger, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          tabIndex: 0,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.styles.container),
          onClick: this.scrollHandler,
          role: 'button' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.styles.text) },
          'Scroll'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.styles.image_container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.styles.image), src: PAW_ASSET, alt: 'Paw' })
        )
      );
    }
  }]);

  return ScrollDownTrigger;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ScrollDownTrigger.defaultProps = {
  handler: function handler() {}
};

ScrollDownTrigger.propTypes = {
  handler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (ScrollDownTrigger);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_react_loader_settings_svg__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_react_loader_settings_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_react_loader_settings_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint import/no-webpack-loader-syntax: off */








var SettingsMenu = function (_Component) {
  _inherits(SettingsMenu, _Component);

  function SettingsMenu(props) {
    _classCallCheck(this, SettingsMenu);

    var _this = _possibleConstructorReturn(this, (SettingsMenu.__proto__ || Object.getPrototypeOf(SettingsMenu)).call(this, props));

    _this.state = {
      menuOpen: false
    };

    _this.logoutHandler = _this.props.logoutHandler.bind(_this);
    _this.toggleMenu = _this.toggleMenu.bind(_this);
    return _this;
  }

  _createClass(SettingsMenu, [{
    key: 'toggleMenu',
    value: function toggleMenu(e, preventDefault) {
      if (preventDefault) e.preventDefault();
      this.setState({
        menuOpen: !this.state.menuOpen
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container, this.state.menuOpen ? styles.container_top : null) + ' SVGContainer SettingsSVG',
          onMouseEnter: !__WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].isMobile && !this.state.menuOpen ? this.toggleMenu : null,
          onMouseLeave: !__WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].isMobile && this.state.menuOpen ? this.toggleMenu : null },
        __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].isMobile && this.state.menuOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.close), onClick: this.toggleMenu, role: 'button', tabIndex: 0 }) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* Link */],
          {
            to: '/settings/profiles',
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.link),
            onClick: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].isMobile ? function (e) {
              return _this2.toggleMenu(e, true);
            } : null
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__svg_react_loader_settings_svg___default.a, { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.icon) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.menu, this.state.menuOpen ? styles.menu_open : null) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.item) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
              {
                to: '/settings/details',
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.link),
                onClick: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].isMobile ? this.toggleMenu : null
              },
              'My Details'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.item) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
              {
                to: '/settings/membership',
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.link),
                onClick: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].isMobile ? this.toggleMenu : null
              },
              'My Membership'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.item) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
              {
                to: '/settings/account',
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.link),
                onClick: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].isMobile ? this.toggleMenu : null
              },
              'My Settings'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.item) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
              {
                to: '/settings/resources',
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.link),
                onClick: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].isMobile ? this.toggleMenu : null
              },
              'My Dog e-Bag'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.item) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
              {
                to: '/settings/help',
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.link),
                onClick: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].isMobile ? this.toggleMenu : null
              },
              'Help'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.item) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.link),
                onClick: this.logoutHandler,
                role: 'button',
                tabIndex: 0 },
              'Logout'
            )
          )
        )
      );
    }
  }]);

  return SettingsMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SettingsMenu);


SettingsMenu.propTypes = {
  logoutHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  close: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    content: '""'
  },
  container_top: {
    zIndex: 9
  },
  container: _defineProperty({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].navigation.height,
    marginLeft: 10,
    marginRight: 10

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    position: 'static',
    marginLeft: 5,
    marginRight: 5
  }),

  icon: {
    transition: 'fill linear, transform cubic-bezier(0.175, 0.885, 0.320, 1.275)',
    transitionDuration: '300ms'
  },

  item: {
    width: '100%',
    ':not(:last-child)': {
      borderBottom: 'solid 1px #16345a'
    }
  },

  link: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    textAlign: 'center',
    height: 60,
    lineHeight: '60px',
    color: '#fff',
    transition: 'all 300ms',

    ':hover': {
      backgroundColor: '#fff',
      color: '#021a36'
    },

    ':hover > svg': _defineProperty({
      fill: '#39b4d6',
      transform: 'rotate(360deg)'

    }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
      fill: '#000'
    })
  },

  menu: _defineProperty({
    position: 'absolute',
    top: '100%',
    right: -10,
    width: 240,
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    backgroundColor: '#021a36',
    transformOrigin: 'top center',
    transition: 'all 500ms cubic-bezier(0.175, 0.885, 0.320, 1.275)',
    pointerEvents: 'none',
    opacity: 0,
    transform: 'rotateX(-100deg)',
    textAlign: 'center'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    right: 0,
    width: '100vw'
  }),
  menu_open: {
    transform: 'rotate(0deg)',
    opacity: 1,
    pointerEvents: 'initial'
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var styles = void 0;
var FACEBOOK = __webpack_require__(332);
var MAIL = __webpack_require__(333);

var ShareProfile = function ShareProfile(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.information) },
      'Share this dog'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.information) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        {
          href: props.facebook,
          target: '_blank',
          rel: 'noopener noreferrer'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: FACEBOOK, alt: 'Share Facebook', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.social_icon) })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { href: props.email, target: '_blank', rel: 'noopener noreferrer' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: MAIL, alt: 'Email us', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.social_icon, styles.mail_icon) })
      )
    )
  );
};

ShareProfile.propTypes = {
  facebook: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired,
  email: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ShareProfile);

styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: {
    display: 'none'
  },
  heading: {
    marginBottom: 5,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_secondary,
    fontSize: 15,
    letterSpacing: 2,
    textTransform: 'uppercase',
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_heading,
    lineHeight: 1.73,
    color: '#000e1f'
  },
  social_icon: {
    maxWidth: 100,
    maxHeight: 100
  },
  information: _defineProperty({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    margin: '0 auto 16px'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto',
    flexWrap: 'wrap',
    justifyContent: 'center'
  }),
  copy: _defineProperty({
    position: 'relative',
    textAlign: 'left',
    lineHeight: 1.73,
    padding: '0 5px'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    textAlign: 'center'
  }),
  osIcon: {
    maxWidth: 40,
    maxHeight: 40,
    margin: '0 10px',
    opacity: 1,
    transition: 'all 300ms',

    ':hover': {
      opacity: 0.6
    }
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var PAW_ASSET = __webpack_require__(334);

var ShowMoreTrigger = function (_Component) {
  _inherits(ShowMoreTrigger, _Component);

  function ShowMoreTrigger(props) {
    _classCallCheck(this, ShowMoreTrigger);

    var _this = _possibleConstructorReturn(this, (ShowMoreTrigger.__proto__ || Object.getPrototypeOf(ShowMoreTrigger)).call(this, props));

    _this.clickHandler = _this.props.handler.bind(_this);
    _this.styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
      container: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justiyContent: 'flex-end',
        fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_secondary,
        fontSize: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_size_secondary,
        fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_secondary,
        outline: 'none'
      },
      text: {
        display: 'flex',
        flex: 1,
        textTransform: 'uppercase',
        letterSpacing: 2,
        textAlign: 'center',
        color: '#56c5ff',
        fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_secondary,
        fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_secondary,
        fontSize: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_size_secondary + 2,
        marginBottom: 20
      },
      image_container: {
        position: 'relative',
        display: 'flex',
        overflow: 'hidden',
        transition: 'all 180ms ease-in-out',
        ':hover': {
          paddingTop: 10,
          paddingRight: 30,
          paddingBottom: 0,
          paddingLeft: 30
        },
        cursor: 'pointer',
        flex: 3,
        alignItems: 'flex-end'
      },
      image: {
        marginBottom: -20,
        display: 'block',
        height: 150,
        transition: 'all 180ms ease-in-out',
        ':hover': {
          scale: 2,
          marginBottom: 0,
          transform: 'scale(1.3,1.1)'
        }
      }
    });
    return _this;
  }

  _createClass(ShowMoreTrigger, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.styles.container),
          role: 'button',
          tabIndex: 0,
          onClick: this.clickHandler },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.styles.text) },
          'Load more dogs'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.styles.image_container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(this.styles.image), src: PAW_ASSET, alt: 'Paw' })
        )
      );
    }
  }]);

  return ShowMoreTrigger;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ShowMoreTrigger);


ShowMoreTrigger.defaultProps = {
  handler: function handler() {}
};

ShowMoreTrigger.propTypes = {
  handler: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func
};

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapStateToProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_hasIn__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_hasIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_hasIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_stripe_elements__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_stripe_elements__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var StripeAPIProvider = function (_Component) {
  _inherits(StripeAPIProvider, _Component);

  function StripeAPIProvider() {
    _classCallCheck(this, StripeAPIProvider);

    return _possibleConstructorReturn(this, (StripeAPIProvider.__proto__ || Object.getPrototypeOf(StripeAPIProvider)).apply(this, arguments));
  }

  _createClass(StripeAPIProvider, [{
    key: 'render',
    value: function render() {
      // Skip Stripe initialization during pre-rendering
      if (navigator.userAgent === 'ReactSnap') {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          null,
          this.props.children
        );
      }

      if (!this.props.stripeApiKey) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', null);
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_stripe_elements__["StripeProvider"],
        { apiKey: this.props.stripeApiKey },
        this.props.children
      );
    }
  }]);

  return StripeAPIProvider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

StripeAPIProvider.propTypes = {
  stripeApiKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element)])
};

StripeAPIProvider.defaultProps = {
  stripeApiKey: null,
  children: null
};

function mapStateToProps(state) {
  var stripeApiKey = null;
  if (__WEBPACK_IMPORTED_MODULE_0_lodash_hasIn___default()(state, ['appdata', 'apiKeys', 'stripe'])) {
    stripeApiKey = state.appdata.apiKeys.stripe;
  }
  return { stripeApiKey: stripeApiKey };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(StripeAPIProvider));

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return organizationSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return websiteSchema; });
/* unused harmony export faqSchema */
/* unused harmony export breadcrumbSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);




var StructuredData = function StructuredData(_ref) {
  var data = _ref.data;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_helmet__["Helmet"],
    null,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'script',
      { type: 'application/ld+json' },
      JSON.stringify(data)
    )
  );
};

StructuredData.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};

// Helper functions for common structured data types
var organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'The Dog Share Collective',
  url: 'https://www.thedogsharecollective.com',
  logo: 'https://www.thedogsharecollective.com/images/tdsc-share.png',
  description: 'Connect dog owners with dog lovers for walking, playdates, and companionship.',
  sameAs: ['https://www.facebook.com/DogShareCollective', 'https://www.instagram.com/dogsharecollective/'],
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'NZ',
    addressRegion: 'New Zealand'
  }
};

var websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  url: 'https://www.thedogsharecollective.com',
  name: 'The Dog Share Collective',
  description: 'Find local dogs to walk, play with, and share companionship.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://www.thedogsharecollective.com/find?q={search_term_string}'
    },
    'query-input': 'required name=search_term_string'
  }
};

var faqSchema = function faqSchema(questions) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questions.map(function (_ref2) {
      var question = _ref2.question,
          answer = _ref2.answer;
      return {
        '@type': 'Question',
        name: question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answer
        }
      };
    })
  };
};

var breadcrumbSchema = function breadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map(function (item, index) {
      return {
        '@type': 'ListItem',
        position: index + 1,
        name: item.name,
        item: item.url
      };
    })
  };
};

/* harmony default export */ __webpack_exports__["a"] = (StructuredData);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConditionsModal__ = __webpack_require__(179);
var _promo;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SubscriptionCard = function (_Component) {
  _inherits(SubscriptionCard, _Component);

  function SubscriptionCard(props) {
    _classCallCheck(this, SubscriptionCard);

    var _this = _possibleConstructorReturn(this, (SubscriptionCard.__proto__ || Object.getPrototypeOf(SubscriptionCard)).call(this, props));

    _this.toggleConditions = _this.toggleConditions.bind(_this);
    _this.state = {
      showConditions: false
    };
    return _this;
  }

  _createClass(SubscriptionCard, [{
    key: 'toggleConditions',
    value: function toggleConditions() {
      this.setState({
        showConditions: !this.state.showConditions
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          role: 'button',
          tabIndex: 0,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.card, this.props.selected === this.props.id ? styles.card_selected : null),
          onClick: function onClick() {
            return _this2.props.handleSelect(_this2.props.id);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.icon), src: this.props.icon, alt: this.props.title }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.title) },
          this.props.title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.includes_label) },
          'Includes'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.includes) },
          this.props.includes.map(function (include) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              { key: include, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.includes_item) },
              include
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.price) },
          '$',
          this.props.promoPrice !== null ? this.props.promoPrice.toFixed(2) : this.props.price.toFixed(2)
        ),
        this.props.promoText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.promo) },
          this.props.promoTitle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.promo_title) },
            this.props.promoTitle
          ) : null,
          this.props.promoText
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            role: 'button',
            tabIndex: 0,
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.conditions),
            onClick: this.toggleConditions
          },
          'See conditions'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__ConditionsModal__["a" /* default */],
          { open: this.state.showConditions, toggle: this.toggleConditions },
          this.props.conditions
        )
      );
    }
  }]);

  return SubscriptionCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SubscriptionCard);


SubscriptionCard.defaultProps = {
  promoPrice: null,
  promoText: null,
  promoTitle: null
};

SubscriptionCard.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  includes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  // conditions: PropTypes.objectOf(PropTypes.node).isRequired,
  handleSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  conditions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  promoPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  promoTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  promoText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node).isRequired, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  card: _defineProperty({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 422,
    padding: '38px 12px 0',
    margin: '0 15px',
    textAlign: 'center',
    color: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].black,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].white,
    boxShadow: '0 3px 4px 0 rgba(171, 171, 171, 0.5), 0 0 0 0 #39b4d6',
    border: 'solid 1px #e4e4e4',
    transition: 'all 300ms',
    outline: 'none',
    cursor: 'pointer'

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    margin: '0 0 30px'
  }),

  promo: (_promo = {
    width: 422,
    margin: '0 -12px',
    padding: '15px',
    textAlign: 'center',
    color: '#fff',
    fontSize: 14,
    lineHeight: 1.4,
    backgroundColor: '#021a36'

  }, _defineProperty(_promo, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto'
  }), _defineProperty(_promo, ':not(.a) strong', {
    fontWeight: 'bold'
  }), _promo),
  promo_title: {
    display: 'block',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    marginBottom: 5,
    fontSize: 13,
    letterSpacing: 0.65
  },

  card_selected: _defineProperty({
    borderColor: 'transparent',
    boxShadow: '0 3px 4px 0 rgba(171, 171, 171, 0.2), 0px 0px 6px 4px #39b4d6'
  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    boxShadow: '0 3px 4px 0 rgba(171, 171, 171, 0.2), 0px 0px 6px 4px #39b4d6'
  }),

  icon: {
    height: 132,
    width: 132,
    borderRadius: '50%',
    marginBottom: 16.5,
    color: 'transparent'
  },

  title: _defineProperty({
    marginBottom: 24.5,
    padding: '0 92px',
    fontSize: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_heading

  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0 30px'
  }),

  includes_label: {
    display: 'block',
    width: '100%',
    paddingTop: 19,
    marginBottom: 10,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_secondary,
    letterSpacing: 1.8,
    lineHeight: 2,
    color: '#a5a5a5',
    fontSize: 13,
    textTransform: 'uppercase',
    borderTop: '1px solid #ddd'
  },

  includes: {
    padding: '0 21px',
    marginBottom: 25
  },

  includes_item: {
    lineHeight: 1.4,
    fontSize: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_primary,

    ':not(:last-child)': {
      marginBottom: 15
    }
  },

  price: {
    marginBottom: 30,
    fontSize: 45,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_heading
  },

  conditions: {
    height: 70,
    width: '100%',
    lineHeight: '70px',
    fontSize: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].font_weight_secondary,
    textTransform: 'uppercase',
    letterSpacing: 2,
    color: '#39b4d6',
    borderTop: '1px solid #ddd',
    outline: 'none',
    cursor: 'pointer'
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_routes__ = __webpack_require__(66);
/* eslint-disable max-len */






var INFORMATION_ICON = __webpack_require__(336);

/**
 * @return {*}
 * @constructor
 */
var SubscriptionExpiryMessage = function SubscriptionExpiryMessage() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'message' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'message__addon' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: INFORMATION_ICON, alt: 'Information icon' })
    ),
    'Sorry, your subscription has expired. To re-activate your subscription please navigate to your ',
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Link */],
      { to: __WEBPACK_IMPORTED_MODULE_2__config_routes__["a" /* ROUTES */].SETTINGS.MEMBERSHIP },
      'My Membership'
    ),
    ' tab.'
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SubscriptionExpiryMessage);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var Toast = function Toast(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'toast' },
    props.children
  );
};

Toast.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Toast);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_react_loader_warning_svg__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_react_loader_warning_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_react_loader_warning_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserImage__ = __webpack_require__(47);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







 // eslint-disable-line


var Profile = function (_Component) {
  _inherits(Profile, _Component);

  function Profile() {
    _classCallCheck(this, Profile);

    return _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).apply(this, arguments));
  }

  _createClass(Profile, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.profile) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Link */],
          { to: '/' + (this.props.dog ? 'pooch' : 'profile') + '/' + this.props.id },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UserImage__["a" /* default */], { styles: styles.profile_image, image: this.props.image })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.profile_details) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.profile_name) },
            this.props.name
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.profile_status) },
            !this.props.published ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_react_loader_warning_svg___default.a, { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.profile_status_icon) }) : null,
            this.props.published ? 'Published' : 'Incomplete'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Link */],
          {
            to: '/' + (this.props.dog ? 'pooch' : 'profile') + '/' + this.props.id + '/edit',
            onClick: this.props.callback,
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.profile_edit) },
          'Edit'
        )
      );
    }
  }]);

  return Profile;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Profile);


Profile.defaultProps = {
  dog: true,
  published: false,
  callback: function callback() {}
};

Profile.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].number.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].string.isRequired,
  image: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].string.isRequired,
  dog: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].bool,
  published: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].bool,
  callback: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].func
};

var styles = __WEBPACK_IMPORTED_MODULE_1_aphrodite__["StyleSheet"].create({
  profile: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 24px 12px 12px',
    borderBottom: '1px solid #16345a'
  },

  profile_image: {
    height: 55,
    width: 55,
    marginLeft: 0,
    marginRight: 15
  },

  profile_details: {
    flexGrow: 1
  },

  profile_name: {
    marginBottom: 8,
    fontSize: 17,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_primary
  },

  profile_status: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_secondary,
    fontSize: 11,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_secondary,
    lineHeight: 1,
    letterSpacing: 1.5,
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    textTransform: 'uppercase'
  },

  profile_status_icon: {
    position: 'relative',
    top: -1,
    marginRight: 12
  },

  profile_edit: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_secondary,
    fontSize: 15,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_secondary,
    lineHeight: 1.73,
    letterSpacing: 2,
    color: '#39b4d6',
    textTransform: 'uppercase'
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserImage__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Profile__ = __webpack_require__(214);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var UserMenu = function (_Component) {
  _inherits(UserMenu, _Component);

  function UserMenu(props) {
    _classCallCheck(this, UserMenu);

    var _this = _possibleConstructorReturn(this, (UserMenu.__proto__ || Object.getPrototypeOf(UserMenu)).call(this, props));

    _this.state = {
      menuOpen: false
    };

    _this.toggleMenu = _this.toggleMenu.bind(_this);
    return _this;
  }

  _createClass(UserMenu, [{
    key: 'getUserImage',
    value: function getUserImage() {
      var user = this.props.user;

      if (user.image_url && user.image_url.length > 10) {
        return user.image_url;
      }

      if (user.profile_photo && user.profile_photo.length > 10) {
        return user.profile_photo;
      }

      return '/images/default_profile.jpg';
    }
  }, {
    key: 'getDogImage',
    value: function getDogImage(dog) {
      if (dog.image_url && dog.image_url.length > 10) {
        return dog.image_url;
      }

      if (dog.profile_photo && dog.profile_photo.length > 10) {
        return dog.profile_photo;
      }

      return '/images/default_dog.jpg';
    }
  }, {
    key: 'getHasDogs',
    value: function getHasDogs() {
      var dogs = this.props.user.dogs;

      return dogs && dogs.length;
    }
  }, {
    key: 'canAddPooch',
    value: function canAddPooch() {
      var userIsOwner = this.props.user.subscription === 'Owner';

      if (!userIsOwner || this.props.user.dogs && this.props.user.dogs.length >= 4) {
        // Maximum of 4 dogs can be added
        return false;
      }

      return true;
    }
  }, {
    key: 'hasUnpublishedProfiles',
    value: function hasUnpublishedProfiles() {
      if (!this.props.user.published) {
        return true;
      }

      return this.props.user.dogs && this.props.user.dogs.find(function (dog) {
        return !dog.published;
      });
    }
  }, {
    key: 'toggleMenu',
    value: function toggleMenu(e, preventDefault) {
      if (preventDefault) e.preventDefault();

      this.setState({
        menuOpen: !this.state.menuOpen
      });
    }
  }, {
    key: 'renderImage',
    value: function renderImage() {
      var _this2 = this;

      // if (this.getHasDogs()) {
      //   const firstDog = this.props.user.dogs[0];
      //   return (
      //     <Link to={`/pooch/${firstDog.id}`} onClick={Theme.isMobile ? e =>
      //             this.toggleMenu(e, true) : null}>
      //       <UserImage styles={styles.profile_image} image={this.getDogImage(firstDog)} />
      //     </Link>
      //   );
      // }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
        { to: '/profile/' + this.props.user.id, onClick: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].isMobile ? function (e) {
            return _this2.toggleMenu(e, true);
          } : null },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__UserImage__["a" /* default */], { styles: styles.profile_image, image: this.getUserImage() })
      );
    }
  }, {
    key: 'renderDogs',
    value: function renderDogs() {
      var _this3 = this;

      return this.getHasDogs() ? this.props.user.dogs.map(function (dog) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Profile__["a" /* default */], {
          id: dog.id,
          name: dog.name,
          dog: true,
          published: dog.published,
          image: _this3.getDogImage(dog),
          callback: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].isMobile ? _this3.toggleMenu : null });
      }) : false;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.profile_container, this.state.menuOpen ? styles.container_top : null) + ' SVGContainer SettingsSVG',
          onMouseEnter: !__WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].isMobile && !this.state.menuOpen ? this.toggleMenu : null,
          onMouseLeave: !__WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].isMobile && this.state.menuOpen ? this.toggleMenu : null },
        __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].isMobile && this.state.menuOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.close), onClick: this.toggleMenu, role: 'button', tabIndex: 0 }) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.profile_bubble) },
          this.renderImage(),
          this.hasUnpublishedProfiles() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.label) },
            'New'
          ) : false
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.profile_menu, this.state.menuOpen ? styles.menu_open : null) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Profile__["a" /* default */], {
            id: this.props.user.id,
            name: this.props.user.display_name ? this.props.user.display_name : this.props.user.first_name,
            dog: false,
            published: this.props.user.published,
            image: this.getUserImage(),
            callback: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].isMobile ? this.toggleMenu : null }),
          this.renderDogs(),
          this.canAddPooch() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* NavLink */],
              { to: '/join/pooch', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.profile_add) },
              'Add ',
              this.props.user.dogs && this.props.user.dogs.length > 0 ? 'another' : 'a',
              ' Pooch'
            )
          ) : false
        )
      );
    }
  }]);

  return UserMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (UserMenu);


UserMenu.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired
  // dispatch: PropTypes.object.isRequired,
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  close: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    content: '""'
  },
  container_top: {
    zIndex: 9
  },
  profile_container: _defineProperty({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].navigation.height,
    marginLeft: 20,
    marginRight: 15

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    position: 'static',
    marginLeft: 10,
    marginRight: 5
  }),
  profile_bubble: {
    position: 'relative'
  },
  label: _defineProperty({
    position: 'absolute',
    zIndex: 1,
    bottom: 0,
    right: -18,
    height: 18,
    padding: '0 7px 0 8px',
    color: '#fff',
    fontSize: 10,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: 900,
    lineHeight: '18px',
    letterSpacing: 1.4,
    textAlign: 'center',
    textTransform: 'uppercase',
    borderRadius: 4,
    backgroundColor: '#39b4d6'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    bottom: -6,
    right: 'calc(50% - 22px)'
  }),

  profile_image: {
    marginLeft: 0,
    marginRight: 0
  },
  menu_open: {
    transform: 'rotate(0deg)',
    opacity: 1,
    pointerEvents: 'initial'
  },

  profile_menu: _defineProperty({
    position: 'absolute',
    top: '100%',
    right: -10,
    width: 385,
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    backgroundColor: '#021a36',
    opacity: 0,
    transform: 'rotateX(-100deg)',
    transformOrigin: 'top center',
    transition: 'all 500ms cubic-bezier(0.175, 0.885, 0.320, 1.275)',
    pointerEvents: 'none'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    right: 0,
    width: '100vw'
  }),

  profile_add: {
    display: 'block',
    height: 60,
    lineHeight: '60px',
    textAlign: 'center',
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_secondary,
    fontSize: 15,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_secondary,
    letterSpacing: 2,
    color: '#39b4d6',
    textTransform: 'uppercase',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    transition: 'all 300ms',

    ':hover': {
      color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
      backgroundColor: '#39b4d6'
    }
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var YouTubeEmbed = function (_Component) {
  _inherits(YouTubeEmbed, _Component);

  function YouTubeEmbed() {
    _classCallCheck(this, YouTubeEmbed);

    return _possibleConstructorReturn(this, (YouTubeEmbed.__proto__ || Object.getPrototypeOf(YouTubeEmbed)).apply(this, arguments));
  }

  _createClass(YouTubeEmbed, [{
    key: 'render',
    value: function render() {
      var videoURL = 'https://www.youtube.com/embed/' + this.props.vid + '?autoplay=0&fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', {
          title: 'YouTube Embed',
          frameBorder: '0',
          scrolling: 'no',
          marginHeight: '0',
          marginWidth: '0',
          width: '100%',
          height: '500',
          type: 'text/html',
          src: videoURL })
      );
    }
  }]);

  return YouTubeEmbed;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (YouTubeEmbed);


YouTubeEmbed.propTypes = {
  vid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    position: 'relative',
    lineHeight: '24px'
  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    margin: '0px auto',
    width: '100%'
  }),
  image: {
    margin: '50px auto',
    width: '100%'
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);


var INITIAL_STATE = {
  interest: [],
  need: [],
  breed: [],
  dogsize: [],
  city: [],
  charity: [],
  locality: [],
  localitydistrict: [],
  suburb: []
};

/**
 * Application props via this.props.appdata in connected components
 */
var applicationData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])({
  UPDATE_APP_DATA: function UPDATE_APP_DATA(state, action) {
    return Object.assign({}, state, action.payload);
  }
}, INITIAL_STATE);

/* harmony default export */ __webpack_exports__["a"] = (applicationData);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);


var INITIAL_STATE = {
  loading: false,
  login_modal_open: false,
  login_modal_title: '',
  loading_text: 'Fetching...'
};

/**
 * Application props via this.props.appstate in connected components
 */
var applicationState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])({
  UPDATE_APP_STATE: function UPDATE_APP_STATE(state, action) {
    return Object.assign({}, state, action.payload);
  }
}, INITIAL_STATE);

/* harmony default export */ __webpack_exports__["a"] = (applicationState);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);


var INITIAL_STATE = {
  dogs: []
};

var DOG_INITIAL_STATE = { //eslint-disable-line
  name: '',
  breed: '',
  dogsize: '',
  about: '',
  date_of_birth: '',
  good_with_children: false,
  plays_with_other_dogs: false,
  registration: '',
  needs: [],
  interests: [],
  health_needs: '',
  hypoallergenic_coat: false,
  image_url: '',

  sex: null,
  fixed: null
};

var dogs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])({
  UPDATE_DOGS: function UPDATE_DOGS(state, action) {
    return Object.assign({}, state, action.payload);
  },
  LOGOUT: INITIAL_STATE
}, INITIAL_STATE);

/* harmony default export */ __webpack_exports__["a"] = (dogs);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__applicationData__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__applicationState__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dogs__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__messaging__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__profile__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__search__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user__ = __webpack_require__(224);










var rootReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* combineReducers */])({
  appdata: __WEBPACK_IMPORTED_MODULE_1__applicationData__["a" /* default */],
  appstate: __WEBPACK_IMPORTED_MODULE_2__applicationState__["a" /* default */],
  dogs: __WEBPACK_IMPORTED_MODULE_3__dogs__["a" /* default */],
  profile: __WEBPACK_IMPORTED_MODULE_5__profile__["a" /* default */],
  user: __WEBPACK_IMPORTED_MODULE_7__user__["a" /* user */],
  search: __WEBPACK_IMPORTED_MODULE_6__search__["a" /* default */],
  messaging: __WEBPACK_IMPORTED_MODULE_4__messaging__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = messaging;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  conversations: {
    data: [],
    loading: false,
    error: null
  },
  messages: {
    // Structured by conversation ID
    // e.g. "1": { data: [], loading: false, error: null, pagination: {} }
  },
  unreadCount: 0,
  pendingActions: {
    sendMessage: {
      inProgress: false,
      error: null
    },
    deleteMessage: {
      inProgress: false,
      error: null
    },
    reportMessage: {
      inProgress: false,
      error: null
    },
    ensureConversation: {
      inProgress: false,
      error: null
    }
  }
};

function messaging() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    // Conversations actions
    case 'CONVERSATIONS_LOADING':
      return Object.assign({}, state, {
        conversations: Object.assign({}, state.conversations, {
          loading: true,
          error: null
        })
      });
    case 'CONVERSATIONS_LOADED':
      return Object.assign({}, state, {
        conversations: {
          data: action.payload.data,
          loading: false,
          error: null
        }
      });
    case 'CONVERSATIONS_ERROR':
      return Object.assign({}, state, {
        conversations: Object.assign({}, state.conversations, {
          loading: false,
          error: action.payload
        })
      });

    case 'ENSURE_CONVERSATION_REQUEST':
      return Object.assign({}, state, {
        pendingActions: Object.assign({}, state.pendingActions, {
          ensureConversation: {
            inProgress: true,
            error: null
          }
        })
      });
    case 'ENSURE_CONVERSATION_SUCCESS':
      {
        var conversation = action.payload.conversation;
        var conversationsState = state.conversations || {};
        var conversationsData = conversationsState.data || [];
        var existingIndex = conversationsData.findIndex(function (existingConversation) {
          return existingConversation && existingConversation.id === conversation.id;
        });

        var updatedData = void 0;
        var nextUnreadCount = state.unreadCount;

        var nextUnread = typeof conversation.unreadCount === 'number' ? conversation.unreadCount : 0;

        if (existingIndex !== -1) {
          var previousConversation = conversationsData[existingIndex] || {};
          var previousUnread = previousConversation && typeof previousConversation.unreadCount === 'number' ? previousConversation.unreadCount : 0;
          var unreadDelta = nextUnread - previousUnread;
          nextUnreadCount = Math.max(0, nextUnreadCount + unreadDelta);

          updatedData = conversationsData.map(function (existingConversation) {
            if (existingConversation && existingConversation.id === conversation.id) {
              return Object.assign({}, existingConversation, conversation);
            }

            return existingConversation;
          });
        } else {
          nextUnreadCount = Math.max(0, nextUnreadCount + nextUnread);
          updatedData = [conversation].concat(_toConsumableArray(conversationsData));
        }

        return Object.assign({}, state, {
          conversations: Object.assign({}, conversationsState, {
            data: updatedData
          }),
          pendingActions: Object.assign({}, state.pendingActions, {
            ensureConversation: {
              inProgress: false,
              error: null
            }
          }),
          unreadCount: nextUnreadCount
        });
      }
    case 'ENSURE_CONVERSATION_ERROR':
      return Object.assign({}, state, {
        pendingActions: Object.assign({}, state.pendingActions, {
          ensureConversation: {
            inProgress: false,
            error: action.payload ? action.payload.error : null
          }
        })
      });

    // Messages actions
    case 'MESSAGES_LOADING':
      return Object.assign({}, state, {
        messages: Object.assign({}, state.messages, _defineProperty({}, action.payload.conversationId, Object.assign({}, state.messages[action.payload.conversationId] || {}, {
          loading: true,
          error: null
        })))
      });
    case 'MESSAGES_LOADED':
      return Object.assign({}, state, {
        messages: Object.assign({}, state.messages, _defineProperty({}, action.payload.conversationId, {
          data: action.payload.data.data,
          pagination: action.payload.data.pagination,
          loading: false,
          error: null
        }))
      });
    case 'MESSAGES_ERROR':
      return Object.assign({}, state, {
        messages: Object.assign({}, state.messages, _defineProperty({}, action.payload.conversationId, Object.assign({}, state.messages[action.payload.conversationId] || {}, {
          loading: false,
          error: action.payload.error
        })))
      });

    // Send message actions
    case 'SEND_MESSAGE_PENDING':
      {
        var conversationId = action.payload.conversationId;
        var conversationState = state.messages[conversationId] || {};
        var currentMessages = conversationState.data || [];

        return Object.assign({}, state, {
          pendingActions: Object.assign({}, state.pendingActions, {
            sendMessage: {
              inProgress: true,
              error: null
            }
          }),
          messages: Object.assign({}, state.messages, _defineProperty({}, conversationId, Object.assign({}, conversationState, {
            // Add the optimistic message to the end of the array
            data: [].concat(_toConsumableArray(currentMessages), [action.payload.optimisticMessage])
          })))
        });
      }
    case 'SEND_MESSAGE_SUCCESS':
      {
        // Get current messages for this conversation
        var _conversationId = action.payload.conversationId;
        var _conversationState = state.messages[_conversationId] || {};
        var _currentMessages = _conversationState.data || [];

        // Replace the optimistic message with the real one
        var updatedMessages = _currentMessages.map(function (msg) {
          if (msg.id === action.payload.tempId) {
            return action.payload.message;
          }
          return msg;
        });

        return Object.assign({}, state, {
          pendingActions: Object.assign({}, state.pendingActions, {
            sendMessage: {
              inProgress: false,
              error: null
            }
          }),
          messages: Object.assign({}, state.messages, _defineProperty({}, _conversationId, Object.assign({}, _conversationState, {
            data: updatedMessages
          })))
        });
      }
    case 'SEND_MESSAGE_ERROR':
      {
        var _conversationId2 = action.payload.conversationId;
        var _conversationState2 = state.messages[_conversationId2] || {};
        var _currentMessages2 = _conversationState2.data || [];

        // Remove the failed optimistic message
        var filteredMessages = _currentMessages2.filter(function (msg) {
          return msg.id !== action.payload.tempId;
        });

        return Object.assign({}, state, {
          pendingActions: Object.assign({}, state.pendingActions, {
            sendMessage: {
              inProgress: false,
              error: action.payload.error
            }
          }),
          messages: Object.assign({}, state.messages, _defineProperty({}, _conversationId2, Object.assign({}, _conversationState2, {
            data: filteredMessages
          })))
        });
      }

    // Delete message actions
    case 'DELETE_MESSAGE_PENDING':
      return Object.assign({}, state, {
        pendingActions: Object.assign({}, state.pendingActions, {
          deleteMessage: {
            inProgress: true,
            error: null
          }
        })
      });
    case 'DELETE_MESSAGE_SUCCESS':
      {
        // Create a new state with the message removed from all conversations
        var messageId = action.payload.messageId;
        var newMessages = Object.assign({}, state.messages);

        // Remove message from any conversation where it exists
        Object.keys(newMessages).forEach(function (conversationId) {
          var conversation = newMessages[conversationId] || {};
          if (conversation.data) {
            newMessages[conversationId] = Object.assign({}, conversation, {
              data: conversation.data.filter(function (message) {
                return message.id !== messageId;
              })
            });
          }
        });

        return Object.assign({}, state, {
          pendingActions: Object.assign({}, state.pendingActions, {
            deleteMessage: {
              inProgress: false,
              error: null
            }
          }),
          messages: newMessages
        });
      }
    case 'DELETE_MESSAGE_ERROR':
      return Object.assign({}, state, {
        pendingActions: Object.assign({}, state.pendingActions, {
          deleteMessage: {
            inProgress: false,
            error: action.payload.error
          }
        })
      });

    // Report message actions
    case 'REPORT_MESSAGE_PENDING':
      return Object.assign({}, state, {
        pendingActions: Object.assign({}, state.pendingActions, {
          reportMessage: {
            inProgress: true,
            error: null
          }
        })
      });
    case 'REPORT_MESSAGE_SUCCESS':
      return Object.assign({}, state, {
        pendingActions: Object.assign({}, state.pendingActions, {
          reportMessage: {
            inProgress: false,
            error: null
          }
        })
      });
    case 'REPORT_MESSAGE_ERROR':
      return Object.assign({}, state, {
        pendingActions: Object.assign({}, state.pendingActions, {
          reportMessage: {
            inProgress: false,
            error: action.payload.error
          }
        })
      });

    // Update state directly
    case 'UPDATE_MESSAGING_STATE':
      return Object.assign({}, state, action.payload);

    // Set unread message count
    case 'SET_UNREAD_MESSAGE_COUNT':
      return Object.assign({}, state, {
        unreadCount: action.payload
      });

    case 'MARK_CONVERSATION_READ':
      {
        var _ref = action.payload || {},
            _conversationId3 = _ref.conversationId,
            _unreadDelta = _ref.unreadDelta;

        var numericConversationId = Number(_conversationId3);
        var _conversationsState = state.conversations || {};
        var _conversationsData = _conversationsState.data || [];

        var delta = typeof _unreadDelta === 'number' ? _unreadDelta : 0;

        var updatedConversationsData = _conversationsData.map(function (conversation) {
          if (!conversation || conversation.id !== numericConversationId) {
            return conversation;
          }

          if (typeof _unreadDelta !== 'number') {
            delta = typeof conversation.unreadCount === 'number' ? conversation.unreadCount : 0;
          }

          return Object.assign({}, conversation, {
            unreadCount: 0
          });
        });

        var _nextUnreadCount = Math.max(0, state.unreadCount - delta);

        return Object.assign({}, state, {
          conversations: Object.assign({}, _conversationsState, {
            data: updatedConversationsData
          }),
          unreadCount: _nextUnreadCount
        });
      }

    default:
      return state;
  }
}

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);


var INITIAL_STATE = {
  display_name: '',
  availability: '',
  living_situation: '',
  bio: '',
  pet_insurance: false,
  police_checked: false,
  needs: [],
  interests: [],
  profile_photo: ''
};

/**
 * profile in state
 * Maintains user profile state (human profile)
 */
var profile = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])({
  UPDATE_PROFILE: function UPDATE_PROFILE(state, action) {
    return Object.assign({}, state, action.payload);
  },
  ADD_PROFILE_NEED: function ADD_PROFILE_NEED(state, action) {
    var inArray = state.needs.find(function (need) {
      return need === action.payload;
    });

    // If the item is not already in the array, add it. Otherwise return state
    return !inArray ? Object.assign({}, state, {
      needs: state.needs.concat([action.payload])
    }) : state;
  },
  REMOVE_PROFILE_NEED: function REMOVE_PROFILE_NEED(state, action) {
    return Object.assign({}, state, {
      needs: state.needs.filter(function (need) {
        return need !== action.payload;
      })
    });
  },
  ADD_PROFILE_INTEREST: function ADD_PROFILE_INTEREST(state, action) {
    var inArray = state.interests.find(function (interest) {
      return interest === action.payload;
    });

    // If the item is not already in the array, add it. Otherwise return state
    return !inArray ? Object.assign({}, state, {
      interests: state.interests.concat([action.payload])
    }) : state;
  },
  REMOVE_PROFILE_INTEREST: function REMOVE_PROFILE_INTEREST(state, action) {
    return Object.assign({}, state, {
      interests: state.interests.filter(function (interest) {
        return interest !== action.payload;
      })
    });
  },
  LOGOUT: function LOGOUT(state) {
    return Object.assign({}, state, INITIAL_STATE);
  }
}, INITIAL_STATE);

/* harmony default export */ __webpack_exports__["a"] = (profile);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);


var INITIAL_STATE = {
  query: '',
  results: [],
  interests: [],
  needs: [],
  district: '',
  suburb: '',
  breed: '',
  page: [],
  sort: []
};

/**
 * search in state
 * Provides search results
 */
var search = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])({
  SEARCH_RESULTS: function SEARCH_RESULTS(state, action) {
    return Object.assign({}, state, action.payload);
  },
  SAVE_SEARCH: function SAVE_SEARCH(state, action) {
    return Object.assign({}, state, action.payload);
  },
  LOGOUT: INITIAL_STATE
}, INITIAL_STATE);

/* harmony default export */ __webpack_exports__["a"] = (search);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return user; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);


var INITIAL_STATE = {
  id: null,
  email: null,
  first_name: null,
  last_name: null,
  access_token: null,
  fb_id: null,
  fb_access_token: null,
  facebook_token: null,
  isAuthenticated: false,

  image_url: null,
  profile_photo: null, // Image URL
  display_name: null,
  living_situation: null,
  availability: 'Auckland', // Default city
  bio: null,
  interests: [],
  needs: [],
  has_dog: false,
  dogs: [],
  police_checked: false,
  pet_insurance: false,
  completed_membership: false,
  verified: false,

  unread_notifications: [],
  all_notifications: [],
  match_requests: [],

  newsletter: true, // TDSC email updates
  dogs_in_area: false,

  // #TODO content below
  billing_first_name: null,
  billing_last_name: null,
  billing_address_1: null,
  billing_address_2: null,
  billing_post_code: null,
  billing_city: null,
  billing_state: null,
  billing_country: null,
  billing_charity: null,

  current_membership: false,
  subscription: null, // Borrower or Owner
  membership_start_date: null,
  card_number: null, // Will be in format XXXX-XXX-XXXX-6789

  suburb: null
};

/**
 * user in state
 * Provides account and authentication details
*/
var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])( // eslint-disable-line
{
  LOGIN: function LOGIN(state, action) {
    return Object.assign({}, state, action.payload);
  },
  UPDATE_USER: function UPDATE_USER(state, action) {
    return Object.assign({}, state, action.payload);
  },
  LOGOUT: function LOGOUT() {
    return INITIAL_STATE;
  },
  READ_NOTIFICATION_BY_ID: function READ_NOTIFICATION_BY_ID(state, action) {
    return Object.assign({}, state, {
      unread_notifications: state.unread_notifications.filter(function (notification) {
        return notification.id !== action.payload;
      })
    });
  }
}, INITIAL_STATE);

/***/ }),
/* 225 */
/***/ (function(module, exports) {

/* eslint-disable */
function warn(error) {
  console.warn(error.message || error);
  throw error; // To let the caller handle the rejection
}

module.exports = function (store) {
  return function (next) {
    return function (action) {
      return typeof action.then === 'function' ? Promise.resolve(action).then(next, warn) : next(action);
    };
  };
};

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_LoginModal__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Loader__ = __webpack_require__(100);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














/*
 * Top-level component which provides global functionality upon state changes
 */

var ApplicationHelper = function (_Component) {
  _inherits(ApplicationHelper, _Component);

  function ApplicationHelper(props) {
    _classCallCheck(this, ApplicationHelper);

    var _this = _possibleConstructorReturn(this, (ApplicationHelper.__proto__ || Object.getPrototypeOf(ApplicationHelper)).call(this, props));

    _this.loginModalCloseHandler = _this.closeLoginModal.bind(_this);
    return _this;
  }

  _createClass(ApplicationHelper, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
        window.scrollTo(0, 0);

        this.props.ga.pageview(window.location.pathname + window.location.search);
      }
    }
  }, {
    key: 'closeLoginModal',
    value: function closeLoginModal() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions_applicationState__["a" /* updateAppState */])({
        login_modal_open: false
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.children,
        this.props.appstate.loading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Loader__["a" /* default */], { text: this.props.appstate.loading_text }) : false,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_LoginModal__["a" /* default */], {
          history: this.props.history,
          dispatch: this.props.dispatch,
          open: this.props.appstate.login_modal_open,
          title: this.props.appstate.login_modal_title,
          closeHandler: this.loginModalCloseHandler })
      );
    }
  }]);

  return ApplicationHelper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ApplicationHelper.defaultProps = {
  children: []
};

ApplicationHelper.propTypes = {
  appstate: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].node).isRequired, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object]),
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  ga: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func, __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_4__utils__["b" /* mapDispatchToProps */])(ApplicationHelper)));

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_applicationData__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_BlogCard__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Body__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_DashboardHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_SEO__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_UnauthenticatedHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ContentContainer__ = __webpack_require__(9);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// import Isvg from 'react-inlinesvg';
















var Blog = function (_Component) {
  _inherits(Blog, _Component);

  function Blog(props) {
    _classCallCheck(this, Blog);

    var _this = _possibleConstructorReturn(this, (Blog.__proto__ || Object.getPrototypeOf(Blog)).call(this, props));

    _this.openLoginHandler = _this.loginModalOpenHandler.bind(_this);
    _this.logoutHandler = _this.performLogout.bind(_this);
    _this.redirectHandler = _this.performRedirect.bind(_this);

    _this.state = {
      posts: [],
      loaded: false
    };
    return _this;
  }

  _createClass(Blog, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Skip API calls during react-snap pre-rendering
      if (navigator.userAgent === 'ReactSnap') {
        this.setState({ loaded: true, posts: [] });
        return;
      }

      this.fetchBlogPosts();
    }
  }, {
    key: 'performLogout',
    value: function performLogout() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_user__["b" /* logout */])());
      this.props.history.push('/');
    }
  }, {
    key: 'performRedirect',
    value: function performRedirect(to) {
      this.props.history.push(to);
    }
  }, {
    key: 'loginModalOpenHandler',
    value: function loginModalOpenHandler() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions_applicationState__["a" /* updateAppState */])({
        login_modal_open: true
      }));
    }
  }, {
    key: 'fetchBlogPosts',
    value: function fetchBlogPosts() {
      var _this2 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions_applicationData__["f" /* getBlogPosts */])()).then(function (response) {
          _this2.setState({
            posts: response.posts,
            loaded: true
          });

          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        }, function (err) {
          console.log(err); // eslint-disable-line no-console
          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
          _this2.props.history.push('/404');
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__components_Body__["a" /* default */],
        { hasFooter: true },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_SEO__["a" /* default */], {
          title: 'Dog Care Blog - Tips, Stories & Advice',
          description: 'Read the latest articles about dog care, training tips, and heartwarming ' + 'stories from The Dog Share Collective community.',
          keywords: 'dog blog, dog care tips, dog training, dog stories, pet care advice',
          url: 'https://www.thedogsharecollective.com/blog'
        }),
        this.props.user.isAuthenticated ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_DashboardHeader__["a" /* default */], Object.assign({
          logoutHandler: this.logoutHandler,
          redirectHandler: this.redirectHandler
        }, this.props)) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_UnauthenticatedHeader__["a" /* default */], { openLoginHandler: this.openLoginHandler }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.heading_section) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15__components_ContentContainer__["a" /* default */],
            { styles: styles.body_container },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'h1',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.heading) },
              'Dog e-Blog'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15__components_ContentContainer__["a" /* default */],
          { styles: styles.container },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cards) },
            this.state.posts && this.state.posts.length ? this.state.posts.map(function (post) {
              return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_BlogCard__["a" /* default */], {
                slug: post.slug,
                image: post.thumbnail_url,
                title: post.title,
                date: post.date,
                summary: post.summary
              });
            }) : false,
            this.state.loaded && this.state.posts && this.state.posts.length === 0 ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'h3',
              null,
              'Our blog is empty at the moment.'
            ) : false
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Footer__["a" /* default */], { user: this.props.user })
      );
    }
  }]);

  return Blog;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Blog.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  more: {
    position: 'relative',
    height: 120,
    marginTop: 50
  },
  cards: {
    // display: 'grid',
    // gridTemplateColumns: 'repeat(4, 262px)',
    // gridGap: 30,
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  body_container: {
    padding: '50px 0'
  },
  main: {
    paddingLeft: 43
  },
  container: {
    padding: '60px 0 0'
  },
  heading_section: {
    paddingTop: 80,
    backgroundColor: '#f9f9f9'
  },
  heading: {
    marginBottom: 0,
    lineHeight: 2.09,
    textAlign: 'center',
    fontSize: 45,
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_weight_heading
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_8__utils__["b" /* mapDispatchToProps */])(Blog));

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_applicationData__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Body__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_DashboardHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_UnauthenticatedHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_YouTubeEmbed__ = __webpack_require__(216);
var _container;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var BlogPost = function (_Component) {
  _inherits(BlogPost, _Component);

  function BlogPost(props) {
    _classCallCheck(this, BlogPost);

    var _this = _possibleConstructorReturn(this, (BlogPost.__proto__ || Object.getPrototypeOf(BlogPost)).call(this, props));

    _this.state = {};

    _this.openLoginHandler = _this.loginModalOpenHandler.bind(_this);
    _this.logoutHandler = _this.performLogout.bind(_this);
    _this.redirectHandler = _this.performRedirect.bind(_this);
    return _this;
  }

  _createClass(BlogPost, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var slug = this.props.match.params.slug;
      this.fetchBlogPost(slug);
    }
  }, {
    key: 'getContent',
    value: function getContent() {
      return {
        '__html': this.state.post.content // eslint-disable-line
      };
    }
  }, {
    key: 'performLogout',
    value: function performLogout() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_user__["b" /* logout */])());
      this.props.history.push('/');
    }
  }, {
    key: 'performRedirect',
    value: function performRedirect(to) {
      this.props.history.push(to);
    }
  }, {
    key: 'loginModalOpenHandler',
    value: function loginModalOpenHandler() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
        login_modal_open: true
      }));
    }
  }, {
    key: 'fetchBlogPost',
    value: function fetchBlogPost(slug) {
      var _this2 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationData__["c" /* getBlogPost */])(slug)).then(function (response) {
          _this2.setState({
            post: response,
            loaded: true
          });

          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        }, function (err) {
          console.log(err); // eslint-disable-line no-console
          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
          _this2.props.history.push('/404');
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var dynamicStyles = __WEBPACK_IMPORTED_MODULE_3_aphrodite__["StyleSheet"].create({
        banner: {
          backgroundImage: this.state.post ? 'url(\'' + this.state.post.hero_url + '\')' : 'none'
        }
      });

      /* eslint-disable react/no-danger */
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__components_Body__["a" /* default */],
        { hasFooter: true },
        this.props.user.isAuthenticated ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_DashboardHeader__["a" /* default */], Object.assign({
          logoutHandler: this.logoutHandler,
          redirectHandler: this.redirectHandler
        }, this.props)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_UnauthenticatedHeader__["a" /* default */], { openLoginHandler: this.openLoginHandler }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.page_container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.banner, dynamicStyles.banner) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.banner_container) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h1',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.banner_title) },
                this.state.post ? this.state.post.title : false
              )
            )
          ),
          this.state.post ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.content) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
              className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.container),
              dangerouslySetInnerHTML: this.getContent() }),
            this.state.post && this.state.post.video ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_YouTubeEmbed__["a" /* default */], { vid: this.state.post.video.id }) : false
          ) : false
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Footer__["a" /* default */], { user: this.props.user })
      );
      /* eslint-enable react/no-danger */
    }
  }]);

  return BlogPost;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

BlogPost.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  match: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_3_aphrodite__["StyleSheet"].create({
  page_container: {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white
  },
  container: (_container = {
    padding: '80px 15px 20px',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white

  }, _defineProperty(_container, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    paddingBottom: 15
  }), _defineProperty(_container, ':not(.a) p', _defineProperty({
    marginBottom: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 16,
    lineHeight: 1.72,
    textAlign: 'left',
    color: '#000e1f'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0 20px',
    fontSize: 15
  })), _defineProperty(_container, ':not(.a) div', _defineProperty({
    marginBottom: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 16,
    lineHeight: 1.72,
    textAlign: 'left',
    color: '#000e1f'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0 20px',
    fontSize: 15
  })), _defineProperty(_container, ':not(.a) h1', {
    margin: '25px 0px',
    fontSize: 28,
    fontWeight: 'bold'
  }), _defineProperty(_container, ':not(.a) h2', {
    margin: '25px 0px',
    fontSize: 25,
    fontWeight: 'bold'
  }), _defineProperty(_container, ':not(.a) h3', {
    margin: '25px 0px',
    fontSize: 22,
    fontWeight: 'bold'
  }), _defineProperty(_container, ':not(.a) strong', {
    fontWeight: 'bold'
  }), _defineProperty(_container, ':not(.a) .photocredit', {
    fontWeight: 'bold',
    marginTop: -20,
    fontSize: 14
  }), _defineProperty(_container, ':not(.a) .photocaption', {
    padding: 0
  }), _defineProperty(_container, ':not(.a) small', {
    margin: '25px 0px',
    fontSize: 14,
    fontWeight: 'bold'
  }), _defineProperty(_container, ':not(.a) em', {
    margin: '25px 0px',
    fontStyle: 'italic'
  }), _defineProperty(_container, ':not(.a) img', {
    margin: '25px 0px'
  }), _container),
  content: {
    paddingBottom: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].footer.height / 2,
    maxWidth: 750,
    margin: '0 auto 20px'
  },
  title: {
    marginBottom: 24,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_heading,
    fontSize: 30,
    lineHeight: 1.17,
    color: '#262626',
    textAlign: 'left'
  },
  banner_container: {
    width: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].container_width,
    margin: '0 auto'
  },
  banner: _defineProperty({
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 400,
    marginTop: 80,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    boxShadow: '0 0 0 1000px rgba(0,0,0,.3) inset'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    height: 'auto',
    padding: '80px 20px',
    backgroundPosition: 'left center'
  }),
  banner_title: _defineProperty({
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 64,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_heading,
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    textAlign: 'center'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 45
  })
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_4__utils__["b" /* mapDispatchToProps */])(BlogPost));

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Body__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DashboardHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SEO__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_TextField__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_UnauthenticatedHeader__ = __webpack_require__(17);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable */

















var styles = void 0;
var BACKGROUND_ASSET = __webpack_require__(603);

var Contact = function (_Component) {
  _inherits(Contact, _Component);

  function Contact(props) {
    _classCallCheck(this, Contact);

    var _this = _possibleConstructorReturn(this, (Contact.__proto__ || Object.getPrototypeOf(Contact)).call(this, props));

    _this.state = {
      messageSent: false,
      errorMessage: false
    };

    _this.openLoginHandler = _this.loginModalOpenHandler.bind(_this);
    _this.logoutHandler = _this.performLogout.bind(_this);
    _this.redirectHandler = _this.performRedirect.bind(_this);
    _this.sendMessage = _this.sendMessageHandler.bind(_this);
    _this.setValue = _this.updateTextField.bind(_this);
    return _this;
  }

  _createClass(Contact, [{
    key: 'updateTextField',
    value: function updateTextField(key, value) {
      this.setState(_defineProperty({}, key, value));
    }
  }, {
    key: 'performLogout',
    value: function performLogout() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_user__["b" /* logout */])());
      this.props.history.push('/');
    }
  }, {
    key: 'performRedirect',
    value: function performRedirect(to) {
      this.props.history.push(to);
    }
  }, {
    key: 'loginModalOpenHandler',
    value: function loginModalOpenHandler() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
        login_modal_open: true
      }));
    }
  }, {
    key: 'sendMessageHandler',
    value: function sendMessageHandler(e) {
      var _this2 = this;

      e.preventDefault();

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
        loading: true,
        loading_text: 'Sending...'
      })).then(function () {
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_user__["o" /* sendContactRequest */])({
          name: _this2.state.name,
          email: _this2.state.email,
          subject: _this2.state.subject,
          message: _this2.state.message
        })).then(function (response) {
          console.log('response', response);

          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));

          if (response.status === 200) {
            _this2.setState({
              messageSent: true
            });
          } else {
            _this2.setState({
              messageSent: false,
              errorMessage: response.data.error
            });
          }
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__components_Body__["a" /* default */],
        { hasFooter: true },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_SEO__["a" /* default */], {
          title: 'Contact Us',
          description: 'Get in touch with The Dog Share Collective team. We\'re here to help with any questions about dog sharing, memberships, or platform support.',
          keywords: 'contact us, dog share support, customer service, help center',
          url: 'https://www.thedogsharecollective.com/contact'
        }),
        this.props.user.isAuthenticated ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_DashboardHeader__["a" /* default */], Object.assign({
          logoutHandler: this.logoutHandler,
          redirectHandler: this.redirectHandler
        }, this.props)) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_UnauthenticatedHeader__["a" /* default */], { openLoginHandler: this.openLoginHandler }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container) },
          this.state.messageSent ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.contact_box) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'h1',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.title) },
              'Thanks!'
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.content) },
              "Your message has been sent, we'll be in touch soon!"
            )
          ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.contact_box) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'h1',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.title) },
              'Send us a message'
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.content) },
              'Give us something to work with - throw us a bone!',
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
              'Our Member Support Team will be happy to assist you.'
            ),
            this.state.errorMessage ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.error_box) },
              this.state.errorMessage
            ) : null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'form',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.form) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_TextField__["a" /* default */], {
                id: 'name',
                name: 'name',
                label: 'Name',
                value: this.state.name,
                handler: this.setValue
              }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_TextField__["a" /* default */], {
                id: 'email',
                name: 'email',
                email: true,
                label: 'Email',
                value: this.state.email,
                handler: this.setValue
              }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_TextField__["a" /* default */], {
                id: 'subject',
                name: 'subject',
                label: 'Subject',
                placeholder: 'What is this enquiry about?',
                fullWidth: true,
                value: this.state.subject,
                handler: this.setValue
              }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_TextField__["a" /* default */], {
                id: 'message',
                name: 'message',
                label: 'Message',
                placeholder: 'What did you want to say?',
                textArea: true,
                fullWidth: true,
                value: this.state.message,
                handler: this.setValue
              }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.submit_container) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'button',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.submit), onClick: this.sendMessage },
                  'Send enquiry'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Footer__["a" /* default */], this.props)
      );
    }
  }]);

  return Contact;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Contact.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    display: 'flex',
    alignItems: 'center',
    minHeight: 'calc(100vh - 240px)',
    paddingTop: 127,
    paddingBottom: 91,
    backgroundImage: 'url(\'' + BACKGROUND_ASSET + '\')',
    backgroundSize: 'cover',
    backgroundPosition: 'center'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    marginTop: 80,
    paddingTop: 209,
    paddingBottom: 0,
    backgroundPosition: 'top center',
    backgroundSize: 'auto 209px',
    backgroundImage: 'url(/images/contact_bg_mob.jpg)'
  }),
  error_box: {
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].red,
    paddingBottom: 40
  },
  contact_box: _defineProperty({
    width: 760,
    margin: '0 auto',
    padding: 60,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    padding: '60px 20px'
  }),
  title: {
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_heading,
    fontSize: 30,
    lineHeight: 1.17,
    color: '#262626',
    textAlign: 'center'
  },
  content: _defineProperty({
    width: 631,
    margin: '0 auto 50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 20,
    fontWeight: 500,
    lineHeight: 1.4,
    textAlign: 'center',
    color: '#000e1f'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -5px'
  },
  submit_container: {
    width: '100%',
    padding: '0 5px',
    textAlign: 'right'
  },
  submit: _defineProperty({
    width: 206,
    height: 50,
    textTransform: 'uppercase',
    fontSize: 15,
    fontWeight: 900,
    lineHeight: 1.73,
    letterSpacing: 2,
    textAlign: 'center',
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    borderRadius: 5,
    border: 0,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary,
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 300ms',

    ':hover': {
      backgroundColor: '#61c3df'
    }

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  })
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* mapDispatchToProps */])(Contact));

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_messaging__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Body__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DashboardHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SubscriptionExpiryMessage__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Toast__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config_routes__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var styles = void 0;

var DashboardContainer = function (_Component) {
  _inherits(DashboardContainer, _Component);

  function DashboardContainer(props) {
    _classCallCheck(this, DashboardContainer);

    var _this = _possibleConstructorReturn(this, (DashboardContainer.__proto__ || Object.getPrototypeOf(DashboardContainer)).call(this, props));

    _this.state = {
      loggedIn: false
    };
    _this.logoutHandler = _this.performLogout.bind(_this);
    _this.redirectHandler = _this.performRedirect.bind(_this);
    _this.renderSubscriptionExpiryMessage = _this.renderSubscriptionExpiryMessage.bind(_this);

    _this.notificationTimer = null;
    return _this;
  }

  _createClass(DashboardContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      if (!this.props.user.isAuthenticated && !this.props.allowUnauthenticated) {
        this.setState({
          loggedIn: true
        });
        this.props.history.push('/');
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
          login_modal_open: true
        }));
      } else if (this.props.user.isAuthenticated) {
        // User is logged in
        // Fetch initial unread count
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_messaging__["c" /* getUnreadMessageCount */])(this.props.user.access_token));

        this.notificationTimer = setInterval(function () {
          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_user__["m" /* fetchCurrentMember */])(_this2.props.user.id, _this2.props.user.access_token));
          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_messaging__["c" /* getUnreadMessageCount */])(_this2.props.user.access_token));
        }, 30000);
      } else {
        // User is not logged in, but authentication is not required in this route
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.notificationTimer);
    }
  }, {
    key: 'performLogout',
    value: function performLogout() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_user__["b" /* logout */])());
      this.props.history.push('/');
    }
  }, {
    key: 'performRedirect',
    value: function performRedirect(to) {
      this.props.history.push(to);
    }

    /**
     * Display a message if the user has no active subscription.
     * @return {*}
     */

  }, {
    key: 'renderSubscriptionExpiryMessage',
    value: function renderSubscriptionExpiryMessage() {
      var _props = this.props,
          URL_PATH = _props.match.path,
          ACTIVE_SUBSCRIPTION = _props.user.active_subscription;

      /**
       * If the user has an active subscription,
       * or they're on the membership page don't
       * display the message.
       */

      if (ACTIVE_SUBSCRIPTION || URL_PATH === __WEBPACK_IMPORTED_MODULE_14__config_routes__["a" /* ROUTES */].SETTINGS.MEMBERSHIP) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13__components_Toast__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SubscriptionExpiryMessage__["a" /* default */], null)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__components_Body__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_DashboardHeader__["a" /* default */], Object.assign({
          logoutHandler: this.logoutHandler,
          redirectHandler: this.redirectHandler
        }, this.props)),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          {
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(this.props.hideFooter ? styles.containerWithoutFooter : styles.container)
          },
          this.props.children
        ),
        !this.props.hideFooter && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer__["a" /* default */], { user: this.props.user }),
        this.renderSubscriptionExpiryMessage()
      );
    }
  }]);

  return DashboardContainer;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    paddingTop: 50,
    paddingBottom: 150
  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    paddingBottom: 0
  }),
  containerWithoutFooter: _defineProperty({
    paddingTop: 50,
    paddingBottom: 0
  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    paddingBottom: 0
  })
});

DashboardContainer.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].any).isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  match: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].shape.isRequired,
  allowUnauthenticated: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool,
  hideFooter: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].bool
};

DashboardContainer.defaultProps = {
  allowUnauthenticated: false,
  hideFooter: false
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["g" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* mapDispatchToProps */])(DashboardContainer)));

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_slick__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_slick_carousel_slick_slick_theme_css__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_slick_carousel_slick_slick_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_slick_carousel_slick_slick_css__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_toastify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_messaging__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_pooch__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ActivityBadge__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_CancelRequestModal__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_HorizontalRule__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_MatchRequestModal__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_NotificationBar__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_ShareProfile__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_ViewProfileCard__ = __webpack_require__(103);
var _bullet_item;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// import {
//   EmailShareButton,
//   FacebookShareButton,
//   TwitterShareButton,
//   EmailIcon,
//   FacebookIcon,
//   TwitterIcon,
// } from 'react-share';





















var CHECK_ICON = __webpack_require__(337);
var LOCATION_ICON = __webpack_require__(341);
var PAW_ICON = __webpack_require__(342);
var HEART_ICON = __webpack_require__(340);
var ENVELOPE_ICON = __webpack_require__(339);
var CROSS_ICON = __webpack_require__(338);
var PREVIEW_ICON = __webpack_require__(343);

var DogProfile = function (_Component) {
  _inherits(DogProfile, _Component);

  function DogProfile(props) {
    _classCallCheck(this, DogProfile);

    var _this = _possibleConstructorReturn(this, (DogProfile.__proto__ || Object.getPrototypeOf(DogProfile)).call(this, props));

    _this.setActiveImage = _this.setActiveImage.bind(_this);
    _this.requestMatch = _this.requestMatchHandler.bind(_this);
    _this.requestFavourite = _this.requestFavouriteHandler.bind(_this);
    _this.setSlide = _this.setSlide.bind(_this);
    _this.toggleMatchRequestModal = _this.toggleMatchRequestModal.bind(_this);
    _this.handleMatchRequestSubmit = _this.handleMatchRequestSubmit.bind(_this);
    _this.openCancelRequestModal = _this.openCancelRequestModal.bind(_this);
    _this.closeCancelRequestModal = _this.closeCancelRequestModal.bind(_this);
    _this.handleCancelRequestSubmit = _this.handleCancelRequestSubmit.bind(_this);
    _this.handleMessageOwner = _this.handleMessageOwner.bind(_this);

    _this.state = {
      active_image: null,
      share_requested: false,
      match_request_modal_open: false,
      cancelRequestModalOpen: false,
      cancelRequestMatch: null,
      message_loading: false
    };
    return _this;
  }

  _createClass(DogProfile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchDog();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.match.params.id !== this.props.match.params.id) {
        this.fetchDog();
      }
    }
  }, {
    key: 'getLivingSituationMessage',
    value: function getLivingSituationMessage() {
      var dog = this.state.dog;

      if (dog && dog.living_situation && dog.living_situation.length) {
        return 'Living Situation: ' + dog.living_situation;
      }

      return false;
    }
  }, {
    key: 'getAvailabilityMessage',
    value: function getAvailabilityMessage() {
      var dog = this.state.dog;

      if (dog && dog.availability && dog.availability.length) {
        return 'Availability: ' + dog.availability;
      }

      return false;
    }
  }, {
    key: 'getRegularityMessage',
    value: function getRegularityMessage() {
      var dog = this.state.dog;

      if (dog && dog.regularity && dog.regularity.length) {
        return 'Regularity: ' + dog.regularity;
      }

      return false;
    }
  }, {
    key: 'getFixedMessage',
    value: function getFixedMessage() {
      var dog = this.state.dog;

      if (dog && dog.fixed) {
        if (dog.fixed === true) {
          return 'Neutered';
        }

        if (dog.fixed === false) {
          return false;
        }

        return dog.fixed;
      }

      return false;
    }
  }, {
    key: 'getDogImage',
    value: function getDogImage() {
      var dog = this.state.dog;

      if (dog.image_url && dog.image_url.length > 10) {
        return dog.image_url;
      }

      if (dog.profile_photo && dog.profile_photo.length > 10) {
        return dog.profile_photo;
      }

      return '/images/default_dog.jpg';
    }
  }, {
    key: 'getMatches',
    value: function getMatches() {
      var dog = this.state.dog;
      var matches = this.props.user.matches;

      return dog && matches && matches.length ? this.props.user.matches.filter(function (match) {
        return match.dog && match.dog.id === dog.id;
      }) : false;
    }
  }, {
    key: 'getFavourites',
    value: function getFavourites() {
      var dog = this.state.dog;
      var favourites = this.props.user.favourites;

      return dog && favourites && favourites.length ? this.props.user.favourites.filter(function (favourite) {
        return favourite && favourite.id === dog.id;
      }) : false;
    }
  }, {
    key: 'getUserIsPublished',
    value: function getUserIsPublished() {
      return this.props.user.published;
    }
  }, {
    key: 'getUserOwnsDog',
    value: function getUserOwnsDog() {
      var dog = this.state.dog;
      var userID = parseInt(this.props.user.id, 10);

      return dog && dog.owner_id && parseInt(dog.owner_id, 10) === userID;
    }
  }, {
    key: 'getCurrentMatches',
    value: function getCurrentMatches() {
      var matches = this.getMatches();

      var currentMatches = this.state.dog && matches && matches.length ? matches.filter(function (match) {
        return match.status === 'Accepted';
      }) : false;

      return currentMatches && currentMatches.length ? currentMatches : false;
    }
  }, {
    key: 'getCurrentFavourites',
    value: function getCurrentFavourites() {
      var _this2 = this;

      var favourites = this.getFavourites();

      var currentFavourites = this.state.dog && favourites && favourites.length ? favourites.filter(function (favourite) {
        return favourite.id === _this2.state.dog.id;
      }) : false;

      return currentFavourites && currentFavourites.length ? currentFavourites : false;
    }
  }, {
    key: 'getPendingShareRequests',
    value: function getPendingShareRequests() {
      var matches = this.getMatches();

      var pendingRequests = this.state.dog && matches ? matches.filter(function (match) {
        return match.status === 'Pending';
      }) : false;

      return pendingRequests && pendingRequests.length ? pendingRequests : false;
    }
  }, {
    key: 'setDog',
    value: function setDog(dog) {
      var _this3 = this;

      this.setState({
        dog: dog,
        active_image: dog.photos[0] ? dog.photos[0].id : null
      }, function () {
        setTimeout(function () {
          _this3.slider.innerSlider.onWindowResized();
        }, 0);
      });
    }
  }, {
    key: 'setSlide',
    value: function setSlide(slide, url) {
      var _this4 = this;

      this.setState({
        active_image: url
      }, function () {
        _this4.slider.slickGoTo(slide);
      });
    }
  }, {
    key: 'setActiveImage',
    value: function setActiveImage(photo) {
      this.setState({
        active_image: photo
      });
    }
  }, {
    key: 'openCancelRequestModal',
    value: function openCancelRequestModal(matchRequest) {
      this.setState({
        cancelRequestModalOpen: true,
        cancelRequestMatch: matchRequest
      });
    }
  }, {
    key: 'closeCancelRequestModal',
    value: function closeCancelRequestModal() {
      this.setState({
        cancelRequestModalOpen: false,
        cancelRequestMatch: null
      });
    }
  }, {
    key: 'handleCancelRequestSubmit',
    value: function handleCancelRequestSubmit(message) {
      var _this5 = this;

      var cancelRequestMatch = this.state.cancelRequestMatch;


      if (!cancelRequestMatch) {
        this.closeCancelRequestModal();
        return;
      }

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        _this5.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions_pooch__["c" /* cancelMatch */])(cancelRequestMatch.id, _this5.props.user.access_token, typeof message === 'string' ? message.trim() : '')).then(function () {
          _this5.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions_user__["i" /* getCurrentMember */])(_this5.props.user.id, _this5.props.user.access_token)).then(function (response) {
            _this5.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions_user__["c" /* updateUser */])(response));

            _this5.fetchDog();
          });
        }, function (err) {
          console.log(err); // eslint-disable-line
          _this5.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        });
      });
    }
  }, {
    key: 'handleMessageOwner',
    value: function handleMessageOwner(match) {
      var _this6 = this;

      if (!match || !this.props.user || !this.props.user.access_token) {
        return;
      }

      this.setState({
        message_loading: match.id
      });

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__actions_messaging__["a" /* ensureConversationForMatch */])(match.id, this.props.user.access_token)).then(function (conversation) {
        _this6.setState({
          message_loading: false
        });
        _this6.props.history.push('/inbox/' + conversation.id);
      }).catch(function (error) {
        var errorMessage = error && error.data && error.data.error || error.message || 'Unable to open conversation';
        __WEBPACK_IMPORTED_MODULE_10_react_toastify__["b" /* toast */].error(errorMessage);
        _this6.setState({
          message_loading: false
        });
      });
    }
  }, {
    key: 'fetchDog',
    value: function fetchDog() {
      var _this7 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        if (!_this7.props.user.access_token) {
          return;
        }

        _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions_pooch__["d" /* getDog */])(_this7.props.match.params.id, _this7.props.user.access_token)).then(function (response) {
          _this7.setDog(response);
          _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
          _this7.slider.slickGoTo(0, true);
        }, function (err) {
          console.log(err); // eslint-disable-line
          _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
          _this7.props.history.push('/404');
        });
      });
    }
  }, {
    key: 'requestMatchHandler',
    value: function requestMatchHandler() {
      this.setState({
        match_request_modal_open: true
      });
    }
  }, {
    key: 'requestFavouriteHandler',
    value: function requestFavouriteHandler() {
      var _this8 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        _this8.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions_pooch__["e" /* toggleFavourite */])(_this8.props.match.params.id, _this8.props.user.access_token)).then(function () {
          _this8.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions_user__["i" /* getCurrentMember */])(_this8.props.user.id, _this8.props.user.access_token)).then(function (response) {
            _this8.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions_user__["c" /* updateUser */])(response));

            _this8.fetchDog();
          });
        }, function (err) {
          console.log(err); // eslint-disable-line
          _this8.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        });
      });
    }
  }, {
    key: 'endRequest',
    value: function endRequest(matchRequest) {
      var _this9 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        _this9.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions_pooch__["f" /* endMatch */])(matchRequest.id, _this9.props.user.access_token)).then(function () {
          _this9.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions_user__["i" /* getCurrentMember */])(_this9.props.user.id, _this9.props.user.access_token)).then(function (response) {
            _this9.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions_user__["c" /* updateUser */])(response));

            _this9.fetchDog();
          });
        }, function (err) {
          console.log(err); // eslint-disable-line
          _this9.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        });
      });
    }
  }, {
    key: 'endFavourite',
    value: function endFavourite(favourite) {
      var _this10 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        _this10.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions_pooch__["e" /* toggleFavourite */])(favourite.id, _this10.props.user.access_token)).then(function () {
          _this10.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions_user__["i" /* getCurrentMember */])(_this10.props.user.id, _this10.props.user.access_token)).then(function (response) {
            _this10.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions_user__["c" /* updateUser */])(response));

            _this10.fetchDog();
          });
        }, function (err) {
          console.log(err); // eslint-disable-line
          _this10.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        });
      });
    }
  }, {
    key: 'toggleMatchRequestModal',
    value: function toggleMatchRequestModal() {
      this.setState({
        match_request_modal_open: !this.state.match_request_modal_open
      });
    }
  }, {
    key: 'handleMatchRequestSubmit',
    value: function handleMatchRequestSubmit(message) {
      var _this11 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        _this11.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions_pooch__["g" /* requestMatch */])(_this11.props.match.params.id, message, _this11.props.user.access_token)).then(function () {
          _this11.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions_user__["i" /* getCurrentMember */])(_this11.props.user.id, _this11.props.user.access_token)).then(function (response) {
            _this11.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions_user__["c" /* updateUser */])(response));

            _this11.fetchDog();
          });
        }, function (err) {
          console.log(err); // eslint-disable-line
          _this11.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        });
      });
    }
  }, {
    key: 'dateOfBirthString',
    value: function dateOfBirthString() {
      var dobYears = __WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.state.dog.date_of_birth).format('YYYY-MM-DD'), 'years');
      if (dobYears !== 0) {
        if (dobYears === 1) {
          return dobYears + ' year';
        }

        return dobYears + ' years';
      }

      var dobMonths = __WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.state.dog.date_of_birth).format('YYYY-MM-DD'), 'months');
      return dobMonths + ' months';
    }
  }, {
    key: 'renderCurrentlySharing',
    value: function renderCurrentlySharing() {
      var userOwnsDog = this.getUserOwnsDog();
      var currentMatches = this.getCurrentMatches();
      var requestPending = this.getPendingShareRequests();

      return !userOwnsDog && currentMatches && !requestPending ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'button',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.action, styles.sharing) },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, {
          cacheGetRequests: true,
          src: PAW_ICON,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.paw_icon, styles.paw_icon_blue, styles.no_action)
        }),
        "You're",
        ' dog sharing'
      ) : false;
    }
  }, {
    key: 'renderRequestShare',
    value: function renderRequestShare() {
      var userOwnsDog = this.getUserOwnsDog();
      var currentMatches = this.getCurrentMatches();
      var requestPending = this.getPendingShareRequests();

      return this.getUserIsPublished() && !userOwnsDog && !currentMatches && !requestPending ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'button',
        { onClick: this.requestMatch, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.action, styles.share_request) },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, { cacheGetRequests: true, src: PAW_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.paw_icon) }),
        'Request to share'
      ) : false;
    }
  }, {
    key: 'renderFavourite',
    value: function renderFavourite() {
      var userOwnsDog = this.getUserOwnsDog();
      var currentFavourites = this.getCurrentFavourites();

      return this.getUserIsPublished() && !userOwnsDog && !currentFavourites ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'button',
        {
          onClick: this.requestFavourite,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.action, styles.favourite_request)
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, { cacheGetRequests: true, src: HEART_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.heart_icon) }),
        'Add to favourites'
      ) : false;
    }
  }, {
    key: 'renderDiscontinueFavourite',
    value: function renderDiscontinueFavourite() {
      var currentFavourites = this.getCurrentFavourites();
      var userOwnsDog = this.getUserOwnsDog();

      return !userOwnsDog && currentFavourites ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'button',
        {
          onClick: this.endFavourite.bind(this, currentFavourites[0]),
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.action, styles.discontinue_favourite)
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, { cacheGetRequests: true, src: HEART_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.heart_icon_red) }),
        'Remove Favourite'
      ) : false;
    }
  }, {
    key: 'renderMessageAction',
    value: function renderMessageAction() {
      var _this12 = this;

      var userOwnsDog = this.getUserOwnsDog();
      var currentMatches = this.getCurrentMatches();

      if (userOwnsDog || !currentMatches || !currentMatches.length) {
        return false;
      }

      var primaryMatch = currentMatches[0];
      var isLoading = this.state.message_loading === primaryMatch.id;

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'button',
        {
          onClick: function onClick() {
            return _this12.handleMessageOwner(primaryMatch);
          },
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.action, styles.message_owner),
          disabled: isLoading
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, { cacheGetRequests: true, src: ENVELOPE_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.envelope_icon) }),
        isLoading ? 'Opening messages...' : 'Message owner'
      );
    }
  }, {
    key: 'renderOwnerProfileButton',
    value: function renderOwnerProfileButton() {
      var _this13 = this;

      var userOwnsDog = this.getUserOwnsDog();
      var currentMatches = this.getCurrentMatches();
      var ownerProfileLink = '/profile/' + this.state.dog.owner_id;

      return !userOwnsDog && currentMatches ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'button',
        {
          onClick: function onClick() {
            return _this13.props.history.push(ownerProfileLink);
          },
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.action, styles.share_request)
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, { cacheGetRequests: true, src: PREVIEW_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.preview_icon) }),
        'View Owners Profile'
      ) : false;
    }
  }, {
    key: 'renderMatchRequestPending',
    value: function renderMatchRequestPending() {
      var userOwnsDog = this.getUserOwnsDog();
      var requestsPending = this.getPendingShareRequests();

      return !userOwnsDog && requestsPending ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'button',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.action, styles.sharing, styles.no_action) },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, {
          cacheGetRequests: true,
          src: PAW_ICON,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.paw_icon, styles.paw_icon_blue)
        }),
        'Match request pending'
      ) : false;
    }
  }, {
    key: 'renderDiscontinueSharing',
    value: function renderDiscontinueSharing() {
      var currentMatches = this.getCurrentMatches();
      var userOwnsDog = this.getUserOwnsDog();

      return !userOwnsDog && currentMatches ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'button',
        {
          onClick: this.endRequest.bind(this, currentMatches[0]),
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.action, styles.discontinue_sharing)
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, { cacheGetRequests: true, src: CROSS_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cross_icon) }),
        'Discontinue Sharing'
      ) : false;
    }
  }, {
    key: 'renderCancelRequest',
    value: function renderCancelRequest() {
      var userOwnsDog = this.getUserOwnsDog();
      var requestsPending = this.getPendingShareRequests();

      return !userOwnsDog && requestsPending ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'button',
        {
          onClick: this.openCancelRequestModal.bind(this, requestsPending[0]),
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.action, styles.discontinue_sharing)
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, { cacheGetRequests: true, src: CROSS_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cross_icon) }),
        'Cancel request'
      ) : false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this14 = this;

      var sliderSettings = void 0;
      var cancelMatchRequest = this.state.cancelRequestMatch;
      var cancelModalDogName = void 0;
      var cancelModalRecipientName = void 0;

      if (cancelMatchRequest && cancelMatchRequest.dog) {
        cancelModalDogName = cancelMatchRequest.dog.name;
        cancelModalRecipientName = cancelMatchRequest.dog.owner_name;
      } else if (this.state.dog) {
        cancelModalDogName = this.state.dog.name;
        cancelModalRecipientName = this.state.dog.owner_name;
      }

      if (this.state.dog) {
        sliderSettings = {
          dots: false,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          afterChange: function afterChange(index) {
            if (_this14.state.dog.photos.length >= 1) {
              _this14.setSlide(index, _this14.state.dog.photos[index].id);
            }
          }
        };
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.body) },
        this.getUserOwnsDog() ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22__components_NotificationBar__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, { cacheGetRequests: true, src: PREVIEW_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.preview_icon) }),
          'This is how borrowers will view this profile.',
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_router_dom__["e" /* Link */],
            { to: '/pooch/' + this.state.dog.id + '/edit', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.notification_link) },
            'Edit profile'
          )
        ) : false,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.primary_container) },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_19__components_ContentContainer__["a" /* default */],
            { styles: styles.container },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.profile) },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.gallery) },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.gallery_main) },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_slick___default.a,
                    Object.assign({}, sliderSettings, {
                      ref: function ref(slider) {
                        _this14.slider = slider;
                      }
                    }),
                    this.state.dog && this.state.dog.photos && this.state.dog.photos.length === 0 ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img', {
                      className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.gallery_photo),
                      src: '/images/default_dog.jpg',
                      alt: this.state.dog && this.state.dog.name ? this.state.dog.name : null
                    }) : false,
                    this.state.dog && this.state.dog.photos && this.state.dog.photos.length >= 1 ? this.state.dog.photos.map(function (photo) {
                      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img', {
                        className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.gallery_photo),
                        src: photo.src,
                        alt: _this14.state.dog && _this14.state.dog.name ? _this14.state.dog.name : null
                      });
                    }) : false
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.gallery_indicators) },
                  this.state.dog && this.state.dog.photos && this.state.dog.photos.length > 1 ? this.state.dog.photos.map(function (photo, index) {
                    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', {
                      className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.gallery_indicator, _this14.state.active_image === photo.id ? styles.gallery_indicator_active : null),
                      'data-photo': photo.src,
                      onClick: function onClick() {
                        return _this14.setSlide(index, photo.id);
                      },
                      role: 'button',
                      tabIndex: 0
                    });
                  }) : false
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.details) },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'h1',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.name) },
                  this.state.dog ? this.state.dog.name : false
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.breed) },
                  this.state.dog ? this.state.dog.breed : false
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.age) },
                  this.state.dog && this.state.dog.sex && this.state.dog.sex.length > 0 ? '' + this.state.dog.sex + (this.state.dog.date_of_birth ? ', ' : false) : false,
                  this.state.dog && this.state.dog.date_of_birth ? this.dateOfBirthString() + ' old' : false,
                  this.getFixedMessage() && this.getFixedMessage().length > 0 ? ', ' + this.getFixedMessage() : false
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.location) },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, {
                    cacheGetRequests: true,
                    src: LOCATION_ICON,
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.location_icon)
                  }),
                  this.state.dog && this.state.dog.suburb ? this.state.dog.suburb.title + ', ' + this.state.dog.suburb.district.title : 'Location not shared'
                ),
                this.state.dog && this.state.dog.plays_with_other_dogs ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.socialised) },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, { cacheGetRequests: true, src: CHECK_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.check_icon) }),
                  'Keen to play with other dogs'
                ) : false,
                this.state.dog && this.state.dog.good_with_children ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.socialised) },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, { cacheGetRequests: true, src: CHECK_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.check_icon) }),
                  'Good with children'
                ) : false,
                this.state.dog && this.state.dog.hypoallergenic_coat ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.socialised) },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, { cacheGetRequests: true, src: CHECK_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.check_icon) }),
                  'Hypoallergenic coat'
                ) : false,
                this.getLivingSituationMessage() ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.socialised) },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, { cacheGetRequests: true, src: CHECK_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.check_icon) }),
                  this.getLivingSituationMessage()
                ) : false,
                this.getAvailabilityMessage() ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.socialised) },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, { cacheGetRequests: true, src: CHECK_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.check_icon) }),
                  this.getAvailabilityMessage()
                ) : false,
                this.getRegularityMessage() ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.socialised) },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, { cacheGetRequests: true, src: CHECK_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.check_icon) }),
                  this.getRegularityMessage()
                ) : false,
                this.getFixedMessage() && this.getFixedMessage() !== 'Entire' ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.socialised) },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, { cacheGetRequests: true, src: CHECK_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.check_icon) }),
                  this.getFixedMessage()
                ) : false
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.actionWrap) },
              this.state.dog ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.actions) },
                this.renderRequestShare(),
                this.renderCurrentlySharing(),
                this.renderOwnerProfileButton(),
                this.renderMatchRequestPending(),
                this.renderCancelRequest(),
                this.renderMessageAction(),
                this.renderDiscontinueSharing()
              ) : false,
              this.state.dog ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.favourites) },
                this.renderFavourite(),
                this.renderDiscontinueFavourite()
              ) : false
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.secondary_container) },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_19__components_ContentContainer__["a" /* default */],
            { styles: styles.container },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.sections) },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section) },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'h2',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_title) },
                  'About Me'
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_content) },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    'p',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_paragraph) },
                    this.state.dog ? this.state.dog.about : false
                  ),
                  this.state.dog ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_ShareProfile__["a" /* default */], {
                    facebook: this.state.dog.facebook_share_url,
                    email: this.state.dog.email_share_url
                  }) : null
                )
              ),
              this.state.dog && this.state.dog.dogsize && this.state.dog.dogsize.length > 0 ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_HorizontalRule__["a" /* default */], null) : false,
              this.state.dog && this.state.dog.dogsize && this.state.dog.dogsize.length > 0 ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section) },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'h2',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_title) },
                  'Size'
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_content) },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    'p',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_paragraph) },
                    this.state.dog ? this.state.dog.dogsize : false
                  )
                )
              ) : false,
              this.state.dog && this.state.dog.interests.length ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_HorizontalRule__["a" /* default */], null) : false,
              this.state.dog && this.state.dog.interests.length ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section) },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'h2',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_title) },
                  "I'm Interested in"
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_content) },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    'div',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.activities) },
                    this.state.dog.interests.map(function (interest) {
                      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_ActivityBadge__["a" /* default */], { activity: interest.title, label: true, styles: styles.activity });
                    })
                  )
                )
              ) : false,
              this.state.dog && this.state.dog.needs && this.state.dog.needs.length ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_HorizontalRule__["a" /* default */], null) : false,
              this.state.dog && this.state.dog.needs && this.state.dog.needs.length ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section) },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'h2',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_title) },
                  "I'm good with"
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_content) },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    'ul',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.bullet_list) },
                    this.state.dog.needs.map(function (need) {
                      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        'li',
                        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.bullet_item) },
                        need.title
                      );
                    })
                  )
                )
              ) : false,
              this.state.dog && this.state.dog.health_needs ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_HorizontalRule__["a" /* default */], null) : false,
              this.state.dog && this.state.dog.health_needs ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section) },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'h2',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_title) },
                  'Important Details'
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_content) },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    'p',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_paragraph) },
                    this.state.dog.health_needs
                  )
                )
              ) : false,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_HorizontalRule__["a" /* default */], null)
            ),
            this.state.dog && this.state.dog.related_dogs.length ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.side) },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_title) },
                'Dogs like ',
                this.state.dog ? this.state.dog.name : false
              ),
              this.state.dog && this.state.dog.related_dogs.length ? this.state.dog.related_dogs.map(function (dog) {
                return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_ViewProfileCard__["a" /* default */], {
                  id: dog.id,
                  image_url: dog.image_url,
                  name: dog.name,
                  breed: dog.breed
                });
              }) : false
            ) : false,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_CancelRequestModal__["a" /* default */], {
              isOpen: this.state.cancelRequestModalOpen,
              onClose: this.closeCancelRequestModal,
              onSubmit: this.handleCancelRequestSubmit,
              dogName: cancelModalDogName,
              recipientName: cancelModalRecipientName
            }),
            this.state.dog ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_MatchRequestModal__["a" /* default */], {
              isOpen: this.state.match_request_modal_open,
              onClose: this.toggleMatchRequestModal,
              onSubmit: this.handleMatchRequestSubmit,
              dogName: this.state.dog.name,
              ownerName: this.state.dog.owner_name
            }) : false
          )
        ),
        this.state.dog && this.state.dog.photos ? this.state.dog.photos.map(function (photo) {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img', {
            src: photo.src,
            alt: 'Preloaded',
            width: '1',
            height: '1',
            style: {
              display: 'none'
            }
          });
        }) : false
      );
    }
  }]);

  return DogProfile;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

DogProfile.propTypes = {
  dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].func.isRequired,
  match: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].object.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].object.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  share_icons: {
    position: 'relative',
    display: 'inline-block',
    width: '100%',
    textAlign: 'center',
    marginTop: '1rem'
  },
  share_icon: {
    position: 'relative',
    display: 'inline-block',
    marginRight: 10,
    marginLeft: 10
  },
  body: {
    position: 'relative',
    marginTop: 30
  },
  preview_icon: {
    marginRight: 10
  },
  notification_link: {
    marginLeft: 5,
    fontWeight: 'bold'
  },
  cross_icon: {
    position: 'relative',
    top: 1,
    marginRight: 10
  },
  envelope_icon: {
    position: 'relative',
    top: 3,
    marginRight: 10
  },
  paw_icon: {
    position: 'relative',
    top: 2,
    marginRight: 10,
    fill: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].white
  },
  paw_icon_blue: {
    fill: '#39b4d6'
  },
  heart_icon: {
    position: 'relative',
    top: 2,
    marginRight: 10,
    fill: '#56C5FF'
  },
  heart_icon_red: {
    position: 'relative',
    top: 2,
    marginRight: 10,
    fill: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].red
  },
  activities: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  activity: {
    marginBottom: 60,

    ':not(:last-child)': {
      marginRight: 35
    }
  },
  bullet_list: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    marginBottom: -14
  },
  bullet_item: (_bullet_item = {
    display: 'flex',
    alignItems: 'center',
    width: '50%',
    marginBottom: 14,
    fontSize: 15,
    lineHeight: 1.53,
    letterSpacing: 0.3,
    color: '#000e1f',
    fontFamily: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].font_weight_primary

  }, _defineProperty(_bullet_item, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }), _defineProperty(_bullet_item, ':before', {
    height: 5,
    width: 5,
    marginRight: 10,
    backgroundColor: '#39b4d6',
    borderRadius: '50%',
    content: '""'
  }), _bullet_item),
  sections: _defineProperty({
    width: 750

  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  side: _defineProperty({
    width: 360,
    flexShrink: 0

  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    paddingTop: 50
  }),
  section: _defineProperty({
    display: 'flex'

  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column'
  }),
  section_content: {
    flexGrow: 1
  },
  section_title: _defineProperty({
    flexShrink: 0,
    width: 195,
    fontFamily: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].font_family_secondary,
    letterSpacing: 1.8,
    color: '#a5a5a5',
    fontSize: 13,
    lineHeight: 1.53,
    textTransform: 'uppercase'

  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    marginBottom: 15
  }),
  section_paragraph: {
    fontSize: 15,
    lineHeight: 1.53,
    letterSpacing: 0.3,
    color: '#000e1f',
    fontFamily: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].font_weight_primary,

    ':not(:last-child)': {
      marginBottom: 15
    }
  },
  primary_container: {
    display: 'flex',
    padding: '84px 0 25px',
    backgroundColor: '#F8F8F8'
  },
  secondary_container: _defineProperty({
    padding: '54px 0 150px'

  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    paddingBottom: 0
  }),
  container: _defineProperty({
    display: 'flex',
    justifyContent: 'space-between'

  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column'
  }),
  profile: _defineProperty({
    display: 'flex'

  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center'
  }),
  details: _defineProperty({
    paddingLeft: 38,
    paddingTop: 40

  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    paddingLeft: 0
  }),
  name: _defineProperty({
    marginBottom: 18,
    fontSize: 45,
    fontFamily: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].font_weight_heading,
    color: '#000e1f'

  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 28
  }),
  breed: _defineProperty({
    marginBottom: 17,
    fontSize: 20,
    fontFamily: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 500,
    color: '#000e1f'

  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 18
  }),
  age: _defineProperty({
    marginBottom: 17,
    fontSize: 20,
    fontFamily: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 500,
    color: '#000e1f'

  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 18
  }),
  location: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 17,
    fontSize: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].font_weight_primary,
    color: '#000e1f'
  },
  location_icon: {
    display: 'block',
    marginRight: 9
  },
  socialised: {
    display: 'flex',
    alignItems: 'left',
    fontSize: 14,
    fontFamily: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 900,
    paddingTop: 10,
    paddingBottom: 10,
    color: '#000e1f'
  },
  check_icon: {
    display: 'block',
    marginRight: 10.8
  },
  gallery: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  gallery_main: _defineProperty({
    height: 360,
    width: 360,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].grey

  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    width: 290,
    height: 'auto'
  }),
  gallery_photo: _defineProperty({
    display: 'block',
    height: 360,
    width: 360,
    border: '4px solid #fff',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, .1)',
    objectFit: 'cover'

  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    width: 290,
    height: 'auto'
  }),
  gallery_indicators: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20
  },
  gallery_indicator: {
    height: 14,
    width: 14,
    margin: '0 10px',
    border: '1px solid #d0d0d0',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].white,
    borderRadius: '50%',
    transition: 'all 300ms',
    cursor: 'pointer',
    outline: 'none'
  },
  gallery_indicator_active: {
    borderColor: '#39b4d6',
    backgroundColor: '#39b4d6'
  },
  actions: _defineProperty({
    width: 294,
    paddingTop: 50

  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    paddingTop: 30
  }),
  favourites: _defineProperty({
    width: 294,
    paddingTop: 20

  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    paddingTop: 10
  }),
  action: _defineProperty({
    display: 'block',
    marginBottom: 16,
    width: 293,
    height: 50,
    textTransform: 'uppercase',
    fontSize: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: 900,
    lineHeight: '50px',
    letterSpacing: 2,
    textAlign: 'center',
    borderRadius: 5,
    border: 0,
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 300ms',

    '@media screen and (max-width: 750px)': {
      width: 230
    }

  }, __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  no_action: {
    cursor: 'default'
  },
  share_request: {
    color: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].white,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].primary,

    ':hover': {
      backgroundColor: '#61c3df'
    }
  },
  favourite_request: {
    color: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].primary,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].white,
    border: '2px solid #56C5FF',
    ':hover': {
      color: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].red
    },
    ':hover svg': {
      fill: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].red
    }
  },
  message_owner: {
    color: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].white,
    backgroundColor: '#000e1f',
    ':disabled': {
      opacity: 0.6,
      cursor: 'not-allowed'
    }
  },
  discontinue_sharing: {
    color: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].white,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].error
  },
  discontinue_favourite: {
    color: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].primary,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].white,
    border: '2px solid #56C5FF',
    ':hover': {
      color: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].red
    }
  },
  sharing: {
    color: '#000e1f',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_15__config_theme__["a" /* Theme */].white
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_16__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_16__utils__["b" /* mapDispatchToProps */])(DogProfile));

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dropzone__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_avatar_editor__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_avatar_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_avatar_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_pooch__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ErrorContainer__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_TextField__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_DateField__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_CheckboxField__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_SimpleSelect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_CheckButton__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_ActivityCard__ = __webpack_require__(43);
var _StyleSheet$create;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// import { withRouter } from 'react-router-dom';













// import InteractiveMap from '../../components/InteractiveMap';










var POOCH_ASSET = __webpack_require__(344);
var UPLOAD_ASSET = __webpack_require__(345);
var ROTATE_ICON = __webpack_require__(604);

var EditPooch = function (_Component) {
  _inherits(EditPooch, _Component);

  function EditPooch(props) {
    _classCallCheck(this, EditPooch);

    var _this = _possibleConstructorReturn(this, (EditPooch.__proto__ || Object.getPrototypeOf(EditPooch)).call(this, props));

    var dog = _this.getDog();
    _this.selectHandler = _this.handleSelect.bind(_this);
    _this.setValue = _this.updateField.bind(_this);
    _this.setMarkers = _this.handleMarkers.bind(_this);
    _this.acceptFiles = _this.handleFileDrop.bind(_this);
    _this.clearImage = _this.handleClearImage.bind(_this);
    _this.saveDraft = _this.handleSave.bind(_this, false);
    _this.savePublish = _this.handleSave.bind(_this, true);
    _this.handleRotation = _this.handleImageRotation.bind(_this);
    _this.avatarSaveImage = _this.handleAvatarSaveImage.bind(_this);
    _this.editAvator = _this.handleAvatarFileDrop.bind(_this);
    _this.editorRef = _this.setEditorRef.bind(_this);
    _this.handleClose = _this.avatarEditorModalHandler.bind(_this);

    _this.toast = function (message) {
      __WEBPACK_IMPORTED_MODULE_0_react_toastify__["b" /* toast */].info(message, {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false
      });
    };

    var dateOfBirth = __WEBPACK_IMPORTED_MODULE_9_moment___default()(dog.date_of_birth).format('YYYY-MM-DD');

    var desexStatus = dog.fixed;
    if (desexStatus !== 'Neutered' && desexStatus !== 'Spayed' && desexStatus !== 'Entire') {
      // desex status using the deprecated checkbox value, so force field to be re-entered
      desexStatus = null;
    }

    _this.state = {
      active: false,
      completed: false,
      adding: false,
      avatar_editor_modal_open: false,

      id: dog.id,
      name: dog.name,
      about: dog.about,
      breed: dog.breed ? _this.props.appdata.breed.find(function (breed) {
        return breed.title === dog.breed;
      }).id : null,
      dogsize: dog.dogsize ? _this.props.appdata.dogsize.find(function (dogsize) {
        return dogsize.title === dog.dogsize;
      }).id : null,
      date_of_birth: dateOfBirth,
      city: dog.city,
      good_with_children: dog.good_with_children,
      health_needs: dog.health_needs,
      hypoallergenic_coat: dog.hypoallergenic_coat,
      markers: dog.markers,
      plays_with_other_dogs: dog.plays_with_other_dogs,
      published: dog.published,
      registration: dog.registration,
      living_situation: dog.living_situation,
      availability: dog.availability,
      regularity: dog.regularity,
      photos: dog.photos,
      interests: dog.interests.map(function (interest) {
        return interest.id;
      }),
      needs: dog.needs.map(function (need) {
        return need.id;
      }),
      removed_images: [],
      avatarPhoto: [],
      avatarPhotoRotation: null,
      sex: dog.sex,
      fixed: desexStatus,

      errors: {
        name: false,
        breed: false,
        dogsize: false,
        about: false,
        registration: false,
        needs: false,
        interests: false,
        photos: false,
        publishError: false,
        health_needs: false,
        userProfilePublishError: false,
        availability: false,
        living_situation: false,
        sex: false
      }
    };

    _this.availability = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* availability */];
    _this.living_situations = __WEBPACK_IMPORTED_MODULE_11__utils__["d" /* livingSituations */];
    _this.regularity = __WEBPACK_IMPORTED_MODULE_11__utils__["e" /* regularity */];
    _this.sex = __WEBPACK_IMPORTED_MODULE_11__utils__["f" /* sex */];
    _this.fixedStatuses = __WEBPACK_IMPORTED_MODULE_11__utils__["g" /* fixedStatuses */];
    return _this;
  }

  _createClass(EditPooch, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var dog = this.getDog();

      // You can't edit a dog that you do not own.
      if (!dog) {
        this.props.history.push('/shares');
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          active: true
        });
      }, 0);
    }
  }, {
    key: 'setEditorRef',
    value: function setEditorRef(editor) {
      this.editor = editor;
    }
  }, {
    key: 'getFieldsToStore',
    value: function getFieldsToStore() {
      var validPhotos = this.state.photos.filter(function (image) {
        return !image.remote;
      });

      var fields = {
        name: this.state.name,
        about: this.state.about,
        breed: this.state.breed,
        dogsize: this.state.dogsize,
        date_of_birth: this.state.date_of_birth,
        city: this.state.city,
        good_with_children: this.state.good_with_children,
        markers: this.state.markers,
        health_needs: this.state.health_needs,
        hypoallergenic_coat: this.state.hypoallergenic_coat,
        plays_with_other_dogs: this.state.plays_with_other_dogs,
        published: this.state.published,
        registration: this.state.registration,
        availability: this.state.availability,
        living_situation: this.state.living_situation,
        regularity: this.state.regularity,
        photos: validPhotos && validPhotos.length ? validPhotos : null,
        interests: this.state.interests && this.state.interests.length ? this.state.interests : null,
        needs: this.state.needs && this.state.needs.length ? this.state.needs : null,
        removed_images: this.state.removed_images && this.state.removed_images.length ? this.state.removed_images : null,

        sex: this.state.sex,
        fixed: this.state.fixed
      };

      return fields;
    }
  }, {
    key: 'getDog',
    value: function getDog() {
      var dogID = this.props.match.params.id;
      return this.props.user.dogs.find(function (pooch) {
        return pooch.id === parseInt(dogID, 10);
      });
    }

    // Validate the form

  }, {
    key: 'validateForm',
    value: function validateForm() {
      var errors = {};

      if (!this.state.name || !this.state.name.length) {
        errors.name = 'Please add a name';
      } else {
        errors.name = null;
      }

      if (!this.state.breed) {
        errors.breed = 'Please select a breed';
      } else {
        errors.breed = null;
      }

      if (!this.state.dogsize) {
        errors.dogsize = 'Please select the size';
      } else {
        errors.dogsize = null;
      }

      if (!this.state.date_of_birth) {
        errors.date_of_birth = 'Please enter a date of birth';
      } else {
        errors.date_of_birth = null;
      }

      if (!this.state.about || !this.state.about.length) {
        errors.about = 'Please tell us about your dog';
      } else {
        errors.about = null;
      }

      if (!this.state.registration || !this.state.registration.length) {
        errors.registration = 'Please enter a registration number';
      } else {
        errors.registration = null;
      }

      if (!this.state.regularity) {
        errors.regularity = 'Please select the most likely regularity for sharing';
      } else {
        errors.regularity = null;
      }

      if (!this.state.availability) {
        errors.availability = 'Please select the availability for sharing';
      } else {
        errors.availability = null;
      }

      if (!this.state.living_situation) {
        errors.living_situation = 'Please select the ideal living situation';
      } else {
        errors.living_situation = null;
      }

      if (!this.state.needs || !this.state.needs.length) {
        errors.needs = 'Please select at least one need';
      } else {
        errors.needs = null;
      }

      if (!this.state.sex || !this.state.sex.length) {
        errors.sex = 'Please select the sex of the dog';
      } else {
        errors.sex = null;
      }

      if (!this.state.fixed || !this.state.fixed.length) {
        errors.fixed = 'Please indicate your dog\'s desex status';
      } else {
        errors.fixed = null;
      }

      if (!this.state.health_needs || !this.state.health_needs.length) {
        errors.health_needs = 'Please add any important details about your pooch. Enter ‘nil’ if not applicable';
      } else {
        errors.health_needs = null;
      }

      if (!this.state.interests || !this.state.interests.length) {
        errors.interests = 'Please select at least one interest';
      } else {
        errors.interests = null;
      }

      if (!this.state.photos || !this.state.photos.length) {
        errors.photos = 'Please upload at least one photo';
      } else {
        errors.photos = null;
      }

      var formErrors = false;

      for (var key in errors) {
        //eslint-disable-line
        if (errors[key] !== null) {
          formErrors = true;
        }
      }

      if (formErrors) {
        errors.publishError = 'Please fix any form errors to continue.';
      } else {
        errors.publishError = null;
      }

      if (formErrors) {
        this.setState({
          errors: errors
        });

        return false;
      }

      if (!this.props.user.published === false) {
        this.setState({
          errors: {
            userProfilePublishError: null
          }
        });
      } else {
        this.setState({
          errors: {
            userProfilePublishError: 'Your personal profile needs to be published prior to your dog\'s profile. Save this profile now as draft.'
          }
        });

        return false;
      }

      return true;
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(name, id, value) {
      var _this3 = this;

      // eslint-disable-next-line
      console.log(name, id, value);
      if (value) {
        this.addKey(name, id);
      } else {
        this.removeKey(name, id);
      }

      setTimeout(function () {
        if (_this3.state.errors[name]) {
          // If there is an error against this field, attempt to revalidate
          _this3.validateForm();
        }
      }, 10);
    }
  }, {
    key: 'handleMarkers',
    value: function handleMarkers(key, id, value) {
      if (value) {
        this.addMarker(key, id, value);
      } else {
        this.removeMarker(key, id);
      }
    }
  }, {
    key: 'addMarker',
    value: function addMarker(key, id, value) {
      this.setState(_defineProperty({}, key, [].concat(_toConsumableArray(this.state.markers), [{
        id: id,
        position: {
          lat: value.lat,
          lng: value.lng
        }
      }])));
    }
  }, {
    key: 'removeMarker',
    value: function removeMarker(key, id) {
      this.setState(_defineProperty({}, key, this.state.markers.filter(function (marker) {
        return marker.id !== id;
      })));
    }
  }, {
    key: 'updateField',
    value: function updateField(key, value) {
      var _this4 = this;

      this.setState(_defineProperty({}, key, value));

      setTimeout(function () {
        if (_this4.state.errors[key]) {
          // If there is an error against this field, attempt to revalidate
          _this4.validateForm();
        }
      }, 10);
    }

    // Add a unique key to array in state

  }, {
    key: 'addKey',
    value: function addKey(name, key) {
      var state = this.state;
      var inArray = state[name].find(function (obj) {
        return obj === key;
      });

      // If the item is not already in the array, add it. Otherwise return state
      this.setState(_defineProperty({}, name, !inArray ? state[name].concat([key]) : state));
    }
  }, {
    key: 'avatarEditorModalHandler',
    value: function avatarEditorModalHandler() {
      this.setState({
        avatar_editor_modal_open: !this.state.avatar_editor_modal_open
      });
    }

    // Remove key from an array in state

  }, {
    key: 'removeKey',
    value: function removeKey(name, key) {
      var state = this.state;

      this.setState(_defineProperty({}, name, state[name].filter(function (obj) {
        return obj !== key;
      })));
    }
  }, {
    key: 'handleClearImage',
    value: function handleClearImage(image) {
      var modifiedState = {
        photos: this.state.photos.filter(function (savedImage) {
          return savedImage.file_name !== image.file_name;
        })
      };

      // Remember in 'removed_images' state so we can remove from remote
      if (image.remote) {
        modifiedState.removed_images = [].concat(this.state.removed_images, [image.id]);
      }

      this.setState(modifiedState);
    }
  }, {
    key: 'handleFileDrop',
    value: function handleFileDrop(acceptedFiles, rejectedFiles) {
      var _this5 = this;

      acceptedFiles.forEach(function (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          var fileAsDataURL = reader.result;

          if (_this5.state.photos.length < 3) {
            _this5.setState({
              photos: [].concat(_this5.state.photos, [{
                id: null,
                remote: false,
                src: fileAsDataURL,
                size: file.size,
                file_name: file.name
              }])
            });
          }
        };
      });

      if (rejectedFiles && rejectedFiles.length) {
        this.setState({
          errors: Object.assign({}, this.state.errors, {
            photos: '1 or more images did not upload. Must be JPG or PNG, and below 2MB.'
          })
        });
      } else {
        this.setState({
          errors: Object.assign({}, this.state.errors, {
            photos: false
          })
        });
      }
    }
  }, {
    key: 'handleAvatarFileDrop',
    value: function handleAvatarFileDrop(acceptedFiles, rejectedFiles) {
      var _this6 = this;

      acceptedFiles.forEach(function (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          var fileAsDataURL = reader.result;

          if (!_this6.state.avatarPhoto.length) {
            _this6.setState({
              avatar_editor_modal_open: true,
              avatarPhoto: {
                id: null,
                remote: false,
                src: fileAsDataURL,
                size: file.size,
                file_name: file.name
              }
            });
          }
        };
      });

      if (rejectedFiles && rejectedFiles.length) {
        this.setState({
          errors: Object.assign({}, this.state.errors, {
            photos: '1 or more images did not upload. Must be JPG or PNG, and below 2MB.'
          })
        });
      } else {
        this.setState({
          errors: Object.assign({}, this.state.errors, {
            photos: false
          })
        });
      }
    }
  }, {
    key: 'handleImageRotation',
    value: function handleImageRotation() {
      var angle = (this.state.avatarPhotoRotation + 90) % 360;
      this.setState({
        avatarPhotoRotation: angle
      });
    }
  }, {
    key: 'handleAvatarSaveImage',
    value: function handleAvatarSaveImage() {
      var avatarPhoto = this.state.avatarPhoto;
      var canvasImage = this.editor.props;
      if (this.state.photos.length < 3) {
        var newImage = this.editor.getImage();
        this.setState({
          avatar_editor_modal_open: false,
          photos: [].concat(this.state.photos, [{
            id: null,
            remote: false,
            src: newImage.toDataURL('image/jpeg', 0.8),
            size: avatarPhoto.size,
            file_name: avatarPhoto.name,
            rotate: canvasImage.rotate
          }])
        });
      }
    }
  }, {
    key: 'fileSize',
    value: function fileSize(b) {
      var u = 0;
      var s = 1024;

      while (b >= s || -b >= s) {
        b /= s; //eslint-disable-line
        u += 1;
      }
      return (u ? b.toFixed(1) + ' ' : b) + ' KMGTPEZY'[u] + 'B';
    }
  }, {
    key: 'handleSave',
    value: function handleSave(published) {
      var _this7 = this;

      if (published) {
        // If the user is trying to publish, the form must validate.
        // The user can save an incomplete form only if it's a draft
        if (!this.validateForm()) {
          return false;
        }
      }

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        return _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__actions_pooch__["b" /* updateDogRemote */])(_this7.state.id, Object.assign({}, _this7.getFieldsToStore(), {
          published: published
        }), _this7.props.user.access_token)).then(function () {
          _this7.toast(published ? 'Your dog is now listed online' : 'Your dog is not listed online');
          _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));

          _this7.props.history.push('/pooch/' + _this7.state.id);
        }, function (err) {
          console.log(err); // eslint-disable-line no-console
          _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        });
      }, function (err) {
        console.log(err); // eslint-disable-line no-console
        _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions_applicationState__["a" /* updateAppState */])({
          loading: false
        }));
      });

      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var dog = this.getDog();
      var selectedNeeds = this.state.needs;
      var selectedInterests = this.state.interests;

      if (!dog) {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.container, this.state.active ? styles.container_active : null, this.state.completed ? styles.container_completed : null) },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15__components_ContentContainer__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_inlinesvg___default.a, {
            cacheGetRequests: true,
            src: POOCH_ASSET,
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.icon)
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h1',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.heading) },
            'Editing ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.highlight) },
              dog.name,
              '\'',
              's'
            ),
            ' profile.'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.main) },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.form) },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__["a" /* default */], { pin: true }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.sub_heading) },
                'Dog information'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_TextField__["a" /* default */], {
                id: 'name',
                name: 'name',
                label: 'Name',
                placeholder: 'Your dog\'s name',
                value: this.state.name,
                handler: this.setValue,
                required: true,
                error: this.state.errors.name
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_SimpleSelect__["a" /* default */], {
                id: 'breed',
                name: 'breed',
                options: this.props.appdata.breed.map(function (breed) {
                  return {
                    value: breed.id,
                    label: breed.title
                  };
                }),
                value: this.state.breed,
                handler: this.setValue,
                label: 'Breed',
                required: true,
                error: this.state.errors.breed
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_DateField__["a" /* default */], {
                id: 'date_of_birth',
                name: 'date_of_birth',
                label: 'Date of birth',
                type: 'date',
                fullWidth: true,
                placeholder: 'DD/MM/YYYY',
                value: this.state.date_of_birth,
                handler: this.setValue,
                required: true,
                error: this.state.errors.date_of_birth
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_SimpleSelect__["a" /* default */], {
                id: 'dogsize',
                name: 'dogsize',
                options: this.props.appdata.dogsize.map(function (dogsize) {
                  return {
                    value: dogsize.id,
                    label: dogsize.title
                  };
                }),
                value: this.state.dogsize,
                handler: this.setValue,
                label: 'Size',
                required: true,
                error: this.state.errors.dogsize
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_SimpleSelect__["a" /* default */], {
                id: 'living_situation',
                name: 'living_situation',
                options: this.living_situations,
                label: 'Ideal living situation of borrower',
                value: this.state.living_situation,
                handler: this.setValue,
                error: this.state.errors.living_situation,
                required: true
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_SimpleSelect__["a" /* default */], {
                id: 'availability',
                name: 'availability',
                options: this.availability,
                label: 'Availability',
                required: true,
                value: this.state.availability,
                handler: this.setValue,
                error: this.state.errors.availability
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_SimpleSelect__["a" /* default */], {
                id: 'regularity',
                name: 'regularity',
                options: this.regularity,
                label: 'Regularity of sharing',
                required: true,
                value: this.state.regularity,
                handler: this.setValue,
                error: this.state.errors.regularity
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_TextField__["a" /* default */], {
                id: 'registration',
                name: 'registration',
                value: this.state.registration,
                handler: this.setValue,
                label: 'Registration No. or Microchip No. - this will not be public.',
                placeholder: 'Enter a valid NZ Registration number.',
                required: true,
                error: this.state.errors.registration
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_SimpleSelect__["a" /* default */], {
                id: 'sex',
                name: 'sex',
                options: this.sex,
                label: 'Sex',
                required: true,
                value: this.state.sex,
                handler: this.setValue,
                error: this.state.errors.sex
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_SimpleSelect__["a" /* default */], {
                id: 'fixed',
                name: 'fixed',
                options: this.fixedStatuses,
                label: 'Desex Status',
                required: true,
                value: this.state.fixed,
                handler: this.setValue,
                error: this.state.errors.fixed,
                placeholder: 'Please indicate your dog\'s desex status',
                tooltip: 'If you are listing a puppy, select \'entire\' and advise the planned date of the puppy\'s neuter/spay within your text'
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_TextField__["a" /* default */], {
                id: 'about',
                name: 'about',
                label: 'Description',
                value: this.state.about,
                handler: this.setValue,
                textArea: true,
                fullWidth: true,
                showRemaining: true,
                required: true,
                limit: 1000,
                height: 85,
                placeholder: ' Tell us a bit about your dog, its needs and availability, this will show up in their profile ',
                error: this.state.errors.about
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.checkboxes) },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_CheckboxField__["a" /* default */], {
                  id: 'good_with_children',
                  name: 'good_with_children',
                  label: 'My dog is good with children',
                  value: this.state.good_with_children,
                  handler: this.setValue,
                  tooltip: 'My dog is safe if left unsupervised around children.'
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_CheckboxField__["a" /* default */], {
                  id: 'plays_with_other_dogs',
                  name: 'plays_with_other_dogs',
                  label: 'My dog is keen to play with other dogs',
                  value: this.state.plays_with_other_dogs,
                  handler: this.setValue,
                  tooltip: 'My dog is safe if left unsupervised around other dogs.'
                })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__["a" /* default */], { pin: true }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.sub_heading) },
                'Dog Needs'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.paragraph) },
                'Select as many that are relevant to you.'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.needs) },
                this.props.appdata.need.map(function (need) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_CheckButton__["a" /* default */], {
                    name: 'needs',
                    label: need.title,
                    id: need.id,
                    onSelect: _this8.selectHandler,
                    selected: selectedNeeds.find(function (selectedNeed) {
                      return need.id === selectedNeed;
                    }) });
                }),
                this.state.errors.needs ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_ErrorContainer__["a" /* default */], { message: this.state.errors.needs }) : null
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__["a" /* default */], { pin: true }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.sub_heading) },
                'Doggie Interests'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.paragraph) },
                'Select as many that are relevant to you.'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.interests) },
                this.props.appdata.interest.map(function (interest) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_ActivityCard__["a" /* default */], {
                    name: 'interests',
                    id: interest.id,
                    activity: interest.title,
                    label: interest.title,
                    styles: styles.interest,
                    onSelect: _this8.selectHandler,
                    profileHandler: true,
                    value: selectedInterests.find(function (selectedInterest) {
                      return interest.id === selectedInterest;
                    }) });
                }),
                this.state.errors.interests ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_ErrorContainer__["a" /* default */], { message: this.state.errors.interests }) : null
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__["a" /* default */], { pin: true }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.sub_heading) },
                'Important Details'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_TextField__["a" /* default */], {
                id: 'health_needs',
                name: 'health_needs',
                label: 'Health and Wellbeing Needs.',
                value: this.state.health_needs,
                error: this.state.errors.health_needs,
                handler: this.setValue,
                textArea: true,
                fullWidth: true,
                height: 85,
                placeholder: 'Tell us anything a borrower may need to know about looking after your dog. i.e. medication, dietary needs, allergies etc.'
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_CheckboxField__["a" /* default */], {
                id: 'hypoallergenic_coat',
                name: 'hypoallergenic_coat',
                value: this.state.hypoallergenic_coat,
                handler: this.setValue,
                label: 'My dog has a hypoallergenic coat'
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__["a" /* default */], { pin: true }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.sub_heading) },
                'Upload a profile photo'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.paragraph) },
                'You can add up to 3 images of your dog, each image has to be below 2MB and be .jpg or .png format.',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                'For security purposes, all human faces should be removed prior to uploading.'
              ),
              this.state.photos.length < 3 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_dropzone__["a" /* default */],
                {
                  maxSize: 2097152,
                  multiple: true,
                  accept: 'image/jpeg, image/png, image/bmp',
                  onDrop: this.editAvator,
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.dropzone) },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_inlinesvg___default.a, {
                  cacheGetRequests: true,
                  src: UPLOAD_ASSET,
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.dropzone_icon)
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  null,
                  'Drop files to attach or',
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.dropzone_browse, styles.highlight) },
                    ' browse'
                  )
                )
              ) : false,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.avatarEditor) },
                this.state.avatarPhoto.src ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_modal___default.a,
                  {
                    isOpen: this.state.avatar_editor_modal_open,
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.modal_container),
                    onRequestClose: this.handleClose,
                    style: {
                      overlay: {
                        backgroundColor: 'rgba(0,0,0,0.67)',
                        zIndex: 101,
                        display: 'flex'
                      }
                    },
                    contentLabel: 'Photo Editor'
                  },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.modal_wrapper) },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.header) },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'h2',
                        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.modal_title) },
                        'Photo Editor'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.body) },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.avatarCanvas) },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_avatar_editor___default.a, {
                          ref: this.editorRef,
                          image: this.state.avatarPhoto.src,
                          width: 250,
                          height: 250,
                          color: [255, 255, 255, 0.6] // RGBA
                          , scale: 1.2,
                          rotate: this.state.avatarPhotoRotation
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.actions_container) },
                      this.state.avatarPhoto.src ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        {
                          role: 'button',
                          tabIndex: 0,
                          onClick: this.handleRotation },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', {
                          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.rotate_icon),
                          src: ROTATE_ICON,
                          alt: 'rotate'
                        })
                      ) : false,
                      this.state.avatarPhoto.src ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'button',
                        {
                          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.avatarAction),
                          onClick: this.avatarSaveImage },
                        'Save Photo'
                      ) : false
                    )
                  )
                ) : false
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.photos) },
                this.state.photos && this.state.photos.length ? this.state.photos.map(function (image) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.image_info_container) },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.file_image) },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', {
                        alt: 'Profile',
                        className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.profile_photo),
                        src: image.src })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.file_info) },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.file_name) },
                        image.file_name
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.file_size) },
                        image.remote ? image.size : _this8.fileSize(image.size)
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        {
                          onClick: _this8.clearImage.bind(_this8, image),
                          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.clear_image),
                          role: 'link',
                          tabIndex: 0 },
                        'Remove picture'
                      )
                    )
                  );
                }) : false,
                this.state.errors.photos ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_ErrorContainer__["a" /* default */], { message: this.state.errors.photos }) : null
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.actions) },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'button',
                  {
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.draft),
                    onClick: this.saveDraft },
                  'Save as Draft / Unpublish'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'button',
                  {
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.publish),
                    onClick: this.savePublish },
                  'Save and publish'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.publishErrorWrapper) },
                this.state.errors.publishError ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_ErrorContainer__["a" /* default */], { message: this.state.errors.publishError }) : null
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.profilePublishErrorWrapper) },
                this.state.errors.userProfilePublishError ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_ErrorContainer__["a" /* default */], { message: this.state.errors.userProfilePublishError }) : null
              )
            )
          )
        )
      );
    }
  }]);

  return EditPooch;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

EditPooch.propTypes = {
  appdata: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].func.isRequired,
  match: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].object.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].object.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_4_aphrodite__["StyleSheet"].create((_StyleSheet$create = {
  needs: _defineProperty({
    display: 'flex',
    flexWrap: 'wrap',
    margin: '6px -4.5px'
  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    margin: '6px 0'
  }),
  interests: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -4.5px'
  },
  interest: _defineProperty({
    width: 244,
    margin: '6px 4.5px'
  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  checkboxes: _defineProperty({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginBottom: 30
  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    'flex-wrap': 'wrap'
  }),
  highlight: {
    color: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].primary
  },
  dropzone: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 94,
    width: '100%',
    fontFamily: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_family_primary,
    backgroundColor: '#f2f2f2',
    border: '1px dashed #39b4d6',
    cursor: 'pointer'
  },
  dropzone_icon: {
    display: 'block',
    marginRight: 15
  },
  dropzone_browse: {
    fontWeight: 900
  },
  icon: {
    display: 'block',
    width: 159,
    margin: '0 auto 20px'
  },
  container: {
    padding: '86px 0 ' + __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].footer.height + 'px',
    transition: 'transform 500ms',
    transform: 'translateX(100vw)'
  },
  container_active: {
    transform: 'translateX(0)'
  },
  container_completed: {
    transform: 'translateX(-100vw)'
  },
  main: {
    width: 750,
    maxWidth: '100%',
    margin: '0 auto'
  },
  publishErrorWrapper: {
    marginTop: 5,
    width: '100%'
  },
  profilePublishErrorWrapper: {
    marginTop: 5,
    width: '100%'
  },
  heading: {
    marginBottom: 30,
    textAlign: 'center',
    fontSize: 30,
    lineHeight: 1.17,
    fontFamily: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_weight_heading
  },
  sub_heading: {
    width: '100%',
    padding: '0 5px',
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 500,
    fontSize: 20,
    color: '#000e1f'
  },
  paragraph: {
    width: '100%',
    padding: '0 5px',
    marginTop: -15,
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14,
    color: '#828282',
    lineHeight: 1.4
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    width: 750,
    maxWidth: '100%',
    margin: '0 -5px'
  },
  actions: _defineProperty({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    'flex-wrap': 'wrap'
  }),
  draft: _defineProperty({
    width: 340,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_weight_secondary,
    color: '#39b4d6',
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].white,
    cursor: 'pointer',
    outline: 'none'
  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  publish: _defineProperty({
    width: 340,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_weight_secondary,
    color: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: '#56C5FF',
    cursor: 'pointer',
    outline: 'none'
  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  photos: _defineProperty({
    display: 'flex',
    flexDirection: 'column'

  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    flexDirection: 'column'
  }),
  profile_photo: {
    maxWidth: 150,
    maxHeight: 150,
    objectFit: 'contain'
  },
  image_info_container: _defineProperty({
    display: 'flex',
    flexDirection: 'row',
    marginTop: 25,
    marginBottom: 25

  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    flexDirection: 'column'
  }),
  file_image: _defineProperty({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'

  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    marginBottom: 25
  }),
  file_info: _defineProperty({
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 25,
    justifyContent: 'center',
    alignItems: 'flex-start'

  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    paddingLeft: 0,
    marginBottom: 25,
    alignItems: 'center'
  }),
  file_name: _defineProperty({
    marginBottom: 5

  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    display: 'none'
  }),
  file_size: {
    fontWeight: 'light',
    color: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].dark_grey
  },
  clear_image: {
    marginTop: 10,
    cursor: 'pointer',
    color: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].teal,
    fontWeight: 'bold'
  },

  avatarEditor: {
    width: '100%',
    padding: 50
  },
  avatarCanvas: {
    display: 'flex',
    justifyContent: 'center',
    borderWidth: 2,
    borderColor: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].baby_blue,
    borderStyle: 'dashed'
  },
  modal_wrapper: _defineProperty({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: 600 - 100,
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 100px'
  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0px 20px 180px'
  }),
  close_icon: {
    position: 'absolute',
    right: 15,
    top: 15,
    outline: 'none',
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6
    }
  }
}, _defineProperty(_StyleSheet$create, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].desktop_query, {
  body: {
    padding: 5,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  }
}), _defineProperty(_StyleSheet$create, 'modal_container', _defineProperty({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  width: 590,
  maxWidth: '100vw',
  minHeight: 0,
  maxHeight: '100vh',
  backgroundColor: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].white,
  borderRadius: 5,
  overflow: 'hidden',
  outline: 'none',
  margin: 'auto auto'
}, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
  width: 'calc(100% - 30px)',
  minHeight: '0',
  maxHeight: 'none',
  height: 'auto'
})), _defineProperty(_StyleSheet$create, 'actions_container', _defineProperty({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%'
}, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
  flexWrap: 'wrap'
})), _defineProperty(_StyleSheet$create, 'rotate_icon', {
  width: 35,
  marginTop: 10,
  marginRight: 25
}), _defineProperty(_StyleSheet$create, 'modal_title', {
  fontFamily: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_family_heading,
  fontSize: 24,
  fontWeight: '600',
  textAlign: 'center',
  padding: 25
}), _defineProperty(_StyleSheet$create, 'avatarAction', _defineProperty({
  width: 200,
  height: 50,
  marginTop: 8,
  fontSize: 15,
  letterSpacing: 2,
  lineHeight: '50px',
  fontFamily: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_family_secondary,
  fontWeight: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_weight_secondary,
  color: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].white,
  textTransform: 'uppercase',
  border: 0,
  borderRadius: 5,
  backgroundColor: '#56C5FF',
  cursor: 'pointer',
  outline: 'none'
}, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
  width: '100%'
})), _StyleSheet$create));

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_11__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_11__utils__["b" /* mapDispatchToProps */])(EditPooch));

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dropzone__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_avatar_editor__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_avatar_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_avatar_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_tippy__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_tippy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_tippy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ErrorContainer__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_TextField__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_SimpleSelect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Select__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_CheckboxField__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_CheckButton__ = __webpack_require__(44);
var _StyleSheet$create;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// import { withRouter } from 'react-router-dom';






















var EDITICON_ASSET = __webpack_require__(346);
var UPLOAD_ASSET = __webpack_require__(347);
var ROTATE_ICON = __webpack_require__(605);
var TOOLTIP_ASSET = __webpack_require__(348);

var EditProfile = function (_Component) {
  _inherits(EditProfile, _Component);

  function EditProfile(props) {
    _classCallCheck(this, EditProfile);

    var _this = _possibleConstructorReturn(this, (EditProfile.__proto__ || Object.getPrototypeOf(EditProfile)).call(this, props));

    _this.selectHandler = _this.handleSelect.bind(_this);
    _this.setValue = _this.updateTextField.bind(_this);
    _this.acceptFiles = _this.handleFileDrop.bind(_this);
    _this.editAvator = _this.handleAvatarFileDrop.bind(_this);
    _this.handleRotation = _this.handleImageRotation.bind(_this);
    _this.avatarSaveImage = _this.handleAvatarSaveImage.bind(_this);
    _this.clearImage = _this.handleClearImage.bind(_this);
    _this.saveDraft = _this.handleSave.bind(_this, false);
    _this.savePublish = _this.handleSave.bind(_this, true);
    _this.editorRef = _this.setEditorRef.bind(_this);
    _this.handleClose = _this.avatarEditorModalHandler.bind(_this);

    _this.toast = function (message) {
      __WEBPACK_IMPORTED_MODULE_0_react_toastify__["b" /* toast */].info(message, {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false
      });
    };

    _this.state = {
      active: false,
      completed: false,

      display_name: props.user.display_name,
      availability: props.user.availability,
      living_situation: props.user.living_situation,
      regularity: props.user.regularity,
      bio: props.user.bio,
      pet_insurance: props.user.pet_insurance,
      police_checked: props.user.police_checked,
      suburb: props.user.suburb ? props.user.suburb.id : null,

      interests: props.user.interests.map(function (interest) {
        return interest.id;
      }),
      needs: props.user.needs.map(function (need) {
        return need.id;
      }),

      profile_photo_updated: false,
      profile_photo_deleted: false,
      profile_photo: props.user.profile_photo,
      profile_photo_size: props.user.profile_photo_size,
      profile_photo_file: props.user.profile_photo_file,
      avatarPhoto: [],
      avatarPhotoRotation: null,

      errors: {
        nickname: false,
        photos: false,
        profile_photo_error: false,
        suburb: false
      }
    };

    _this.availability = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* availability */];
    _this.living_situations = __WEBPACK_IMPORTED_MODULE_11__utils__["d" /* livingSituations */];
    _this.regularity = __WEBPACK_IMPORTED_MODULE_11__utils__["e" /* regularity */];
    return _this;
  }

  _createClass(EditProfile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          active: true
        });
      }, 100);

      setTimeout(function () {
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions_applicationState__["a" /* updateAppState */])({
          loading: false
        }));
      }, 750);
    }
  }, {
    key: 'setEditorRef',
    value: function setEditorRef(editor) {
      this.editor = editor;
    }
  }, {
    key: 'getFieldsToStore',
    value: function getFieldsToStore() {
      var fields = {
        display_name: this.state.display_name,
        availability: this.state.availability,
        living_situation: this.state.living_situation,
        regularity: this.state.regularity,
        bio: this.state.bio,
        pet_insurance: this.state.pet_insurance,
        police_checked: this.state.police_checked,
        suburb: this.state.suburb && this.state.suburb.value > 0 ? this.state.suburb.value : null,

        interests: this.state.interests,
        needs: this.state.needs,

        profile_photo_deleted: this.state.profile_photo_deleted
      };

      if (this.state.profile_photo_updated) {
        fields.profile_photo = this.state.profile_photo;
        fields.profile_photo_size = this.state.profile_photo_size;
        fields.profile_photo_file = this.state.profile_photo_file;
      }

      return fields;
    }
  }, {
    key: 'avatarEditorModalHandler',
    value: function avatarEditorModalHandler() {
      this.setState({
        avatar_editor_modal_open: !this.state.avatar_editor_modal_open
      });
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(name, id, value) {
      if (value) {
        this.addKey(name, id);
      } else {
        this.removeKey(name, id);
      }
    }
  }, {
    key: 'updateTextField',
    value: function updateTextField(key, value) {
      var updatedState = _defineProperty({}, key, value);
      this.setState(updatedState);
    }

    // Add a unique key to array in state

  }, {
    key: 'addKey',
    value: function addKey(name, key) {
      var state = this.state;
      var inArray = state[name].find(function (obj) {
        return obj === key;
      });

      // If the item is not already in the array, add it. Otherwise return state
      this.setState(_defineProperty({}, name, !inArray ? state[name].concat([key]) : state));
    }

    // Remove key from an array in state

  }, {
    key: 'removeKey',
    value: function removeKey(name, key) {
      var state = this.state;

      this.setState(_defineProperty({}, name, state[name].filter(function (obj) {
        return obj !== key;
      })));
    }
  }, {
    key: 'handleClearImage',
    value: function handleClearImage() {
      this.setState({
        profile_photo_updated: false,
        profile_photo_deleted: true,
        profile_photo: null
      });
    }
  }, {
    key: 'handleFileDrop',
    value: function handleFileDrop(acceptedFiles, rejectedFiles) {
      var _this3 = this;

      acceptedFiles.forEach(function (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          var fileAsDataURL = reader.result;

          _this3.setState({
            profile_photo_updated: true,
            profile_photo_deleted: false,
            profile_photo: fileAsDataURL,
            profile_photo_size: file.size,
            profile_photo_file: file.name
          });
        };
      });

      if (rejectedFiles && rejectedFiles.length) {
        this.setState({
          errors: Object.assign({}, this.state.errors, {
            photos: '1 or more images did not upload. Must be JPG or PNG, and below 2MB.'
          })
        });
      } else {
        this.setState({
          errors: Object.assign({}, this.state.errors, {
            photos: false
          })
        });
      }
    }
  }, {
    key: 'handleAvatarFileDrop',
    value: function handleAvatarFileDrop(acceptedFiles, rejectedFiles) {
      var _this4 = this;

      acceptedFiles.forEach(function (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          var fileAsDataURL = reader.result;

          if (!_this4.state.avatarPhoto.length) {
            _this4.setState({
              avatar_editor_modal_open: true,
              profile_photo_deleted: false,
              avatarPhoto: {
                id: null,
                remote: false,
                src: fileAsDataURL,
                size: file.size,
                file_name: file.name
              }
            });
          }
        };
      });

      if (rejectedFiles && rejectedFiles.length) {
        this.setState({
          errors: Object.assign({}, this.state.errors, {
            photos: '1 or more images did not upload. Must be JPG or PNG, and below 2MB.'
          })
        });
      } else {
        this.setState({
          errors: Object.assign({}, this.state.errors, {
            photos: false
          })
        });
      }
    }
  }, {
    key: 'handleImageRotation',
    value: function handleImageRotation() {
      var angle = (this.state.avatarPhotoRotation + 90) % 360;
      this.setState({
        avatarPhotoRotation: angle
      });
    }
  }, {
    key: 'handleAvatarSaveImage',
    value: function handleAvatarSaveImage() {
      var avatarPhoto = this.state.avatarPhoto;
      var canvasImage = this.editor.props;
      var newImage = this.editor.getImage();
      this.setState({
        avatar_editor_modal_open: false,
        profile_photo_updated: true,
        profile_photo_deleted: false,
        profile_photo: newImage.toDataURL('image/jpeg', 0.8),
        profile_photo_size: avatarPhoto.size,
        profile_photo_file: avatarPhoto.name,
        profile_photo_rotation: canvasImage.rotate
      });
    }
  }, {
    key: 'fileSize',
    value: function fileSize(b) {
      var u = 0;
      var s = 1024;

      while (b >= s || -b >= s) {
        b /= s; //eslint-disable-line
        u += 1;
      }
      return (u ? b.toFixed(1) + ' ' : b) + ' KMGTPEZY'[u] + 'B';
    }
  }, {
    key: 'validateForm',
    value: function validateForm() {
      var errors = {};

      if (!this.state.profile_photo || !this.state.profile_photo.length) {
        errors.profile_photo_error = 'To save your profile as complete, please upload your photo.';
      } else {
        errors.profile_photo_error = null;
      }

      if (!this.state.display_name) {
        errors.nickname = 'Please enter your Name / Nickname';
      } else {
        errors.nickname = null;
      }

      var formErrors = false;

      for (var key in errors) {
        //eslint-disable-line
        if (errors[key] !== null) {
          formErrors = true;
        }
      }

      if (formErrors) {
        this.setState({
          errors: errors
        });

        return false;
      }

      return true;
    }
  }, {
    key: 'handleSave',
    value: function handleSave(published) {
      var _this5 = this;

      if (published) {
        // If the user is trying to publish, the form must validate.
        // The user can save an incomplete form only if it's a draft
        if (!this.validateForm()) {
          return false;
        }
      }

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        return _this5.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__actions_user__["g" /* updateUserRemote */])(Object.assign({}, _this5.getFieldsToStore(), {
          published: published
        }), _this5.props.user.access_token)).then(function () {
          _this5.toast(published ? 'Your profile is now saved as \'complete\'.' : 'Your profile is now saved as \'draft\'.');
          _this5.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));

          _this5.props.history.push('/profile/' + _this5.props.user.id);
        }, function (err) {
          console.log(err); // eslint-disable-line no-console
          _this5.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        });
      }, function (err) {
        console.log(err); // eslint-disable-line no-console
        _this5.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions_applicationState__["a" /* updateAppState */])({
          loading: false
        }));
      });

      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var selectedNeeds = this.state.needs;
      var selectedInterests = this.state.interests;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.container, this.state.active ? styles.container_active : null, this.state.completed ? styles.container_completed : null) },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15__components_ContentContainer__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_inlinesvg___default.a, {
            cacheGetRequests: true,
            src: EDITICON_ASSET,
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.icon)
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h1',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.heading) },
            'Hi ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.highlight) },
              this.props.user.display_name
            ),
            ',',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
            'Let\'s',
            ' edit your profile.'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.main) },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.form) },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__["a" /* default */], { pin: true }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.sub_heading) },
                'Personal information'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_TextField__["a" /* default */], {
                id: 'display_name',
                name: 'display_name',
                label: 'Name/Nickname',
                required: true,
                value: this.state.display_name,
                handler: this.setValue,
                error: this.state.errors.nickname
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.select_parent_container) },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.select_container) },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_Select__["a" /* default */], {
                    id: 'suburb',
                    name: 'suburb',
                    options: this.props.appdata.suburb.map(function (suburb) {
                      return {
                        value: suburb.id,
                        label: suburb.title + ', ' + suburb.district.title
                      };
                    }),
                    label: 'Suburb',
                    required: true,
                    value: this.state.suburb,
                    type: 'location',
                    handler: this.setValue,
                    style: styles.select_style
                  })
                )
              ),
              this.props.user.subscription === 'Borrower' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_SimpleSelect__["a" /* default */], {
                id: 'availability',
                name: 'availability',
                options: this.availability,
                label: 'Availability',
                required: true,
                value: this.state.availability,
                handler: this.setValue
              }) : null,
              this.props.user.subscription === 'Borrower' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_SimpleSelect__["a" /* default */], {
                id: 'living_situation',
                name: 'living_situation',
                options: this.living_situations,
                label: 'Living situation',
                value: this.state.living_situation,
                handler: this.setValue,
                required: true
              }) : null,
              this.props.user.subscription === 'Borrower' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_SimpleSelect__["a" /* default */], {
                id: 'regularity',
                name: 'regularity',
                options: this.regularity,
                label: 'Regularity desired',
                required: true,
                value: this.state.regularity,
                handler: this.setValue
              }) : null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_TextField__["a" /* default */], {
                id: 'bio',
                name: 'bio',
                label: 'About me',
                textArea: true,
                fullWidth: true,
                showRemaining: true,
                limit: 1000,
                height: 85,
                required: true,
                value: this.state.bio,
                handler: this.setValue
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.checkboxes) },
                this.props.user.subscription === 'Owner' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_CheckboxField__["a" /* default */], {
                  id: 'pet_insurance',
                  name: 'pet_insurance',
                  label: 'I have pet insurance',
                  tooltip: 'Do you have pet insurance secured for your pooch?',
                  required: true,
                  value: this.state.pet_insurance,
                  handler: this.setValue
                }) : false,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_CheckboxField__["a" /* default */], {
                  id: 'police_checked',
                  name: 'police_checked',
                  label: 'I have been police checked',
                  tooltip: 'Do you hold a Police Check? You can indicate this to increase your personal trust profile.',
                  required: true,
                  value: this.state.police_checked,
                  handler: this.setValue
                })
              ),
              this.props.user.subscription === 'Borrower' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__["a" /* default */], { pin: true }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'h2',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.sub_heading) },
                  'I\'m good with...'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.paragraph) },
                  'Select as many that are relevant to you.'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.check_buttons) },
                  this.props.appdata.need.map(function (need) {
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_CheckButton__["a" /* default */], {
                      id: need.id,
                      name: 'needs',
                      label: need.title,
                      onSelect: _this6.selectHandler,
                      selected: selectedNeeds.find(function (selectedNeed) {
                        return need.id === selectedNeed || need.id === selectedNeed.id;
                      }) });
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__["a" /* default */], { pin: true }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'h2',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.sub_heading) },
                  'I\'m interested in...'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.paragraph) },
                  'Select as many that are relevant to you.'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.check_buttons) },
                  this.props.appdata.interest.map(function (interest) {
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_CheckButton__["a" /* default */], {
                      id: interest.id,
                      name: 'interests',
                      label: interest.title,
                      onSelect: _this6.selectHandler,
                      selected: selectedInterests.find(function (selectedInterest) {
                        return interest.id === selectedInterest || interest.id === selectedInterest.id;
                      }) });
                  })
                )
              ) : null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__["a" /* default */], { pin: true }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.sub_heading) },
                'Upload a profile photo'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.paragraph) },
                'You can add one photo of yourself, each image has to be below 2MB, and be in .jpg or .png format. For security purposes, the image must clearly be a picture of you (not your dog)!'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.avatarEditor) },
                this.state.avatarPhoto.src ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_modal___default.a,
                  {
                    isOpen: this.state.avatar_editor_modal_open,
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.modal_container),
                    onRequestClose: this.handleClose,
                    style: {
                      overlay: {
                        backgroundColor: 'rgba(0,0,0,0.67)',
                        zIndex: 101,
                        display: 'flex'
                      }
                    },
                    contentLabel: 'Photo Editor'
                  },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.modal_wrapper) },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.header) },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'h2',
                        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.modal_title) },
                        'Photo Editor'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.body) },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.avatarCanvas) },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_avatar_editor___default.a, {
                          ref: this.editorRef,
                          image: this.state.avatarPhoto.src,
                          width: 250,
                          height: 250,
                          color: [255, 255, 255, 0.6] // RGBA
                          , scale: 1.2,
                          rotate: this.state.avatarPhotoRotation
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.actions_container) },
                      this.state.avatarPhoto.src ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        {
                          role: 'button',
                          tabIndex: 0,
                          onClick: this.handleRotation },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', {
                          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.rotate_icon),
                          src: ROTATE_ICON,
                          alt: 'rotate'
                        })
                      ) : false,
                      this.state.avatarPhoto.src ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'button',
                        {
                          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.avatarAction),
                          onClick: this.avatarSaveImage },
                        'Save Photo'
                      ) : false
                    )
                  )
                ) : false
              ),
              this.state.profile_photo ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.image_info_container) },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.file_image) },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', {
                    alt: 'Profile',
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.profile_photo),
                    src: this.state.profile_photo })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.file_info) },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.file_name) },
                    this.state.profile_photo_file
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.file_size) },
                    this.state.profile_photo_updated ? this.fileSize(this.state.profile_photo_size) : this.state.profile_photo_size
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    {
                      onClick: this.clearImage,
                      className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.clear_image),
                      role: 'link',
                      tabIndex: 0 },
                    'Remove picture'
                  )
                )
              ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_dropzone__["a" /* default */],
                {
                  maxSize: 2097152,
                  multiple: false,
                  accept: 'image/jpeg, image/png, image/bmp',
                  onDrop: this.editAvator,
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.dropzone) },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_inlinesvg___default.a, {
                  cacheGetRequests: true,
                  src: UPLOAD_ASSET,
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.dropzone_icon)
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  null,
                  'Drop files to attach or',
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.dropzone_browse, styles.highlight) },
                    ' browse'
                  )
                )
              ),
              this.state.errors.photos ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_ErrorContainer__["a" /* default */], { message: this.state.errors.photos }) : null,
              this.state.errors.profile_photo_error ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_ErrorContainer__["a" /* default */], { message: this.state.errors.profile_photo_error }) : null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.actions) },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'button',
                  {
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.draft),
                    onClick: this.saveDraft },
                  'Save as Draft'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'button',
                  {
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.publish),
                    onClick: this.savePublish },
                  'Save As Complete'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_react_tippy__["Tooltip"],
                  {
                    position: 'bottom',
                    arrow: true,
                    html: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.actions_tooltip) },
                      'Your borrower / owner profile remains private, until you request to share a dog (borrower version) / accept a dog share request (owner version)'
                    )
                  },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_inlinesvg___default.a, {
                    cacheGetRequests: true,
                    src: TOOLTIP_ASSET,
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.actions_tooltip_trigger)
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.publishErrorWrapper) },
                this.state.errors.publishError ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_ErrorContainer__["a" /* default */], { message: this.state.errors.publishError }) : null
              )
            )
          )
        )
      );
    }
  }]);

  return EditProfile;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

EditProfile.propTypes = {
  appdata: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_4_aphrodite__["StyleSheet"].create((_StyleSheet$create = {
  actions_tooltip: {
    padding: 5,
    fontSize: 14,
    fontFamily: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_family_primary
  },
  actions_tooltip_trigger: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 10px',
    cursor: 'pointer'
  },
  check_buttons: _defineProperty({
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -4.5px'

  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    margin: 0
  }),
  highlight: {
    color: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].primary
  },
  checkboxes: _defineProperty({
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    marginBottom: 30

  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column'
  }),
  dropzone: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 94,
    width: '100%',
    fontFamily: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_family_primary,
    backgroundColor: '#f2f2f2',
    border: '1px dashed #39b4d6',
    cursor: 'pointer'
  },
  dropzone_icon: {
    display: 'block',
    marginRight: 15
  },
  dropzone_browse: {
    fontWeight: 900
  },
  icon: {
    display: 'block',
    width: 159,
    margin: '0 auto 20px'
  },
  container: {
    padding: '86px 0 ' + __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].footer.height + 'px',
    transition: 'transform 500ms',
    transform: 'translateX(100vw)'
  },
  select_parent_container: _defineProperty({
    position: 'relative',
    padding: '0px 5px',
    marginBottom: '5px',
    width: '50%'

  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  select_container: _defineProperty({
    position: 'relative',
    zIndex: 10,
    width: '100%'

  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  select_style: _defineProperty({
    width: '100%',
    height: '48px'
  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  container_active: {
    transform: 'translateX(0)'
  },
  container_completed: {
    transform: 'translateX(-100vw)'
  },
  main: _defineProperty({
    width: 750,
    margin: '0 auto'

  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  heading: {
    marginBottom: 30,
    textAlign: 'center',
    fontSize: 30,
    lineHeight: 1.17,
    fontFamily: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_weight_heading
  },
  sub_heading: {
    width: '100%',
    padding: '0 5px',
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 500,
    fontSize: 20,
    color: '#000e1f'
  },
  paragraph: {
    width: '100%',
    padding: '0 5px',
    marginTop: -15,
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14,
    color: '#828282',
    lineHeight: 1.4
  },
  form: _defineProperty({
    display: 'flex',
    flexWrap: 'wrap',
    width: 750,
    margin: '0 -5px'

  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    margin: 0
  }),
  actions: _defineProperty({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'

  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column'
  }),
  draft: _defineProperty({
    width: 340,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_weight_secondary,
    color: '#39b4d6',
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].white,
    cursor: 'pointer',
    outline: 'none'

  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  publish: _defineProperty({
    width: 340,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_weight_secondary,
    color: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: '#56C5FF',
    cursor: 'pointer',
    outline: 'none'

  }, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  publishErrorWrapper: {
    marginTop: 5,
    width: '100%'
  },
  profile_photo: {
    maxWidth: 150,
    maxHeight: 150,
    objectFit: 'contain'
  },
  image_info_container: {
    display: 'flex',
    flexDirection: 'row'
  },
  file_image: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  file_info: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 25,
    justifyContent: 'center',
    alignItems: 'flex-start'
  },
  file_name: {
    marginBottom: 5
  },
  file_size: {
    fontWeight: 'light',
    color: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].dark_grey
  },
  clear_image: {
    marginTop: 10,
    cursor: 'pointer',
    color: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].teal,
    fontWeight: 'bold'
  },
  avatarEditor: {
    width: '100%',
    padding: 50
  },
  avatarCanvas: {
    display: 'flex',
    justifyContent: 'center',
    borderWidth: 2,
    borderColor: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].baby_blue,
    borderStyle: 'dashed'
  }
}, _defineProperty(_StyleSheet$create, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].desktop_query, {
  body: {
    padding: 5,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  }
}), _defineProperty(_StyleSheet$create, 'modal_container', _defineProperty({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  width: 590,
  maxWidth: '100vw',
  minHeight: 0,
  maxHeight: '100vh',
  backgroundColor: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].white,
  borderRadius: 5,
  overflow: 'hidden',
  outline: 'none',
  margin: 'auto auto'
}, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
  width: 'calc(100% - 30px)',
  minHeight: '0',
  maxHeight: 'none',
  height: 'auto'
})), _defineProperty(_StyleSheet$create, 'modal_wrapper', _defineProperty({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  height: 600 - 100,
  width: '100%',
  boxSizing: 'border-box',
  padding: '0px 100px'
}, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
  padding: '0px 20px 180px'
})), _defineProperty(_StyleSheet$create, 'actions_container', _defineProperty({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%'
}, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
  flexWrap: 'wrap'
})), _defineProperty(_StyleSheet$create, 'rotate_icon', {
  width: 35,
  marginTop: 10,
  marginRight: 25
}), _defineProperty(_StyleSheet$create, 'modal_title', {
  fontFamily: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_family_heading,
  fontSize: 24,
  fontWeight: '600',
  textAlign: 'center',
  padding: 25
}), _defineProperty(_StyleSheet$create, 'avatarAction', _defineProperty({
  width: 200,
  height: 50,
  marginTop: 8,
  fontSize: 15,
  letterSpacing: 2,
  lineHeight: '50px',
  fontFamily: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_family_secondary,
  fontWeight: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].font_weight_secondary,
  color: __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].white,
  textTransform: 'uppercase',
  border: 0,
  borderRadius: 5,
  backgroundColor: '#56C5FF',
  cursor: 'pointer',
  outline: 'none'
}, __WEBPACK_IMPORTED_MODULE_10__config_theme__["a" /* Theme */].mobile_query, {
  width: '100%'
})), _StyleSheet$create));

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_11__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_11__utils__["b" /* mapDispatchToProps */])(EditProfile));

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Body__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Heading__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Paragraph__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_DashboardHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_UnauthenticatedHeader__ = __webpack_require__(17);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var styles = void 0;

var ErrorView = function (_Component) {
  _inherits(ErrorView, _Component);

  function ErrorView(props) {
    _classCallCheck(this, ErrorView);

    var _this = _possibleConstructorReturn(this, (ErrorView.__proto__ || Object.getPrototypeOf(ErrorView)).call(this, props));

    _this.state = {};

    _this.openLoginHandler = _this.loginModalOpenHandler.bind(_this);
    _this.logoutHandler = _this.performLogout.bind(_this);
    _this.redirectHandler = _this.performRedirect.bind(_this);
    return _this;
  }

  _createClass(ErrorView, [{
    key: 'performLogout',
    value: function performLogout() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_user__["b" /* logout */])());
      this.props.history.push('/');
    }
  }, {
    key: 'performRedirect',
    value: function performRedirect(to) {
      this.props.history.push(to);
    }
  }, {
    key: 'loginModalOpenHandler',
    value: function loginModalOpenHandler() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
        login_modal_open: true
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__components_Body__["a" /* default */],
        { hasFooter: true },
        this.props.user.isAuthenticated ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_DashboardHeader__["a" /* default */], Object.assign({
          logoutHandler: this.logoutHandler,
          redirectHandler: this.redirectHandler
        }, this.props)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_UnauthenticatedHeader__["a" /* default */], { openLoginHandler: this.openLoginHandler }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__components_Heading__["a" /* default */],
            null,
            'That page wasn',
            '\'',
            't found.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__components_Paragraph__["a" /* default */],
            null,
            'But we do have plenty of great pages. Have you read ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
              { to: '/story' },
              'our story'
            ),
            ' yet?'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer__["a" /* default */], { user: this.props.user })
      );
    }
  }]);

  return ErrorView;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ErrorView.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

styles = __WEBPACK_IMPORTED_MODULE_4_aphrodite__["StyleSheet"].create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    height: window.innerHeight - (__WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].navigation.height + __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].footer.height),
    width: '100vw',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 150
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* mapDispatchToProps */])(ErrorView));

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_scroll__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_applicationData__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Body__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_DashboardHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SEO__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_UnauthenticatedHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_FAQ__ = __webpack_require__(180);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// import Isvg from 'react-inlinesvg';

















var ScrollLink = __WEBPACK_IMPORTED_MODULE_4_react_scroll__["Link"];
var ScrollElement = __WEBPACK_IMPORTED_MODULE_4_react_scroll__["Element"];
// const ICON1_ASSET = require('./assets/icon_1.svg');

var FAQs = function (_Component) {
  _inherits(FAQs, _Component);

  function FAQs(props) {
    _classCallCheck(this, FAQs);

    var _this = _possibleConstructorReturn(this, (FAQs.__proto__ || Object.getPrototypeOf(FAQs)).call(this, props));

    _this.setQuestion = _this.setQuestion.bind(_this);
    _this.renderFAQs = _this.renderFAQs.bind(_this);
    _this.openLoginHandler = _this.loginModalOpenHandler.bind(_this);
    _this.logoutHandler = _this.performLogout.bind(_this);
    _this.redirectHandler = _this.performRedirect.bind(_this);

    _this.state = {
      posts: [],
      loaded: false,
      question: null
    };
    return _this;
  }

  _createClass(FAQs, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Skip API calls during react-snap pre-rendering
      if (navigator.userAgent === 'ReactSnap') {
        this.setState({
          loaded: true,
          posts: {
            borrower: [{ id: 1, question: 'Loading...', answer: 'Loading...' }],
            owner: [{ id: 2, question: 'Loading...', answer: 'Loading...' }]
          },
          question: 1
        });
        return;
      }

      this.fetchFAQs();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (this.state.loaded && prevProps.type !== this.props.type) {
        setTimeout(function () {
          _this2.setState({
            question: _this2.state.posts[_this2.props.type][0].id
          });
        }, 50);
      }
    }
  }, {
    key: 'setQuestion',
    value: function setQuestion(faqID) {
      this.setState({ question: faqID });
    }
  }, {
    key: 'performLogout',
    value: function performLogout() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_user__["b" /* logout */])());
      this.props.history.push('/');
    }
  }, {
    key: 'performRedirect',
    value: function performRedirect(to) {
      this.props.history.push(to);
    }
  }, {
    key: 'loginModalOpenHandler',
    value: function loginModalOpenHandler() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
        login_modal_open: true
      }));
    }
  }, {
    key: 'fetchFAQs',
    value: function fetchFAQs() {
      var _this3 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationData__["g" /* getFAQs */])()).then(function (response) {
          _this3.setState({
            posts: response,
            loaded: true,
            question: response[_this3.props.type][0].id
          });

          _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        }, function (err) {
          console.log(err); // eslint-disable-line no-console
          _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
          _this3.props.history.push('/404');
        });
      });
    }
  }, {
    key: 'renderFAQs',
    value: function renderFAQs(data) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.faqs_container) },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.menu) },
          data.map(function (faq) {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              ScrollLink,
              {
                to: 'faq-container',
                smooth: true,
                duration: 800,
                offset: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].isMobile ? -80 : -180,
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.menu_trigger, _this4.state.question === faq.id ? styles.menu_trigger_active : null),
                onClick: function onClick() {
                  return _this4.setQuestion(faq.id);
                },
                key: 'faq-question-' + faq.id
              },
              faq.question
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          ScrollElement,
          { name: 'faq-container', className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.main) },
          data.map(function (faq) {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_17__components_FAQ__["a" /* default */],
              {
                id: faq.id,
                question: faq.question,
                visible: _this4.state.question === faq.id,
                key: 'faq-answer-' + faq.id
              },
              faq.answer
            );
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var pageTitle = this.props.type === 'borrower' ? 'FAQs for Dog Borrowers' : 'FAQs for Dog Owners';
      var pageDescription = this.props.type === 'borrower' ? 'Common questions about borrowing dogs through The Dog Share Collective. Learn about safety, matching, and getting started.' : 'Common questions for dog owners about sharing your dog. Learn about safety, vetting borrowers, and the sharing process.';

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__components_Body__["a" /* default */],
        { hasFooter: true },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_SEO__["a" /* default */], {
          title: pageTitle,
          description: pageDescription,
          keywords: 'dog sharing faq, frequently asked questions, dog borrowing, dog owner questions',
          url: 'https://www.thedogsharecollective.com/faqs-dog-' + this.props.type
        }),
        this.props.user.isAuthenticated ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_DashboardHeader__["a" /* default */], Object.assign({
          logoutHandler: this.logoutHandler,
          redirectHandler: this.redirectHandler
        }, this.props)) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_UnauthenticatedHeader__["a" /* default */], { openLoginHandler: this.openLoginHandler }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.heading_section) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__components_ContentContainer__["a" /* default */],
            { styles: styles.body_container },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'h1',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.heading) },
              'How can we help?'
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.tabs) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Link */],
                { to: '/faqs-dog-borrower' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  {
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.tab, this.props.type === 'borrower' ? styles.tab_active : null)
                  },
                  "I'm a borrower"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Link */],
                { to: '/faqs-dog-owner' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  {
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.tab, this.props.type === 'owner' ? styles.tab_active : null)
                  },
                  "I'm an owner"
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_16__components_ContentContainer__["a" /* default */],
          { styles: styles.container },
          this.state.loaded ? this.renderFAQs(this.state.posts[this.props.type]) : false
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Footer__["a" /* default */], { user: this.props.user })
      );
    }
  }]);

  return FAQs;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

FAQs.defaultProps = {
  type: 'borrower'
};

FAQs.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  faqs_container: _defineProperty({
    display: 'flex',
    padding: '60px 0 105px',
    lineHeight: '24px'
  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column'
  }),
  body_container: {
    paddingTop: 50
  },
  menu: {
    flexShrink: 0,
    width: 348,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].white
  },
  menu_trigger: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 60,
    width: '100%',
    padding: '0 27px',
    textAlign: 'left',
    fontSize: 16,
    fontFamily: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_weight_primary,
    color: '#000e1f',
    lineHeight: '1.1',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].white,
    border: 0,
    borderLeft: '8px solid #000e1f',
    outline: 'none',
    cursor: 'pointer',
    transition: 'all 300ms'
  },
  menu_trigger_active: {
    color: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].white,
    borderColor: '#f0f0f0',
    backgroundColor: '#000e1f'
  },
  main: _defineProperty({
    paddingLeft: 43
  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    padding: '40px 15px'
  }),
  container: {
    display: 'flex',
    padding: '60px 0 105px',
    lineHeight: '24px'
  },
  heading_section: {
    paddingTop: 74,
    backgroundColor: '#f9f9f9'
  },
  heading: {
    marginBottom: 42,
    lineHeight: 2.09,
    textAlign: 'center',
    fontSize: 45,
    fontFamily: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_weight_heading
  },
  tabs: {
    display: 'flex',
    justifyContent: 'center'
  },
  tab: {
    padding: '0 25px 17px',
    fontSize: 14,
    fontFamily: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_weight_secondary,
    letterSpacing: 1.9,
    lineHeight: 1.86,
    textTransform: 'uppercase',
    color: '#4a4a4a',
    backgroundColor: 'transparent',
    border: 0,
    borderBottom: '4px solid transparent',
    outline: 'none',
    cursor: 'pointer',
    transition: 'all 300ms',

    ':hover': {
      color: '#39b4d6',
      borderColor: '#39b4d6'
    }
  },
  tab_active: {
    color: '#39b4d6',
    borderColor: '#39b4d6'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_10__utils__["b" /* mapDispatchToProps */])(FAQs));

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AppDownloadInformation__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DogCard__ = __webpack_require__(37);
var _more, _cards;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var PLUS_ASSET = __webpack_require__(349);

var Favourites = function (_Component) {
  _inherits(Favourites, _Component);

  function Favourites(props) {
    _classCallCheck(this, Favourites);

    var _this = _possibleConstructorReturn(this, (Favourites.__proto__ || Object.getPrototypeOf(Favourites)).call(this, props));

    _this.state = {};

    _this.redirect = _this.redirectToFind.bind(_this);
    return _this;
  }

  _createClass(Favourites, [{
    key: 'redirectToFind',
    value: function redirectToFind() {
      this.props.history.push('/find');
    }
  }, {
    key: 'renderFavourites',
    value: function renderFavourites() {
      var favourites = this.props.user.favourites;
      return favourites ? favourites.map(function (favourite) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_DogCard__["a" /* default */], {
          id: favourite.id,
          image: favourite.image_url,
          name: favourite.name,
          breed: favourite.breed,
          status: 'favourite'
        });
      }) : false;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container) },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__components_ContentContainer__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h1',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.heading) },
            'My Favourites'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cards) },
            this.renderFavourites(),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { tabIndex: 0, role: 'button', onClick: this.redirect, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.more) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: PLUS_ASSET, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.more_icon) }),
              'Find more Dogs'
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_AppDownloadInformation__["a" /* default */], null)
          )
        )
      );
    }
  }]);

  return Favourites;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Favourites.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  more_icon: {
    display: 'block',
    marginBottom: 21,

    ':not(.a) > svg > g': {
      transition: 'all 300ms'
    }
  },
  more: (_more = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 262,
    minWidth: 262,
    padding: '100px 18px',
    margin: '0 15px 23px',
    backgroundColor: '#f2f2f2',
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#e8e8e8',
    fontSize: 15,
    color: '#39b4d6',
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_secondary,
    textTransform: 'uppercase',
    letterSpacing: 1.3,
    transition: 'all 300ms',
    cursor: 'pointer',

    ':hover': {
      color: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].white,
      backgroundColor: '#39b4d6'
    },

    ':hover > .isvg > svg > g': {
      fill: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].white
    }

  }, _defineProperty(_more, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }), _defineProperty(_more, '@media screen and (min-width: 625px) and (max-width: 768px)', {
    width: 262
  }), _more),
  actions: {
    margin: '0 -5px',

    '@media screen and (max-width: 1170px)': {
      display: 'flex',
      justifyContent: 'center'
    }
  },
  sort: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    fontSize: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_primary,
    marginBottom: 30
  },
  sort_select: {
    padding: 0,
    marginBottom: 0,
    marginLeft: 14,
    width: 135
  },
  cards: (_cards = {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -15px -15px'

  }, _defineProperty(_cards, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0 20px'
  }), _defineProperty(_cards, '@media screen and (max-width: 1170px)', {
    justifyContent: 'center'
  }), _cards),
  container: {
    paddingTop: 75,
    paddingBottom: 150
  },
  heading: {
    marginBottom: 60,
    textAlign: 'center',
    fontSize: 45,
    lineHeight: 2.09,
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_heading
  },
  title: {
    marginBottom: 30,
    textAlign: 'center',
    fontSize: 30,
    lineHeight: 1.17,
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_heading
  },
  sub_heading: {
    position: 'relative',
    width: '100%',
    padding: '0 5px',
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 400,
    fontSize: 18,
    color: '#000e1f',
    textAlign: 'center'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["g" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_7__utils__["b" /* mapDispatchToProps */])(Favourites)));

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_routes__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_search__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_DogCard__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_FindADog__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_GlobalMessage__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ShowMoreTrigger__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_SimpleSelect__ = __webpack_require__(29);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var Find = function (_Component) {
  _inherits(Find, _Component);

  function Find(props) {
    _classCallCheck(this, Find);

    var _this = _possibleConstructorReturn(this, (Find.__proto__ || Object.getPrototypeOf(Find)).call(this, props));

    _this.state = {
      sort: 'proximity',
      count: 0,
      page: 0,
      loaded: false,
      results: [],
      interests: _this.props.search.interests,
      needs: _this.props.search.needs,
      district: _this.props.search.district,
      suburb: _this.props.search.suburb,
      breeds: _this.props.search.breeds && _this.props.search.breeds.length ? _this.props.search.breeds.pop() : null,
      searchQuery: '',
      district_title: null,
      loaded_district_title: null,
      filterVisibleMob: false,
      nearestMe: true,
      maxDegrees: 5,
      isInitialSearch: true
    };

    _this.handleSearch = _this.doSearch.bind(_this);
    _this.loadNextPage = _this.doLoadMore.bind(_this);
    _this.handleInterests = _this.toggleInterest.bind(_this);
    _this.clearInterests = _this.clearInterests.bind(_this);
    _this.clearNeeds = _this.clearNeeds.bind(_this);
    _this.handleNeeds = _this.toggleNeeds.bind(_this);
    _this.handleDistrict = _this.setDistrict.bind(_this);
    _this.handleSuburb = _this.setSuburb.bind(_this);
    _this.handleBreeds = _this.setBreeds.bind(_this);
    _this.setValue = _this.updateField.bind(_this);
    _this.toggleNearestMe = _this.toggleNearestMe.bind(_this);
    // this.toggleMobFilter = this.toggleMobFilter.bind(this);

    _this.setSort = _this.setSort.bind(_this);

    // Debounce timer for search query
    _this.searchDebounceTimer = null;

    _this.sortOptions = [{
      label: 'Latest',
      value: 'latest'
    }, {
      label: 'Name',
      value: 'name'
    }, {
      label: 'Dog Size (smallest to largest)',
      value: 'dogsize-asc'
    }, {
      label: 'Dog Size (largest to smallest)',
      value: 'dogsize-desc'
    }];

    // Add proximity sort option when nearestMe is active
    _this.sortOptionsWithProximity = [].concat(_toConsumableArray(_this.sortOptions), [{
      label: 'Distance (nearest first)',
      value: 'proximity'
    }]);
    return _this;
  }

  _createClass(Find, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Redirect the user to verify if they do not have a verifications sent
      if (this.props.user.verified === false) {
        this.props.history.push('/join/verify');
      } else if (!this.props.user.completed_membership) {
        // Redirect the user to Membership if they do not have an active subscription
        this.props.history.push('/join/profile');
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isSubscriptionActive()) {
        this.doSearch(false, true);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Clear debounce timer on unmount
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }
    }
  }, {
    key: 'getResults',
    value: function getResults() {
      var _this2 = this;

      return this.state.results.length ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cards) },
        this.state.results.length ? this.state.results.map(function (dog) {
          var proximityText = _this2.state.nearestMe && dog.proximity_degree !== undefined ? dog.proximity_degree === 0 ? 'In your suburb' : dog.proximity_degree === 1 ? '1 suburb away' : dog.proximity_degree + ' suburbs away' : null;

          return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_DogCard__["a" /* default */], {
            key: dog.id || dog.dog_id,
            id: dog.id || dog.dog_id,
            image: dog.image_url,
            name: dog.name,
            breed: dog.breed,
            summary: dog.bio,
            interests: dog.interests,
            needs: dog.needs,
            suburb: dog.suburb,
            proximityText: proximityText
          });
        }) : false
      ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'h3',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.no_results) },
        'No dogs matched those filters!'
      );
    }
  }, {
    key: 'setDistrict',
    value: function setDistrict(name, district) {
      var _this3 = this;

      // If nearestMe is active, don't allow district selection
      if (this.state.nearestMe) {
        return;
      }

      this.setState({
        district: district ? district.value : null,
        district_title: district ? district.label : null,
        // Reset suburb when district changes
        suburb: null,
        suburb_title: null
      }, function () {
        // Automatically trigger search after state update
        _this3.doSearch();
      });
    }
  }, {
    key: 'setSuburb',
    value: function setSuburb(name, suburb) {
      var _this4 = this;

      // If nearestMe is active, don't allow suburb selection
      if (this.state.nearestMe) {
        return;
      }

      this.setState({
        suburb: suburb ? suburb.value : null,
        suburb_title: suburb ? suburb.label : null
      }, function () {
        // Automatically trigger search after state update
        _this4.doSearch();
      });
    }
  }, {
    key: 'setBreeds',
    value: function setBreeds(name, breed) {
      var _this5 = this;

      this.setState({
        breeds: breed ? breed.value : null
      }, function () {
        // Automatically trigger search after state update
        _this5.doSearch();
      });
    }
  }, {
    key: 'setSort',
    value: function setSort(key, value) {
      this.setState({
        sort: value
      });

      this.performSearch(this.state.searchQuery, this.state.interests, this.state.district, this.state.suburb, this.state.breeds, this.state.needs, this.state.page, value);
    }
  }, {
    key: 'updateField',
    value: function updateField(key, value) {
      var _this6 = this;

      this.setState(_defineProperty({}, key, value), function () {
        // If updating search query, debounce the search
        if (key === 'searchQuery') {
          // Clear existing timer
          if (_this6.searchDebounceTimer) {
            clearTimeout(_this6.searchDebounceTimer);
          }

          // Set new timer to trigger search after 500ms of no typing
          _this6.searchDebounceTimer = setTimeout(function () {
            _this6.doSearch();
          }, 500);
        }
      });
    }

    /**
     * Check if the user has an active subscription.
     * @NOTE: This should be split into a utility function
     * but the way that the store has been implemented would require refactoring.
     */

  }, {
    key: 'isSubscriptionActive',
    value: function isSubscriptionActive() {
      var user = this.props.user;


      if (!user) {
        return false;
      }

      var ACTIVE = user.active_subscription;


      return ACTIVE;
    }
  }, {
    key: 'doLoadMore',
    value: function doLoadMore() {
      this.performSearch(this.state.searchQuery, this.state.interests, this.state.district, this.state.suburb, this.state.breeds, this.state.needs, this.state.page + 1, this.state.sort);
    }
  }, {
    key: 'performSearch',
    value: function performSearch(query, interests, district, suburb, breeds, needs, page) {
      var _this7 = this;

      var sort = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
      var showLoading = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : true;

      // When nearestMe is active, don't send district/suburb
      var districtQuery = this.state.nearestMe ? null : district;
      var suburbQuery = this.state.nearestMe ? null : suburb;
      var breedsQuery = typeof breeds === 'number' ? [breeds] : null;
      var interestsQuery = interests && interests.length ? interests : null;
      var needsQuery = needs && needs.length ? needs : null;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
        loading: showLoading,
        loading_text: 'Fetching...'
      })).then(function () {
        _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__actions_search__["a" /* search */])(query, interestsQuery, districtQuery, suburbQuery, breedsQuery, needsQuery, page, 'search', sort, _this7.props.user.access_token, _this7.state.nearestMe, _this7.state.maxDegrees)).then(function (results) {
          // Check if this is the initial search and no results were found with nearestMe enabled
          var shouldRetryWithoutNearestMe = _this7.state.isInitialSearch && _this7.state.nearestMe && results.dogs.length === 0;

          if (shouldRetryWithoutNearestMe) {
            // Mark that we've completed the initial search attempt
            _this7.setState({ isInitialSearch: false, nearestMe: false }, function () {
              // Retry the search without nearestMe
              _this7.performSearch(query, interests, district, suburb, breeds, needs, page, 'latest', // Change sort to 'latest' when nearestMe is disabled
              false // Don't show loading again for the retry
              );
            });
          } else {
            setTimeout(function () {
              _this7.setState({
                loaded: true,
                results: page === 1 ? results.dogs : [].concat(_this7.state.results, results.dogs),
                count: results.count,
                page: results.page,
                loaded_district_title: _this7.state.district_title,
                filterVisibleMob: false,
                isInitialSearch: false // Mark initial search as complete
              });

              _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
                loading: false,
                loading_text: false
              }));
            }, 1500);
          }
        });
      });
    }
  }, {
    key: 'doSearch',
    value: function doSearch() {
      var showLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      document.body.classList.remove('scroll-locked');

      // If this is a manual search, ensure the flag is set to false
      if (!isInitial && this.state.isInitialSearch) {
        this.setState({ isInitialSearch: false });
      }

      this.performSearch(this.state.searchQuery, this.state.interests, this.state.district, this.state.suburb, this.state.breeds, this.state.needs, 1, this.state.sort, showLoading);
    }

    // toggleMobFilter() {
    //   if (this.state.filterVisibleMob) {
    //     document.body.classList.remove('scroll-locked');
    //   } else {
    //     document.body.classList.add('scroll-locked');
    //   }
    //
    //   this.setState({
    //     filterVisibleMob: !this.state.filterVisibleMob,
    //   });
    // }

  }, {
    key: 'toggleInterest',
    value: function toggleInterest(selected, interestID) {
      var _this8 = this;

      var newInterests = selected ? [].concat(this.state.interests, [interestID]) : this.state.interests.filter(function (interest) {
        return interest !== interestID;
      });

      this.setState({
        interests: newInterests
      }, function () {
        // Automatically trigger search after state update
        _this8.doSearch();
      });
    }
  }, {
    key: 'clearInterests',
    value: function clearInterests() {
      var _this9 = this;

      this.setState({
        interests: []
      }, function () {
        // Automatically trigger search after clearing
        _this9.doSearch();
      });
    }
  }, {
    key: 'toggleNeeds',
    value: function toggleNeeds(selected, needID) {
      var _this10 = this;

      var newNeeds = selected ? [].concat(this.state.needs, [needID]) : this.state.needs.filter(function (need) {
        return need !== needID;
      });

      this.setState({
        needs: newNeeds
      }, function () {
        // Automatically trigger search after state update
        _this10.doSearch();
      });
    }
  }, {
    key: 'clearNeeds',
    value: function clearNeeds() {
      var _this11 = this;

      this.setState({
        needs: []
      }, function () {
        // Automatically trigger search after clearing
        _this11.doSearch();
      });
    }
  }, {
    key: 'toggleNearestMe',
    value: function toggleNearestMe() {
      var _this12 = this;

      var newNearestMe = !this.state.nearestMe;

      this.setState({
        nearestMe: newNearestMe,
        // Clear district/suburb when enabling nearestMe
        district: newNearestMe ? null : this.state.district,
        suburb: newNearestMe ? null : this.state.suburb,
        // If enabling nearestMe and current sort is not supported, default to proximity
        sort: newNearestMe && this.state.sort === 'latest' ? 'proximity' : this.state.sort,
        // Mark that this is a manual action, not the initial search
        isInitialSearch: false
      }, function () {
        // Trigger search after state update
        _this12.doSearch();
      });
    }

    /**
     * Render a message if the subscription has expired.
     * @return {*}
     */

  }, {
    key: 'renderSubscriptionMessage',
    value: function renderSubscriptionMessage() {
      if (this.isSubscriptionActive()) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'p',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.reactivate_subscription) },
        'To find a dog, please re-activate your subscription. You can do so by navigating to your',
        ' ',
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* Link */],
          { to: __WEBPACK_IMPORTED_MODULE_7__config_routes__["a" /* ROUTES */].SETTINGS.MEMBERSHIP },
          'My Membership'
        ),
        ' tab.'
      );
    }

    /**
     * Render the filter form
     * @return {*}
     */

  }, {
    key: 'renderFilterForm',
    value: function renderFilterForm() {
      if (!this.isSubscriptionActive()) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        null,
        this.props.appdata.globalMessage.enabled ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.globalMessage) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_GlobalMessage__["a" /* default */], {
            title: this.props.appdata.globalMessage.title,
            message: this.props.appdata.globalMessage.message
          })
        ) : false,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.filters) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_FindADog__["a" /* default */], Object.assign({}, this.props, {
            interests: this.state.interests,
            breeds: this.state.breeds,
            district: this.state.district,
            suburb: this.state.suburb,
            needs: this.state.needs,
            nearestMe: this.state.nearestMe,
            handleSearch: this.handleSearch,
            handleInterests: this.handleInterests,
            clearInterests: this.clearInterests,
            handleNeeds: this.handleNeeds,
            handleSearchQuery: this.setValue,
            searchQuery: this.state.searchQuery,
            clearNeeds: this.clearNeeds,
            handleBreeds: this.handleBreeds,
            handleDistrict: this.handleDistrict,
            handleSuburb: this.handleSuburb,
            mobFilterVisible: this.state.filterVisibleMob
          }))
        ),
        this.state.loaded ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.actions) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.nearest_me_container) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'label',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.nearest_me_label), htmlFor: 'nearest-me-checkbox' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', {
                type: 'checkbox',
                id: 'nearest-me-checkbox',
                checked: this.state.nearestMe,
                onChange: this.toggleNearestMe,
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.nearest_me_checkbox)
              }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'span',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.nearest_me_text) },
                'Dogs nearest me'
              )
            )
          ),
          this.state.results.length ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.sort) },
            'Sort by',
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_SimpleSelect__["a" /* default */], {
              id: 'Sort',
              name: 'Sort',
              label: 'Sort',
              hideLabel: true,
              fullWidth: true,
              value: this.state.sort,
              handler: this.setSort,
              options: this.state.nearestMe ? this.sortOptionsWithProximity : this.sortOptions,
              styles: styles.sort_select
            })
          ) : null
        ) : null,
        this.state.loaded ? this.getResults() : false
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container) },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__components_ContentContainer__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h1',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.heading) },
            'Find a dog'
          ),
          this.renderSubscriptionMessage(),
          this.renderFilterForm()
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.more) },
          this.state.results.length && this.state.results.length < this.state.count ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_ShowMoreTrigger__["a" /* default */], { handler: this.loadNextPage }) : false
        )
      );
    }
  }]);

  return Find;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    padding: '100px 0 0',
    minHeight: '80vh'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    padding: '80px 0 0'
  }),
  heading: _defineProperty({
    marginBottom: 45,
    textAlign: 'center',
    fontSize: 45,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_heading

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 28
  }),
  globalMessage: {
    marginBottom: 25
  },
  filters: {
    marginBottom: 15
  },
  actions: _defineProperty({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 30,
    marginTop: 30,
    paddingLeft: 15,
    paddingRight: 15

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column',
    alignItems: 'flex-start'
  }),
  mob_find: {
    display: 'block',
    width: '100vw',
    height: 50,
    margin: '0 -15px 30px',
    textTransform: 'uppercase',
    fontSize: 15,
    fontWeight: 900,
    lineHeight: 1.73,
    letterSpacing: 2,
    textAlign: 'center',
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].primary,
    border: 0,
    borderTop: '1px solid #cecece',
    borderBottom: '1px solid #cecece',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 300ms'
  },
  location: {
    fontWeight: 'bold',
    fontSize: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary
  },
  sort: _defineProperty({
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_primary,
    color: '#828282',
    marginLeft: 'auto'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    marginLeft: 0,
    marginTop: 15
  }),
  sort_select: {
    padding: 0,
    marginBottom: 0,
    marginLeft: 14,
    width: 200
  },
  cards: _defineProperty({
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    margin: '0 -15px'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0 20px'
  }),
  more: _defineProperty({
    position: 'relative',
    height: 120,
    marginTop: 85,
    marginBottom: 85
  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    marginTop: 40,
    marginBottom: 0
  }),
  no_results: {
    marginTop: 55,
    textAlign: 'center',
    fontSize: 28,
    marginBottom: 50,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_heading
  },
  reactivate_subscription: {
    textAlign: 'center',
    padding: 30,
    marginBottom: 30
  },
  nearest_me_container: {
    display: 'flex',
    alignItems: 'center'
  },
  nearest_me_label: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: 16,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_secondary,
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].black
  },
  nearest_me_checkbox: {
    width: 20,
    height: 20,
    marginRight: 10,
    cursor: 'pointer'
  },
  nearest_me_text: {
    userSelect: 'none'
  }
});

Find.propTypes = {
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].array,
  appdata: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object
};

Find.defaultProps = {
  search: [],
  appdata: {}
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* mapDispatchToProps */])(Find));

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DashboardHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_UnauthenticatedHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Body__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_TextField__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable */
















var styles = void 0;
var BACKGROUND_ASSET = __webpack_require__(606);

var Contact = function (_Component) {
  _inherits(Contact, _Component);

  function Contact(props) {
    _classCallCheck(this, Contact);

    var _this = _possibleConstructorReturn(this, (Contact.__proto__ || Object.getPrototypeOf(Contact)).call(this, props));

    _this.state = {
      email: _this.props.user.email,
      forgotPassword: false,
      passwordReset: false,
      errorMessage: false,
      token: null
    };

    _this.openLoginHandler = _this.loginModalOpenHandler.bind(_this);
    _this.logoutHandler = _this.performLogout.bind(_this);
    _this.redirectHandler = _this.performRedirect.bind(_this);
    _this.forgotPassword = _this.forgotPasswordHandler.bind(_this);
    _this.resetPassword = _this.resetPasswordHandler.bind(_this);
    _this.setValue = _this.updateTextField.bind(_this);
    return _this;
  }

  _createClass(Contact, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        token: this.findGetParameter('token'),
        member_id: this.findGetParameter('id')
      });
    }
  }, {
    key: 'updateTextField',
    value: function updateTextField(key, value) {
      this.setState(_defineProperty({}, key, value));
    }
  }, {
    key: 'performLogout',
    value: function performLogout() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_user__["b" /* logout */])());
      this.props.history.push('/');
    }
  }, {
    key: 'performRedirect',
    value: function performRedirect(to) {
      this.props.history.push(to);
    }
  }, {
    key: 'loginModalOpenHandler',
    value: function loginModalOpenHandler() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
        login_modal_open: true
      }));
    }
  }, {
    key: 'loginModalOpenHandler',
    value: function loginModalOpenHandler() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
        login_modal_open: true
      }));
    }
  }, {
    key: 'forgotPasswordHandler',
    value: function forgotPasswordHandler(e) {
      var _this2 = this;

      e.preventDefault();

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
        loading: true,
        loading_text: 'Sending...'
      })).then(function () {

        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_user__["p" /* sendForgotPasswordRequest */])({
          email: _this2.state.email
        })).then(function (response) {

          console.log('sendForgotPasswordRequest response', response);

          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));

          if (response.status === 200) {
            _this2.setState({
              forgotPassword: true
            });
          } else {

            _this2.setState({
              forgotPassword: false,
              errorMessage: response.data.error
            });
          }
        });
      });
    }
  }, {
    key: 'resetPasswordHandler',
    value: function resetPasswordHandler(e) {
      var _this3 = this;

      e.preventDefault();

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
        loading: true,
        loading_text: 'Sending...'
      })).then(function () {

        _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_user__["q" /* sendResetPasswordRequest */])({
          token: _this3.state.token,
          password: _this3.state.password,
          id: _this3.state.member_id
        })).then(function (response) {

          console.log('resetPasswordHandler response', response);

          _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));

          if (response.status === 200) {
            _this3.setState({
              resetPassword: true
            });
          } else {
            _this3.setState({
              resetPassword: false,
              errorMessage: response.data.error
            });
          }
        });
      });
    }
  }, {
    key: 'findGetParameter',
    value: function findGetParameter(parameterName) {
      var result = null,
          tmp = [];
      var items = location.search.substr(1).split("&");
      for (var index = 0; index < items.length; index++) {
        tmp = items[index].split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      }
      return result;
    }
  }, {
    key: 'resetForm',
    value: function resetForm() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.form) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.title) },
          'Reset your password'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.content) },
          'Enter your new password below.'
        ),
        this.state.errorMessage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.error_box, styles.form_error) },
          this.state.errorMessage
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_TextField__["a" /* default */], {
          id: 'password',
          name: 'password',
          label: 'Password',
          type: 'password',
          value: this.state.password,
          handler: this.setValue
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_TextField__["a" /* default */], {
          id: 'confirm_password',
          name: 'confirm_password',
          label: 'Confirm Password',
          type: 'password',
          value: this.state.confirm_password,
          handler: this.setValue
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.submit_container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.submit),
              onClick: this.resetPassword },
            'Submit'
          )
        )
      );
    }
  }, {
    key: 'forgotForm',
    value: function forgotForm() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.form) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.title) },
          'Forgot your password?'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.content) },
          'Enter your email below.'
        ),
        this.state.errorMessage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.error_box, styles.form_error) },
          this.state.errorMessage
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_TextField__["a" /* default */], {
          id: 'email',
          name: 'email',
          label: 'Email',
          value: this.state.email,
          handler: this.setValue,
          email: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.submit_container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.submit, styles.login),
              onClick: this.forgotPassword },
            'Submit'
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__components_Body__["a" /* default */],
        { hasFooter: true },
        this.props.user.isAuthenticated ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_DashboardHeader__["a" /* default */], Object.assign({
          logoutHandler: this.logoutHandler,
          redirectHandler: this.redirectHandler
        }, this.props)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_UnauthenticatedHeader__["a" /* default */], { openLoginHandler: this.openLoginHandler }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.container) },
          this.state.resetPassword || this.state.forgotPassword ? this.state.resetPassword ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.contact_box) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h1',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.title) },
              'Your password has been reset!'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.content) },
              'You can now login with your new password.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.submit, styles.login),
                onClick: this.openLoginHandler },
              'Login now'
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.contact_box) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h1',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.title) },
              'We\'ve sent you an email.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.content) },
              'Click the link that we\'ve sent you in order to reset your password'
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.contact_box) },
            this.state.token && this.state.member_id ? this.resetForm() : this.forgotForm()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer__["a" /* default */], this.props)
      );
    }
  }]);

  return Contact;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Contact.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

styles = __WEBPACK_IMPORTED_MODULE_3_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    display: 'flex',
    alignItems: 'center',
    minHeight: 'calc(100vh - 240px)',
    paddingTop: 127,
    paddingBottom: 91,
    backgroundImage: 'url(\'' + BACKGROUND_ASSET + '\')',
    backgroundSize: 'cover',
    backgroundPosition: 'center'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    marginTop: 80,
    paddingTop: 209,
    paddingBottom: 0,
    backgroundPosition: 'top center',
    backgroundSize: 'auto 209px',
    backgroundImage: 'url(/images/contact_bg_mob.jpg)'
  }),
  error_box: {
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].red,
    paddingBottom: 40
  },
  form_error: {
    width: '100%'
  },
  contact_box: _defineProperty({
    width: 760,
    margin: '0 auto',
    padding: 60,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    padding: '60px 20px'
  }),
  title: {
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_heading,
    fontSize: 30,
    lineHeight: 1.17,
    color: '#262626',
    textAlign: 'center'
  },
  content: _defineProperty({
    width: 631,
    margin: '0 auto 50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 20,
    fontWeight: 500,
    lineHeight: 1.4,
    textAlign: 'center',
    color: '#000e1f'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 -5px'
  },
  submit_container: {
    width: '100%',
    padding: '0 5px',
    textAlign: 'right',
    marginTop: 10
  },
  submit: _defineProperty({
    width: 206,
    height: 50,
    textTransform: 'uppercase',
    fontSize: 15,
    fontWeight: 900,
    lineHeight: 1.73,
    letterSpacing: 2,
    textAlign: 'center',
    color: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    borderRadius: 5,
    border: 0,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].primary,
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 300ms',

    ':hover': {
      backgroundColor: '#61c3df'
    }

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  login: {
    textAlign: 'center',
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* mapDispatchToProps */])(Contact));

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AsSeenOnTV__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Body__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Charities__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Community__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_HomepageFeaturedDogs__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_HomepageHero__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_HomepageInspiration__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_PromoSearch__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_SEO__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_StructuredData__ = __webpack_require__(210);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




 // Imports all Mixins
















var scroll = __WEBPACK_IMPORTED_MODULE_3_react_scroll__["animateScroll"];

var Home = function (_Component) {
  _inherits(Home, _Component);

  function Home(props) {
    _classCallCheck(this, Home);

    var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));

    _this.handleScroll = _this.scrollDown.bind(_this);
    _this.state = {
      login_modal_open: false
    };
    return _this;
  }

  _createClass(Home, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var searchParams = new URLSearchParams(this.props.location.search);
      var backURL = searchParams.get('backURL');

      if (backURL === 'settings/account' && !this.props.user.isAuthenticated) {
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions_applicationState__["a" /* updateAppState */])({
          login_modal_open: true
        }));
      }
      if (this.props.user.isAuthenticated && backURL) {
        this.props.history.push('/' + backURL);
      }
    }
  }, {
    key: 'scrollDown',
    value: function scrollDown() {
      scroll.scrollTo(window.innerHeight);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__components_Body__["a" /* default */],
        { hasFooter: true },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_SEO__["a" /* default */], {
          title: 'Find Local Dogs to Walk, Play With & Share',
          description: 'Connect with dog owners in your area for dog walking, playdates, and ' + 'companionship. Join The Dog Share Collective - where dog lovers meet dogs who need love.',
          keywords: 'dog sharing, dog walking, dog sitting, pet sharing, dog borrowing, local dogs',
          url: 'https://www.thedogsharecollective.com/'
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_StructuredData__["a" /* default */], { data: __WEBPACK_IMPORTED_MODULE_16__components_StructuredData__["b" /* organizationSchema */] }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_StructuredData__["a" /* default */], { data: __WEBPACK_IMPORTED_MODULE_16__components_StructuredData__["c" /* websiteSchema */] }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_HomepageHero__["a" /* default */], {
          user: this.props.user,
          scrollHandler: this.handleScroll,
          dispatch: this.props.dispatch
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_PromoSearch__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_HomepageFeaturedDogs__["a" /* default */], this.props),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_scroll__["Element"],
          { name: 'homepage-inspiration-1' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_HomepageInspiration__["a" /* default */], {
            position: 1,
            description: 'How it works',
            title: 'People who have dogs',
            text: ' Dog Owners profile their dog\'s doggie interests and companionship needs for trusted dog-lovers to review. '
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_HomepageInspiration__["a" /* default */], {
          position: 2,
          description: '',
          title: 'Share their dogs',
          text: ' Dogs wait for compatible local dog-lovers to seek them out for dog walking, adventures or home hangs together, or to hook up with other local dogs for more dog-time. '
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_HomepageInspiration__["a" /* default */], {
          position: 3,
          description: 'With',
          title: 'People who can\'t have dogs',
          text: ' Dog Borrowers request matches and connect direct. Dog Owners start enriching their dog\'s life through dog sharing, enjoy peace of mind and save thousands. Dog Borrowers enjoy sharing their company with a dog. '
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Community__["a" /* default */], { dispatch: this.props.dispatch }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Charities__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_AsSeenOnTV__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Footer__["a" /* default */], { user: this.props.user })
      );
    }
  }]);

  return Home;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Home.propTypes = {
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types__["PropTypes"].func.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_0_prop_types__["PropTypes"].object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types__["PropTypes"].object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_0_prop_types__["PropTypes"].object.isRequired
  // appdata: PropTypes.object.isRequired,
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* mapDispatchToProps */])(Home));

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_EditProfileSummary__ = __webpack_require__(98);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var ARROW = __webpack_require__(607);

var JoinComplete = function (_Component) {
  _inherits(JoinComplete, _Component);

  function JoinComplete(props) {
    _classCallCheck(this, JoinComplete);

    var _this = _possibleConstructorReturn(this, (JoinComplete.__proto__ || Object.getPrototypeOf(JoinComplete)).call(this, props));

    _this.state = {
      active: false,
      completed: false,
      adding: false
    };
    return _this;
  }

  _createClass(JoinComplete, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          active: true
        });
      }, 0);
    }
  }, {
    key: 'getUserImage',
    value: function getUserImage() {
      var user = this.props.user;

      if (user.image_url && user.image_url.length > 10) {
        return user.image_url;
      }

      if (user.profile_photo && user.profile_photo.length > 10) {
        return user.profile_photo;
      }

      return '/images/default_profile.jpg';
    }
  }, {
    key: 'getDogImage',
    value: function getDogImage(dog) {
      if (dog.image_url && dog.image_url.length > 10) {
        return dog.image_url;
      }

      if (dog.profile_photo && dog.profile_photo.length > 10) {
        return dog.profile_photo;
      }

      return '/images/default_dog.jpg';
    }
  }, {
    key: 'getDogs',
    value: function getDogs() {
      var _this3 = this;

      return this.props.user.dogs.map(function (dog) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_EditProfileSummary__["a" /* default */], {
          id: dog.id,
          image_url: _this3.getDogImage(dog),
          name: dog.name,
          breed: dog.breed });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var hasDogs = this.props.user.subscription === 'Owner' && this.props.user.dogs && this.props.user.dogs.length;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.container, this.state.active ? styles.container_active : null, this.state.completed ? styles.container_completed : null) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__components_ContentContainer__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.heading) },
            'Nice! Your',
            hasDogs ? ' dog\'s' : false,
            ' profile has been updated'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.sub_heading) },
            'You can update ',
            hasDogs ? 'their' : 'your',
            ' info at anytime via this menu',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
              src: ARROW,
              className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.arrow),
              alt: 'Your can update your dog any time via this menu' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.main) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.profiles) },
              hasDogs ? this.getDogs() : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_EditProfileSummary__["a" /* default */], {
                dog: false,
                id: this.props.user.id,
                image_url: this.getUserImage(),
                name: this.props.user.display_name })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.actions) },
              this.props.user.subscription === 'Owner' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Link */],
                {
                  to: '/join/pooch',
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.draft),
                  onClick: this.saveDraft },
                'Add ',
                hasDogs ? 'another' : 'a',
                ' pooch'
              ) : false,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Link */],
                {
                  to: '/shares',
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.publish),
                  onClick: this.savePublish },
                'Go to my dog shares'
              )
            )
          )
        )
      );
    }
  }]);

  return JoinComplete;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

JoinComplete.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].object.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_4_aphrodite__["StyleSheet"].create({
  container: {
    padding: '86px 0 ' + __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].footer.height + 'px',
    transition: 'transform 500ms',
    transform: 'translateX(100vw)'
  },
  container_active: {
    transform: 'translateX(0)'
  },
  container_completed: {
    transform: 'translateX(-100vw)'
  },
  main: _defineProperty({
    width: 750,
    margin: '0 auto'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  arrow: _defineProperty({
    position: 'absolute',
    top: -108,
    right: 120,
    maxWidth: 178,
    maxHeight: 108

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    display: 'none'
  }),
  heading: {
    marginBottom: 30,
    textAlign: 'center',
    fontSize: 30,
    lineHeight: 1.17,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_heading
  },
  sub_heading: {
    position: 'relative',
    width: '100%',
    padding: '0 5px',
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 400,
    fontSize: 18,
    color: '#000e1f',
    textAlign: 'center'
  },
  actions: _defineProperty({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column'
  }),
  draft: _defineProperty({
    width: 340,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_secondary,
    color: '#39b4d6',
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    cursor: 'pointer',
    outline: 'none',
    textAlign: 'center'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  publish: _defineProperty({
    width: 340,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_secondary,
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: '#56C5FF',
    cursor: 'pointer',
    outline: 'none',
    textAlign: 'center'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  })
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* mapDispatchToProps */])(JoinComplete));

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable */








var CHECK_ASSET = __webpack_require__(350);
var DOG_ASSET = __webpack_require__(351);

var JoinContainer = function (_Component) {
  _inherits(JoinContainer, _Component);

  function JoinContainer(props) {
    _classCallCheck(this, JoinContainer);

    var _this = _possibleConstructorReturn(this, (JoinContainer.__proto__ || Object.getPrototypeOf(JoinContainer)).call(this, props));

    _this.state = {};
    _this.logoutHandler = _this.performLogout.bind(_this);
    _this.redirectHandler = _this.performRedirect.bind(_this);
    return _this;
  }

  _createClass(JoinContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.user.isAuthenticated) {
        this.props.history.push('/find');
      }
    }
  }, {
    key: 'performLogout',
    value: function performLogout() {
      this.props.dispatch(logout());
      this.props.history.push('/');
    }
  }, {
    key: 'performRedirect',
    value: function performRedirect(to) {
      this.props.history.push(to);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.container) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.header_container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.links) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
              {
                to: '/join/subscription',
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item, styles.nav_item_active) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item_num, this.props.step > 1 ? styles.nav_item_num_complete : null) },
                '1'
              ),
              'Subscription',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.dog_icon, this.props.step === 1 ? styles.dog_icon_visible : null) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
              {
                to: this.props.step > 1 ? '/join/details' : false,
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item, this.props.step > 1 ? styles.nav_item_active : null) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item_num, this.props.step > 2 ? styles.nav_item_num_complete : null) },
                '2'
              ),
              'My Details',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.dog_icon, this.props.step === 2 ? styles.dog_icon_visible : null) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
              {
                to: this.props.step > 2 ? '/join/payment' : false,
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item, this.props.step > 2 ? styles.nav_item_active : null) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item_num, this.props.step > 3 ? styles.nav_item_num_complete : null) },
                '3'
              ),
              'Payment',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.dog_icon, this.props.step === 3 ? styles.dog_icon_visible : null) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
              {
                to: this.props.step > 3 ? '/join/profile' : false,
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item, this.props.step > 3 ? styles.nav_item_active : null) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item_num) },
                '4'
              ),
              'Set up Account',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.dog_icon, this.props.step === 4 ? styles.dog_icon_visible : null) })
            )
          )
        ),
        this.props.children
      );
    }
  }]);

  return JoinContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var styles = __WEBPACK_IMPORTED_MODULE_3_aphrodite__["StyleSheet"].create({
  container: {},
  header_container: _defineProperty({
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    borderTop: 'solid 1px #bfbfbf',
    borderBottom: 'solid 1px #bfbfbf',
    height: 107,

    ':before': {
      height: '100%',
      flexGrow: 1,
      backgroundColor: '#021a36',
      content: '""'
    },

    ':after': {
      flexGrow: 1,
      content: '""'
    }

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    display: 'none'
  }),
  title: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 45,
    textAlign: 'center',
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].black,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_heading
  },
  links: {
    display: 'flex',
    maxWidth: '100%',
    width: 1070,
    height: '100%'
  },
  nav_item: {
    flexGrow: 1,
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    textTransform: 'uppercase',
    textAlign: 'center',
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_secondary,
    fontSize: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_size_secondary,
    letterSpacing: 1,
    color: '#bbbbbb',
    transition: 'all 500ms 500ms ease-in-out',

    ':before': {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: -1,
      height: '100%',
      width: 0,
      backgroundColor: '#021a36',
      content: '""',
      transition: 'width 500ms 0ms'
    }
  },
  dog_icon: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(50%,-50%)',
    width: 45,
    height: 39,
    backgroundImage: 'url(\'' + DOG_ASSET + '\')',
    backgroundSize: 'cover',
    opacity: 0
  },
  dog_icon_visible: {
    opacity: 1
  },
  nav_item_active: {
    zIndex: 2,
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,

    ':before': {
      width: '100%'
    },

    ':not(.d) > div': {
      color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
      borderColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white
    }
  },
  nav_item_num: {
    position: 'relative',
    height: 28,
    width: 28,
    lineHeight: '23px',
    textAlign: 'center',
    marginBottom: 12,
    border: 'solid 2.5px #bbbbbb',
    color: '#bbbbbb',
    borderRadius: '50%',
    overflow: 'hidden',
    transition: 'all 300ms',

    ':before': {
      position: 'absolute',
      top: 0,
      left: 0,
      display: 'block',
      height: '100%',
      width: '100%',
      backgroundImage: 'url(' + CHECK_ASSET + ')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: '0 0',
      content: '""'
    }
  },
  nav_item_num_complete: {
    ':not(.d):not(.c)': { // specificity hack...
      color: 'transparent',
      borderColor: '#39b4d6',
      backgroundColor: '#39b4d6'
    },

    ':before': {
      backgroundSize: '14px 13px'
    }
  }
});

JoinContainer.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};

JoinContainer.defaultProps = {
  children: []
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["g" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* mapDispatchToProps */])(JoinContainer)));

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_facebook_login__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_facebook_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_facebook_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_HorizontalRule__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_TextField__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_CheckboxField__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Select__ = __webpack_require__(46);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// import AvatarEditor from 'react-avatar-editor';











var JoinDetails = function (_Component) {
  _inherits(JoinDetails, _Component);

  function JoinDetails(props) {
    _classCallCheck(this, JoinDetails);

    var _this = _possibleConstructorReturn(this, (JoinDetails.__proto__ || Object.getPrototypeOf(JoinDetails)).call(this, props));

    _this.continue = _this.continue.bind(_this);
    _this.state = {
      selected: 'owner',
      active: false,
      completed: false,

      first_name: props.user.first_name,
      last_name: props.user.last_name,
      email: props.user.email,
      phone: props.user.phone,
      suburb: props.user.suburb,
      password: props.user.password,
      confirmed_password: props.user.confirmed_password,
      newsletter: props.user.newsletter,
      dogs_in_area: props.user.dogs_in_area,
      accepted_terms: props.user.accepted_terms,
      facebook_token: props.user.facebook_token,
      fb_id: props.user.fb_id,

      errors: {
        first_name: false,
        last_name: false,
        email: false,
        phone: false,
        suburb: false,
        password: false,
        confirmed_password: false,
        newsletter: false,
        dogs_in_area: false,
        accepted_terms: false
      }
    };

    _this.setValue = _this.updateTextField.bind(_this);
    _this.facebookCallback = _this.facebookResponse.bind(_this);
    return _this;
  }

  _createClass(JoinDetails, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          active: true
        });
      }, 10);
    }

    // Handle "email already exists" error

  }, {
    key: 'getEmailError',
    value: function getEmailError() {
      if (this.state.errors.email) {
        return this.state.errors.email;
      } else if (this.props.location && this.props.location.state && this.props.location.state.error) {
        // If the user hasn't changed the value, then this error should persist.
        if (this.state.email === this.props.location.state.value) {
          return this.props.location.state.message;
        }
      }

      return false;
    }

    // Validate the form

  }, {
    key: 'validateForm',
    value: function validateForm() {
      var errors = {};

      if (!this.state.first_name || !this.state.first_name.length > 0) {
        errors.first_name = 'Please enter your first name';
      } else {
        errors.first_name = null;
      }

      if (!this.state.last_name || !this.state.last_name.length > 0) {
        errors.last_name = 'Please enter your last name';
      } else {
        errors.last_name = null;
      }

      if (!this.state.email || !this.state.email.length > 0) {
        errors.email = 'Please enter your email address';
      } else {
        errors.email = null;
      }

      if (!this.state.phone || !this.state.phone.length > 0) {
        errors.phone = 'Please enter your phone number';
      } else {
        errors.phone = null;
      }

      if (!this.state.facebook_token) {
        if (!this.state.password) {
          errors.password = 'Please enter a password';
        } else {
          errors.password = null;
        }

        if (this.state.password) {
          if (this.state.password.length < 8) {
            errors.password = 'Password must be at least 8 characters.';
          } else {
            errors.password = null;
          }

          var hasNumber = /\d/;
          if (!hasNumber.test(this.state.password)) {
            errors.password = 'Password must contain at least one number.';
          } else if (!errors.password) {
            errors.password = null;
          }
        }

        if (!this.state.confirmed_password) {
          errors.confirmed_password = 'Please repeat your password';
        } else if (this.state.confirmed_password !== this.state.password) {
          errors.confirmed_password = 'Your passwords do not match';
        } else {
          errors.confirmed_password = null;
        }
      }

      if (!this.state.suburb) {
        errors.suburb = 'Please select a suburb';
      } else {
        errors.suburb = null;
      }

      if (!this.state.accepted_terms) {
        errors.accepted_terms = 'You must read and accept the Terms of Service.';
      } else {
        errors.accepted_terms = null;
      }

      var formErrors = false;

      for (var key in errors) {
        //eslint-disable-line
        if (errors[key] !== null) {
          formErrors = true;
        }
      }

      if (formErrors) {
        this.setState({
          errors: errors
        });

        return false;
      }

      return true;
    }
  }, {
    key: 'continue',
    value: function _continue(history) {
      if (this.validateForm()) {
        var signupFields = {
          first_name: this.state.first_name,
          last_name: this.state.last_name,
          email: this.state.email,
          phone: this.state.phone,
          suburb: this.state.suburb ? this.state.suburb.value : null,
          newsletter: this.state.newsletter,
          dogs_in_area: this.state.dogs_in_area,
          accepted_terms: this.state.accepted_terms,
          password: this.state.password,
          confirmed_password: this.state.confirmed_password
        };

        if (this.state.facebook_token) {
          signupFields.facebook_token = this.state.facebook_token;
          signupFields.fb_id = this.state.fb_id;
        }

        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_user__["c" /* updateUser */])(signupFields));

        this.setState({
          completed: true
        }, function () {
          setTimeout(function () {
            history.push('/join/payment');
          }, 500);
        });
      }
    }
  }, {
    key: 'facebookResponse',
    value: function facebookResponse(response) {
      if (response && response.accessToken) {
        this.setState({
          first_name: response.first_name,
          last_name: response.last_name,
          email: response.email,
          facebook_token: response.accessToken,
          fb_id: response.id
        });
      }
    }
  }, {
    key: 'updateTextField',
    value: function updateTextField(key, value) {
      var _this3 = this;

      var updatedState = _defineProperty({}, key, value);

      this.setState(updatedState);

      setTimeout(function () {
        if (_this3.state.errors[key]) {
          // If there is an error against this field, attempt to revalidate
          _this3.validateForm();
        }
      }, 10);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var Continue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(function (_ref) {
        var history = _ref.history;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.continue),
            onClick: function onClick() {
              _this4.continue(history);
            }
          },
          'Continue'
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.container, this.state.active ? styles.container_active : styles.container_inactive, this.state.completed ? styles.container_completed : null) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.main) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.heading) },
            'Your membership details'
          ),
          !this.state.facebook_token ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_facebook_login___default.a, {
            appId: '727162037485391',
            autoLoad: false,
            fields: 'first_name,last_name,email,picture',
            callback: this.facebookCallback,
            cssClass: 'facebook-login-button',
            textButton: false,
            isMobile: false,
            icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.facebook) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.facebook_btn) },
                'Sign up with Facebook'
              )
            )
          }) : false,
          !this.state.facebook_token ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.or_label) },
            'Or'
          ) : false,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_HorizontalRule__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.form) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_TextField__["a" /* default */], {
              id: 'first_name',
              name: 'first_name',
              label: 'First Name',
              value: this.state.first_name,
              handler: this.setValue,
              error: this.state.errors.first_name
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_TextField__["a" /* default */], {
              id: 'last_name',
              name: 'last_name',
              label: 'Last Name',
              value: this.state.last_name,
              handler: this.setValue,
              error: this.state.errors.last_name
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_TextField__["a" /* default */], {
              id: 'email',
              name: 'email',
              label: 'Email',
              email: true,
              value: this.state.email,
              handler: this.setValue,
              error: this.getEmailError()
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_TextField__["a" /* default */], {
              id: 'phone',
              name: 'phone',
              label: 'Phone number - this will not be public',
              value: this.state.phone,
              handler: this.setValue,
              error: this.state.errors.phone
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.select_parent_container) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.select_field_container) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Select__["a" /* default */], {
                  id: 'suburb',
                  name: 'suburb',
                  options: this.props.appdata.suburb.map(function (suburb) {
                    return {
                      value: suburb.id,
                      label: suburb.title + ', ' + suburb.district.title
                    };
                  }),
                  label: 'Suburb',
                  required: true,
                  value: this.state.suburb,
                  type: 'location',
                  handler: this.setValue,
                  style: styles.select_style
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            !this.state.facebook_token ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_TextField__["a" /* default */], {
              id: 'password',
              name: 'password',
              type: 'password',
              label: 'Password',
              value: this.state.password,
              handler: this.setValue,
              error: this.state.errors.password
            }) : false,
            !this.state.facebook_token ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_TextField__["a" /* default */], {
              id: 'confirmed_password',
              name: 'confirmed_password',
              type: 'password',
              label: 'Re-Type Password',
              value: this.state.confirmed_password,
              handler: this.setValue,
              error: this.state.errors.confirmed_password
            }) : false,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_CheckboxField__["a" /* default */], {
              id: 'newsletter',
              name: 'newsletter',
              label: 'I want to sign up to email updates',
              value: this.state.newsletter,
              handler: this.setValue,
              fullWidth: true
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_CheckboxField__["a" /* default */], {
              id: 'accepted_terms',
              name: 'accepted_terms',
              label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                'I accept The Dog Share Collective',
                '\'',
                's\xA0',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    href: '/terms',
                    target: '_blank',
                    rel: 'noopener noreferrer' },
                  'Terms of Service'
                ),
                '.'
              ),
              value: this.state.accepted_terms,
              handler: this.setValue,
              fullWidth: true,
              error: this.state.errors.accepted_terms
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_HorizontalRule__["a" /* default */], null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.actions) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Continue, null)
          )
        )
      );
    }
  }]);

  return JoinDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var styles = __WEBPACK_IMPORTED_MODULE_4_aphrodite__["StyleSheet"].create({
  or_label: {
    display: 'block',
    margin: '15px 0 -20px',
    textAlign: 'center',
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_secondary,
    color: '#a5a5a5',
    textTransform: 'uppercase',
    fontSize: 13,
    letterSpacing: 1.8
  },
  facebook_btn: {
    display: 'block',
    width: '100%',
    maxWidth: 340,
    height: 50,
    margin: '0 auto',
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_secondary,
    color: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: '#1a488f',
    cursor: 'pointer',
    outline: 'none'
  },
  container: _defineProperty({
    padding: '86px 0 ' + __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].footer.height + 'px',
    transition: 'transform 500ms',
    transform: 'translateX(100vw)'

  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    padding: '50px 0'
  }),
  container_active: {
    transform: 'translateX(0)'
  },
  container_inactive: {
    display: 'none'
  },
  container_completed: {
    transform: 'translateX(-100vw)'
  },
  main: _defineProperty({
    width: 750,
    margin: '0 auto'

  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    padding: '0 15px'
  }),
  heading: _defineProperty({
    marginBottom: 42,
    textAlign: 'center',
    fontSize: 45,
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_heading

  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 28
  }),
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -5px'
  },
  select_container: {
    position: 'relative'
  },
  select_parent_container: _defineProperty({
    position: 'relative',
    padding: '0px 5px',
    marginBottom: '15px',
    width: '100%'

  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  select_field_container: _defineProperty({
    position: 'relative',
    zIndex: 10,
    width: '50%',
    paddingRight: '5px'

  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  select_style: _defineProperty({
    width: '100%',
    height: '48px'
  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  actions: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  continue: {
    width: 340,
    height: 50,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_secondary,
    color: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].primary,
    cursor: 'pointer',
    outline: 'none'
  }
});

JoinDetails.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  appdata: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_7__utils__["b" /* mapDispatchToProps */])(JoinDetails));

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_stripe_elements__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_tippy__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_tippy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_tippy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_CheckoutForm__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ErrorContainer__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_HorizontalRule__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_OrderSummary__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_SimpleSelect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_TextField__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable */





















var POWERED_BY_STRIPE = __webpack_require__(610);

var civilDefenseLogo = __webpack_require__(608);
var goldCardLogo = __webpack_require__(609);
var TOOLTIP_ASSET = __webpack_require__(352);

var PRICE = 49.99;
var PROMO_PRICE = 30.0;
var DONATION_PRICE = 1.0;

var JoinPayment = function (_Component) {
  _inherits(JoinPayment, _Component);

  function JoinPayment(props) {
    _classCallCheck(this, JoinPayment);

    var _this = _possibleConstructorReturn(this, (JoinPayment.__proto__ || Object.getPrototypeOf(JoinPayment)).call(this, props));

    _this.continue = _this.continue.bind(_this);
    _this.setValue = _this.updateTextField.bind(_this);
    _this.stickySideHandler = _this.stickySideHandler.bind(_this);

    var userCity = props.appdata.city.find(function (city) {
      return city.id === parseInt(props.user.city, 10);
    });

    _this.state = {
      selected: 'owner',
      active: false,
      completed: false,
      stickySide: false,
      billing_first_name: props.user.billing_first_name ? props.user.billing_first_name : props.user.first_name,
      billing_last_name: props.user.billing_last_name ? props.user.billing_last_name : props.user.last_name,
      billing_email: props.user.billing_email ? props.user.billing_email : props.user.email,
      billing_city: userCity ? userCity.title : null,
      billing_post_code: props.user.billing_post_code ? props.user.billing_post_code : null,
      billing_address_1: props.user.billing_address_1 ? props.user.billing_address_1 : null,
      billing_address_2: props.user.billing_address_2 ? props.user.billing_address_2 : null,
      billing_country: 'New Zealand',
      billing_charity: props.user.billing_charity ? props.user.billing_charity : null,
      suburb: props.user.suburb,

      billing_cc_number: null,
      billing_cc_expiry: null,
      billing_cc_cvv: null,

      last4: null,
      stripeToken: null,
      stripeCard: null,

      errors: {
        billing_first_name: false,
        billing_last_name: false,
        billing_email: false,
        billing_city: false,
        billing_post_code: false,
        billing_address_1: false,
        billing_address_2: false,
        billing_country: false,
        billing_charity: false,
        billing_cc_number: false,
        billing_cc_expiry: false,
        billing_cc_cvv: false
      }
    };
    return _this;
  }

  _createClass(JoinPayment, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          active: true
        }, function () {
          window.addEventListener('scroll', _this2.stickySideHandler);
        });
      }, 0);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.stickySideHandler);
    }
  }, {
    key: 'stickySideHandler',
    value: function stickySideHandler() {
      if (this.side && this.stickySide) {
        if (window.pageYOffset >= this.side.offsetTop + 70 && !this.state.stickySide) {
          this.setState({
            stickySide: true
          });
        } else if (window.pageYOffset < this.side.offsetTop + 70 && this.state.stickySide) {
          this.setState({
            stickySide: false
          });
        }

        if (window.pageYOffset - (this.side.offsetTop + 70) <= this.side.offsetHeight - this.stickySide.offsetHeight) {
          this.offset = window.pageYOffset - (this.side.offsetTop + 70);
          this.stickySide.style.transform = 'translateY(' + (this.offset > 0 ? this.offset : 0) + 'px)';
        }
      }
    }

    // Validate the form

  }, {
    key: 'validateForm',
    value: function validateForm() {
      var errors = {};

      if (!this.state.billing_first_name || !this.state.billing_first_name.length) {
        errors.billing_first_name = 'Please complete this field';
      } else {
        errors.billing_first_name = null;
      }

      if (!this.state.billing_last_name || !this.state.billing_last_name.length) {
        errors.billing_last_name = 'Please complete this field';
      } else {
        errors.billing_last_name = null;
      }

      if (!this.state.billing_email || !this.state.billing_email.length) {
        errors.billing_email = 'Please complete this field';
      } else {
        errors.billing_email = null;
      }

      if (!this.state.billing_address_1 || !this.state.billing_address_1.length) {
        errors.billing_address_1 = 'Please complete this field';
      } else {
        errors.billing_address_1 = null;
      }

      if (!this.state.billing_city || !this.state.billing_city.length) {
        errors.billing_city = 'Please select a city';
      } else {
        errors.billing_city = null;
      }

      if (!this.state.billing_post_code || !this.state.billing_post_code.length) {
        errors.billing_post_code = 'Please complete this field';
      } else {
        errors.billing_post_code = null;
      }

      if (!this.state.billing_email || !this.state.billing_email.length) {
        errors.billing_email = 'Please complete this field';
      } else {
        errors.billing_email = null;
      }

      if (!this.state.billing_country || !this.state.billing_country.length) {
        errors.billing_country = 'Please complete this field';
      } else {
        errors.billing_country = null;
      }

      if (!this.state.billing_charity) {
        errors.billing_charity = 'Please choose the local or favourite dog charity you\'d like to support. Your favourite dog charity not here? Please email us.';
      } else {
        errors.billing_charity = null;
      }

      var formErrors = false;

      for (var key in errors) {
        //eslint-disable-line
        if (errors[key] !== null) {
          formErrors = true;
        }
      }

      if (formErrors) {
        this.setState({
          errors: errors,
          hasError: true
        });

        return false;
      }

      this.setState({
        errors: errors,
        hasError: false
      });

      return true;
    }
  }, {
    key: 'continue',
    value: function _continue(history) {
      var _this3 = this;

      if (this.validateForm()) {
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
          loading: true
        })).then(function () {
          return _this3.CheckoutForm.verifyCard().then(function (response) {
            var paymentFields = {
              billing_first_name: _this3.state.billing_first_name,
              billing_last_name: _this3.state.billing_last_name,
              billing_email: _this3.state.billing_email,
              billing_address_1: _this3.state.billing_address_1,
              billing_address_2: _this3.state.billing_address_2,
              billing_city: _this3.state.billing_city,
              billing_post_code: _this3.state.billing_post_code,
              billing_country: _this3.state.billing_country,
              billing_charity: _this3.state.billing_charity,
              stripeToken: _this3.state.stripeToken,
              stripeCard: _this3.state.stripeCard,
              last4: _this3.state.last4,
              payment: true
            };

            _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__actions_user__["c" /* updateUser */])(paymentFields)).then(function () {
              var registrationFields = Object.assign({}, _this3.props.user, paymentFields);

              _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__actions_user__["j" /* register */])(registrationFields)).then(function (response) {
                if (response.transaction.status === 'failed') {
                  _this3.setState({
                    errors: Object.assign({}, _this3.state.errors, {
                      card: 'A problem occurred with this card.' + 'Please try another card.'
                    }),
                    hasError: true
                  });

                  _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
                    loading: false
                  }));
                } else {
                  _this3.setState({
                    completed: true
                  }, function () {
                    setTimeout(function () {
                      // Successful payment - track ecommerce data if there is a transaction attached
                      if (response.transaction && response.transaction.id && response.transaction.amount) {
                        _this3.props.ga.plugin.execute('ecommerce', 'addTransaction', {
                          id: response.transaction.id,
                          name: 'Annual Subscription Year 1',
                          category: _this3.props.user.subscription,
                          price: response.transaction.amount,
                          quantity: '1'
                        });
                        _this3.props.ga.plugin.execute('ecommerce', 'send');
                        _this3.props.ga.plugin.execute('ecommerce', 'clear');
                      }

                      // Redirect user
                      _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
                        loading: false
                      }));
                      history.push('/join/verify');
                    }, 500);
                  });
                }
              }, function (err) {
                _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
                  loading: false
                }));

                if (err.data.error === 'email_exists') {
                  _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__actions_user__["c" /* updateUser */])({
                    facebook_token: null,
                    fb_id: null
                  }));

                  setTimeout(function () {
                    history.push({
                      pathname: '/join/details',
                      state: {
                        error: 'email_exists',
                        message: 'The email ' + _this3.props.user.email + ' already has an account.',
                        value: _this3.props.user.email
                      }
                    });
                  }, 100);
                } else if (err.data.error === 'incomplete_payment_details') {
                  _this3.setState({
                    errors: Object.assign({}, _this3.state.errors, {
                      card: 'A problem occured with this card, and you were not charged. ' + 'Please try another card.'
                    }),
                    hasError: true
                  });
                }
              });
            }, function (err) {
              _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
                loading: false
              }));
            });
          });
        });
      }

      return false;
    }
  }, {
    key: 'handleCardToken',
    value: function handleCardToken(response) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        if (response.error) {
          _this4.setState({
            errors: Object.assign({}, _this4.state.errors, {
              card: 'A problem occured with this card, and you were not charged. ' + 'Please try another card.'
            }),
            hasError: true
          });

          _this4.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));

          reject(response);
        } else if (response.token) {
          _this4.setState({
            stripeToken: response.token.id,
            stripeCard: response.token.card.id,
            last4: response.token.card.last4
          });

          resolve(response);
        }
      });
    }
  }, {
    key: 'clearCardError',
    value: function clearCardError() {
      this.setState({
        errors: Object.assign({}, this.state.errors, {
          card: false
        })
      });

      if (this.state.hasError) {
        // Attempt to revalidate
        this.validateForm();
      }
    }
  }, {
    key: 'updateTextField',
    value: function updateTextField(key, value) {
      var _this5 = this;

      this.setState(_defineProperty({}, key, value));

      setTimeout(function () {
        if (_this5.state.errors[key]) {
          // If there is an error against this field, attempt to revalidate
          _this5.validateForm();
        }
      }, 10);
    }
  }, {
    key: 'renderCheckoutButton',
    value: function renderCheckoutButton() {
      var _this6 = this;

      var Checkout = void 0;

      if (this.state.hasError) {
        Checkout = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'button',
          {
            disabled: true,
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.continue, styles.continue_disabled),
            onClick: function onClick() {
              _this6.continue(_this6.props.history);
            }
          },
          'Checkout'
        );
      } else {
        Checkout = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'button',
          {
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.continue),
            onClick: function onClick() {
              _this6.continue(_this6.props.history);
            }
          },
          'Checkout'
        );
      }

      return Checkout;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          {
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container, this.state.active ? styles.container_active : null, this.state.completed ? styles.container_completed : null)
          },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__components_ContentContainer__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'h1',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.heading) },
              'Payment'
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.main) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.form) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'h2',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.sub_heading) },
                  'Personal Details'
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_TextField__["a" /* default */], {
                  id: 'billing_first_name',
                  name: 'billing_first_name',
                  label: 'First Name',
                  value: this.state.billing_first_name,
                  handler: this.setValue,
                  error: this.state.errors.billing_first_name
                }),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_TextField__["a" /* default */], {
                  id: 'billing_last_name',
                  name: 'billing_last_name',
                  label: 'Last Name',
                  value: this.state.billing_last_name,
                  handler: this.setValue,
                  error: this.state.errors.billing_last_name
                }),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_TextField__["a" /* default */], {
                  id: 'billing_email',
                  name: 'billing_email',
                  label: 'Email address (for receipt)',
                  email: true,
                  fullWidth: true,
                  value: this.state.billing_email,
                  handler: this.setValue,
                  error: this.state.errors.billing_email
                }),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_TextField__["a" /* default */], {
                  id: 'billing_address_1',
                  name: 'billing_address_1',
                  label: 'Physical Address Line 1',
                  value: this.state.billing_address_1,
                  handler: this.setValue,
                  error: this.state.errors.billing_address_1
                }),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_TextField__["a" /* default */], {
                  id: 'billing_address_2',
                  name: 'billing_address_2',
                  label: 'Physical Address Line 2',
                  value: this.state.billing_address_2,
                  handler: this.setValue
                }),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_TextField__["a" /* default */], {
                  id: 'billing_city',
                  name: 'billing_city',
                  label: 'City',
                  value: this.state.billing_city,
                  handler: this.setValue,
                  error: this.state.errors.billing_city
                }),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_TextField__["a" /* default */], {
                  id: 'billing_post_code',
                  name: 'billing_post_code',
                  label: 'Postcode',
                  value: this.state.billing_post_code,
                  handler: this.setValue,
                  error: this.state.errors.billing_post_code
                }),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_TextField__["a" /* default */], {
                  id: 'billing_country',
                  name: 'billing_country',
                  label: 'Country',
                  value: 'New Zealand',
                  readOnly: 1,
                  handler: this.setValue,
                  error: this.state.errors.billing_country
                }),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_HorizontalRule__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'h2',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.sub_heading) },
                  'Select your charity'
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'p',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.paragraph) },
                  '$',
                  DONATION_PRICE.toFixed(2),
                  ' of your membership fee will go directly to one of these dog charities.',
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
                  'Please choose the dog charity you\'d like to support.'
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_SimpleSelect__["a" /* default */], {
                  id: 'billing_charity',
                  name: 'billing_charity',
                  options: this.props.appdata.charity.map(function (charity) {
                    return {
                      value: charity.id,
                      label: charity.title
                    };
                  }),
                  label: 'Charity',
                  value: this.state.billing_charity,
                  error: this.state.errors.billing_charity,
                  handler: this.setValue
                }),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_HorizontalRule__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'h2',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.sub_heading) },
                  'Payment'
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.creditcard_container) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.creditcard) },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_5_react_stripe_elements__["Elements"],
                      null,
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_CheckoutForm__["a" /* default */], {
                        cardChangedHandler: this.clearCardError.bind(this),
                        onRef: function onRef(ref) {
                          return _this7.CheckoutForm = ref;
                        },
                        handler: this.handleCardToken.bind(this),
                        first_name: this.state.billing_first_name,
                        last_name: this.state.billing_last_name
                      })
                    ),
                    this.state.errors.card ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_ErrorContainer__["a" /* default */], { message: this.state.errors.card }) : null
                  ),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'a',
                    { href: 'https://stripe.com', target: '_blank', rel: 'noopener noreferrer' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', {
                      alt: 'Payment is secured by Stripe',
                      src: POWERED_BY_STRIPE,
                      className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.powered_by_stripe)
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_HorizontalRule__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'p',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.paragraph) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
                  'Your investment in letting us find a dog the companionship they need,\n                  is priceless. Our promise to you, is that our service will bring joy and\n                  value well beyond this annual investment. In a dog eat dog world, take\n                  sanctuary with us. '
                )
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                {
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.side),
                  ref: function ref(side) {
                    _this7.side = side;
                  }
                },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  {
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(this.state.stickySide ? styles.side_sticky : null),
                    ref: function ref(stickySide) {
                      _this7.stickySide = stickySide;
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_OrderSummary__["a" /* default */], {
                    type: this.props.user.subscription,
                    membership: 'Full',
                    price: PRICE,
                    promoPrice: PROMO_PRICE,
                    donationPrice: DONATION_PRICE,
                    promoTitle: '#COLLECTIVEGIVING',
                    promoText: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'span',
                      null,
                      'One year subscription for $30.00 ',
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
                      '100% Pooch Pleasure Guarantee: No connections in your first year? Get your second year FREE!'
                    ),
                    hasError: this.state.hasError,
                    checkout: this.renderCheckoutButton()
                  }),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.freeMembershipNote) },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'div',
                      { style: { display: 'flex' } },
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', {
                        src: goldCardLogo,
                        alt: 'Gold Card',
                        className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.freeMembershipNoteLogos)
                      }),
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_react_tippy__["Tooltip"],
                        {
                          style: { alignSelf: 'center', marginLeft: 10 },
                          arrow: true,
                          html: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.actions_tooltip) },
                            'SuperGold Card Holders go FREE! Please do not proceed through payment, instead email us at support@thedogsharecollective.com.'
                          )
                        },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, {
                          cacheGetRequests: true,
                          src: TOOLTIP_ASSET,
                          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.actions_tooltip_trigger)
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'div',
                      { style: { display: 'flex' } },
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', {
                        src: civilDefenseLogo,
                        alt: 'Civil Defense',
                        className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.freeMembershipNoteLogos)
                      }),
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_react_tippy__["Tooltip"],
                        {
                          style: { alignSelf: 'center', marginLeft: 10 },
                          arrow: true,
                          html: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.actions_tooltip) },
                            'In a Civil Defence Emergency? You go FREE! Please do not proceed through payment, instead email us at support@thedogsharecollective.com.'
                          )
                        },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, {
                          cacheGetRequests: true,
                          src: TOOLTIP_ASSET,
                          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.actions_tooltip_trigger)
                        })
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return JoinPayment;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  freeMembershipNote: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: 60
  },
  freeMembershipNoteLogos: {
    width: 100,
    height: '100%'
  },
  actions_tooltip: {
    padding: 5,
    fontSize: 14,
    marginLeft: 10,
    alignSelf: 'center',
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_primary
  },
  actions_tooltip_trigger: {
    alignItems: 'center',
    cursor: 'pointer'
  },
  creditcard_container: _defineProperty({
    position: 'relative',
    display: 'flex',
    width: '100%'

  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column'
  }),
  creditcard: _defineProperty({
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    width: '50%'

  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  input_sm: _defineProperty({
    ':not(.a) > input': _defineProperty({
      width: '70%'

    }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
      width: '100%'
    })

  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    width: '50%'
  }),
  container: _defineProperty({
    padding: '86px 0 ' + __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].footer.height + 'px',
    transition: 'transform 500ms',
    transform: 'translateX(100vw)'

  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    padding: '50px 0'
  }),
  container_active: {
    transform: 'translateX(0)'
  },
  container_completed: {
    transform: 'translateX(-100vw)'
  },
  main: _defineProperty({
    display: 'flex',
    justifyContent: 'space-between'

  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    flexWrap: 'wrap'
  }),
  side: _defineProperty({
    width: 360,
    transform: 'translate3d(0,0,0)'

  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  heading: _defineProperty({
    marginBottom: 42,
    textAlign: 'center',
    fontSize: 45,
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_heading

  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 28
  }),
  sub_heading: {
    width: '100%',
    padding: '0 5px',
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 500,
    fontSize: 20,
    color: '#000e1f'
  },
  paragraph: {
    width: '100%',
    padding: '0 5px',
    marginTop: -15,
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14,
    color: '#828282',
    lineHeight: 1.4
  },
  form: _defineProperty({
    display: 'flex',
    flexWrap: 'wrap',
    width: 750,
    margin: '0 -5px'

  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto'
  }),
  continue: {
    width: '100%',
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_secondary,
    color: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: '#56C5FF',
    cursor: 'pointer',
    outline: 'none'
  },
  continue_disabled: {
    opacity: 0.5,
    backgroundColor: '#999',
    pointerEvents: 'none'
  },
  powered_by_stripe: _defineProperty({
    position: 'absolute',
    right: 0,
    maxWidth: 223.5,
    maxHeight: 61.5

  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    position: 'relative',
    marginTop: 20,
    right: 'auto',
    maxWidth: 112.25,
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block'
  })
});

JoinPayment.propTypes = {
  appdata: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  ga: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_7__utils__["b" /* mapDispatchToProps */])(JoinPayment));

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dropzone__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_avatar_editor__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_avatar_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_avatar_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_pooch__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ErrorContainer__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_HorizontalRule__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_TextField__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_DateField__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_CheckboxField__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_SimpleSelect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_CheckButton__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ActivityCard__ = __webpack_require__(43);
var _StyleSheet$create;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import { withRouter } from 'react-router-dom';






















var POOCH_ASSET = __webpack_require__(353);
var UPLOAD_ASSET = __webpack_require__(354);
// const CLOSE_ICON = require('./close.svg');
var ROTATE_ICON = __webpack_require__(611);

var JoinPooch = function (_Component) {
  _inherits(JoinPooch, _Component);

  function JoinPooch(props) {
    _classCallCheck(this, JoinPooch);

    var _this = _possibleConstructorReturn(this, (JoinPooch.__proto__ || Object.getPrototypeOf(JoinPooch)).call(this, props));

    _this.selectHandler = _this.handleSelect.bind(_this);
    _this.setValue = _this.updateTextField.bind(_this);
    _this.saveDraft = _this.handleSave.bind(_this, false);
    _this.savePublish = _this.handleSave.bind(_this, true);
    _this.acceptFiles = _this.handleFileDrop.bind(_this);
    _this.editAvator = _this.handleAvatarFileDrop.bind(_this);
    _this.handleRotation = _this.handleImageRotation.bind(_this);
    _this.avatarSaveImage = _this.handleAvatarSaveImage.bind(_this);
    _this.clearImage = _this.handleClearImage.bind(_this);
    _this.editorRef = _this.setEditorRef.bind(_this);
    _this.handleClose = _this.avatarEditorModalHandler.bind(_this);

    _this.state = {
      active: false,
      completed: false,
      adding: false,
      avatar_editor_modal_open: false,

      name: null,
      breed: null,
      dogsize: null,
      date_of_birth: null,
      about: null,
      good_with_children: false,
      plays_with_other_dogs: false,
      registration: null,
      availability: null,
      living_situation: null,
      regularity: null,
      needs: [],
      interests: [],
      health_needs: '',
      hypoallergenic_coat: false,
      photos: [],
      avatarPhoto: [],
      avatarPhotoRotation: null,
      sex: null,
      fixed: null,

      errors: {
        name: false,
        breed: false,
        dogsize: false,
        about: false,
        registration: false,
        needs: false,
        interests: false,
        photos: false,
        publishError: false,
        health_needs: false,
        availability: false,
        living_situation: false,
        sex: false
      }
    };

    _this.availability = __WEBPACK_IMPORTED_MODULE_9__utils__["c" /* availability */];
    _this.living_situations = __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* livingSituations */];
    _this.regularity = __WEBPACK_IMPORTED_MODULE_9__utils__["e" /* regularity */];
    _this.sex = __WEBPACK_IMPORTED_MODULE_9__utils__["f" /* sex */];
    _this.fixedStatuses = __WEBPACK_IMPORTED_MODULE_9__utils__["g" /* fixedStatuses */];
    return _this;
  }

  _createClass(JoinPooch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          active: true
        });
      }, 0);
    }
  }, {
    key: 'setEditorRef',
    value: function setEditorRef(editor) {
      this.editor = editor;
    }
  }, {
    key: 'getFieldsToStore',
    value: function getFieldsToStore() {
      var fields = {
        name: this.state.name,
        breed: this.state.breed,
        date_of_birth: this.state.date_of_birth,
        about: this.state.about,
        good_with_children: this.state.good_with_children,
        plays_with_other_dogs: this.state.plays_with_other_dogs,
        registration: this.state.registration,
        needs: this.state.needs,
        availability: this.state.availability,
        living_situation: this.state.living_situation,
        regularity: this.state.regularity,
        interests: this.state.interests,
        health_needs: this.state.health_needs,
        hypoallergenic_coat: this.state.hypoallergenic_coat,
        photos: this.state.photos,
        dogsize: this.state.dogsize,
        sex: this.state.sex,
        fixed: this.state.fixed
      };

      return fields;
    }

    // Validate the form

  }, {
    key: 'validateForm',
    value: function validateForm() {
      var errors = {};

      if (!this.state.name || !this.state.name.length) {
        errors.name = 'Please add a name';
      } else {
        errors.name = null;
      }

      if (!this.state.breed) {
        errors.breed = 'Please select a breed';
      } else {
        errors.breed = null;
      }

      if (!this.state.dogsize) {
        errors.dogsize = 'Please specify the size of your dog';
      } else {
        errors.dogsize = null;
      }

      if (!this.state.date_of_birth) {
        errors.date_of_birth = 'Please enter a date of birth';
      } else {
        errors.date_of_birth = null;
      }

      if (!this.state.about || !this.state.about.length) {
        errors.about = 'Please tell us about your dog';
      } else {
        errors.about = null;
      }

      if (!this.state.registration || !this.state.registration.length) {
        errors.registration = 'Please enter a registration number';
      } else {
        errors.registration = null;
      }

      if (!this.state.needs || !this.state.needs.length) {
        errors.needs = 'Please select at least one need';
      } else {
        errors.needs = null;
      }

      if (!this.state.sex || !this.state.sex.length) {
        errors.sex = 'Please select the sex of the dog';
      } else {
        errors.sex = null;
      }

      if (!this.state.fixed || !this.state.fixed.length) {
        errors.fixed = 'Please indicate your dog\'s desex status';
      } else {
        errors.fixed = null;
      }

      if (!this.state.interests || !this.state.interests.length) {
        errors.interests = 'Please select at least one interest';
      } else {
        errors.interests = null;
      }

      if (!this.state.regularity) {
        errors.regularity = 'Please select the most likely regularity for sharing';
      } else {
        errors.regularity = null;
      }

      if (!this.state.availability) {
        errors.availability = 'Please select the availability for sharing';
      } else {
        errors.availability = null;
      }

      if (!this.state.living_situation) {
        errors.living_situation = 'Please select the ideal living situation';
      } else {
        errors.living_situation = null;
      }

      if (!this.state.health_needs || !this.state.health_needs.length) {
        errors.health_needs = 'Please add any important details about your pooch. Enter ‘nil’ if not applicable';
      } else {
        errors.health_needs = null;
      }

      if (!this.state.photos || !this.state.photos.length) {
        errors.photos = 'Please upload at least one photo';
      } else {
        errors.photos = null;
      }

      var formErrors = false;

      for (var key in errors) {
        //eslint-disable-line
        if (errors[key] !== null) {
          formErrors = true;
        }
      }

      if (formErrors) {
        errors.publishError = 'Please fix any form errors to continue.';
      } else {
        errors.publishError = null;
      }

      if (formErrors) {
        this.setState({
          errors: errors
        });

        return false;
      }

      return true;
    }
  }, {
    key: 'avatarEditorModalHandler',
    value: function avatarEditorModalHandler() {
      this.setState({
        avatar_editor_modal_open: !this.state.avatar_editor_modal_open
      });
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(name, id, value) {
      var _this3 = this;

      if (value) {
        this.addKey(name, id);
      } else {
        this.removeKey(name, id);
      }

      setTimeout(function () {
        if (_this3.state.errors[name]) {
          // If there is an error against this field, attempt to revalidate
          _this3.validateForm();
        }
      }, 10);
    }
  }, {
    key: 'updateTextField',
    value: function updateTextField(key, value) {
      var _this4 = this;

      this.setState(_defineProperty({}, key, value));

      setTimeout(function () {
        if (_this4.state.errors[key]) {
          // If there is an error against this field, attempt to revalidate
          _this4.validateForm();
        }
      }, 10);
    }

    // Add a unique key to array in state

  }, {
    key: 'addKey',
    value: function addKey(name, key) {
      var state = this.state;
      var inArray = state[name].find(function (obj) {
        return obj === key;
      });

      // If the item is not already in the array, add it. Otherwise return state
      this.setState(_defineProperty({}, name, !inArray ? state[name].concat([key]) : state));
    }

    // Remove key from an array in state

  }, {
    key: 'removeKey',
    value: function removeKey(name, key) {
      var state = this.state;

      this.setState(_defineProperty({}, name, state[name].filter(function (obj) {
        return obj !== key;
      })));
    }
  }, {
    key: 'handleClearImage',
    value: function handleClearImage(image) {
      var modifiedState = {
        photos: this.state.photos.filter(function (savedImage) {
          return savedImage.file_name !== image.file_name;
        })
      };

      // Remember in 'removed_images' state so we can remove from remote
      if (image.remote) {
        modifiedState.removed_images = [].concat(this.state.removed_images, [image.id]);
      }

      this.setState(modifiedState);
    }
  }, {
    key: 'handleFileDrop',
    value: function handleFileDrop(acceptedFiles, rejectedFiles) {
      var _this5 = this;

      acceptedFiles.forEach(function (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          var fileAsDataURL = reader.result;

          if (_this5.state.photos.length < 3) {
            _this5.setState({
              photos: [].concat(_this5.state.photos, [{
                id: null,
                remote: false,
                src: fileAsDataURL,
                size: file.size,
                file_name: file.name
              }])
            });
          }
        };
      });

      if (rejectedFiles && rejectedFiles.length) {
        this.setState({
          errors: Object.assign({}, this.state.errors, {
            photos: '1 or more images did not upload. Must be JPG or PNG, and below 2MB.'
          })
        });
      } else {
        this.setState({
          errors: Object.assign({}, this.state.errors, {
            photos: false
          })
        });
      }
    }
  }, {
    key: 'handleAvatarFileDrop',
    value: function handleAvatarFileDrop(acceptedFiles, rejectedFiles) {
      var _this6 = this;

      acceptedFiles.forEach(function (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          var fileAsDataURL = reader.result;

          if (!_this6.state.avatarPhoto.length) {
            _this6.setState({
              avatar_editor_modal_open: true,
              avatarPhoto: {
                id: null,
                remote: false,
                src: fileAsDataURL,
                size: file.size,
                file_name: file.name
              }
            });
          }
        };
      });

      if (rejectedFiles && rejectedFiles.length) {
        this.setState({
          errors: Object.assign({}, this.state.errors, {
            photos: '1 or more images did not upload. Must be JPG or PNG, and below 2MB.'
          })
        });
      } else {
        this.setState({
          errors: Object.assign({}, this.state.errors, {
            photos: false
          })
        });
      }
    }
  }, {
    key: 'handleImageRotation',
    value: function handleImageRotation() {
      var angle = (this.state.avatarPhotoRotation + 90) % 360;
      this.setState({
        avatarPhotoRotation: angle
      });
    }
  }, {
    key: 'handleAvatarSaveImage',
    value: function handleAvatarSaveImage() {
      var avatarPhoto = this.state.avatarPhoto;
      var canvasImage = this.editor.props;
      if (this.state.photos.length < 3) {
        var newImage = this.editor.getImage();
        this.setState({
          avatar_editor_modal_open: false,
          photos: [].concat(this.state.photos, [{
            id: null,
            remote: false,
            src: newImage.toDataURL('image/jpeg', 0.8),
            size: avatarPhoto.size,
            file_name: avatarPhoto.name,
            rotate: canvasImage.rotate
          }])
        });
      }
    }
  }, {
    key: 'fileSize',
    value: function fileSize(b) {
      var u = 0;
      var s = 1024;

      while (b >= s || -b >= s) {
        b /= s; //eslint-disable-line
        u += 1;
      }
      return (u ? b.toFixed(1) + ' ' : b) + ' KMGTPEZY'[u] + 'B';
    }
  }, {
    key: 'handleSave',
    value: function handleSave(published) {
      var _this7 = this;

      if (!this.validateForm() && published) {
        // If the user is trying to publish, the form must validate.
        // The user can save an incomplete form only if it's a draft
        return false;
      }

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        return _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__actions_pooch__["a" /* createDog */])(Object.assign({}, _this7.getFieldsToStore(), {
          published: published
        }), _this7.props.user.access_token)).then(function () {
          _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));

          // Update the member

          if (_this7.props.user.subscription === 'Owner') {
            _this7.props.history.push('/join/complete');
          } else {
            _this7.props.history.push('/settings/details');
          }
        });
      }, function (err) {
        console.log(err); // eslint-disable-line no-console
        _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_applicationState__["a" /* updateAppState */])({
          loading: false
        }));
      });

      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var userIsOwner = this.props.user.subscription === 'Owner';
      var selectedNeeds = this.state.needs;
      var selectedInterests = this.state.interests;

      if (!userIsOwner) return false;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.container, this.state.active ? styles.container_active : null, this.state.completed ? styles.container_completed : null) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__components_ContentContainer__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, {
            cacheGetRequests: true,
            src: POOCH_ASSET,
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.icon)
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.heading) },
            'Great Stuff!',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            'Let\'s',
            ' add your pooch ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.highlight) },
              'profile'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.main) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.form) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_HorizontalRule__["a" /* default */], { pin: true }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.sub_heading) },
                'Dog information'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_TextField__["a" /* default */], {
                id: 'name',
                name: 'name',
                label: 'Name',
                placeholder: 'Your dog\'s name',
                required: true,
                value: this.state.name,
                handler: this.setValue,
                error: this.state.errors.name
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_SimpleSelect__["a" /* default */], {
                id: 'breed',
                name: 'breed',
                options: this.props.appdata.breed.map(function (breed) {
                  return {
                    value: breed.id,
                    label: breed.title
                  };
                }),
                label: 'Breed',
                required: true,
                value: this.state.breed,
                handler: this.setValue,
                error: this.state.errors.breed
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_DateField__["a" /* default */], {
                id: 'date_of_birth',
                name: 'date_of_birth',
                label: 'Date of birth',
                type: 'date',
                fullWidth: true,
                placeholder: 'DD/MM/YYYY',
                value: this.state.date_of_birth,
                handler: this.setValue,
                required: true,
                error: this.state.errors.date_of_birth
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_SimpleSelect__["a" /* default */], {
                id: 'dogsize',
                name: 'dogsize',
                options: this.props.appdata.dogsize.map(function (dogsize) {
                  return {
                    value: dogsize.id,
                    label: dogsize.title
                  };
                }),
                value: this.state.dogsize,
                handler: this.setValue,
                label: 'Size',
                required: true,
                error: this.state.errors.dogsize
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_SimpleSelect__["a" /* default */], {
                id: 'living_situation',
                name: 'living_situation',
                options: this.living_situations,
                label: 'Ideal living situation of borrower',
                value: this.state.living_situation,
                handler: this.setValue,
                required: true,
                error: this.state.errors.living_situation
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_SimpleSelect__["a" /* default */], {
                id: 'availability',
                name: 'availability',
                options: this.availability,
                label: 'Availability',
                required: true,
                value: this.state.availability,
                handler: this.setValue,
                error: this.state.errors.availability
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_SimpleSelect__["a" /* default */], {
                id: 'regularity',
                name: 'regularity',
                options: this.regularity,
                label: 'Regularity of sharing',
                required: true,
                value: this.state.regularity,
                handler: this.setValue,
                error: this.state.errors.regularity
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_TextField__["a" /* default */], {
                id: 'registration',
                name: 'registration',
                label: 'Registration No. or Microchip No. - this will not be public.',
                placeholder: 'Enter a valid NZ Registration number.',
                required: true,
                value: this.state.registration,
                handler: this.setValue,
                error: this.state.errors.registration
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_SimpleSelect__["a" /* default */], {
                id: 'sex',
                name: 'sex',
                options: this.sex,
                label: 'Sex',
                required: true,
                value: this.state.sex,
                handler: this.setValue,
                error: this.state.errors.sex
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_SimpleSelect__["a" /* default */], {
                id: 'fixed',
                name: 'fixed',
                options: this.fixedStatuses,
                label: 'Desex Status',
                required: true,
                value: this.state.fixed,
                handler: this.setValue,
                error: this.state.errors.fixed,
                placeholder: 'Please indicate your dog\'s desex status',
                tooltip: 'If you are listing a puppy, select \'entire\' and advise the planned date of the puppy\'s neuter/spay within your text'
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_TextField__["a" /* default */], {
                id: 'about',
                name: 'about',
                label: 'Description (about your dog)',
                textArea: true,
                fullWidth: true,
                showRemaining: true,
                required: true,
                limit: 1000,
                height: 85,
                placeholder: 'Tell us a bit about your dog, its needs and availability, this will show up in their profile ',
                value: this.state.about,
                handler: this.setValue,
                error: this.state.errors.about
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.checkboxes) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_CheckboxField__["a" /* default */], {
                  id: 'good_with_children',
                  name: 'good_with_children',
                  label: 'My dog is good with children',
                  tooltip: 'My dog is safe if left unsupervised around children.',
                  value: this.state.good_with_children,
                  handler: this.setValue
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_CheckboxField__["a" /* default */], {
                  id: 'plays_with_other_dogs',
                  name: 'plays_with_other_dogs',
                  label: 'My dog is keen to play with other dogs',
                  tooltip: 'My dog is safe if left unsupervised around other dogs.',
                  value: this.state.plays_with_other_dogs,
                  handler: this.setValue
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_HorizontalRule__["a" /* default */], { pin: true }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.sub_heading) },
                'Dog Needs'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.paragraph) },
                'Select as many that are relevant to you.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.needs) },
                this.props.appdata.need.map(function (need) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_CheckButton__["a" /* default */], {
                    name: 'needs',
                    label: need.title,
                    id: need.id,
                    onSelect: _this8.selectHandler,
                    selected: selectedNeeds.find(function (selectedNeed) {
                      return need.id === selectedNeed;
                    }) });
                }),
                this.state.errors.needs ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ErrorContainer__["a" /* default */], { message: this.state.errors.needs }) : null
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_HorizontalRule__["a" /* default */], { pin: true }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.sub_heading) },
                'Doggie Interests'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.paragraph) },
                'Select as many that are relevant to your dog.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.interests) },
                this.props.appdata.interest.map(function (interest) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_ActivityCard__["a" /* default */], {
                    name: 'interests',
                    id: interest.id,
                    activity: interest.title,
                    label: interest.title,
                    styles: styles.interest,
                    onSelect: _this8.selectHandler,
                    profileHandler: true,
                    value: selectedInterests.find(function (selectedInterest) {
                      return interest.id === selectedInterest;
                    }) });
                }),
                this.state.errors.interests ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ErrorContainer__["a" /* default */], { message: this.state.errors.interests }) : null
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_HorizontalRule__["a" /* default */], { pin: true }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.sub_heading) },
                'Important Details'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_TextField__["a" /* default */], {
                id: 'health_needs',
                name: 'health_needs',
                label: 'Health and Wellbeing Needs.',
                textArea: true,
                fullWidth: true,
                height: 100,
                value: this.state.health_needs,
                handler: this.setValue,
                error: this.state.errors.health_needs,
                placeholder: 'Tell us anything a borrower may need to know about looking after your dog. i.e. medication, dietary needs, allergies etc.'
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_CheckboxField__["a" /* default */], {
                id: 'hypoallergenic_coat',
                name: 'hypoallergenic_coat',
                label: 'My dog has a hypoallergenic coat',
                value: this.state.hypoallergenic_coat,
                handler: this.setValue
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_HorizontalRule__["a" /* default */], { pin: true }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.sub_heading) },
                'Upload a profile photo'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.paragraph) },
                'You can add up to 3 images of your dog, each image has to be below 2MB and be .jpg or .png format.',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                'For security purposes, all human faces should be removed prior to uploading.'
              ),
              this.state.photos.length < 3 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_dropzone__["a" /* default */],
                {
                  maxSize: 2097152,
                  multiple: true,
                  accept: 'image/jpeg, image/png, image/bmp',
                  onDrop: this.editAvator,
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.dropzone) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, {
                  cacheGetRequests: true,
                  src: UPLOAD_ASSET,
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.dropzone_icon)
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  'Drop files to attach or',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.dropzone_browse, styles.highlight) },
                    ' browse'
                  )
                )
              ) : false,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.avatarEditor) },
                this.state.avatarPhoto.src ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_modal___default.a,
                  {
                    isOpen: this.state.avatar_editor_modal_open,
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.modal_container),
                    onRequestClose: this.handleClose,
                    style: {
                      overlay: {
                        backgroundColor: 'rgba(0,0,0,0.67)',
                        zIndex: 101,
                        display: 'flex'
                      }
                    },
                    contentLabel: 'Photo Editor'
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.modal_wrapper) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.header) },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h2',
                        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.modal_title) },
                        'Photo Editor'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.body) },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.avatarCanvas) },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_avatar_editor___default.a, {
                          ref: this.editorRef,
                          image: this.state.avatarPhoto.src,
                          width: 250,
                          height: 250,
                          color: [255, 255, 255, 0.6] // RGBA
                          , scale: 1.2,
                          rotate: this.state.avatarPhotoRotation
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.actions_container) },
                      this.state.avatarPhoto.src ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        {
                          role: 'button',
                          tabIndex: 0,
                          onClick: this.handleRotation },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.rotate_icon),
                          src: ROTATE_ICON,
                          alt: 'rotate'
                        })
                      ) : false,
                      this.state.avatarPhoto.src ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        {
                          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.avatarAction),
                          onClick: this.avatarSaveImage },
                        'Save Photo'
                      ) : false
                    )
                  )
                ) : false
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.photos) },
                this.state.photos && this.state.photos.length ? this.state.photos.map(function (image) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.image_info_container) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.file_image) },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                        alt: 'Profile',
                        className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.profile_photo),
                        src: image.src
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.file_info) },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.file_name) },
                        image.file_name
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.file_size) },
                        image.remote ? image.size : _this8.fileSize(image.size)
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        {
                          onClick: _this8.clearImage.bind(_this8, image),
                          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.clear_image),
                          role: 'link',
                          tabIndex: 0 },
                        'Remove picture'
                      )
                    )
                  );
                }) : false,
                this.state.errors.photos ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ErrorContainer__["a" /* default */], { message: this.state.errors.photos }) : null
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_HorizontalRule__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.actions) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  {
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.draft),
                    onClick: this.saveDraft },
                  'Save as Draft / Unpublish'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  {
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.publish),
                    onClick: this.savePublish },
                  'Save and publish'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.publishErrorWrapper) },
                this.state.errors.publishError ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ErrorContainer__["a" /* default */], { message: this.state.errors.publishError }) : null
              )
            )
          )
        )
      );
    }
  }]);

  return JoinPooch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

JoinPooch.propTypes = {
  appdata: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].object.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].func.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].object.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_3_aphrodite__["StyleSheet"].create((_StyleSheet$create = {
  needs: _defineProperty({
    display: 'flex',
    flexWrap: 'wrap',
    margin: '6px -4.5px'
  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    margin: '6px 0'
  }),
  interests: _defineProperty({
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -4.5px'
  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    margin: '6px 0'
  }),
  interest: _defineProperty({
    width: 244,
    margin: '6px 4.5px'
  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    margin: '6px 0'
  }),
  checkboxes: _defineProperty({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginBottom: 30
  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    'flex-wrap': 'wrap'
  }),
  highlight: {
    color: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].primary
  },
  dropzone: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 94,
    width: '100%',
    fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_primary,
    backgroundColor: '#f2f2f2',
    border: '1px dashed #39b4d6',
    cursor: 'pointer'
  },
  dropzone_icon: {
    display: 'block',
    marginRight: 15
  },
  dropzone_browse: {
    fontWeight: 900
  },
  icon: {
    display: 'block',
    width: 159,
    margin: '0 auto 20px'
  },
  container: {
    padding: '86px 0 ' + __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].footer.height + 'px',
    transition: 'transform 500ms',
    transform: 'translateX(100vw)'
  },
  container_active: {
    transform: 'translateX(0)'
  },
  container_completed: {
    transform: 'translateX(-100vw)'
  },
  main: _defineProperty({
    width: 750,
    maxWidth: '100%',
    margin: '0 auto'
  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    margin: '6px 0'
  }),
  heading: {
    marginBottom: 30,
    textAlign: 'center',
    fontSize: 30,
    lineHeight: 1.17,
    fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_weight_heading
  },
  sub_heading: {
    width: '100%',
    padding: '0 5px',
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 500,
    fontSize: 20,
    color: '#000e1f'
  },
  paragraph: {
    width: '100%',
    padding: '0 5px',
    marginTop: -15,
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14,
    color: '#828282',
    lineHeight: 1.4
  },
  form: _defineProperty({
    display: 'flex',
    flexWrap: 'wrap',
    width: 750,
    maxWidth: '100%',
    margin: '0 -5px'
  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    margin: '0'
  }),
  actions: _defineProperty({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    'flex-wrap': 'wrap'
  }),
  draft: _defineProperty({
    width: 340,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_weight_secondary,
    color: '#39b4d6',
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].white,
    cursor: 'pointer',
    outline: 'none'
  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  publish: _defineProperty({
    width: 340,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_weight_secondary,
    color: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: '#56C5FF',
    cursor: 'pointer',
    outline: 'none'
  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  publishErrorWrapper: {
    marginTop: 5,
    width: '100%'
  },
  photos: {
    display: 'flex',
    flexDirection: 'column'
  },
  profile_photo: {
    maxWidth: 150,
    maxHeight: 150,
    objectFit: 'contain'
  },
  image_info_container: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 25,
    marginBottom: 25
  },
  file_image: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  file_info: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 25,
    justifyContent: 'center',
    alignItems: 'flex-start'
  },
  file_name: {
    marginBottom: 5
  },
  file_size: {
    fontWeight: 'light',
    color: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].dark_grey
  },
  clear_image: {
    marginTop: 10,
    cursor: 'pointer',
    color: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].teal,
    fontWeight: 'bold'
  },
  avatarEditor: {
    width: '100%',
    padding: 50
  },
  avatarCanvas: {
    display: 'flex',
    justifyContent: 'center',
    borderWidth: 2,
    borderColor: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].baby_blue,
    borderStyle: 'dashed'
  },
  modal_wrapper: _defineProperty({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: 600 - 100,
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 100px'
  }, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0px 20px 180px'
  }),
  close_icon: {
    position: 'absolute',
    right: 15,
    top: 15,
    outline: 'none',
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6
    }
  }
}, _defineProperty(_StyleSheet$create, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].desktop_query, {
  body: {
    padding: 5,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  }
}), _defineProperty(_StyleSheet$create, 'modal_container', _defineProperty({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  width: 590,
  maxWidth: '100vw',
  minHeight: 0,
  maxHeight: '100vh',
  backgroundColor: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].white,
  borderRadius: 5,
  overflow: 'hidden',
  outline: 'none',
  margin: 'auto auto'
}, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
  width: 'calc(100% - 30px)',
  minHeight: '0',
  maxHeight: 'none',
  height: 'auto'
})), _defineProperty(_StyleSheet$create, 'actions_container', _defineProperty({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%'
}, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
  flexWrap: 'wrap'
})), _defineProperty(_StyleSheet$create, 'rotate_icon', {
  width: 35,
  marginTop: 10,
  marginRight: 25
}), _defineProperty(_StyleSheet$create, 'modal_title', {
  fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_heading,
  fontSize: 24,
  fontWeight: '600',
  textAlign: 'center',
  padding: 25
}), _defineProperty(_StyleSheet$create, 'avatarAction', _defineProperty({
  width: 200,
  height: 50,
  marginTop: 8,
  fontSize: 15,
  letterSpacing: 2,
  lineHeight: '50px',
  fontFamily: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_family_secondary,
  fontWeight: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].font_weight_secondary,
  color: __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].white,
  textTransform: 'uppercase',
  border: 0,
  borderRadius: 5,
  backgroundColor: '#56C5FF',
  cursor: 'pointer',
  outline: 'none'
}, __WEBPACK_IMPORTED_MODULE_8__config_theme__["a" /* Theme */].mobile_query, {
  width: '100%'
})), _StyleSheet$create));

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_9__utils__["b" /* mapDispatchToProps */])(JoinPooch));

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dropzone__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_avatar_editor__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_avatar_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_avatar_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tippy__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tippy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_tippy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ErrorContainer__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_HorizontalRule__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_TextField__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_SimpleSelect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Select__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_CheckboxField__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_CheckButton__ = __webpack_require__(44);
var _StyleSheet$create;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import { withRouter } from 'react-router-dom';






















var EDITICON_ASSET = __webpack_require__(355);
var UPLOAD_ASSET = __webpack_require__(356);
var ROTATE_ICON = __webpack_require__(612);
var TOOLTIP_ASSET = __webpack_require__(357);

var JoinDetails = function (_Component) {
  _inherits(JoinDetails, _Component);

  function JoinDetails(props) {
    _classCallCheck(this, JoinDetails);

    var _this = _possibleConstructorReturn(this, (JoinDetails.__proto__ || Object.getPrototypeOf(JoinDetails)).call(this, props));

    _this.selectHandler = _this.handleSelect.bind(_this);
    _this.setValue = _this.updateTextField.bind(_this);
    _this.acceptFiles = _this.handleFileDrop.bind(_this);
    _this.editAvator = _this.handleAvatarFileDrop.bind(_this);
    _this.handleRotation = _this.handleImageRotation.bind(_this);
    _this.avatarSaveImage = _this.handleAvatarSaveImage.bind(_this);
    _this.clearImage = _this.handleClearImage.bind(_this);
    _this.saveDraft = _this.handleSave.bind(_this, false);
    _this.savePublish = _this.handleSave.bind(_this, true);
    _this.editorRef = _this.setEditorRef.bind(_this);
    _this.handleClose = _this.avatarEditorModalHandler.bind(_this);
    _this.state = {
      active: false,
      completed: false,

      display_name: props.user.display_name,
      availability: props.user.availability,
      living_situation: props.user.living_situation,
      regularity: props.user.regularity,
      bio: props.user.bio,
      pet_insurance: props.user.pet_insurance,
      police_checked: props.user.police_checked,
      suburb: props.user.suburb ? props.user.suburb.id : null,

      interests: props.user.interests.map(function (interest) {
        return interest.id;
      }),
      needs: props.user.needs.map(function (need) {
        return need.id;
      }),

      profile_photo_updated: false,
      profile_photo_deleted: false,
      profile_photo: props.user.profile_photo,
      profile_photo_size: props.user.profile_photo_size,
      profile_photo_file: props.user.profile_photo_file,
      avatarPhoto: [],
      avatarPhotoRotation: null,

      errors: {
        photos: false,
        profile_photo_error: false,
        suburb: false
      }
    };

    _this.availability = __WEBPACK_IMPORTED_MODULE_10__utils__["c" /* availability */];
    _this.living_situations = __WEBPACK_IMPORTED_MODULE_10__utils__["d" /* livingSituations */];
    _this.regularity = __WEBPACK_IMPORTED_MODULE_10__utils__["e" /* regularity */];
    return _this;
  }

  _createClass(JoinDetails, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          active: true
        });
      }, 100);

      setTimeout(function () {
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__actions_applicationState__["a" /* updateAppState */])({
          loading: false
        }));
      }, 750);
    }
  }, {
    key: 'setEditorRef',
    value: function setEditorRef(editor) {
      this.editor = editor;
    }
  }, {
    key: 'getFieldsToStore',
    value: function getFieldsToStore() {
      var fields = {
        display_name: this.state.display_name,
        availability: this.state.availability,
        living_situation: this.state.living_situation,
        regularity: this.state.regularity,
        bio: this.state.bio,
        pet_insurance: this.state.pet_insurance,
        police_checked: this.state.police_checked,
        suburb: this.state.suburb && this.state.suburb.value > 0 ? this.state.suburb.value : null,

        interests: this.state.interests,
        needs: this.state.needs
      };

      if (this.state.profile_photo_updated) {
        fields.profile_photo = this.state.profile_photo;
        fields.profile_photo_size = this.state.profile_photo_size;
        fields.profile_photo_file = this.state.profile_photo_file;
      }

      return fields;
    }
  }, {
    key: 'avatarEditorModalHandler',
    value: function avatarEditorModalHandler() {
      this.setState({
        avatar_editor_modal_open: !this.state.avatar_editor_modal_open
      });
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(name, id, value) {
      var _this3 = this;

      if (value) {
        this.addKey(name, id);
      } else {
        this.removeKey(name, id);
      }

      setTimeout(function () {
        if (_this3.state.errors[name]) {
          // If there is an error against this field, attempt to revalidate
          _this3.validateForm();
        }
      }, 10);
    }
  }, {
    key: 'updateTextField',
    value: function updateTextField(key, value) {
      var _this4 = this;

      var updatedState = _defineProperty({}, key, value);

      this.setState(updatedState);

      setTimeout(function () {
        if (_this4.state.errors[key]) {
          // If there is an error against this field, attempt to revalidate
          _this4.validateForm();
        }
      }, 10);
    }

    // Add a unique key to array in state

  }, {
    key: 'addKey',
    value: function addKey(name, key) {
      var state = this.state;
      var inArray = state[name].find(function (obj) {
        return obj === key;
      });

      // If the item is not already in the array, add it. Otherwise return state
      this.setState(_defineProperty({}, name, !inArray ? state[name].concat([key]) : state));
    }

    // Remove key from an array in state

  }, {
    key: 'removeKey',
    value: function removeKey(name, key) {
      var state = this.state;

      this.setState(_defineProperty({}, name, state[name].filter(function (obj) {
        return obj !== key;
      })));
    }
  }, {
    key: 'handleClearImage',
    value: function handleClearImage() {
      this.setState({
        profile_photo_updated: false,
        profile_photo_deleted: true,
        profile_photo: null
      });
    }
  }, {
    key: 'handleFileDrop',
    value: function handleFileDrop(acceptedFiles, rejectedFiles) {
      var _this5 = this;

      acceptedFiles.forEach(function (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          var fileAsDataURL = reader.result;

          _this5.setState({
            profile_photo_updated: true,
            profile_photo_deleted: false,
            profile_photo: fileAsDataURL,
            profile_photo_size: file.size,
            profile_photo_file: file.name
          });
        };
      });

      if (rejectedFiles && rejectedFiles.length) {
        this.setState({
          errors: Object.assign({}, this.state.errors, {
            photos: '1 or more images did not upload. Must be JPG or PNG, and below 2MB.'
          })
        });
      } else {
        this.setState({
          errors: Object.assign({}, this.state.errors, {
            photos: false
          })
        });
      }
    }
  }, {
    key: 'handleAvatarFileDrop',
    value: function handleAvatarFileDrop(acceptedFiles, rejectedFiles) {
      var _this6 = this;

      acceptedFiles.forEach(function (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          var fileAsDataURL = reader.result;

          if (!_this6.state.avatarPhoto.length) {
            _this6.setState({
              avatar_editor_modal_open: true,
              profile_photo_deleted: false,
              avatarPhoto: {
                id: null,
                remote: false,
                src: fileAsDataURL,
                size: file.size,
                file_name: file.name
              }
            });
          }
        };
      });

      if (rejectedFiles && rejectedFiles.length) {
        this.setState({
          errors: Object.assign({}, this.state.errors, {
            photos: '1 or more images did not upload. Must be JPG or PNG, and below 2MB.'
          })
        });
      } else {
        this.setState({
          errors: Object.assign({}, this.state.errors, {
            photos: false
          })
        });
      }
    }
  }, {
    key: 'handleImageRotation',
    value: function handleImageRotation() {
      var angle = (this.state.avatarPhotoRotation + 90) % 360;
      this.setState({
        avatarPhotoRotation: angle
      });
    }
  }, {
    key: 'handleAvatarSaveImage',
    value: function handleAvatarSaveImage() {
      var avatarPhoto = this.state.avatarPhoto;
      var canvasImage = this.editor.props;
      var newImage = this.editor.getImage();
      this.setState({
        avatar_editor_modal_open: false,
        profile_photo_updated: true,
        profile_photo_deleted: false,
        profile_photo: newImage.toDataURL('image/jpeg', 0.8),
        profile_photo_size: avatarPhoto.size,
        profile_photo_file: avatarPhoto.name,
        profile_photo_rotation: canvasImage.rotate
      });
    }
  }, {
    key: 'fileSize',
    value: function fileSize(b) {
      var u = 0;
      var s = 1024;

      while (b >= s || -b >= s) {
        b /= s; //eslint-disable-line
        u += 1;
      }
      return (u ? b.toFixed(1) + ' ' : b) + ' KMGTPEZY'[u] + 'B';
    }
  }, {
    key: 'handleSave',
    value: function handleSave(published) {
      var _this7 = this;

      if (!this.validateForm() && published) {
        // If the user is trying to publish, the form must validate.
        // The user can save an incomplete form only if it's a draft
        return false;
      }

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        return _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_user__["g" /* updateUserRemote */])(Object.assign({}, _this7.getFieldsToStore(), {
          published: published
        }), _this7.props.user.access_token)).then(function () {
          _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));

          if (_this7.props.user.subscription === 'Owner') {
            _this7.props.history.push('/join/pooch');
          } else {
            _this7.props.history.push('/join/complete');
          }
        });
      }, function () {
        _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__actions_applicationState__["a" /* updateAppState */])({
          loading: false
        }));
      });

      return true;
    }

    // Validate the form

  }, {
    key: 'validateForm',
    value: function validateForm() {
      var errors = {};

      if (!this.state.display_name || !this.state.display_name.length > 0) {
        errors.display_name = 'Please enter your Name / Nickname';
      } else {
        errors.display_name = null;
      }

      if (!this.state.suburb || this.state.suburb.value === 0) {
        errors.suburb = 'Please select your suburb';
      } else {
        errors.suburb = null;
      }

      if (this.props.user.subscription === 'Borrower' && (!this.state.availability || !this.state.availability.length > 0)) {
        errors.availability = 'Please enter your availability';
      } else {
        errors.availability = null;
      }

      if (this.props.user.subscription === 'Borrower' && (!this.state.living_situation || !this.state.living_situation.length > 0)) {
        errors.living_situation = 'Please enter your living situation';
      } else {
        errors.living_situation = null;
      }

      if (this.props.user.subscription === 'Borrower' && (!this.state.regularity || !this.state.regularity.length > 0)) {
        errors.regularity = 'Please enter your regularity';
      } else {
        errors.regularity = null;
      }

      if (!this.state.bio || !this.state.bio.length > 0) {
        errors.bio = 'Please enter your bio';
      } else {
        errors.bio = null;
      }

      if (!this.state.profile_photo || !this.state.profile_photo.length > 0) {
        errors.profile_photo_error = 'To save your profile as complete, please upload your photo.';
      } else {
        errors.profile_photo_error = null;
      }

      var formErrors = false;

      for (var key in errors) {
        //eslint-disable-line
        if (errors[key] !== null) {
          formErrors = true;
        }
      }

      if (formErrors) {
        this.setState({
          errors: errors
        });

        return false;
      }

      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var selectedNeeds = this.state.needs;
      var selectedInterests = this.state.interests;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.container, this.state.active ? styles.container_active : null, this.state.completed ? styles.container_completed : null) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14__components_ContentContainer__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, {
            cacheGetRequests: true,
            src: EDITICON_ASSET,
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.icon)
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.heading) },
            'Thanks ' + this.props.user.first_name + '. You\'re in!',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            'Let\'s',
            ' set up your ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.highlight) },
              'profile'
            ),
            '.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.main) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.form) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_HorizontalRule__["a" /* default */], { pin: true }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.sub_heading) },
                'Personal information'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_TextField__["a" /* default */], {
                id: 'display_name',
                name: 'display_name',
                label: 'Name/Nickname',
                required: true,
                value: this.state.display_name,
                handler: this.setValue,
                error: this.state.errors.display_name
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.select_parent_container) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.select_container) },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_Select__["a" /* default */], {
                    id: 'suburb',
                    name: 'suburb',
                    options: this.props.appdata.suburb.map(function (suburb) {
                      return {
                        value: suburb.id,
                        label: suburb.title + ', ' + suburb.district.title
                      };
                    }),
                    label: 'Suburb',
                    required: true,
                    value: this.state.suburb,
                    type: 'location',
                    handler: this.setValue,
                    style: styles.select_style
                  })
                )
              ),
              this.props.user.subscription === 'Borrower' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_SimpleSelect__["a" /* default */], {
                id: 'availability',
                name: 'availability',
                options: this.availability,
                label: 'Availability',
                required: true,
                value: this.state.availability,
                handler: this.setValue,
                error: this.state.errors.availability
              }) : null,
              this.props.user.subscription === 'Borrower' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_SimpleSelect__["a" /* default */], {
                id: 'living_situation',
                name: 'living_situation',
                options: this.living_situations,
                label: 'Living situation',
                value: this.state.living_situation,
                handler: this.setValue,
                error: this.state.errors.living_situation,
                required: true
              }) : null,
              this.props.user.subscription === 'Borrower' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_SimpleSelect__["a" /* default */], {
                id: 'regularity',
                name: 'regularity',
                options: this.regularity,
                label: 'Regularity desired',
                required: true,
                value: this.state.regularity,
                handler: this.setValue,
                error: this.state.errors.regularity
              }) : null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_TextField__["a" /* default */], {
                id: 'bio',
                name: 'bio',
                label: 'About me',
                textArea: true,
                fullWidth: true,
                showRemaining: true,
                limit: 1000,
                height: 85,
                required: true,
                value: this.state.bio,
                handler: this.setValue,
                error: this.state.errors.bio
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.checkboxes) },
                this.props.user.subscription === 'Owner' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_CheckboxField__["a" /* default */], {
                  id: 'pet_insurance',
                  name: 'pet_insurance',
                  label: 'I have pet insurance',
                  tooltip: 'Do you have pet insurance secured for your pooch?',
                  required: true,
                  value: this.state.pet_insurance,
                  handler: this.setValue
                }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_CheckboxField__["a" /* default */], {
                  id: 'police_checked',
                  name: 'police_checked',
                  label: 'I have been police checked',
                  tooltip: 'Do you hold a Police Check? You can indicate this to increase your personal trust profile.',
                  required: true,
                  value: this.state.police_checked,
                  handler: this.setValue
                })
              ),
              this.props.user.subscription === 'Borrower' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_HorizontalRule__["a" /* default */], { pin: true }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h2',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.sub_heading) },
                  'I\'m good with...'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.paragraph) },
                  'Select as many that are relevant to you.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.check_buttons) },
                  this.props.appdata.need.map(function (need) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_CheckButton__["a" /* default */], {
                      id: need.id,
                      name: 'needs',
                      label: need.title,
                      onSelect: _this8.selectHandler,
                      selected: selectedNeeds.find(function (selectedNeed) {
                        return need.id === selectedNeed || need.id === selectedNeed.id;
                      }) });
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_HorizontalRule__["a" /* default */], { pin: true }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h2',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.sub_heading) },
                  'I\'m interested in...'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.paragraph) },
                  'Select as many that are relevant to you.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.check_buttons) },
                  this.props.appdata.interest.map(function (interest) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_CheckButton__["a" /* default */], {
                      id: interest.id,
                      name: 'interests',
                      label: interest.title,
                      onSelect: _this8.selectHandler,
                      selected: selectedInterests.find(function (selectedInterest) {
                        return interest.id === selectedInterest || interest.id === selectedInterest.id;
                      }) });
                  })
                )
              ) : null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_HorizontalRule__["a" /* default */], { pin: true }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.sub_heading) },
                'Upload a profile photo'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.paragraph) },
                'You can add one photo of yourself, each image has to be below 2MB, and be in .jpg or .png format. For security purposes, the image must clearly be a picture of you (not your dog)!'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.avatarEditor) },
                this.state.avatarPhoto.src ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_modal___default.a,
                  {
                    isOpen: this.state.avatar_editor_modal_open,
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.modal_container),
                    onRequestClose: this.handleClose,
                    style: {
                      overlay: {
                        backgroundColor: 'rgba(0,0,0,0.67)',
                        zIndex: 101,
                        display: 'flex'
                      }
                    },
                    contentLabel: 'Photo Editor'
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.modal_wrapper) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.header) },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h2',
                        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.modal_title) },
                        'Photo Editor'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.body) },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.avatarCanvas) },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_avatar_editor___default.a, {
                          ref: this.editorRef,
                          image: this.state.avatarPhoto.src,
                          width: 250,
                          height: 250,
                          color: [255, 255, 255, 0.6] // RGBA
                          , scale: 1.2,
                          rotate: this.state.avatarPhotoRotation
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.actions_container) },
                      this.state.avatarPhoto.src ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        {
                          role: 'button',
                          tabIndex: 0,
                          onClick: this.handleRotation },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.rotate_icon),
                          src: ROTATE_ICON,
                          alt: 'rotate'
                        })
                      ) : false,
                      this.state.avatarPhoto.src ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        {
                          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.avatarAction),
                          onClick: this.avatarSaveImage },
                        'Save Photo'
                      ) : false
                    )
                  )
                ) : false
              ),
              this.state.profile_photo ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.image_info_container) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.file_image) },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                    alt: 'Profile',
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.profile_photo),
                    src: this.state.profile_photo })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.file_info) },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.file_name) },
                    this.state.profile_photo_file
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.file_size) },
                    this.state.profile_photo_updated ? this.fileSize(this.state.profile_photo_size) : this.state.profile_photo_size
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: this.clearImage,
                      className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.clear_image),
                      role: 'link',
                      tabIndex: 0 },
                    'Remove picture'
                  )
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_dropzone__["a" /* default */],
                {
                  maxSize: 2097152,
                  multiple: false,
                  accept: 'image/jpeg, image/png, image/bmp',
                  onDrop: this.editAvator,
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.dropzone) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, {
                  cacheGetRequests: true,
                  src: UPLOAD_ASSET,
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.dropzone_icon)
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  'Drop files to attach or',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.dropzone_browse, styles.highlight) },
                    ' browse'
                  )
                )
              ),
              this.state.errors.photos ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_ErrorContainer__["a" /* default */], { message: this.state.errors.photos }) : null,
              this.state.errors.profile_photo_error ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_ErrorContainer__["a" /* default */], { message: this.state.errors.profile_photo_error }) : null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_HorizontalRule__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.actions) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  {
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.draft),
                    onClick: this.saveDraft },
                  'Save as Draft'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  {
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.publish),
                    onClick: this.savePublish },
                  'Save As Complete'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_tippy__["Tooltip"],
                  {
                    position: 'bottom',
                    arrow: true,
                    html: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.actions_tooltip) },
                      'Your borrower / owner profile remains private, until you request to share a dog (borrower version) / accept a dog share request (owner version)'
                    )
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg___default.a, {
                    cacheGetRequests: true,
                    src: TOOLTIP_ASSET,
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.actions_tooltip_trigger)
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return JoinDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

JoinDetails.propTypes = {
  appdata: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_3_aphrodite__["StyleSheet"].create((_StyleSheet$create = {
  actions_tooltip: {
    padding: 5,
    fontSize: 14,
    fontFamily: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_family_primary
  },
  actions_tooltip_trigger: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 10px',
    cursor: 'pointer'
  },
  check_buttons: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -4.5px'
  },
  highlight: {
    color: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].primary
  },
  checkboxes: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    marginBottom: 30
  },
  dropzone: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 94,
    width: '100%',
    fontFamily: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_family_primary,
    backgroundColor: '#f2f2f2',
    border: '1px dashed #39b4d6',
    cursor: 'pointer'
  },
  dropzone_icon: {
    display: 'block',
    marginRight: 15
  },
  dropzone_browse: {
    fontWeight: 900
  },
  icon: {
    display: 'block',
    width: 159,
    margin: '0 auto 20px'
  },
  container: {
    padding: '86px 0 ' + __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].footer.height + 'px',
    transition: 'transform 500ms',
    transform: 'translateX(100vw)'
  },
  select_parent_container: _defineProperty({
    position: 'relative',
    padding: '0px 5px',
    marginBottom: '5px',
    width: '50%'

  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  select_container: _defineProperty({
    position: 'relative',
    zIndex: 10,
    width: '100%'

  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  select_style: _defineProperty({
    width: '100%',
    height: '48px'
  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  container_active: {
    transform: 'translateX(0)'
  },
  container_completed: {
    transform: 'translateX(-100vw)'
  },
  main: _defineProperty({
    width: 750,
    margin: '0 auto'

  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  heading: {
    marginBottom: 30,
    textAlign: 'center',
    fontSize: 30,
    lineHeight: 1.17,
    fontFamily: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_weight_heading
  },
  sub_heading: {
    width: '100%',
    padding: '0 5px',
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 500,
    fontSize: 20,
    color: '#000e1f'
  },
  paragraph: {
    width: '100%',
    padding: '0 5px',
    marginTop: -15,
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14,
    color: '#828282',
    lineHeight: 1.4
  },
  form: _defineProperty({
    display: 'flex',
    flexWrap: 'wrap',
    width: 750,
    margin: '0 -5px'

  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    margin: 0
  }),
  actions: _defineProperty({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'

  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column'
  }),
  draft: _defineProperty({
    width: 340,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_weight_secondary,
    color: '#39b4d6',
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].white,
    cursor: 'pointer',
    outline: 'none'

  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  publish: _defineProperty({
    width: 340,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_weight_secondary,
    color: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: '#56C5FF',
    cursor: 'pointer',
    outline: 'none'

  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  profile_photo: {
    maxWidth: 150,
    maxHeight: 150,
    objectFit: 'contain'
  },
  image_info_container: {
    display: 'flex',
    flexDirection: 'row'
  },
  file_image: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  file_info: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 25,
    justifyContent: 'center',
    alignItems: 'flex-start'
  },
  file_name: {
    marginBottom: 5
  },
  file_size: {
    fontWeight: 'light',
    color: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].dark_grey
  },
  clear_image: {
    marginTop: 10,
    cursor: 'pointer',
    color: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].teal,
    fontWeight: 'bold'
  },
  avatarEditor: {
    width: '100%',
    padding: 50
  },
  avatarCanvas: {
    display: 'flex',
    justifyContent: 'center',
    borderWidth: 2,
    borderColor: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].baby_blue,
    borderStyle: 'dashed'
  }
}, _defineProperty(_StyleSheet$create, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].desktop_query, {
  body: {
    padding: 5,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  }
}), _defineProperty(_StyleSheet$create, 'modal_container', _defineProperty({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  width: 590,
  maxWidth: '100vw',
  minHeight: 0,
  maxHeight: '100vh',
  backgroundColor: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].white,
  borderRadius: 5,
  overflow: 'hidden',
  outline: 'none',
  margin: 'auto auto'
}, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
  width: 'calc(100% - 30px)',
  minHeight: '0',
  maxHeight: 'none',
  height: 'auto'
})), _defineProperty(_StyleSheet$create, 'modal_wrapper', _defineProperty({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  height: 600 - 100,
  width: '100%',
  boxSizing: 'border-box',
  padding: '0px 100px'
}, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
  padding: '0px 20px 180px'
})), _defineProperty(_StyleSheet$create, 'actions_container', _defineProperty({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%'
}, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
  flexWrap: 'wrap'
})), _defineProperty(_StyleSheet$create, 'rotate_icon', {
  width: 35,
  marginTop: 10,
  marginRight: 25
}), _defineProperty(_StyleSheet$create, 'modal_title', {
  fontFamily: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_family_heading,
  fontSize: 24,
  fontWeight: '600',
  textAlign: 'center',
  padding: 25
}), _defineProperty(_StyleSheet$create, 'avatarAction', _defineProperty({
  width: 200,
  height: 50,
  marginTop: 8,
  fontSize: 15,
  letterSpacing: 2,
  lineHeight: '50px',
  fontFamily: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_family_secondary,
  fontWeight: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_weight_secondary,
  color: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].white,
  textTransform: 'uppercase',
  border: 0,
  borderRadius: 5,
  backgroundColor: '#56C5FF',
  cursor: 'pointer',
  outline: 'none'
}, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
  width: '100%'
})), _StyleSheet$create));

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_10__utils__["b" /* mapDispatchToProps */])(JoinDetails));

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AcceptanceConditionsModal__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SubscriptionCard__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Borrower_svg__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Borrower_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Borrower_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Owner_svg__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Owner_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Owner_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var JoinSubscription = function (_Component) {
  _inherits(JoinSubscription, _Component);

  function JoinSubscription(props) {
    _classCallCheck(this, JoinSubscription);

    var _this = _possibleConstructorReturn(this, (JoinSubscription.__proto__ || Object.getPrototypeOf(JoinSubscription)).call(this, props));

    _this.toggleConditions = _this.toggleConditions.bind(_this);
    _this.toggleConditionsPopup = _this.toggleConditionsPopup.bind(_this);
    _this.setSelected = _this.setSelected.bind(_this);
    _this.state = {
      selected: _this.props.user.subscription ? _this.props.user.subscription : 'Borrower',
      completed: false
    };
    return _this;
  }

  _createClass(JoinSubscription, [{
    key: 'setSelected',
    value: function setSelected(id) {
      this.setState({
        selected: id
      });
    }
  }, {
    key: 'continue',
    value: function _continue() {
      var _this2 = this;

      this.toggleConditions();
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_user__["c" /* updateUser */])({
        subscription: this.state.selected
      }));

      this.setState({
        completed: true
      }, function () {
        setTimeout(function () {
          return _this2.props.history.push('/join/details');
        }, 300);
      });
    }
  }, {
    key: 'toggleConditionsPopup',
    value: function toggleConditionsPopup() {
      this.toggleConditions();
    }
  }, {
    key: 'toggleConditions',
    value: function toggleConditions() {
      this.setState({
        showAcceptanceConditions: !this.state.showAcceptanceConditions
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var Continue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["g" /* withRouter */])(function (_ref) {
        var history = _ref.history;
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'button',
          {
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.continue),
            onClick: _this3.toggleConditionsPopup,
            history: history,
            onClickPass: _this3.continue
          },
          'Continue',
          _this3.state.selected ? ' as ' + _this3.state.selected : false
        );
      });
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        {
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container, this.state.completed ? styles.container_completed : null)
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__components_ContentContainer__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__components_AcceptanceConditionsModal__["a" /* default */],
            {
              open: this.state.showAcceptanceConditions,
              toggle: this.toggleConditions,
              history: history,
              onClickPass: function onClickPass() {
                _this3.continue(history);
              }
            },
            this.state.AcceptanceConditions
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h1',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.heading) },
            'Select your subscription'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cards) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_SubscriptionCard__["a" /* default */], {
              id: 'Owner',
              icon: __WEBPACK_IMPORTED_MODULE_12__Owner_svg___default.a,
              title: 'I own dogs I\'d like to share',
              includes: ['Connect with Unlimited Dog Lovers', 'List all your Dogs - find compatible local Dog Lovers and/or Dogs', 'Travelling? Find In-Home Dog Sitters when your dog wants to stay home', 'Remain anonymous until you Accept a Match', 'Verified and Reviewed Dog Borrowers/ Sitters', 'Member Support Services'],
              price: 49.99,
              promoPrice: 30.0,
              promoTitle: '#COLLECTIVEGIVING',
              promoText: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'span',
                null,
                'One year subscription for $30.00 ',
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
                '100% Pooch Pleasure Guarantee: No connections in your first year? Get your second year FREE!'
              ),
              conditions: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'ul',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conditions_list) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'li',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conditions_list_item) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'p',
                    null,
                    'I am the legal owner/ guardian of my dog(s).'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'li',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conditions_list_item) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'p',
                    null,
                    'My dog(s) is registered.'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'li',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conditions_list_item) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'p',
                    null,
                    'My dog(s) is safe to share - healthy, over 3 months of age, not registered as \u2018dangerous\u2019 or \u2018menacing\u2019 dog.'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'li',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conditions_list_item) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'p',
                    null,
                    'I am over 18 years of age.'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'li',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conditions_list_item) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'p',
                    null,
                    'I have not been convicted of an offence under the Dog Control Act (1996), Parts 1 and 2 of Animal Welfare Act (1999), s26ZZP of the Conservation Act (1987) or s56I of the National Parks Act (1980).'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'li',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conditions_list_item) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'p',
                    null,
                    'I have read the Terms of Service and will comply with Member Code of Conduct.'
                  )
                )
              ),
              selected: this.state.selected,
              handleSelect: this.setSelected
            }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_SubscriptionCard__["a" /* default */], {
              id: 'Borrower',
              icon: __WEBPACK_IMPORTED_MODULE_11__Borrower_svg___default.a,
              title: 'I want to find a dog to share',
              includes: ['Connect with Unlimited Dogs', 'Find a compatible local pooch. Receive notifications of Accepted Dog Shares', 'Up for National Travel and Free accom, with a Dog-Fix? Go In-Home Dog Sitting', 'Remain anonymous until you Request a Match', 'Verified and Reviewed Dog Owners', 'Member Support Services'],
              price: 49.99,
              promoPrice: 30.0,
              promoTitle: '#COLLECTIVEGIVING',
              promoText: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'span',
                null,
                'One year subscription for $30.00 ',
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
                '100% Pooch Pleasure Guarantee: No connections in your first year? Get your second year FREE!'
              ),
              conditions: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'ul',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conditions_list) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'li',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conditions_list_item) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'p',
                    null,
                    'I am over 18 years of age.'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'li',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conditions_list_item) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'p',
                    null,
                    'I have not been convicted of an offence under the Dog Control Act (1996), Parts 1 and 2 of Animal Welfare Act (1999), s26ZZP of the Conservation Act (1987) or s56I of the National Parks Act (1980).'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'li',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conditions_list_item) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'p',
                    null,
                    'I have read the Terms of Service and will comply with Member Code of Conduct.'
                  )
                )
              ),
              selected: this.state.selected,
              handleSelect: this.setSelected
            })
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.selection_type) },
            'You',
            "'",
            've selected ',
            this.state.selected === 'Owner' ? 'an' : 'a',
            ' ',
            '"',
            this.state.selected,
            '"',
            ' subscription.'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.actions) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Continue, null)
          )
        )
      );
    }
  }]);

  return JoinSubscription;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

JoinSubscription.propTypes = {
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    padding: '86px 0 ' + __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].footer.height + 'px',
    transition: 'transform 500ms'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    padding: '50px 15px'
  }),
  container_completed: {
    transform: 'translateX(-100vw)'
  },
  heading: _defineProperty({
    marginBottom: 42,
    textAlign: 'center',
    fontSize: 45,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_heading

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 28
  }),
  cards: _defineProperty({
    display: 'flex',
    justifyContent: 'center'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column'
  }),
  selection_type: _defineProperty({
    display: 'flex',
    justifyContent: 'center',
    marginTop: 60,
    marginBottom: 20,
    fontWeight: 'bold',
    textAlign: 'center'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    marginTop: 30,
    marginBottom: 30,
    fontSize: 14
  }),
  actions: _defineProperty({
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    marginTop: 0
  }),
  continue: {
    width: 340,
    height: 50,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_secondary,
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].primary,
    cursor: 'pointer',
    outline: 'none'
  },
  conditions_list_item: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_primary,
    marginBottom: 20,
    fontSize: 15,
    lineHeight: '1.4'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* mapDispatchToProps */])(JoinSubscription));

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Body__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_UnauthenticatedHeader__ = __webpack_require__(17);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable */













var styles = void 0;

var Verify = function (_Component) {
  _inherits(Verify, _Component);

  function Verify(props) {
    _classCallCheck(this, Verify);

    var _this = _possibleConstructorReturn(this, (Verify.__proto__ || Object.getPrototypeOf(Verify)).call(this, props));

    _this.state = {
      verified: false,
      verifyingSent: false
    };

    _this.openLoginHandler = _this.loginModalOpenHandler.bind(_this);
    _this.resendVerification = _this.resendVerification.bind(_this);
    return _this;
  }

  _createClass(Verify, [{
    key: 'loginModalOpenHandler',
    value: function loginModalOpenHandler() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions_applicationState__["a" /* updateAppState */])({
        login_modal_open: true
      }));
    }
  }, {
    key: 'resendVerification',
    value: function resendVerification() {
      var _this2 = this;

      this.setState({
        verifyingSent: true
      });
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_user__["h" /* resendVerification */])(this.props.user.email)).then(function (response) {
        if (response.status === 200) {
          _this2.setState({
            verifyingSent: true
          });
        } else {
          _this2.setState({
            verifyingSent: false
          });
        }
      }, function (err) {
        if (err.status === 503) {
          _this2.setState({
            verified: true
          });
          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_user__["i" /* getCurrentMember */])(_this2.props.user.id, _this2.props.user.access_token)).then(function (response) {
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_user__["c" /* updateUser */])(response));

            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions_applicationState__["a" /* updateAppState */])({
              loading: false
            }));
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__components_Body__["a" /* default */],
        { hasFooter: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_UnauthenticatedHeader__["a" /* default */], { openLoginHandler: this.openLoginHandler }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.subtitle) },
            'Thank you for joining The Dog Share Collective.'
          ),
          this.state.verified ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.paragraph) },
            'Your account is already verified.'
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            this.state.verifyingSent ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.paragraph) },
              'Your email verification has been resent.'
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.paragraph) },
              'To finish activating your account, please follow the link in the email we have sent you. If you need another email verifiction please click ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.anchor), onClick: this.resendVerification },
                'here'
              ),
              '.'
            )
          )
        )
      );
    }
  }]);

  return Verify;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Verify.propTypes = {
  dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

styles = __WEBPACK_IMPORTED_MODULE_3_aphrodite__["StyleSheet"].create({
  container: {
    padding: '70px 15px',
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 515,
    marginTop: 80,
    flexDirection: 'column'
  },
  title: _defineProperty({
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 60,
    fontWeight: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_weight_heading,
    color: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].black,
    marginBottom: 30

  }, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 45
  }),
  subtitle: _defineProperty({
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 40,
    fontWeight: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_weight_heading,
    color: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].black,
    marginBottom: 30

  }, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 25
  }),
  message: _defineProperty({
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 30,
    fontWeight: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_weight_heading,
    color: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].black

  }, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 25
  }),
  login_link: {
    cursor: 'pointer'
  },
  anchor: {
    cursor: 'pointer'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_4__utils__["b" /* mapDispatchToProps */])(Verify));

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__View__ = __webpack_require__(248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__View__["a"]; });


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DogCard__ = __webpack_require__(37);
var _more, _cards;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var PLUS_ASSET = __webpack_require__(360);

var Matches = function (_Component) {
  _inherits(Matches, _Component);

  function Matches(props) {
    _classCallCheck(this, Matches);

    var _this = _possibleConstructorReturn(this, (Matches.__proto__ || Object.getPrototypeOf(Matches)).call(this, props));

    _this.state = {};

    _this.redirect = _this.redirectToFind.bind(_this);
    return _this;
  }

  _createClass(Matches, [{
    key: 'getMatches',
    value: function getMatches() {
      var matches = this.props.user.matches;
      var relevantMatches = matches && matches.length ? matches.filter(function (match) {
        return match.status === 'Accepted' || match.status === 'Declined' || match.status === 'Pending';
      }) : false;

      return relevantMatches && relevantMatches.length ? relevantMatches : false;
    }
  }, {
    key: 'redirectToFind',
    value: function redirectToFind() {
      this.props.history.push('/find');
    }

    /**
     * Check if the user has an active subscription.
     * @NOTE: This should be split into a utility function
     * but the way that the store has been implemented would require refactoring.
     */

  }, {
    key: 'isSubscriptionActive',
    value: function isSubscriptionActive() {
      var user = this.props.user;


      if (!user) {
        return false;
      }

      var ACTIVE = user.active_subscription;


      return ACTIVE;
    }
  }, {
    key: 'renderMatches',
    value: function renderMatches() {
      var _this2 = this;

      var matches = this.getMatches();

      return matches ? matches.map(function (match) {
        var isBorrower = _this2.props.user.id === match.borrower.id;

        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_DogCard__["a" /* default */], {
          member: !isBorrower,
          id: isBorrower ? match.dog.id : match.borrower.id,
          image: isBorrower ? match.dog.image_url : match.borrower.profile_photo,
          name: isBorrower ? match.dog.name : match.borrower.display_name,
          breed: isBorrower ? match.dog.breed : false,
          summary: isBorrower ? match.dog.about : match.borrower.bio,
          status: match.status.toLowerCase()
        });
      }) : false;
    }
  }, {
    key: 'renderList',
    value: function renderList() {
      if (!this.isSubscriptionActive()) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cards) },
        this.renderMatches(),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { tabIndex: 0, role: 'button', onClick: this.redirect, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.more) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: PLUS_ASSET, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.more_icon) }),
          'Find more Dogs'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container) },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__components_ContentContainer__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h1',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.heading) },
            'My Dog Shares'
          ),
          this.renderList()
        )
      );
    }
  }]);

  return Matches;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Matches.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  more_icon: {
    display: 'block',
    marginBottom: 21,

    ':not(.a) > svg > g': {
      transition: 'all 300ms'
    }
  },
  more: (_more = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 262,
    minWidth: 262,
    padding: '100px 18px',
    margin: '0 15px 23px',
    backgroundColor: '#f2f2f2',
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#e8e8e8',
    fontSize: 15,
    color: '#39b4d6',
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_secondary,
    textTransform: 'uppercase',
    letterSpacing: 1.3,
    transition: 'all 300ms',
    cursor: 'pointer',

    ':hover': {
      color: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].white,
      backgroundColor: '#39b4d6'
    },

    ':hover > .isvg > svg > g': {
      fill: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].white
    }

  }, _defineProperty(_more, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }), _defineProperty(_more, '@media screen and (min-width: 625px) and (max-width: 768px)', {
    width: 262
  }), _more),
  actions: {
    margin: '0 -5px',

    '@media screen and (max-width: 1170px)': {
      display: 'flex',
      justifyContent: 'center'
    }
  },
  sort: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    fontSize: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_primary,
    marginBottom: 30
  },
  sort_select: {
    padding: 0,
    marginBottom: 0,
    marginLeft: 14,
    width: 135
  },
  cards: (_cards = {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -15px -15px'

  }, _defineProperty(_cards, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0 20px'
  }), _defineProperty(_cards, '@media screen and (max-width: 1170px)', {
    justifyContent: 'center'
  }), _cards),
  container: {
    paddingTop: 75,
    paddingBottom: 150
  },
  heading: {
    marginBottom: 60,
    textAlign: 'center',
    fontSize: 45,
    lineHeight: 2.09,
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_heading
  },
  title: {
    marginBottom: 30,
    textAlign: 'center',
    fontSize: 30,
    lineHeight: 1.17,
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_heading
  },
  sub_heading: {
    position: 'relative',
    width: '100%',
    padding: '0 5px',
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 400,
    fontSize: 18,
    color: '#000e1f',
    textAlign: 'center'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["g" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_7__utils__["b" /* mapDispatchToProps */])(Matches)));

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_toastify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_messaging__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_pooch__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_profile__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ActivityBadge__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_MatchResponseModal__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_NotificationBar__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_ReportModal__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Reviews__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ViewProfileCard__ = __webpack_require__(103);
var _bullet_item;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var CHECK_ICON = __webpack_require__(361);
var LOCATION_ICON = __webpack_require__(364);
var PAW_ICON = __webpack_require__(365);
var ENVELOPE_ICON = __webpack_require__(363);
var CROSS_ICON = __webpack_require__(362);
var PREVIEW_ICON = __webpack_require__(366);
var WARNING_ICON = __webpack_require__(367);

var MemberProfile = function (_Component) {
  _inherits(MemberProfile, _Component);

  function MemberProfile(props) {
    _classCallCheck(this, MemberProfile);

    var _this = _possibleConstructorReturn(this, (MemberProfile.__proto__ || Object.getPrototypeOf(MemberProfile)).call(this, props));

    _this.fetchProfile = _this.fetchProfile.bind(_this);
    _this.reportModalHandler = _this.openReportModalHandler.bind(_this);
    _this.writeReviewModalHandler = _this.writeReviewModalOpenHandler.bind(_this);
    _this.pushReviewHandler = _this.pushReview.bind(_this);
    _this.acceptRequest = _this.acceptRequest.bind(_this);
    _this.endRequest = _this.endRequest.bind(_this);
    _this.declineRequest = _this.declineRequest.bind(_this);
    _this.notNowRequest = _this.notNowRequest.bind(_this);
    _this.toggleResponseModal = _this.toggleResponseModal.bind(_this);
    _this.handleResponseSubmit = _this.handleResponseSubmit.bind(_this);
    _this.handleMessageMember = _this.handleMessageMember.bind(_this);
    _this.state = {
      profile: null,
      profile_reviewable: false,
      open_report_modal: false,
      open_write_review_modal: false,
      response_modal_open: false,
      response_modal_type: 'decline',
      selected_match: null,
      message_loading: false
    };
    return _this;
  }

  _createClass(MemberProfile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchProfile();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.match.params.id !== this.props.match.params.id) {
        this.fetchProfile();
      }
    }
  }, {
    key: 'getPoliceChecked',
    value: function getPoliceChecked() {
      var profile = this.state.profile;

      if (profile && profile.police_checked) {
        return 'Police checked';
      }

      return false;
    }
  }, {
    key: 'getLivingSituationMessage',
    value: function getLivingSituationMessage() {
      var profile = this.state.profile;

      if (profile && profile.living_situation && profile.availability.length) {
        return 'Living Situation: ' + profile.living_situation;
      }

      return false;
    }
  }, {
    key: 'getAvailabilityMessage',
    value: function getAvailabilityMessage() {
      var profile = this.state.profile;

      if (profile && profile.availability && profile.availability.length) {
        return 'Availability: ' + profile.availability;
      }

      return false;
    }
  }, {
    key: 'getRegularityMessage',
    value: function getRegularityMessage() {
      var profile = this.state.profile;

      if (profile && profile.regularity && profile.regularity.length) {
        return 'Regularity: ' + profile.regularity;
      }

      return false;
    }

    // Select the most appropriate name for the profile

  }, {
    key: 'getProfileName',
    value: function getProfileName() {
      return this.state.profile.display_name ? this.state.profile.display_name : this.state.profile.first_name;
    }
  }, {
    key: 'getUserImage',
    value: function getUserImage() {
      var user = this.state.profile;

      if (user.image_url && user.image_url.length > 10) {
        return user.image_url;
      }

      if (user.profile_photo && user.profile_photo.length > 10) {
        return user.profile_photo;
      }

      return '/images/default_profile.jpg';
    }

    // View the match requests from this user

  }, {
    key: 'getMatchRequests',
    value: function getMatchRequests() {
      var _this2 = this;

      var matches = this.props.user.matches;

      return matches && matches.length ? matches.filter(function (match) {
        return match.borrower.id !== _this2.props.user.id && match.borrower.id === _this2.state.profile.id && match.status === 'Pending';
      }) : false;
    }

    // View the active shares between
    // the borrower and owner, validates both
    // scenarios

  }, {
    key: 'getCurrentShares',
    value: function getCurrentShares() {
      var profile = this.state.profile;
      var currentUser = this.props.user;
      var matches = this.props.user.matches;

      var currentSharesWithBorrower = matches && matches.length ? this.props.user.matches.filter(function (match) {
        return match.borrower.id !== currentUser.id && match.borrower.id === profile.id && match.status === 'Accepted';
      }) : false;

      var currentSharesWithOwner = matches && matches.length ? this.props.user.matches.filter(function (match) {
        return parseFloat(match.owner_id) !== currentUser.id && parseFloat(match.owner_id) === profile.id && match.status === 'Accepted';
      }) : false;

      if (currentSharesWithBorrower && currentSharesWithBorrower.length) {
        return currentSharesWithBorrower;
      } else if (currentSharesWithOwner && currentSharesWithOwner.length) {
        return currentSharesWithOwner;
      }

      return false;
    }

    // Returns true if this is the profile of the current authenticated member

  }, {
    key: 'getIsUser',
    value: function getIsUser() {
      var profile = this.state.profile;
      var currentUser = this.props.user;

      return profile && profile.id && profile.id === currentUser.id;
    }
  }, {
    key: 'setProfile',
    value: function setProfile(profile) {
      this.setState({
        profile: profile
      });
    }
  }, {
    key: 'pushReview',
    value: function pushReview(newReview) {
      var _this3 = this;

      // gets current reviews state, iterates through existing
      // and does not add duplicate state values
      var currentReviews = this.state.profile.reviews;
      if (!currentReviews.length) {
        this.setState({
          profile: Object.assign({}, this.state.profile, {
            reviews: [].concat(_toConsumableArray(this.state.profile.reviews), [newReview])
          })
        });
      } else {
        currentReviews.forEach(function (currentReview) {
          if (currentReview.reviewer_id !== newReview.reviewer_id) {
            _this3.setState({
              profile: Object.assign({}, _this3.state.profile, {
                reviews: [].concat(_toConsumableArray(_this3.state.profile.reviews), [newReview])
              })
            });
          }
        });
      }
    }
  }, {
    key: 'writeReviewModalOpenHandler',
    value: function writeReviewModalOpenHandler() {
      this.setState({
        open_write_review_modal: !this.state.open_write_review_modal
      });
    }
  }, {
    key: 'openReportModalHandler',
    value: function openReportModalHandler() {
      this.setState({
        open_report_modal: !this.state.open_report_modal
      });
    }
  }, {
    key: 'profileIsReviewableHandler',
    value: function profileIsReviewableHandler() {
      var _this4 = this;

      // Loop through profile reviews and check if this user
      // has already reviewed this profile
      var reviews = this.state.profile.reviews;
      var canReview = {};
      reviews.forEach(function (review) {
        if (_this4.props.user.id === review.reviewer_id) {
          if (!_this4.getIsUser() && _this4.getCurrentShares() && _this4.props.user.id !== review.reviewer_id) {
            canReview.profile_reviewable = true;
          } else {
            canReview.profile_reviewable = false;
          }
        }
      });

      if (!this.getIsUser() && this.getCurrentShares() && reviews.length === 0) {
        canReview.profile_reviewable = true;
      } else {
        canReview.profile_reviewable = false;
      }

      this.setState(canReview);
    }
  }, {
    key: 'fetchProfile',
    value: function fetchProfile() {
      var _this5 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        _this5.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__actions_profile__["a" /* getMember */])(_this5.props.match.params.id, _this5.props.user.access_token)).then(function (response) {
          _this5.setProfile(response);
          _this5.profileIsReviewableHandler();

          _this5.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        }, function (err) {
          console.log(err); // eslint-disable-line no-console
          _this5.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
          _this5.props.history.push('/404');
        });
      });
    }
  }, {
    key: 'handleMessageMember',
    value: function handleMessageMember(match) {
      var _this6 = this;

      if (!match || !this.props.user || !this.props.user.access_token) {
        return;
      }

      this.setState({
        message_loading: match.id
      });

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_messaging__["a" /* ensureConversationForMatch */])(match.id, this.props.user.access_token)).then(function (conversation) {
        _this6.setState({
          message_loading: false
        });
        _this6.props.history.push('/inbox/' + conversation.id);
      }).catch(function (error) {
        var errorMessage = error && error.data && error.data.error || error.message || 'Unable to open conversation';
        __WEBPACK_IMPORTED_MODULE_6_react_toastify__["b" /* toast */].error(errorMessage);
        _this6.setState({
          message_loading: false
        });
      });
    }
  }, {
    key: 'acceptRequest',
    value: function acceptRequest(matchRequest) {
      var _this7 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__actions_pooch__["h" /* acceptMatch */])(matchRequest.id, _this7.props.user.access_token)).then(function () {
          _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_user__["i" /* getCurrentMember */])(_this7.props.user.id, _this7.props.user.access_token)).then(function (response) {
            _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_user__["c" /* updateUser */])(response));

            _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
              loading: false
            }));
          });
        }, function (err) {
          console.log(err); // eslint-disable-line no-console
          _this7.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        });
      });
    }
  }, {
    key: 'endRequest',
    value: function endRequest(matchRequest) {
      var _this8 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        _this8.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__actions_pooch__["f" /* endMatch */])(matchRequest.id, _this8.props.user.access_token)).then(function () {
          _this8.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_user__["i" /* getCurrentMember */])(_this8.props.user.id, _this8.props.user.access_token)).then(function (response) {
            _this8.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_user__["c" /* updateUser */])(response));

            _this8.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
              loading: false
            }));
          });
        }, function (err) {
          console.log(err); // eslint-disable-line
          _this8.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        });
      });
    }
  }, {
    key: 'declineRequest',
    value: function declineRequest(matchRequest) {
      this.setState({
        selected_match: matchRequest,
        response_modal_type: 'decline',
        response_modal_open: true
      });
    }
  }, {
    key: 'notNowRequest',
    value: function notNowRequest(matchRequest) {
      this.setState({
        selected_match: matchRequest,
        response_modal_type: 'notNow',
        response_modal_open: true
      });
    }
  }, {
    key: 'toggleResponseModal',
    value: function toggleResponseModal() {
      this.setState({
        response_modal_open: !this.state.response_modal_open
      });
    }
  }, {
    key: 'handleResponseSubmit',
    value: function handleResponseSubmit(message) {
      var _this9 = this;

      var matchRequest = this.state.selected_match;
      var actionType = this.state.response_modal_type;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        var action = actionType === 'decline' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__actions_pooch__["i" /* declineMatch */])(matchRequest.id, message, _this9.props.user.access_token) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__actions_pooch__["j" /* notNowMatch */])(matchRequest.id, message, _this9.props.user.access_token);

        _this9.props.dispatch(action).then(function () {
          _this9.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_user__["i" /* getCurrentMember */])(_this9.props.user.id, _this9.props.user.access_token)).then(function (response) {
            _this9.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_user__["c" /* updateUser */])(response));

            _this9.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
              loading: false
            }));
          });
        }, function (err) {
          console.log(err); // eslint-disable-line no-console
          _this9.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        });
      });
    }
  }, {
    key: 'renderCurrentlySharing',
    value: function renderCurrentlySharing() {
      var isUser = this.getIsUser();
      var currentShares = this.getCurrentShares();

      return !isUser && currentShares ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'button',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.action, styles.sharing, styles.no_action) },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, {
          cacheGetRequests: true,
          src: PAW_ICON,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.paw_icon, styles.paw_icon_blue)
        }),
        "You're",
        ' dog sharing'
      ) : false;
    }
  }, {
    key: 'renderMessageAction',
    value: function renderMessageAction() {
      var _this10 = this;

      var isUser = this.getIsUser();
      var currentShares = this.getCurrentShares();

      if (isUser || !currentShares || !currentShares.length) {
        return false;
      }

      var primaryMatch = currentShares[0];
      var isLoading = this.state.message_loading === primaryMatch.id;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'button',
        {
          onClick: function onClick() {
            return _this10.handleMessageMember(primaryMatch);
          },
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.action, styles.message_owner),
          disabled: isLoading
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: ENVELOPE_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.envelope_icon) }),
        isLoading ? 'Opening messages...' : 'Message'
      );
    }
  }, {
    key: 'renderPendingMatchRequests',
    value: function renderPendingMatchRequests() {
      var matchRequests = this.getMatchRequests();

      return matchRequests ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.pending_match_requests) },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'strong',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.pending_title) },
          'Pending match requests'
        )
      ) : false;
    }
  }, {
    key: 'renderDiscontinueSharing',
    value: function renderDiscontinueSharing() {
      var isUser = this.getIsUser();
      var currentShares = this.getCurrentShares();

      return !isUser && currentShares ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'button',
        {
          onClick: this.endRequest.bind(this, currentShares[0]),
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.action, styles.discontinue_sharing)
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: CROSS_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cross_icon) }),
        'Discontinue Sharing'
      ) : false;
    }
  }, {
    key: 'renderReportMember',
    value: function renderReportMember() {
      var isUser = this.getIsUser();
      var currentShares = this.getCurrentShares();

      return !isUser && currentShares ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'a',
        { // eslint-disable-line
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.report_member),
          onClick: this.openReportModalHandler
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: WARNING_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.warning_icon) }),
        'Report member'
      ) : false;
    }
  }, {
    key: 'renderAcceptShare',
    value: function renderAcceptShare() {
      var _this11 = this;

      var matchRequests = this.getMatchRequests();

      return matchRequests ? matchRequests.map(function (match) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { key: match.id },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'button',
            {
              onClick: _this11.acceptRequest.bind(_this11, match),
              className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.action, styles.share_request)
            },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: PAW_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.paw_icon) }),
            'Accept'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'button',
            {
              onClick: _this11.declineRequest.bind(_this11, match),
              className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.action, styles.decline_request)
            },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: CROSS_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cross_icon) }),
            'Decline'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'button',
            {
              onClick: _this11.notNowRequest.bind(_this11, match),
              className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.action, styles.not_now_request)
            },
            'Not Now'
          )
        );
      }) : false;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.body) },
        this.getIsUser() ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_18__components_NotificationBar__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: PREVIEW_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.preview_icon) }),
          'This is how others will view your profile.',
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Link */],
            {
              to: '/profile/' + this.state.profile.id + '/edit',
              className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.notification_link)
            },
            'Edit profile'
          )
        ) : false,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.primary_container) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15__components_ContentContainer__["a" /* default */],
            { styles: styles.container },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.profile) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.gallery) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.gallery_main) },
                  this.state.profile ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', {
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.gallery_photo),
                    src: this.getUserImage(),
                    alt: this.state.profile ? this.getProfileName() : null
                  }) : false
                )
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.details) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'h1',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.name) },
                  this.state.profile ? this.getProfileName() : false
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.location) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, {
                    cacheGetRequests: true,
                    src: LOCATION_ICON,
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.location_icon)
                  }),
                  this.state.profile && this.state.profile.suburb ? this.state.profile.suburb.title + ', ' + this.state.profile.suburb.district.title : 'Location not shared'
                ),
                this.state.profile && this.state.profile.availability ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.socialised) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: CHECK_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.check_icon) }),
                  this.state.profile.availability
                ) : false,
                this.getPoliceChecked() ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.socialised) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: CHECK_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.check_icon) }),
                  this.getPoliceChecked()
                ) : false,
                this.getLivingSituationMessage() ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.socialised) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: CHECK_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.check_icon) }),
                  this.getLivingSituationMessage()
                ) : false,
                this.getAvailabilityMessage() ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.socialised) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: CHECK_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.check_icon) }),
                  this.getAvailabilityMessage()
                ) : false,
                this.getRegularityMessage() ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.socialised) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: CHECK_ICON, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.check_icon) }),
                  this.getRegularityMessage()
                ) : false
              )
            ),
            this.state.profile ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.actions) },
              this.renderCurrentlySharing(),
              this.renderMessageAction(),
              this.renderDiscontinueSharing(),
              this.renderAcceptShare(),
              this.renderReportMember()
            ) : false
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.secondary_container) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15__components_ContentContainer__["a" /* default */],
            { styles: styles.container },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.sections) },
              this.state.profile && this.state.profile.bio ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'h2',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_title) },
                  'About Me'
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_content) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'p',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_paragraph) },
                    this.state.profile.bio
                  )
                )
              ) : false,
              this.state.profile && this.state.profile.interests.length ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__["a" /* default */], null) : false,
              this.state.profile && this.state.profile.interests.length ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'h2',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_title) },
                  "I'm Interested in"
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_content) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.activities) },
                    this.state.profile.interests.map(function (interest) {
                      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_ActivityBadge__["a" /* default */], { activity: interest.title, label: true, styles: styles.activity });
                    })
                  )
                )
              ) : false,
              this.state.profile && this.state.profile.needs && this.state.profile.needs.length ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__["a" /* default */], null) : false,
              this.state.profile && this.state.profile.needs && this.state.profile.needs.length ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'h2',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_title) },
                  "I'm good with"
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_content) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'ul',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.bullet_list) },
                    this.state.profile.needs.map(function (need) {
                      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'li',
                        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.bullet_item) },
                        need.title
                      );
                    })
                  )
                )
              ) : false,
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__["a" /* default */], null),
              this.state.profile ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'span',
                null,
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_Reviews__["a" /* default */], Object.assign({
                  open: this.state.open_write_review_modal,
                  openHandler: this.writeReviewModalHandler,
                  reviews: this.state.profile.reviews,
                  canReview: this.state.profile_reviewable,
                  pushReviewHandler: this.pushReviewHandler
                }, this.props)),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_HorizontalRule__["a" /* default */], null)
              ) : false
            ),
            this.state.profile && this.state.profile.dogs && this.state.profile.dogs.length ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.side) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.section_title) },
                this.getProfileName() + '\'s dogs'
              ),
              this.state.profile.dogs.map(function (dog) {
                return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_ViewProfileCard__["a" /* default */], Object.assign({ dog: true }, dog));
              })
            ) : false,
            this.state.profile && this.renderReportMember() ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_ReportModal__["a" /* default */], Object.assign({
              open: this.state.open_report_modal,
              openHandler: this.openReportModalHandler
            }, this.props)) : false,
            this.state.selected_match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_MatchResponseModal__["a" /* default */], {
              isOpen: this.state.response_modal_open,
              onClose: this.toggleResponseModal,
              onSubmit: this.handleResponseSubmit,
              actionType: this.state.response_modal_type,
              borrowerName: this.state.selected_match.borrower.display_name || this.state.selected_match.borrower.first_name,
              dogName: this.state.selected_match.dog.name
            }) : false
          )
        )
      );
    }
  }]);

  return MemberProfile;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

MemberProfile.propTypes = {
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  match: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  body: _defineProperty({
    position: 'relative',
    marginTop: 30

  }, __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].mobile_query, {
    marginTop: 0
  }),
  preview_icon: {
    marginRight: 10
  },
  notification_link: {
    marginLeft: 5,
    fontWeight: 'bold'
  },
  cross_icon: {
    position: 'relative',
    top: 1,
    marginRight: 10
  },
  warning_icon: {
    position: 'relative',
    top: 4,
    marginRight: 10
  },
  envelope_icon: {
    position: 'relative',
    top: 3,
    marginRight: 10
  },
  paw_icon: {
    position: 'relative',
    top: 2,
    marginRight: 10,
    fill: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].white
  },
  paw_icon_blue: {
    fill: '#39b4d6'
  },
  activities: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  activity: {
    marginBottom: 60,

    ':not(:last-child)': {
      marginRight: 35
    }
  },
  bullet_list: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    marginBottom: -14
  },
  bullet_item: (_bullet_item = {
    display: 'flex',
    alignItems: 'center',
    width: '33.3333%',
    marginBottom: 14,
    fontSize: 15,
    lineHeight: 1.53,
    letterSpacing: 0.3,
    color: '#000e1f',
    fontFamily: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].font_weight_primary

  }, _defineProperty(_bullet_item, __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }), _defineProperty(_bullet_item, ':before', {
    height: 5,
    width: 5,
    marginRight: 10,
    backgroundColor: '#39b4d6',
    borderRadius: '50%',
    content: '""'
  }), _bullet_item),
  sections: _defineProperty({
    width: 750

  }, __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  side: _defineProperty({
    width: 360,
    flexShrink: 0

  }, __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    paddingTop: 50
  }),
  section: _defineProperty({
    display: 'flex'

  }, __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column'
  }),
  section_content: {
    flexGrow: 1
  },
  section_title: _defineProperty({
    flexShrink: 0,
    width: 195,
    fontFamily: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].font_family_secondary,
    letterSpacing: 1.8,
    color: '#a5a5a5',
    fontSize: 13,
    lineHeight: 1.53,
    textTransform: 'uppercase'

  }, __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].mobile_query, {
    marginBottom: 15
  }),
  section_paragraph: {
    fontSize: 15,
    lineHeight: 1.53,
    letterSpacing: 0.3,
    color: '#000e1f',
    fontFamily: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].font_weight_primary,

    ':not(:last-child)': {
      marginBottom: 15
    }
  },
  primary_container: {
    display: 'flex',
    padding: '84px 0 25px',
    backgroundColor: '#F8F8F8'
  },
  secondary_container: _defineProperty({
    padding: '54px 0 150px'

  }, __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].mobile_query, {
    paddingBottom: 0
  }),
  container: _defineProperty({
    display: 'flex',
    justifyContent: 'space-between'

  }, __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column',
    paddingBottom: 50
  }),
  profile: _defineProperty({
    display: 'flex'

  }, __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center'
  }),
  details: _defineProperty({
    paddingLeft: 38,
    paddingTop: 40

  }, __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].mobile_query, {
    paddingLeft: 0
  }),
  name: _defineProperty({
    marginBottom: 18,
    fontSize: 45,
    fontFamily: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].font_weight_heading,
    color: '#000e1f'

  }, __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 28
  }),
  breed: _defineProperty({
    marginBottom: 17,
    fontSize: 20,
    fontFamily: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 500,
    color: '#000e1f'

  }, __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 18
  }),
  location: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 17,
    fontSize: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].font_weight_primary,
    color: '#000e1f'
  },
  location_icon: {
    display: 'block',
    marginRight: 9
  },
  socialised: {
    display: 'flex',
    alignItems: 'left',
    fontSize: 14,
    fontFamily: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 900,
    paddingTop: 10,
    paddingBottom: 10,
    color: '#000e1f'
  },
  check_icon: {
    display: 'block',
    marginRight: 10.8
  },
  gallery: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  gallery_main: _defineProperty({
    height: 360,
    width: 360,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].grey

  }, __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].mobile_query, {
    width: 290,
    height: 'auto'
  }),
  gallery_photo: _defineProperty({
    display: 'block',
    height: 360,
    width: 360,
    border: '4px solid #fff',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, .1)',
    objectFit: 'cover'

  }, __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].mobile_query, {
    width: 290,
    height: 'auto'
  }),
  gallery_indicators: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20
  },
  gallery_indicator: {
    height: 14,
    width: 14,
    margin: '0 10px',
    border: '1px solid #d0d0d0',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].white,
    borderRadius: '50%',
    transition: 'all 300ms',
    cursor: 'pointer',
    outline: 'none'
  },
  no_action: {
    cursor: 'default'
  },
  gallery_indicator_active: {
    borderColor: '#39b4d6',
    backgroundColor: '#39b4d6'
  },
  actions: _defineProperty({
    width: 294,
    paddingTop: 100

  }, __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    paddingTop: 30
  }),
  action: _defineProperty({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 16,
    width: 293,
    height: 50,
    padding: '0 18px',
    textTransform: 'uppercase',
    fontSize: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: 900,
    letterSpacing: 2,
    textAlign: 'center',
    borderRadius: 5,
    border: 0,
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 300ms',

    '@media screen and (max-width: 750px)': {
      width: 230
    }

  }, __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  share_request: {
    color: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].white,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].primary,

    ':hover': {
      backgroundColor: '#61c3df'
    }
  },
  message_owner: {
    color: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].white,
    backgroundColor: '#000e1f',
    ':disabled': {
      opacity: 0.6,
      cursor: 'not-allowed'
    }
  },
  discontinue_sharing: {
    color: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].white,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].error
  },
  sharing: {
    color: '#000e1f',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].white
  },
  pending_match_requests: {
    marginTop: 30,
    textAlign: 'center',
    marginBottom: 20
  },
  pending_title: {
    textAlign: 'center',
    flexShrink: 0,
    width: 195,
    fontFamily: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].font_family_secondary,
    letterSpacing: 1.8,
    color: '#a5a5a5',
    fontSize: 13,
    lineHeight: 1.53,
    textTransform: 'uppercase'
  },
  report_member: {
    float: 'right',
    padding: 10,
    cursor: 'pointer'
  },
  decline_request: {
    color: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].white,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].error
  },
  not_now_request: {
    color: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].white,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_12__config_theme__["a" /* Theme */].primary
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_13__utils__["b" /* mapDispatchToProps */])(MemberProfile));

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ConversationHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minWidth: 0 // Allow text truncation
  },
  avatar: _defineProperty({
    width: '3rem',
    height: '3rem',
    borderRadius: '50%',
    backgroundColor: '#e0e0e0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    color: '#ffffff',
    flexShrink: 0
  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    width: '2.5rem',
    height: '2.5rem'
  }),
  avatarImage: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    objectFit: 'cover'
  },
  nameStatus: _defineProperty({
    marginLeft: '1rem',
    flex: 1,
    minWidth: 0 }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    marginLeft: '0.75rem'
  }),
  name: _defineProperty({
    margin: 0,
    fontSize: '1.125rem',
    fontWeight: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: '1rem'
  }),
  status: _defineProperty({
    margin: 0,
    fontSize: '0.875rem',
    color: '#6c757d'
  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: '0.75rem'
  }),
  menuContainer: {
    position: 'relative'
  },
  menuButton: _defineProperty({
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '1.5rem',
    color: '#6c757d',
    padding: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ':hover': {
      color: '#495057'
    }
  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0.75rem',
    minWidth: '44px',
    minHeight: '44px'
  }),
  menu: {
    position: 'absolute',
    top: '100%',
    right: 0,
    width: 240,
    backgroundColor: '#ffffff',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    borderRadius: '0.5rem',
    transformOrigin: 'top right',
    transition: 'all 200ms ease-out',
    opacity: 0,
    transform: 'scale(0.95)',
    pointerEvents: 'none',
    zIndex: 1000,
    border: '1px solid #e9ecef'
  },
  menuOpen: {
    opacity: 1,
    transform: 'scale(1)',
    pointerEvents: 'auto'
  },
  menuList: {
    margin: 0,
    padding: '0.25rem 0',
    listStyle: 'none'
  },
  menuItem: {
    display: 'block',
    width: '100%',
    padding: '0.75rem 1rem',
    fontSize: '0.875rem',
    color: '#495057',
    cursor: 'pointer',
    transition: 'background-color 150ms',
    textAlign: 'left',
    border: 'none',
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
    background: 'none',
    ':hover': {
      backgroundColor: '#f8f9fa'
    },
    ':last-child': {
      borderBottom: 'none'
    }
  },
  menuItemDanger: {
    color: '#dc3545',
    ':hover': {
      backgroundColor: '#fff5f5'
    }
  }
});

ConversationHeader.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onVisitProfile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onReportConversation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onUnfriend: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

function ConversationHeader(_ref) {
  var name = _ref.name,
      status = _ref.status,
      image = _ref.image,
      onVisitProfile = _ref.onVisitProfile,
      onReportConversation = _ref.onReportConversation,
      onUnfriend = _ref.onUnfriend;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMenuOpen = _useState2[0],
      setIsMenuOpen = _useState2[1];

  var toggleMenu = function toggleMenu() {
    setIsMenuOpen(!isMenuOpen);
  };

  var handleClickOutside = function handleClickOutside(e) {
    if (isMenuOpen && !e.target.closest('.' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.menuContainer))) {
      setIsMenuOpen(false);
    }
  };

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    document.addEventListener('click', handleClickOutside);
    return function () {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isMenuOpen]);

  var initials = name.split(' ').map(function (n) {
    return n[0];
  }).join('');

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.headerContainer) },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.userInfo) },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.avatar) },
        image ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { src: image, alt: name, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.avatarImage) }) : initials
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.nameStatus) },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'h2',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.name) },
          name
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'p',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.status) },
          status
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.menuContainer) },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'button',
        {
          type: 'button',
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.menuButton),
          onClick: toggleMenu,
          'aria-label': 'Menu'
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'svg',
          {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            xmlns: 'http://www.w3.org/2000/svg'
          },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('circle', { cx: '12', cy: '6', r: '2', fill: 'currentColor' }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('circle', { cx: '12', cy: '12', r: '2', fill: 'currentColor' }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('circle', { cx: '12', cy: '18', r: '2', fill: 'currentColor' })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.menu, isMenuOpen && styles.menuOpen) },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'ul',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.menuList) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'button',
              {
                type: 'button',
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.menuItem),
                onClick: function onClick() {
                  if (onVisitProfile) onVisitProfile();
                  setIsMenuOpen(false);
                }
              },
              'Visit profile'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'button',
              {
                type: 'button',
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.menuItem),
                onClick: function onClick() {
                  if (onReportConversation) onReportConversation();
                  setIsMenuOpen(false);
                }
              },
              'Report conversation'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'button',
              {
                type: 'button',
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.menuItem, styles.menuItemDanger),
                onClick: function onClick() {
                  if (onUnfriend) onUnfriend();
                  setIsMenuOpen(false);
                }
              },
              'Unfriend and end conversation'
            )
          )
        )
      )
    )
  );
}

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_messaging__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Button__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TextField__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_Api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__conversation_header__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__message_input__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__message_list__ = __webpack_require__(256);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















var CLOSE_ICON = __webpack_require__(67);

var openModalKeyFrames = {
  from: {
    transform: 'scale(0.8)',
    animationTimingFunction: 'ease-in'
  },
  to: {
    transform: 'scale(1)',
    animationTimingFunction: 'ease-in'
  }
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  conversationContainer: _defineProperty({
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 82px)'
  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: 'calc(var(--vh, 1vh) * 100)',
    width: '100vw'
  }),
  conversationTopBar: _defineProperty({
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #e0e0e0',
    width: '100%'
  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    position: 'fixed',
    top: 80,
    left: 0,
    right: 0,
    zIndex: 99999,
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)'
  }),
  topBarContent: _defineProperty({
    maxWidth: '900px',
    margin: '0 auto',
    padding: '1rem',
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0.75rem',
    minHeight: '60px', // Ensure minimum height for touch targets
    backgroundColor: '#ffffff' // Ensure background is visible
  }),
  backButton: _defineProperty({
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '1.5rem',
    marginRight: '1rem',
    color: '#333333',
    padding: '0.5rem'
  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: '1.25rem',
    marginRight: '0.5rem',
    minWidth: '44px',
    minHeight: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }),
  centeredContainer: _defineProperty({
    maxWidth: '960px',
    margin: '0 auto',
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    overflow: 'hidden'
  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    maxWidth: '100%',
    marginTop: '60px', // Account for fixed header
    marginBottom: '72px' // Account for fixed input
  }),
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    color: '#6c757d',
    fontSize: '1rem'
  },
  errorContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    color: '#dc3545',
    fontSize: '1rem',
    padding: '2rem',
    textAlign: 'center'
  },
  retryButton: {
    marginTop: '1rem',
    padding: '0.5rem 1rem',
    backgroundColor: '#0084ff',
    color: '#ffffff',
    border: 'none',
    borderRadius: '0.25rem',
    cursor: 'pointer',
    fontSize: '0.875rem',
    ':hover': {
      backgroundColor: '#0056b3'
    }
  },
  mobileInputWrapper: _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10
  }),
  modalContainer: _defineProperty({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 590,
    maxWidth: '100vw',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].white,
    borderRadius: 5,
    overflow: 'hidden',
    outline: 'none',
    margin: 'auto auto',
    animationName: openModalKeyFrames,
    animationDuration: '100ms',
    animationDirection: 'alternate'

  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    height: '100%',
    borderRadius: 0
  }),
  modalWrapper: _defineProperty({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 60px 40px'

  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0px 20px 20px'
  }),
  modalHeader: _defineProperty({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px 0px 35px'

  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    padding: '40px 0px 25px'
  }),
  modalTitle: _defineProperty({
    marginBottom: 0,
    fontFamily: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 26,
    fontWeight: '900',
    textAlign: 'center'

  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 22,
    paddingRight: 30,
    paddingLeft: 30
  }),
  closeIcon: {
    position: 'absolute',
    right: 15,
    top: 15,
    outline: 'none',
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6
    }
  },
  modalBody: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  },
  modalDescription: {
    marginBottom: 25,
    fontFamily: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 16,
    lineHeight: 1.5,
    color: '#4A4A4A',
    textAlign: 'center'
  },
  modalSubtext: {
    marginTop: 15,
    marginBottom: 25,
    fontFamily: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14,
    lineHeight: 1.5,
    color: '#828282',
    textAlign: 'center'
  },
  inputContainer: {
    position: 'relative',
    width: '100%',
    marginBottom: 30
  },
  textAreaField: {
    display: 'flex',
    flexDirection: 'column',
    height: 150,
    width: '100%',
    marginBottom: 10,

    ':not(.a) > *': {
      flexGrow: 1
    }
  },
  modalActions: _defineProperty({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: 15

  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column',
    gap: 10
  }),
  cancelButton: _defineProperty({
    width: 150

  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  submitButton: _defineProperty({
    width: 150

  }, __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  })
});

var Conversation = function (_React$Component) {
  _inherits(Conversation, _React$Component);

  function Conversation(props) {
    _classCallCheck(this, Conversation);

    var _this = _possibleConstructorReturn(this, (Conversation.__proto__ || Object.getPrototypeOf(Conversation)).call(this, props));

    _this.state = {
      reportModalOpen: false,
      selectedMessage: null,
      reportReason: '',
      reportSubmitting: false,
      unfriendModalOpen: false,
      unfriendSubmitting: false,
      reportConversationModalOpen: false,
      reportConversationReason: '',
      reportConversationSubmitting: false
    };

    _this.messageListRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createRef();
    _this.pollingInterval = null;

    _this.handleSendMessage = _this.handleSendMessage.bind(_this);
    _this.handleDeleteMessage = _this.handleDeleteMessage.bind(_this);
    _this.handleReportMessage = _this.handleReportMessage.bind(_this);
    _this.handleSubmitReport = _this.handleSubmitReport.bind(_this);
    _this.handleUnfriend = _this.handleUnfriend.bind(_this);
    _this.handleSubmitUnfriend = _this.handleSubmitUnfriend.bind(_this);
    _this.handleVisitProfile = _this.handleVisitProfile.bind(_this);
    _this.handleReportConversation = _this.handleReportConversation.bind(_this);
    _this.handleSubmitReportConversation = _this.handleSubmitReportConversation.bind(_this);
    _this.scrollToBottom = _this.scrollToBottom.bind(_this);
    _this.fetchMessages = _this.fetchMessages.bind(_this);
    _this.formatMessages = _this.formatMessages.bind(_this);
    _this.getConversationInfo = _this.getConversationInfo.bind(_this);
    _this.getUserImage = _this.getUserImage.bind(_this);
    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
    _this.handleListClick = _this.handleListClick.bind(_this);
    _this.handleConversationOpened = _this.handleConversationOpened.bind(_this);
    _this.syncUnreadCount = _this.syncUnreadCount.bind(_this);

    _this.needsUnreadRefresh = false;
    return _this;
  }

  _createClass(Conversation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // Hide main mobile navigation when viewing conversations
      if (__WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].isMobile) {
        var mobileNav = document.querySelector('[class*="mobile_nav"]');
        var dashboardHeader = document.querySelector('[class*="dashboard_header"]');
        var mobileHeader = document.querySelector('[class*="mobile_header"]');

        if (mobileNav) {
          mobileNav.style.setProperty('display', 'none', 'important');
        }
        if (dashboardHeader) {
          dashboardHeader.style.setProperty('display', 'none', 'important');
        }
        if (mobileHeader) {
          mobileHeader.style.setProperty('display', 'none', 'important');
        }
      }

      // Hide doorbell widget when viewing conversations (for all devices)
      var hideDoorbellWidget = function hideDoorbellWidget() {
        // Try multiple possible selectors
        var selectors = ['#doorbell-button', '#doorbell', '.doorbell-button', '[id*="doorbell"]'];

        selectors.forEach(function (selector) {
          var elements = document.querySelectorAll(selector);
          elements.forEach(function (element) {
            element.style.setProperty('display', 'none', 'important');
            element.style.setProperty('visibility', 'hidden', 'important');
          });
        });

        // Also hide the doorbell container div that has inline styles
        var doorbellContainer = document.querySelector('div[style*="doorbell"]');
        if (doorbellContainer) {
          doorbellContainer.style.setProperty('display', 'none', 'important');
        }
      };

      // Try to hide immediately
      hideDoorbellWidget();

      // Also try after a delay in case it loads asynchronously
      setTimeout(hideDoorbellWidget, 500);
      setTimeout(hideDoorbellWidget, 1000);
      setTimeout(hideDoorbellWidget, 2000);

      // Use MutationObserver to catch dynamically added elements
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.addedNodes.length) {
            hideDoorbellWidget();
          }
        });
      });

      // Start observing the document body for added nodes
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Store observer reference for cleanup
      this.doorbellObserver = observer;

      // Mobile-specific setup
      if (__WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].isMobile) {
        // Prevent zooming on mobile by setting viewport meta tag
        var viewportMeta = document.querySelector('meta[name="viewport"]');
        if (viewportMeta) {
          this.originalViewportContent = viewportMeta.getAttribute('content');
          viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
        }

        // Handle viewport height changes (keyboard open/close)
        var handleViewportChange = function handleViewportChange() {
          var vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', vh + 'px');
        };

        // Initial set
        handleViewportChange();

        // Update on resize
        window.addEventListener('resize', handleViewportChange);
        this.handleViewportChange = handleViewportChange;

        // Ensure body doesn't scroll
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      }

      // Initial fetch
      this.handleConversationOpened();
      var initialFetch = this.fetchMessages();

      if (!initialFetch) {
        this.syncUnreadCount();
      }

      // Set up polling
      this.pollingInterval = setInterval(function () {
        _this2.fetchMessages();
      }, 2000);

      // Scroll to bottom on initial load
      setTimeout(function () {
        _this2.scrollToBottom();
      }, 100);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          id = _props.id,
          messaging = _props.messaging;

      var conversationMessages = id ? messaging.messages[id] || {} : {};
      var prevMessages = id ? prevProps.messaging.messages[id] || {} : {};

      if ((conversationMessages.data && conversationMessages.data.length) !== (prevMessages.data && prevMessages.data.length)) {
        this.scrollToBottom();
      }

      if (id && id !== prevProps.id) {
        this.handleConversationOpened();
        var fetchResult = this.fetchMessages();
        if (!fetchResult) {
          this.syncUnreadCount();
        }
      } else if (id) {
        var numericId = parseInt(id, 10);

        if (!Number.isNaN(numericId)) {
          var conversations = messaging.conversations.data || [];
          var prevConversations = prevProps.messaging.conversations.data || [];

          var currentConversation = conversations.find(function (conversation) {
            return conversation && conversation.id === numericId;
          });
          var previousConversation = prevConversations.find(function (conversation) {
            return conversation && conversation.id === numericId;
          });

          if (currentConversation && typeof currentConversation.unreadCount === 'number' && currentConversation.unreadCount > 0 && (!previousConversation || previousConversation.unreadCount !== currentConversation.unreadCount)) {
            this.handleConversationOpened();
            var refreshResult = this.fetchMessages();
            if (!refreshResult) {
              this.syncUnreadCount();
            }
          }
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Restore main mobile navigation
      if (__WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].isMobile) {
        var mobileNav = document.querySelector('[class*="mobile_nav"]');
        var dashboardHeader = document.querySelector('[class*="dashboard_header"]');
        var mobileHeader = document.querySelector('[class*="mobile_header"]');

        if (mobileNav) {
          mobileNav.style.removeProperty('display');
        }
        if (dashboardHeader) {
          dashboardHeader.style.removeProperty('display');
        }
        if (mobileHeader) {
          mobileHeader.style.removeProperty('display');
        }
      }

      if (this.doorbellObserver) {
        this.doorbellObserver.disconnect();
      }

      // Don't restore doorbell widget immediately to prevent auto-open
      // Instead, add a CSS class that we'll remove after navigation completes
      var style = document.createElement('style');
      style.id = 'doorbell-hide-temp';
      style.innerHTML = '\n      #doorbell-button, #doorbell, .doorbell-button, [id*="doorbell"], div[style*="doorbell"] {\n        display: none !important;\n        visibility: hidden !important;\n      }\n    ';
      document.head.appendChild(style);

      // Remove the temporary hiding after navigation completes
      setTimeout(function () {
        var tempStyle = document.getElementById('doorbell-hide-temp');
        if (tempStyle) {
          tempStyle.remove();
        }
      }, 500);

      // Restore mobile viewport if changed
      if (__WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].isMobile) {
        var viewportMeta = document.querySelector('meta[name="viewport"]');
        if (viewportMeta && this.originalViewportContent) {
          viewportMeta.setAttribute('content', this.originalViewportContent);
        }

        // Remove viewport handler
        if (this.handleViewportChange) {
          window.removeEventListener('resize', this.handleViewportChange);
        }

        // Restore body position
        document.body.style.position = '';
        document.body.style.width = '';
      }

      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
      }
    }
  }, {
    key: 'getUserImage',
    value: function getUserImage(otherUser) {
      if (!otherUser) return null;

      if (otherUser.image_url && otherUser.image_url.length > 10) {
        return otherUser.image_url;
      }

      if (otherUser.profile_photo && otherUser.profile_photo.length > 10) {
        return otherUser.profile_photo;
      }

      return null;
    }
  }, {
    key: 'getConversationInfo',
    value: function getConversationInfo() {
      var _props2 = this.props,
          id = _props2.id,
          messaging = _props2.messaging,
          user = _props2.user;

      // First try to get info from the conversations list (already loaded in inbox)

      var conversations = messaging.conversations.data || [];
      var currentConversation = conversations.find(function (conv) {
        return conv.id === parseInt(id, 10);
      });

      if (currentConversation && currentConversation.otherUser) {
        return {
          name: currentConversation.otherUser.name || currentConversation.otherUser.email || 'Unknown',
          status: 'Online', // Placeholder
          userId: currentConversation.otherUser.id,
          image: this.getUserImage(currentConversation.otherUser)
        };
      }

      // Fallback: try to get info from messages if conversation data not available
      var conversationMessages = messaging.messages[id] || {};
      var messages = conversationMessages.data || [];

      if (messages.length === 0) {
        return {
          name: 'Loading...',
          status: '',
          userId: null,
          image: null
        };
      }

      // Get the other participant from the first message
      // Note: Messages only have 'sender', not 'receiver'
      var firstMessage = messages[0] || {};
      if (!firstMessage.sender) {
        return {
          name: 'Loading...',
          status: '',
          userId: null,
          image: null
        };
      }

      // Determine who the other user is based on the sender
      // If the sender is the current user, we need to look at different messages
      var otherUserMessage = messages.find(function (msg) {
        return msg.sender && msg.sender.id !== user.id;
      });
      var otherUser = otherUserMessage ? otherUserMessage.sender : null;

      // If all messages are from current user, use the conversation data from backend
      if (!otherUser && messages.length > 0) {
        // This shouldn't happen in normal flow, but handle it gracefully
        return {
          name: 'User',
          status: '',
          userId: null,
          image: null
        };
      }

      return {
        name: otherUser ? otherUser.name || otherUser.email || 'Unknown' : 'Unknown',
        status: 'Online', // Placeholder
        userId: otherUser ? otherUser.id : null,
        image: this.getUserImage(otherUser)
      };
    }
  }, {
    key: 'scrollToBottom',
    value: function scrollToBottom() {
      if (this.messageListRef.current) {
        this.messageListRef.current.scrollTop = this.messageListRef.current.scrollHeight;
      }
    }
  }, {
    key: 'handleInputFocus',
    value: function handleInputFocus() {
      var _this3 = this;

      // Scroll to bottom when input is focused
      // Add a small delay to ensure keyboard is shown on mobile
      setTimeout(function () {
        _this3.scrollToBottom();
      }, 300);
    }
  }, {
    key: 'handleListClick',
    value: function handleListClick() {
      // On mobile, unfocus the input when clicking the message list
      if (__WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].isMobile) {
        var activeElement = document.activeElement;
        if (activeElement && activeElement.tagName === 'INPUT') {
          activeElement.blur();
        }
      }
    }
  }, {
    key: 'handleConversationOpened',
    value: function handleConversationOpened() {
      var _props3 = this.props,
          id = _props3.id,
          dispatch = _props3.dispatch;


      if (!id) {
        return null;
      }

      this.needsUnreadRefresh = true;
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_messaging__["b" /* markConversationAsRead */])(id));
    }
  }, {
    key: 'syncUnreadCount',
    value: function syncUnreadCount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$force = options.force,
          force = _options$force === undefined ? false : _options$force;
      var _props4 = this.props,
          dispatch = _props4.dispatch,
          user = _props4.user;


      if (!force && !this.needsUnreadRefresh) {
        return Promise.resolve();
      }

      if (user && user.access_token) {
        this.needsUnreadRefresh = false;
        var result = dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_messaging__["c" /* getUnreadMessageCount */])(user.access_token));

        if (result && typeof result.catch === 'function') {
          result.catch(function () {});
        }

        return result;
      }

      this.needsUnreadRefresh = false;
      return Promise.resolve();
    }
  }, {
    key: 'fetchMessages',
    value: function fetchMessages() {
      var _this4 = this;

      var _props5 = this.props,
          id = _props5.id,
          dispatch = _props5.dispatch,
          user = _props5.user;


      if (id && user && user.access_token) {
        var result = dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_messaging__["d" /* getMessages */])(id, 1, 50, user.access_token));

        if (result && typeof result.then === 'function') {
          result.then(function (response) {
            if (_this4.needsUnreadRefresh) {
              return _this4.syncUnreadCount();
            }

            return response;
          }).catch(function () {});
        }

        return result;
      }

      return null;
    }
  }, {
    key: 'handleSendMessage',
    value: function handleSendMessage(content) {
      var _this5 = this;

      var attachmentIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var _props6 = this.props,
          id = _props6.id,
          dispatch = _props6.dispatch,
          user = _props6.user;

      if ((content.trim() || attachmentIds.length > 0) && user && user.access_token) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_messaging__["e" /* sendMessage */])(id, content, user.access_token, user.id, attachmentIds));
        // Immediately scroll to bottom to show the optimistically added message
        // Using setTimeout to ensure DOM has updated with the new message
        setTimeout(function () {
          _this5.scrollToBottom();
        }, 0);
      }
    }
  }, {
    key: 'handleDeleteMessage',
    value: function handleDeleteMessage(messageId) {
      var _props7 = this.props,
          dispatch = _props7.dispatch,
          user = _props7.user;

      if (!window.confirm('Are you sure you want to delete this message?')) {
        return;
      }

      if (messageId && user && user.access_token) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_messaging__["f" /* deleteMessage */])(messageId, user.access_token));
      }
    }
  }, {
    key: 'handleReportMessage',
    value: function handleReportMessage(message) {
      this.setState({
        selectedMessage: message,
        reportReason: '',
        reportModalOpen: true
      });
    }
  }, {
    key: 'handleSubmitReport',
    value: function handleSubmitReport() {
      var _state = this.state,
          selectedMessage = _state.selectedMessage,
          reportReason = _state.reportReason;
      var _props8 = this.props,
          dispatch = _props8.dispatch,
          user = _props8.user;


      if (!selectedMessage || !reportReason.trim() || !user || !user.access_token) {
        return;
      }

      // Close modal optimistically
      this.setState({
        reportModalOpen: false,
        reportSubmitting: false,
        reportReason: '',
        selectedMessage: null
      });

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_messaging__["g" /* reportMessage */])(selectedMessage.id, reportReason, user.access_token)).then(function () {
        __WEBPACK_IMPORTED_MODULE_5_react_toastify__["b" /* toast */].success('Report submitted successfully.', {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false
        });
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_5_react_toastify__["b" /* toast */].error('Failed to submit report. Please try again.', {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false
        });
      });
    }
  }, {
    key: 'handleUnfriend',
    value: function handleUnfriend() {
      this.setState({
        unfriendModalOpen: true
      });
    }
  }, {
    key: 'handleSubmitUnfriend',
    value: function handleSubmitUnfriend() {
      var _props9 = this.props,
          id = _props9.id,
          dispatch = _props9.dispatch,
          user = _props9.user,
          onBackClick = _props9.onBackClick;


      if (!user || !user.access_token) {
        return;
      }

      // Close modal optimistically
      this.setState({
        unfriendModalOpen: false,
        unfriendSubmitting: false
      });

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_messaging__["h" /* endConversation */])(id, user.access_token)).then(function () {
        __WEBPACK_IMPORTED_MODULE_5_react_toastify__["b" /* toast */].info('Conversation ended successfully.', {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false
        });
        // Redirect to inbox after successful unfriend
        if (onBackClick) {
          setTimeout(function () {
            onBackClick();
          }, 500);
        }
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_5_react_toastify__["b" /* toast */].error('Failed to end conversation. Please try again.', {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false
        });
      });
    }
  }, {
    key: 'handleVisitProfile',
    value: function handleVisitProfile() {
      var conversationInfo = this.getConversationInfo();
      if (conversationInfo.userId) {
        this.props.history.push('/profile/' + conversationInfo.userId);
      }
    }
  }, {
    key: 'handleReportConversation',
    value: function handleReportConversation() {
      this.setState({
        reportConversationModalOpen: true,
        reportConversationReason: ''
      });
    }
  }, {
    key: 'handleSubmitReportConversation',
    value: function handleSubmitReportConversation() {
      var reportConversationReason = this.state.reportConversationReason;
      var _props10 = this.props,
          dispatch = _props10.dispatch,
          user = _props10.user;

      var conversationInfo = this.getConversationInfo();

      if (!conversationInfo.userId || !reportConversationReason.trim() || !user || !user.access_token) {
        return;
      }

      // Close modal optimistically
      this.setState({
        reportConversationModalOpen: false,
        reportConversationSubmitting: false,
        reportConversationReason: ''
      });

      // Report the member (since there's no specific conversation report endpoint)
      dispatch({
        type: 'REPORT_MEMBER_REQUEST',
        payload: new Promise(function (resolve, reject) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_Api__["b" /* request */])('member/' + conversationInfo.userId + '/report', 'POST', {
            message: reportConversationReason,
            reporter_id: user.id,
            reporter_name: user.first_name + ' ' + user.surname,
            reported_id: conversationInfo.userId,
            email: user.email
          }, { Authorization: 'Bearer ' + user.access_token }).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_5_react_toastify__["b" /* toast */].success('Report submitted successfully.', {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false
            });
            resolve(response);
          }, function (error) {
            __WEBPACK_IMPORTED_MODULE_5_react_toastify__["b" /* toast */].error('Failed to submit report. Please try again.', {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false
            });
            reject(error);
          });
        })
      });
    }
  }, {
    key: 'formatMessages',
    value: function formatMessages(apiMessages) {
      var user = this.props.user;

      if (!apiMessages || !user) {
        return [];
      }

      // Map messages to the correct format
      var formattedMessages = apiMessages.map(function (msg) {
        return {
          id: msg.id,
          content: msg.content,
          sender: msg.sender.id === user.id ? 'user' : 'other',
          originalSender: msg.sender,
          timestamp: new Date(msg.created),
          isRead: msg.isRead,
          isPending: msg.isPending || false, // Preserve the pending flag for optimistic messages
          attachments: msg.attachments || [] // Include attachments
        };
      });

      // Sort messages in ascending order by timestamp (oldest first)
      return formattedMessages.sort(function (a, b) {
        return a.timestamp - b.timestamp;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props11 = this.props,
          id = _props11.id,
          messaging = _props11.messaging,
          onBackClick = _props11.onBackClick;
      var _state2 = this.state,
          reportModalOpen = _state2.reportModalOpen,
          reportReason = _state2.reportReason,
          reportSubmitting = _state2.reportSubmitting,
          unfriendModalOpen = _state2.unfriendModalOpen,
          unfriendSubmitting = _state2.unfriendSubmitting,
          reportConversationModalOpen = _state2.reportConversationModalOpen,
          reportConversationReason = _state2.reportConversationReason,
          reportConversationSubmitting = _state2.reportConversationSubmitting;


      var conversationMessages = messaging.messages[id] || {};
      var loading = conversationMessages.loading || false;
      var error = conversationMessages.error || null;
      var messages = this.formatMessages(conversationMessages.data || []);

      var conversationInfo = this.getConversationInfo();

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conversationContainer) },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conversationTopBar) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.topBarContent) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'button',
              { onClick: onBackClick, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.backButton) },
              '\u2190'
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { style: { flex: 1 } },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__conversation_header__["a" /* ConversationHeader */], {
                name: conversationInfo.name,
                status: conversationInfo.status,
                image: conversationInfo.image,
                onVisitProfile: this.handleVisitProfile,
                onReportConversation: this.handleReportConversation,
                onUnfriend: this.handleUnfriend
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.centeredContainer) },
          loading && messages.length === 0 ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.loadingContainer) },
            'Loading messages...'
          ) : error ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.errorContainer) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'p',
              null,
              error
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'button',
              { onClick: this.fetchMessages, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.retryButton) },
              'Retry'
            )
          ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__message_list__["a" /* MessageList */], {
            messages: messages,
            ref: this.messageListRef,
            onDeleteMessage: this.handleDeleteMessage,
            onReportMessage: this.handleReportMessage,
            onListClick: this.handleListClick
          })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.mobileInputWrapper) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__message_input__["a" /* MessageInput */], {
            onSendMessage: this.handleSendMessage,
            onInputFocus: this.handleInputFocus,
            accessToken: this.props.user ? this.props.user.access_token : null
          })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_modal___default.a,
          {
            isOpen: reportModalOpen,
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalContainer),
            style: {
              overlay: {
                backgroundColor: 'rgba(0,0,0,0.67)',
                zIndex: 10,
                display: 'flex'
              }
            },
            contentLabel: 'Report Message'
          },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalWrapper) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalHeader) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalTitle) },
                'Report Message'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                {
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.closeIcon),
                  onClick: function onClick() {
                    return _this6.setState({ reportModalOpen: false, reportReason: '' });
                  },
                  role: 'button',
                  tabIndex: 0
                },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { src: CLOSE_ICON, alt: 'Close modal' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalBody) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'p',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalDescription) },
                'Please provide a reason for reporting this message:'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.inputContainer) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_TextField__["a" /* default */], {
                  textArea: true,
                  name: 'reportReason',
                  styles: styles.textAreaField,
                  handler: function handler(key, value) {
                    return _this6.setState({ reportReason: value });
                  },
                  value: reportReason,
                  placeholder: 'Enter your reason here...'
                })
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalActions) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Button__["a" /* default */], {
                  title: 'Cancel',
                  theme: 'white',
                  handler: function handler() {
                    return _this6.setState({ reportModalOpen: false, reportReason: '' });
                  },
                  styles: styles.cancelButton
                }),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Button__["a" /* default */], {
                  title: 'Submit Report',
                  theme: 'blue',
                  handler: this.handleSubmitReport,
                  disabled: !reportReason.trim() || reportSubmitting,
                  styles: styles.submitButton
                })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_modal___default.a,
          {
            isOpen: reportConversationModalOpen,
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalContainer),
            style: {
              overlay: {
                backgroundColor: 'rgba(0,0,0,0.67)',
                zIndex: 10,
                display: 'flex'
              }
            },
            contentLabel: 'Report Conversation'
          },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalWrapper) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalHeader) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalTitle) },
                'Report Conversation'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                {
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.closeIcon),
                  onClick: function onClick() {
                    return _this6.setState({
                      reportConversationModalOpen: false,
                      reportConversationReason: ''
                    });
                  },
                  role: 'button',
                  tabIndex: 0
                },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { src: CLOSE_ICON, alt: 'Close modal' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalBody) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'p',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalDescription) },
                'Please provide a reason for reporting this conversation with ',
                conversationInfo.name,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.inputContainer) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_TextField__["a" /* default */], {
                  textArea: true,
                  name: 'reportConversationReason',
                  styles: styles.textAreaField,
                  handler: function handler(key, value) {
                    return _this6.setState({ reportConversationReason: value });
                  },
                  value: reportConversationReason,
                  placeholder: 'Tell us why you\'d like to report this conversation...'
                })
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalActions) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Button__["a" /* default */], {
                  title: 'Cancel',
                  theme: 'white',
                  handler: function handler() {
                    return _this6.setState({
                      reportConversationModalOpen: false,
                      reportConversationReason: ''
                    });
                  },
                  styles: styles.cancelButton
                }),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Button__["a" /* default */], {
                  title: 'Submit Report',
                  theme: 'blue',
                  handler: this.handleSubmitReportConversation,
                  disabled: !reportConversationReason.trim() || reportConversationSubmitting,
                  styles: styles.submitButton
                })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_modal___default.a,
          {
            isOpen: unfriendModalOpen,
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalContainer),
            style: {
              overlay: {
                backgroundColor: 'rgba(0,0,0,0.67)',
                zIndex: 10,
                display: 'flex'
              }
            },
            contentLabel: 'End Conversation'
          },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalWrapper) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalHeader) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'h2',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalTitle) },
                'End Conversation'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                {
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.closeIcon),
                  onClick: function onClick() {
                    return _this6.setState({ unfriendModalOpen: false });
                  },
                  role: 'button',
                  tabIndex: 0
                },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { src: CLOSE_ICON, alt: 'Close modal' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalBody) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'p',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalDescription) },
                'Are you sure you want to unfriend ',
                conversationInfo.name,
                ' and end this conversation?'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'p',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalSubtext) },
                'This action will end the match and you won\'t be able to message each other anymore.'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.modalActions) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Button__["a" /* default */], {
                  title: 'Cancel',
                  theme: 'white',
                  handler: function handler() {
                    return _this6.setState({ unfriendModalOpen: false });
                  },
                  disabled: unfriendSubmitting,
                  styles: styles.cancelButton
                }),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Button__["a" /* default */], {
                  title: 'End Conversation',
                  theme: 'blue',
                  handler: this.handleSubmitUnfriend,
                  disabled: unfriendSubmitting,
                  styles: styles.submitButton
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Conversation;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Conversation.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onBackClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  messaging: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

var mapMessagingStateToProps = function mapMessagingStateToProps(state) {
  return {
    messaging: state.messaging,
    user: state.user
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapMessagingStateToProps)(Conversation));

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__conversation__ = __webpack_require__(253);
var _more, _cards;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











function MessengerConversation(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container) },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.appContainer) },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__conversation__["a" /* default */], {
        id: props.match.params.conversationId,
        onBackClick: function onBackClick() {
          // navigate to /inbox
          props.history.push('/inbox');
        },
        history: props.history
      })
    )
  );
}

MessengerConversation.propTypes = {
  match: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      conversationId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    }).isRequired
  }).isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  }).isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    paddingTop: 75
  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    paddingTop: 0
  }),
  appContainer: _defineProperty({
    // padding: '0 50px',
    margin: '-44px 0px -30px'
  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    margin: 0
  }),
  more_icon: {
    display: 'block',
    marginBottom: 21,

    ':not(.a) > svg > g': {
      transition: 'all 300ms'
    }
  },
  more: (_more = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 262,
    minWidth: 262,
    padding: '100px 18px',
    margin: '0 15px 23px',
    backgroundColor: '#f2f2f2',
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#e8e8e8',
    fontSize: 15,
    color: '#39b4d6',
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_secondary,
    textTransform: 'uppercase',
    letterSpacing: 1.3,
    transition: 'all 300ms',
    cursor: 'pointer',

    ':hover': {
      color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
      backgroundColor: '#39b4d6'
    },

    ':hover > .isvg > svg > g': {
      fill: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white
    }

  }, _defineProperty(_more, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }), _defineProperty(_more, '@media screen and (min-width: 625px) and (max-width: 768px)', {
    width: 262
  }), _more),
  actions: {
    margin: '0 -5px',

    '@media screen and (max-width: 1170px)': {
      display: 'flex',
      justifyContent: 'center'
    }
  },
  sort: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    fontSize: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_primary,
    marginBottom: 30
  },
  sort_select: {
    padding: 0,
    marginBottom: 0,
    marginLeft: 14,
    width: 135
  },
  cards: (_cards = {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -15px -15px'

  }, _defineProperty(_cards, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0 20px'
  }), _defineProperty(_cards, '@media screen and (max-width: 1170px)', {
    justifyContent: 'center'
  }), _cards),
  heading: {
    marginBottom: 60,
    textAlign: 'center',
    fontSize: 45,
    lineHeight: 2.09,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_heading
  },
  title: {
    marginBottom: 30,
    textAlign: 'center',
    fontSize: 30,
    lineHeight: 1.17,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_heading
  },
  sub_heading: {
    position: 'relative',
    width: '100%',
    padding: '0 5px',
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 400,
    fontSize: 18,
    color: '#000e1f',
    textAlign: 'center'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["g" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* mapDispatchToProps */])(MessengerConversation)));

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MessageInput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Api__ = __webpack_require__(18);


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var styles = __WEBPACK_IMPORTED_MODULE_1_aphrodite__["StyleSheet"].create({
  messageInputForm: _defineProperty({
    backgroundColor: '#ffffff',
    borderTop: '1px solid #e0e0e0',
    width: '100%'
  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    paddingBottom: 'env(safe-area-inset-bottom, 0)',
    backgroundColor: '#ffffff',
    boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)'
  }),
  messageInputInner: _defineProperty({
    maxWidth: '900px',
    margin: '0 auto',
    padding: '1rem'
  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0.75rem',
    paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom, 0))'
  }),
  attachmentPreview: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem',
    marginBottom: '0.5rem',
    padding: '0.5rem',
    backgroundColor: '#f8f9fa',
    borderRadius: '0.5rem'
  },
  attachmentItem: {
    position: 'relative',
    width: '60px',
    height: '60px',
    borderRadius: '0.25rem',
    overflow: 'hidden',
    border: '1px solid #dee2e6',
    marginTop: '4px',
    marginRight: '4px'
  },
  attachmentImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  removeAttachment: {
    position: 'absolute',
    top: '0px',
    right: '0px',
    width: '26px',
    height: '26px',
    borderRadius: '50%',
    backgroundColor: '#dc3545',
    color: '#ffffff',
    border: '2px solid #ffffff',
    fontSize: '12px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
    zIndex: 1,
    ':hover': {
      backgroundColor: '#c82333'
    }
  },
  messageInputContainer: _defineProperty({
    display: 'flex',
    gap: '0.5rem'
  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    gap: '0.75rem'
  }),
  messageInput: _defineProperty({
    flex: 1,
    padding: '0.5rem 1rem',
    border: '1px solid #ced4da',
    borderRadius: '1.5rem',
    fontSize: '16px',
    '-webkit-text-size-adjust': '100%',
    '-moz-text-size-adjust': '100%',
    '-ms-text-size-adjust': '100%'
  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0.75rem 1rem',
    fontSize: '16px', // Prevents zoom on iOS
    borderRadius: '2rem',
    minHeight: '44px' // iOS recommended touch target
  }),
  attachButton: _defineProperty({
    backgroundColor: '#e9ecef',
    color: '#495057',
    border: 'none',
    borderRadius: '50%',
    width: '2.5rem',
    height: '2.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: '#dee2e6'
    }
  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: '44px',
    height: '44px'
  }),
  sendButton: _defineProperty({
    backgroundColor: '#0084ff',
    color: '#ffffff',
    border: 'none',
    borderRadius: '50%',
    width: '2.5rem',
    height: '2.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: '#0056b3'
    },
    ':disabled': {
      backgroundColor: '#ccc',
      cursor: 'not-allowed'
    }
  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: '44px',
    height: '44px',
    fontSize: '1.25rem'
  }),
  hiddenFileInput: {
    display: 'none'
  }
});

function MessageInput(_ref) {
  var _this = this;

  var onSendMessage = _ref.onSendMessage,
      onInputFocus = _ref.onInputFocus,
      accessToken = _ref.accessToken;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(''),
      _useState2 = _slicedToArray(_useState, 2),
      message = _useState2[0],
      setMessage = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])([]),
      _useState4 = _slicedToArray(_useState3, 2),
      attachments = _useState4[0],
      setAttachments = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isUploading = _useState6[0],
      setIsUploading = _useState6[1];

  var fileInputRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(null);

  var handleSubmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (e) {
    e.preventDefault();
    if (message.trim() || attachments.length > 0) {
      onSendMessage(message.trim(), attachments.map(function (a) {
        return a.id;
      }));
      setMessage('');
      setAttachments([]);
    }
  }, [message, attachments, onSendMessage]);

  var handleChange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (e) {
    setMessage(e.target.value);
  }, []);

  var handleFocus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function () {
    // Call the onInputFocus prop if provided
    if (onInputFocus) {
      onInputFocus();
    }
  }, [onInputFocus]);

  var handleAttachClick = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function () {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  }, []);

  var handleFileSelect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(e) {
      var file, reader;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              file = e.target.files && e.target.files[0];

              if (file) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt('return');

            case 3:

              // Reset file input
              e.target.value = '';

              // Validate file type

              if (file.type.startsWith('image/')) {
                _context2.next = 7;
                break;
              }

              alert('Please select an image file');
              return _context2.abrupt('return');

            case 7:
              if (!(file.size > 5 * 1024 * 1024)) {
                _context2.next = 10;
                break;
              }

              alert('Image size must be less than 5MB');
              return _context2.abrupt('return');

            case 10:

              setIsUploading(true);

              try {
                // Convert to base64
                reader = new FileReader();

                reader.onload = function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event) {
                    var base64, response;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            base64 = event.target.result;

                            // Upload to server

                            _context.prev = 1;
                            _context.next = 4;
                            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_Api__["b" /* request */])('messages/attachment/upload', 'POST', { image: base64 }, {
                              Authorization: 'Bearer ' + accessToken
                            });

                          case 4:
                            response = _context.sent;

                            if (!(response.status !== 200)) {
                              _context.next = 7;
                              break;
                            }

                            throw new Error('Upload failed: ' + response.status);

                          case 7:

                            // Add to attachments
                            setAttachments(function (prev) {
                              return [].concat(_toConsumableArray(prev), [{
                                id: response.data.data.id,
                                url: response.data.data.url,
                                type: response.data.data.type,
                                filename: response.data.data.filename || file.name
                              }]);
                            });
                            _context.next = 14;
                            break;

                          case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](1);

                            console.error('Upload error:', _context.t0);
                            alert('Failed to upload image. Please try again.');

                          case 14:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this, [[1, 10]]);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }();
                reader.readAsDataURL(file);
              } catch (error) {
                console.error('File read error:', error);
                alert('Failed to read image. Please try again.');
              } finally {
                setIsUploading(false);
              }

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [accessToken]);

  var handleRemoveAttachment = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (id) {
    setAttachments(function (prev) {
      return prev.filter(function (a) {
        return a.id !== id;
      });
    });
  }, []);

  // Determine send button tooltip
  var getSendButtonTooltip = function getSendButtonTooltip() {
    if (isUploading) return 'Uploading image...';
    if (!message.trim() && attachments.length === 0) return 'Type a message or attach an image';
    return 'Send message';
  };

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    'form',
    { onSubmit: handleSubmit, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.messageInputForm) },
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.messageInputInner) },
      attachments.length > 0 && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.attachmentPreview) },
        attachments.map(function (attachment) {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'div',
            { key: attachment.id, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.attachmentItem) },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img', {
              src: attachment.url,
              alt: attachment.filename,
              className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.attachmentImage)
            }),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'button',
              {
                type: 'button',
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.removeAttachment),
                onClick: function onClick() {
                  return handleRemoveAttachment(attachment.id);
                },
                'aria-label': 'Remove attachment',
                title: 'Remove attachment'
              },
              '\xD7'
            )
          );
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.messageInputContainer) },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
          type: 'text',
          value: message,
          onChange: handleChange,
          onFocus: handleFocus,
          placeholder: 'Type a message...',
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.messageInput),
          'aria-label': 'Message input',
          autoFocus: !__WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].isMobile // Only autofocus on desktop
        }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
          ref: fileInputRef,
          type: 'file',
          accept: 'image/*',
          onChange: handleFileSelect,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.hiddenFileInput),
          'aria-label': 'Select image'
        }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.attachButton),
            onClick: handleAttachClick,
            disabled: isUploading,
            'aria-label': 'Attach image',
            title: 'Attach an image'
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'span',
            { role: 'img', 'aria-label': 'Paperclip' },
            '\uD83D\uDCCE'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'button',
          {
            type: 'submit',
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_aphrodite__["css"])(styles.sendButton),
            disabled: !message.trim() && attachments.length === 0 || isUploading,
            'aria-label': getSendButtonTooltip(),
            title: getSendButtonTooltip()
          },
          '\u2192'
        )
      )
    )
  );
}

MessageInput.propTypes = {
  onSendMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  onInputFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  accessToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

MessageInput.defaultProps = {
  onInputFocus: null,
  accessToken: null
};

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessageList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_theme__ = __webpack_require__(2);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  messageList: _defineProperty({
    position: 'relative',
    flex: 1,
    overflowY: 'auto',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
    height: '100%',
    minHeight: 0,
    WebkitOverflowScrolling: 'touch' }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0.75rem',
    gap: '0.75rem',
    // Add extra padding at bottom to ensure last message is visible
    paddingBottom: '2rem'
  }),
  messageContainer: _defineProperty({
    position: 'relative',
    maxWidth: '70%',
    display: 'flex',
    flexDirection: 'column'
  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    maxWidth: '85%' // Allow more width on mobile
  }),
  userMessageContainer: {
    alignSelf: 'flex-end'
  },
  otherMessageContainer: {
    alignSelf: 'flex-start'
  },
  message: _defineProperty({
    padding: '0.75rem',
    borderRadius: '0.5rem',
    position: 'relative'
  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0.625rem 0.875rem',
    borderRadius: '1rem'
  }),
  userMessage: {
    backgroundColor: '#0084ff',
    color: '#ffffff'
  },
  otherMessage: {
    backgroundColor: '#ffffff'
  },
  pendingMessage: {
    opacity: 0.6
  },
  messageTimestamp: _defineProperty({
    fontSize: '0.75rem',
    marginTop: '0.25rem',
    opacity: 0.7
  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: '0.7rem'
  }),
  pendingIndicator: {
    fontSize: '0.75rem',
    marginTop: '0.25rem',
    opacity: 0.9,
    fontStyle: 'italic'
  },
  messageAttachments: {
    marginTop: '0.5rem',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem'
  },
  attachmentThumbnail: _defineProperty({
    maxWidth: '200px',
    maxHeight: '200px',
    borderRadius: '0.5rem',
    cursor: 'pointer',
    transition: 'opacity 200ms ease',
    ':hover': {
      opacity: 0.9
    }
  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    maxWidth: '150px',
    maxHeight: '150px'
  }),
  messageActions: _defineProperty({
    position: 'absolute',
    top: '-2px',
    right: '-8px',
    opacity: 0,
    transition: 'opacity 200ms ease'
  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    opacity: 1,
    top: '4px',
    right: '4px'
  }),
  otherMessageActions: {
    right: 'auto',
    left: '100%',
    marginRight: 0,
    marginLeft: '0.5rem'
  },
  messageAction: {
    width: '2rem',
    height: '2rem',
    borderRadius: '50%',
    backgroundColor: '#ffffff',
    border: '1px solid #e0e0e0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: '1rem',
    color: '#6c757d',
    transition: 'all 200ms ease',
    ':hover': {
      backgroundColor: '#f8f9fa',
      borderColor: '#ced4da'
    }
  },
  deleteAction: {
    ':hover': {
      backgroundColor: '#fff5f5',
      borderColor: '#dc3545',
      color: '#dc3545'
    }
  },
  reportAction: {
    ':hover': {
      backgroundColor: '#fff7e5',
      borderColor: '#fd7e14',
      color: '#fd7e14'
    }
  },
  messageContainerHover: {
    '&:hover .messageActions': {
      opacity: 1
    }
  },
  mobileClickOverlay: _defineProperty({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    zIndex: -1, // Behind messages
    display: 'none'
  }, __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].mobile_query, {
    display: 'block'
  })
});

var MessageList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"])(function (_ref, ref) {
  var messages = _ref.messages,
      onDeleteMessage = _ref.onDeleteMessage,
      onReportMessage = _ref.onReportMessage,
      onListClick = _ref.onListClick;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      hoveredMessageId = _useState2[0],
      setHoveredMessageId = _useState2[1];

  var handleMouseEnter = function handleMouseEnter(messageId) {
    setHoveredMessageId(messageId);
  };

  var handleMouseLeave = function handleMouseLeave() {
    setHoveredMessageId(null);
  };

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { ref: ref, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.messageList) },
    messages.map(function (message) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        {
          key: message.id,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.messageContainer, message.sender === 'user' ? styles.userMessageContainer : styles.otherMessageContainer, styles.messageContainerHover),
          onMouseEnter: function onMouseEnter() {
            return handleMouseEnter(message.id);
          },
          onMouseLeave: handleMouseLeave
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          {
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.message, message.sender === 'user' ? styles.userMessage : styles.otherMessage, message.isPending && styles.pendingMessage)
          },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'p',
            null,
            message.content
          ),
          message.attachments && message.attachments.length > 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.messageAttachments) },
            message.attachments.map(function (attachment) {
              return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'a',
                {
                  key: attachment.id,
                  href: attachment.url,
                  target: '_blank',
                  rel: 'noopener noreferrer'
                },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', {
                  src: attachment.url,
                  alt: attachment.filename || 'Attachment',
                  className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.attachmentThumbnail)
                })
              );
            })
          ),
          message.isPending ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'p',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.pendingIndicator) },
            'Sending...'
          ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'p',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.messageTimestamp) },
            message.timestamp.toLocaleString([], {
              month: 'short',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })
          )
        ),
        hoveredMessageId === message.id && !message.isPending && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          {
            className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.messageActions, message.sender === 'other' && styles.otherMessageActions)
          },
          message.sender === 'user' && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.messageAction, styles.deleteAction),
              onClick: function onClick() {
                return onDeleteMessage(message.id);
              },
              'aria-label': 'Delete message'
            },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'span',
              { role: 'img', 'aria-label': 'Delete' },
              '\uD83D\uDDD1\uFE0F'
            )
          ),
          message.sender === 'other' && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.messageAction, styles.reportAction),
              onClick: function onClick() {
                return onReportMessage(message);
              },
              'aria-label': 'Report message'
            },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'span',
              { role: 'img', 'aria-label': 'Report' },
              '\u26A0\uFE0F'
            )
          )
        )
      );
    }),
    __WEBPACK_IMPORTED_MODULE_3__config_theme__["a" /* Theme */].isMobile && onListClick && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button', {
      type: 'button',
      onClick: onListClick,
      className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.mobileClickOverlay),
      'aria-label': 'Tap to hide keyboard'
    })
  );
});

MessageList.displayName = 'MessageList';

MessageList.propTypes = {
  messages: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    sender: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['user', 'other']).isRequired,
    timestamp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date).isRequired,
    isPending: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    attachments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      filename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }))
  })).isRequired,
  onDeleteMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onReportMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onListClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

MessageList.defaultProps = {
  onDeleteMessage: function onDeleteMessage() {},
  onReportMessage: function onReportMessage() {},
  onListClick: null
};

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InboxComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_messaging__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  inboxContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  inboxHeader: {
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #e0e0e0',
    padding: '1rem'
  },
  inboxTitle: {
    fontSize: '1.5rem',
    fontWeight: 'bold'
  },
  inboxMain: {
    flex: 1,
    overflowY: 'auto',
    padding: '1rem'
  },
  conversationItem: {
    width: '100%',
    textAlign: 'left',
    backgroundColor: '#ffffff',
    borderRadius: '0.5rem',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    marginBottom: '1rem',
    padding: '1rem',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.15s ease-in-out',
    ':hover': {
      backgroundColor: '#f8f9fa'
    }
  },
  conversationHeader: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    width: '3rem',
    height: '3rem',
    borderRadius: '50%',
    backgroundColor: '#e0e0e0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    color: '#ffffff',
    flexShrink: 0
  },
  avatarImage: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    objectFit: 'cover'
  },
  conversationInfo: {
    marginLeft: '1rem',
    flex: 1,
    minWidth: 0
  },
  conversationName: {
    fontSize: '1.125rem',
    fontWeight: 600
  },
  conversationTimestamp: {
    fontSize: '0.875rem',
    color: '#6c757d',
    marginLeft: '0.5rem'
  },
  conversationLastMessage: {
    color: '#6c757d',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    lineHeight: 1.3,
    marginTop: '0.25rem'
  },
  conversationUnreadLabel: {
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].red,
    fontWeight: 700
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '2rem',
    color: '#6c757d'
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    color: '#dc3545'
  },
  retryButton: {
    marginTop: '1rem',
    padding: '0.5rem 1rem',
    backgroundColor: '#0084ff',
    color: '#ffffff',
    border: 'none',
    borderRadius: '0.25rem',
    cursor: 'pointer',
    fontSize: '0.875rem'
  },
  emptyContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3rem',
    color: '#6c757d',
    textAlign: 'center'
  }
});

var Inbox = function (_React$Component) {
  _inherits(Inbox, _React$Component);

  function Inbox(props) {
    _classCallCheck(this, Inbox);

    // Binding methods
    var _this = _possibleConstructorReturn(this, (Inbox.__proto__ || Object.getPrototypeOf(Inbox)).call(this, props));

    _this.fetchConversations = _this.fetchConversations.bind(_this);
    _this.formatDate = _this.formatDate.bind(_this);
    _this.getUserImage = _this.getUserImage.bind(_this);
    _this.truncateMessage = _this.truncateMessage.bind(_this);
    return _this;
  }

  _createClass(Inbox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchConversations();
    }
  }, {
    key: 'getUserImage',
    value: function getUserImage(otherUser) {
      if (otherUser.image_url && otherUser.image_url.length > 10) {
        return otherUser.image_url;
      }

      if (otherUser.profile_photo && otherUser.profile_photo.length > 10) {
        return otherUser.profile_photo;
      }

      return null;
    }
  }, {
    key: 'fetchConversations',
    value: function fetchConversations() {
      var _props = this.props,
          dispatch = _props.dispatch,
          user = _props.user;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions_messaging__["i" /* getConversations */])(user.access_token));
    }
  }, {
    key: 'truncateMessage',
    value: function truncateMessage(message) {
      var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

      if (!message) return 'No messages yet';
      if (message.length <= maxLength) return message;
      return message.substring(0, maxLength) + '...';
    }
  }, {
    key: 'formatDate',
    value: function formatDate(dateString) {
      if (!dateString) return '';

      var date = new Date(dateString);
      var now = new Date();
      var diff = now - date;

      // If less than 24 hours, show time
      if (diff < 86400000) {
        return date.toLocaleString([], {
          hour: '2-digit',
          minute: '2-digit'
        });
      }

      // If less than 7 days, show day of week
      if (diff < 604800000) {
        return date.toLocaleString([], {
          weekday: 'short'
        });
      }

      // Otherwise show date
      return date.toLocaleString([], {
        month: 'short',
        day: 'numeric'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          onConversationClick = _props2.onConversationClick,
          messaging = _props2.messaging;
      var conversations = messaging.conversations;


      if (conversations.loading) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.inboxContainer) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.loadingContainer) },
            'Loading conversations...'
          )
        );
      }

      if (conversations.error) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.inboxContainer) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.errorContainer) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'p',
              null,
              'Failed to load conversations: ',
              conversations.error
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'button',
              { onClick: this.fetchConversations, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.retryButton) },
              'Retry'
            )
          )
        );
      }

      var conversationsData = conversations.data || [];

      if (conversationsData.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.inboxContainer) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.emptyContainer) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'p',
              null,
              'You don\'t have any conversations yet.'
            )
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.inboxContainer) },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'main',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.inboxMain) },
          conversationsData.map(function (conversation) {
            var userImage = _this2.getUserImage(conversation.otherUser);
            var initials = conversation.otherUser.name ? conversation.otherUser.name.split(' ').map(function (n) {
              return n[0];
            }).join('') : conversation.otherUser.email.charAt(0).toUpperCase();

            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'button',
              {
                key: conversation.id,
                onClick: function onClick() {
                  return onConversationClick(conversation.id);
                },
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conversationItem)
              },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conversationHeader) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.avatar) },
                  userImage ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', {
                    src: userImage,
                    alt: conversation.otherUser.name || conversation.otherUser.email,
                    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.avatarImage)
                  }) : initials
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conversationInfo) },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'span',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conversationName) },
                      conversation.otherUser.name || conversation.otherUser.email
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'span',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conversationTimestamp) },
                      _this2.formatDate(conversation.lastMessageAt)
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'p',
                    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conversationLastMessage) },
                    _this2.truncateMessage(conversation.lastMessage ? conversation.lastMessage.content : null),
                    conversation.unreadCount > 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'span',
                      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.conversationUnreadLabel) },
                      ' • ',
                      conversation.unreadCount + ' unread message' + (conversation.unreadCount > 1 ? 's' : '')
                    )
                  )
                )
              )
            );
          })
        )
      );
    }
  }]);

  return Inbox;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Inbox.propTypes = {
  onConversationClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  messaging: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    messaging: state.messaging,
    user: state.user
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(Inbox));


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inbox__ = __webpack_require__(257);
var _more, _cards;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












function MessengerInbox(props) {
  var navigateToConversation = function navigateToConversation(id) {
    // navigate to /inbox
    props.history.push('/inbox/' + id);
  };

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container) },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__components_ContentContainer__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'h1',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.heading) },
        'Messages'
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.appContainer) },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__inbox__["a" /* default */], { onConversationClick: navigateToConversation })
      )
    )
  );
}

MessengerInbox.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  }).isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  more_icon: {
    display: 'block',
    marginBottom: 21,

    ':not(.a) > svg > g': {
      transition: 'all 300ms'
    }
  },
  more: (_more = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 262,
    minWidth: 262,
    padding: '100px 18px',
    margin: '0 15px 23px',
    backgroundColor: '#f2f2f2',
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#e8e8e8',
    fontSize: 15,
    color: '#39b4d6',
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_secondary,
    textTransform: 'uppercase',
    letterSpacing: 1.3,
    transition: 'all 300ms',
    cursor: 'pointer',

    ':hover': {
      color: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].white,
      backgroundColor: '#39b4d6'
    },

    ':hover > .isvg > svg > g': {
      fill: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].white
    }

  }, _defineProperty(_more, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }), _defineProperty(_more, '@media screen and (min-width: 625px) and (max-width: 768px)', {
    width: 262
  }), _more),
  actions: {
    margin: '0 -5px',

    '@media screen and (max-width: 1170px)': {
      display: 'flex',
      justifyContent: 'center'
    }
  },
  sort: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    fontSize: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_primary,
    marginBottom: 30
  },
  sort_select: {
    padding: 0,
    marginBottom: 0,
    marginLeft: 14,
    width: 135
  },
  cards: (_cards = {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -15px -15px'

  }, _defineProperty(_cards, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0 20px'
  }), _defineProperty(_cards, '@media screen and (max-width: 1170px)', {
    justifyContent: 'center'
  }), _cards),
  container: {
    paddingTop: 75,
    paddingBottom: 150
  },
  heading: {
    marginBottom: 60,
    textAlign: 'center',
    fontSize: 45,
    lineHeight: 2.09,
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_heading
  },
  title: {
    marginBottom: 30,
    textAlign: 'center',
    fontSize: 30,
    lineHeight: 1.17,
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_heading
  },
  sub_heading: {
    position: 'relative',
    width: '100%',
    padding: '0 5px',
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 400,
    fontSize: 18,
    color: '#000e1f',
    textAlign: 'center'
  },
  appContainer: {
    width: '100%',
    maxWidth: '800px',
    margin: '0 auto'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["g" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_7__utils__["b" /* mapDispatchToProps */])(MessengerInbox)));

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_applicationData__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Body__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DashboardHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SEO__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_UnauthenticatedHeader__ = __webpack_require__(17);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var Privacy = function (_Component) {
  _inherits(Privacy, _Component);

  function Privacy(props) {
    _classCallCheck(this, Privacy);

    var _this = _possibleConstructorReturn(this, (Privacy.__proto__ || Object.getPrototypeOf(Privacy)).call(this, props));

    _this.state = {};

    _this.openLoginHandler = _this.loginModalOpenHandler.bind(_this);
    _this.logoutHandler = _this.performLogout.bind(_this);
    _this.redirectHandler = _this.performRedirect.bind(_this);
    return _this;
  }

  _createClass(Privacy, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Skip API calls during react-snap pre-rendering
      if (navigator.userAgent === 'ReactSnap') {
        this.setState({
          loaded: true,
          privacy: { content: '<p>Loading privacy policy...</p>' }
        });
        return;
      }

      this.fetchPrivacy();
    }
  }, {
    key: 'getContent',
    value: function getContent() {
      return {
        __html: this.state.privacy.content // eslint-disable-line
      };
    }
  }, {
    key: 'performLogout',
    value: function performLogout() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_user__["b" /* logout */])());
      this.props.history.push('/');
    }
  }, {
    key: 'performRedirect',
    value: function performRedirect(to) {
      this.props.history.push(to);
    }
  }, {
    key: 'loginModalOpenHandler',
    value: function loginModalOpenHandler() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
        login_modal_open: true
      }));
    }
  }, {
    key: 'fetchPrivacy',
    value: function fetchPrivacy() {
      var _this2 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationData__["d" /* getPrivacy */])()).then(function (response) {
          _this2.setState({
            privacy: response,
            loaded: true
          });

          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        }, function (err) {
          console.log(err); // eslint-disable-line no-console
          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
          _this2.props.history.push('/404');
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      /* eslint-disable react/no-danger */
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__components_Body__["a" /* default */],
        { hasFooter: true },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SEO__["a" /* default */], {
          title: 'Privacy Policy',
          description: 'Learn how The Dog Share Collective protects your privacy and handles your personal ' + 'information. Read our comprehensive privacy policy.',
          keywords: 'privacy policy, data protection, personal information, dog sharing privacy',
          url: 'https://www.thedogsharecollective.com/privacy'
        }),
        this.props.user.isAuthenticated ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_DashboardHeader__["a" /* default */], Object.assign({
          logoutHandler: this.logoutHandler,
          redirectHandler: this.redirectHandler
        }, this.props)) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_UnauthenticatedHeader__["a" /* default */], { openLoginHandler: this.openLoginHandler }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.page_container) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.heading_section) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'h1',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.heading) },
              'Privacy Policy'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.content) },
            this.state.privacy ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container), dangerouslySetInnerHTML: this.getContent() }) : null
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer__["a" /* default */], { user: this.props.user })
      );
      /* eslint-enable react/no-danger */
    }
  }]);

  return Privacy;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Privacy.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  page_container: {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    minHeight: '100vh'
  },
  heading_section: {
    paddingTop: 140,
    paddingBottom: 50,
    backgroundColor: '#f9f9f9'
  },
  heading: {
    marginBottom: 0,
    lineHeight: 2.09,
    textAlign: 'center',
    fontSize: 45,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_heading
  },
  container: {
    padding: '80px 15px ' + __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].footer.height + 'px',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,

    ':not(.a) > p': _defineProperty({
      fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
      fontSize: 16,
      lineHeight: 1.72,
      textAlign: 'left',
      color: '#000e1f',
      marginBottom: 20

    }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
      padding: '0 20px',
      fontSize: 15
    }),
    ':not(.a) > h1': {
      margin: '25px 0px',
      fontSize: 28,
      fontWeight: 'bold'
    },
    ':not(.a) > h2': {
      margin: '25px 0px',
      fontSize: 25,
      fontWeight: 'bold'
    },
    ':not(.a) > h3': {
      margin: '25px 0px',
      fontSize: 22,
      fontWeight: 'bold'
    },
    ':not(.a) > strong': {
      fontWeight: 'bold'
    },
    ':not(.a) > small': {
      margin: '25px 0px',
      fontSize: 14,
      fontWeight: 'bold'
    },
    ':not(.a) > em': {
      margin: '25px 0px',
      fontStyle: 'italic'
    },
    ':not(.a) > img': {
      margin: '25px 0px'
    }
  },
  content: {
    maxWidth: 750,
    margin: '0 auto 20px'
  },
  title: {
    marginBottom: 24,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_heading,
    fontSize: 30,
    lineHeight: 1.17,
    color: '#262626',
    textAlign: 'left'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* mapDispatchToProps */])(Privacy));

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Profiles = function (_Component) {
  _inherits(Profiles, _Component);

  function Profiles(props) {
    _classCallCheck(this, Profiles);

    var _this = _possibleConstructorReturn(this, (Profiles.__proto__ || Object.getPrototypeOf(Profiles)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(Profiles, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          null,
          'Settings'
        )
      );
    }
  }]);

  return Profiles;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* mapDispatchToProps */])(Profiles));

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Body__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Heading__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Paragraph__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_DashboardHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_UnauthenticatedHeader__ = __webpack_require__(17);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var styles = void 0;

var ErrorView = function (_Component) {
  _inherits(ErrorView, _Component);

  function ErrorView(props) {
    _classCallCheck(this, ErrorView);

    var _this = _possibleConstructorReturn(this, (ErrorView.__proto__ || Object.getPrototypeOf(ErrorView)).call(this, props));

    _this.state = {};

    _this.openLoginHandler = _this.loginModalOpenHandler.bind(_this);
    _this.logoutHandler = _this.performLogout.bind(_this);
    _this.redirectHandler = _this.performRedirect.bind(_this);
    return _this;
  }

  _createClass(ErrorView, [{
    key: 'performLogout',
    value: function performLogout() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_user__["b" /* logout */])());
      this.props.history.push('/');
    }
  }, {
    key: 'performRedirect',
    value: function performRedirect(to) {
      this.props.history.push(to);
    }
  }, {
    key: 'loginModalOpenHandler',
    value: function loginModalOpenHandler() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_applicationState__["a" /* updateAppState */])({
        login_modal_open: true
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__components_Body__["a" /* default */],
        { hasFooter: true },
        this.props.user.isAuthenticated ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_DashboardHeader__["a" /* default */], Object.assign({
          logoutHandler: this.logoutHandler,
          redirectHandler: this.redirectHandler
        }, this.props)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_UnauthenticatedHeader__["a" /* default */], { openLoginHandler: this.openLoginHandler }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_aphrodite__["css"])(styles.container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__components_Heading__["a" /* default */],
            null,
            'Sorry for the inconvenience - our site is being a dog!'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__components_Paragraph__["a" /* default */],
            null,
            'We',
            '\'',
            'll have everything back online, just as soon as we can. But we do have plenty of great pages. Have you read ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Link */],
              { to: '/story' },
              'our story'
            ),
            ' yet?'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer__["a" /* default */], { user: this.props.user })
      );
    }
  }]);

  return ErrorView;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ErrorView.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

styles = __WEBPACK_IMPORTED_MODULE_4_aphrodite__["StyleSheet"].create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    height: window.innerHeight - (__WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].navigation.height + __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].footer.height),
    width: '100vw',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 150
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* mapDispatchToProps */])(ErrorView));

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Button__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CheckboxField__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_HorizontalRule__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_TextField__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var SettingsAccount = function (_Component) {
  _inherits(SettingsAccount, _Component);

  function SettingsAccount(props) {
    _classCallCheck(this, SettingsAccount);

    var _this = _possibleConstructorReturn(this, (SettingsAccount.__proto__ || Object.getPrototypeOf(SettingsAccount)).call(this, props));

    _this.state = {
      newsletter: props.user.newsletter,
      dogs_in_area: props.user.dogs_in_area,
      email_matches: props.user.email_matches,
      password: '',
      new_password: '',
      retype_new_password: '',

      errors: {
        password: false,
        new_password: false,
        retype_new_password: false
      }
    };

    _this.setValue = _this.updateField.bind(_this);
    _this.performSave = _this.performSave.bind(_this);
    return _this;
  }

  _createClass(SettingsAccount, [{
    key: 'updateField',
    value: function updateField(key, value) {
      this.setState(_defineProperty({}, key, value));
    }

    // Validate the form

  }, {
    key: 'validateForm',
    value: function validateForm() {
      var errors = {};

      if (this.state.new_password.length > 0 && this.state.new_password.length < 8) {
        errors.new_password = 'Password must be at least 8 characters.';
      } else if (!this.state.new_password || !this.state.new_password.length) {
        errors.new_password = 'Please enter a new password';
      } else {
        errors.new_password = null;
      }

      if (this.state.retype_new_password !== this.state.new_password) {
        errors.retype_new_password = 'Your passwords do not match';
      } else if (!this.state.retype_new_password || !this.state.retype_new_password.length) {
        errors.retype_new_password = 'Please repeat your new password.';
      } else {
        errors.retype_new_password = null;
      }
      var formErrors = false;

      Object.keys(errors).forEach(function (key) {
        if (errors[key] !== null) {
          formErrors = true;
        }
      });

      if (formErrors) {
        this.setState({
          errors: errors,
          hasError: true
        });

        return false;
      }

      this.setState({
        errors: errors,
        hasError: false
      });

      return true;
    }
  }, {
    key: 'performSave',
    value: function performSave() {
      var _this2 = this;

      var fields = {
        newsletter: this.state.newsletter,
        dogs_in_area: this.state.dogs_in_area
      };

      if (this.state.password.length > 0) {
        if (this.validateForm()) {
          fields.password = this.state.password;
          fields.new_password = this.state.new_password;
        } else {
          return;
        }
      }

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      }));

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_user__["g" /* updateUserRemote */])(fields, this.props.user.access_token)).then(function (response) {
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
          loading: false
        }));

        if (response && response.id) {
          _this2.setState({
            password: '',
            new_password: '',
            retype_new_password: ''
          });

          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_user__["c" /* updateUser */])(response));
        }
      }, function (err) {
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
          loading: false
        }));

        if (err.data.error === 'wrong_password') {
          _this2.setState({
            errors: Object.assign({}, _this2.state.errors, {
              password: 'You entered the wrong password'
            }),
            hasError: false
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__components_ContentContainer__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h2',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.h2) },
            'Choose the notifications you',
            "'",
            'd like to receive'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.form_checkboxes) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_CheckboxField__["a" /* default */], {
              id: 'newsletter',
              name: 'newsletter',
              label: 'email updates',
              fullWidth: true,
              handler: this.setValue,
              value: this.state.newsletter
            }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_CheckboxField__["a" /* default */], {
              id: 'dogs_in_area',
              name: 'dogs_in_area',
              label: 'new dog listings in my area',
              fullWidth: true,
              handler: this.setValue,
              value: this.state.dogs_in_area
            })
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_HorizontalRule__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h2',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.h2) },
            'Change Password'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.form_group) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_TextField__["a" /* default */], {
              id: 'password',
              name: 'password',
              type: 'password',
              value: this.state.password,
              handler: this.setValue,
              error: this.state.errors.password,
              fullWidth: true,
              label: 'Please enter your current Password'
            })
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.form_group) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_TextField__["a" /* default */], {
              id: 'new_password',
              name: 'new_password',
              type: 'password',
              value: this.state.new_password,
              handler: this.setValue,
              error: this.state.errors.new_password,
              label: 'New Password'
            }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_TextField__["a" /* default */], {
              id: 'retype_new_password',
              name: 'retype_new_password',
              type: 'password',
              value: this.state.retype_new_password,
              handler: this.setValue,
              error: this.state.errors.retype_new_password,
              label: 'Re-type New Password'
            })
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.button_container) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Button__["a" /* default */], { handler: this.performSave, title: 'Save changes', styles: styles.button })
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_HorizontalRule__["a" /* default */], null)
        )
      );
    }
  }]);

  return SettingsAccount;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

SettingsAccount.propTypes = {
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    width: 800,
    margin: '0 auto'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto'
  }),
  h2: {
    fontSize: 20,
    margin: '45px 5px'
  },
  form_group: _defineProperty({
    display: 'flex',
    flexDirection: 'row',
    margin: '20px 0'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column'
  }),
  form_checkboxes: {
    margin: '20px 0'
  },
  button_container: _defineProperty({
    display: 'flex',
    justifyContent: 'flex-end'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    justifyContent: 'center'
  })
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* mapDispatchToProps */])(SettingsAccount));

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Body__ = __webpack_require__(12);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var SettingsContainer = function (_Component) {
  _inherits(SettingsContainer, _Component);

  function SettingsContainer(props) {
    _classCallCheck(this, SettingsContainer);

    var _this = _possibleConstructorReturn(this, (SettingsContainer.__proto__ || Object.getPrototypeOf(SettingsContainer)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(SettingsContainer, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__components_Body__["a" /* default */],
        { hasFooter: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.header_container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.title) },
            'My account'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.links) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
              {
                to: '/settings/profiles',
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item),
                activeClassName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item_active) },
              'My Details'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
              {
                to: '/settings/membership',
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item),
                activeClassName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item_active) },
              'My Membership'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
              {
                to: '/settings/account',
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item),
                activeClassName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item_active) },
              'My Settings'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
              {
                to: '/settings/resources',
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item),
                activeClassName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item_active) },
              'My Dog e-Bag'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* NavLink */],
              {
                to: '/settings/help',
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item),
                activeClassName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.nav_item_active) },
              'Help'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.view_container) },
          this.props.children
        )
      );
    }
  }]);

  return SettingsContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var styles = __WEBPACK_IMPORTED_MODULE_3_aphrodite__["StyleSheet"].create({
  container: {},
  view_container: {
    paddingTop: 30,
    paddingBottom: 40
  },
  header_container: _defineProperty({
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].lighter_grey,
    height: 280

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    height: 'auto',
    paddingTop: 80
  }),
  title: _defineProperty({
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 45,
    textAlign: 'center',
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].black,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_heading

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 28,
    marginBottom: 50
  }),
  links: _defineProperty({
    position: 'absolute',
    bottom: 20

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    position: 'static',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 30
  }),
  nav_item: _defineProperty({
    position: 'relative',
    textTransform: 'uppercase',
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_weight_secondary,
    fontSize: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_size_secondary,
    letterSpacing: 1,
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].dark_grey,
    transition: 'all 160ms ease-in-out',
    marginLeft: 25,
    marginRight: 25,
    ':hover': {
      color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].primary
    }

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%',
    marginBottom: 20,
    textAlign: 'center',
    marginLeft: 0,
    marginRight: 0
  }),
  nav_item_active: {
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].primary,
    ':after': _defineProperty({
      content: "' '",
      display: 'block',
      position: 'absolute',
      width: '100%',
      backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].primary,
      height: 3,
      bottom: -17,
      left: 0

    }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
      content: 'none'
    })
  }
});

SettingsContainer.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};

SettingsContainer.defaultProps = {
  children: []
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* mapDispatchToProps */])(SettingsContainer));

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_EditProfileSummary__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_HorizontalRule__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var SettingsDetails = function (_Component) {
  _inherits(SettingsDetails, _Component);

  function SettingsDetails() {
    _classCallCheck(this, SettingsDetails);

    return _possibleConstructorReturn(this, (SettingsDetails.__proto__ || Object.getPrototypeOf(SettingsDetails)).apply(this, arguments));
  }

  _createClass(SettingsDetails, [{
    key: 'getUserImage',
    value: function getUserImage() {
      var user = this.props.user;

      if (user.image_url && user.image_url.length > 10) {
        return user.image_url;
      }

      if (user.profile_photo && user.profile_photo.length > 10) {
        return user.profile_photo;
      }

      return '/images/default_profile.jpg';
    }
  }, {
    key: 'getDogImage',
    value: function getDogImage(dog) {
      if (dog.image_url && dog.image_url.length > 10) {
        return dog.image_url;
      }

      if (dog.profile_photo && dog.profile_photo.length > 10) {
        return dog.profile_photo;
      }

      return '/images/default_dog.jpg';
    }
  }, {
    key: 'getDogs',
    value: function getDogs() {
      var _this2 = this;

      return this.props.user.dogs.map(function (dog) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_EditProfileSummary__["a" /* default */], {
          id: dog.id,
          image_url: _this2.getDogImage(dog),
          name: dog.name,
          breed: dog.breed
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__components_ContentContainer__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.profiles_container) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_EditProfileSummary__["a" /* default */], {
              dog: false,
              id: this.props.user.id,
              image_url: this.getUserImage(),
              name: this.props.user.display_name
            }),
            this.props.user.dogs && this.props.user.dogs.length > 0 ? this.getDogs() : false
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_HorizontalRule__["a" /* default */], null)
        )
      );
    }
  }]);

  return SettingsDetails;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

SettingsDetails.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  dogs: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].array.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    width: 800,
    margin: '0 auto'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto'
  }),
  h2: {
    fontSize: 20,
    margin: '45px 5px'
  },
  form_group: {
    display: 'flex',
    flexDirection: 'row'
  },
  button_container: _defineProperty({
    display: 'flex',
    justifyContent: 'flex-end'

  }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
    justifyContent: 'center'
  }),
  profiles_container: {
    marginTop: 50
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* mapDispatchToProps */])(SettingsDetails));

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FacebookChat__ = __webpack_require__(182);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SettingsHelp = function (_Component) {
  _inherits(SettingsHelp, _Component);

  function SettingsHelp() {
    _classCallCheck(this, SettingsHelp);

    return _possibleConstructorReturn(this, (SettingsHelp.__proto__ || Object.getPrototypeOf(SettingsHelp)).apply(this, arguments));
  }

  _createClass(SettingsHelp, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__components_ContentContainer__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.h2) },
              'Member Support'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.list) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.listItem) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.strong) },
                  'Phone:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { href: 'tel:0800364747' },
                  '0800 DOG SHR (364 747)'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.listItem) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.strong) },
                  'Hours:'
                ),
                ' 10:00am - 4:00pm, Mon - Fri'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.listItem) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.strong) },
                  'Email: '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { href: 'mailto:support@thedogsharecollective.com' },
                  'support@thedogsharecollective .com'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.listItem) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_aphrodite__["css"])(styles.strong) },
                  'Mail:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'address',
                  null,
                  'The Dog Share Collective ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  'PO Box 416, Orewa, 0946, ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  'Auckland'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_FacebookChat__["a" /* default */], null)
      );
    }
  }]);

  return SettingsHelp;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var styles = __WEBPACK_IMPORTED_MODULE_2_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    width: 800,
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto',
    flexDirection: 'column'
  }),
  h2: {
    fontSize: 20,
    margin: '45px 5px'
  },
  form_group: _defineProperty({
    display: 'flex',
    flexDirection: 'row',
    margin: '20px 0'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column'
  }),
  list: {
    margin: '0 5px'
  },
  listItem: _defineProperty({
    display: 'flex',
    margin: '0 0 0.7rem 0',
    lineHeight: '1.8'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column'
  }),
  strong: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    margin: '0 50px 0 0',
    minWidth: 40
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* mapDispatchToProps */])(SettingsHelp));

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SimpleSelect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Button__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_CancelSubscriptionModal__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_HorizontalRule__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_RenewResubscriptionModal__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_TextField__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var SettingsMembership = function (_Component) {
  _inherits(SettingsMembership, _Component);

  function SettingsMembership(props) {
    _classCallCheck(this, SettingsMembership);

    // eslint-disable-next-line
    var _this = _possibleConstructorReturn(this, (SettingsMembership.__proto__ || Object.getPrototypeOf(SettingsMembership)).call(this, props));

    console.log(props);

    _this.setValue = _this.updateTextField.bind(_this);
    _this.cardModalHandler = _this.paymentMethodModalHandler.bind(_this);
    _this.cancelModalHandler = _this.cancelSubscriptionModalHandler.bind(_this);
    _this.performSave = _this.performSave.bind(_this);
    _this.state = {
      charities: props.appdata.charity.map(function (charity) {
        return {
          value: charity.id,
          label: charity.title
        };
      }),
      charity: props.user.charity,
      payment_method_modal_open: false,
      cancel_subscription_modal_open: false,

      billing_first_name: props.user.billing_first_name,
      billing_last_name: props.user.billing_last_name,
      billing_city: props.user.billing_city,
      billing_post_code: props.user.billing_post_code,
      billing_address_1: props.user.billing_address_1,
      billing_address_2: props.user.billing_address_2,
      billing_country: props.user.billing_country,
      billing_email: props.user.billing_email,

      hasErrors: false,

      errors: {
        billing_first_name: false,
        billing_last_name: false,
        billing_email: false,
        billing_city: false,
        billing_post_code: false,
        billing_address_1: false,
        billing_address_2: false,
        billing_country: false
      }
    };
    return _this;
  }

  _createClass(SettingsMembership, [{
    key: 'updateTextField',
    value: function updateTextField(key, value) {
      var _this2 = this;

      this.setState(_defineProperty({}, key, value));

      setTimeout(function () {
        if (_this2.state.errors[key]) {
          // If there is an error against this field, attempt to revalidate
          _this2.validateForm();
        }
      }, 10);
    }
  }, {
    key: 'paymentMethodModalHandler',
    value: function paymentMethodModalHandler() {
      this.setState({
        payment_method_modal_open: !this.state.payment_method_modal_open
      });
    }
  }, {
    key: 'cancelSubscriptionModalHandler',
    value: function cancelSubscriptionModalHandler() {
      this.setState({
        cancel_subscription_modal_open: !this.state.cancel_subscription_modal_open
      });
    }

    // Validate the form

  }, {
    key: 'validateForm',
    value: function validateForm() {
      var errors = {};

      if (!this.state.billing_first_name || !this.state.billing_first_name.length) {
        errors.billing_first_name = 'Please complete this field';
      } else {
        errors.billing_first_name = null;
      }

      if (!this.state.billing_last_name || !this.state.billing_last_name.length) {
        errors.billing_last_name = 'Please complete this field';
      } else {
        errors.billing_last_name = null;
      }

      if (!this.state.billing_email || !this.state.billing_email.length) {
        errors.billing_email = 'Please complete this field';
      } else {
        errors.billing_email = null;
      }

      if (!this.state.billing_address_1 || !this.state.billing_address_1.length) {
        errors.billing_address_1 = 'Please complete this field';
      } else {
        errors.billing_address_1 = null;
      }

      if (!this.state.billing_city || !this.state.billing_city.length) {
        errors.billing_city = 'Please select a city';
      } else {
        errors.billing_city = null;
      }

      if (!this.state.billing_post_code || !this.state.billing_post_code.length) {
        errors.billing_post_code = 'Please complete this field';
      } else {
        errors.billing_post_code = null;
      }

      if (!this.state.billing_email || !this.state.billing_email.length) {
        errors.billing_email = 'Please complete this field';
      } else {
        errors.billing_email = null;
      }

      if (!this.state.billing_country || !this.state.billing_country.length) {
        errors.billing_country = 'Please complete this field';
      } else {
        errors.billing_country = null;
      }

      if (!this.state.charity || !this.state.charity.length) {
        errors.charity = 'Please complete this field';
      } else {
        errors.charity = null;
      }

      var formErrors = Object.values(errors).some(function (error) {
        return error !== null;
      });

      if (formErrors) {
        this.setState({
          errors: errors,
          hasError: true
        });

        return false;
      }

      this.setState({
        errors: errors,
        hasError: false
      });

      return true;
    }
  }, {
    key: 'performSave',
    value: function performSave() {
      var _this3 = this;

      if (this.validateForm()) {
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
          loading: true
        }));

        var fields = {
          billing_first_name: this.state.billing_first_name,
          billing_last_name: this.state.billing_last_name,
          billing_email: this.state.billing_email,
          billing_address_1: this.state.billing_address_1,
          billing_address_2: this.state.billing_address_2,
          billing_city: this.state.billing_city,
          billing_post_code: this.state.billing_post_code,
          billing_country: this.state.billing_country,
          charity: this.state.charity
        };

        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_user__["g" /* updateUserRemote */])(fields, this.props.user.access_token)).then(function (response) {
          _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));

          if (response && response.id) {
            _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_user__["c" /* updateUser */])(response));
          }
        }, function (err) {
          console.log(err); // eslint-disable-line no-console
          _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        });
      }
    }
  }, {
    key: 'renderCreditCardNumber',
    value: function renderCreditCardNumber() {
      var last4 = this.props.user.last4 ? this.props.user.last4 : false;

      if (last4) {
        if (last4.length > 4) {
          return 'XXXX-XXXXXX-' + last4;
        }

        return 'XXXX-XXXX-XXXX-' + last4;
      }

      return 'No credit card saved';
    }
  }, {
    key: 'renderChangePaymentDetailsTitle',
    value: function renderChangePaymentDetailsTitle() {
      return this.props.user.last4 ? 'Change payment details' : 'Add a payment method';
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__components_ContentContainer__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h2',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.h2) },
            'Subscription'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.subscription_container) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.membership_info_group, styles.larger) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.membership_level) },
                'Full Membership'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.membership_started) },
                '(started ',
                this.props.user.membership_started,
                ')'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.membership_info_group) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.membership_level) },
                '$30.00'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.membership_started) },
                'per year'
              )
            ),
            this.props.user.renew_membership && this.props.user.active_subscription ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              {
                role: 'link',
                tabIndex: 0,
                onClick: this.cancelModalHandler,
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cancel_link)
              },
              'Cancel my resubscription'
            ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              {
                role: 'link',
                tabIndex: 0,
                onClick: this.cardModalHandler,
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cancel_link)
              },
              'Activate my resubscription'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_HorizontalRule__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h2',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.h2) },
            'Personal Details'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.form_group) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_TextField__["a" /* default */], {
              id: 'billing_first_name',
              name: 'billing_first_name',
              label: 'First Name',
              handler: this.setValue,
              error: this.state.errors.billing_first_name,
              value: this.state.billing_first_name
            }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_TextField__["a" /* default */], {
              id: 'billing_last_name',
              name: 'billing_last_name',
              label: 'Last Name',
              handler: this.setValue,
              error: this.state.errors.billing_last_name,
              value: this.state.billing_last_name
            })
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.form_group) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_TextField__["a" /* default */], {
              id: 'billing_address_1',
              name: 'billing_address_1',
              label: 'Address 1',
              handler: this.setValue,
              error: this.state.errors.billing_address_1,
              value: this.state.billing_address_1
            }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_TextField__["a" /* default */], {
              id: 'billing_address_2',
              name: 'billing_address_2',
              label: 'Address 2',
              handler: this.setValue,
              error: this.state.errors.billing_address_2,
              value: this.state.billing_address_2
            })
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.form_group) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_TextField__["a" /* default */], {
              id: 'billing_city',
              name: 'billing_city',
              label: 'City',
              handler: this.setValue,
              error: this.state.errors.billing_city,
              value: this.state.billing_city
            }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_TextField__["a" /* default */], {
              id: 'billing_post_code',
              name: 'billing_post_code',
              label: 'Post Code',
              handler: this.setValue,
              error: this.state.errors.billing_post_code,
              value: this.state.billing_post_code
            })
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.form_group) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_TextField__["a" /* default */], {
              id: 'billing_country',
              name: 'billing_country',
              label: 'Country',
              handler: this.setValue,
              error: this.state.errors.billing_country,
              value: this.state.billing_country
            }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_TextField__["a" /* default */], {
              id: 'billing_email',
              name: 'billing_email',
              label: 'Email Address',
              email: true,
              handler: this.setValue,
              error: this.state.errors.billing_email,
              value: this.state.billing_email
            })
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_HorizontalRule__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_SimpleSelect__["a" /* default */], {
            id: 'charity',
            name: 'charity',
            options: this.state.charities,
            label: 'My Favourite Charity',
            required: true,
            value: this.state.charity,
            handler: this.setValue,
            error: this.state.errors.charity
          }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_HorizontalRule__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.form_group) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_TextField__["a" /* default */], {
              id: 'credit_card_number',
              disabled: true,
              value: this.renderCreditCardNumber(),
              name: 'credit_card_number',
              label: 'Credit Card Number'
            }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              {
                role: 'link',
                tabIndex: 0,
                onClick: this.cardModalHandler,
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.change_payment_link)
              },
              this.renderChangePaymentDetailsTitle()
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_HorizontalRule__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.button_container) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Button__["a" /* default */], {
              theme: this.state.hasErrors ? 'disabled' : false,
              title: 'Save changes',
              handler: this.performSave,
              styles: styles.button
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_RenewResubscriptionModal__["a" /* default */], {
          dispatch: this.props.dispatch,
          user: this.props.user,
          first_name: this.state.billing_first_name,
          last_name: this.state.billing_last_name,
          current_card: this.renderCreditCardNumber(),
          open: this.state.payment_method_modal_open,
          closeHandler: this.cardModalHandler
        }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_CancelSubscriptionModal__["a" /* default */], {
          dispatch: this.props.dispatch,
          user: this.props.user,
          open: this.state.cancel_subscription_modal_open,
          closeHandler: this.cancelModalHandler
        })
      );
    }
  }]);

  return SettingsMembership;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

SettingsMembership.propTypes = {
  appdata: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].func.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  container: _defineProperty({
    width: 800,
    margin: '0 auto'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto'
  }),
  h2: {
    fontSize: 20,
    margin: '45px 5px'
  },
  form_group: _defineProperty({
    display: 'flex',
    flexDirection: 'row'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column'
  }),
  subscription_container: _defineProperty({
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].white,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: 20,
    width: '750',
    height: 100,
    margin: '20px auto',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    flexDirection: 'column',
    height: 'auto'
  }),
  membership_info_group: _defineProperty({
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'row'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    marginBottom: 15,
    flexDirection: 'column'
  }),
  larger: {
    flex: 2,
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  membership_level: _defineProperty({
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 20,
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].black,
    fontWeight: 'bold',
    marginRight: 10

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    marginBottom: 5
  }),
  membership_started: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 14,
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].grey,
    fontWeight: 'normal'
  },
  cancel_link: {
    display: 'flex',
    flex: 1.5,
    fontSize: 14,
    textAlign: 'right',
    alignItems: 'center',
    justifyContent: 'flex-end',
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].primary,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    cursor: 'pointer',
    fontWeight: 600,
    outline: 'none'
  },
  change_payment_link: {
    display: 'flex',
    flex: 1,
    fontSize: 14,
    textAlign: 'right',
    alignItems: 'center',
    justifyContent: 'flex-end',
    color: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].primary,
    fontFamily: __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].font_family_primary,
    cursor: 'pointer',
    fontWeight: 600,
    outline: 'none'
  },
  button_container: _defineProperty({
    display: 'flex',
    justifyContent: 'flex-end'

  }, __WEBPACK_IMPORTED_MODULE_5__config_theme__["a" /* Theme */].mobile_query, {
    justifyContent: 'center'
  })
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* mapDispatchToProps */])(SettingsMembership));

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_applicationData__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ResourceCard__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_theme__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var SettingsResources = function (_Component) {
  _inherits(SettingsResources, _Component);

  function SettingsResources(props) {
    _classCallCheck(this, SettingsResources);

    var _this = _possibleConstructorReturn(this, (SettingsResources.__proto__ || Object.getPrototypeOf(SettingsResources)).call(this, props));

    _this.state = {
      resources: [],
      loaded: false
    };
    return _this;
  }

  _createClass(SettingsResources, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.fetchFAQs();
    }
  }, {
    key: 'fetchFAQs',
    value: function fetchFAQs() {
      var _this2 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions_applicationData__["b" /* getResources */])()).then(function (response) {
          _this2.setState({
            resources: response,
            loaded: true
          });

          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        }, function (err) {
          console.log(err); // eslint-disable-line no-console
          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
          _this2.props.history.push('/404');
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__components_ContentContainer__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.container) },
          this.state.loaded && this.state.resources.length ? this.state.resources.filter(function (resource) {
            return resource.type === _this3.props.user.subscription;
          }).filter(function (resource) {
            return resource.url && resource.url.length && resource.title && resource.title.length && resource.summary && resource.summary.length;
          }).map(function (resource) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ResourceCard__["a" /* default */], {
              link: resource.url,
              title: resource.title,
              summary: resource.summary });
          }) : false
        )
      );
    }
  }]);

  return SettingsResources;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SettingsResources.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_3_aphrodite__["StyleSheet"].create({
  heading: {
    marginBottom: 30,
    lineHeight: 2.09,
    textAlign: 'center',
    fontSize: 28,
    fontFamily: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_9__config_theme__["a" /* Theme */].font_weight_heading
  },
  cards: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_4__utils__["b" /* mapDispatchToProps */])(SettingsResources));

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ContentContainer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DogCard__ = __webpack_require__(37);
var _more, _cards;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var PLUS_ASSET = __webpack_require__(368);

var ShareHistory = function (_Component) {
  _inherits(ShareHistory, _Component);

  function ShareHistory(props) {
    _classCallCheck(this, ShareHistory);

    var _this = _possibleConstructorReturn(this, (ShareHistory.__proto__ || Object.getPrototypeOf(ShareHistory)).call(this, props));

    _this.state = {};

    _this.redirect = _this.redirectToFind.bind(_this);
    return _this;
  }

  _createClass(ShareHistory, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Redirect the user to Membership if they do not have an active subscription
      if (!this.props.user.active_subscription) {
        this.props.history.push('/settings/membership');
      }
    }
  }, {
    key: 'getMatches',
    value: function getMatches() {
      var matches = this.props.user.matches;
      var relevantMatches = matches && matches.length ? matches.filter(function (match) {
        return match.status === 'Declined' || match.status === 'Ended';
      }) : false;

      return relevantMatches && relevantMatches.length ? relevantMatches : false;
    }
  }, {
    key: 'redirectToFind',
    value: function redirectToFind() {
      this.props.history.push('/find');
    }
  }, {
    key: 'renderMatches',
    value: function renderMatches() {
      var _this2 = this;

      var matches = this.getMatches();

      return matches ? matches.map(function (match) {
        var isBorrower = _this2.props.user.id === match.borrower.id;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_DogCard__["a" /* default */], {
          member: !isBorrower,
          id: isBorrower ? match.dog.id : match.borrower.id,
          image: isBorrower ? match.dog.image_url : match.borrower.profile_photo,
          name: isBorrower ? match.dog.name : match.borrower.display_name,
          breed: isBorrower ? match.dog.breed : false,
          summary: isBorrower ? match.dog.about : match.borrower.bio,
          status: match.status.toLowerCase()
        });
      }) : false;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.container) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__components_ContentContainer__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.heading) },
            'My dog share history'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.cards) },
            this.renderMatches(),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                tabIndex: 0,
                role: 'button',
                onClick: this.redirect,
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.more) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_inlinesvg___default.a, {
                cacheGetRequests: true,
                src: PLUS_ASSET,
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.more_icon)
              }),
              'Find more Dogs'
            )
          )
        )
      );
    }
  }]);

  return ShareHistory;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ShareHistory.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_3_aphrodite__["StyleSheet"].create({
  more_icon: {
    display: 'block',
    marginBottom: 21,

    ':not(.a) > svg > g': {
      transition: 'all 300ms'
    }
  },
  more: (_more = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 262,
    minWidth: 262,
    padding: '100px 18px',
    margin: '0 15px 23px',
    backgroundColor: '#f2f2f2',
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#e8e8e8',
    fontSize: 15,
    color: '#39b4d6',
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_weight_secondary,
    textTransform: 'uppercase',
    letterSpacing: 1.3,
    transition: 'all 300ms',
    cursor: 'pointer',

    ':hover': {
      color: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].white,
      backgroundColor: '#39b4d6'
    },

    ':hover > .isvg > svg > g': {
      fill: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].white
    }

  }, _defineProperty(_more, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }), _defineProperty(_more, '@media screen and (min-width: 625px) and (max-width: 768px)', {
    width: 262
  }), _more),
  actions: {
    margin: '0 -5px',

    '@media screen and (max-width: 1170px)': {
      display: 'flex',
      justifyContent: 'center'
    }
  },
  sort: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    fontSize: 15,
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_weight_primary,
    marginBottom: 30
  },
  sort_select: {
    padding: 0,
    marginBottom: 0,
    marginLeft: 14,
    width: 135
  },
  cards: (_cards = {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -15px -15px'

  }, _defineProperty(_cards, __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0 20px'
  }), _defineProperty(_cards, '@media screen and (max-width: 1170px)', {
    justifyContent: 'center'
  }), _cards),
  container: {
    paddingTop: 75,
    paddingBottom: 150
  },
  heading: {
    marginBottom: 60,
    textAlign: 'center',
    fontSize: 45,
    lineHeight: 2.09,
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_weight_heading
  },
  title: {
    marginBottom: 30,
    textAlign: 'center',
    fontSize: 30,
    lineHeight: 1.17,
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_weight_heading
  },
  sub_heading: {
    position: 'relative',
    width: '100%',
    padding: '0 5px',
    marginBottom: 30,
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: 400,
    fontSize: 18,
    color: '#000e1f',
    textAlign: 'center'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["g" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* mapDispatchToProps */])(ShareHistory)));

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AboutHero__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Body__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DashboardHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SEO__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_UnauthenticatedHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config_theme__ = __webpack_require__(2);
var _cv_dogs;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var styles = void 0;

var ICON1_ASSET = __webpack_require__(369);
var ICON2_ASSET = __webpack_require__(370);
var ICON3_ASSET = __webpack_require__(371);

var PAW_ASSET = __webpack_require__(372);

// const BANNER_ASSET = require('./assets/banner.png');

var FOUNDER_ASSET = __webpack_require__(617);
var SIGNATURE_ASSET = __webpack_require__(618);

var CV1_ASSET = __webpack_require__(613);
var CV2_ASSET = __webpack_require__(614);
var CV3_ASSET = __webpack_require__(615);
var CV4_ASSET = __webpack_require__(616);

var Story = function (_Component) {
  _inherits(Story, _Component);

  function Story(props) {
    _classCallCheck(this, Story);

    var _this = _possibleConstructorReturn(this, (Story.__proto__ || Object.getPrototypeOf(Story)).call(this, props));

    _this.state = {};

    _this.openLoginHandler = _this.loginModalOpenHandler.bind(_this);
    _this.logoutHandler = _this.performLogout.bind(_this);
    _this.redirectHandler = _this.performRedirect.bind(_this);
    return _this;
  }

  _createClass(Story, [{
    key: 'performLogout',
    value: function performLogout() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_user__["b" /* logout */])());
      this.props.history.push('/');
    }
  }, {
    key: 'performRedirect',
    value: function performRedirect(to) {
      this.props.history.push(to);
    }
  }, {
    key: 'loginModalOpenHandler',
    value: function loginModalOpenHandler() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
        login_modal_open: true
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__components_Body__["a" /* default */],
        { hasFooter: true },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SEO__["a" /* default */], {
          title: 'Our Story - Meet the Team Behind Dog Sharing',
          description: 'Learn about The Dog Share Collective mission to connect dog lovers with dogs ' + "who need companionship. Founded by Sandra Walker, we're building a community " + "that enriches dogs' lives through trusted sharing.",
          keywords: 'dog sharing story, about dog share, sandra walker, dog collective',
          url: 'https://www.thedogsharecollective.com/story'
        }),
        this.props.user.isAuthenticated ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_DashboardHeader__["a" /* default */], Object.assign({
          logoutHandler: this.logoutHandler,
          redirectHandler: this.redirectHandler
        }, this.props)) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_UnauthenticatedHeader__["a" /* default */], { openLoginHandler: this.openLoginHandler }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_AboutHero__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container, styles.container_white) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h2',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.title) },
            'Who we are'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'p',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.content, styles.content_narrow) },
            'The Dog Share Collective is a community-led social enterprise that gets dogs the companionship they need. We get dogs social lives sorted by sharing dogs. Founded on the principles of promoting member defined good, The Dog Share Collective is shaped by those who we serve; our members and their dogs. Sharing anything',
            ' ',
            '"involves mutual assistance',
            ' in working towards a common goal"',
            '. Together, we share values of connection, caring for others, social responsibility and cooperative spirit.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h2',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.title) },
            'What we do'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.whatwedo_blocks) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.whatwedo_block) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: ICON1_ASSET, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.whatwedo_icon) }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.whatwedo_title) },
                'We make access easy for',
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'span',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.highlight) },
                  ' people without dogs'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.whatwedo_block) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: ICON2_ASSET, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.whatwedo_icon) }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.whatwedo_title) },
                'We bring peace of mind to',
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'span',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.highlight) },
                  ' people with dogs'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.whatwedo_block) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: ICON3_ASSET, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.whatwedo_icon) }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.whatwedo_title) },
                'We help',
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'span',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.highlight) },
                  ' dogs '
                ),
                'live better lives'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'p',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.content) },
            'The Dog Share Collective connects people who want more dog in their life, with people who want to find more life for their dog. Like us, dogs are social animals. Companionship is everything to a dog. What we do is life-giving. For the dog. For dog-less people. For dog owners.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container, styles.container_white) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h2',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.title) },
            "Where we're heading"
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'p',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.content, styles.content_narrow) },
            'At first, The Dog Share Collective was simply imagined as a place where any dog could find a new best friend, by connecting with a local dog-lover\u2026'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.where_points) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.content, styles.content_narrow) },
              'To help ',
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'strong',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.bold) },
                '683,000 NZ dogs '
              ),
              'live better lives'
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: PAW_ASSET, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.paw_icon) }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.content, styles.content_narrow) },
              'To make dog access easy for the',
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'strong',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.bold) },
                ' 232,700 New Zealanders '
              ),
              'who wanted a dog as a companion in their life, but ',
              "couldn't",
              ' commit to owning one'
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: PAW_ASSET, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.paw_icon) }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.content, styles.content_narrow) },
              'To bring dog companionship support to the',
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'strong',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.bold) },
                ' 28% of NZ households'
              ),
              ' who own dogs, in a meaningful, socially sensible and economically sustainable way'
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg___default.a, { cacheGetRequests: true, src: PAW_ASSET, className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.paw_icon) }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'p',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.content, styles.content_narrow) },
              'To build a collective of dog-lovers to help ',
              "NZ's",
              ' widest dog community, by giving back'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'p',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.content, styles.content_narrow) },
            'As we have grown, so has our ',
            "collective's",
            ' motivation to do more and be more. Whilst our focus will always be providing a super functional, safe and secure online environment where people can co-create better lives themselves, for the good of dogs, we reckon we have loads more good up our sleeve for dogs.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.banner) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'p',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.banner_text) },
            'Today, we are leaders in the world of dog companionship.'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'p',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.banner_text) },
            'Tomorrow, we will lead in the world of dog collectives.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container, styles.container_white, styles.container_founder) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h2',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.title) },
            'Meet our founder'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.founder) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.founder_photo), src: FOUNDER_ASSET, alt: 'Sandra Walker' }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.founder_content) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'h3',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.founder_name) },
                'Sandra Walker'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.founder_titles) },
                'MMGT, PGDIP (OPS MGMT), GDIP (HR)',
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
                "Chief Dog's Body",
                ' | Founder of The Dog Share Collective'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.founder_bio) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'p',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.founder_paragraph) },
                  'Hello awesome you! Thank you for being a part of this movement. Together we are disrupting things a bit to make life better for dogs. And ',
                  "it's",
                  ' wonderful to watch it happen for you. After my dog Pearl died, I ',
                  "couldn't",
                  ' commit to another dog full time. Flat out with a career driving ships for the Navy and regularly deploying overseas, I was dog-less for way too many years. Then the Bailey Family changed my life, by letting me share their dog Tess for four years.'
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'p',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.founder_paragraph) },
                  'I have no experience in running a dog organisation, but after becoming the biggest dog sharing advocate ever, I started this Collective to give all dogs and dog lovers the same life giving joy that I found from sharing my life with Tess and The Bailey Family. You see\u2026what I once wanted for one dog, I now want for all dogs and what I once wanted for myself, I now want for everybody.'
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'p',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.founder_paragraph) },
                  'Why? Because I think the boring stuff in life prevents us dog lovers from doing what we really want to be doing, which is hanging out with dogs. And dogs have been waiting for us to find a way to work this problem out. Finally, we have. Through trusted dog sharing we can now enrich ',
                  "dogs'",
                  ' lives, and our own lives, and still do the boring stuff!'
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'p',
                  { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.founder_paragraph) },
                  'So ',
                  "here's",
                  ' to you, us, and more happy dog time',
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'span',
                    { role: 'img', 'aria-label': 'Smiley Emoji' },
                    ' ',
                    '\uD83D\uDE0A'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', {
                className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.founder_signature),
                src: SIGNATURE_ASSET,
                alt: 'Sandra\'s Signature'
              }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'span',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.founder_signoff) },
                'Sandra'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container, styles.container_white) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h2',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_title) },
            "P.S. Here's my dog sharing CV"
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_dogs) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_dog) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_photo), src: CV1_ASSET, alt: 'Sandra & Pearl' }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_dog_name) },
                'Pearl'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_dog_breed) },
                'Staffordshire Cross'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_dog_bio) },
                'Rescued off the street. My best friend for 13 years. She was shared with my parents every time I deployed overseas.'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_dog) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_photo), src: CV2_ASSET, alt: 'Sandra & Carly' }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_dog_name) },
                'Carly'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_dog_breed) },
                'Black Labrador'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_dog_bio) },
                'One very special Epilepsy Assistance Dog who I fostered for 7 months. My colleagues at work and the Air New Zealand staff fell in love with her!'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_dog) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_photo), src: CV3_ASSET, alt: 'Sandra & Tess' }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_dog_name) },
                'Tess'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_dog_breed) },
                'Border Collie'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_dog_bio) },
                'Owned by The Bailey Family, just around the corner from my home and gratefully shared with me for 4 years. She inspired all of this.'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_dog) },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_photo), src: CV4_ASSET, alt: 'Sandra & Finbar' }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_dog_name) },
                'Finbar'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_dog_breed) },
                'Irish Wheaten Terrier'
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.cv_dog_bio) },
                'Owned by The Johnsons and shared with me for 3 weeks while they were overseas. I dog sat Finbar in her house and we had a ball.'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer__["a" /* default */], { user: this.props.user })
      );
    }
  }]);

  return Story;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Story.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  cv_title: {
    marginBottom: 40,
    fontFamily: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_weight_heading,
    fontSize: 20,
    lineHeight: 1.5,
    textAlign: 'center',
    color: '#262626'
  },
  cv_dogs: (_cv_dogs = {
    display: 'flex',
    justifyContent: 'space-between',
    width: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].container_width,
    margin: '0 auto 75px'

  }, _defineProperty(_cv_dogs, __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 0
  }), _defineProperty(_cv_dogs, '@media screen and (max-width: 1170px)', {
    width: 'auto',
    flexWrap: 'wrap'
  }), _cv_dogs),
  cv_dog: _defineProperty({
    width: 202,
    textAlign: 'center',

    '@media screen and (max-width: 1170px)': {
      width: '50%',
      marginBottom: 50,
      padding: '0 30px'
    }

  }, __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].mobile_query, {
    width: '100%'
  }),
  cv_photo: {
    display: 'block',
    height: 180,
    width: 180,
    margin: '0 auto 22px',
    borderRadius: '50%'
  },
  cv_dog_name: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_weight_heading,
    fontSize: 20,
    lineHeight: 1.5,
    color: '#262626'
  },
  cv_dog_breed: {
    marginBottom: 20,
    fontFamily: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_weight_primary,
    fontSize: 14,
    color: '#828282'
  },
  cv_dog_bio: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_weight_primary,
    fontSize: 15,
    color: '#000e1f',
    lineHeight: 1.4
  },
  container_founder: {
    '@media screen and (max-width: 810px)': {
      padding: '70px 0'
    }
  },
  founder: _defineProperty({
    display: 'flex',
    justifyContent: 'space-between',
    width: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].container_width,
    margin: '55px auto -70px',
    padding: 60,
    borderRadius: 6,
    backgroundColor: '#f5f5f5',
    border: 'solid 1px #e4e4e4',

    '@media screen and (max-width: 1170px)': {
      width: 'auto'
    },

    '@media screen and (max-width: 810px)': {
      flexDirection: 'column',
      alignItems: 'center'
    }

  }, __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].mobile_query, {
    borderRadius: 0,
    borderLeft: 0,
    borderRight: 0
  }),
  founder_photo: {
    display: 'block',
    width: 274,
    height: 274,
    borderRadius: '50%',
    marginRight: 80,

    '@media screen and (max-width: 810px)': {
      marginBottom: 30,
      marginRight: 0
    }
  },
  founder_content: {
    width: 694,

    '@media screen and (max-width: 810px)': {
      width: 'auto'
    }
  },
  founder_name: {
    marginBottom: 20,
    fontSize: 20,
    fontFamily: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_weight_heading,
    lineHeight: 1.5,
    color: '#262626'
  },
  founder_titles: {
    marginBottom: 25,
    fontSize: 13,
    fontFamily: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_family_secondary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_weight_secondary,
    textTransform: 'uppercase',
    letterSpacing: 1.8,
    lineHeight: 2,
    color: '#a5a5a5'
  },
  founder_paragraph: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_weight_primary,
    fontSize: 15,
    color: '#000e1f',
    lineHeight: 1.4,

    ':not(:last-child)': {
      marginBottom: 15
    }
  },
  founder_signature: {
    display: 'block',
    margin: '20px 0'
  },
  founder_signoff: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_family_primary,
    fontWeight: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_weight_primary,
    fontSize: 15,
    color: '#000e1f',
    lineHeight: 1.4
  },
  highlight: {
    color: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].turquoise
  },
  container: {
    padding: '70px 15px'
  },
  container_white: {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].white
  },
  title: {
    marginBottom: 24,
    fontFamily: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_weight_heading,
    fontSize: 30,
    lineHeight: 1.17,
    color: '#262626',
    textAlign: 'center'
  },
  content: _defineProperty({
    maxWidth: 826,
    margin: '0 auto 20px',
    fontFamily: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_family_primary,
    fontSize: 18,
    lineHeight: 1.72,
    textAlign: 'center',
    color: '#000e1f'

  }, __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].mobile_query, {
    padding: '0 20px',
    fontSize: 15
  }),
  bold: {
    fontWeight: 900
  },
  content_narrow: {
    maxWidth: 750
  },
  whatwedo_blocks: _defineProperty({
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 46,
    marginTop: 45

  }, __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 16
  }),
  whatwedo_block: _defineProperty({
    width: 290,
    margin: '0 35px',
    textAlign: 'center'

  }, __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].mobile_query, {
    marginBottom: 30
  }),
  whatwedo_icon: {
    display: 'inline-block',
    height: 130,
    width: 130,
    marginBottom: 23
  },
  whatwedo_title: {
    fontFamily: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 20,
    lineHeight: 1.5,
    fontWeight: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_weight_heading,
    color: '#262626'
  },
  where_points: {
    marginTop: 40
  },
  paw_icon: {
    display: 'block',
    width: 20,
    height: 18,
    margin: '0 auto 10px'
  },
  banner: _defineProperty({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 500,
    // paddingLeft: 200,
    // backgroundImage: `url('${BANNER_ASSET}')`,
    backgroundColor: 'rgb(253, 253, 253)',
    backgroundSize: 'cover',
    backgroundPosition: 'center'

  }, __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].mobile_query, {
    height: 'auto',
    padding: '50px 20px'
  }),
  banner_text: _defineProperty({
    width: 691,
    fontFamily: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].font_weight_heading,
    fontSize: 45,
    textAlign: 'center',
    lineHeight: 1.16,
    color: __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].turquoise,

    ':not(:last-child)': {
      marginBottom: 40
    }

  }, __WEBPACK_IMPORTED_MODULE_14__config_theme__["a" /* Theme */].mobile_query, {
    width: 'auto',
    fontSize: 30
  })
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* mapDispatchToProps */])(Story));

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_applicationData__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_user__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Body__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DashboardHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SEO__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_UnauthenticatedHeader__ = __webpack_require__(17);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var Terms = function (_Component) {
  _inherits(Terms, _Component);

  function Terms(props) {
    _classCallCheck(this, Terms);

    var _this = _possibleConstructorReturn(this, (Terms.__proto__ || Object.getPrototypeOf(Terms)).call(this, props));

    _this.state = {};

    _this.openLoginHandler = _this.loginModalOpenHandler.bind(_this);
    _this.logoutHandler = _this.performLogout.bind(_this);
    _this.redirectHandler = _this.performRedirect.bind(_this);
    return _this;
  }

  _createClass(Terms, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Skip API calls during react-snap pre-rendering
      if (navigator.userAgent === 'ReactSnap') {
        this.setState({
          loaded: true,
          terms: { content: '<p>Loading terms...</p>' }
        });
        return;
      }

      this.fetchTerms();
    }
  }, {
    key: 'getContent',
    value: function getContent() {
      return {
        __html: this.state.terms.content // eslint-disable-line
      };
    }
  }, {
    key: 'performLogout',
    value: function performLogout() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions_user__["b" /* logout */])());
      this.props.history.push('/');
    }
  }, {
    key: 'performRedirect',
    value: function performRedirect(to) {
      this.props.history.push(to);
    }
  }, {
    key: 'loginModalOpenHandler',
    value: function loginModalOpenHandler() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
        login_modal_open: true
      }));
    }
  }, {
    key: 'fetchTerms',
    value: function fetchTerms() {
      var _this2 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
        loading: true
      })).then(function () {
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationData__["e" /* getTerms */])()).then(function (response) {
          _this2.setState({
            terms: response,
            loaded: true
          });

          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
        }, function (err) {
          console.log(err); // eslint-disable-line no-console
          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_applicationState__["a" /* updateAppState */])({
            loading: false
          }));
          _this2.props.history.push('/404');
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      /* eslint-disable react/no-danger */
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__components_Body__["a" /* default */],
        { hasFooter: true },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SEO__["a" /* default */], {
          title: 'Terms of Service',
          description: 'Read The Dog Share Collective terms of service, including user agreements, ' + 'safety guidelines, and platform policies.',
          keywords: 'terms of service, user agreement, dog sharing terms, platform policies',
          url: 'https://www.thedogsharecollective.com/terms'
        }),
        this.props.user.isAuthenticated ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_DashboardHeader__["a" /* default */], Object.assign({
          logoutHandler: this.logoutHandler,
          redirectHandler: this.redirectHandler
        }, this.props)) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_UnauthenticatedHeader__["a" /* default */], { openLoginHandler: this.openLoginHandler }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.page_container) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.heading_section) },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'h1',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.heading) },
              'Terms of Service'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.content) },
            this.state.terms ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_aphrodite__["css"])(styles.container), dangerouslySetInnerHTML: this.getContent() }) : null
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer__["a" /* default */], { user: this.props.user })
      );
      /* eslint-enable react/no-danger */
    }
  }]);

  return Terms;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Terms.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var styles = __WEBPACK_IMPORTED_MODULE_0_aphrodite__["StyleSheet"].create({
  page_container: {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,
    minHeight: '100vh'
  },
  heading_section: {
    paddingTop: 140,
    paddingBottom: 50,
    backgroundColor: '#f9f9f9'
  },
  heading: {
    marginBottom: 0,
    lineHeight: 2.09,
    textAlign: 'center',
    fontSize: 45,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_heading
  },
  container: {
    padding: '80px 15px ' + __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].footer.height + 'px',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].white,

    ':not(.a) > p': _defineProperty({
      fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_primary,
      fontSize: 16,
      lineHeight: 1.72,
      textAlign: 'left',
      color: '#000e1f',
      marginBottom: 20

    }, __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].mobile_query, {
      padding: '0 20px',
      fontSize: 15
    }),
    ':not(.a) > h1': {
      margin: '25px 0px',
      fontSize: 28,
      fontWeight: 'bold'
    },
    ':not(.a) > h2': {
      margin: '25px 0px',
      fontSize: 25,
      fontWeight: 'bold'
    },
    ':not(.a) > h3': {
      margin: '25px 0px',
      fontSize: 22,
      fontWeight: 'bold'
    },
    ':not(.a) > strong': {
      fontWeight: 'bold'
    },
    ':not(.a) > small': {
      margin: '25px 0px',
      fontSize: 14,
      fontWeight: 'bold'
    },
    ':not(.a) > em': {
      margin: '25px 0px',
      fontStyle: 'italic'
    },
    ':not(.a) > img': {
      margin: '25px 0px'
    }
  },
  content: {
    maxWidth: 750,
    margin: '0 auto 20px'
  },
  title: {
    marginBottom: 24,
    fontFamily: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_family_heading,
    fontWeight: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].font_weight_heading,
    fontSize: 30,
    lineHeight: 1.17,
    color: '#262626',
    textAlign: 'left'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* mapDispatchToProps */])(Terms));

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Body__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_UnauthenticatedHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Footer__ = __webpack_require__(16);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var UnauthenticatedContainer = function (_Component) {
  _inherits(UnauthenticatedContainer, _Component);

  function UnauthenticatedContainer(props) {
    _classCallCheck(this, UnauthenticatedContainer);

    var _this = _possibleConstructorReturn(this, (UnauthenticatedContainer.__proto__ || Object.getPrototypeOf(UnauthenticatedContainer)).call(this, props));

    _this.state = {};

    _this.openLoginHandler = _this.loginModalOpenHandler.bind(_this);
    return _this;
  }

  _createClass(UnauthenticatedContainer, [{
    key: 'loginModalOpenHandler',
    value: function loginModalOpenHandler() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_applicationState__["a" /* updateAppState */])({
        login_modal_open: true
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__components_Body__["a" /* default */],
        { hasFooter: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_UnauthenticatedHeader__["a" /* default */], { openLoginHandler: this.openLoginHandler }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.container) },
          this.props.children
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Footer__["a" /* default */], { user: false })
      );
    }
  }]);

  return UnauthenticatedContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var styles = __WEBPACK_IMPORTED_MODULE_3_aphrodite__["StyleSheet"].create({
  container: {
    paddingTop: __WEBPACK_IMPORTED_MODULE_4__config_theme__["a" /* Theme */].navigation.height
  }
});

UnauthenticatedContainer.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

UnauthenticatedContainer.defaultProps = {
  children: []
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* mapDispatchToProps */])(UnauthenticatedContainer));

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aphrodite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aphrodite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_applicationState__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_theme__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Body__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_UnauthenticatedHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Loader__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_user__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable */















var styles = void 0;

var Verify = function (_Component) {
  _inherits(Verify, _Component);

  function Verify(props) {
    _classCallCheck(this, Verify);

    var _this = _possibleConstructorReturn(this, (Verify.__proto__ || Object.getPrototypeOf(Verify)).call(this, props));

    _this.state = {
      verifying: true,
      successful: true,
      errorMessage: null
    };

    _this.openLoginHandler = _this.loginModalOpenHandler.bind(_this);
    return _this;
  }

  _createClass(Verify, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var ID = this.findGetParameter('Member');
      var VerificationToken = this.findGetParameter('VerificationToken');
      // console.log('ID, VerificationToken', ID, VerificationToken);

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_user__["n" /* sendMemberVerificationRequest */])(ID, VerificationToken)).then(function (response) {
        if (response.status === 200) {
          _this2.setState({
            verifying: false,
            successful: true
          });
        } else {
          _this2.setState({
            errorMessage: response.data.error,
            verifying: false,
            successful: false
          });
        }
      });
    }
  }, {
    key: 'findGetParameter',
    value: function findGetParameter(parameterName) {
      var result = null,
          tmp = [];
      var items = location.search.substr(1).split("&");
      for (var index = 0; index < items.length; index++) {
        tmp = items[index].split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      }
      return result;
    }
  }, {
    key: 'loginModalOpenHandler',
    value: function loginModalOpenHandler() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions_applicationState__["a" /* updateAppState */])({
        login_modal_open: true
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__components_Body__["a" /* default */],
        { hasFooter: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_UnauthenticatedHeader__["a" /* default */], { openLoginHandler: this.openLoginHandler }),
        this.state.verifying ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Loader__["a" /* default */], { text: 'Verifying' }) : this.state.successful === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.title) },
            'Your account has been activated'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.paragraph) },
            'You can now ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.login_link), onClick: this.openLoginHandler },
              'log in'
            ),
            ' using your email address and password. It\'s time to set up your profile and get dog sharing!'
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.container) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.title) },
            'Oops, we couldn\'t verify you.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.subtitle) },
            this.state.errorMessage
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_aphrodite__["css"])(styles.message) },
            'Please double check the email link we sent you and try again later.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Footer__["a" /* default */], { user: {} })
      );
    }
  }]);

  return Verify;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Verify.propTypes = {
  dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

styles = __WEBPACK_IMPORTED_MODULE_3_aphrodite__["StyleSheet"].create({
  container: {
    padding: '70px 15px',
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 515,
    marginTop: 80,
    flexDirection: 'column'
  },
  title: _defineProperty({
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 60,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_heading,
    color: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].black,
    marginBottom: 30

  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 45
  }),
  subtitle: _defineProperty({
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 40,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_heading,
    color: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].black,
    marginBottom: 30

  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 25
  }),
  message: _defineProperty({
    fontFamily: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_family_heading,
    fontSize: 30,
    fontWeight: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].font_weight_heading,
    color: __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].black

  }, __WEBPACK_IMPORTED_MODULE_6__config_theme__["a" /* Theme */].mobile_query, {
    fontSize: 25
  }),
  login_link: {
    cursor: 'pointer'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* mapStateToProps */], __WEBPACK_IMPORTED_MODULE_4__utils__["b" /* mapDispatchToProps */])(Verify));

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(553);


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["Cleave"] = factory(require("react"));
	else
		root["Cleave"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

	var React = __webpack_require__(1); // eslint-disable-line no-unused-vars
	var CreateReactClass = __webpack_require__(2);

	var NumeralFormatter = __webpack_require__(9);
	var DateFormatter = __webpack_require__(10);
	var TimeFormatter = __webpack_require__(11);
	var PhoneFormatter = __webpack_require__(12);
	var CreditCardDetector = __webpack_require__(13);
	var Util = __webpack_require__(14);
	var DefaultProperties = __webpack_require__(15);

	var cleaveReactClass = CreateReactClass({
	    componentDidMount: function componentDidMount() {
	        this.init();
	    },

	    componentDidUpdate: function componentDidUpdate(prevProps) {
	        var owner = this,
	            phoneRegionCode = (owner.props.options || {}).phoneRegionCode,
	            newValue = owner.props.value,
	            pps = owner.properties;

	        owner.updateRegisteredEvents(owner.props);
	        if (prevProps.value !== newValue && newValue !== undefined && newValue !== null) {
	            newValue = newValue.toString();

	            if (newValue !== owner.properties.result) {
	                owner.properties.initValue = newValue;
	                owner.onInput(newValue, true);
	            }
	        }

	        // update phone region code
	        var prevPhoneRegionCode = (prevProps.options || {}).phoneRegionCode;
	        if (prevPhoneRegionCode !== phoneRegionCode && phoneRegionCode && phoneRegionCode !== owner.properties.phoneRegionCode) {
	            owner.properties.phoneRegionCode = phoneRegionCode;
	            owner.initPhoneFormatter();
	            owner.onInput(owner.properties.result);
	        }

	        Util.setSelection(owner.element, owner.state.cursorPosition, pps.document);
	    },

	    updateRegisteredEvents: function updateRegisteredEvents(props) {
	        var owner = this,
	            _owner$registeredEven = owner.registeredEvents,
	            onKeyDown = _owner$registeredEven.onKeyDown,
	            onChange = _owner$registeredEven.onChange,
	            onFocus = _owner$registeredEven.onFocus,
	            onBlur = _owner$registeredEven.onBlur,
	            onInit = _owner$registeredEven.onInit;


	        if (props.onInit && props.onInit !== onInit) owner.registeredEvents.onInit = props.onInit;
	        if (props.onChange && props.onChange !== onChange) owner.registeredEvents.onChange = props.onChange;
	        if (props.onFocus && props.onFocus !== onFocus) owner.registeredEvents.onFocus = props.onFocus;
	        if (props.onBlur && props.onBlur !== onBlur) owner.registeredEvents.onBlur = props.onBlur;
	        if (props.onKeyDown && props.onKeyDown !== onKeyDown) owner.registeredEvents.onKeyDown = props.onKeyDown;
	    },

	    getInitialState: function getInitialState() {
	        var owner = this,
	            _owner$props = owner.props,
	            value = _owner$props.value,
	            options = _owner$props.options,
	            onKeyDown = _owner$props.onKeyDown,
	            onChange = _owner$props.onChange,
	            onFocus = _owner$props.onFocus,
	            onBlur = _owner$props.onBlur,
	            onInit = _owner$props.onInit;


	        owner.registeredEvents = {
	            onInit: onInit || Util.noop,
	            onChange: onChange || Util.noop,
	            onFocus: onFocus || Util.noop,
	            onBlur: onBlur || Util.noop,
	            onKeyDown: onKeyDown || Util.noop
	        };

	        if (!options) {
	            options = {};
	        }

	        options.initValue = value;

	        owner.properties = DefaultProperties.assign({}, options);

	        return {
	            value: owner.properties.result,
	            cursorPosition: 0
	        };
	    },

	    init: function init() {
	        var owner = this,
	            pps = owner.properties;

	        // so no need for this lib at all
	        if (!pps.numeral && !pps.phone && !pps.creditCard && !pps.time && !pps.date && pps.blocksLength === 0 && !pps.prefix) {
	            owner.onInput(pps.initValue);
	            owner.registeredEvents.onInit(owner);

	            return;
	        }

	        pps.maxLength = Util.getMaxLength(pps.blocks);

	        owner.isAndroid = Util.isAndroid();

	        owner.initPhoneFormatter();
	        owner.initDateFormatter();
	        owner.initTimeFormatter();
	        owner.initNumeralFormatter();

	        // avoid touch input field if value is null
	        // otherwise Firefox will add red box-shadow for <input required />
	        if (pps.initValue || pps.prefix && !pps.noImmediatePrefix) {
	            owner.onInput(pps.initValue);
	        }

	        owner.registeredEvents.onInit(owner);
	    },

	    initNumeralFormatter: function initNumeralFormatter() {
	        var owner = this,
	            pps = owner.properties;

	        if (!pps.numeral) {
	            return;
	        }

	        pps.numeralFormatter = new NumeralFormatter(pps.numeralDecimalMark, pps.numeralIntegerScale, pps.numeralDecimalScale, pps.numeralThousandsGroupStyle, pps.numeralPositiveOnly, pps.stripLeadingZeroes, pps.prefix, pps.signBeforePrefix, pps.tailPrefix, pps.delimiter);
	    },

	    initTimeFormatter: function initTimeFormatter() {
	        var owner = this,
	            pps = owner.properties;

	        if (!pps.time) {
	            return;
	        }

	        pps.timeFormatter = new TimeFormatter(pps.timePattern, pps.timeFormat);
	        pps.blocks = pps.timeFormatter.getBlocks();
	        pps.blocksLength = pps.blocks.length;
	        pps.maxLength = Util.getMaxLength(pps.blocks);
	    },

	    initDateFormatter: function initDateFormatter() {
	        var owner = this,
	            pps = owner.properties;

	        if (!pps.date) {
	            return;
	        }

	        pps.dateFormatter = new DateFormatter(pps.datePattern, pps.dateMin, pps.dateMax);
	        pps.blocks = pps.dateFormatter.getBlocks();
	        pps.blocksLength = pps.blocks.length;
	        pps.maxLength = Util.getMaxLength(pps.blocks);
	    },

	    initPhoneFormatter: function initPhoneFormatter() {
	        var owner = this,
	            pps = owner.properties;

	        if (!pps.phone) {
	            return;
	        }

	        // Cleave.AsYouTypeFormatter should be provided by
	        // external google closure lib
	        try {
	            pps.phoneFormatter = new PhoneFormatter(new pps.root.Cleave.AsYouTypeFormatter(pps.phoneRegionCode), pps.delimiter);
	        } catch (ex) {
	            throw new Error('Please include phone-type-formatter.{country}.js lib');
	        }
	    },

	    setRawValue: function setRawValue(value) {
	        var owner = this,
	            pps = owner.properties;

	        value = value !== undefined && value !== null ? value.toString() : '';

	        if (pps.numeral) {
	            value = value.replace('.', pps.numeralDecimalMark);
	        }

	        pps.postDelimiterBackspace = false;

	        owner.onChange({
	            target: { value: value },

	            // Methods to better resemble a SyntheticEvent
	            stopPropagation: Util.noop,
	            preventDefault: Util.noop,
	            persist: Util.noop
	        });
	    },

	    getRawValue: function getRawValue() {
	        var owner = this,
	            pps = owner.properties,
	            rawValue = pps.result;

	        if (pps.rawValueTrimPrefix) {
	            rawValue = Util.getPrefixStrippedValue(rawValue, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);
	        }

	        if (pps.numeral) {
	            rawValue = pps.numeralFormatter ? pps.numeralFormatter.getRawValue(rawValue) : '';
	        } else {
	            rawValue = Util.stripDelimiters(rawValue, pps.delimiter, pps.delimiters);
	        }

	        return rawValue;
	    },

	    getISOFormatDate: function getISOFormatDate() {
	        var owner = this,
	            pps = owner.properties;

	        return pps.date ? pps.dateFormatter.getISOFormatDate() : '';
	    },

	    getISOFormatTime: function getISOFormatTime() {
	        var owner = this,
	            pps = owner.properties;

	        return pps.time ? pps.timeFormatter.getISOFormatTime() : '';
	    },

	    onInit: function onInit(owner) {
	        return owner;
	    },

	    onKeyDown: function onKeyDown(event) {
	        var owner = this,
	            pps = owner.properties,
	            charCode = event.which || event.keyCode;

	        owner.lastInputValue = pps.result;
	        owner.isBackward = charCode === 8;

	        owner.registeredEvents.onKeyDown(event);
	    },

	    onFocus: function onFocus(event) {
	        var owner = this,
	            pps = owner.properties;

	        if (pps.prefix && pps.noImmediatePrefix && !event.target.value) {
	            owner.onInput(pps.prefix);
	        }

	        event.target.rawValue = owner.getRawValue();
	        event.target.value = pps.result;

	        owner.registeredEvents.onFocus(event);

	        Util.fixPrefixCursor(owner.element, pps.prefix, pps.delimiter, pps.delimiters);
	    },

	    onBlur: function onBlur(event) {
	        var owner = this,
	            pps = owner.properties;

	        event.target.rawValue = owner.getRawValue();
	        event.target.value = pps.result;

	        owner.registeredEvents.onBlur(event);
	    },

	    onChange: function onChange(event) {
	        var owner = this,
	            pps = owner.properties;

	        owner.isBackward = owner.isBackward || event.inputType === 'deleteContentBackward';
	        // hit backspace when last character is delimiter
	        var postDelimiter = Util.getPostDelimiter(owner.lastInputValue, pps.delimiter, pps.delimiters);

	        if (owner.isBackward && postDelimiter) {
	            pps.postDelimiterBackspace = postDelimiter;
	        } else {
	            pps.postDelimiterBackspace = false;
	        }

	        owner.onInput(event.target.value);

	        event.target.rawValue = owner.getRawValue();
	        event.target.value = pps.result;

	        owner.registeredEvents.onChange(event);
	    },

	    onInput: function onInput(value, fromProps) {
	        var owner = this,
	            pps = owner.properties;

	        // case 1: delete one more character "4"
	        // 1234*| -> hit backspace -> 123|
	        // case 2: last character is not delimiter which is:
	        // 12|34* -> hit backspace -> 1|34*
	        var postDelimiterAfter = Util.getPostDelimiter(value, pps.delimiter, pps.delimiters);
	        if (!fromProps && !pps.numeral && pps.postDelimiterBackspace && !postDelimiterAfter) {
	            value = Util.headStr(value, value.length - pps.postDelimiterBackspace.length);
	        }

	        // phone formatter
	        if (pps.phone) {
	            if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
	                pps.result = pps.prefix + pps.phoneFormatter.format(value).slice(pps.prefix.length);
	            } else {
	                pps.result = pps.phoneFormatter.format(value);
	            }
	            owner.updateValueState();

	            return;
	        }

	        // numeral formatter
	        if (pps.numeral) {
	            // Do not show prefix when noImmediatePrefix is specified
	            // This mostly because we need to show user the native input placeholder
	            if (pps.prefix && pps.noImmediatePrefix && value.length === 0) {
	                pps.result = '';
	            } else {
	                pps.result = pps.numeralFormatter.format(value);
	            }
	            owner.updateValueState();

	            return;
	        }

	        // date
	        if (pps.date) {
	            value = pps.dateFormatter.getValidatedDate(value);
	        }

	        // time
	        if (pps.time) {
	            value = pps.timeFormatter.getValidatedTime(value);
	        }

	        // strip delimiters
	        value = Util.stripDelimiters(value, pps.delimiter, pps.delimiters);

	        // strip prefix
	        value = Util.getPrefixStrippedValue(value, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);

	        // strip non-numeric characters
	        value = pps.numericOnly ? Util.strip(value, /[^\d]/g) : value;

	        // convert case
	        value = pps.uppercase ? value.toUpperCase() : value;
	        value = pps.lowercase ? value.toLowerCase() : value;

	        // prevent from showing prefix when no immediate option enabled with empty input value
	        if (pps.prefix) {
	            if (pps.tailPrefix) {
	                value = value + pps.prefix;
	            } else {
	                value = pps.prefix + value;
	            }

	            // no blocks specified, no need to do formatting
	            if (pps.blocksLength === 0) {
	                pps.result = value;
	                owner.updateValueState();

	                return;
	            }
	        }

	        // update credit card props
	        if (pps.creditCard) {
	            owner.updateCreditCardPropsByValue(value);
	        }

	        // strip over length characters
	        value = pps.maxLength > 0 ? Util.headStr(value, pps.maxLength) : value;

	        // apply blocks
	        pps.result = Util.getFormattedValue(value, pps.blocks, pps.blocksLength, pps.delimiter, pps.delimiters, pps.delimiterLazyShow);

	        owner.updateValueState();
	    },

	    updateCreditCardPropsByValue: function updateCreditCardPropsByValue(value) {
	        var owner = this,
	            pps = owner.properties,
	            creditCardInfo;

	        // At least one of the first 4 characters has changed
	        if (Util.headStr(pps.result, 4) === Util.headStr(value, 4)) {
	            return;
	        }

	        creditCardInfo = CreditCardDetector.getInfo(value, pps.creditCardStrictMode);

	        pps.blocks = creditCardInfo.blocks;
	        pps.blocksLength = pps.blocks.length;
	        pps.maxLength = Util.getMaxLength(pps.blocks);

	        // credit card type changed
	        if (pps.creditCardType !== creditCardInfo.type) {
	            pps.creditCardType = creditCardInfo.type;

	            pps.onCreditCardTypeChanged.call(owner, pps.creditCardType);
	        }
	    },

	    updateValueState: function updateValueState() {
	        var owner = this,
	            pps = owner.properties;

	        if (!owner.element) {
	            owner.setState({ value: pps.result });
	            return;
	        }

	        var endPos = owner.element.selectionEnd;
	        var oldValue = owner.element.value;
	        var newValue = pps.result;

	        owner.lastInputValue = newValue;

	        endPos = Util.getNextCursorPosition(endPos, oldValue, newValue, pps.delimiter, pps.delimiters);

	        if (owner.isAndroid) {
	            window.setTimeout(function () {
	                owner.setState({ value: newValue, cursorPosition: endPos });
	            }, 1);

	            return;
	        }

	        owner.setState({ value: newValue, cursorPosition: endPos });
	    },

	    render: function render() {
	        var owner = this;
	        // eslint-disable-next-line

	        var _owner$props2 = owner.props,
	            value = _owner$props2.value,
	            options = _owner$props2.options,
	            onKeyDown = _owner$props2.onKeyDown,
	            onFocus = _owner$props2.onFocus,
	            onBlur = _owner$props2.onBlur,
	            onChange = _owner$props2.onChange,
	            onInit = _owner$props2.onInit,
	            htmlRef = _owner$props2.htmlRef,
	            propsToTransfer = _objectWithoutProperties(_owner$props2, ['value', 'options', 'onKeyDown', 'onFocus', 'onBlur', 'onChange', 'onInit', 'htmlRef']);

	        return React.createElement('input', _extends({
	            type: 'text',
	            ref: function ref(_ref) {
	                owner.element = _ref;

	                if (!htmlRef) {
	                    return;
	                }

	                htmlRef.apply(this, arguments);
	            },
	            value: owner.state.value,
	            onKeyDown: owner.onKeyDown,
	            onChange: owner.onChange,
	            onFocus: owner.onFocus,
	            onBlur: owner.onBlur
	        }, propsToTransfer));
	    }
	});

	module.exports = cleaveReactClass;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */

	'use strict';

	var React = __webpack_require__(1);
	var factory = __webpack_require__(3);

	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}

	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;

	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */

	'use strict';

	var _assign = __webpack_require__(4);

	var emptyObject = __webpack_require__(5);
	var _invariant = __webpack_require__(6);

	if (false) {
	  var warning = __webpack_require__(7);
	}

	var MIXINS_KEY = 'mixins';

	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}

	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}

	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */

	  var injectedMixins = [];

	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',

	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',

	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',

	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',

	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',

	    // ==== Definition methods ====

	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',

	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',

	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',

	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',

	    // ==== Delegate methods ====

	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',

	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',

	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',

	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',

	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',

	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',

	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',

	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',

	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

	    // ==== Advanced methods ====

	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };

	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };

	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };

	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }

	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;

	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }

	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }

	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;

	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }

	      return;
	    }

	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );

	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;

	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }

	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }

	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }

	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);

	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;

	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];

	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );

	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }

	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }

	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }

	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );

	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;

	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );

	        Constructor[name] = createMergedResultFunction(Constructor[name], property);

	        return;
	      }

	      Constructor[name] = property;
	    }
	  }

	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );

	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }

	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }

	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }

	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }

	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }

	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }

	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };

	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };

	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },

	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };

	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );

	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.

	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }

	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }

	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;

	      this.state = null;

	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.

	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );

	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];

	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }

	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }

	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );

	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }

	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }

	    return Constructor;
	  }

	  return createClass;
	}

	module.exports = factory;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/

	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */

	'use strict';

	var emptyObject = {};

	if (false) {
	  Object.freeze(emptyObject);
	}

	module.exports = emptyObject;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */

	'use strict';

	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */

	var validateFormat = function validateFormat(format) {};

	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}

	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);

	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }

	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}

	module.exports = invariant;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */

	'use strict';

	var emptyFunction = __webpack_require__(8);

	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */

	var warning = emptyFunction;

	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }

	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };

	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }

	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }

	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }

	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}

	module.exports = warning;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */

	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}

	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};

	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};

	module.exports = emptyFunction;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';

	var NumeralFormatter = function NumeralFormatter(numeralDecimalMark, numeralIntegerScale, numeralDecimalScale, numeralThousandsGroupStyle, numeralPositiveOnly, stripLeadingZeroes, prefix, signBeforePrefix, tailPrefix, delimiter) {
	    var owner = this;

	    owner.numeralDecimalMark = numeralDecimalMark || '.';
	    owner.numeralIntegerScale = numeralIntegerScale > 0 ? numeralIntegerScale : 0;
	    owner.numeralDecimalScale = numeralDecimalScale >= 0 ? numeralDecimalScale : 2;
	    owner.numeralThousandsGroupStyle = numeralThousandsGroupStyle || NumeralFormatter.groupStyle.thousand;
	    owner.numeralPositiveOnly = !!numeralPositiveOnly;
	    owner.stripLeadingZeroes = stripLeadingZeroes !== false;
	    owner.prefix = prefix || prefix === '' ? prefix : '';
	    owner.signBeforePrefix = !!signBeforePrefix;
	    owner.tailPrefix = !!tailPrefix;
	    owner.delimiter = delimiter || delimiter === '' ? delimiter : ',';
	    owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';
	};

	NumeralFormatter.groupStyle = {
	    thousand: 'thousand',
	    lakh: 'lakh',
	    wan: 'wan',
	    none: 'none'
	};

	NumeralFormatter.prototype = {
	    getRawValue: function getRawValue(value) {
	        return value.replace(this.delimiterRE, '').replace(this.numeralDecimalMark, '.');
	    },

	    format: function format(value) {
	        var owner = this,
	            parts,
	            partSign,
	            partSignAndPrefix,
	            partInteger,
	            partDecimal = '';

	        // strip alphabet letters
	        value = value.replace(/[A-Za-z]/g, '')
	        // replace the first decimal mark with reserved placeholder
	        .replace(owner.numeralDecimalMark, 'M')

	        // strip non numeric letters except minus and "M"
	        // this is to ensure prefix has been stripped
	        .replace(/[^\dM-]/g, '')

	        // replace the leading minus with reserved placeholder
	        .replace(/^\-/, 'N')

	        // strip the other minus sign (if present)
	        .replace(/\-/g, '')

	        // replace the minus sign (if present)
	        .replace('N', owner.numeralPositiveOnly ? '' : '-')

	        // replace decimal mark
	        .replace('M', owner.numeralDecimalMark);

	        // strip any leading zeros
	        if (owner.stripLeadingZeroes) {
	            value = value.replace(/^(-)?0+(?=\d)/, '$1');
	        }

	        partSign = value.slice(0, 1) === '-' ? '-' : '';
	        if (typeof owner.prefix != 'undefined') {
	            if (owner.signBeforePrefix) {
	                partSignAndPrefix = partSign + owner.prefix;
	            } else {
	                partSignAndPrefix = owner.prefix + partSign;
	            }
	        } else {
	            partSignAndPrefix = partSign;
	        }

	        partInteger = value;

	        if (value.indexOf(owner.numeralDecimalMark) >= 0) {
	            parts = value.split(owner.numeralDecimalMark);
	            partInteger = parts[0];
	            partDecimal = owner.numeralDecimalMark + parts[1].slice(0, owner.numeralDecimalScale);
	        }

	        if (partSign === '-') {
	            partInteger = partInteger.slice(1);
	        }

	        if (owner.numeralIntegerScale > 0) {
	            partInteger = partInteger.slice(0, owner.numeralIntegerScale);
	        }

	        switch (owner.numeralThousandsGroupStyle) {
	            case NumeralFormatter.groupStyle.lakh:
	                partInteger = partInteger.replace(/(\d)(?=(\d\d)+\d$)/g, '$1' + owner.delimiter);

	                break;

	            case NumeralFormatter.groupStyle.wan:
	                partInteger = partInteger.replace(/(\d)(?=(\d{4})+$)/g, '$1' + owner.delimiter);

	                break;

	            case NumeralFormatter.groupStyle.thousand:
	                partInteger = partInteger.replace(/(\d)(?=(\d{3})+$)/g, '$1' + owner.delimiter);

	                break;
	        }

	        if (owner.tailPrefix) {
	            return partSign + partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : '') + owner.prefix;
	        }

	        return partSignAndPrefix + partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : '');
	    }
	};

	module.exports = NumeralFormatter;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';

	var DateFormatter = function DateFormatter(datePattern, dateMin, dateMax) {
	    var owner = this;

	    owner.date = [];
	    owner.blocks = [];
	    owner.datePattern = datePattern;
	    owner.dateMin = dateMin.split('-').reverse().map(function (x) {
	        return parseInt(x, 10);
	    });
	    if (owner.dateMin.length === 2) owner.dateMin.unshift(0);

	    owner.dateMax = dateMax.split('-').reverse().map(function (x) {
	        return parseInt(x, 10);
	    });
	    if (owner.dateMax.length === 2) owner.dateMax.unshift(0);

	    owner.initBlocks();
	};

	DateFormatter.prototype = {
	    initBlocks: function initBlocks() {
	        var owner = this;
	        owner.datePattern.forEach(function (value) {
	            if (value === 'Y') {
	                owner.blocks.push(4);
	            } else {
	                owner.blocks.push(2);
	            }
	        });
	    },

	    getISOFormatDate: function getISOFormatDate() {
	        var owner = this,
	            date = owner.date;

	        return date[2] ? date[2] + '-' + owner.addLeadingZero(date[1]) + '-' + owner.addLeadingZero(date[0]) : '';
	    },

	    getBlocks: function getBlocks() {
	        return this.blocks;
	    },

	    getValidatedDate: function getValidatedDate(value) {
	        var owner = this,
	            result = '';

	        value = value.replace(/[^\d]/g, '');

	        owner.blocks.forEach(function (length, index) {
	            if (value.length > 0) {
	                var sub = value.slice(0, length),
	                    sub0 = sub.slice(0, 1),
	                    rest = value.slice(length);

	                switch (owner.datePattern[index]) {
	                    case 'd':
	                        if (sub === '00') {
	                            sub = '01';
	                        } else if (parseInt(sub0, 10) > 3) {
	                            sub = '0' + sub0;
	                        } else if (parseInt(sub, 10) > 31) {
	                            sub = '31';
	                        }

	                        break;

	                    case 'm':
	                        if (sub === '00') {
	                            sub = '01';
	                        } else if (parseInt(sub0, 10) > 1) {
	                            sub = '0' + sub0;
	                        } else if (parseInt(sub, 10) > 12) {
	                            sub = '12';
	                        }

	                        break;
	                }

	                result += sub;

	                // update remaining string
	                value = rest;
	            }
	        });

	        return this.getFixedDateString(result);
	    },

	    getFixedDateString: function getFixedDateString(value) {
	        var owner = this,
	            datePattern = owner.datePattern,
	            date = [],
	            dayIndex = 0,
	            monthIndex = 0,
	            yearIndex = 0,
	            dayStartIndex = 0,
	            monthStartIndex = 0,
	            yearStartIndex = 0,
	            day,
	            month,
	            year,
	            fullYearDone = false;

	        // mm-dd || dd-mm
	        if (value.length === 4 && datePattern[0].toLowerCase() !== 'y' && datePattern[1].toLowerCase() !== 'y') {
	            dayStartIndex = datePattern[0] === 'd' ? 0 : 2;
	            monthStartIndex = 2 - dayStartIndex;
	            day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
	            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);

	            date = this.getFixedDate(day, month, 0);
	        }

	        // yyyy-mm-dd || yyyy-dd-mm || mm-dd-yyyy || dd-mm-yyyy || dd-yyyy-mm || mm-yyyy-dd
	        if (value.length === 8) {
	            datePattern.forEach(function (type, index) {
	                switch (type) {
	                    case 'd':
	                        dayIndex = index;
	                        break;
	                    case 'm':
	                        monthIndex = index;
	                        break;
	                    default:
	                        yearIndex = index;
	                        break;
	                }
	            });

	            yearStartIndex = yearIndex * 2;
	            dayStartIndex = dayIndex <= yearIndex ? dayIndex * 2 : dayIndex * 2 + 2;
	            monthStartIndex = monthIndex <= yearIndex ? monthIndex * 2 : monthIndex * 2 + 2;

	            day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
	            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
	            year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);

	            fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;

	            date = this.getFixedDate(day, month, year);
	        }

	        // mm-yy || yy-mm
	        if (value.length === 4 && (datePattern[0] === 'y' || datePattern[1] === 'y')) {
	            monthStartIndex = datePattern[0] === 'm' ? 0 : 2;
	            yearStartIndex = 2 - monthStartIndex;
	            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
	            year = parseInt(value.slice(yearStartIndex, yearStartIndex + 2), 10);

	            fullYearDone = value.slice(yearStartIndex, yearStartIndex + 2).length === 2;

	            date = [0, month, year];
	        }

	        // mm-yyyy || yyyy-mm
	        if (value.length === 6 && (datePattern[0] === 'Y' || datePattern[1] === 'Y')) {
	            monthStartIndex = datePattern[0] === 'm' ? 0 : 4;
	            yearStartIndex = 2 - 0.5 * monthStartIndex;
	            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
	            year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);

	            fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;

	            date = [0, month, year];
	        }

	        date = owner.getRangeFixedDate(date);
	        owner.date = date;

	        var result = date.length === 0 ? value : datePattern.reduce(function (previous, current) {
	            switch (current) {
	                case 'd':
	                    return previous + (date[0] === 0 ? '' : owner.addLeadingZero(date[0]));
	                case 'm':
	                    return previous + (date[1] === 0 ? '' : owner.addLeadingZero(date[1]));
	                case 'y':
	                    return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], false) : '');
	                case 'Y':
	                    return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], true) : '');
	            }
	        }, '');

	        return result;
	    },

	    getRangeFixedDate: function getRangeFixedDate(date) {
	        var owner = this,
	            datePattern = owner.datePattern,
	            dateMin = owner.dateMin || [],
	            dateMax = owner.dateMax || [];

	        if (!date.length || dateMin.length < 3 && dateMax.length < 3) return date;

	        if (datePattern.find(function (x) {
	            return x.toLowerCase() === 'y';
	        }) && date[2] === 0) return date;

	        if (dateMax.length && (dateMax[2] < date[2] || dateMax[2] === date[2] && (dateMax[1] < date[1] || dateMax[1] === date[1] && dateMax[0] < date[0]))) return dateMax;

	        if (dateMin.length && (dateMin[2] > date[2] || dateMin[2] === date[2] && (dateMin[1] > date[1] || dateMin[1] === date[1] && dateMin[0] > date[0]))) return dateMin;

	        return date;
	    },

	    getFixedDate: function getFixedDate(day, month, year) {
	        day = Math.min(day, 31);
	        month = Math.min(month, 12);
	        year = parseInt(year || 0, 10);

	        if (month < 7 && month % 2 === 0 || month > 8 && month % 2 === 1) {
	            day = Math.min(day, month === 2 ? this.isLeapYear(year) ? 29 : 28 : 30);
	        }

	        return [day, month, year];
	    },

	    isLeapYear: function isLeapYear(year) {
	        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
	    },

	    addLeadingZero: function addLeadingZero(number) {
	        return (number < 10 ? '0' : '') + number;
	    },

	    addLeadingZeroForYear: function addLeadingZeroForYear(number, fullYearMode) {
	        if (fullYearMode) {
	            return (number < 10 ? '000' : number < 100 ? '00' : number < 1000 ? '0' : '') + number;
	        }

	        return (number < 10 ? '0' : '') + number;
	    }
	};

	module.exports = DateFormatter;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';

	var TimeFormatter = function TimeFormatter(timePattern, timeFormat) {
	    var owner = this;

	    owner.time = [];
	    owner.blocks = [];
	    owner.timePattern = timePattern;
	    owner.timeFormat = timeFormat;
	    owner.initBlocks();
	};

	TimeFormatter.prototype = {
	    initBlocks: function initBlocks() {
	        var owner = this;
	        owner.timePattern.forEach(function () {
	            owner.blocks.push(2);
	        });
	    },

	    getISOFormatTime: function getISOFormatTime() {
	        var owner = this,
	            time = owner.time;

	        return time[2] ? owner.addLeadingZero(time[0]) + ':' + owner.addLeadingZero(time[1]) + ':' + owner.addLeadingZero(time[2]) : '';
	    },

	    getBlocks: function getBlocks() {
	        return this.blocks;
	    },

	    getTimeFormatOptions: function getTimeFormatOptions() {
	        var owner = this;
	        if (String(owner.timeFormat) === '12') {
	            return {
	                maxHourFirstDigit: 1,
	                maxHours: 12,
	                maxMinutesFirstDigit: 5,
	                maxMinutes: 60
	            };
	        }

	        return {
	            maxHourFirstDigit: 2,
	            maxHours: 23,
	            maxMinutesFirstDigit: 5,
	            maxMinutes: 60
	        };
	    },

	    getValidatedTime: function getValidatedTime(value) {
	        var owner = this,
	            result = '';

	        value = value.replace(/[^\d]/g, '');

	        var timeFormatOptions = owner.getTimeFormatOptions();

	        owner.blocks.forEach(function (length, index) {
	            if (value.length > 0) {
	                var sub = value.slice(0, length),
	                    sub0 = sub.slice(0, 1),
	                    rest = value.slice(length);

	                switch (owner.timePattern[index]) {

	                    case 'h':
	                        if (parseInt(sub0, 10) > timeFormatOptions.maxHourFirstDigit) {
	                            sub = '0' + sub0;
	                        } else if (parseInt(sub, 10) > timeFormatOptions.maxHours) {
	                            sub = timeFormatOptions.maxHours + '';
	                        }

	                        break;

	                    case 'm':
	                    case 's':
	                        if (parseInt(sub0, 10) > timeFormatOptions.maxMinutesFirstDigit) {
	                            sub = '0' + sub0;
	                        } else if (parseInt(sub, 10) > timeFormatOptions.maxMinutes) {
	                            sub = timeFormatOptions.maxMinutes + '';
	                        }
	                        break;
	                }

	                result += sub;

	                // update remaining string
	                value = rest;
	            }
	        });

	        return this.getFixedTimeString(result);
	    },

	    getFixedTimeString: function getFixedTimeString(value) {
	        var owner = this,
	            timePattern = owner.timePattern,
	            time = [],
	            secondIndex = 0,
	            minuteIndex = 0,
	            hourIndex = 0,
	            secondStartIndex = 0,
	            minuteStartIndex = 0,
	            hourStartIndex = 0,
	            second,
	            minute,
	            hour;

	        if (value.length === 6) {
	            timePattern.forEach(function (type, index) {
	                switch (type) {
	                    case 's':
	                        secondIndex = index * 2;
	                        break;
	                    case 'm':
	                        minuteIndex = index * 2;
	                        break;
	                    case 'h':
	                        hourIndex = index * 2;
	                        break;
	                }
	            });

	            hourStartIndex = hourIndex;
	            minuteStartIndex = minuteIndex;
	            secondStartIndex = secondIndex;

	            second = parseInt(value.slice(secondStartIndex, secondStartIndex + 2), 10);
	            minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
	            hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);

	            time = this.getFixedTime(hour, minute, second);
	        }

	        if (value.length === 4 && owner.timePattern.indexOf('s') < 0) {
	            timePattern.forEach(function (type, index) {
	                switch (type) {
	                    case 'm':
	                        minuteIndex = index * 2;
	                        break;
	                    case 'h':
	                        hourIndex = index * 2;
	                        break;
	                }
	            });

	            hourStartIndex = hourIndex;
	            minuteStartIndex = minuteIndex;

	            second = 0;
	            minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
	            hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);

	            time = this.getFixedTime(hour, minute, second);
	        }

	        owner.time = time;

	        return time.length === 0 ? value : timePattern.reduce(function (previous, current) {
	            switch (current) {
	                case 's':
	                    return previous + owner.addLeadingZero(time[2]);
	                case 'm':
	                    return previous + owner.addLeadingZero(time[1]);
	                case 'h':
	                    return previous + owner.addLeadingZero(time[0]);
	            }
	        }, '');
	    },

	    getFixedTime: function getFixedTime(hour, minute, second) {
	        second = Math.min(parseInt(second || 0, 10), 60);
	        minute = Math.min(minute, 60);
	        hour = Math.min(hour, 60);

	        return [hour, minute, second];
	    },

	    addLeadingZero: function addLeadingZero(number) {
	        return (number < 10 ? '0' : '') + number;
	    }
	};

	module.exports = TimeFormatter;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';

	var PhoneFormatter = function PhoneFormatter(formatter, delimiter) {
	    var owner = this;

	    owner.delimiter = delimiter || delimiter === '' ? delimiter : ' ';
	    owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';

	    owner.formatter = formatter;
	};

	PhoneFormatter.prototype = {
	    setFormatter: function setFormatter(formatter) {
	        this.formatter = formatter;
	    },

	    format: function format(phoneNumber) {
	        var owner = this;

	        owner.formatter.clear();

	        // only keep number and +
	        phoneNumber = phoneNumber.replace(/[^\d+]/g, '');

	        // strip non-leading +
	        phoneNumber = phoneNumber.replace(/^\+/, 'B').replace(/\+/g, '').replace('B', '+');

	        // strip delimiter
	        phoneNumber = phoneNumber.replace(owner.delimiterRE, '');

	        var result = '',
	            current,
	            validated = false;

	        for (var i = 0, iMax = phoneNumber.length; i < iMax; i++) {
	            current = owner.formatter.inputDigit(phoneNumber.charAt(i));

	            // has ()- or space inside
	            if (/[\s()-]/g.test(current)) {
	                result = current;

	                validated = true;
	            } else {
	                if (!validated) {
	                    result = current;
	                }
	                // else: over length input
	                // it turns to invalid number again
	            }
	        }

	        // strip ()
	        // e.g. US: 7161234567 returns (716) 123-4567
	        result = result.replace(/[()]/g, '');
	        // replace library delimiter with user customized delimiter
	        result = result.replace(/[\s-]/g, owner.delimiter);

	        return result;
	    }
	};

	module.exports = PhoneFormatter;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';

	var CreditCardDetector = {
	    blocks: {
	        uatp: [4, 5, 6],
	        amex: [4, 6, 5],
	        diners: [4, 6, 4],
	        discover: [4, 4, 4, 4],
	        mastercard: [4, 4, 4, 4],
	        dankort: [4, 4, 4, 4],
	        instapayment: [4, 4, 4, 4],
	        jcb15: [4, 6, 5],
	        jcb: [4, 4, 4, 4],
	        maestro: [4, 4, 4, 4],
	        visa: [4, 4, 4, 4],
	        mir: [4, 4, 4, 4],
	        unionPay: [4, 4, 4, 4],
	        general: [4, 4, 4, 4]
	    },

	    re: {
	        // starts with 1; 15 digits, not starts with 1800 (jcb card)
	        uatp: /^(?!1800)1\d{0,14}/,

	        // starts with 34/37; 15 digits
	        amex: /^3[47]\d{0,13}/,

	        // starts with 6011/65/644-649; 16 digits
	        discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/,

	        // starts with 300-305/309 or 36/38/39; 14 digits
	        diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,

	        // starts with 51-55/2221–2720; 16 digits
	        mastercard: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,

	        // starts with 5019/4175/4571; 16 digits
	        dankort: /^(5019|4175|4571)\d{0,12}/,

	        // starts with 637-639; 16 digits
	        instapayment: /^63[7-9]\d{0,13}/,

	        // starts with 2131/1800; 15 digits
	        jcb15: /^(?:2131|1800)\d{0,11}/,

	        // starts with 2131/1800/35; 16 digits
	        jcb: /^(?:35\d{0,2})\d{0,12}/,

	        // starts with 50/56-58/6304/67; 16 digits
	        maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,

	        // starts with 22; 16 digits
	        mir: /^220[0-4]\d{0,12}/,

	        // starts with 4; 16 digits
	        visa: /^4\d{0,15}/,

	        // starts with 62/81; 16 digits
	        unionPay: /^(62|81)\d{0,14}/
	    },

	    getStrictBlocks: function getStrictBlocks(block) {
	        var total = block.reduce(function (prev, current) {
	            return prev + current;
	        }, 0);

	        return block.concat(19 - total);
	    },

	    getInfo: function getInfo(value, strictMode) {
	        var blocks = CreditCardDetector.blocks,
	            re = CreditCardDetector.re;

	        // Some credit card can have up to 19 digits number.
	        // Set strictMode to true will remove the 16 max-length restrain,
	        // however, I never found any website validate card number like
	        // this, hence probably you don't want to enable this option.
	        strictMode = !!strictMode;

	        for (var key in re) {
	            if (re[key].test(value)) {
	                var matchedBlocks = blocks[key];
	                return {
	                    type: key,
	                    blocks: strictMode ? this.getStrictBlocks(matchedBlocks) : matchedBlocks
	                };
	            }
	        }

	        return {
	            type: 'unknown',
	            blocks: strictMode ? this.getStrictBlocks(blocks.general) : blocks.general
	        };
	    }
	};

	module.exports = CreditCardDetector;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';

	var Util = {
	    noop: function noop() {},

	    strip: function strip(value, re) {
	        return value.replace(re, '');
	    },

	    getPostDelimiter: function getPostDelimiter(value, delimiter, delimiters) {
	        // single delimiter
	        if (delimiters.length === 0) {
	            return value.slice(-delimiter.length) === delimiter ? delimiter : '';
	        }

	        // multiple delimiters
	        var matchedDelimiter = '';
	        delimiters.forEach(function (current) {
	            if (value.slice(-current.length) === current) {
	                matchedDelimiter = current;
	            }
	        });

	        return matchedDelimiter;
	    },

	    getDelimiterREByDelimiter: function getDelimiterREByDelimiter(delimiter) {
	        return new RegExp(delimiter.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'), 'g');
	    },

	    getNextCursorPosition: function getNextCursorPosition(prevPos, oldValue, newValue, delimiter, delimiters) {
	        // If cursor was at the end of value, just place it back.
	        // Because new value could contain additional chars.
	        if (oldValue.length === prevPos) {
	            return newValue.length;
	        }

	        return prevPos + this.getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters);
	    },

	    getPositionOffset: function getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters) {
	        var oldRawValue, newRawValue, lengthOffset;

	        oldRawValue = this.stripDelimiters(oldValue.slice(0, prevPos), delimiter, delimiters);
	        newRawValue = this.stripDelimiters(newValue.slice(0, prevPos), delimiter, delimiters);
	        lengthOffset = oldRawValue.length - newRawValue.length;

	        return lengthOffset !== 0 ? lengthOffset / Math.abs(lengthOffset) : 0;
	    },

	    stripDelimiters: function stripDelimiters(value, delimiter, delimiters) {
	        var owner = this;

	        // single delimiter
	        if (delimiters.length === 0) {
	            var delimiterRE = delimiter ? owner.getDelimiterREByDelimiter(delimiter) : '';

	            return value.replace(delimiterRE, '');
	        }

	        // multiple delimiters
	        delimiters.forEach(function (current) {
	            current.split('').forEach(function (letter) {
	                value = value.replace(owner.getDelimiterREByDelimiter(letter), '');
	            });
	        });

	        return value;
	    },

	    headStr: function headStr(str, length) {
	        return str.slice(0, length);
	    },

	    getMaxLength: function getMaxLength(blocks) {
	        return blocks.reduce(function (previous, current) {
	            return previous + current;
	        }, 0);
	    },

	    // strip prefix
	    // Before type  |   After type    |     Return value
	    // PEFIX-...    |   PEFIX-...     |     ''
	    // PREFIX-123   |   PEFIX-123     |     123
	    // PREFIX-123   |   PREFIX-23     |     23
	    // PREFIX-123   |   PREFIX-1234   |     1234
	    getPrefixStrippedValue: function getPrefixStrippedValue(value, prefix, prefixLength, prevResult, delimiter, delimiters, noImmediatePrefix, tailPrefix, signBeforePrefix) {
	        // No prefix
	        if (prefixLength === 0) {
	            return value;
	        }

	        // Value is prefix
	        if (value === prefix && value !== '') {
	            return '';
	        }

	        if (signBeforePrefix && value.slice(0, 1) == '-') {
	            var prev = prevResult.slice(0, 1) == '-' ? prevResult.slice(1) : prevResult;
	            return '-' + this.getPrefixStrippedValue(value.slice(1), prefix, prefixLength, prev, delimiter, delimiters, noImmediatePrefix, tailPrefix, signBeforePrefix);
	        }

	        // Pre result prefix string does not match pre-defined prefix
	        if (prevResult.slice(0, prefixLength) !== prefix && !tailPrefix) {
	            // Check if the first time user entered something
	            if (noImmediatePrefix && !prevResult && value) return value;
	            return '';
	        } else if (prevResult.slice(-prefixLength) !== prefix && tailPrefix) {
	            // Check if the first time user entered something
	            if (noImmediatePrefix && !prevResult && value) return value;
	            return '';
	        }

	        var prevValue = this.stripDelimiters(prevResult, delimiter, delimiters);

	        // New value has issue, someone typed in between prefix letters
	        // Revert to pre value
	        if (value.slice(0, prefixLength) !== prefix && !tailPrefix) {
	            return prevValue.slice(prefixLength);
	        } else if (value.slice(-prefixLength) !== prefix && tailPrefix) {
	            return prevValue.slice(0, -prefixLength - 1);
	        }

	        // No issue, strip prefix for new value
	        return tailPrefix ? value.slice(0, -prefixLength) : value.slice(prefixLength);
	    },

	    getFirstDiffIndex: function getFirstDiffIndex(prev, current) {
	        var index = 0;

	        while (prev.charAt(index) === current.charAt(index)) {
	            if (prev.charAt(index++) === '') {
	                return -1;
	            }
	        }

	        return index;
	    },

	    getFormattedValue: function getFormattedValue(value, blocks, blocksLength, delimiter, delimiters, delimiterLazyShow) {
	        var result = '',
	            multipleDelimiters = delimiters.length > 0,
	            currentDelimiter = '';

	        // no options, normal input
	        if (blocksLength === 0) {
	            return value;
	        }

	        blocks.forEach(function (length, index) {
	            if (value.length > 0) {
	                var sub = value.slice(0, length),
	                    rest = value.slice(length);

	                if (multipleDelimiters) {
	                    currentDelimiter = delimiters[delimiterLazyShow ? index - 1 : index] || currentDelimiter;
	                } else {
	                    currentDelimiter = delimiter;
	                }

	                if (delimiterLazyShow) {
	                    if (index > 0) {
	                        result += currentDelimiter;
	                    }

	                    result += sub;
	                } else {
	                    result += sub;

	                    if (sub.length === length && index < blocksLength - 1) {
	                        result += currentDelimiter;
	                    }
	                }

	                // update remaining string
	                value = rest;
	            }
	        });

	        return result;
	    },

	    // move cursor to the end
	    // the first time user focuses on an input with prefix
	    fixPrefixCursor: function fixPrefixCursor(el, prefix, delimiter, delimiters) {
	        if (!el) {
	            return;
	        }

	        var val = el.value,
	            appendix = delimiter || delimiters[0] || ' ';

	        if (!el.setSelectionRange || !prefix || prefix.length + appendix.length <= val.length) {
	            return;
	        }

	        var len = val.length * 2;

	        // set timeout to avoid blink
	        setTimeout(function () {
	            el.setSelectionRange(len, len);
	        }, 1);
	    },

	    // Check if input field is fully selected
	    checkFullSelection: function checkFullSelection(value) {
	        try {
	            var selection = window.getSelection() || document.getSelection() || {};
	            return selection.toString().length === value.length;
	        } catch (ex) {
	            // Ignore
	        }

	        return false;
	    },

	    setSelection: function setSelection(element, position, doc) {
	        if (element !== this.getActiveElement(doc)) {
	            return;
	        }

	        // cursor is already in the end
	        if (element && element.value.length <= position) {
	            return;
	        }

	        if (element.createTextRange) {
	            var range = element.createTextRange();

	            range.move('character', position);
	            range.select();
	        } else {
	            try {
	                element.setSelectionRange(position, position);
	            } catch (e) {
	                // eslint-disable-next-line
	                console.warn('The input element type does not support selection');
	            }
	        }
	    },

	    getActiveElement: function getActiveElement(parent) {
	        var activeElement = parent.activeElement;
	        if (activeElement && activeElement.shadowRoot) {
	            return this.getActiveElement(activeElement.shadowRoot);
	        }
	        return activeElement;
	    },

	    isAndroid: function isAndroid() {
	        return navigator && /android/i.test(navigator.userAgent);
	    },

	    // On Android chrome, the keyup and keydown events
	    // always return key code 229 as a composition that
	    // buffers the user’s keystrokes
	    // see https://github.com/nosir/cleave.js/issues/147
	    isAndroidBackspaceKeydown: function isAndroidBackspaceKeydown(lastInputValue, currentInputValue) {
	        if (!this.isAndroid() || !lastInputValue || !currentInputValue) {
	            return false;
	        }

	        return currentInputValue === lastInputValue.slice(0, -1);
	    }
	};

	module.exports = Util;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';

	/**
	 * Props Assignment
	 *
	 * Separate this, so react module can share the usage
	 */

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var DefaultProperties = {
	    // Maybe change to object-assign
	    // for now just keep it as simple
	    assign: function assign(target, opts) {
	        target = target || {};
	        opts = opts || {};

	        // credit card
	        target.creditCard = !!opts.creditCard;
	        target.creditCardStrictMode = !!opts.creditCardStrictMode;
	        target.creditCardType = '';
	        target.onCreditCardTypeChanged = opts.onCreditCardTypeChanged || function () {};

	        // phone
	        target.phone = !!opts.phone;
	        target.phoneRegionCode = opts.phoneRegionCode || 'AU';
	        target.phoneFormatter = {};

	        // time
	        target.time = !!opts.time;
	        target.timePattern = opts.timePattern || ['h', 'm', 's'];
	        target.timeFormat = opts.timeFormat || '24';
	        target.timeFormatter = {};

	        // date
	        target.date = !!opts.date;
	        target.datePattern = opts.datePattern || ['d', 'm', 'Y'];
	        target.dateMin = opts.dateMin || '';
	        target.dateMax = opts.dateMax || '';
	        target.dateFormatter = {};

	        // numeral
	        target.numeral = !!opts.numeral;
	        target.numeralIntegerScale = opts.numeralIntegerScale > 0 ? opts.numeralIntegerScale : 0;
	        target.numeralDecimalScale = opts.numeralDecimalScale >= 0 ? opts.numeralDecimalScale : 2;
	        target.numeralDecimalMark = opts.numeralDecimalMark || '.';
	        target.numeralThousandsGroupStyle = opts.numeralThousandsGroupStyle || 'thousand';
	        target.numeralPositiveOnly = !!opts.numeralPositiveOnly;
	        target.stripLeadingZeroes = opts.stripLeadingZeroes !== false;
	        target.signBeforePrefix = !!opts.signBeforePrefix;
	        target.tailPrefix = !!opts.tailPrefix;

	        // others
	        target.swapHiddenInput = !!opts.swapHiddenInput;

	        target.numericOnly = target.creditCard || target.date || !!opts.numericOnly;

	        target.uppercase = !!opts.uppercase;
	        target.lowercase = !!opts.lowercase;

	        target.prefix = target.creditCard || target.date ? '' : opts.prefix || '';
	        target.noImmediatePrefix = !!opts.noImmediatePrefix;
	        target.prefixLength = target.prefix.length;
	        target.rawValueTrimPrefix = !!opts.rawValueTrimPrefix;
	        target.copyDelimiter = !!opts.copyDelimiter;

	        target.initValue = opts.initValue !== undefined && opts.initValue !== null ? opts.initValue.toString() : '';

	        target.delimiter = opts.delimiter || opts.delimiter === '' ? opts.delimiter : opts.date ? '/' : opts.time ? ':' : opts.numeral ? ',' : opts.phone ? ' ' : ' ';
	        target.delimiterLength = target.delimiter.length;
	        target.delimiterLazyShow = !!opts.delimiterLazyShow;
	        target.delimiters = opts.delimiters || [];

	        target.blocks = opts.blocks || [];
	        target.blocksLength = target.blocks.length;

	        target.root = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global ? global : window;
	        target.document = opts.document || target.root.document;

	        target.maxLength = 0;

	        target.backspace = false;
	        target.result = '';

	        target.onValueChanged = opts.onValueChanged || function () {};

	        return target;
	    }
	};

	module.exports = DefaultProperties;

/***/ })
/******/ ])
});
;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
});


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(382);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasClass__ = __webpack_require__(278);

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__hasClass__["a" /* default */])(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasClass;
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeClass;
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(282);
var each = __webpack_require__(105).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(280);
var Util = __webpack_require__(105);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(281);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.7082e21a.svg";

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/adventures.1f9046a9.svg";

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/agility.942e96c6.svg";

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/beach.4a9a3540.svg";

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cafes.7a9ffe27.svg";

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dogTime.d7639d34.svg";

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/home.98750e5e.svg";

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/parks.4e53a9d2.svg";

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/running.3e29e1ee.svg";

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/service.65172ea4.svg";

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/swimming.dd5a8975.svg";

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/therapy.8bf6333e.svg";

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/training.dad3b238.svg";

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/walking.736a6d71.svg";

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/check.3a844cc1.svg";

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon.328cea88.svg";

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.7082e21a.svg";

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/check.3a844cc1.svg";

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/check.3a844cc1.svg";

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.179bcf65.svg";

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.7082e21a.svg";

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/paw.a67c80c2.svg";

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.7082e21a.svg";

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/facebook.cba4b3f5.svg";

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/instagram.ad27e94b.svg";

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mail.830d68a7.svg";

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/youtube.e5b5d0e2.svg";

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pin.b63d66c4.svg";

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrow.3eb1be84.svg";

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.7082e21a.svg";

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.7082e21a.svg";

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.7082e21a.svg";

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.d01e5ead.svg";

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon.328cea88.svg";

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.7082e21a.svg";

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.7082e21a.svg";

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.7082e21a.svg";

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/star.d19afe83.svg";

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/paw.ad5923d4.svg";

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrow.3eb1be84.svg";

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/activity.328cea88.svg";

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/breed.85ebfa2c.svg";

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/location.0b09de3a.svg";

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/facebook.65ba4750.svg";

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mail.830d68a7.svg";

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/paw.2cd39b64.svg";

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrow.3eb1be84.svg";

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/information.309d71c6.svg";

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/check.3a844cc1.svg";

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cross.bc4070c2.svg";

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/envelope.28273fe1.svg";

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/heart.77630f3f.svg";

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/location.bdfeb66a.svg";

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/paw.f30524df.svg";

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/preview.657b740e.svg";

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PoochIcon.5ffcee59.svg";

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Upload.8a3cae0d.svg";

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/EditIcon.698f838c.svg";

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Upload.8a3cae0d.svg";

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tooltip.1b52d399.svg";

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/plus.46e0a872.svg";

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/check.561ccaa6.svg";

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dog.a70ea4a7.svg";

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tooltip.1b52d399.svg";

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PoochIcon.c97e0fc0.svg";

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Upload.8a3cae0d.svg";

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/EditIcon.5fd931c5.svg";

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Upload.8a3cae0d.svg";

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tooltip.1b52d399.svg";

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Borrower.4d0180d3.svg";

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Owner.ea91044e.svg";

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/plus.46e0a872.svg";

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/check.3a844cc1.svg";

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cross.bc4070c2.svg";

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/envelope.28273fe1.svg";

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/location.bdfeb66a.svg";

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/paw.a67c80c2.svg";

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/preview.657b740e.svg";

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/warning.5794f6ae.svg";

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/plus.46e0a872.svg";

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_1.2f19ec74.svg";

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_2.ca95817f.svg";

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_3.05dfe8d2.svg";

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/paw.1518c91f.svg";

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isFSA = isFSA;
exports.isError = isError;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodashIsplainobject = __webpack_require__(374);

var _lodashIsplainobject2 = _interopRequireDefault(_lodashIsplainobject);

var validKeys = ['type', 'payload', 'error', 'meta'];

function isValidKey(key) {
  return validKeys.indexOf(key) > -1;
}

function isFSA(action) {
  return _lodashIsplainobject2['default'](action) && typeof action.type !== 'undefined' && Object.keys(action).every(isValidKey);
}

function isError(action) {
  return action.error === true;
}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseFor = __webpack_require__(116),
    isArguments = __webpack_require__(48),
    keysIn = __webpack_require__(118);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * The base implementation of `_.forIn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForIn(object, iteratee) {
  return baseFor(object, iteratee, keysIn);
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * **Note:** This method assumes objects created by the `Object` constructor
 * have no inherited enumerable properties.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  var Ctor;

  // Exit early for non `Object` objects.
  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
    return false;
  }
  // IE < 9 iterates inherited properties before own properties. If the first
  // iterated property is an object's own property then there are no inherited
  // enumerable properties.
  var result;
  // In most environments an object's own properties are iterated before
  // its inherited properties. If the last iterated property is an object's
  // own property then there are no inherited enumerable properties.
  baseForIn(value, function(subValue, key) {
    result = key;
  });
  return result === undefined || hasOwnProperty.call(value, result);
}

module.exports = isPlainObject;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(128);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Response = __webpack_require__(110);
var extractResponseProps = __webpack_require__(111);
var extend = __webpack_require__(68);

function RequestError(message, props) {
  var err = new Error(message);
  err.name = 'RequestError';
  this.name = err.name;
  this.message = err.message;
  if (err.stack) {
    this.stack = err.stack;
  }

  this.toString = function() {
    return this.message;
  };

  for (var k in props) {
    if (props.hasOwnProperty(k)) {
      this[k] = props[k];
    }
  }
}

RequestError.prototype = extend(Error.prototype);
RequestError.prototype.constructor = RequestError;

RequestError.create = function(message, req, props) {
  var err = new RequestError(message, props);
  Response.call(err, extractResponseProps(req));
  return err;
};

module.exports = RequestError;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var
  cleanURL = __webpack_require__(380),
  XHR = __webpack_require__(379),
  delay = __webpack_require__(378),
  RequestError = __webpack_require__(376),
  Response = __webpack_require__(110),
  Request = __webpack_require__(109),
  extend = __webpack_require__(68),
  once = __webpack_require__(112);

var i,
    createError = RequestError.create;

function factory(defaults, plugins) {
  defaults = defaults || {};
  plugins = plugins || [];

  function http(req, cb) {
    var xhr, plugin, done, k, timeoutId, supportsLoadAndErrorEvents;

    req = new Request(extend(defaults, req));

    for (i = 0; i < plugins.length; i++) {
      plugin = plugins[i];
      if (plugin.processRequest) {
        plugin.processRequest(req);
      }
    }

    // Give the plugins a chance to create the XHR object
    for (i = 0; i < plugins.length; i++) {
      plugin = plugins[i];
      if (plugin.createXHR) {
        xhr = plugin.createXHR(req);
        break; // First come, first serve
      }
    }
    xhr = xhr || new XHR();

    req.xhr = xhr;

    // Use a single completion callback. This can be called with or without
    // an error. If no error is passed, the request will be examined to see
    // if it was successful.
    done = once(delay(function(rawError) {
      clearTimeout(timeoutId);
      xhr.onload = xhr.onerror = xhr.onabort = xhr.onreadystatechange = xhr.ontimeout = xhr.onprogress = null;

      var err = getError(req, rawError);

      var res = err || Response.fromRequest(req);
      for (i = 0; i < plugins.length; i++) {
        plugin = plugins[i];
        if (plugin.processResponse) {
          plugin.processResponse(res);
        }
      }

      // Invoke callbacks
      if (err && req.onerror) req.onerror(err);
      if (!err && req.onload) req.onload(res);
      if (cb) cb(err, err ? undefined : res);

    }));

    supportsLoadAndErrorEvents = ('onload' in xhr) && ('onerror' in xhr);
    xhr.onload = function() { done(); };
    xhr.onerror = done;
    xhr.onabort = function() { done(); };

    // We'd rather use `onload`, `onerror`, and `onabort` since they're the
    // only way to reliably detect successes and failures but, if they
    // aren't available, we fall back to using `onreadystatechange`.
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== 4) return;

      if (req.aborted) return done();

      if (!supportsLoadAndErrorEvents) {
        // Assume a status of 0 is an error. This could be a false
        // positive, but there's no way to tell when using
        // `onreadystatechange` ):
        // See matthewwithanm/react-inlinesvg#10.

        // Some browsers don't like you reading XHR properties when the
        // XHR has been aborted. In case we've gotten here as a result
        // of that (either our calling `about()` in the timeout handler
        // or the user calling it directly even though they shouldn't),
        // be careful about accessing it.
        var status;
        try {
          status = xhr.status;
        } catch (err) {}
        var err = status === 0 ? new Error('Internal XHR Error') : null;
        return done(err);
      }
    };

    // IE sometimes fails if you don't specify every handler.
    // See http://social.msdn.microsoft.com/Forums/ie/en-US/30ef3add-767c-4436-b8a9-f1ca19b4812e/ie9-rtm-xdomainrequest-issued-requests-may-abort-if-all-event-handlers-not-specified?forum=iewebdevelopment
    xhr.ontimeout = function() { /* noop */ };
    xhr.onprogress = function() { /* noop */ };

    xhr.open(req.method, req.url);

    if (req.timeout) {
      // If we use the normal XHR timeout mechanism (`xhr.timeout` and
      // `xhr.ontimeout`), `onreadystatechange` will be triggered before
      // `ontimeout`. There's no way to recognize that it was triggered by
      // a timeout, and we'd be unable to dispatch the right error.
      timeoutId = setTimeout(function() {
        req.timedOut = true;
        done();
        try {
          xhr.abort();
        } catch (err) {}
      }, req.timeout);
    }

    for (k in req.headers) {
      if (req.headers.hasOwnProperty(k)) {
        xhr.setRequestHeader(k, req.headers[k]);
      }
    }

    xhr.send(req.body);

    return req;
  }

  var method,
    methods = ['get', 'post', 'put', 'head', 'patch', 'delete'],
    verb = function(method) {
      return function(req, cb) {
        req = new Request(req);
        req.method = method;
        return http(req, cb);
      };
    };
  for (i = 0; i < methods.length; i++) {
    method = methods[i];
    http[method] = verb(method);
  }

  http.plugins = function() {
    return plugins;
  };

  http.defaults = function(newValues) {
    if (newValues) {
      return factory(extend(defaults, newValues), plugins);
    }
    return defaults;
  };

  http.use = function() {
    var newPlugins = Array.prototype.slice.call(arguments, 0);
    return factory(defaults, plugins.concat(newPlugins));
  };

  http.bare = function() {
    return factory();
  };

  http.Request = Request;
  http.Response = Response;
  http.RequestError = RequestError;

  return http;
}

module.exports = factory({}, [cleanURL]);

/**
 * Analyze the request to see if it represents an error. If so, return it! An
 * original error object can be passed as a hint.
 */
function getError(req, err) {
  if (req.aborted) return createError('Request aborted', req, {name: 'Abort'});

  if (req.timedOut) return createError('Request timeout', req, {name: 'Timeout'});

  var xhr = req.xhr;
  var type = Math.floor(xhr.status / 100);

  var kind;
  switch (type) {
    case 0:
    case 2:
      // These don't represent errors unless the function was passed an
      // error object explicitly.
      if (!err) return;
      return createError(err.message, req);
    case 4:
      // Sometimes 4XX statuses aren't errors.
      if (xhr.status === 404 && !req.errorOn404) return;
      kind = 'Client';
      break;
    case 5:
      kind = 'Server';
      break;
    default:
      kind = 'HTTP';
  }
  var msg = kind + ' Error: ' +
        'The server returned a status of ' + xhr.status +
        ' for the request "' +
        req.method.toUpperCase() + ' ' + req.url + '"';
  return createError(msg, req);
}


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Wrap a function in a `setTimeout` call. This is used to guarantee async
// behavior, which can avoid unexpected errors.

module.exports = function(fn) {
  return function() {
    var
      args = Array.prototype.slice.call(arguments, 0),
      newFunc = function() {
        return fn.apply(null, args);
      };
    setTimeout(newFunc, 0);
  };
};


/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports = window.XMLHttpRequest;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  processRequest: function(req) {
    req.url = req.url.replace(/[^%]+/g, function(s) {
      return encodeURI(s);
    });
  }
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var
  urllite = __webpack_require__(619),
  once = __webpack_require__(112);

var warningShown = false;

var supportsXHR = once(function() {
  return (
    typeof window !== 'undefined' &&
    window !== null &&
    window.XMLHttpRequest &&
    'withCredentials' in new window.XMLHttpRequest()
  );
});

// This plugin creates a Microsoft `XDomainRequest` in supporting browsers when
// the URL being requested is on a different domain. This is necessary to
// support IE9, which only supports CORS via its proprietary `XDomainRequest`
// object. We need to check the URL because `XDomainRequest` *doesn't* work for
// same domain requests (unless your server sends CORS headers).
// `XDomainRequest` also has other limitations (no custom headers), so we try to
// catch those and error.
module.exports = {
  createXHR: function(req) {
    var a, b, k;

    if (typeof window === 'undefined' || window === null) {
      return;
    }

    a = urllite(req.url);
    b = urllite(window.location.href);

    // Don't do anything for same-domain requests.
    if (!a.host) {
      return;
    }
    if (a.protocol === b.protocol && a.host === b.host && a.port === b.port) {
      return;
    }

    // Show a warning if there are custom headers. We do this even in
    // browsers that won't use XDomainRequest so that users know there's an
    // issue right away, instead of if/when they test in IE9.
    if (!warningShown && req.headers) {
      for (k in req.headers) {
        if (req.headers.hasOwnProperty(k)) {
          warningShown = true;
          if (window && window.console && window.console.warn) {
            window.console.warn('Request headers are ignored in old IE when using the oldiexdomain plugin.');
          }
          break;
        }
      }
    }

    // Don't do anything if we can't do anything (:
    // Don't do anything if the browser supports proper XHR.
    if (window.XDomainRequest && !supportsXHR()) {
      // We've come this far. Might as well make an XDomainRequest.
      var xdr = new window.XDomainRequest();
      xdr.setRequestHeader = function() {}; // Ignore request headers.
      return xdr;
    }
  }
};


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["default"] = (hyphenateStyleName);


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrefixer;

var _prefixProperty = __webpack_require__(398);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(399);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _addNewValuesOnly = __webpack_require__(396);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(397);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  function prefixAll(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if ((0, _isObject2.default)(value)) {
        style[property] = prefixAll(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        (0, _prefixProperty2.default)(prefixMap, property, style);
      }
    }

    return style;
  }

  return prefixAll;
}
module.exports = exports['default'];

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _isPrefixedValue = __webpack_require__(31);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];
function calc(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = crossFade;

var _isPrefixedValue = __webpack_require__(31);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#search=cross-fade
var prefixes = ['-webkit-', ''];
function crossFade(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;
var prefixes = ['-webkit-', '-moz-', ''];

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filter;

var _isPrefixedValue = __webpack_require__(31);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-filter-function
var prefixes = ['-webkit-', ''];
function filter(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
module.exports = exports['default'];

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;
var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
};

function flexboxIE(property, value, style) {
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(31);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageSet;

var _isPrefixedValue = __webpack_require__(31);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-image-set
var prefixes = ['-webkit-', ''];
function imageSet(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}
module.exports = exports['default'];

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(276);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(31);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(113);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
module.exports = exports['default'];

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
module.exports = exports["default"];

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}
module.exports = exports["default"];

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__(113);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var requiredPrefixes = prefixProperties[property];
    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
module.exports = exports["default"];

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(561);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 401 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(406);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(407);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(114);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(403);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 410 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * A specialized version of `_.forEach` for arrays without support for callback
 * shorthands or `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var keys = __webpack_require__(414);

/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.forEach` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object|string} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `baseForIn` and `baseForOwn` which iterates
 * over `object` properties returned by `keysFunc` invoking `iteratee` for
 * each property. Iteratee functions may exit iteration early by explicitly
 * returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    var length = collection ? getLength(collection) : 0;
    if (!isLength(length)) {
      return eachFunc(collection, iteratee);
    }
    var index = fromRight ? length : -1,
        iterable = toObject(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for `_.forIn` or `_.forInRight`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var iterable = toObject(object),
        props = keysFunc(object),
        length = props.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      var key = props[index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = baseEach;


/***/ }),
/* 412 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * A specialized version of `baseCallback` which only supports `this` binding
 * and specifying the number of arguments to provide to `func`.
 *
 * @private
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */
function bindCallback(func, thisArg, argCount) {
  if (typeof func != 'function') {
    return identity;
  }
  if (thisArg === undefined) {
    return func;
  }
  switch (argCount) {
    case 1: return function(value) {
      return func.call(thisArg, value);
    };
    case 3: return function(value, index, collection) {
      return func.call(thisArg, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(thisArg, accumulator, value, index, collection);
    };
    case 5: return function(value, other, key, object, source) {
      return func.call(thisArg, value, other, key, object, source);
    };
  }
  return function() {
    return func.apply(thisArg, arguments);
  };
}

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = bindCallback;


/***/ }),
/* 413 */
/***/ (function(module, exports) {

/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = getNative;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(413),
    isArguments = __webpack_require__(48),
    isArray = __webpack_require__(69);

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeKeys = getNative(Object, 'keys');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function shimKeys(object) {
  var props = keysIn(object),
      propsLength = props.length,
      length = propsLength && object.length;

  var allowIndexes = !!length && isLength(length) &&
    (isArray(object) || isArguments(object));

  var index = -1,
      result = [];

  while (++index < propsLength) {
    var key = props[index];
    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  var Ctor = object == null ? undefined : object.constructor;
  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
      (typeof object != 'function' && isArrayLike(object))) {
    return shimKeys(object);
  }
  return isObject(object) ? nativeKeys(object) : [];
};

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keys;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(430),
    hashDelete = __webpack_require__(431),
    hashGet = __webpack_require__(432),
    hashHas = __webpack_require__(433),
    hashSet = __webpack_require__(434);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(439),
    listCacheDelete = __webpack_require__(440),
    listCacheGet = __webpack_require__(441),
    listCacheHas = __webpack_require__(442),
    listCacheSet = __webpack_require__(443);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(119),
    root = __webpack_require__(72);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(444),
    mapCacheDelete = __webpack_require__(445),
    mapCacheGet = __webpack_require__(446),
    mapCacheHas = __webpack_require__(447),
    mapCacheSet = __webpack_require__(448);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 419 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 420 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(71),
    isObjectLike = __webpack_require__(73);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(457),
    isMasked = __webpack_require__(438),
    isObject = __webpack_require__(120),
    toSource = __webpack_require__(453);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(70),
    arrayMap = __webpack_require__(419),
    isArray = __webpack_require__(52),
    isSymbol = __webpack_require__(74);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(52),
    isKey = __webpack_require__(436),
    stringToPath = __webpack_require__(451),
    toString = __webpack_require__(460);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(72);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(70);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 428 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(424),
    isArguments = __webpack_require__(456),
    isArray = __webpack_require__(52),
    isIndex = __webpack_require__(435),
    isLength = __webpack_require__(458),
    toKey = __webpack_require__(452);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(51);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 431 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(51);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(51);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(51);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 435 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(52),
    isSymbol = __webpack_require__(74);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 437 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(425);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 439 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(49);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(49);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(49);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(49);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(415),
    ListCache = __webpack_require__(416),
    Map = __webpack_require__(417);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(50);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(50);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(50);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(50);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(459);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 450 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(449);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(74);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 453 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 454 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(420),
    hasPath = __webpack_require__(429);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(421),
    isObjectLike = __webpack_require__(73);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(71),
    isObject = __webpack_require__(120);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 458 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(418);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(423);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var wrappy = __webpack_require__(624)
module.exports = wrappy(once)
module.exports.strict = wrappy(onceStrict)

once.proto = once(function () {
  Object.defineProperty(Function.prototype, 'once', {
    value: function () {
      return once(this)
    },
    configurable: true
  })

  Object.defineProperty(Function.prototype, 'onceStrict', {
    value: function () {
      return onceStrict(this)
    },
    configurable: true
  })
})

function once (fn) {
  var f = function () {
    if (f.called) return f.value
    f.called = true
    return f.value = fn.apply(this, arguments)
  }
  f.called = false
  return f
}

function onceStrict (fn) {
  var f = function () {
    if (f.called)
      throw new Error(f.onceError)
    f.called = true
    return f.value = fn.apply(this, arguments)
  }
  var name = fn.name || 'Function wrapped with `once`'
  f.onceError = name + " shouldn't be called more than once"
  f.called = false
  return f
}


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(123);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(123);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(466);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(53),r=__webpack_require__(558);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportMultiple; });
/* harmony export (immutable) */ __webpack_exports__["g"] = getDataTransferItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["c"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["e"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["a"] = onDocumentDragOver;
/* harmony export (immutable) */ __webpack_exports__["d"] = isIeOrEdge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);


var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt = event.dataTransfer;

    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      // During the drag even the dataTransfer.files is null
      // but Chrome implements some drag store, which is accesible via dataTransfer.items
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }

  // Convert from DataTransferItemsList to the native Array
  return Array.prototype.slice.call(dataTransferItemsList);
}

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
}

function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}

function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

  return isIe(userAgent) || isEdge(userAgent);
}

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  rejected: {
    borderStyle: 'solid',
    borderColor: '#c66',
    backgroundColor: '#eee'
  },
  disabled: {
    opacity: 0.5
  },
  active: {
    borderStyle: 'solid',
    borderColor: '#6c6',
    backgroundColor: '#eee'
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
  }
});

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OutboundLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_console_warn__ = __webpack_require__(75);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink =
/*#__PURE__*/
function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick,
          trackerNames = _this$props.trackerNames;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        }, trackerNames);
      } else {
        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          oldProps = _objectWithoutProperties(_this$props2, ["to"]);

      var props = _objectSpread({}, oldProps, {
        href: href,
        onClick: this.handleClick
      });

      if (this.props.target === NEWTAB) {
        props.rel = 'noopener noreferrer';
      }

      delete props.eventLabel;
      delete props.trackerNames;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(OutboundLink, "trackLink", function () {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_console_warn__["a" /* default */])('ga tracking not enabled');
});

_defineProperty(OutboundLink, "propTypes", {
  eventLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  trackerNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
});

_defineProperty(OutboundLink, "defaultProps", {
  target: null,
  to: null,
  onClick: null,
  trackerNames: null
});



/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["initialize"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["ga"] = ga;
/* harmony export (immutable) */ __webpack_exports__["set"] = set;
/* harmony export (immutable) */ __webpack_exports__["send"] = send;
/* harmony export (immutable) */ __webpack_exports__["pageview"] = pageview;
/* harmony export (immutable) */ __webpack_exports__["modalview"] = modalview;
/* harmony export (immutable) */ __webpack_exports__["timing"] = timing;
/* harmony export (immutable) */ __webpack_exports__["event"] = event;
/* harmony export (immutable) */ __webpack_exports__["exception"] = exception;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "plugin", function() { return plugin; });
/* harmony export (immutable) */ __webpack_exports__["outboundLink"] = outboundLink;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "testModeAPI", function() { return testModeAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_format__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_trim__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_loadGA__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_console_warn__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_console_log__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__ = __webpack_require__(479);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * React Google Analytics Module
 *
 * @package react-ga
 * @author  Adam Lofting <adam@mozillafoundation.org>
 *          Atul Varma <atul@mozillafoundation.org>
 */

/**
 * Utilities
 */








var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';

var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */].ga.apply(__WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */], arguments);
  if (_isNotBrowser) return false;
  if (!window.ga) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_format__["a" /* default */])(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }

    if (options.useExistingGa) {
      return;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (_isNotBrowser) {
      return false;
    }

    if (!options || options.standardImplementation !== true) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_loadGA__["a" /* default */])(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (_typeof(config) !== 'object') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(void 0, args);

    if (_debug) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'arguments\');');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`fieldsObject` is required in .set()');
    return;
  }

  if (_typeof(fieldsObject) !== 'object') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'set\', fieldsObject);');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', fieldObject);');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path is required in .pageview()');
    return;
  }

  var path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawPath);

  if (path === '') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _objectSpread({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawModalName));

  if (modalName === '') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   * @param trackerName {String} optional e.g 'trackerName'
   */
  require: function require(rawName, options, trackerName) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` is required in .require()');
        return;
      }

      var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawName);

      if (name === '') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` cannot be an empty string in .require()');
        return;
      }

      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields

      if (options) {
        if (_typeof(options) !== 'object') {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Empty `options` given to .require()');
        }

        ga(requireString, name, options);

        if (_debug) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga(requireString, name);

        if (_debug) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
var testModeAPI = __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = ({
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  testModeAPI: __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */]
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialize */
/* unused harmony export ga */
/* unused harmony export set */
/* unused harmony export send */
/* unused harmony export pageview */
/* unused harmony export modalview */
/* unused harmony export timing */
/* unused harmony export event */
/* unused harmony export exception */
/* unused harmony export plugin */
/* unused harmony export outboundLink */
/* unused harmony export testModeAPI */
/* unused harmony export OutboundLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(472);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialize = __WEBPACK_IMPORTED_MODULE_1__core__["initialize"];
var ga = __WEBPACK_IMPORTED_MODULE_1__core__["ga"];
var set = __WEBPACK_IMPORTED_MODULE_1__core__["set"];
var send = __WEBPACK_IMPORTED_MODULE_1__core__["send"];
var pageview = __WEBPACK_IMPORTED_MODULE_1__core__["pageview"];
var modalview = __WEBPACK_IMPORTED_MODULE_1__core__["modalview"];
var timing = __WEBPACK_IMPORTED_MODULE_1__core__["timing"];
var event = __WEBPACK_IMPORTED_MODULE_1__core__["event"];
var exception = __WEBPACK_IMPORTED_MODULE_1__core__["exception"];
var plugin = __WEBPACK_IMPORTED_MODULE_1__core__["plugin"];
var outboundLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var testModeAPI = __WEBPACK_IMPORTED_MODULE_1__core__["testModeAPI"];
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].origTrackLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink;
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var OutboundLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__core__, {
  OutboundLink: OutboundLink
}));

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
function log(s) {
  console.info('[react-ga]', s);
}

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mightBeEmail__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toTitleCase__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__console_warn__ = __webpack_require__(75);



var redacted = 'REDACTED (Potential Email Address)';
function format(s, titleCase) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mightBeEmail__["a" /* default */])(s)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__console_warn__["a" /* default */])('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toTitleCase__["a" /* default */])(s);
  }

  return s;
}

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */


  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */

});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mightBeEmail;
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === 'string' && s.indexOf('@') !== -1;
}

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeLeadingSlash;
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gaCalls */
var gaCalls = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toTitleCase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trim__ = __webpack_require__(125);
/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__trim__["a" /* default */])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(53);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(127);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(485);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(129);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(131);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = 'ReactModalPortal';
var bodyOpenClassName = exports.bodyOpenClassName = 'ReactModal__Body--open';

var renderSubtreeIntoContainer = _reactDom2.default.unstable_renderSubtreeIntoContainer;

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.renderPortal = function (props) {
      _this.portal = renderSubtreeIntoContainer(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.node = document.createElement('div');
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      this.renderPortal(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var isOpen = newProps.isOpen;
      // Stop unnecessary renders if modal is remaining closed

      if (!this.props.isOpen && !isOpen) return;

      var currentParent = getParentElement(this.props.parentSelector);
      var newParent = getParentElement(newProps.parentSelector);

      if (newParent !== currentParent) {
        currentParent.removeChild(this.node);
        newParent.appendChild(this.node);
      }

      this.renderPortal(newProps);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(newProps) {
      if (newProps.portalClassName !== this.props.portalClassName) {
        this.node.className = newProps.portalClassName;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'setAppElement',
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable no-console */

  }, {
    key: 'injectCSS',
    value: function injectCSS() {
      "production" !== "production" && console.warn('React-Modal: injectCSS has been deprecated ' + 'and no longer has any effect. It will be removed in a later version');
    }
    /* eslint-enable no-console */

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfter: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnOverlayClick: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)'
  },
  content: {
    position: 'absolute',
    top: '40px',
    left: '40px',
    right: '40px',
    bottom: '40px',
    border: '1px solid #ccc',
    background: '#fff',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    padding: '20px'
  }
};
exports.default = Modal;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _focusManager = __webpack_require__(487);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(488);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(129);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _refCount = __webpack_require__(130);

var refCount = _interopRequireWildcard(_refCount);

var _bodyClassList = __webpack_require__(486);

var bodyClassList = _interopRequireWildcard(_bodyClassList);

var _safeHTMLElement = __webpack_require__(131);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: 'ReactModal__Overlay',
  content: 'ReactModal__Content'
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setFocusAfterRender = function (focus) {
      _this.focusAfterRender = _this.props.shouldFocusAfterRender && focus;
    };

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
    };

    _this.setContentRef = function (content) {
      _this.content = content;
    };

    _this.afterClose = function () {
      focusManager.returnFocus();
      focusManager.teardownScopedFocus();
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        focusManager.setupScopedFocus(_this.node);
        focusManager.markForFocusLater();
        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      _this.beforeClose();
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }
      if (event.keyCode === ESC_KEY) {
        event.preventDefault();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
      _this.moveFromContentToOverlay = null;
    };

    _this.handleOverlayOnMouseUp = function () {
      if (_this.moveFromContentToOverlay === null) {
        _this.shouldClose = false;
      }
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function () {
      _this.moveFromContentToOverlay = false;
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
      _this.moveFromContentToOverlay = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === 'undefined' ? 'undefined' : _typeof(additional)) === 'object' ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + '--after-open',
        beforeClose: CLASS_NAMES[which] + '--before-close'
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + ' ' + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + ' ' + classNames.beforeClose;
      }
      return typeof additional === 'string' && additional ? className + ' ' + additional : className;
    };

    _this.ariaAttributes = function (items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc['aria-' + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Focus needs to be set when mounting and already open
      if (this.props.isOpen) {
        this.setFocusAfterRender(true);
        this.open();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (false) {
        if (newProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + 'This may cause unexpected behavior when multiple modals are open.');
        }
      }
      // Focus only needs to be set once when the modal is being opened
      if (!this.props.isOpen && newProps.isOpen) {
        this.setFocusAfterRender(true);
        this.open();
      } else if (this.props.isOpen && !newProps.isOpen) {
        this.close();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.focusAfterRender) {
        this.focusContent();
        this.setFocusAfterRender(false);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.beforeClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: 'beforeOpen',
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          bodyOpenClassName = _props.bodyOpenClassName;
      // Add body class

      bodyClassList.add(bodyOpenClassName);
      // Add aria-hidden to appElement
      if (ariaHideApp) {
        ariaAppHider.hide(appElement);
      }
    }
  }, {
    key: 'beforeClose',
    value: function beforeClose() {
      var _props2 = this.props,
          appElement = _props2.appElement,
          ariaHideApp = _props2.ariaHideApp,
          bodyOpenClassName = _props2.bodyOpenClassName;
      // Remove class if no more modals are open

      bodyClassList.remove(bodyOpenClassName);
      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && refCount.totalCount() < 1) {
        ariaAppHider.show(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          overlayClassName = _props3.overlayClassName,
          defaultStyles = _props3.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        'div',
        {
          ref: this.setOverlayRef,
          className: this.buildClassName('overlay', overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown,
          onMouseUp: this.handleOverlayOnMouseUp },
        _react2.default.createElement(
          'div',
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName('content', className),
            tabIndex: '-1',
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            'aria-label': this.props.contentLabel
          }, this.ariaAttributes(this.props.aria || {})),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  }
};
ModalPortal.propTypes = {
  isOpen: _propTypes.PropTypes.bool.isRequired,
  defaultStyles: _propTypes.PropTypes.shape({
    content: _propTypes.PropTypes.object,
    overlay: _propTypes.PropTypes.object
  }),
  style: _propTypes.PropTypes.shape({
    content: _propTypes.PropTypes.object,
    overlay: _propTypes.PropTypes.object
  }),
  className: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.string, _propTypes.PropTypes.object]),
  overlayClassName: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.string, _propTypes.PropTypes.object]),
  bodyOpenClassName: _propTypes.PropTypes.string,
  ariaHideApp: _propTypes.PropTypes.bool,
  appElement: _propTypes.PropTypes.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes.PropTypes.func,
  onRequestClose: _propTypes.PropTypes.func,
  closeTimeoutMS: _propTypes.PropTypes.number,
  shouldFocusAfterRender: _propTypes.PropTypes.bool,
  shouldCloseOnOverlayClick: _propTypes.PropTypes.bool,
  role: _propTypes.PropTypes.string,
  contentLabel: _propTypes.PropTypes.string,
  aria: _propTypes.PropTypes.object,
  children: _propTypes.PropTypes.node
};
exports.default = ModalPortal;
module.exports = exports['default'];

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.remove = remove;

var _refCount = __webpack_require__(130);

var refCount = _interopRequireWildcard(_refCount);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function add(bodyClass) {
  // Increment class(es) on refCount tracker and add class(es) to body
  bodyClass.split(' ').map(refCount.add).forEach(function (className) {
    return document.body.classList.add(className);
  });
}

function remove(bodyClass) {
  var classListMap = refCount.get();
  // Decrement class(es) from the refCount tracker
  // and remove unused class(es) from body
  bodyClass.split(' ').map(refCount.remove).filter(function (className) {
    return classListMap[className] === 0;
  }).forEach(function (className) {
    return document.body.classList.remove(className);
  });
}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(132);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    toFocus = focusLaterElements.pop();
    toFocus.focus();
    return;
  } catch (e) {
    console.warn(['You tried to return focus to', toFocus, 'but it is not in the DOM anymore'].join(" "));
  }
}
/* eslint-enable no-console */

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener('blur', handleBlur, false);
    document.addEventListener('focus', handleFocus, true);
  } else {
    window.attachEvent('onBlur', handleBlur);
    document.attachEvent('onFocus', handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener('blur', handleBlur);
    document.removeEventListener('focus', handleFocus);
  } else {
    window.detachEvent('onBlur', handleBlur);
    document.detachEvent('onFocus', handleFocus);
  }
}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(132);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);
  if (!tabbable.length) {
    event.preventDefault();
    return;
  }
  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  var leavingFinalTabbable = finalTabbable === document.activeElement ||
  // handle immediate shift+tab after opening with mouse
  node === document.activeElement;
  if (!leavingFinalTabbable) return;
  event.preventDefault();
  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  target.focus();
}
module.exports = exports['default'];

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(76);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(494);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(134);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(134);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(136);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(495);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(76);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(77);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history__["f" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(77);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(140);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(137);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(141);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(142);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(143);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(144);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(79);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(57);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(145);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(140);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(141);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(142);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(78);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(56);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(143);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(144);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(79);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(57);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(145);
/* unused harmony reexport withRouter */





















/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(83);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck(this, ButtonElement);

    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'input',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(ButtonElement);

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollElement = __webpack_require__(148);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck(this, ElementWrapper);

    return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` from props
      var newProps = _extends({}, this.props);
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

;

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

exports.default = (0, _scrollElement2.default)(ElementWrapper);

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(83);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LinkElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(LinkElement);

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* DEPRECATED */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(19);

var utils = __webpack_require__(59);
var scrollSpy = __webpack_require__(84);
var defaultScroller = __webpack_require__(58);
var PropTypes = __webpack_require__(1);
var scrollHash = __webpack_require__(149);

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    ;

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.name !== prevProps.name) {
            this.registerElems(this.props.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    ;

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

module.exports = Helpers;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(81);

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

exports.default = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Async */
/* unused harmony export AsyncCreatable */
/* unused harmony export Creatable */
/* unused harmony export Value */
/* unused harmony export Option */
/* unused harmony export defaultMenuRenderer */
/* unused harmony export defaultArrowRenderer */
/* unused harmony export defaultClearRenderer */
/* unused harmony export defaultFilterOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
			var pref = document.addEventListener ? '' : 'on';

			document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
			document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false,
						focusedOption: null
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen,
					focusedOption: null
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (!this.props.closeOnSelect) {
				return;
			}
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value,
							values: valueArray
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'div',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator,
			    showNewOptionAtTop = _props2.showNewOptionAtTop;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					if (showNewOptionAtTop) {
						filteredOptions.unshift(this._createPlaceholderOption);
					} else {
						filteredOptions.push(this._createPlaceholderOption);
					}
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
	showNewOptionAtTop: true
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Where to show prompt/placeholder option text.
	// true: new option prompt at top of list (default)
	// false: new option prompt at bottom of list
	showNewOptionAtTop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["a"] = (Select$1);


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var shallowEqual = _interopDefault(__webpack_require__(560));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(SideEffect, _Component);

      function SideEffect() {
        return _Component.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      _proto.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextArrow = exports.PrevArrow = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(38));

var _innerSliderUtils = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PrevArrow =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _getPrototypeOf(PrevArrow).apply(this, arguments));
  }

  _createClass(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames.default)(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = _react.default.cloneElement(this.props.prevArrow, _objectSpread({}, prevArrowProps, customProps));
      } else {
        prevArrow = _react.default.createElement("button", _extends({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(_react.default.PureComponent);

exports.PrevArrow = PrevArrow;

var NextArrow =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _getPrototypeOf(NextArrow).apply(this, arguments));
  }

  _createClass(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames.default)(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = _react.default.cloneElement(this.props.nextArrow, _objectSpread({}, nextArrowProps, customProps));
      } else {
        nextArrow = _react.default.createElement("button", _extends({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(_react.default.PureComponent);

exports.NextArrow = NextArrow;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react.default.createElement("ul", {
      style: {
        display: "block"
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react.default.createElement("button", null, i + 1);
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
var _default = defaultProps;
exports.default = _default;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dots = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(38));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _getPrototypeOf(Dots).apply(this, arguments));
  }

  _createClass(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var dotCount = getDotCount({
        slideCount: this.props.slideCount,
        slidesToScroll: this.props.slidesToScroll,
        slidesToShow: this.props.slidesToShow,
        infinite: this.props.infinite
      }); // Apply join & split to Array to pre-fill it for IE8
      //
      // Credit: http://stackoverflow.com/a/13735425/1849458

      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
        var leftBound = i * _this.props.slidesToScroll;
        var rightBound = i * _this.props.slidesToScroll + (_this.props.slidesToScroll - 1);
        var className = (0, _classnames.default)({
          "slick-active": _this.props.currentSlide >= leftBound && _this.props.currentSlide <= rightBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: _this.props.slidesToScroll,
          currentSlide: _this.props.currentSlide
        };

        var onClick = _this.clickHandler.bind(_this, dotOptions);

        return _react.default.createElement("li", {
          key: i,
          className: className
        }, _react.default.cloneElement(_this.props.customPaging(i), {
          onClick: onClick
        }));
      });
      return _react.default.cloneElement(this.props.appendDots(dots), _objectSpread({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);

  return Dots;
}(_react.default.PureComponent);

exports.Dots = Dots;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0
};
var _default = initialState;
exports.default = _default;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerSlider = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(19));

var _initialState = _interopRequireDefault(__webpack_require__(525));

var _lodash = _interopRequireDefault(__webpack_require__(529));

var _classnames = _interopRequireDefault(__webpack_require__(38));

var _innerSliderUtils = __webpack_require__(60);

var _track = __webpack_require__(528);

var _dots = __webpack_require__(524);

var _arrows = __webpack_require__(522);

var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(555));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InnerSlider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    var _this;

    _classCallCheck(this, InnerSlider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InnerSlider).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "listRefHandler", function (ref) {
      return _this.list = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillMount", function () {
      _this.ssrInit();

      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidMount", function () {
      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      }); // To support server-side rendering

      if (!window) {
        return;
      }

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillReceiveProps", function (nextProps) {
      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);

      var setTrackStyle = false;

      var _arr = Object.keys(_this.props);

      for (var _i = 0; _i < _arr.length; _i++) {
        var key = _arr[_i];

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }

        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidUpdate", function () {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!_reactDom.default.findDOMNode(_this.track)) return;

      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread({}, spec, updatedState, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread({}, spec, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react.default.Children.count(_this.props.children) !== _react.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }

        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        _this.setState({
          trackStyle: _trackStyle
        });

        return;
      }

      var childrenCount = _react.default.Children.count(_this.props.children);

      var spec = _objectSpread({}, _this.props, _this.state, {
        slideCount: childrenCount
      });

      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };

      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "checkImagesLoad", function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread({}, _this.props, _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== _this.state.currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread({}, _this.props, _this.state);

      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectHandler", function (options) {
      _this.changeSlide(options);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_objectSpread({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
      var className = (0, _classnames.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread({}, _this.props, _this.state);

      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });
      var dots;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread({}, verticalHeightStyle, centerPaddingStyle);

      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return _react.default.createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", _react.default.createElement("div", _extends({
        ref: _this.listRefHandler
      }, listProps), _react.default.createElement(_track.Track, _extends({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });

    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread({}, _initialState.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react.default.Component);

exports.InnerSlider = InnerSlider;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _innerSlider = __webpack_require__(526);

var _json2mq = _interopRequireDefault(__webpack_require__(400));

var _defaultProps = _interopRequireDefault(__webpack_require__(523));

var _innerSliderUtils = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(283);

var Slider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "innerSliderRefHandler", function (ref) {
      return _this.innerSlider = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPrev", function () {
      return _this.innerSlider.slickPrev();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickNext", function () {
      return _this.innerSlider.slickNext();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPause", function () {
      return _this.innerSlider.pause("paused");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPlay", function () {
      return _this.innerSlider.autoPlay("play");
    });

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  _createClass(Slider, [{
    key: "media",
    value: function media(query, handler) {
      // javascript handler for  css media query
      enquire.register(query, handler);

      this._responsiveMediaHandlers.push({
        query: query,
        handler: handler
      });
    } // handles responsive breakpoints

  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      // performance monitoring
      //if (process.env.NODE_ENV !== 'production') {
      //const { whyDidYouUpdate } = require('why-did-you-update')
      //whyDidYouUpdate(React)
      //}
      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var bQuery;

          if (index === 0) {
            bQuery = (0, _json2mq.default)({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = (0, _json2mq.default)({
              minWidth: breakpoints[index - 1] + 1,
              maxWidth: breakpoint
            });
          } // when not using server side rendering


          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
            _this2.setState({
              breakpoint: breakpoint
            });
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = (0, _json2mq.default)({
          minWidth: breakpoints.slice(-1)[0]
        });
        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        enquire.unregister(obj.query, obj.handler);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var settings;
      var newProps;

      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread({}, _defaultProps.default, this.props, newProps[0].settings);
      } else {
        settings = _objectSpread({}, _defaultProps.default, this.props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "production" !== "production") {
          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
        }

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && "production" !== "production") {
          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
        }

        if (settings.slidesToScroll > 1 && "production" !== "production") {
          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
        }

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // makes sure that children is an array, even when there is only 1 child


      var children = _react.default.Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


      children = children.filter(function (child) {
        if (typeof child === "string") {
          return !!child.trim();
        }

        return !!child;
      }); // rows and slidesPerRow logic is handled here

      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }

      var newChildren = [];
      var currentWidth = null;

      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
        var newSlide = [];

        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
          var row = [];

          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
            if (settings.variableWidth && children[k].props.style) {
              currentWidth = children[k].props.style.width;
            }

            if (k >= children.length) break;
            row.push(_react.default.cloneElement(children[k], {
              key: 100 * i + 10 * j + k,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }

          newSlide.push(_react.default.createElement("div", {
            key: 10 * i + j
          }, row));
        }

        if (settings.variableWidth) {
          newChildren.push(_react.default.createElement("div", {
            key: i,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push(_react.default.createElement("div", {
            key: i
          }, newSlide));
        }
      }

      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return _react.default.createElement("div", {
          className: className
        }, newChildren);
      } else if (newChildren.length <= settings.slidesToShow) {
        settings.unslick = true;
      }

      return _react.default.createElement(_innerSlider.InnerSlider, _extends({
        ref: this.innerSliderRefHandler
      }, settings), newChildren);
    }
  }]);

  return Slider;
}(_react.default.Component);

exports.default = Slider;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Track = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(38));

var _innerSliderUtils = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react.default.Children.count(spec.children);

  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react.default.Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react.default.createElement("div", null);
    }

    var childStyle = getSlideStyle(_objectSpread({}, spec, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread({}, spec, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push(_react.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread({
        outline: "none"
      }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread({}, spec, {
          index: key
        }));
        preCloneSlides.push(_react.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread({}, spec, {
          index: key
        }));
        postCloneSlides.push(_react.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _getPrototypeOf(Track).apply(this, arguments));
  }

  _createClass(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return _react.default.createElement("div", _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);

  return Track;
}(_react.default.PureComponent);

exports.Track = Track;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shallowEqual = __webpack_require__(151);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _Elements = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var noop = function noop() {};

var _extractOptions = function _extractOptions(props) {
  var id = props.id,
      className = props.className,
      elementRef = props.elementRef,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onReady = props.onReady,
      options = _objectWithoutProperties(props, ['id', 'className', 'elementRef', 'onChange', 'onFocus', 'onBlur', 'onReady']);

  return options;
};

var Element = function Element(type) {
  var _class, _temp;

  var hocOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _temp = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props, context) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      _this.handleRef = function (ref) {
        _this._ref = ref;
      };

      _this._element = null;

      var options = _extractOptions(_this.props);
      // We keep track of the extracted options on this._options to avoid re-rendering.
      // (We would unnecessarily re-render if we were tracking them with state.)
      _this._options = options;
      return _this;
    }

    _class.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      this.context.addElementsLoadListener(function (elements) {
        var element = elements.create(type, _this2._options);
        _this2._element = element;

        _this2._setupEventListeners(element);

        element.mount(_this2._ref);
        if (hocOptions.sourceType) {
          _this2.context.registerElement(hocOptions.sourceType, element);
        }
      });
    };

    _class.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var options = _extractOptions(nextProps);
      if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
        this._options = options;
        if (this._element) {
          this._element.update(options);
        }
      }
    };

    _class.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this._element) {
        var element = this._element;
        element.destroy();
        this.context.unregisterElement(element);
      }
    };

    _class.prototype._setupEventListeners = function _setupEventListeners(element) {
      var _this3 = this;

      element.on('ready', function () {
        if (_this3.props.elementRef) {
          if (window.console && window.console.warn) {
            console.warn("'elementRef()' is deprecated and will be removed in a future version of react-stripe-elements. Please use 'onReady()' instead.");
          }
          _this3.props.elementRef(_this3._element);
        }
        _this3.props.onReady(_this3._element);
      });

      element.on('change', function (change) {
        _this3.props.onChange(change);
      });

      element.on('blur', function () {
        var _props;

        return (_props = _this3.props).onBlur.apply(_props, arguments);
      });
      element.on('focus', function () {
        var _props2;

        return (_props2 = _this3.props).onFocus.apply(_props2, arguments);
      });
    };

    _class.prototype.render = function render() {
      return _react2.default.createElement('div', {
        id: this.props.id,
        className: this.props.className,
        ref: this.handleRef
      });
    };

    return _class;
  }(_react2.default.Component), _class.propTypes = {
    id: _propTypes2.default.string,
    className: _propTypes2.default.string,
    elementRef: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    onBlur: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    onReady: _propTypes2.default.func
  }, _class.defaultProps = {
    id: undefined,
    className: undefined,
    elementRef: undefined,
    onChange: noop,
    onBlur: noop,
    onFocus: noop,
    onReady: noop
  }, _class.contextTypes = _Elements.elementContextTypes, _temp;
};

exports.default = Element;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shallowEqual = __webpack_require__(151);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _Elements = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var noop = function noop() {};

var _extractOptions = function _extractOptions(props) {
  var id = props.id,
      className = props.className,
      elementRef = props.elementRef,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onReady = props.onReady,
      paymentRequest = props.paymentRequest,
      options = _objectWithoutProperties(props, ['id', 'className', 'elementRef', 'onBlur', 'onClick', 'onFocus', 'onReady', 'paymentRequest']);

  return options;
};

var PaymentRequestButtonElement = function (_React$Component) {
  _inherits(PaymentRequestButtonElement, _React$Component);

  function PaymentRequestButtonElement(props, context) {
    _classCallCheck(this, PaymentRequestButtonElement);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleRef = function (ref) {
      _this._ref = ref;
    };

    var options = _extractOptions(props);
    // We keep track of the extracted options on this._options to avoid re-rendering.
    // (We would unnecessarily re-render if we were tracking them with state.)
    _this._options = options;
    return _this;
  }

  PaymentRequestButtonElement.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.context.addElementsLoadListener(function (elements) {
      _this2._element = elements.create('paymentRequestButton', _extends({
        paymentRequest: _this2.props.paymentRequest
      }, _this2._options));
      _this2._element.on('ready', function () {
        if (_this2.props.elementRef) {
          if (window.console && window.console.warn) {
            console.warn("'elementRef()' is deprecated and will be removed in a future version of react-stripe-elements. Please use 'onReady()' instead.");
          }
          _this2.props.elementRef(_this2._element);
        }
        _this2.props.onReady(_this2._element);
      });
      _this2._element.on('focus', function () {
        var _props;

        return (_props = _this2.props).onFocus.apply(_props, arguments);
      });
      _this2._element.on('click', function () {
        var _props2;

        return (_props2 = _this2.props).onClick.apply(_props2, arguments);
      });
      _this2._element.on('blur', function () {
        var _props3;

        return (_props3 = _this2.props).onBlur.apply(_props3, arguments);
      });
      _this2._element.mount(_this2._ref);
    });
  };

  PaymentRequestButtonElement.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.paymentRequest !== nextProps.paymentRequest) {
      console.warn('Unsupported prop change: paymentRequest is not a customizable property.');
    }
    var options = _extractOptions(nextProps);
    if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
      this._options = options;
      this._element.update(options);
    }
  };

  PaymentRequestButtonElement.prototype.componentWillUnmount = function componentWillUnmount() {
    this._element.destroy();
  };

  PaymentRequestButtonElement.prototype.render = function render() {
    return _react2.default.createElement('div', {
      id: this.props.id,
      className: this.props.className,
      ref: this.handleRef
    });
  };

  return PaymentRequestButtonElement;
}(_react2.default.Component);

PaymentRequestButtonElement.propTypes = {
  id: _propTypes2.default.string,
  className: _propTypes2.default.string,
  elementRef: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onReady: _propTypes2.default.func,
  paymentRequest: _propTypes2.default.shape({
    canMakePayment: _propTypes2.default.func.isRequired,
    on: _propTypes2.default.func.isRequired,
    show: _propTypes2.default.func.isRequired
  }).isRequired
};
PaymentRequestButtonElement.defaultProps = {
  id: undefined,
  className: undefined,
  elementRef: undefined,
  onBlur: noop,
  onClick: noop,
  onFocus: noop,
  onReady: noop
};
PaymentRequestButtonElement.contextTypes = _Elements.elementContextTypes;
exports.default = PaymentRequestButtonElement;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Elements = __webpack_require__(61);

var _Provider = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// react-redux does a bunch of stuff with pure components / checking if it needs to re-render.
// not sure if we need to do the same.
var inject = function inject(WrappedComponent) {
  var _class, _temp;

  var componentOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _componentOptions$wit = componentOptions.withRef,
      withRef = _componentOptions$wit === undefined ? false : _componentOptions$wit;


  return _temp = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props, context) {
      _classCallCheck(this, _class);

      if (!context || !context.getRegisteredElements) {
        throw new Error('It looks like you are trying to inject Stripe context outside of an Elements context.\nPlease be sure the component that calls createSource or createToken is within an <Elements> component.');
      }

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      _this.findElement = function (specifiedType) {
        var allElements = _this.context.getRegisteredElements();
        var matchingElements = specifiedType === 'auto' ? allElements : allElements.filter(function (_ref) {
          var type = _ref.type;
          return type === specifiedType;
        });

        if (matchingElements.length === 1) {
          return matchingElements[0].element;
        } else if (matchingElements.length > 1) {
          throw new Error('You did not specify the type of Source or Token to create.\n        We could not infer which Element you want to use for this operation.');
        } else {
          return null;
        }
      };

      _this.requireElement = function (specifiedType) {
        var element = _this.findElement(specifiedType);
        if (element) {
          return element;
        } else {
          throw new Error('You did not specify the type of Source or Token to create.\n        We could not infer which Element you want to use for this operation.');
        }
      };

      _this.wrappedCreateToken = function (stripe) {
        return function () {
          var typeOrOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          if (typeOrOptions && (typeof typeOrOptions === 'undefined' ? 'undefined' : _typeof(typeOrOptions)) === 'object') {
            var type = typeOrOptions.type,
                rest = _objectWithoutProperties(typeOrOptions, ['type']);

            var specifiedType = typeof type === 'string' ? type : 'auto';
            var element = _this.requireElement(specifiedType);
            return stripe.createToken(element, rest);
          } else if (typeof typeOrOptions === 'string') {
            return stripe.createToken(typeOrOptions, options);
          } else {
            throw new Error('Invalid options passed to createToken. Expected an object, got ' + (typeof typeOrOptions === 'undefined' ? 'undefined' : _typeof(typeOrOptions)) + '.');
          }
        };
      };

      _this.wrappedCreateSource = function (stripe) {
        return function () {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            var type = options.type,
                rest = _objectWithoutProperties(options, ['type']); // eslint-disable-line no-unused-vars


            var specifiedType = typeof type === 'string' ? type : 'auto';

            var element = _this.findElement(specifiedType);
            if (element) {
              if (specifiedType === 'auto' && window.console && window.console.warn) {
                console.warn("Inferred Source type of 'card' for createSource(). This behavior will be deprecated in a future version. Please pass the Source type to createSource() explicitly.");
              }
              return stripe.createSource(element, rest);
            } else if (specifiedType !== 'auto') {
              return stripe.createSource(options);
            } else {
              throw new Error('You did not specify the type of Source to create. We also could not find any Elements in the current context.');
            }
          } else {
            throw new Error('Invalid options passed to createSource. Expected an object, got ' + (typeof options === 'undefined' ? 'undefined' : _typeof(options)) + '.');
          }
        };
      };

      if (_this.context.tag === 'sync') {
        _this.state = {
          stripe: _this.stripeProps(_this.context.stripe)
        };
      } else {
        _this.state = {
          stripe: null
        };
      }
      return _this;
    }

    _class.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      if (this.context.tag === 'async') {
        this.context.addStripeLoadListener(function (stripe) {
          _this2.setState({
            stripe: _this2.stripeProps(stripe)
          });
        });
      } else {
        // when 'sync', it's already set in the constructor.
      }
    };

    _class.prototype.getWrappedInstance = function getWrappedInstance() {
      if (!withRef) {
        throw new Error('To access the wrapped instance, the `{withRef: true}` option must be set when calling `injectStripe()`');
      }
      return this.wrappedInstance;
    };

    _class.prototype.stripeProps = function stripeProps(stripe) {
      return _extends({}, stripe, {
        // These are the only functions that take elements.
        createToken: this.wrappedCreateToken(stripe),
        createSource: this.wrappedCreateSource(stripe)
      });
    };
    // Finds the element by the specified type. Throws if multiple Elements match.

    // Require that exactly one Element is found.


    // createToken has a bit of an unusual method signature for legacy reasons
    // -- we're allowed to pass in the token type OR the element as the first parameter,
    // so we need to check if we're passing in a string as the first parameter and
    // just pass through the options if that's the case.


    _class.prototype.render = function render() {
      var _this3 = this;

      return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
        stripe: this.state.stripe,
        ref: withRef ? function (c) {
          _this3.wrappedInstance = c;
        } : null
      }));
    };

    return _class;
  }(_react2.default.Component), _class.contextTypes = _extends({}, _Provider.providerContextTypes, _Elements.injectContextTypes), _class.displayName = 'InjectStripe(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _temp;
};

exports.default = inject;

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_addClass__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_removeClass__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Transition__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_PropTypes__ = __webpack_require__(154);










var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_dom_helpers_addClass__["a" /* default */])(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_removeClass__["a" /* default */])(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["classNames"]);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Transition__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
/* unused harmony default export */ var _unused_webpack_default_export = (CSSTransition);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TransitionGroup__ = __webpack_require__(152);






/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;
    var child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(children)[idx];
    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);

    if (this.props[handler]) {
      var maybeNode = child.props.nodeRef ? undefined : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);
      this.props[handler](maybeNode);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "in"]);

    var _React$Children$toArr = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TransitionGroup__["a" /* default */], props, inProp ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ReplaceTransition.propTypes =  false ? {
  in: PropTypes.bool.isRequired,
  children: function children(props, propName) {
    if (React.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (ReplaceTransition);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export modes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Transition__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TransitionGroupContext__ = __webpack_require__(87);


var _leaveRenders, _enterRenders;






function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;

  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(oldChildren) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }

  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */


var modes = {
  out: 'out-in',
  in: 'in-out'
};

var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;

    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};

var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
      changeState = _ref.changeState;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */], null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
      changeState = _ref2.changeState,
      children = _ref2.children;
  return [current, __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
      changeState = _ref3.changeState;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["c" /* ENTERED */], __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
      children = _ref4.children,
      changeState = _ref4.changeState;
  return [__WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["c" /* ENTERED */], __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        in: true
      }));
    })
  }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(SwitchTransition, _React$Component);

  function SwitchTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: __WEBPACK_IMPORTED_MODULE_3__Transition__["c" /* ENTERED */],
      current: null
    };
    _this.appeared = false;

    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }

      _this.setState({
        status: status,
        current: current
      });
    };

    return _this;
  }

  var _proto = SwitchTransition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }

    if (state.status === __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */] && props.mode === modes.in) {
      return {
        status: __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]
      };
    }

    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: __WEBPACK_IMPORTED_MODULE_3__Transition__["d" /* EXITING */]
      };
    }

    return {
      current: __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(props.children, {
        in: true
      })
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        mode = _this$props.mode,
        _this$state = this.state,
        status = _this$state.status,
        current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;

    switch (status) {
      case __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]:
        component = enterRenders[mode](data);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__Transition__["d" /* EXITING */]:
        component = leaveRenders[mode](data);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__Transition__["c" /* ENTERED */]:
        component = current;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TransitionGroupContext__["a" /* default */].Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };

  return SwitchTransition;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

SwitchTransition.propTypes =  false ? {
  /**
   * Transition modes.
   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
   *
   * @type {'out-in'|'in-out'}
   */
  mode: PropTypes.oneOf([modes.in, modes.out]),

  /**
   * Any `Transition` or `CSSTransition` component.
   */
  children: PropTypes.oneOfType([PropTypes.element.isRequired])
} : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};
/* unused harmony default export */ var _unused_webpack_default_export = (SwitchTransition);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CSSTransition__ = __webpack_require__(533);
/* unused harmony reexport CSSTransition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReplaceTransition__ = __webpack_require__(534);
/* unused harmony reexport ReplaceTransition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SwitchTransition__ = __webpack_require__(535);
/* unused harmony reexport SwitchTransition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TransitionGroup__ = __webpack_require__(152);
/* unused harmony reexport TransitionGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Transition__ = __webpack_require__(86);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__Transition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(153);
/* unused harmony reexport config */







/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getChildMapping;
/* unused harmony export mergeChildMappings */
/* harmony export (immutable) */ __webpack_exports__["a"] = getInitialChildMapping;
/* harmony export (immutable) */ __webpack_exports__["b"] = getNextChildMapping;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        in: false
      });
    } else if (hasNext && hasPrev && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(53),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return function (previous, current) {
    return reducers.reduce(function (p, r) {
      return r(p, current);
    }, previous);
  };
};

module.exports = exports["default"];

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = createAction;
function identity(t) {
  return t;
}

function createAction(type, actionCreator, metaCreator) {
  var finalActionCreator = typeof actionCreator === 'function' ? actionCreator : identity;

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var action = {
      type: type,
      payload: finalActionCreator.apply(undefined, args)
    };

    if (args.length === 1 && args[0] instanceof Error) {
      // Handle FSA errors where the payload is an Error object. Set error.
      action.error = true;
    }

    if (typeof metaCreator === 'function') {
      action.meta = metaCreator.apply(undefined, args);
    }

    return action;
  };
}

module.exports = exports['default'];

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = handleActions;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _handleAction = __webpack_require__(155);

var _handleAction2 = _interopRequireDefault(_handleAction);

var _ownKeys = __webpack_require__(542);

var _ownKeys2 = _interopRequireDefault(_ownKeys);

var _reduceReducers = __webpack_require__(539);

var _reduceReducers2 = _interopRequireDefault(_reduceReducers);

function handleActions(handlers, defaultState) {
  var reducers = _ownKeys2['default'](handlers).map(function (type) {
    return _handleAction2['default'](type, handlers[type]);
  });

  return typeof defaultState !== 'undefined' ? function (state, action) {
    if (state === undefined) state = defaultState;
    return _reduceReducers2['default'].apply(undefined, reducers)(state, action);
  } : _reduceReducers2['default'].apply(undefined, reducers);
}

module.exports = exports['default'];

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = ownKeys;

function ownKeys(object) {
  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    return Reflect.ownKeys(object);
  }

  var keys = Object.getOwnPropertyNames(object);

  if (typeof Object.getOwnPropertySymbols === 'function') {
    keys = keys.concat(Object.getOwnPropertySymbols(object));
  }

  return keys;
}

module.exports = exports['default'];

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodashIsplainobject = __webpack_require__(548);

var _lodashIsplainobject2 = _interopRequireDefault(_lodashIsplainobject);

var _bufferActions = __webpack_require__(544);

var _bufferActions2 = _interopRequireDefault(_bufferActions);

var _constants = __webpack_require__(62);

module.exports = function autoRehydrate() {
  var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  return function (next) {
    return function (reducer, initialState, enhancer) {
      var rehydrationReducer = createRehydrationReducer(reducer);

      // buffer actions
      var store = next(rehydrationReducer, initialState, enhancer);
      var dispatch = _bufferActions2['default'](onBufferEnd)(store.dispatch);

      return _extends({}, store, {
        dispatch: dispatch
      });
    };
  };

  function onBufferEnd(err, queue) {
    if (err) console.error(err);
    if (config.log) console.log('redux-persist/autoRehydrate action buffer released', queue);
  }

  function createRehydrationReducer(reducer) {
    return function (state, action) {
      if (action.type === _constants.REHYDRATE) {
        var key = action.key;
        var data = action.payload;
        var reducedState = reducer(state, action);

        // if reducer modifies substate, skip auto rehydration
        if (state[key] !== reducedState[key]) {
          if (config.log) console.log('redux-persist/autoRehydrate sub state for key "%s" modified, skipping autoRehydrate', key);
          return reducedState;
        }

        var autoReducedState = _extends({}, reducedState);
        var statesArePlain = checkIfPlain(data, reducedState[key]);
        if (!statesArePlain) {
          // assign value
          autoReducedState[key] = data;
        } else {
          // shallow merge
          var subState = {};
          for (var subkey in reducedState[key]) {
            subState[subkey] = reducedState[key][subkey];
          }
          for (var datakey in data) {
            subState[datakey] = data[datakey];
          }
          autoReducedState[key] = subState;
        }

        if (config.log) console.log('redux-persist/autoRehydrate key: %s, rehydrated to:', key, autoReducedState[key]);
        return autoReducedState;
      } else {
        return reducer(state, action);
      }
    };
  }
};

function checkIfPlain(a, b) {
  // isPlainObject + duck type not immutable
  if (typeof a !== 'object' || typeof b !== 'object') return false;
  if (typeof a.mergeDeep === 'function' || typeof b.mergeDeep === 'function') return false;
  if (!_lodashIsplainobject2['default'](a) || !_lodashIsplainobject2['default'](b)) return false;
  return true;
}

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(62);

module.exports = function bufferActions(cb) {
  var active = true;
  var queue = [];

  return function (next) {
    return function (action) {
      if (!active) return next(action);
      if (action.type === constants.REHYDRATE) return next(action);
      if (action.type === constants.REHYDRATE_COMPLETE) {
        active = false;
        var result = next(action);
        queue.forEach(function (queuedAction) {
          return next(queuedAction);
        });
        cb(null, queue);
        return result;
      }

      queue.push(action);
    };
  };
};

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = getStoredState;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodashForeach = __webpack_require__(117);

var _lodashForeach2 = _interopRequireDefault(_lodashForeach);

var _constants = __webpack_require__(62);

var _constants2 = _interopRequireDefault(_constants);

var _defaultsAsyncLocalStorage = __webpack_require__(88);

var _defaultsAsyncLocalStorage2 = _interopRequireDefault(_defaultsAsyncLocalStorage);

function getStoredState(config, onComplete) {
  var storage = config.storage || _defaultsAsyncLocalStorage2['default'];
  var deserialize = config.deserialize || defaultDeserialize;
  var transforms = config.transforms || [];

  var restoredState = {};
  var completionCount = 0;

  storage.getAllKeys(function (err, allKeys) {
    if (err && "production" !== 'production') {
      console.warn('Error in storage.getAllKeys');
    }
    var persistKeys = allKeys.filter(function (key) {
      return key.indexOf(_constants2['default'].keyPrefix) === 0;
    }).map(function (key) {
      return key.slice(_constants2['default'].keyPrefix.length);
    });
    var restoreCount = persistKeys.length;

    if (restoreCount === 0) complete(null, restoredState);
    _lodashForeach2['default'](persistKeys, function (key) {
      storage.getItem(createStorageKey(key), function (err, serialized) {
        if (err && "production" !== 'production') console.warn('Error restoring data for key:', key, err);else restoredState[key] = rehydrate(key, serialized);
        completionCount += 1;
        if (completionCount === restoreCount) complete(null, restoredState);
      });
    });
  });

  function rehydrate(key, serialized) {
    var state = null;

    try {
      var data = deserialize(serialized);
      state = transforms.reduceRight(function (subState, transformer) {
        return transformer.out(subState);
      }, data);
    } catch (err) {
      if (false) console.warn('Error restoring data for key:', key, err);
    }

    return state;
  }

  function complete(err, restoredState) {
    onComplete(err, restoredState);
  }
}

function defaultDeserialize(serial) {
  return JSON.parse(serial);
}

function createStorageKey(key) {
  return _constants2['default'].keyPrefix + key;
}
module.exports = exports['default'];

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createAsyncLocalStorage = __webpack_require__(88);

module.exports.persistStore = __webpack_require__(547);
module.exports.autoRehydrate = __webpack_require__(543);
module.exports.getStoredState = __webpack_require__(545);
module.exports.storages = {
  asyncLocalStorage: createAsyncLocalStorage('local'),
  asyncSessionStorage: createAsyncLocalStorage('session')
};

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate, global) {

exports.__esModule = true;
exports['default'] = persistStore;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodashForeach = __webpack_require__(117);

var _lodashForeach2 = _interopRequireDefault(_lodashForeach);

var _constants = __webpack_require__(62);

var _constants2 = _interopRequireDefault(_constants);

var _defaultsAsyncLocalStorage = __webpack_require__(88);

var _defaultsAsyncLocalStorage2 = _interopRequireDefault(_defaultsAsyncLocalStorage);

function persistStore(store, config, onComplete) {
  if (config === undefined) config = {};

  // defaults
  var blacklist = config.blacklist || [];
  var whitelist = config.whitelist || false;
  var rehydrateAction = config.rehydrateAction || defaultRehydrateAction;
  var completeAction = config.completeAction || defaultCompleteAction;
  var serialize = config.serialize || defaultSerialize;
  var deserialize = config.deserialize || defaultDeserialize;
  var transforms = config.transforms || [];
  var storage = config.storage || _defaultsAsyncLocalStorage2['default']('local');
  var debounce = config.debounce || false;
  var shouldRestore = !config.skipRestore;
  var genericSetImmediate = typeof setImmediate === 'undefined' ? global.setImmediate : setImmediate;

  // initialize values
  var timeIterator = null;
  var lastState = store.getState();
  var purgeMode = false;
  var restoreCount = 0;
  var completionCount = 0;
  var storesToProcess = [];
  var restoredState = {};

  // restore
  if (shouldRestore) {
    _lodashForeach2['default'](lastState, function (s, key) {
      if (whitelistBlacklistCheck(key)) return;
      restoreCount += 1;
      genericSetImmediate(function () {
        restoreKey(key, function (err, substate) {
          if (err) substate = null;
          completionCount += 1;
          restoredState[key] = substate;
          if (completionCount === restoreCount) rehydrationComplete();
        });
      });
    });
    if (restoreCount === 0) rehydrationComplete();
  } else rehydrationComplete();

  // store
  store.subscribe(function () {
    if (timeIterator !== null) clearInterval(timeIterator);

    var state = store.getState();
    _lodashForeach2['default'](state, function (subState, key) {
      if (whitelistBlacklistCheck(key)) return;
      if (lastState[key] === state[key]) return;
      if (storesToProcess.indexOf(key) !== -1) return;
      storesToProcess.push(key);
    });

    // time iterator (read: debounce)
    timeIterator = setInterval(function () {
      if (storesToProcess.length === 0) {
        clearInterval(timeIterator);
        return;
      }

      var key = createStorageKey(storesToProcess[0]);
      var endState = transforms.reduce(function (subState, transformer) {
        return transformer['in'](subState);
      }, state[storesToProcess[0]]);
      if (typeof endState !== 'undefined') storage.setItem(key, serialize(endState), warnIfSetError(key));
      storesToProcess.shift();
    }, debounce);

    lastState = state;
  });

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  function restoreKey(key, cb) {
    storage.getItem(createStorageKey(key), function (err, serialized) {
      if (err && "production" !== 'production') console.warn('Error restoring data for key:', key, err);else rehydrate(key, serialized, cb);
    });
  }

  function rehydrate(key, serialized, cb) {
    var state = null;

    try {
      var data = deserialize(serialized);
      state = transforms.reduceRight(function (subState, transformer) {
        return transformer.out(subState);
      }, data);
    } catch (err) {
      if (false) console.warn('Error restoring data for key:', key, err);
      storage.removeItem(key, warnIfRemoveError(key));
    }

    if (state !== null && purgeMode !== '*') {
      if (!Array.isArray(purgeMode) || purgeMode.indexOf(key) === -1) store.dispatch(rehydrateAction(key, state));
    }
    cb && cb(null, state);
  }

  function rehydrationComplete() {
    store.dispatch(completeAction());
    genericSetImmediate(function () {
      return onComplete && onComplete(null, restoredState);
    });
  }

  function purge(keys) {
    purgeMode = keys;
    _lodashForeach2['default'](keys, function (key) {
      storage.removeItem(createStorageKey(key), warnIfRemoveError(key));
    });
  }

  function purgeAll() {
    purgeMode = '*';
    storage.getAllKeys(function (err, allKeys) {
      if (err && "production" !== 'production') {
        console.warn('Error in storage.getAllKeys');
      }
      purge(allKeys.filter(function (key) {
        return key.indexOf(_constants2['default'].keyPrefix) === 0;
      }).map(function (key) {
        return key.slice(_constants2['default'].keyPrefix.length);
      }));
    });
  }

  // return `persistor`
  return {
    rehydrate: rehydrate,
    purge: purge,
    purgeAll: purgeAll
  };
}

function warnIfRemoveError(key) {
  return function removeError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}

function warnIfSetError(key) {
  return function setError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}

function createStorageKey(key) {
  return _constants2['default'].keyPrefix + key;
}

function defaultRehydrateAction(key, data) {
  return {
    type: _constants2['default'].REHYDRATE,
    key: key,
    payload: data
  };
}

function defaultCompleteAction() {
  return {
    type: _constants2['default'].REHYDRATE_COMPLETE
  };
}

function defaultSerialize(data) {
  return JSON.stringify(data);
}

function defaultDeserialize(serial) {
  return JSON.parse(serial);
}
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(159).setImmediate, __webpack_require__(13)))

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseFor = __webpack_require__(116),
    isArguments = __webpack_require__(48),
    keysIn = __webpack_require__(118);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * The base implementation of `_.forIn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForIn(object, iteratee) {
  return baseFor(object, iteratee, keysIn);
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * **Note:** This method assumes objects created by the `Object` constructor
 * have no inherited enumerable properties.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  var Ctor;

  // Exit early for non `Object` objects.
  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
    return false;
  }
  // IE < 9 iterates inherited properties before own properties. If the first
  // iterated property is an object's own property then there are no inherited
  // enumerable properties.
  var result;
  // In most environments an object's own properties are iterated before
  // its inherited properties. If the last iterated property is an object's
  // own property then there are no inherited enumerable properties.
  baseForIn(value, function(subValue, key) {
    result = key;
  });
  return result === undefined || hasOwnProperty.call(value, result);
}

module.exports = isPlainObject;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function thunkMiddleware(_ref) {
  var dispatch = _ref.dispatch;
  var getState = _ref.getState;

  return function (next) {
    return function (action) {
      return typeof action === 'function' ? action(dispatch, getState) : next(action);
    };
  };
}

module.exports = thunkMiddleware;

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(156);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(158);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(554);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(557);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13), __webpack_require__(122)))

/***/ }),
/* 560 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 561 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function hash(str) {
  var hash = 5381,
      i    = str.length;

  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }

  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return hash >>> 0;
}

module.exports = hash;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Dismiss (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.364 5.757L11.56 2.56 9.44.44 6.242 3.635 3.046.44.926 2.56 4.12 5.758.926 8.954l2.12 2.12L6.244 7.88l3.196 3.195 2.12-2.12-3.196-3.198z","fillRule":"nonzero","fill":"#979797"}));
}

Dismiss.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = Dismiss;

Dismiss.default = Dismiss;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Notifications (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"notifications-icon","d":"M.593 11.91C1.296 5.998 6.09 1.24 12.008.584c7.77-.864 14.476 5.176 14.476 12.91 0 6.998-5.535 12.703-12.468 12.98l-4.314 3.54c-1.402 1.147-3.507.15-3.507-1.66v-4.125C2.23 21.533.007 16.86.593 11.91zm2.98.355c-.48 4.05 1.468 7.842 4.88 9.843l.742.435v4.005l3.734-3.066h.56c5.52 0 9.994-4.472 9.994-9.99 0-5.95-5.156-10.594-11.144-9.927-4.534.503-8.23 4.17-8.767 8.7z","fillRule":"nonzero"}));
}

Notifications.defaultProps = {"width":"27","height":"31","viewBox":"0 0 27 31"};

module.exports = Notifications;

Notifications.default = Notifications;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Settings (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group 2"),React.createElement("g",{"fillRule":"evenodd","key":1},[React.createElement("path",{"className":"settings-icon","d":"M24.116 20.567c-1.46-2.56-.98-3.867 1.636-4.898.188-.075.388-.385.398-.593.045-.883.05-1.77-.004-2.65-.014-.217-.267-.54-.477-.607-2.304-.733-2.944-2.27-1.836-4.394.107-.205.05-.637-.102-.812-.58-.664-1.213-1.288-1.873-1.873-.16-.14-.565-.187-.753-.084-2.04 1.113-3.646.473-4.38-1.74-.075-.23-.42-.507-.655-.525-.852-.062-1.713-.06-2.565 0-.242.017-.598.277-.67.5-.757 2.304-2.236 2.915-4.4 1.797-.18-.094-.53-.145-.64-.042-.82.767-1.6 1.577-2.378 2.358.076.155.106.234.15.302 1.302 2.013.653 3.768-1.625 4.502-.24.077-.5.47-.528.738-.073.74.007 1.49-.036 2.234-.032.592.144.878.77 1.012 1.162.248 1.982 1.02 2.053 2.198.05.827-.31 1.676-.503 2.58.734.717 1.61 1.573 2.504 2.444 2.292-1.33 3.753-.808 4.644 1.698.074.205.405.438.63.452.853.053 1.714.057 2.565-.003.242-.015.6-.27.673-.493.724-2.242 2.256-2.9 4.346-1.854.198.1.598.07.755-.067.787-.69 1.526-1.436 2.3-2.18m-21.197.047c.28-.65.465-1.192.738-1.684.272-.493.214-.724-.354-.893-1.865-.554-2.316-1.195-2.317-3.16 0-.885-.01-1.77.003-2.652.02-1.38.756-2.296 2.08-2.61.895-.212.933-.297.486-1.072-.74-1.285-.613-2.326.42-3.373.737-.747 1.477-1.492 2.227-2.225.998-.976 2.1-1.095 3.31-.376.746.443.843.406 1.067-.408.422-1.53 1.218-2.147 2.79-2.156.995-.005 1.99-.012 2.984.003 1.378.018 2.27.738 2.606 2.08.235.932.267.945 1.132.427 1.048-.628 2.226-.527 3.124.323.842.797 1.66 1.62 2.46 2.46.877.916.98 2.1.318 3.19-.487.8-.45.888.494 1.13 1.297.337 2.023 1.22 2.05 2.554.024 1.076.026 2.154 0 3.23-.032 1.376-.774 2.257-2.122 2.583-.898.218-.918.27-.418 1.067.716 1.147.594 2.335-.363 3.315-.733.75-1.477 1.49-2.226 2.225-1.048 1.03-2.206 1.174-3.444.365-.58-.38-.798-.246-.966.386-.44 1.66-1.2 2.222-2.896 2.227-.995.002-1.99.012-2.983-.004-1.315-.022-2.23-.785-2.523-2.073-.21-.918-.262-.942-1.06-.485-1.27.724-2.36.595-3.386-.415-.766-.756-1.57-1.483-2.267-2.3-.407-.476-.64-1.103-.963-1.684","key":0}),React.createElement("path",{"className":"settings-icon","d":"M14.598 17.947c2.793-.184 4.16-1.443 4.324-4.22.14-2.348-1.886-4.44-4.267-4.342-2.708.112-4.112 1.376-4.285 4.156-.148 2.357 1.845 4.353 4.228 4.407m-.003 2.352c-3.7-.005-6.664-2.93-6.61-6.635.058-4.033 2.65-6.583 6.604-6.664 3.7-.072 6.744 2.973 6.66 6.686-.087 3.933-2.587 6.535-6.655 6.613","key":1})])]);
}

Settings.defaultProps = {"width":"29","height":"28","viewBox":"0 0 29 28"};

module.exports = Settings;

Settings.default = Settings;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Warning (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-83 -41)","fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"fill":"#E85E5E","x":"83","y":"41","width":"18","height":"18","rx":"9","key":0}),React.createElement("path",{"d":"M91.946 51.038h.484c.275 0 .45-.143.484-.43l.462-3.915v-.242c0-.285-.165-.45-.45-.45H91.46c-.297 0-.462.165-.462.45v.243l.462 3.916c.044.285.21.428.484.428zm.22 2.783c.66 0 1.166-.44 1.166-1.022 0-.605-.506-1.045-1.166-1.045-.66 0-1.155.44-1.155 1.045 0 .583.496 1.023 1.156 1.023z","fill":"#FFF","key":1})]));
}

Warning.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Warning;

Warning.default = Warning;


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(568);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13), __webpack_require__(621)(module)))

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/background.c95a6ca1.png";

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAEUklEQVR4nO2dy24URxSGPzvKeJMQLhZRbC8CQizCRV7lEaKI5BEAsbRCALGxFwiJFwgS5BEI4hkIUUA4igkCjGSRRFmgQIQUQAKEzd3CLKot5tIzUzXdp+t0+XzS2dhdp079f09PVd8G4rIXuAP8C3wdsY6vgHvAo6ymNckQ8ARYyeIxMBGhjoms7+Y61iRDwEPeC7ECnM/+XmUN59tqeFBh/+o4QqsYK8BUhf1P5fR/pML+1TEMXKJVkCVgWwV9bwGetvX9W1bTmmYLsEinMB8I9pm3Izyjmh2hFhyi89BxtG2bjcAe4ARwFrgC3MXNjN5k8Sj721y2zYmszYa2XEdz+jtU8phqzTBwkVaBnuPEPAZcB97SKaJvvAWuZbn2ZLmb/38RO1R18Dmdx/QqoqrvrNoxBJyhekPOUO1UuxZMArNUb8ZqXAW+FB9lDRjGzftfE8+M1VjGTQIkZ3eq+ZTOqaeG+BXYLDhulWwF/iG++N3iNrBdbPTK2IU7XxRb9H7xP7BTSAM1TOAWbrHF9o17uOl4kqwD/qa/CC+BaWAsixnglUe7fvGqLe+0Z96/stqT4xx+wk3ntJ3xbNsrZgrkPVtg3Co5gL9wn+W0Hwto3y3GCubdN/DolbGezgtRoYaMB7SXynsf+GRADbyp4oTacWA0YPu8PbGM69z7C+bdjDs5WWtGgReE7cmSX+ozBfM+BzaVqlDFHKO4kNoib3JQC4Zwt/jEFrDsuF2mSFUySXzxpGJ3iTq1IPml/o1g7th8G7sAwzAMwyiDEeAw7r6opSxmc7aLPROSjnZmm/S4grvPa6SPloUZB256FhhbsKoNydtmPtNMhBG6m2GGdN9uHqFPyuGSCkwlQsb7fQ9dB+aPEgtMIULGO9dD1xZC7thbBD4KyJVXdEqEjHcJ+HiQpL3oJ7AZErZ9LnbHtzLMEGWYIcowQ5RhhijDDFGGGaIMM0QZZogyzBBlmCHKMEOUYYYowwxRhhmiDDNEGWaIMswQZZghyjBDlGGGKMMMUYYZogwzRBlmiDLMEGWYIcoIMWRJrIr0eeq7YYghfw5QiOHw1i7EkJ8GKMRwiLwAbQT3eJY9sBM23nmg0UPXQozT3RTfAlMJn/GKPvS5SgP3zNwc7qmqReCyZ4EpRTuzTXr8nmkU/MmQfAl9XtEpIaKdrUOUYYYowwxRhqQhKa/svVfeoUgackswd2zExiZpSHKv526ilmct+q3s6xrXEVx5SzMO3CC+iGWakfcO+VrRAA7iVq/tv+hZh1hdeX9HjT8ZhmEYRvrE/MnRlYLt+9UunV8EO5elDDNEGWaIMswQZZghyjBDlGGGKCOmIYsF2vpcsZPOL0JMQ/4r0PaugvwixDTkQoG2PyvInxw7gWXCr08sA18oyJ8kPxIu2ClF+ZOjAfyCv1gXgA8V5U+SBnCa3oeXZdyeO4hY0vmTZQdwEljg/V3kC8APlHNMl85fCu8AZuIu9Bu6dJEAAAAASUVORK5CYII="

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAEGklEQVR4nO2dz0/UUBDHP1EiB34Y3cDFRP4UMIoH4UACeNezcjXiTcGTf4yRk8LZH6CsR4IXxcQTHmQxEQ+sh2nTsmzrttvXN+3OJ2nI0t3OtN/OvHn7uu+BYRiGYRiGYRiGYRiGYRiGYSQxCawBTeAYaCvejoFd4Fngd+1YBo7wf6HzbEfAUvGXxB/LwClyci+BaWDEq0f/ZwSYAV4hfp9SE1EmiSLjkWdf8rKK+P8LmPDsS9+sEUVGldlAzuOpb0f65TNyItMFH3ef9Ly/X7C9G8Fxdws+bum0kBMZ9e1In4wRNfCVJrxj64C3c7ngw6iRjGtBfuK/b9FLu5PUDp0A67nP3jPdwrwqKayb322gAfwp351iqKMg3fY5xdoQZZggwhffDrigyimrE0tZnkmqshpIpVUaJkg6P4AXvp3IS11TVqlYhCjDBFGGCaKMugsyDKwA78n2sEVIL+89Do7/MLCnBm2N+jWiQbOytmZgVwWaBBkmEuMAWEQGnlwwBiwAe0SiqIgUTYKsEIlxtSSbVwJ7beBBSTZT0STIh8D2YsbPdY7fZx2vXw4+9y7j55ygSZBwfN9VmkpiPLCrYjxekyDeetr92q572RtS9FByr0PAXtEcIa796NZ3ycWgRIgPvD8gYRFy1rb3BySqIshz5O5tc/4uzrsv3obEbfv8pqIygpwQdRY77+K8+5JsmyAxu0mCpPmYd19hETKIjfpf5A6H82PmefeppCoRss7ZtmCtgH3dbFuj3mG3zCqrm+000RIZKtwdIyTXV/CD2Ia4KHtVUpWU5aLsTaqyvFIVQVyUvZX5LkvLQ8xxPwa67PVFmi8uyt7CIqRI1DhC+b5UJmUZGTFBlGGCKMO1ICrHmgcFzf2QMuwVYntQ+iEDGamay1576iRgIO9MLWhuQyxCjHyYIMowQZRhgijD9Zh6+NS54QHrh3S3nQlLWcqokiDzwDbyu/BtYM6vO/pxmbLmga/ATWSu9lvB6yRRKpuyisSlIzuIGHFmkV/b9uKLCVIwR5yfMXuM5F+7dvpyGPufi+0wxbY3wpURXEw1voOkqThZIqRM1AjSRByZcXDssA2ZRQS/DXwD7iS83wRBlgxqIwujuGAOiYhW8DdJDMh/UaaALaSS2wSu5ziGGkHiC7qsevYl70XZAh4jldwq8KZE205YIlryaANZi8PH8hV5L0qLyN+0osGFbWcsIUsGuaxqet2yznWyiUTGKPCE7BFyObCrYq6TOBPIkkGfiCaC8bEtZPR7ChGhBbwmextyN7CrYjYgTdxHLsweMo9VGTSA74FdFfNlaeIi8BG5OAfIPFbjjmyNI5ERitEELjmyVWkaSIeyzBSpas5FjQwB95B+y2/ciNAC3iJpyiLDMAzDMAzDMAzDMGrFP9CvEj5zz9SIAAAAAElFTkSuQmCC"

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1news.c89b51b8.png";

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/7sharp.cdc8d08b.png";

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tvnz.86be5fa9.png";

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1.d789d654.jpg";

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/10.b233f18b.jpg";

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/11.7526084e.jpg";

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/12.e0426e80.jpg";

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/13.22046b82.jpeg";

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/14.3f3387fd.jpg";

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/15.c0ec13c7.jpg";

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/17.2bee0a0d.jpg";

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/18.fb0e1a44.jpg";

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/19.cd854a8b.jpg";

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2.25696bae.jpg";

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/20.27484437.jpg";

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/21.546e94b4.jpg";

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/23.9fb909b7.png";

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3.2304969a.jpg";

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/4.c0f5e0a0.jpg";

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/6.c573d122.jpg";

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/7.a9c168f9.jpg";

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/8.9a8078e7.jpg";

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/9.d6a4b4ce.jpg";

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/animation.a8052f9a.gif";

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/background.e64620ea.png";

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/background.8d8e76c5.jpg";

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rotate.aaa7d450.png";

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rotate.aaa7d450.png";

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/background.8d8e76c5.jpg";

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/CivilDefense.25c2256a.png";

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/SuperGold.b8175062.png";

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rotate.aaa7d450.png";

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rotate.aaa7d450.png";

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cv_1.fcb59a99.png";

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cv_2.c62851f3.png";

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cv_3.059fdbbe.png";

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cv_4.e7268406.png";

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/founder.8cb8fabb.png";

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 619 */
/***/ (function(module, exports) {

(function() {
  var URL, URL_PATTERN, defaults, urllite,
    __hasProp = {}.hasOwnProperty;

  URL_PATTERN = /^(?:(?:([^:\/?\#]+:)\/+|(\/\/))(?:([a-z0-9-\._~%]+)(?::([a-z0-9-\._~%]+))?@)?(([a-z0-9-\._~%!$&'()*+,;=]+)(?::([0-9]+))?)?)?([^?\#]*?)(\?[^\#]*)?(\#.*)?$/;

  urllite = function(raw, opts) {
    return urllite.URL.parse(raw, opts);
  };

  urllite.URL = URL = (function() {
    function URL(props) {
      var k, v, _ref;
      for (k in defaults) {
        if (!__hasProp.call(defaults, k)) continue;
        v = defaults[k];
        this[k] = (_ref = props[k]) != null ? _ref : v;
      }
      this.host || (this.host = this.hostname && this.port ? "" + this.hostname + ":" + this.port : this.hostname ? this.hostname : '');
      this.origin || (this.origin = this.protocol ? "" + this.protocol + "//" + this.host : '');
      this.isAbsolutePathRelative = !this.host && this.pathname.charAt(0) === '/';
      this.isPathRelative = !this.host && this.pathname.charAt(0) !== '/';
      this.isRelative = this.isSchemeRelative || this.isAbsolutePathRelative || this.isPathRelative;
      this.isAbsolute = !this.isRelative;
    }

    URL.parse = function(raw) {
      var m, pathname, protocol;
      m = raw.toString().match(URL_PATTERN);
      pathname = m[8] || '';
      protocol = m[1];
      return new urllite.URL({
        protocol: protocol,
        username: m[3],
        password: m[4],
        hostname: m[6],
        port: m[7],
        pathname: protocol && pathname.charAt(0) !== '/' ? "/" + pathname : pathname,
        search: m[9],
        hash: m[10],
        isSchemeRelative: m[2] != null
      });
    };

    return URL;

  })();

  defaults = {
    protocol: '',
    username: '',
    password: '',
    host: '',
    hostname: '',
    port: '',
    pathname: '',
    search: '',
    hash: '',
    origin: '',
    isSchemeRelative: false
  };

  module.exports = urllite;

}).call(this);


/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 623 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 624 */
/***/ (function(module, exports) {

// Returns a wrapper function that returns a wrapped callback
// The wrapper function should do some stuff, and return a
// presumably different callback function.
// This makes sure that own properties are retained, so that
// decorations and such are not lost along the way.
module.exports = wrappy
function wrappy (fn, cb) {
  if (fn && cb) return wrappy(fn)(cb)

  if (typeof fn !== 'function')
    throw new TypeError('need wrapper function')

  Object.keys(fn).forEach(function (k) {
    wrapper[k] = fn[k]
  })

  return wrapper

  function wrapper() {
    var args = new Array(arguments.length)
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i]
    }
    var ret = fn.apply(this, args)
    var cb = args[args.length-1]
    if (typeof ret === 'function' && ret !== cb) {
      Object.keys(cb).forEach(function (k) {
        ret[k] = cb[k]
      })
    }
    return ret
  }
}


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./activity.svg": 329,
	"./breed.svg": 330,
	"./location.svg": 331
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 625;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(160);
module.exports = __webpack_require__(161);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.04dd75a6.js